/*jshint sub:true*/
// ---------------------------------------------------
// ---------------------------------------------------
// IMPORTS

import Prism from 'prismjs';
window.Prism = Prism;

import tinycolor from './libs/tinycolor.min.js';
window.tinycolor = tinycolor;

import CP from './libs/colorpicker.min.js';
window.CP = CP;

import beautify from 'js-beautify';
window.beautify_html = beautify.html_beautify;

import FileSaver from './libs/FileSaver.min.js';
window.FileSaver = FileSaver;

import localforage from './libs/localforage.min.js';
window.localforage = localforage;

import JSZip from './libs/jszip.min.js';
window.JSZip = JSZip;

import axios from "axios";
import { serializeProjectSnapshot } from './modules/project-snapshot.mjs';
import { importProjectZip } from './modules/project-import.mjs';
import { createPreviewSnapshot } from './modules/preview-snapshot.mjs';
import { recoveryArchive } from './modules/recovery-project.mjs';
window.axios = axios;
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

// ---------------------------------------------------
// ---------------------------------------------------
// load projects
var token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
  window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
}

var showAll = document.querySelector('meta[name="_showAll"]');
if (showAll) {
  var url = showAll.getAttribute("content");
  axios
    .get(url)
    .then(function (response) {
      var res = response.data;

      var projectsArr = [];
      var projectsfilesArr = [];

      [].forEach.call(res.projects, function (value) {
        projectsArr.push(value);
      });

      [].forEach.call(res.projectfiles, function (value) {
        projectsfilesArr.push(value);
      });

    })
    .catch(function (error) {
      document.getElementById("showData").textContent = JSON.stringify(
        error
      );
    });
}

// ---------------------------------------------------
// ---------------------------------------------------
// load DOMPOSER

const DOMPOSER = document.getElementById("scrollbox");

(function (undefined) {
  "use strict";
  if (!DOMPOSER) {
    return;
  }

  // Preview compatibility is between editor, shell and runtime, not worker lifecycle.
  let preview_update_required = false;
  const previewReleaseMeta = document.querySelector('meta[name=domposer-preview-release]');
  const preview_asset_release = previewReleaseMeta && previewReleaseMeta.content;
  const recoveryDrafts = new Map();
  const recoveryCSSDrafts = new Map();
  function require_preview_update() {
    preview_update_required = true;
    if (typeof preview !== 'undefined' && preview && !preview.closed) preview.close();
    info('Preview is incompatible. Save your work or download a recovery ZIP before reopening Domposer manually.', false, true);
  }
  // info() depends on later editor initialization; validate on explicit preview open.

  // enviroment
  const browserLocation = window.location.href.toString();
  let developmentMode = true;
  if (
    window.location.hostname === "domposer.com" ||
    window.location.hostname === "www.domposer.com" ||
    window.location.hostname === "domposer.dunkerley.dev"
  ) {
    developmentMode = false;
  }

  // ---------------------------------------------------
  // ---------------------------------------------------

  /***
   *    ########   #######  ##     ## ########   #######   ######  ######## ########
   *    ##     ## ##     ## ###   ### ##     ## ##     ## ##    ## ##       ##     ##
   *    ##     ## ##     ## #### #### ##     ## ##     ## ##       ##       ##     ##
   *    ##     ## ##     ## ## ### ## ########  ##     ##  ######  ######   ########
   *    ##     ## ##     ## ##     ## ##        ##     ##       ## ##       ##   ##
   *    ##     ## ##     ## ##     ## ##        ##     ## ##    ## ##       ##    ##
   *    ########   #######  ##     ## ##         #######   ######  ######## ##     ##
   */

  function con(consolelog) {
    if (developmentMode) {
      console.log('con(', consolelog);
    }
  }

  function conStyle(consolelog, style) {
    if (developmentMode) {
      if (!style) {
        style = "color:#fff;";
      }
      var conWithStyle = "%c" + consolelog;
      return console.log(conWithStyle, style);
    }
  }

  if (developmentMode) {
    conStyle(
      "domposer is in development mode | " + time(),
      "color: var(--mainColor); font-size: 20px;"
    );
  } else {
    console.log(
      "%cdomposer.dunkerley.dev | " + time(),
      "color: var(--mainColor); font-size: 20px;"
    );
  }

  let img = new Image();
  img.src = "/images/dragger.gif";

  // GUI Elements
  // ScrollBox

  let scrollbox_width_resizer_vars = -40; // -20 absolute
  let scrollbox_width_resizer_vars_with_side_panels = -40; // -20 absolute
  let scrollbox_width_resizer_vars_min_width = scrollbox_width_resizer_vars + 70;
  const SCROLLBOX = domID("scrollbox");
  const scrollboxAreaBG = domID("scrollboxAreaBG");
  const SCROLLBOX_HANDEL = domID('scrollbox-resizer-handel');
  const scrollboxResizeBlocker = domID('scrollboxResizeBlocker');
  // Inputs
  const INPUTER1 = domID("inputer1");
  const INPUTER2 = domID("inputer2"); // Input fields, HIGH DEPENDENCY !
  const INPUTER3 = domID("inputer3");
  const INPUTER4 = domID("inputer4"); // ''
  const INFO_READOUT = domID("para1");
  const BREAKPOINT_WIDTH_READOUT = domID("paraBreakWidth");
  const ADDCLASS_BTN = domID("addClass");
  const ADDPROP_BTN = domID("addProp");
  const REMOVEPROP_BTN = domID("removeProp");
  const DROPDOWN_CLASSES = domID("dropdown-classes");
  const DROPDOWN_CLASSES_RENDER = domID("dropdown-classes-render");
  const INPUTER1_WRAP = document.querySelector(".input-wrap-1");
  const INPUTER4_WRAP = document.querySelector(".input-wrap-4");
  const OPEN_RENAME = domID("open-input-renameclass");
  const OPEN_DUPLICATE = domID("open-input-duplicateclass");
  const CLEANCLASSES = domID("cleanClasses");
  const COPY_SELECTOR_STYLES = domID("copy-selector-styles");
  const PASTE_SELECTOR_STYLES = domID("paste-selector-styles");
  const DELETE_SELECTOR_STYLES = domID("delete-selector-styles");

  // var OPEN_TARGET = domID("targetDropdown");
  const NUMBEROFELSFORSELECTOR = domID("number-of-elements-for-selector");
  const OPEN_CANCEL = domID("cancelClassChange");
  const UNDO_BTN = domID("undobutton");
  const REDO_BTN = domID("redobutton");
  const RED_SLIDER = domID("red"); // Color value slider.
  const GREEN_SLIDER = domID("green"); // ''
  const BLUE_SLIDER = domID("blue"); // ''
  const ALPHA_SLIDER = domID("alpha"); // ''
  // projects
  const CURRENT_PROJECT = domID("currentProject");
  const PROJECT_NAME = domID("projectName");
  const PROJECT_DESCRIPTION = domID("projectDescription");
  // BreakPointLines
  const BREAKPOINT_LINE_LG = domID("breakPointLineFull");
  const BREAKPOINT_LINE_MD = domID("breakPointLine3");
  const BREAKPOINT_LINE_SM = domID("breakPointLine2");
  const BREAKPOINT_LINE_XS = domID("breakPointLine1");
  const breakPointLineMin = domID("breakPointLineMin");
  // Breakpoints
  const BREAKPOINT_BTN_LG = domID("breakPoint_LG");
  const BREAKPOINT_BTN_MD = domID("breakPoint_MD");
  const BREAKPOINT_BTN_SM = domID("breakPoint_SM");
  const BREAKPOINT_BTN_XS = domID("breakPoint_XS");
  // Breakpoints inputs
  const BREAKPOINT_INPUT_XS = domID("inputBreakPointValue_XS");
  const BREAKPOINT_INPUT_SM = domID("inputBreakPointValue_SM");
  const BREAKPOINT_INPUT_MD = domID("inputBreakPointValue_MD");
  // Breakpoint settings
  const BREAKPOINT_SETTINGS = domID("breakPointSettings");
  const BREAKPOINT_SETTINGS_CONTAINER = domID("breakPointSettingsContainer");
  const BREAKPOINT_INPUTS_APPLY = domID("inputBreakPointApply");
  const BREAKPOINT_INPUTS_DEFAULTS = domID("inputBreakPointDefaults");
  const BREAKPOINT_INPUTS_CANCEL = domID("inputBreakPointCancel");
  // Margins
  const marginTopValue = domID("margin-top_value");
  const marginLeftValue = domID("margin-left_value");
  const marginRightValue = domID("margin-right_value");
  const marginBottomValue = domID("margin-bottom_value");
  // Margin direction hidden value elements
  const marginTopValue_dragger = domID("margin-top-dragger_value");
  const marginLeftValue_dragger = domID("margin-left-dragger_value");
  const marginRightValue_dragger = domID("margin-right-dragger_value");
  const marginBottomValue_dragger = domID("margin-bottom-dragger_value");

  // Borders
  const borderTopWidthValue = domID("border-top-width_value");
  const borderLeftWidthValue = domID("border-left-width_value");
  const borderRightWidthValue = domID("border-right-width_value");
  const borderBottomWidthValue = domID("border-bottom-width_value");
  // Border direction hidden value elements
  const borderTopWidthValue_dragger = domID("border-top-width-dragger_value");
  const borderLeftWidthValue_dragger = domID("border-left-width-dragger_value");
  const borderRightWidthValue_dragger = domID("border-right-width-dragger_value");
  const borderBottomWidthValue_dragger = domID("border-bottom-width-dragger_value");
  // border radius
  const borderTopLeftRadiusValue = domID("border-top-left-radius_value");
  const borderTopRightRadiusValue = domID("border-top-right-radius_value");
  const borderBottomLeftRadiusValue = domID("border-bottom-left-radius_value");
  const borderBottomRightRadiusValue = domID(
    "border-bottom-right-radius_value"
  );
  // Border radius direction hidden value elements
  const borderTopLeftRadiusValue_dragger = domID("border-top-left-radius-dragger_value");
  const borderTopRightRadiusValue_dragger = domID("border-top-right-radius-dragger_value");
  const borderBottomLeftRadiusValue_dragger = domID("border-bottom-left-radius-dragger_value");
  const borderBottomRightRadiusValue_dragger = domID("border-bottom-right-radius-dragger_value");

  // Outline
  const outlineWidthValue = domID("outline-width_value");
  const outlineOffsetValue = domID("outline-offset_value");
  // text-decoration
  const textDecorationThicknessValue = domID("text-decoration-thickness_value");
  // Padding
  const paddingTopValue = domID("padding-top_value");
  const paddingLeftValue = domID("padding-left_value");
  const paddingRightValue = domID("padding-right_value");
  const paddingBottomValue = domID("padding-bottom_value");
  // Padding direction hidden value elements
  const paddingTopValue_dragger = domID("padding-top-dragger_value");
  const paddingLeftValue_dragger = domID("padding-left-dragger_value");
  const paddingRightValue_dragger = domID("padding-right-dragger_value");
  const paddingBottomValue_dragger = domID("padding-bottom-dragger_value");
  // Size
  const widthValue = domID("width_value");
  const heightValue = domID("height_value");
  // Size hidden value elements
  const widthValue_dragger = domID("width-dragger_value");
  const heightValue_dragger = domID("height-dragger_value");
  const minWidthValue = domID("min-width_value");
  const minHeightValue = domID("min-height_value");
  const maxWidthValue = domID("max-width_value");
  const maxHeightValue = domID("max-height_value");
  // Position
  const leftValue = domID("left_value");
  const topValue = domID("top_value");
  const rightValue = domID("right_value");
  const bottomValue = domID("bottom_value");
  // zIndex
  const zindexValue = domID("zIndex_value");
  const zIndexAuto = domID("zIndex-auto");
  const zIndexInitial = domID("zIndex-initial");
  const zIndexInherit = domID("zIndex-inherit");
  // Font
  const fontSizeValue = domID("font-size_value");
  const letterSpacingValue = domID("letter-spacing_value");
  const lineHeightValue = domID("line-height_value");
  // Flex direction
  const flexDirectionRow = domID("flex-direction-row");
  const flexDirectionRowReverse = domID("flex-direction-row-reverse");
  const flexDirectionColumn = domID("flex-direction-column");
  const flexDirectionColumnReverse = domID("flex-direction-column-reverse");
  // Flex item inputs
  const flexOrder = domID("order");
  const flexGrow = domID("flex-grow");
  const flexShrink = domID("flex-shrink");
  const flexBasis = domID("flex-basis");
  // grid inputs
  const gridRowStartValue = domID("grid-row-start_value");
  const gridRowEndValue = domID("grid-row-end_value");
  const gridColumnStartValue = domID("grid-column-start_value");
  const gridColumnEndValue = domID("grid-column-end_value");
  // Opacity
  const opacityValue = domID("opacity_value");
  const colorValue_input = domID("color_value");
  const backgroundColorValue_input = domID("background-color_value");
  // Class and DOM tree insertion points
  //var rebtns = domID("rebtns");
  const rebtns3 = domID("rebtns3");
  // Box Shadows
  const currentShad1 = domID("currentShad1");
  const currentShad2 = domID("currentShad2");
  const currentShad3 = domID("currentShad3");
  const currentShad4 = domID("currentShad4");
  const boxShadowHShadowValue = domID("box-shadow-hShadow_value");
  const boxShadowVShadowValue = domID("box-shadow-vShadow_value");
  const boxShadowBlurValue = domID("box-shadow-blur_value");
  const boxShadowSpreadValue = domID("box-shadow-spread_value");
  const boxShadowInset = domID("box-shadow-inset");
  const redShadValue = domID("redShadValue");
  const redShad = domID("redShad");
  const greenShadValue = domID("greenShadValue");
  const greenShad = domID("greenShad");
  const blueShadValue = domID("blueShadValue");
  const blueShad = domID("blueShad");
  const alphaShadValue = domID("alphaShadValue");
  const alphaShad = domID("alphaShad");
  // Text Shadows
  const currentShad1Text = domID("currentShad1Text");
  const currentShad2Text = domID("currentShad2Text");
  const currentShad3Text = domID("currentShad3Text");
  const currentShad4Text = domID("currentShad4Text");
  const TextShadowHShadowValue = domID("text-shadow-hShadow_value");
  const TextShadowVShadowValue = domID("text-shadow-vShadow_value");
  const TextShadowBlurValue = domID("text-shadow-blur_value");
  const redShadTextValue = domID("redShadTextValue");
  const redShadText = domID("redShadText");
  const greenShadTextValue = domID("greenShadTextValue");
  const greenShadText = domID("greenShadText");
  const blueShadTextValue = domID("blueShadTextValue");
  const blueShadText = domID("blueShadText");
  const alphaShadTextValue = domID("alphaShadTextValue");
  const alphaShadText = domID("alphaShadText");
  // Expand buttons
  const customPropertyButton = domID("customPropertyButton");
  const colorsButton = domID("colorsButton");
  const positionButton = domID("positionButton");
  const displayButton = domID("displayButton");
  const flexboxButton = domID("flexboxButton");
  const gridButton = domID("gridButton");
  const floatButton = domID("floatButton");
  const stackButton = domID("stackButton");
  const cursorButton = domID("cursorButton");
  const cursorTest = domID("test-cursor");
  const overflowButton = domID("overflowButton");
  const spacingButton = domID("spacingButton");
  const sizeButton = domID("sizeButton");
  const fontsButton = domID("fontsButton");
  const textButton = domID("textButton");
  const listButton = domID("listButton");
  const bordersButton = domID("bordersButton");
  const outlineButton = domID("outlineButton");
  const shadowsButton = domID("shadowsButton");
  const shadowsButtonText = domID("shadowsButtonText");
  const transformButton = domID("transformButton");
  const backgroundButton = domID("backgroundButton");
  const gradientButton = domID("gradientButton");
  const filtersButton = domID("filtersButton");
  // Containers
  const maincontainerRight = domID("maincontainerRight");
  const fullScreenMessage = domID("fullScreenMessage");
  const mobileFirstBtn = domID("mobileFirst");
  const mobileLastBtn = domID("mobileLast");
  const reverseBreakpointsDiv = domID("reverseBreakpoints");
  const addAttributes = domID("addAttributes");
  const imageHolder = domID("imageHolder");
  const autoScrollButton = domID("autoScrollButton");
  const iframeBlocker = domID("iframeBlocker");
  const holder = domID("fileDrop");
  const imageDropZone = domID("maincontainerLeftBottom");
  const rotateValReadout = domID("rotate_value");
  const scaleValXReadout = domID("scaleX_value");
  const scaleValYReadout = domID("scaleY_value");
  const skewValXReadout = domID("skewX_value");
  const skewValYReadout = domID("skewY_value");
  const translateValXReadout = domID("translateX_value");
  const translateValYReadout = domID("translateY_value");
  const originValXReadout = domID("originX_value");
  const originValYReadout = domID("originY_value");
  const gapValXReadout = domID("gapX_value");
  const gapValYReadout = domID("gapY_value");
  const fontFamilyInputer = domID("fontFamilyInputer");
  const targetDropText = domID("targetDropText");
  const targetDropBox = domID("targetDropBox");
  const colorPickerShowBtn = domID("colorPickerShow");
  const colorPanel = domID("colorPanel");
  const copyHTML = domID("copyHTML");
  const copyCSS = domID("copyCSS");
  const btnsThatUndo = getTheButtonsWithHasUndo();
  const filters_render = domID("filters_render");
  const codesection = domID("code-section");
  const CSSINLINEBTN = domID('css-inline');

  function getTheButtonsWithHasUndo() {
    var array = [];
    var els = document.querySelectorAll(".HD");
    els.forEach.call(els, function (el) {
      array.push(el.id);
    });
    return array;
  }
  var inactiveStyle = "display: none;";
  var mainColor = "var(--mainColor)";
  var ButtonBorderHL = "var(--data-rainbow-color)" + " solid 1px";
  var buttonHLColor = "background: var(--mainColor); color: var(--button-text-active);";
  var buttonHLColor_faded = "background: #777; color: #fff;";
  var buttonBGColor = null;
  var BorderHL = "var(--main-text-faded)";
  var iframe = document.createElement("iframe");
  //var theValREGEX = /\D+$/; // Removes letters from digits.
  var theValREGEX = /\D+$/g;
  var iframeContents;
  var iframeBody;
  var iframeHTML;
  var iframeElementSelect;
  var classcss; // Main Canvas elements are added to
  var units = "px"; // Default units
  var uniqid; // Random ID generated by guidGenerator()
  var domElement = ["classcss", "DIV"]; // 0 = id; 1 = tag name. Default target for adding new elements.
  var droppedIn; // For element Drag/Drop.
  var vauleBeingDragged = false; // For value Drag.
  var editingText = false; // Set when double clicking text to edit.
  var HTMLarray; // Array of all html in the classcss DIV.
  var thecssLG; // Object of all the css values that are created. logger() needs calling after adding/deleting.
  var thecssMD;
  var thecssSM;
  var thecssXS; // Object of all the css values with breakpoints.
  var breakPoint;
  var BP;
  var CSSstyles = {};
  var input1fortarget; // Creates a target for the place to add elements.
  var inc; // Updates the undo level.
  var undoInc; // Updates the undo level.
  var currentundoLevel; // Updates the undo level.
  var theColorProperty = "background-color"; // for inputer2 to color or BG color.
  var alphaVal = 1; // alpha value slider of RGBA type.
  var rgb; // Holds Red; Green and Blue color values.
  var theColor; // Holds Red; Green; Blue and Opacity values.
  var overScrollbox; // true or false.
  var overMainRight; // ''
  var PseudoState = "noneSelected"; // other states: link; visited; hover & active.
  // Breakpoint defaults

  var breakPoint_Min_Value = 320;
  var breakPoint_XS_Value = 576;
  var breakPoint_SM_Value = 768;
  var breakPoint_MD_Value = 992;
  setBreakPointCSSvariables();

  var clickedBP = false;
  var mobileFirst;
  // pages
  var page_name = window.localStorage.getItem('page_name') || 'index';
  window.localStorage.setItem('page_name', page_name);
  var page_names =
    JSON.parse(window.localStorage.getItem('page_names')) || ["index"];
  window.localStorage.setItem('page_names', JSON.stringify(page_names));

  var pages_render = domID('pages-render');

  // Style tags in <head>
  var placeInHeadNormalize;
  var placeInHead;
  var placeInHeadTransition;
  var placeInHeadTempCSS;
  var altKeyPressed;
  var fullScreenMode;
  var editingTextElement;
  var currentElement;
  var valueReadout;
  var objectOfBlobs;
  var autoScroll = true;
  var siteTitle;
  var codeView;
  // select element box overlays

  var component_theme = 'light';
  var component_theme__select = domID('select-theme');

  // preview - opens preview in new tab
  var preview;
  var preview_active;

  cssStylesBreakPoints(); // Needs calling early
  breakPoint = "fullWidth";
  if (window.localStorage.breakPoint1Value) {
    breakPoint_MD_Value = Number(window.localStorage.breakPoint1Value);
    breakPoint_SM_Value = Number(window.localStorage.breakPoint2Value);
    breakPoint_XS_Value = Number(window.localStorage.breakPoint3Value);
    setBreakPointCSSvariables();
  }

  function detectIfChrome() {

    // disabling this as firefox now ok // not sure about safari and others
    return true;

    // var isChrome =
    //   /Chrome/.test(navigator.userAgent) &&
    //   /Google Inc/.test(navigator.vendor);
    // if (isChrome) return true;
    // return true; // to test browsers that are not chrome.
  }

  window.addEventListener("load", function () {
    var chrome = detectIfChrome();
    var w = window.innerWidth;
    if (w < breakPoint_MD_Value + scrollbox_width_resizer_vars_min_width) {
      fullScreenMessage.style.cssText = "display: none;";
      CSSDone();
      setTimeout(function () {
        toggleFullScreenMode();
      }, 0);
    } else {
      CSSDone();
      // Give the canvas background a checkerd pattern
      scrollboxAreaBG.style.background =
        "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAJUlEQVQoU2NkYGD4z4AJGNGFQAJDQSEWv2C6G8N3UF0YHhxAhQBLjgoG6DTb1AAAAABJRU5ErkJggg==) repeat;";
      if (chrome) {
        domID("resolutionMessageText").style["pointer-events"] = null;
        domID("resolutionMessageText").style["user-Select"] = null;
        domID("resolutionMessage").style["pointer-events"] = null;
        domID("resolutionMessageText").innerHTML = "";
      } else {
        if (onLoadCounter === 1) {
          var text =
            "Domposer works best with " +
            '<span class="res-message"><a id="resolutionMessageTextLink"' +
            ' href="https://www.google.co.uk/chrome/">' +
            "Google Chrome." +
            "</a></span><br>Some features of this app may not work<br> correctly in your current Browser.<br><br>" +
            '<span id="not-chrome">Continue anyway</span>';
          domID("resolutionMessageText").innerHTML = text;
          domID("resolutionMessage").style.display = "initial";
          domID("resolutionMessageText").style["pointer-events"] =
            "initial";
          domID("resolutionMessageText").style["user-Select"] =
            "initial";
          domID("resolutionMessage").style["pointer-events"] =
            "initial";
          domID("resolutionMessageTextLink").style["pointer-events"] =
            "initial";
          domID("not-chrome").addEventListener("click", function () {
            location.reload();
          });
        }
      }
    }
  });
  // ---------------------------------------------------
  // ---------------------------------------------------
  // ---------------------------------------------------
  // ---------------------------------------------------
  // Iframe setup when loadad.

  /***
   *    #### ######## ########     ###    ##     ## ########
   *     ##  ##       ##     ##   ## ##   ###   ### ##
   *     ##  ##       ##     ##  ##   ##  #### #### ##
   *     ##  ######   ########  ##     ## ## ### ## ######
   *     ##  ##       ##   ##   ######### ##     ## ##
   *     ##  ##       ##    ##  ##     ## ##     ## ##
   *    #### ##       ##     ## ##     ## ##     ## ########
   *
   *     #######  ##    ## ##        #######     ###    ########
   *    ##     ## ###   ## ##       ##     ##   ## ##   ##     ##
   *    ##     ## ####  ## ##       ##     ##  ##   ##  ##     ##
   *    ##     ## ## ## ## ##       ##     ## ##     ## ##     ##
   *    ##     ## ##  #### ##       ##     ## ######### ##     ##
   *    ##     ## ##   ### ##       ##     ## ##     ## ##     ##
   *     #######  ##    ## ########  #######  ##     ## ########
   */

  function setBreakPointCSSvariables() {
    document.documentElement.style.setProperty('--scrollBoxMin', breakPoint_Min_Value + 'px');
    document.documentElement.style.setProperty('--scrollBoxMin_value', '"' + breakPoint_Min_Value + '"');
    document.documentElement.style.setProperty('--breakPointLine1_value', '"' + breakPoint_XS_Value + '"');
    document.documentElement.style.setProperty('--breakPointLine2_value', '"' + breakPoint_SM_Value + '"');
    document.documentElement.style.setProperty('--breakPointLine3_value', '"' + breakPoint_MD_Value + '"');
  }

  function setColorCSSvariables() {

    var hue = 0;
    var sat_rainbowbutton = 0.6666;
    var sat = sat_rainbowbutton;
    document.documentElement.style.setProperty('--sat-rainbowbutton', sat_rainbowbutton);

    if (window.localStorage.getItem("theme-color")) {
      hue = window.localStorage.getItem("theme-color");
    } else {
      hue = 180; // blue
    }

    if (hue === 'grey') {
      document.documentElement.style.setProperty('--sat-value', 0);
      iframeHTML.style.setProperty('--sat-value', 0);
      document.documentElement.style.setProperty('--hue-value', 0 + 'deg');
      iframeHTML.style.setProperty('--hue-value', 0 + 'deg');
    } else {
      document.documentElement.style.setProperty('--hue-value', hue + 'deg');
      iframeHTML.style.setProperty('--hue-value', hue + 'deg');
      document.documentElement.style.setProperty('--sat-value', sat);
      iframeHTML.style.setProperty('--sat-value', sat);
    }

    var rainbow_buttons = document.querySelectorAll(".rainbow-button");
    [].forEach.call(rainbow_buttons, function (rainbow_button) {

      rainbow_button.onclick = function (e) {
        hue = e.target.getAttribute("data-raindow");
        window.localStorage.setItem("theme-color", hue);

        if (hue === 'grey') {
          document.documentElement.style.setProperty('--sat-value', 0);
          iframeHTML.style.setProperty('--sat-value', 0);
          document.documentElement.style.setProperty('--hue-value', 0 + 'deg');
          iframeHTML.style.setProperty('--hue-value', 0 + 'deg');
        } else {
          document.documentElement.style.setProperty('--hue-value', hue + 'deg');
          iframeHTML.style.setProperty('--hue-value', hue + 'deg');
          document.documentElement.style.setProperty('--sat-value', sat);
          iframeHTML.style.setProperty('--sat-value', sat);
        }
      };
    });
  }

  function removeBreakPointLine() {
    // remove the class active
    BREAKPOINT_LINE_LG.classList.remove("breakPointLine--active");
    BREAKPOINT_LINE_MD.classList.remove("breakPointLine--active");
    BREAKPOINT_LINE_SM.classList.remove("breakPointLine--active");
    BREAKPOINT_LINE_XS.classList.remove("breakPointLine--active");
    // remove the class inherit
    BREAKPOINT_LINE_LG.classList.remove("breakPointLine--inherit");
    BREAKPOINT_LINE_MD.classList.remove("breakPointLine--inherit");
    BREAKPOINT_LINE_SM.classList.remove("breakPointLine--inherit");
    BREAKPOINT_LINE_XS.classList.remove("breakPointLine--inherit");
    // remove the class none
    BREAKPOINT_LINE_LG.classList.remove("breakPointLine--text-active");
    BREAKPOINT_LINE_MD.classList.remove("breakPointLine--text-active");
    BREAKPOINT_LINE_SM.classList.remove("breakPointLine--text-active");
    BREAKPOINT_LINE_XS.classList.remove("breakPointLine--text-active");
    breakPointLineMin.classList.remove("breakPointLine--text-active");
  }

  function setBreakPointLine(BREAKPOINT_LINE) {
    // breakpoing values
    if (mobileFirst) {
      switch (breakPoint) {
        case "fullWidth":
          removeBreakPointLine();
          BREAKPOINT_LINE_MD.classList.add("breakPointLine--text-active");
          break;
        case "breakPoint1":
          removeBreakPointLine();
          BREAKPOINT_LINE_LG.classList.add("breakPointLine--inherit");
          BREAKPOINT_LINE_MD.classList.add("breakPointLine--text-active");
          BREAKPOINT_LINE_SM.classList.add("breakPointLine--text-active");
          break;
        case "breakPoint2":
          removeBreakPointLine();
          BREAKPOINT_LINE_LG.classList.add("breakPointLine--inherit");
          BREAKPOINT_LINE_MD.classList.add("breakPointLine--inherit");
          BREAKPOINT_LINE_MD.classList.add("breakPointLine--text-active");
          BREAKPOINT_LINE_SM.classList.add("breakPointLine--text-active");
          BREAKPOINT_LINE_XS.classList.add("breakPointLine--text-active");
          break;
        case "breakPoint3":
          removeBreakPointLine();
          BREAKPOINT_LINE_LG.classList.add("breakPointLine--inherit");
          BREAKPOINT_LINE_MD.classList.add("breakPointLine--inherit");
          BREAKPOINT_LINE_SM.classList.add("breakPointLine--inherit");
          BREAKPOINT_LINE_MD.classList.add("breakPointLine--text-active");
          BREAKPOINT_LINE_SM.classList.add("breakPointLine--text-active");
          BREAKPOINT_LINE_XS.classList.add("breakPointLine--text-active");
          breakPointLineMin.classList.add("breakPointLine--text-active");
          break;
      }
    } else {
      switch (breakPoint) {
        case "fullWidth":
          removeBreakPointLine();
          BREAKPOINT_LINE_MD.classList.add("breakPointLine--inherit");
          BREAKPOINT_LINE_SM.classList.add("breakPointLine--inherit");
          BREAKPOINT_LINE_XS.classList.add("breakPointLine--inherit");
          BREAKPOINT_LINE_MD.classList.add("breakPointLine--text-active");
          BREAKPOINT_LINE_SM.classList.add("breakPointLine--text-active");
          BREAKPOINT_LINE_XS.classList.add("breakPointLine--text-active");
          breakPointLineMin.classList.add("breakPointLine--text-active");
          break;
        case "breakPoint1":
          removeBreakPointLine();
          BREAKPOINT_LINE_SM.classList.add("breakPointLine--inherit");
          BREAKPOINT_LINE_XS.classList.add("breakPointLine--inherit");
          BREAKPOINT_LINE_SM.classList.add("breakPointLine--text-active");
          BREAKPOINT_LINE_XS.classList.add("breakPointLine--text-active");
          breakPointLineMin.classList.add("breakPointLine--text-active");
          break;
        case "breakPoint2":
          removeBreakPointLine();
          BREAKPOINT_LINE_XS.classList.add("breakPointLine--inherit");
          BREAKPOINT_LINE_XS.classList.add("breakPointLine--text-active");
          breakPointLineMin.classList.add("breakPointLine--text-active");
          break;
        case "breakPoint3":
          removeBreakPointLine();
          breakPointLineMin.classList.add("breakPointLine--text-active");
          break;
      }
    }
    // add the class
    BREAKPOINT_LINE.classList.add("breakPointLine--active");
  }

  var BREAKPOINT_WIDTH_READOUT_mode;

  function mobileFirstTrue() {
    mobileFirst = true;
    BREAKPOINT_WIDTH_READOUT_mode = " mobile first";
    breakPoint = "breakPoint3";
    mobileFirstBtn.style = buttonHLColor;
    mobileLastBtn.style = buttonBGColor;
    BREAKPOINT_BTN_LG.style = buttonBGColor;
    BREAKPOINT_BTN_MD.style = buttonBGColor;
    BREAKPOINT_BTN_SM.style = buttonBGColor;
    BREAKPOINT_BTN_XS.style = buttonHLColor;
    setBreakPointLine(BREAKPOINT_LINE_XS);

    setBreakpointWhenPageLoads();
    setScrollboxResizeBlocker();

  }

  function mobileFirstFalse() {
    mobileFirst = false;
    BREAKPOINT_WIDTH_READOUT_mode = " responsive";
    breakPoint = "fullWidth";
    mobileFirstBtn.style = buttonBGColor;
    mobileLastBtn.style = buttonHLColor;
    BREAKPOINT_BTN_LG.style = buttonHLColor;
    BREAKPOINT_BTN_MD.style = buttonBGColor;
    BREAKPOINT_BTN_SM.style = buttonBGColor;
    BREAKPOINT_BTN_XS.style = buttonBGColor;
    setBreakPointLine(BREAKPOINT_LINE_LG);
    // clickedBP = true;
    // fullWidth();
    // setScrollboxResizeBlocker();

    setBreakpointWhenPageLoads();
    setScrollboxResizeBlocker();

  }

  iframe.onload = function () {
    iframeContents =
      iframe.contentDocument || iframe.contentWindow.document;
    classcss = iframeContents.getElementById("classcss");
    iframeBody = iframeContents.getElementById("body");
    iframeHTML = iframeContents.documentElement;
    iframeElementSelect = iframeHTML.querySelector('element-select');
    if (darkmode === 'false') {
      iframeHTML.setAttribute('data-theme', 'light');
    } else {
      iframeHTML.setAttribute('data-theme', 'dark');
    }

    placeInHeadNormalize = iframeContents.getElementById("normalizeCSS");
    placeInHead = iframeContents.getElementById("JScss");
    placeInHeadTransition = iframeContents.getElementById(
      "JScssTransition"
    );
    placeInHeadTempCSS = iframeContents.getElementById(
      "JScssTempCSS"
    );

    NormalizeToIframe();
    clearTheHTML(classcss);
    renderHTML();
    createObjectOfBlobs();
    INPUTER1.value = "";
    DOMtree();
    cssStylesBreakPoints();
    ScrollboxSizeResizer();
    visitorFileLoadLogic();
    setColorCSSvariables();
    classcss.addEventListener("transitionend", function () {
      if (is_this_or_parents_web_component()) {
        BoxRefresh();
      }
    });
    classcss.addEventListener('dp-element-transitiionend', () => {
      BoxRefresh();
    });
    setTimeout(function () {
      domID("spinner").style.cssText = "display: none;";
    }, 2000);
    if (!classcss.children.length) {
      info(
        "Start by adding a tag name (top left)" +
        ' then click the add element button.',
        null,
        null
      );
    } else {
      info("Select an element.", null, null);
    }
    iframeLoaded();

    if (window.localStorage.mobileFirst) {
      var mobileFirstval = window.localStorage.mobileFirst;
      if (mobileFirstval === "true") {
        mobileFirstTrue();
      } else {
        mobileFirstFalse();
      }
    } else {
      mobileFirstTrue();
      FillStoragemobileFirst();
    }
    renderPreviewImagesFromIndexedDB();
    renderImagesFromIndexedDB();

    if (SCROLLBOX.offsetHeight < 200) {
      SCROLLBOX.style.removeProperty('height');
    }

    setBreakpointWhenPageLoads();
    var testFrameEl;
    var lastElSelected = window.localStorage.getItem("domElement");
    lastElSelected = false;
    if (lastElSelected) {
      testFrameEl = frameID(lastElSelected);
      if (testFrameEl) {
        // after load this is when element is selected
        selectElement(frameID(lastElSelected));
      }
    }
    //undoRedo();
    if (window.sessionStorage.getItem('preview') && window.sessionStorage.getItem('preview') === 'true') {
      has_preview = 'true';
      domID('preview').style.cssText = 'background: var(--mainColor); color: var(--button-text-active);';
      setTimeout(() => {
        initiate_preview();
      }, 0);
    }
  };
  iframe.src = "/iframe";
  iframe.setAttribute("title", "main canvas");
  iframe.setAttribute('sandbox', 'allow-same-origin allow-scripts');
  SCROLLBOX.appendChild(iframe);
  iframe.id = "iframeClasscss";
  iframe.style.overflow = "hidden";
  // in "iframeLoaded()" function.
  function iframeLoaded() {

    refreshCodeView();
    show_tutorial();

    // events
    iframeContents.onmousedown = function (e) {
      let selection = iframeContents.getSelection();
      selection.removeAllRanges();
      if (!editingText) {

        // iframeElementSelect.setAttribute('target', e.target.id);
        // iframe.contentWindow.postMessage('text_options_hide');
      }
    };

    iframeContents.addEventListener('contextmenu', (e) => {
      e.preventDefault();
      // if (e.target.id !== domElement[0]) {
      //   SelectTarget(e);
      // }
      context_menu(e);
    });

    iframeContents.onblur = function (e) {
      let selection = iframeContents.getSelection();
      selection.removeAllRanges();
      iframe.contentWindow.postMessage('text_options_hide', window.location.origin);
    };

    iframeContents.onmouseup = function (event) {
      event.preventDefault();
      var btnCode;
      // forward back buttons on mouse
      if ('object' === typeof event) {
        btnCode = event.button;
        switch (btnCode) {
          case 3:
            // undo/back mouse button
            if (fullScreenMode) {
              reload();
            } else {
              undoBtn();
            }
            break;
          case 4:
            // redo/forward mouse button
            if (fullScreenMode) {
              reload();
            } else {
              redoBtn();
            }
            break;
        }
      }



      iframe.contentWindow.postMessage('text_options_hide', window.location.origin);
      if (iframeContents.getSelection().toString().length > 0) {

        // store selection range here
        let selection = iframeContents.getSelection();
        let range = selection.getRangeAt(0);

        var saveNode = range.startContainer;
        var startOffset = range.startOffset; // where the range starts
        var endOffset = range.endOffset; // where the range ends

        var nodeData = saveNode.data; // the actual selected text
        var nodeHTML = saveNode.parentElement.innerHTML; // parent element innerHTML
        var nodeTagName = saveNode.parentElement.tagName; // parent element tag name

        let saved_range = {
          'startOffset': startOffset,
          'endOffset': endOffset,
          'nodeData': nodeData,
          'nodeHTML': nodeHTML,
          'nodeTagName': nodeTagName,
        };


        window.localStorage.setItem('saved_range', JSON.stringify(saved_range));


        iframe.contentWindow.postMessage('text_options_show', window.location.origin);
      }
    };

    iframeContents.ondblclick = (e) => {
      e.preventDefault();
      if (fullScreenMode) {
        return false;
      }
      if (overScrollbox === false) {
        return false;
      }
      let et = e.target;
      if (et.id === 'classcss' || !et.id) {
        return false;
      }

      var can_edit_text = false;
      var tag = e.target.tagName.toLowerCase();
      acceptTextEdit.map((item) => {
        if (item === tag) {
          can_edit_text = true;
        }
      });

      if (!can_edit_text) {

        let can_edit_text_child = false;

        let elements_children = [...e.target.children];

        for (var i = 0; i < elements_children.length; i++) {
          let child = elements_children[i];
          tag = child.tagName.toLowerCase();
          for (var j = 0; j < acceptTextEdit.length; j++) {
            let item = acceptTextEdit[j];
            if (item === tag) {
              et = child;
              can_edit_text_child = true;
              break;
            }
          }
          if (can_edit_text_child) {
            break;
          }
        }


        if (!can_edit_text_child) {
          selectElement(e.target);
          //info('Text edit not allowed on &lt;' + tag + '&gt;', 2000, true);
          return false;
        }

      }
      info('Editing text on &lt;' + tag + '&gt;', 2000, false);
      editingTextElement = et;
      et.setAttribute("contenteditable", "true");
      //et.style.setProperty('user-select', 'all');
      editingText = true;
      et.focus();
      iframeElementSelect.setAttribute('target', et.id);
      iframe.contentWindow.postMessage('update_target', window.location.origin);

      //editTextSwitchOn();
      et.onblur = () => {
        if (fullScreenMode) {
          return false;
        }
        var el = editingTextElement;
        editingText = false;
        var tempInnerHTML = el.innerHTML;
        el.innerHTML = "";
        el.innerHTML = tempInnerHTML;
        setTimeout(function () {
          FillStorageHTML();
          selectElement(el);
          FillUndo();
          let all_these_els = [...classcss.querySelectorAll('*')];
          all_these_els.map((el) => {
            el.removeAttribute("contenteditable");
            //et.style.removeProperty('user-select');
          });
        }, 0);
      };

    };


    //Listen for the event from <element-select>
    let evt_el; // retains this for mouseup & mousemove
    iframe.contentWindow.addEventListener("element_select_mousedown", function (e) {

      let evt_type = "";
      let evt = e.detail.event;

      switch (e.detail.button) {
        // size
        case "s-handel-r-down":
          evt_el = widthValue_dragger;
          evt_type = "mousedown";
          open_tab_with_animation("size");
          break;
        case "s-handel-b-down":
          evt_el = heightValue_dragger;
          evt_type = "mousedown";
          open_tab_with_animation("size");
          break;
          // padding
        case "p-handel-t-down":
          evt_el = paddingTopValue_dragger;
          evt_type = "mousedown";
          open_tab_with_animation("padding");
          break;
        case "p-handel-l-down":
          evt_el = paddingLeftValue_dragger;
          evt_type = "mousedown";
          open_tab_with_animation("padding");
          break;
        case "p-handel-r-down":
          evt_el = paddingRightValue_dragger;
          evt_type = "mousedown";
          open_tab_with_animation("padding");
          break;
        case "p-handel-b-down":
          evt_el = paddingBottomValue_dragger;
          evt_type = "mousedown";
          open_tab_with_animation("padding");
          break;
          // margin
        case "m-handel-t-down":
          evt_el = marginTopValue_dragger;
          evt_type = "mousedown";
          open_tab_with_animation("margin");
          break;
        case "m-handel-l-down":
          evt_el = marginLeftValue_dragger;
          evt_type = "mousedown";
          open_tab_with_animation("margin");
          break;
        case "m-handel-r-down":
          evt_el = marginRightValue_dragger;
          evt_type = "mousedown";
          open_tab_with_animation("margin");
          break;
        case "m-handel-b-down":
          evt_el = marginBottomValue_dragger;
          evt_type = "mousedown";
          open_tab_with_animation("margin");
          break;
          // border
        case "b-handel-b-down":
          evt_el = borderBottomWidthValue_dragger;
          evt_type = "mousedown";
          open_tab_with_animation("border");
          break;
        case "b-handel-l-down":
          evt_el = borderLeftWidthValue_dragger;
          evt_type = "mousedown";
          open_tab_with_animation("border");
          break;
        case "b-handel-r-down":
          evt_el = borderRightWidthValue_dragger;
          evt_type = "mousedown";
          open_tab_with_animation("border");
          break;
        case "b-handel-t-down":
          evt_el = borderTopWidthValue_dragger;
          evt_type = "mousedown";
          open_tab_with_animation("border");
          break;
        case "br-handel-tl-down":
          evt_el = borderTopLeftRadiusValue_dragger;
          evt_type = "mousedown";
          open_tab_with_animation("border");
          break;
        case "br-handel-tr-down":
          evt_el = borderTopRightRadiusValue_dragger;
          evt_type = "mousedown";
          open_tab_with_animation("border");
          break;
        case "br-handel-bl-down":
          evt_el = borderBottomLeftRadiusValue_dragger;
          evt_type = "mousedown";
          open_tab_with_animation("border");
          break;
        case "br-handel-br-down":
          evt_el = borderBottomRightRadiusValue_dragger;
          evt_type = "mousedown";
          open_tab_with_animation("border");
          break;

          // other events
        case "element-select-mouseup":
          evt_type = "mouseup";
          break;
        case "element-select-mousemove":
          evt_type = "mousemove";
          break;
        default:
          setTimeout(() => {
            con('element_select_mousedown');
            con(e);
            con(e.detail.button);
            if (e.detail.button === "context-menu-open") {
              e.preventDefault();
              context_menu(e.detail.event, false);
            }
            open_tab_with_animation(e.detail.button, true);
          }, 0);
          break;
      }
      if (evt_el && evt_type) {
        simulateMouseEvent(evt_el, evt_type, evt.bubbles, evt.cancelable, evt.view, evt.detail, evt.screenX, evt.screenY, evt.clientX, evt.clientY);
        add_element_empty_attributes();
      }
    }, false);

    let last_open_tab_with_animation = "";
    let prev_autoscroll;

    function open_tab_with_animation(style_property, force) {

      if (!force && last_open_tab_with_animation === style_property) {
        return;
      }
      last_open_tab_with_animation = style_property;

      openTabForProperty(style_property, true);
      let fade_el = document.getElementById('fadeOutAnimation_tab_' + style_property);

      let elmnt = document.getElementById("right-sections");
      let display_of = elmnt.style.getPropertyValue('display');
      if (display_of === 'none') {
        simulateMouseEvent(domID('cssButton'), "click");
      }

      if (fade_el) {
        prev_autoscroll = autoScroll;
        autoScroll = false;
        fade_el.scrollIntoView({
          behavior: "auto",
          block: "center",
          inline: "center"
        });
        setTimeout(() => {
          fade_el.classList.add('fadeOutAnimation_tab');
          fade_el.addEventListener("animationend", function () {
            fade_el.classList.remove('fadeOutAnimation_tab');
            autoScroll = prev_autoscroll;
          });
        }, 300);
      }
    }

    iframeContents.onclick = SelectTarget;

    function SelectTarget(event) {
      if (fullScreenMode) {
        return false;
      }
      if (
        editingTextElement !== frameID(event.target.id) &&
        editingText === true
      ) {
        return false;
      }
      if (overScrollbox === false) {
        return false;
      }

      if (!editingText) {
        var allels = classcss.querySelectorAll("*");
        [].forEach.call(allels, function (el) {
          el.removeAttribute("contenteditable");
        });
        if (overScrollbox === true) {
          if (event.target.id !== "classcss") {
            var thisElement = event.target.id;
            if (event.altKey) {
              altKeyPressed = true;
            } else {
              altKeyPressed = false;
            }
            con(thisElement);
            con(domElement[0]);
            if (thisElement === domElement[0]) {
              deselectElement();
              domElement[0] = "classcss";
              domElement[1] = "DIV";
            } else {
              selectElement(frameID(thisElement));
            }
          }
        } else {
          event.target.draggable = null;
          SCROLLBOX.removeAttribute("draggable");
          classcss.removeAttribute("draggable");
        }
      }
    }


    iframeContents.onkeydown = iframe_enter_key;
    iframeContents.onkeyup = () => {
      setTimeout(() => {
        refreshCodeView();
      }, 10);
    };

    function iframe_enter_key(e) {
      if (!editingText) {
        return false;
      }
      // trap the return key being pressed
      if (e.keyCode === 13 || e.which === 13) {
        e.preventDefault();
        let selection = iframeContents.getSelection();
        let range = selection.getRangeAt(0);
        let br = document.createElement('br');
        let current_br = e.target.querySelector('br');
        if (!current_br) {
          e.target.appendChild(br);
        }
        range.deleteContents();
        range.insertNode(br);
        range.setStartAfter(br);
        range.setEndAfter(br);
        range.collapse(false);

        selection.removeAllRanges();
        selection.addRange(range);
      }
      if (e.keyCode === 32 || e.which === 32) {
        // SpaceBar
        e.preventDefault();
        iframeContents.execCommand(
          "insertHTML",
          false,
          "&nbsp;"
        );
      }
    }

    iframeContents.onmousemove = function overTarget(event) {

      if (fullScreenMode) {
        return false;
      } else {
        if (overScrollbox === false) {
          // BUTTONS IN THE APP !!
        } else {
          // ELEMENTS ON THE CANVAS !!
          if (overScrollbox === true) {
            if (event.target.id !== "classcss") {
              var thisElement_1 = event.target.id;
              var treeBTN = document.querySelector(
                '[data-clicks="' + thisElement_1 + '"]'
              );
              clearDOMTreeButtonsHL();
              if (thisElement_1) {
                iframeElementSelect.setAttribute('target-hover', thisElement_1);
                if (treeBTN) {
                  treeBTN.style.border = ButtonBorderHL;
                }
              }
              event.target.onmouseleave = function () {
                iframeElementSelect.setAttribute('target-hover', '');
                clearDOMTreeButtonsHL();
              };
              domID("unitsPanel").style.cssText =
                "display: none;";
            }
          }
        }
      }
    };

    function clearDOMTreeButtonsHL() {
      var treeBTNs = document.querySelectorAll("[data-clicks]");
      [].forEach.call(treeBTNs, function (BTN) {
        BTN.style.border = null;
      });
    }
    clearDOMTreeButtonsHL();
    // in "iframeLoaded()" function.
    iframeContents.ondragenter = function (event) {
      if (vauleBeingDragged === false) {
        event.preventDefault();
        dragEnter(event);
      }
    };
    // in "iframeLoaded()" function.
    iframeContents.ondrop = function (event) {
      if (vauleBeingDragged === false) {
        dragDrop(event);
        //event.target.removeAttribute('style');
      }
    };
    // in "iframeLoaded()" function.
    iframeContents.ondragover = function (event) {
      if (vauleBeingDragged === false) {
        event.preventDefault();
        return false;
      }
    };
    // in "iframeLoaded()" function.
    iframeContents.ondragleave = function (event) {
      if (vauleBeingDragged === false) {
        dragLeave(event);
        try {
          //event.target.removeAttribute('style');
        } catch (err) {
          con("iframeContents.ondragleave err : " + err.message);
        }
      }
    };
    // in "iframeLoaded()" function.
    iframe.contentWindow.window.onkeyup = keyboardInput;
    iframeContents.onscroll = () => {
      // iframe scroll
    };

    // in "iframeLoaded()" function.
    var disableTransition =
      "*, *:hover{transition: all 0s ease 0s !important;}";
    overScrollbox = true;
    document
      .getElementById("scrollbox")
      .querySelector("iframe")
      .addEventListener("mouseenter", function () {
        placeInHeadTransition.innerHTML = "";
        overScrollbox = true;
      });
    document
      .getElementById("scrollbox")
      .querySelector("iframe")
      .addEventListener("mouseleave", function () {
        placeInHeadTransition.innerHTML = disableTransition;
        overScrollbox = false;
      });
    document
      .getElementById("maincontainerRight")
      .addEventListener("mouseenter", overMainRightFunction);
    document
      .getElementById("maincontainerRight")
      .addEventListener("mouseleave", overMainRightFunction2);
    // in "iframeLoaded()" function.
    function overMainRightFunction() {
      overMainRight = true;
    }
    // in "iframeLoaded()" function.
    function overMainRightFunction2() {
      overMainRight = false;
    }
    observe_classcss();
    // ---------------------------------------------------
    // End of iframeLoaded();
    // ---------------------------------------------------
  }

  /***
   *    ##     ## ######## ##       ########  ######## ########   ######
   *    ##     ## ##       ##       ##     ## ##       ##     ## ##    ##
   *    ##     ## ##       ##       ##     ## ##       ##     ## ##
   *    ######### ######   ##       ########  ######   ########   ######
   *    ##     ## ##       ##       ##        ##       ##   ##         ##
   *    ##     ## ##       ##       ##        ##       ##    ##  ##    ##
   *    ##     ## ######## ######## ##        ######## ##     ##  ######
   */

  function domID(ID) {
    if (ID) {
      return document.getElementById(ID);
    }
  }

  function frameID(ID) {
    if (ID) {
      if (iframeContents) {
        return iframeContents.getElementById(ID);
      }
    }
  }

  const isSelectorValid = ((dummyElement) =>
    (selector) => {
      try {
        dummyElement.querySelector(selector);
      } catch (err) {
        return false;
      }
      return true;
    })(document.createDocumentFragment());

  function frameSelectorAll(selector) {
    if (selector) {
      if (iframeContents && classcss && isSelectorValid(selector)) {
        return [...classcss.querySelectorAll(selector)];
      } else {
        return [];
      }
    }
  }

  // puts an element after another.
  function insertAfter(referenceNode, newNode) {
    referenceNode.parentNode.insertBefore(
      newNode,
      referenceNode.nextSibling
    );
  }

  // The querySelectorAll method returns a NodeList, which is similar to an array,
  // but it's not quite an array. Therefore, it doesn't have a forEach method
  // (which array objects inherit via Array.prototype).
  function domForQuery(query, dothis) {
    var thequery = document.querySelectorAll(query);
    [].forEach.call(thequery, dothis);
  }
  // ---------------------------------------------------
  // ---------------------------------------------------
  // Add to object.
  function put(key, value, obj) {
    obj[key] = value;
    return obj;
  }
  // Delete a key from object.
  function del(key, obj) {
    if (obj && obj[key]) {
      delete obj[key];
      return obj;
    }
  }
  // ---------------------------------------------------
  // ---------------------------------------------------
  // Info Readout along the bottom of the page.
  var setTimeoutInfoReadout;

  var inputer1Label = document.querySelector('[for="inputer1"]');


  function info(str, ms, warn) {
    if (warn) {
      INFO_READOUT.style.color = "red";
    } else {
      INFO_READOUT.style.color = null;
    }
    var timer = ms || "0";
    timer = Number(timer);
    if (str) {
      INFO_READOUT.textContent = str;
      if (str === "No classname or element selected.") {
        inputer1Label.style = "color: red";
      }
    } else {
      INFO_READOUT.innerHTML = "";
      inputer1Label.removeAttribute('style');
    }
    if (ms) {
      clearTimeout(setTimeoutInfoReadout);
      setTimeoutInfoReadout = setTimeout(function () {
        INFO_READOUT.innerHTML = "";
        inputer1Label.removeAttribute('style');
      }, timer);
    } else {
      clearTimeout(setTimeoutInfoReadout);
      inputer1Label.removeAttribute('style');
    }
  }

  // ---------------------------------------------------
  // --------------------------------------------------
  // puts css in the style tag placeInHeadTempCSS in the iframe
  function placeInHeadTempCSS_func(val) {
    if (inline_external_css === 'inline') {
      if (INPUTER1.value && INPUTER2.value && val) {
        frameID(domElement[0]).style[INPUTER2.value] = val;
      }
    } else {
      if (INPUTER1.value && INPUTER2.value && val) {
        placeInHeadTempCSS.innerHTML = INPUTER1.value + "{" + INPUTER2.value + ":" + val + ";}";
      } else {
        placeInHeadTempCSS.innerHTML = "";
        setTimeout(() => {
          placeInHeadTempCSS.innerHTML = "";
        }, 3);
      }
    }
  }

  function placeInHeadTempCSS_func_multi(property, val) {
    if (INPUTER1.value && INPUTER2.value && val && property) {
      let cssString;
      switch (property) {
        case "padding":
          paddingTopValue.textContent = val;
          paddingLeftValue.textContent = val;
          paddingRightValue.textContent = val;
          paddingBottomValue.textContent = val;
          paddingTopValue_dragger.textContent = val;
          paddingLeftValue_dragger.textContent = val;
          paddingRightValue_dragger.textContent = val;
          paddingBottomValue_dragger.textContent = val;
          if (inline_external_css === 'inline') {
            frameID(domElement[0]).style[property] = val;
          } else {
            cssString = `${INPUTER1.value} { 
              padding-top: ${val};padding-right: ${val};
              padding-bottom: ${val}; padding-left: ${val};}`;
            placeInHeadTempCSS.innerHTML = cssString;
          }
          break;
        case "margin":
          marginTopValue.textContent = val;
          marginLeftValue.textContent = val;
          marginRightValue.textContent = val;
          marginBottomValue.textContent = val;
          marginTopValue_dragger.textContent = val;
          marginLeftValue_dragger.textContent = val;
          marginRightValue_dragger.textContent = val;
          marginBottomValue_dragger.textContent = val;
          if (inline_external_css === 'inline') {
            frameID(domElement[0]).style[property] = val;
          } else {
            cssString = `${INPUTER1.value} { 
              margin-top: ${val};margin-right: ${val};
              margin-bottom: ${val}; margin-left: ${val};}`;
            placeInHeadTempCSS.innerHTML = cssString;
          }
          break;
        case "border-width":
          borderTopWidthValue.textContent = val;
          borderLeftWidthValue.textContent = val;
          borderRightWidthValue.textContent = val;
          borderBottomWidthValue.textContent = val;
          borderTopWidthValue_dragger.textContent = val;
          borderLeftWidthValue_dragger.textContent = val;
          borderRightWidthValue_dragger.textContent = val;
          borderBottomWidthValue_dragger.textContent = val;
          if (inline_external_css === 'inline') {
            frameID(domElement[0]).style[property] = val;
          } else {
            cssString = `${INPUTER1.value} { 
              border-left-width: ${val}; border-top-width: ${val};
              border-right-width: ${val}; border-bottom-width: ${val};}`;
            placeInHeadTempCSS.innerHTML = cssString;
          }
          break;
        case "border-radius":
          borderTopLeftRadiusValue.textContent = val;
          borderTopRightRadiusValue.textContent = val;
          borderBottomLeftRadiusValue.textContent = val;
          borderBottomRightRadiusValue.textContent = val;
          borderTopLeftRadiusValue_dragger.textContent = val;
          borderTopRightRadiusValue_dragger.textContent = val;
          borderBottomLeftRadiusValue_dragger.textContent = val;
          borderBottomRightRadiusValue_dragger.textContent = val;
          if (inline_external_css === 'inline') {
            frameID(domElement[0]).style[property] = val;
          } else {
            cssString = `${INPUTER1.value} { 
              border-top-left-radius: ${val}; border-top-right-radius: ${val};
              border-bottom-left-radius: ${val}; border-bottom-right-radius: ${val};}`;
            placeInHeadTempCSS.innerHTML = cssString;
          }
          break;
        case "border-color":
          colorinput_border_top.style.background = val;
          colorinput_border_top_picker.source.value = set_color_for_picker(val);
          border_top_color_triangle.style.fill = color2NoAlpha(val);
          colorinput_border_bottom.style.background = val;
          colorinput_border_bottom_picker.source.value = set_color_for_picker(val);
          border_bottom_color_triangle.style.fill = color2NoAlpha(val);
          colorinput_border_left.style.background = val;
          colorinput_border_left_picker.source.value = set_color_for_picker(val);
          border_left_color_triangle.style.fill = color2NoAlpha(val);
          colorinput_border_right.style.background = val;
          colorinput_border_right_picker.source.value = set_color_for_picker(val);
          border_right_color_triangle.style.fill = color2NoAlpha(val);
          if (inline_external_css === 'inline') {
            frameID(domElement[0]).style[property] = val;
          } else {
            cssString = `${INPUTER1.value} { 
              border-top-color: ${val}; border-bottom-color: ${val};
              border-left-color: ${val}; border-right-color: ${val};}`;

            placeInHeadTempCSS.innerHTML = cssString;
          }
          break;
      }
    } else {
      placeInHeadTempCSS.innerHTML = "";
      setTimeout(() => {
        placeInHeadTempCSS.innerHTML = "";
      }, 3);
    }


  }

  // ---------------------------------------------------
  // --------------------------------------------------

  var add_vendor_prefixes_data = {
    "background-clip": {
      "text": ["-webkit-", "-moz-"]
    }
  };

  var remove_vendor_prefixes_data = ["-webkit-", "-moz-"];

  function add_prefixed_css(input2, input3) {
    var input1 = INPUTER1.value;
    switch (breakPoint) {
      case "fullWidth":
        if (thecssLG[input1] && thecssLG[input1][input2] !== input3) {
          put(input2, input3, thecssLG[input1]);
        }
        break;
      case "breakPoint1":
        if (thecssMD[input1] && thecssMD[input1][input2] !== input3) {
          put(input2, input3, thecssMD[input1]);
        }
        break;
      case "breakPoint2":
        if (thecssSM[input1] && thecssSM[input1][input2] !== input3) {
          put(input2, input3, thecssSM[input1]);
        }
        break;
      case "breakPoint3":
        if (thecssXS[input1] && thecssXS[input1][input2] !== input3) {
          put(input2, input3, thecssXS[input1]);
        }
        break;
    }
  }

  function remove_prefixed_css(input2, input3) {
    var input1 = INPUTER1.value;
    switch (breakPoint) {
      case "fullWidth":
        if (thecssLG[input1] && thecssLG[input1][input2] !== input3) {
          del(input2, thecssLG[input1]);
        }
        break;
      case "breakPoint1":
        if (thecssMD[input1] && thecssMD[input1][input2] !== input3) {
          del(input2, thecssMD[input1]);
        }
        break;
      case "breakPoint2":
        if (thecssSM[input1] && thecssSM[input1][input2] !== input3) {
          del(input2, thecssSM[input1]);
        }
        break;
      case "breakPoint3":
        if (thecssXS[input1] && thecssXS[input1][input2] !== input3) {
          del(input2, thecssXS[input1]);
        }
        break;
    }
  }

  function return_cleared_of_prefixes(input2) {
    remove_vendor_prefixes_data.map((prefix) => {
      input2 = input2.replace(prefix, '');
    });
    INPUTER2.value = input2;
    return input2;
  }

  var data_selects = document.querySelectorAll("[data-select]");
  [].forEach.call(data_selects, function (data_select) {
    data_select.onchange = function () {
      con(data_select.value);
      con(data_select.getAttribute('data-select'));
      if (INPUTER1.value) {
        var css_property = data_select.getAttribute('data-select');
        var css_property_value = data_select.value;
        if (!css_property || !css_property_value) {
          return false;
        }
        INPUTER2.value = css_property;
        INPUTER3.value = css_property_value;
        clickAdder();
        checkLocks();

        // check if vendor prefixes needed
        if (
          add_vendor_prefixes_data[css_property] &&
          add_vendor_prefixes_data[css_property][data_select.value]
        ) {
          add_vendor_prefixes_data[css_property][data_select.value].map((prefix) => {
            add_prefixed_css(prefix + css_property, css_property_value);
          });
        } else {
          remove_vendor_prefixes_data.map((prefix) => {
            remove_prefixed_css(prefix + css_property, css_property_value);
          });
        }
        buttonRefresh();
        FillUndo();
        FillValueReadouts();
      }
    };
    data_select.onclick = function () {
      con(data_select.value);
      con(data_select.getAttribute('data-select'));
      if (INPUTER1.value) {
        INPUTER2.value = data_select.getAttribute('data-select');
        INPUTER3.value = data_select.value;
        FillValueReadouts();
      }
    };
  });


  var void_elements = [
    'input', 'img'
  ];

  function change_tag_of_element(el, new_tag_type) {
    const new_el = el.ownerDocument.createElement(new_tag_type);
    for (const attr of el.attributes) {
      new_el.setAttribute(attr.name, attr.value);
    }
    new_el.innerHTML = el.innerHTML;
    el.replaceWith(new_el);
  }


  domID('change-element').onclick = function () {
    var data_select_html = domID('select__element');
    con(data_select_html.value);
    con(data_select_html.getAttribute('data-select_html'));

    if (void_elements.indexOf(data_select_html.value) > -1 && frameID(domElement[0]).innerHTML) {
      alert(`Unable to change element tag from ${frameID(domElement[0]).tagName.toLowerCase()} to ${data_select_html.value}, elements contents will be lost, delete element or remove all the elements content.`);
      return false;
    }


    con(frameID(domElement[0]));
    change_tag_of_element(frameID(domElement[0]), data_select_html.value);
    buttonRefresh();
    DOMtree();
    FillUndo();
    selectElement(frameID(domElement[0]));
    highlight_select('select__element');
  };

  function highlight_select(id) {
    var data_select_html = domID(id);
    var element_options = document.querySelectorAll('[data-select_html="' + data_select_html.getAttribute('data-select_html') + '"] option');
    [].forEach.call(element_options, function (element_option) {
      element_option.removeAttribute("selected");
    });
    var select_option_el = document.querySelector('[data-select_html="' + data_select_html.getAttribute('data-select_html') + '"] option[value="' + data_select_html.value + '"]');
    data_select_html.style = null;
    if (select_option_el && domElement[1]) {
      select_option_el.setAttribute("selected", true);
      if (data_select_html.value === domElement[1].toLowerCase()) {
        data_select_html.style = 'color: var(--mainColor);';
      } else {
        data_select_html.style = null;
      }
    }
  }

  var data_selects_html = document.querySelectorAll("[data-select_html]");
  [].forEach.call(data_selects_html, function (data_select_html) {
    data_select_html.onchange = function () {
      highlight_select(data_select_html.id);
    };
  });

  function checkLocks() {
    switch (INPUTER2.value) {
      case "border-left-style":
      case "border-top-style":
      case "border-right-style":
      case "border-bottom-style":
        if (locks_obj['lock_border-style'] === 'true') {
          var lock_items = [
            "border-left-style",
            "border-top-style",
            "border-right-style",
            "border-bottom-style"
          ];
          if (inline_external_css === 'inline') {
            lock_items.map(item => {
              frameID(domElement[0]).style[item] = INPUTER3.value;
            });
          } else {
            switch (breakPoint) {
              case "fullWidth":
                lock_items.map(item => put(item, INPUTER3.value, thecssLG[INPUTER1.value]));
                break;
              case "breakPoint1":
                lock_items.map(item => put(item, INPUTER3.value, thecssMD[INPUTER1.value]));
                break;
              case "breakPoint2":
                lock_items.map(item => put(item, INPUTER3.value, thecssSM[INPUTER1.value]));
                break;
              case "breakPoint3":
                lock_items.map(item => put(item, INPUTER3.value, thecssXS[INPUTER1.value]));
                break;
            }
          }
          buttonRefresh();
        }
        break;
    }
  }

  // Dragger
  // also handels double click
  // draggerMaker(buttonID, value, axis);
  draggerMaker("margin-left_value", "margin-left", "y");
  draggerMaker("margin-top_value", "margin-top", "y");
  draggerMaker("margin-right_value", "margin-right", "y");
  draggerMaker("margin-bottom_value", "margin-bottom", "y");
  draggerMaker("margin-top-dragger_value", "margin-top", "y", undefined, "margin-top_value");
  draggerMaker("margin-left-dragger_value", "margin-left", "-x", undefined, "margin-left_value");
  draggerMaker("margin-right-dragger_value", "margin-right", "x", undefined, "margin-right_value");
  draggerMaker("margin-bottom-dragger_value", "margin-bottom", "-y", undefined, "margin-bottom_value");

  draggerMaker("border-left-width_value", "border-left-width", "y");
  draggerMaker("border-top-width_value", "border-top-width", "y");
  draggerMaker("border-right-width_value", "border-right-width", "y");
  draggerMaker("border-bottom-width_value", "border-bottom-width", "y");

  draggerMaker("border-left-width-dragger_value", "border-left-width", "-x", undefined, "border-left-width_value");
  draggerMaker("border-top-width-dragger_value", "border-top-width", "y", undefined, "border-top-width_value");
  draggerMaker("border-right-width-dragger_value", "border-right-width", "x", undefined, "border-right-width_value");
  draggerMaker("border-bottom-width-dragger_value", "border-bottom-width", "-y", undefined, "border-bottom-width_value");


  draggerMaker("border-top-left-radius_value", "border-top-left-radius", "y");
  draggerMaker(
    "border-top-right-radius_value",
    "border-top-right-radius",
    "y"
  );
  draggerMaker(
    "border-bottom-left-radius_value",
    "border-bottom-left-radius",
    "y"
  );
  draggerMaker(
    "border-bottom-right-radius_value",
    "border-bottom-right-radius",
    "y"
  );

  draggerMaker("border-top-left-radius-dragger_value", "border-top-left-radius", "-y", undefined, "border-top-left-radius_value");
  draggerMaker("border-top-right-radius-dragger_value", "border-top-right-radius", "-y", undefined, "border-top-right-radius_value");
  draggerMaker("border-bottom-left-radius-dragger_value", "border-bottom-left-radius", "y", undefined, "border-bottom-left-radius_value");
  draggerMaker("border-bottom-right-radius-dragger_value", "border-bottom-right-radius", "y", undefined, "border-bottom-right-radius_value");

  draggerMaker("padding-left_value", "padding-left", "y");
  draggerMaker("padding-top_value", "padding-top", "y");
  draggerMaker("padding-right_value", "padding-right", "y");
  draggerMaker("padding-bottom_value", "padding-bottom", "y");
  draggerMaker("padding-top-dragger_value", "padding-top", "y", undefined, "padding-top_value");
  draggerMaker("padding-left-dragger_value", "padding-left", "-x", undefined, "padding-left_value");
  draggerMaker("padding-right-dragger_value", "padding-right", "x", undefined, "padding-right_value");
  draggerMaker("padding-bottom-dragger_value", "padding-bottom", "-y", undefined, "padding-bottom_value");

  draggerMaker("width_value", "width", "y");
  draggerMaker("height_value", "height", "y");

  draggerMaker("width-dragger_value", "width", "x", undefined, "width_value");
  draggerMaker("height-dragger_value", "height", "-y", undefined, "height_value");

  draggerMaker("min-width_value", "min-width", "y");
  draggerMaker("min-height_value", "min-height", "y");
  draggerMaker("max-width_value", "max-width", "y");
  draggerMaker("max-height_value", "max-height", "y");
  draggerMaker("left_value", "left", "y");
  draggerMaker("top_value", "top", "y");
  draggerMaker("right_value", "right", "y");
  draggerMaker("bottom_value", "bottom", "y");
  draggerMaker("font-size_value", "font-size", "y");
  draggerMaker("letter-spacing_value", "letter-spacing", "y");
  draggerMaker("line-height_value", "line-height", "y");
  draggerMaker("box-shadow-hShadow_value", "box-shadow", "y");
  draggerMaker("box-shadow-vShadow_value", "box-shadow", "y");
  draggerMaker("box-shadow-blur_value", "box-shadow", "y");
  draggerMaker("box-shadow-spread_value", "box-shadow", "y");
  draggerMaker("text-shadow-hShadow_value", "text-shadow", "y");
  draggerMaker("text-shadow-vShadow_value", "text-shadow", "y");
  draggerMaker("text-shadow-blur_value", "text-shadow", "y");
  draggerMaker("rotate_value", "transform", "y");
  draggerMaker("scaleX_value", "transform", "y");
  draggerMaker("scaleY_value", "transform", "y");
  draggerMaker("skewX_value", "transform", "y");
  draggerMaker("skewY_value", "transform", "y");
  draggerMaker("translateX_value", "transform", "y");
  draggerMaker("translateY_value", "transform", "y");
  draggerMaker("originX_value", "transform-origin", "y");
  draggerMaker("originY_value", "transform-origin", "y");
  draggerMaker("zIndex_value", "z-index", "y");
  draggerMaker("gapX_value", "gap", "y");
  draggerMaker("gapY_value", "gap", "y");

  draggerMaker("outline-width_value", "outline-width", "y");
  draggerMaker("outline-offset_value", "outline-offset", "y");

  draggerMaker("text-decoration-thickness_value", "text-decoration-thickness", "y");
  draggerMaker("opacity_value", "opacity", "y");


  function setLockItems(lock_items) {

    if (inline_external_css === 'inline') {
      lock_items.map(item => {
        frameID(domElement[0]).style[item] = INPUTER3.value;
      });
    } else {
      switch (breakPoint) {
        case "fullWidth":
          lock_items.map(item => put(item, INPUTER3.value, thecssLG[INPUTER1.value]));
          break;
        case "breakPoint1":
          lock_items.map(item => put(item, INPUTER3.value, thecssMD[INPUTER1.value]));
          break;
        case "breakPoint2":
          lock_items.map(item => put(item, INPUTER3.value, thecssSM[INPUTER1.value]));
          break;
        case "breakPoint3":
          lock_items.map(item => put(item, INPUTER3.value, thecssXS[INPUTER1.value]));
          break;
      }
    }
    buttonRefresh();
  }

  function setLockItems_remove(lock_items) {
    if (inline_external_css === 'inline') {
      lock_items.map(item => {
        frameID(domElement[0]).style[item] = '';
      });
    } else {
      switch (breakPoint) {
        case "fullWidth":
          lock_items.map(item => del(item, thecssLG[INPUTER1.value]));
          break;
        case "breakPoint1":
          lock_items.map(item => del(item, thecssMD[INPUTER1.value]));
          break;
        case "breakPoint2":
          lock_items.map(item => del(item, thecssSM[INPUTER1.value]));
          break;
        case "breakPoint3":
          lock_items.map(item => del(item, thecssXS[INPUTER1.value]));
          break;
      }
    }
    buttonRefresh();
  }


  function addUnits(val) {
    val = val.toString();
    var checkunits;
    if (units) {
      checkunits = units.toString();
    }
    if (checkunits) {
      if (checkunits.indexOf('span') > -1) {
        return checkunits + ' ' + val;
      } else {
        return val + checkunits;
      }
    } else {
      return val;
    }
  }

  var value_dragger_input_id; // For the switch statements.
  /** also handels double click
   * usage:
   * draggerMaker("margin-top-dragger_value", "margin-top", "y", undefined, "margin-top_value");
   * */
  function draggerMaker(buttonID, value, axis, default_units = 'px', other_buttonID = false) {
    var dragBtn;
    var startPos;
    var dragPosStart;
    let editing_value_via_text = false;


    dragBtn = domID(buttonID);
    dragBtn.draggable = null;
    // in draggerMaker.
    dragBtn.addEventListener("mouseover", function (e) {
      e.preventDefault();
      if (editing_value_via_text) return;
      if (axis === "x") {
        dragBtn.style.cssText = "cursor: ew-resize !important";
      } else if (axis === "y") {
        dragBtn.style.cssText = "cursor: ns-resize !important";
      }
    });

    // in draggerMaker.

    // dragBtn.addEventListener("mouseleave", function (e) {
    //   e.preventDefault();
    //   if (axis === "x") {
    //     maincontainerRight.style.cssText = "";
    //   } else if (axis === "y") {
    //     maincontainerRight.style.cssText = "";
    //   }
    // });

    // in draggerMaker.
    dragBtn.addEventListener("mousedown", dragBtn_mousedown, {
      passive: false
    });
    dragBtn.addEventListener("touchstart", dragBtn_mousedown, {
      passive: false
    });
    dragBtn.addEventListener("dblclick", e => dragBtn_dblclick(e));
    dragBtn.addEventListener("blur", e => dragBtn_blur(e));

    function dragBtn_dblclick(e) {
      e.preventDefault();
      editing_value_via_text = true;
      dragBtn.contentEditable = true;
      dragBtn.focus();
      dragBtn.style.cursor = "text";
      dragBtn.style.outline = "none";
      dragBtn.onkeydown = function (event) {
        // INPUTER2.value = value;
        // INPUTER3.value = dragBtn.textContent;
        if (event.key === "Enter") {
          dragBtn.blur();
        }
      };
    }

    function dragBtn_blur(e) {
      // INPUTER2.value = value;
      // INPUTER3.value = dragBtn.textContent;
      valueDragRepeat(e);
      dragBtn_dragend(e);
      e.preventDefault();
      editing_value_via_text = false;
      dragBtn.contentEditable = false;
      dragBtn.style.cursor = "ns-resize";
    }


    function dragBtn_mousedown(e) {
      if (editing_value_via_text) return;
      //console.log('dragBtn_mousedown', e);
      e = e || window.event;
      e.preventDefault();
      INPUTER2.value = value;

      if (frameID(domElement[0]).style[value]) {
        INPUTER3.value = frameID(domElement[0]).style[value];
      } else if (CSSstyles[value]) {
        INPUTER3.value = CSSstyles[value];
      } else if (getInheritedStyle(value).style) {
        INPUTER3.value = getInheritedStyle(value).style;
        clickAdder('units');
      } else {
        let base_size = 0;
        switch (value) {
          case 'height':
            base_size = window.getComputedStyle(frameID(domElement[0]), null)
              .getPropertyValue('height');
            INPUTER3.value = base_size;
            break;
          case 'width':
            base_size = window.getComputedStyle(frameID(domElement[0]), null)
              .getPropertyValue('width');
            INPUTER3.value = base_size;
            break;
          default:
            INPUTER3.value = 0 + default_units;
            break;
        }

        switch (buttonID) {
          case 'rotate_value':
            INPUTER3.value = 'rotate(0deg)';
            break;
          case 'skewX_value':
          case 'skewY_value':
            INPUTER3.value = 'skew(0deg,0deg)';
            break;
          case 'scaleX_value':
          case 'scaleY_value':
            INPUTER3.value = 'scale(1,1)';
            break;
          case 'translateX_value':
            INPUTER3.value = 'translateX(0px)';
            break;
          case 'translateY_value':
            INPUTER3.value = 'translateY(0px)';
            break;
          case 'originY_value':
          case 'originX_value':
            INPUTER3.value = '50% 50%';
            break;
        }

        clickAdder('units');
        FillValueReadouts();
      }

      if (INPUTER3.value.indexOf('auto') > -1) {
        let base_size = 0;
        if (value === 'height') {
          base_size = window.getComputedStyle(frameID(domElement[0]), null)
            .getPropertyValue('height');
          INPUTER3.value = base_size;
          clickAdder('units');
        } else if (value === 'width') {
          base_size = window.getComputedStyle(frameID(domElement[0]), null)
            .getPropertyValue('width');
          INPUTER3.value = base_size;
          clickAdder('units');
        } else {
          INPUTER3.value = INPUTER3.value.replaceAll('auto', base_size + default_units);
        }
      }



      input1ForDragger = INPUTER1.value;
      input2ForDragger = INPUTER2.value;
      currentElement = frameID(domElement[0]);
      if (other_buttonID) {
        valueReadout = domID(other_buttonID);
      } else {
        valueReadout = domID(buttonID);
      }
      addBorederStyleIfNoneSetFace();
      //iframe.style.pointerEvents = "none";


      if (INPUTER3.value.indexOf(' ') > -1) {
        let [tmp_inputter3] = INPUTER3.value.split(' ');
        startPos = tmp_inputter3.replace(
          theValREGEX,
          ""
        );
        units = tmp_inputter3.match(
          theValREGEX,
          ""
        );
      } else {
        startPos = INPUTER3.value.replace(
          theValREGEX,
          ""
        );
        units = INPUTER3.value.match(
          theValREGEX,
          ""
        );
      }

      console.log('startPos', startPos, 'units', units);


      valueDraggerStart(e);
      value_dragger_input_id = e.target.id;
      document.addEventListener("mousemove", dragBtn_drag, {
        passive: false
      });
      document.addEventListener("touchmove", dragBtn_drag, {
        passive: false
      });

      document.addEventListener("mouseup", dragBtn_dragend);
      document.addEventListener("touchend", dragBtn_dragend);
    }


    // in draggerMaker.
    function dragBtn_drag(e) {
      //console.log('dragBtn_drag', e);
      e = e || window.event;
      e.preventDefault();
      var newClient;
      if (axis === "x" || axis === "-x") {
        if (e.type === "touchmove") {
          newClient = e.touches[0].clientX;
        } else {
          newClient = e.clientX;
        }
      } else if (axis === "y" || axis === "-y") {
        if (e.type === "touchmove") {
          newClient = e.touches[0].clientY;
        } else {
          newClient = e.clientY;
        }
      }
      if (!newClient) {
        return false;
      }
      let within_window = false;
      if (axis === "x" || axis === "-x" && newClient < window.outerWidth - 2) {
        within_window = true;
      }
      if (axis === "y" || axis === "-y" && newClient < window.outerHeight - 2) {
        within_window = true;
      }
      if (within_window) {
        valueDragger(e);
        BoxRefresh();
        if (axis === "x") {
          domID('app').style.cssText = "cursor: ew-resize !important";
          maincontainerRight.style.cssText = "cursor: ew-resize !important";
        } else if (axis === "y") {
          domID('app').style.cssText = "cursor: ns-resize !important";
          maincontainerRight.style.cssText = "cursor: ns-resize !important";
        }
      } else {
        return false;
      }
    }

    // in draggerMaker.

    function dragBtn_dragend(e) {
      e.preventDefault();
      document.removeEventListener("mousemove", dragBtn_drag);
      document.removeEventListener("mouseup", dragBtn_dragend);
      document.removeEventListener("touchmove", dragBtn_drag);
      document.removeEventListener("touchend", dragBtn_dragend);
      domID('app').style.cssText = "";
      maincontainerRight.style.cssText = "";
      iframe.style.pointerEvents = "auto";
      var lock_items;
      switch (INPUTER2.value) {
        case "padding-left":
        case "padding-top":
        case "padding-right":
        case "padding-bottom":
          if (locks_obj['lock_padding'] === 'true') {
            lock_items = [
              "padding-left",
              "padding-top",
              "padding-right",
              "padding-bottom",
            ];
            setLockItems(lock_items);
          } else {
            clickAdder("increment");
          }
          break;
        case "margin-left":
        case "margin-top":
        case "margin-right":
        case "margin-bottom":
          if (locks_obj['lock_margin'] === 'true') {
            lock_items = [
              "margin-left",
              "margin-top",
              "margin-right",
              "margin-bottom"
            ];
            setLockItems(lock_items);
          } else {
            clickAdder("increment");
          }
          break;
        case "border-left-width":
        case "border-top-width":
        case "border-right-width":
        case "border-bottom-width":
          if (locks_obj['lock_border-width'] === 'true') {
            lock_items = [
              "border-left-width",
              "border-top-width",
              "border-right-width",
              "border-bottom-width"
            ];
            setLockItems(lock_items);
          } else {
            clickAdder("increment");
          }
          break;
        case "border-top-left-radius":
        case "border-top-right-radius":
        case "border-bottom-left-radius":
        case "border-bottom-right-radius":
          if (locks_obj['lock_border-radius'] === 'true') {
            lock_items = [
              "border-top-left-radius",
              "border-top-right-radius",
              "border-bottom-left-radius",
              "border-bottom-right-radius",
            ];
            setLockItems(lock_items);
          } else {
            clickAdder("increment");
          }
          break;
        default:
          clickAdder("increment");
          break;
      }

      FillUndo();
      placeInHeadTempCSS_func();
      placeInHeadTempCSS_func_multi();
      setTimeout(function () {
        //selectElement(frameID(domElement[0]));
      }, 0);
      vauleBeingDragged = false;
      iframe.removeAttribute('style');
      document.body.removeAttribute('style');
      dragBtn.removeAttribute('style');
      FillValueReadouts();
    }

    // in draggerMaker.
    function valueDraggerStart(event) {
      event.preventDefault();
      if (axis === "x" || axis === "-x") {
        if (event.type === "touchstart") {
          dragPosStart = event.touches[0].clientX;
        } else {
          dragPosStart = event.clientX;
        }
      }
      if (axis === "y" || axis === "-y") {
        if (event.type === "touchstart") {
          dragPosStart = event.touches[0].clientY;
        } else {
          dragPosStart = event.clientY;
        }
      }
      if (INPUTER1.value) {
        INPUTER2.value = value;
        var input3 = frameID(domElement[0]).style[INPUTER2.value] || CSSstyles[INPUTER2.value];
        if (!input3) {
          INPUTER3.value = "0" + default_units;
          clickAdder('units');
          //dragBtn.onmousemove = valueDragger;
        } else {
          if (
            INPUTER2.value === "box-shadow" ||
            INPUTER2.value === "text-shadow" ||
            INPUTER2.value === "transform" ||
            INPUTER2.value === "transform-origin" ||
            INPUTER2.value === "gap" ||
            INPUTER2.value === "grid-template-columns" ||
            INPUTER2.value === "grid-template-rows" ||
            INPUTER2.value === "grid-auto-columns" ||
            INPUTER2.value === "grid-auto-rows" ||
            INPUTER2.value === "background" ||
            INPUTER2.value === "filter"
          ) {
            startPos = event.target.innerHTML.replace(
              theValREGEX,
              ""
            );
          } else if (input3.indexOf('span') > -1) {
            var spansplit = input3.split('span');
            var splitnumber = spansplit[1].trim();
            units = 'span';
            startPos = Number(splitnumber);
          } else {
            startPos = INPUTER3.value.replace(theValREGEX, "");
          }
        }
      }
    }
    // in draggerMaker.

    function valueDragger(event) {
      event = event || window.event;
      event.preventDefault();

      requestAnimationFrame(function () {
        valueDragRepeat(event);
      });
    }
    // in draggerMaker.
    var theVal;
    var valueReadout;
    var input1ForDragger;
    // in draggerMaker.
    function theBoxShadowValueFunction() {
      var theShadowValue = theVal;
      var forInput3;
      var theShadColors =
        "rgba(" +
        currentShad.red +
        ", " +
        currentShad.green +
        ", " +
        currentShad.blue +
        ", " +
        currentShad.alpha +
        ") ";
      var theShadInset = currentShad.inset;
      switch (value_dragger_input_id) {
        case "box-shadow-hShadow_value":
          forInput3 =
            theShadColors +
            theShadowValue +
            "px " +
            currentShad.vShadow +
            " " +
            currentShad.blur +
            " " +
            currentShad.spread +
            " " +
            theShadInset;
          boxShadowHShadowValue.textContent = theShadowValue + "px ";
          break;
        case "box-shadow-vShadow_value":
          forInput3 =
            theShadColors +
            currentShad.hShadow +
            " " +
            theShadowValue +
            "px " +
            currentShad.blur +
            " " +
            currentShad.spread +
            " " +
            theShadInset;
          boxShadowVShadowValue.textContent = theShadowValue + "px ";
          break;
        case "box-shadow-blur_value":
          forInput3 =
            theShadColors +
            currentShad.hShadow +
            " " +
            currentShad.vShadow +
            " " +
            theShadowValue +
            "px " +
            currentShad.spread +
            " " +
            theShadInset;
          boxShadowBlurValue.textContent = theShadowValue + "px ";
          break;
        case "box-shadow-spread_value":
          forInput3 =
            theShadColors +
            currentShad.hShadow +
            " " +
            currentShad.vShadow +
            " " +
            currentShad.blur +
            " " +
            theShadowValue +
            "px " +
            theShadInset;
          boxShadowSpreadValue.textContent = theShadowValue + "px ";
          break;
      }


      if (inline_external_css === 'inline') {
        frameID(domElement[0]).style["box-shadow"] = boxShadowAdder(forInput3);
      } else {
        switch (breakPoint) {
          case "fullWidth":
            put(
              "box-shadow",
              boxShadowAdder(forInput3),
              thecssLG[INPUTER1.value]
            );
            break;
          case "breakPoint1":
            put(
              "box-shadow",
              boxShadowAdder(forInput3),
              thecssMD[INPUTER1.value]
            );
            break;
          case "breakPoint2":
            put(
              "box-shadow",
              boxShadowAdder(forInput3),
              thecssSM[INPUTER1.value]
            );
            break;
          case "breakPoint3":
            put(
              "box-shadow",
              boxShadowAdder(forInput3),
              thecssXS[INPUTER1.value]
            );
            break;
        }
      }
      return boxShadowAdder(forInput3);
    }
    // in draggerMaker.
    function theTextShadowValueFunction() {
      var theShadowValue = theVal;
      var forInput3;
      var theShadColors =
        "rgba(" +
        currentShadText.red +
        ", " +
        currentShadText.green +
        ", " +
        currentShadText.blue +
        ", " +
        currentShadText.alpha +
        ") ";
      switch (value_dragger_input_id) {
        case "text-shadow-hShadow_value":
          forInput3 =
            theShadColors +
            theShadowValue +
            "px " +
            currentShadText.vShadow +
            " " +
            currentShadText.blur;
          TextShadowHShadowValue.textContent = theShadowValue + "px ";
          break;
        case "text-shadow-vShadow_value":
          forInput3 =
            theShadColors +
            currentShadText.hShadow +
            " " +
            theShadowValue +
            "px " +
            currentShadText.blur;
          TextShadowVShadowValue.textContent = theShadowValue + "px ";
          break;
        case "text-shadow-blur_value":
          forInput3 =
            theShadColors +
            currentShadText.hShadow +
            " " +
            currentShadText.vShadow +
            " " +
            theShadowValue +
            "px ";
          TextShadowBlurValue.textContent = theShadowValue + "px ";
          break;
      }
      switch (breakPoint) {
        case "fullWidth":
          put(
            "text-shadow",
            textShadowAdder(forInput3),
            thecssLG[INPUTER1.value]
          );
          break;
        case "breakPoint1":
          put(
            "text-shadow",
            textShadowAdder(forInput3),
            thecssMD[INPUTER1.value]
          );
          break;
        case "breakPoint2":
          put(
            "text-shadow",
            textShadowAdder(forInput3),
            thecssSM[INPUTER1.value]
          );
          break;
        case "breakPoint3":
          put(
            "text-shadow",
            textShadowAdder(forInput3),
            thecssXS[INPUTER1.value]
          );
          break;
      }
      return textShadowAdder(forInput3);
    }
    // in draggerMaker.
    function transformValueFunction() {
      var forReturn;
      switch (value_dragger_input_id) {
        case "rotate_value":
          rotateVal = theVal.toFixed(1);
          break;
        case "scaleX_value":
          theVal = Number(theVal / 100) + Number(startPos);
          scaleValX = theVal.toFixed(2);
          break;
        case "scaleY_value":
          theVal = Number(theVal / 100) + Number(startPos);
          scaleValY = theVal.toFixed(2);
          break;
        case "skewX_value":
          skewValX = theVal.toFixed(1);
          break;
        case "skewY_value":
          skewValY = theVal.toFixed(1);
          break;
        case "translateX_value":
          translateValX = theVal;
          break;
        case "translateY_value":
          translateValY = theVal;
          break;
      }
      forReturn = createNewTransformValues();
      switch (breakPoint) {
        case "fullWidth":
          put("transform", forReturn, thecssLG[INPUTER1.value]);
          break;
        case "breakPoint1":
          put("transform", forReturn, thecssMD[INPUTER1.value]);
          break;
        case "breakPoint2":
          put("transform", forReturn, thecssSM[INPUTER1.value]);
          break;
        case "breakPoint3":
          put("transform", forReturn, thecssXS[INPUTER1.value]);
          break;
      }
      getTransformValues();
      setTransformValues();
      return forReturn;
    }
    // in draggerMaker.
    function transformOriginValueFunction() {
      var forReturn;
      switch (value_dragger_input_id) {
        case "originX_value":
          originValX = theVal;
          break;
        case "originY_value":
          originValY = theVal;
          break;
      }
      forReturn = createNewTransformOriginValues();
      switch (breakPoint) {
        case "fullWidth":
          put("transform-origin", forReturn, thecssLG[INPUTER1.value]);
          break;
        case "breakPoint1":
          put(
            "transform-origin",
            forReturn,
            thecssMD[INPUTER1.value]
          );
          break;
        case "breakPoint2":
          put(
            "transform-origin",
            forReturn,
            thecssSM[INPUTER1.value]
          );
          break;
        case "breakPoint3":
          put(
            "transform-origin",
            forReturn,
            thecssXS[INPUTER1.value]
          );
          break;
      }
      getTransformValues();
      setTransformValues();
      return forReturn;
    }

    function createNewGapValues(passedunits) {
      var forReturn;
      if (!theVal || theVal < 0) {
        theVal = 0;
      }
      if (locks_obj['lock_gap'] === 'true') {
        forReturn = theVal + passedunits + ' ' + theVal + passedunits;
      } else {
        switch (value_dragger_input_id) {
          case "gapX_value":
            forReturn = theVal + passedunits + ' ' + (gapValYReadout.innerHTML || 0 + passedunits);
            break;
          case "gapY_value":
            forReturn = (gapValXReadout.innerHTML || 0 + passedunits) + ' ' + theVal + passedunits;
            break;
        }
      }
      let [valX, valY] = forReturn.split(' ');
      gapValXReadout.textContent = valX;
      gapValYReadout.textContent = valY;
      return forReturn;
    }

    function createNewGridTemplateValues(passedunits, type, data_type) {
      var forReturn;
      if (!theVal || theVal < 0) {
        theVal = 0;
      }
      // get the index
      var index = domID(buttonID).getAttribute(data_type + type + '_value');
      var grid_values = [];
      if (INPUTER3.value) {
        if (INPUTER3.value.indexOf(' ') > -1) {
          grid_values = INPUTER3.value.split(' ');
        } else {
          grid_values.push(INPUTER3.value);
        }
      }
      grid_values[index] = theVal + passedunits;
      forReturn = grid_values.join(' ');
      domID(buttonID).textContent = theVal + passedunits;
      return forReturn;
    }

    function createFilterValues(passedunits) {
      let filter_type = buttonID.replace('filter_', '').replace('filter_', '').replace('_value', '');
      let unit_min = '0';
      let unit_max = '100';
      let filter_drop = '';
      switch (filter_type) {
        case 'blur':
          unit_max = '999999';
          break;
        case 'hue-rotate':
          unit_max = '360';
          break;
        case 'grayscale':
        case 'invert':
        case 'opacity':
        case 'sepia':
          unit_max = '100';
          break;
        case 'brightness':
        case 'contrast':
        case 'saturate':
          unit_max = '10000';
          break;
        case 'drop-shadow-X':
        case 'drop-shadow-Y':
          unit_min = '-999999';
          unit_max = '999999';
          filter_drop = 'drop-shadow';
          break;
        case 'drop-shadow-blur':
          unit_min = '0';
          unit_max = '999999';
          filter_drop = 'drop-shadow';
          break;
      }
      if (Number(theVal) >= Number(unit_max)) {
        theVal = Number(unit_max);
      }
      if (Number(theVal) <= Number(unit_min)) {
        theVal = Number(unit_min);
      }
      domID(buttonID).textContent = theVal + passedunits;
      if (filter_drop) {
        set_filter_val(theVal + passedunits, filter_drop);
      } else {
        set_filter_val(theVal + passedunits, filter_type);
      }
      return INPUTER3.value;
    }

    function createNewGradientValues() {
      if (value_dragger_input_id.indexOf('gradient-stop-position') > -1) {
        if (!theVal && theVal !== 0) {
          theVal = 0;
        }
        if (theVal >= 100) {
          theVal = 100;
        }
        if (theVal <= 0) {
          theVal = 0;
        }
        domID(buttonID).innerText = theVal + '%';
      } else if (value_dragger_input_id.indexOf('gradient-deg') > -1) {
        if (!theVal && theVal !== 0) {
          theVal = 0;
        }
        if (theVal >= 360) {
          theVal = 360;
        }
        if (theVal <= 0) {
          theVal = 0;
        }
        domID(buttonID).innerText = theVal;
      } else if (value_dragger_input_id.indexOf('gradient-x') > -1) {
        if (!theVal && theVal !== 0) {
          theVal = 50;
        }
        domID(buttonID).innerText = theVal + '%';
      } else if (value_dragger_input_id.indexOf('gradient-y') > -1) {
        if (!theVal && theVal !== 0) {
          theVal = 50;
        }
        domID(buttonID).innerText = theVal + '%';
      }
      return createGradientValue();
    }

    function changeFromAuto(event) {
      var tempunits;
      var checkUnits = domID(buttonID).innerHTML.match(theValREGEX);
      if (!checkUnits) {
        return false;
      }
      if (!checkUnits.includes("auto")) {
        tempunits = domID(buttonID).innerHTML.match(theValREGEX);
      } else {
        tempunits = "px";
      }
      units = tempunits;
    }

    // in draggerMaker.
    function valueDragRepeat(event) {
      event = event || window.event;
      event.preventDefault();
      var getVal;
      var setVal;

      if (editing_value_via_text === false) {
        if (event.type === "touchmove") {
          if (axis === "x") {
            theVal = event.touches[0].clientX - dragPosStart;
          } else if (axis === "-x") {
            theVal = dragPosStart - event.touches[0].clientX;
          } else if (axis === "y") {
            theVal = dragPosStart - event.touches[0].clientY;
          } else if (axis === "-y") {
            theVal = event.touches[0].clientY - dragPosStart;
          }
        } else {
          if (axis === "x") {
            theVal = event.clientX - dragPosStart;
          } else if (axis === "-x") {
            theVal = dragPosStart - event.clientX;
          } else if (axis === "y") {
            theVal = dragPosStart - event.clientY;
          } else if (axis === "-y") {
            theVal = event.clientY - dragPosStart;
          }
        }
      } else {
        let val_entered = dragBtn.innerText;
        theVal = val_entered.replace(
          theValREGEX,
          ""
        );
        units = val_entered.match(
          theValREGEX,
          ""
        );
      }

      //console.log('valueDragRepeat units', theVal, units);
      if (Array.isArray(units)) {
        units = units[0];
      }

      if (editing_value_via_text === false) {
        if (units === "em" || units === "rem" || units === "deg") {
          if (INPUTER2.value === "filter") {
            theVal = Number(theVal) + Number(startPos);
          } else {
            theVal = Number(theVal / 16) + Number(startPos);
          }
        } else {
          theVal = Number(theVal) + Number(startPos);
        }
      } else {
        theVal = Number(theVal);
      }

      if (units === "em" || units === "rem" || units === "deg") {
        if (INPUTER2.value === "filter") {
          theVal = Number(theVal).toFixed(0);
        } else {
          theVal = Number(theVal).toFixed(2);
        }
      } else {
        if (INPUTER2.value === "letter-spacing") {
          if (units === "%") {
            info("% not supported for letter spacing.", 4000, null);
          } else {
            theVal = theVal.toFixed(2);
          }
        } else {
          theVal = Number(theVal.toFixed(0));
        }
      }
      if (input1ForDragger) {
        setVal = addUnits(theVal);
        switch (INPUTER2.value) {
          case "letter-spacing":
            if (units === "em" || units === "px") {
              changeFromAuto(event);
              INPUTER3.value = setVal;
              valueReadout.textContent = setVal;
              placeInHeadTempCSS_func(setVal);
            } else {
              units = "px";
            }
            break;
          case "opacity":
            units = "";
            theVal = theVal / 100;
            if (theVal >= 0 && theVal <= 1) {
              INPUTER3.value = theVal;
              valueReadout.textContent = theVal;
              placeInHeadTempCSS_func(theVal);
            }
            break;
          case "line-height":
            if (theVal >= 0) {
              changeFromAuto(event);
              INPUTER3.value = setVal;
              valueReadout.textContent = setVal;
              placeInHeadTempCSS_func(setVal);
            }
            break;
          case "z-index":
            if (theVal < 1000) {
              units = "";
              INPUTER3.value = setVal;
              valueReadout.textContent = setVal;
              placeInHeadTempCSS_func(setVal);
            }
            break;
          case "margin-left":
          case "margin-top":
          case "margin-right":
          case "margin-bottom":
            if (units !== "") {
              if (locks_obj['lock_margin'] === 'true') {
                changeFromAuto(event);
                INPUTER3.value = setVal;
                placeInHeadTempCSS_func_multi('margin', setVal);
                setIframeSelectHandels('margin', setVal);
              } else {
                changeFromAuto(event);
                INPUTER3.value = setVal;
                valueReadout.textContent = setVal;
                placeInHeadTempCSS_func(setVal);
                setIframeSelectHandels(INPUTER2.value, setVal);
              }
            } else {
              units = "px";
            }
            break;
          case "padding-left":
          case "padding-top":
          case "padding-right":
          case "padding-bottom":
            if (units !== "") {
              if (theVal >= 0) {
                if (locks_obj['lock_padding'] === 'true') {
                  changeFromAuto(event);
                  INPUTER3.value = setVal;
                  placeInHeadTempCSS_func_multi('padding', setVal);
                  setIframeSelectHandels('padding', setVal);
                } else {
                  changeFromAuto(event);
                  INPUTER3.value = setVal;
                  valueReadout.textContent = setVal;
                  placeInHeadTempCSS_func(setVal);
                  setIframeSelectHandels(INPUTER2.value, setVal);
                }
              }
            } else {
              units = "px";
            }
            break;
          case "border-left-width":
          case "border-top-width":
          case "border-right-width":
          case "border-bottom-width":
            if (units !== "") {
              if (theVal >= 0) {
                if (locks_obj['lock_border-width'] === 'true') {
                  changeFromAuto(event);
                  INPUTER3.value = setVal;
                  placeInHeadTempCSS_func_multi('border-width', setVal);
                  setIframeSelectHandels('border-width', setVal);
                } else {
                  changeFromAuto(event);
                  INPUTER3.value = setVal;
                  valueReadout.textContent = setVal;
                  placeInHeadTempCSS_func(setVal);
                  setIframeSelectHandels(INPUTER2.value, setVal);
                }
              }
            } else {
              units = "px";
            }
            break;
          case "border-top-left-radius":
          case "border-top-right-radius":
          case "border-bottom-left-radius":
          case "border-bottom-right-radius":
            if (units !== "") {
              if (theVal >= 0) {
                if (locks_obj['lock_border-radius'] === 'true') {
                  changeFromAuto(event);
                  INPUTER3.value = setVal;
                  placeInHeadTempCSS_func_multi('border-radius', setVal);
                  setIframeSelectHandels('border-radius', setVal);
                } else {
                  changeFromAuto(event);
                  INPUTER3.value = setVal;
                  valueReadout.textContent = setVal;
                  placeInHeadTempCSS_func(setVal);
                  setIframeSelectHandels(INPUTER2.value, setVal);
                }
              }
            } else {
              units = "px";
            }
            break;
          case "width":
          case "height":
          case "min-width":
          case "min-height":
          case "max-width":
          case "max-height":
          case "font-size":
          case "outline-width":
          case "text-decoration-thickness":
            // propertys that dont go below 0
            if (units !== "") {
              if (theVal >= 0) {
                changeFromAuto(event);
                INPUTER3.value = setVal;
                valueReadout.textContent = setVal;
                placeInHeadTempCSS_func(setVal);
              }
            } else {
              units = "px";
            }
            break;
          case "box-shadow":
            if (buttonID === "box-shadow-blur_value") {
              if (theVal < 0) {
                theVal = '0';
              }
            }
            getVal = theBoxShadowValueFunction();
            INPUTER3.value = getVal;
            placeInHeadTempCSS_func(getVal);
            refreshShadowValues();
            break;
          case "text-shadow":
            if (buttonID === "text-shadow-blur_value") {
              if (theVal < 0) {
                theVal = '0';
              }
            }
            getVal = theTextShadowValueFunction();
            INPUTER3.value = getVal;
            placeInHeadTempCSS_func(getVal);
            refreshTextShadowValues();
            break;
          case "transform":
            getVal = transformValueFunction();
            placeInHeadTempCSS_func(getVal);
            INPUTER3.value = getVal;
            break;
          case "transform-origin":
            getVal = transformOriginValueFunction();
            placeInHeadTempCSS_func(getVal);
            INPUTER3.value = getVal;
            break;
          case "background":
            getVal = createNewGradientValues();
            placeInHeadTempCSS_func(getVal);
            INPUTER3.value = getVal;
            break;

          case "gap":
            if (units !== "") {
              changeFromAuto(event);
              getVal = createNewGapValues(units);
              placeInHeadTempCSS_func(getVal);
              INPUTER3.value = getVal;
            } else {
              units = "px";
            }
            break;

          case "filter":
            if (units !== "") {
              changeFromAuto(event);
              getVal = createFilterValues(units);
              placeInHeadTempCSS_func(getVal);
              INPUTER3.value = getVal;
            }
            // placeInHeadTempCSS_func(getVal);
            // INPUTER3.value = getVal;
            break;
          case "grid-template-columns":
            if (units !== "") {
              changeFromAuto(event);
              getVal = createNewGridTemplateValues(units, 'columns', 'data-grid_template_');
              placeInHeadTempCSS_func(getVal);
              INPUTER3.value = getVal;
            } else {
              units = "fr";
            }
            break;
          case "grid-template-rows":
            if (units !== "") {
              changeFromAuto(event);
              getVal = createNewGridTemplateValues(units, 'rows', 'data-grid_template_');
              placeInHeadTempCSS_func(getVal);
              INPUTER3.value = getVal;
            } else {
              units = "fr";
            }
            break;
          case "grid-auto-columns":
            if (units !== "") {
              changeFromAuto(event);
              getVal = createNewGridTemplateValues(units, 'columns', 'data-grid_auto_');
              placeInHeadTempCSS_func(getVal);
              INPUTER3.value = getVal;
            } else {
              units = "fr";
            }
            break;
          case "grid-auto-rows":
            if (units !== "") {
              changeFromAuto(event);
              getVal = createNewGridTemplateValues(units, 'rows', 'data-grid_auto_');
              placeInHeadTempCSS_func(getVal);
              INPUTER3.value = getVal;
            } else {
              units = "fr";
            }
            break;
          default:
            if (units !== "") {
              // requestAnimationFrame(function () {
              changeFromAuto(event);
              INPUTER3.value = setVal;
              valueReadout.textContent = setVal;
              placeInHeadTempCSS_func(setVal);
              // });
            } else {
              units = "px";
            }
            break;
        }
      }
    }
  }

  // End of draggerMaker.
  // ---------------------------------------------------
  // --------------------------------------------------

  /***
   *    ########  ##       ##     ##  ######
   *    ##     ## ##       ##     ## ##    ##
   *    ##     ## ##       ##     ## ##
   *    ########  ##       ##     ##  ######
   *    ##        ##       ##     ##       ##
   *    ##        ##       ##     ## ##    ##
   *    ##        ########  #######   ######
   *
   *    ##     ## #### ##    ## ##     ##  ######
   *    ###   ###  ##  ###   ## ##     ## ##    ##
   *    #### ####  ##  ####  ## ##     ## ##
   *    ## ### ##  ##  ## ## ## ##     ##  ######
   *    ##     ##  ##  ##  #### ##     ##       ##
   *    ##     ##  ##  ##   ### ##     ## ##    ##
   *    ##     ## #### ##    ##  #######   ######
   */

  // BUTTONS SETUP
  // Params
  // 1.Id of the button in DOM
  // 2.Group Name 'margin-left' for Example
  // 3.Readout Name 'margin-left_value' for Example
  // 4.PlusOrMinus 'plus' for Example
  // margins
  plusMinusBtnMaker(
    "margin-left-up",
    "margin-left",
    "margin-left_value",
    "plus"
  );
  plusMinusBtnMaker(
    "margin-left-down",
    "margin-left",
    "margin-left_value",
    "minus"
  );
  plusMinusBtnMaker(
    "margin-top-up",
    "margin-top",
    "margin-top_value",
    "plus"
  );
  plusMinusBtnMaker(
    "margin-top-down",
    "margin-top",
    "margin-top_value",
    "minus"
  );
  plusMinusBtnMaker(
    "margin-right-up",
    "margin-right",
    "margin-right_value",
    "plus"
  );
  plusMinusBtnMaker(
    "margin-right-down",
    "margin-right",
    "margin-right_value",
    "minus"
  );
  plusMinusBtnMaker(
    "margin-bottom-up",
    "margin-bottom",
    "margin-bottom_value",
    "plus"
  );
  plusMinusBtnMaker(
    "margin-bottom-down",
    "margin-bottom",
    "margin-bottom_value",
    "minus"
  );
  // border widths
  plusMinusBtnMaker(
    "border-left-width-up",
    "border-left-width",
    "border-left-width_value",
    "plus"
  );
  plusMinusBtnMaker(
    "border-left-width-down",
    "border-left-width",
    "border-left-width_value",
    "minus"
  );
  plusMinusBtnMaker(
    "border-top-width-up",
    "border-top-width",
    "border-top-width_value",
    "plus"
  );
  plusMinusBtnMaker(
    "border-top-width-down",
    "border-top-width",
    "border-top-width_value",
    "minus"
  );
  plusMinusBtnMaker(
    "border-right-width-up",
    "border-right-width",
    "border-right-width_value",
    "plus"
  );
  plusMinusBtnMaker(
    "border-right-width-down",
    "border-right-width",
    "border-right-width_value",
    "minus"
  );
  plusMinusBtnMaker(
    "border-bottom-width-up",
    "border-bottom-width",
    "border-bottom-width_value",
    "plus"
  );
  plusMinusBtnMaker(
    "border-bottom-width-down",
    "border-bottom-width",
    "border-bottom-width_value",
    "minus"
  );
  // border radius
  plusMinusBtnMaker(
    "border-top-left-radius-up",
    "border-top-left-radius",
    "border-top-left-radius_value",
    "plus"
  );
  plusMinusBtnMaker(
    "border-top-left-radius-down",
    "border-top-left-radius",
    "border-top-left-radius_value",
    "minus"
  );
  plusMinusBtnMaker(
    "border-top-right-radius-up",
    "border-top-right-radius",
    "border-top-right-radius_value",
    "plus"
  );
  plusMinusBtnMaker(
    "border-top-right-radius-down",
    "border-top-right-radius",
    "border-top-right-radius_value",
    "minus"
  );
  plusMinusBtnMaker(
    "border-bottom-left-radius-up",
    "border-bottom-left-radius",
    "border-bottom-left-radius_value",
    "plus"
  );
  plusMinusBtnMaker(
    "border-bottom-left-radius-down",
    "border-bottom-left-radius",
    "border-bottom-left-radius_value",
    "minus"
  );
  plusMinusBtnMaker(
    "border-bottom-right-radius-up",
    "border-bottom-right-radius",
    "border-bottom-right-radius_value",
    "plus"
  );
  plusMinusBtnMaker(
    "border-bottom-right-radius-down",
    "border-bottom-right-radius",
    "border-bottom-right-radius_value",
    "minus"
  );
  // paddings
  plusMinusBtnMaker(
    "padding-left-up",
    "padding-left",
    "padding-left_value",
    "plus"
  );
  plusMinusBtnMaker(
    "padding-left-down",
    "padding-left",
    "padding-left_value",
    "minus"
  );
  plusMinusBtnMaker(
    "padding-top-up",
    "padding-top",
    "padding-top_value",
    "plus"
  );
  plusMinusBtnMaker(
    "padding-top-down",
    "padding-top",
    "padding-top_value",
    "minus"
  );
  plusMinusBtnMaker(
    "padding-right-up",
    "padding-right",
    "padding-right_value",
    "plus"
  );
  plusMinusBtnMaker(
    "padding-right-down",
    "padding-right",
    "padding-right_value",
    "minus"
  );
  plusMinusBtnMaker(
    "padding-bottom-up",
    "padding-bottom",
    "padding-bottom_value",
    "plus"
  );
  plusMinusBtnMaker(
    "padding-bottom-down",
    "padding-bottom",
    "padding-bottom_value",
    "minus"
  );
  // width
  plusMinusBtnMaker("width-up", "width", "width_value", "plus");
  plusMinusBtnMaker("width-down", "width", "width_value", "minus");
  plusMinusBtnMaker("min-width-up", "min-width", "min-width_value", "plus");
  plusMinusBtnMaker(
    "min-width-down",
    "min-width",
    "min-width_value",
    "minus"
  );
  plusMinusBtnMaker("max-width-up", "max-width", "max-width_value", "plus");
  plusMinusBtnMaker(
    "max-width-down",
    "max-width",
    "max-width_value",
    "minus"
  );
  // height
  plusMinusBtnMaker("height-up", "height", "height_value", "plus");
  plusMinusBtnMaker("height-down", "height", "height_value", "minus");
  plusMinusBtnMaker(
    "min-height-up",
    "min-height",
    "min-height_value",
    "plus"
  );
  plusMinusBtnMaker(
    "min-height-down",
    "min-height",
    "min-height_value",
    "minus"
  );
  plusMinusBtnMaker(
    "max-height-up",
    "max-height",
    "max-height_value",
    "plus"
  );
  plusMinusBtnMaker(
    "max-height-down",
    "max-height",
    "max-height_value",
    "minus"
  );
  // left
  plusMinusBtnMaker("left-up", "left", "left_value", "plus");
  plusMinusBtnMaker("left-down", "left", "left_value", "minus");
  // top
  plusMinusBtnMaker("top-up", "top", "top_value", "plus");
  plusMinusBtnMaker("top-down", "top", "top_value", "minus");
  // right
  plusMinusBtnMaker("right-up", "right", "right_value", "plus");
  plusMinusBtnMaker("right-down", "right", "right_value", "minus");
  // bottom
  plusMinusBtnMaker("bottom-up", "bottom", "bottom_value", "plus");
  plusMinusBtnMaker("bottom-down", "bottom", "bottom_value", "minus");
  // zIndex
  plusMinusBtnMaker("zIndex-up", "z-index", "zIndex_value", "plus");
  plusMinusBtnMaker("zIndex-down", "z-index", "zIndex_value", "minus");
  // font size
  plusMinusBtnMaker("font-size-up", "font-size", "font-size_value", "plus");
  plusMinusBtnMaker(
    "font-size-down",
    "font-size",
    "font-size_value",
    "minus"
  );
  // letter spacing
  plusMinusBtnMaker(
    "letter-spacing-up",
    "letter-spacing",
    "letter-spacing_value",
    "plus"
  );
  plusMinusBtnMaker(
    "letter-spacing-down",
    "letter-spacing",
    "letter-spacing_value",
    "minus"
  );

  // opacity
  plusMinusBtnMaker(
    "opacity-up",
    "opacity",
    "opacity_value",
    "plus"
  );
  plusMinusBtnMaker(
    "opacity-down",
    "opacity",
    "opacity_value",
    "minus"
  );

  // line height
  plusMinusBtnMaker(
    "line-height-up",
    "line-height",
    "line-height_value",
    "plus"
  );
  plusMinusBtnMaker(
    "line-height-down",
    "line-height",
    "line-height_value",
    "minus"
  );
  // gap
  plusMinusBtnMaker(
    "gapX-up",
    "gap",
    "gapX_value",
    "plus"
  );
  plusMinusBtnMaker(
    "gapX-down",
    "gap",
    "gapX_value",
    "minus"
  );
  plusMinusBtnMaker(
    "gapY-up",
    "gap",
    "gapY_value",
    "plus"
  );
  plusMinusBtnMaker(
    "gapY-down",
    "gap",
    "gapY_value",
    "minus"
  );
  // grid start end
  plusMinusBtnMaker(
    "grid-row-start-up",
    "grid-row-start",
    "grid-row-start_value",
    "plus"
  );
  plusMinusBtnMaker(
    "grid-row-start-down",
    "grid-row-start",
    "grid-row-start_value",
    "minus"
  );
  plusMinusBtnMaker(
    "grid-column-start-up",
    "grid-column-start",
    "grid-column-start_value",
    "plus"
  );
  plusMinusBtnMaker(
    "grid-column-start-down",
    "grid-column-start",
    "grid-column-start_value",
    "minus"
  );

  // grid start end
  plusMinusBtnMaker(
    "grid-row-end-up",
    "grid-row-end",
    "grid-row-end_value",
    "plus"
  );
  plusMinusBtnMaker(
    "grid-row-end-down",
    "grid-row-end",
    "grid-row-end_value",
    "minus"
  );
  plusMinusBtnMaker(
    "grid-column-end-up",
    "grid-column-end",
    "grid-column-end_value",
    "plus"
  );
  plusMinusBtnMaker(
    "grid-column-end-down",
    "grid-column-end",
    "grid-column-end_value",
    "minus"
  );

  // outline
  plusMinusBtnMaker(
    "outline-width-up",
    "outline-width",
    "outline-width_value",
    "plus"
  );
  plusMinusBtnMaker(
    "outline-width-down",
    "outline-width",
    "outline-width_value",
    "minus"
  );
  plusMinusBtnMaker(
    "outline-offset-up",
    "outline-offset",
    "outline-offset_value",
    "plus"
  );
  plusMinusBtnMaker(
    "outline-offset-down",
    "outline-offset",
    "outline-offset_value",
    "minus"
  );

  // text-decoration-thickness
  plusMinusBtnMaker(
    "text-decoration-thickness-up",
    "text-decoration-thickness",
    "text-decoration-thickness_value",
    "plus"
  );
  plusMinusBtnMaker(
    "text-decoration-thickness-down",
    "text-decoration-thickness",
    "text-decoration-thickness_value",
    "minus"
  );

  // ---------------------------------------------------
  // ---------------------------------------------------
  // Value increment button creator
  function plusMinusBtnMaker(Id, Group, Readout, PlusOrMinus) {
    var btn = domID(Id);
    var readoutValue = domID(Readout);
    var timepressed;
    var deleypress;
    var timedelay;
    var mouseDown;

    function iter() {
      timepressed = setInterval(function () {
        requestAnimationFrame(function () {
          PlusMinus(Group, PlusOrMinus, btn.id);
          increment++;
          BoxRefresh();
        });
      }, timedelay);
    }
    // stops iter and timepressed functions
    function clearIter() {
      clearInterval(timepressed);
      clearTimeout(deleypress);
      if (mouseDown) {
        requestAnimationFrame(function () {
          increment = 1;
          var lock_items;
          switch (INPUTER2.value) {
            case "padding-left":
            case "padding-top":
            case "padding-right":
            case "padding-bottom":
              if (locks_obj['lock_padding'] === 'true') {
                lock_items = [
                  "padding-left",
                  "padding-top",
                  "padding-right",
                  "padding-bottom",
                ];
                setLockItems(lock_items);
              } else {
                clickAdder(null);
              }
              break;
            case "margin-left":
            case "margin-top":
            case "margin-right":
            case "margin-bottom":
              if (locks_obj['lock_margin'] === 'true') {
                lock_items = [
                  "margin-left",
                  "margin-top",
                  "margin-right",
                  "margin-bottom"
                ];
                setLockItems(lock_items);
              } else {
                clickAdder(null);
              }
              break;
            case "border-left-width":
            case "border-top-width":
            case "border-right-width":
            case "border-bottom-width":
              if (locks_obj['lock_border-width'] === 'true') {
                lock_items = [
                  "border-left-width",
                  "border-top-width",
                  "border-right-width",
                  "border-bottom-width"
                ];
                setLockItems(lock_items);
              } else {
                clickAdder(null);
              }
              break;
            case "border-top-left-radius":
            case "border-top-right-radius":
            case "border-bottom-left-radius":
            case "border-bottom-right-radius":
              if (locks_obj['lock_border-radius'] === 'true') {
                lock_items = [
                  "border-top-left-radius",
                  "border-top-right-radius",
                  "border-bottom-left-radius",
                  "border-bottom-right-radius"
                ];
                setLockItems(lock_items);
              } else {
                clickAdder(null);
              }
              break;
            case "gap":
              clickAdder('increment');
              break;
            case "grid-template-columns":
              clickAdder('increment');
              break;
            case "grid-template-rows":
              clickAdder('increment');
              break;
            case "grid-auto-columns":
              clickAdder('increment');
              break;
            case "grid-auto-rows":
              clickAdder('increment');
              break;
            case "background":
              clickAdder('increment');
              break;
            default:
              clickAdder(null);
              break;
          }
          FillUndo();
          placeInHeadTempCSS_func();
          placeInHeadTempCSS_func_multi();
          FillValueReadouts();
        });
      }
      mouseDown = false;
    }
    // delay then fire the iter function
    function mousedown(e) {
      e = e || window.event;
      e.preventDefault();

      clearIter();
      INPUTER2.value = Group;
      var col_index;
      var grid_values;
      if (INPUTER2.value === 'gap') {
        let [gapX, gapY] = INPUTER3.value.split(' ');
        gapValXReadout.textContent = gapX || '0px';
        gapValYReadout.textContent = gapY || '0px';
      } else if (INPUTER2.value === 'grid-template-columns') {
        col_index = domID(Id).getAttribute('data-grid_template_columns_index');
        grid_values = [];
        if (INPUTER3.value) {
          if (INPUTER3.value.indexOf(' ') > -1) {
            grid_values = INPUTER3.value.split(' ');
          } else {
            grid_values.push(INPUTER3.value);
          }
        }
        domID(Readout).textContent = grid_values[col_index];
      } else if (INPUTER2.value === 'grid-template-rows') {
        col_index = domID(Id).getAttribute('data-grid_template_rows_index');
        grid_values = [];
        if (INPUTER3.value) {
          if (INPUTER3.value.indexOf(' ') > -1) {
            grid_values = INPUTER3.value.split(' ');
          } else {
            grid_values.push(INPUTER3.value);
          }
        }
        domID(Readout).textContent = grid_values[col_index];
      } else if (INPUTER2.value === 'grid-auto-columns') {
        col_index = domID(Id).getAttribute('data-grid_auto_columns_index');
        grid_values = [];
        if (INPUTER3.value) {
          if (INPUTER3.value.indexOf(' ') > -1) {
            grid_values = INPUTER3.value.split(' ');
          } else {
            grid_values.push(INPUTER3.value);
          }
        }
        domID(Readout).textContent = grid_values[col_index];
      } else if (INPUTER2.value === 'grid-auto-rows') {
        col_index = domID(Id).getAttribute('data-grid_auto_rows_index');
        grid_values = [];
        if (INPUTER3.value) {
          if (INPUTER3.value.indexOf(' ') > -1) {
            grid_values = INPUTER3.value.split(' ');
          } else {
            grid_values.push(INPUTER3.value);
          }
        }
        domID(Readout).textContent = grid_values[col_index];
      } else {
        readoutValue.textContent = INPUTER3.value;
      }
      timedelay = 10;
      increment = 1;
      mouseDown = true;
      if (INPUTER1.value) {
        requestAnimationFrame(function () {
          currentElement = frameID(domElement[0]);
          valueReadout = domID(Readout);
          var col_index;
          var grid_values;
          PlusMinus(Group, PlusOrMinus, btn.id);
          if (INPUTER2.value === 'gap') {
            let [gapX, gapY] = INPUTER3.value.split(' ');
            gapValXReadout.textContent = gapX;
            gapValYReadout.textContent = gapY;
          } else if (INPUTER2.value === 'grid-template-columns') {
            col_index = domID(Id).getAttribute('data-grid_template_columns_index');
            grid_values = [];
            if (INPUTER3.value) {
              if (INPUTER3.value.indexOf(' ') > -1) {
                grid_values = INPUTER3.value.split(' ');
              } else {
                grid_values.push(INPUTER3.value);
              }
            }
            valueReadout.textContent = grid_values[col_index];
          } else if (INPUTER2.value === 'grid-template-rows') {
            col_index = domID(Id).getAttribute('data-grid_template_rows_index');
            grid_values = [];
            if (INPUTER3.value) {
              if (INPUTER3.value.indexOf(' ') > -1) {
                grid_values = INPUTER3.value.split(' ');
              } else {
                grid_values.push(INPUTER3.value);
              }
            }
            valueReadout.textContent = grid_values[col_index];
          } else if (INPUTER2.value === 'grid-auto-columns') {
            col_index = domID(Id).getAttribute('data-grid_auto_columns_index');
            grid_values = [];
            if (INPUTER3.value) {
              if (INPUTER3.value.indexOf(' ') > -1) {
                grid_values = INPUTER3.value.split(' ');
              } else {
                grid_values.push(INPUTER3.value);
              }
            }
            valueReadout.textContent = grid_values[col_index];
          } else if (INPUTER2.value === 'grid-auto-rows') {
            col_index = domID(Id).getAttribute('data-grid_auto_rows_index');
            grid_values = [];
            if (INPUTER3.value) {
              if (INPUTER3.value.indexOf(' ') > -1) {
                grid_values = INPUTER3.value.split(' ');
              } else {
                grid_values.push(INPUTER3.value);
              }
            }
            valueReadout.textContent = grid_values[col_index];
          } else {
            readoutValue.textContent = INPUTER3.value;
          }
          clearInterval(timepressed);
          clearTimeout(deleypress);
          if (mouseDown) {
            deleypress = setTimeout(iter, 200);
          } else {
            clearInterval(timepressed);
            clearTimeout(deleypress);
          }
        });
      }
    }
    // btn.ondblclick = clearIter;
    // btn.onmousedown = mousedown;
    // btn.onmouseup = clearIter;
    // btn.onmouseleave = clearIter;
    // btn.onclick = clearIter;

    btn.addEventListener('mousedown', mousedown);
    btn.addEventListener('mouseup', clearIter);
    btn.addEventListener('touchstart', mousedown);
    btn.addEventListener('touchend', clearIter);

  }
  var increment = 1;
  var input2ForDragger;
  // Increments value in input 3 up or down
  function PlusMinus(ButtonPair, PlusOrMinus, btn) {
    var theVal = 0;
    var col_index;
    var grid_values;

    INPUTER2.value = ButtonPair;

    input2ForDragger = INPUTER2.value;
    addBorederStyleIfNoneSetFace();

    if (frameID(domElement[0]).style[ButtonPair]) {
      INPUTER3.value = frameID(domElement[0]).style[ButtonPair];
    } else if (CSSstyles[ButtonPair]) {
      INPUTER3.value = CSSstyles[ButtonPair];
    } else if (getInheritedStyle(ButtonPair).style) {
      INPUTER3.value = getInheritedStyle(ButtonPair).style;
      clickAdder('units');
    } else {
      if (INPUTER2.value === 'gap') {
        INPUTER3.value = "0px 0px";
      } else if (INPUTER2.value === 'grid-template-columns') {
        INPUTER3.value = "1fr";
      } else if (INPUTER2.value === 'grid-template-rows') {
        INPUTER3.value = "1fr";
      } else if (INPUTER2.value === 'grid-auto-columns') {
        INPUTER3.value = "1fr";
      } else if (INPUTER2.value === 'grid-auto-rows') {
        INPUTER3.value = "1fr";
      } else {
        INPUTER3.value = "0px";
      }
      clickAdder(null);
    }

    var tempunits = "";
    var checkUnits;
    var getValues = frameID(domElement[0]).style[ButtonPair] || CSSstyles[ButtonPair];
    var getValuesSplit;
    if (INPUTER2.value === "gap" && (btn === 'gapX-up' || btn === 'gapX-down')) {
      getValuesSplit = getValues.split(' ')[0];
      checkUnits = getValuesSplit.match(theValREGEX) || "";
      if (!checkUnits.includes("auto")) {
        tempunits = getValuesSplit.match(theValREGEX);
      } else {
        tempunits = "px";
      }
      units = tempunits;
      theVal = Number(getValuesSplit.replace(theValREGEX, ""));
    } else if (INPUTER2.value === "gap" && (btn === 'gapY-up' || btn === 'gapY-down')) {
      getValuesSplit = getValues.split(' ')[1];
      checkUnits = getValuesSplit.match(theValREGEX) || "";
      if (!checkUnits.includes("auto")) {
        tempunits = getValuesSplit.match(theValREGEX);
      } else {
        tempunits = "px";
      }
      units = tempunits;
      theVal = Number(getValuesSplit.replace(theValREGEX, ""));
    } else if (INPUTER2.value === "grid-template-columns") {
      // get the index
      col_index = domID(btn).getAttribute('data-grid_template_columns_index');
      grid_values = [];
      if (getValues) {
        if (getValues.indexOf(' ') > -1) {
          grid_values = getValues.split(' ');
        } else {
          grid_values.push(getValues);
        }
      }
      checkUnits = grid_values[col_index].match(theValREGEX) || "";
      if (!checkUnits.includes("auto")) {
        tempunits = grid_values[col_index].match(theValREGEX);
      } else {
        tempunits = "px";
      }
      units = tempunits;
      theVal = Number(grid_values[col_index].replace(theValREGEX, ""));
    } else if (INPUTER2.value === "grid-template-rows") {
      // get the index
      col_index = domID(btn).getAttribute('data-grid_template_rows_index');
      grid_values = [];
      if (getValues) {
        if (getValues.indexOf(' ') > -1) {
          grid_values = getValues.split(' ');
        } else {
          grid_values.push(getValues);
        }
      }
      checkUnits = grid_values[col_index].match(theValREGEX) || "";
      if (!checkUnits.includes("auto")) {
        tempunits = grid_values[col_index].match(theValREGEX);
      } else {
        tempunits = "px";
      }
      units = tempunits;
      theVal = Number(grid_values[col_index].replace(theValREGEX, ""));
    } else if (INPUTER2.value === "grid-auto-columns") {
      // get the index
      col_index = domID(btn).getAttribute('data-grid_auto_columns_index');
      grid_values = [];
      if (getValues) {
        if (getValues.indexOf(' ') > -1) {
          grid_values = getValues.split(' ');
        } else {
          grid_values.push(getValues);
        }
      }
      checkUnits = grid_values[col_index].match(theValREGEX) || "";
      if (!checkUnits.includes("auto")) {
        tempunits = grid_values[col_index].match(theValREGEX);
      } else {
        tempunits = "px";
      }
      units = tempunits;
      theVal = Number(grid_values[col_index].replace(theValREGEX, ""));
    } else if (INPUTER2.value === "grid-auto-rows") {
      // get the index
      col_index = domID(btn).getAttribute('data-grid_auto_rows_index');
      grid_values = [];
      if (getValues) {
        if (getValues.indexOf(' ') > -1) {
          grid_values = getValues.split(' ');
        } else {
          grid_values.push(getValues);
        }
      }
      checkUnits = grid_values[col_index].match(theValREGEX) || "";
      if (!checkUnits.includes("auto")) {
        tempunits = grid_values[col_index].match(theValREGEX);
      } else {
        tempunits = "px";
      }
      units = tempunits;
      theVal = Number(grid_values[col_index].replace(theValREGEX, ""));
    } else if (getValues.indexOf('span') > -1) {
      var spansplit = getValues.split('span');
      var splitnumber = spansplit[1].trim();
      units = 'span';
      theVal = Number(splitnumber);
    } else {
      checkUnits = getValues.match(theValREGEX) || "";
      if (!checkUnits.includes("auto")) {
        tempunits = getValues.match(theValREGEX);
      } else {
        tempunits = "px";
      }
      units = tempunits;
      theVal = Number(getValues.replace(theValREGEX, ""));
    }

    if (Array.isArray(units)) {
      units = units[0];
    }
    //console.log('PlusMinus units', theVal, units);

    if (units === "em" || units === "rem" || units === "deg") {
      theVal = Number(theVal.toFixed(2));
    } else {
      if (INPUTER2.value === "letter-spacing") {
        theVal = Number(theVal.toFixed(1));
      } else if (INPUTER2.value === "line-height") {
        theVal = Number(theVal.toFixed(1));
      } else if (INPUTER2.value === "opacity") {
        theVal = Number(theVal).toFixed(2);
      } else {
        // THE MAIN INCREMENT +++++++++++++++++++++++
        theVal = Number(theVal.toFixed(0));
      }
    }
    switch (PlusOrMinus) {
      case "plus":
        if (units === "em" || units === "rem" || units === "deg") {
          theVal = Number((theVal + increment / 10).toFixed(2));
        } else {
          if (INPUTER2.value === "letter-spacing") {
            theVal = Number((theVal + increment / 10).toFixed(1));
          } else if (INPUTER2.value === "line-height") {
            theVal = Number((theVal + increment / 10).toFixed(1));
          } else if (INPUTER2.value === "opacity") {
            theVal = Number(Number(theVal) + Number(increment / 100)).toFixed(2);
          } else {
            // THE MAIN INCREMENT +++++++++++++++++++++++
            theVal = Number((theVal + increment).toFixed(0));
          }
        }
        break;
      case "minus":
        if (units === "em" || units === "rem" || units === "deg") {
          theVal = Number((theVal - increment / 10).toFixed(2));
        } else {
          if (INPUTER2.value === "letter-spacing") {
            theVal = Number((theVal - increment / 10).toFixed(1));
          } else if (INPUTER2.value === "line-height") {
            theVal = Number((theVal - increment / 10).toFixed(1));
          } else if (INPUTER2.value === "opacity") {
            theVal = Number(Number(theVal) - Number(increment / 100)).toFixed(2);
          } else {
            // THE MAIN INCREMENT -----------------------
            theVal = Number((theVal - increment).toFixed(0));
          }
        }
        break;
    }
    var setVal;
    var theValToPut;
    switch (INPUTER2.value) {
      case "gap":
        var forValue;
        if (units) {} else {
          units = "px";
        }
        if (theVal >= 0) {
          setVal = addUnits(theVal);
        } else {
          setVal = addUnits(0);
        }
        theValToPut = setVal;
        if (locks_obj['lock_gap'] === 'true') {
          forValue = theValToPut + ' ' + theValToPut;
        } else {
          if (btn === 'gapX-up' || btn === 'gapX-down') {
            forValue = theValToPut + ' ' + gapValYReadout.innerHTML;
          } else if (btn === 'gapY-up' || btn === 'gapY-down') {
            forValue = gapValXReadout.innerHTML + ' ' + theValToPut;
          }
        }
        INPUTER3.value = forValue;
        placeInHeadTempCSS_func(forValue);
        let [gapX, gapY] = forValue.split(' ');
        gapValXReadout.textContent = gapX;
        gapValYReadout.textContent = gapY;
        break;
      case "grid-template-columns":
        if (units) {} else {
          units = "px";
        }
        if (theVal >= 0) {
          setVal = addUnits(theVal);
        } else {
          setVal = addUnits(0);
        }
        theValToPut = setVal;
        col_index = domID(btn).getAttribute('data-grid_template_columns_index');
        grid_values = [];
        if (INPUTER3.value) {
          if (INPUTER3.value.indexOf(' ') > -1) {
            grid_values = INPUTER3.value.split(' ');
          } else {
            grid_values.push(INPUTER3.value);
          }
        }
        grid_values[col_index] = theValToPut;
        INPUTER3.value = grid_values.join(' ');
        placeInHeadTempCSS_func(INPUTER3.value);
        domID('grid-template-columns_value_' + col_index).textContent = grid_values[col_index];
        break;
      case "grid-template-rows":
        if (units) {} else {
          units = "px";
        }
        if (theVal >= 0) {
          setVal = addUnits(theVal);
        } else {
          setVal = addUnits(0);
        }
        theValToPut = setVal;
        col_index = domID(btn).getAttribute('data-grid_template_rows_index');
        grid_values = [];
        if (INPUTER3.value) {
          if (INPUTER3.value.indexOf(' ') > -1) {
            grid_values = INPUTER3.value.split(' ');
          } else {
            grid_values.push(INPUTER3.value);
          }
        }
        grid_values[col_index] = theValToPut;
        INPUTER3.value = grid_values.join(' ');
        placeInHeadTempCSS_func(INPUTER3.value);
        domID('grid-template-rows_value_' + col_index).textContent = grid_values[col_index];
        break;
      case "grid-auto-columns":
        if (units) {} else {
          units = "px";
        }
        if (theVal >= 0) {
          setVal = addUnits(theVal);
        } else {
          setVal = addUnits(0);
        }
        theValToPut = setVal;
        col_index = domID(btn).getAttribute('data-grid_auto_columns_index');
        grid_values = [];
        if (INPUTER3.value) {
          if (INPUTER3.value.indexOf(' ') > -1) {
            grid_values = INPUTER3.value.split(' ');
          } else {
            grid_values.push(INPUTER3.value);
          }
        }
        grid_values[col_index] = theValToPut;
        INPUTER3.value = grid_values.join(' ');
        placeInHeadTempCSS_func(INPUTER3.value);
        domID('grid-auto-columns_value_' + col_index).textContent = grid_values[col_index];
        break;
      case "grid-auto-rows":
        if (units) {} else {
          units = "px";
        }
        if (theVal >= 0) {
          setVal = addUnits(theVal);
        } else {
          setVal = addUnits(0);
        }
        theValToPut = setVal;
        col_index = domID(btn).getAttribute('data-grid_auto_rows_index');
        grid_values = [];
        if (INPUTER3.value) {
          if (INPUTER3.value.indexOf(' ') > -1) {
            grid_values = INPUTER3.value.split(' ');
          } else {
            grid_values.push(INPUTER3.value);
          }
        }
        grid_values[col_index] = theValToPut;
        INPUTER3.value = grid_values.join(' ');
        placeInHeadTempCSS_func(INPUTER3.value);
        domID('grid-auto-rows_value_' + col_index).textContent = grid_values[col_index];
        break;
      case "opacity":
        if (theVal <= 0) {
          theVal = '0';
        }
        if (theVal >= 1) {
          theVal = '1';
        }
        units = "";
        setVal = theVal;
        INPUTER3.value = setVal;
        valueReadout.textContent = setVal;
        placeInHeadTempCSS_func(setVal);

        break;
      case "line-height":
        if (theVal >= 0) {
          setVal = addUnits(theVal);
          INPUTER3.value = setVal;
          valueReadout.textContent = setVal;
          placeInHeadTempCSS_func(setVal);
        }
        break;
      case "margin-left":
      case "margin-top":
      case "margin-right":
      case "margin-bottom":
        if (locks_obj['lock_margin'] === 'true') {
          if (units) {} else {
            units = "px";
          }
          setVal = addUnits(theVal);
          INPUTER3.value = setVal;
          placeInHeadTempCSS_func_multi('margin', setVal);
        } else {
          if (units) {} else {
            units = "px";
          }
          setVal = addUnits(theVal);
          INPUTER3.value = setVal;
          valueReadout.textContent = setVal;
          placeInHeadTempCSS_func(setVal);
        }
        break;
      case "padding-left":
      case "padding-top":
      case "padding-right":
      case "padding-bottom":
        if (theVal <= 0) {
          theVal = '0';
        }
        if (locks_obj['lock_padding'] === 'true') {
          if (units) {} else {
            units = "px";
          }
          setVal = addUnits(theVal);
          INPUTER3.value = setVal;
          placeInHeadTempCSS_func_multi('padding', setVal);
        } else {
          if (units) {} else {
            units = "px";
          }
          setVal = addUnits(theVal);
          INPUTER3.value = setVal;
          valueReadout.textContent = setVal;
          placeInHeadTempCSS_func(setVal);
        }
        break;
      case "border-left-width":
      case "border-top-width":
      case "border-right-width":
      case "border-bottom-width":
        if (theVal <= 0) {
          theVal = '0';
        }
        if (locks_obj['lock_border-width'] === 'true') {
          if (units) {} else {
            units = "px";
          }
          setVal = addUnits(theVal);
          INPUTER3.value = setVal;
          placeInHeadTempCSS_func_multi('border-width', setVal);
        } else {
          if (units) {} else {
            units = "px";
          }
          setVal = addUnits(theVal);
          INPUTER3.value = setVal;
          valueReadout.textContent = setVal;
          placeInHeadTempCSS_func(setVal);
        }

        break;
      case "border-top-left-radius":
      case "border-top-right-radius":
      case "border-bottom-left-radius":
      case "border-bottom-right-radius":
        if (theVal <= 0) {
          theVal = '0';
        }

        if (locks_obj['lock_border-radius'] === 'true') {
          if (units) {} else {
            units = "px";
          }
          setVal = addUnits(theVal);
          INPUTER3.value = setVal;
          placeInHeadTempCSS_func_multi('border-radius', setVal);
        } else {
          if (units) {} else {
            units = "px";
          }
          setVal = addUnits(theVal);
          INPUTER3.value = setVal;
          valueReadout.textContent = setVal;
          placeInHeadTempCSS_func(setVal);
        }

        break;
      case "width":
      case "height":
      case "min-width":
      case "min-height":
      case "max-width":
      case "max-height":
      case "font-size":
      case "font-size":
      case "outline-width":
      case "text-decoration-thickness":
        // propertys that dont go below 0
        if (theVal <= 0) {
          theVal = '0';
        }
        if (units) {} else {
          units = "px";
        }
        setVal = addUnits(theVal);
        INPUTER3.value = setVal;
        valueReadout.textContent = setVal;
        placeInHeadTempCSS_func(setVal);

        break;
      case "z-index":
        if (theVal < 1000) {
          units = "";
          setVal = addUnits(theVal);
          INPUTER3.value = setVal;
          valueReadout.textContent = setVal;
          placeInHeadTempCSS_func(setVal);
        }
        break;
      case "grid-row-start":
      case "grid-column-start":
      case "grid-row-end":
      case "grid-column-end":
        if (units !== "span") {
          units = "";
        }
        setVal = addUnits(theVal);
        INPUTER3.value = setVal;
        valueReadout.textContent = setVal;
        placeInHeadTempCSS_func(setVal);
        break;
      default:
        if (units) {} else {
          units = "px";
        }
        setVal = addUnits(theVal);
        INPUTER3.value = setVal;
        valueReadout.textContent = setVal;
        placeInHeadTempCSS_func(setVal);
        break;
    }
    addBorederStyleIfNoneSetFace();
  }
  // ---------------------------------------------------
  // ---------------------------------------------------
  // Units

  function returnUnits(str, unit) {
    var units_split;
    var forReturn;
    if (str.indexOf(unit) > -1) {
      units_split = str.match(/[a-z%]+|[^a-z%]+/gi);
      if (units_split[0] === unit) {
        forReturn = units_split[0];
      } else if (units_split[1] === unit) {
        forReturn = units_split[1];
      }
    }
    return forReturn;
  }

  var array_of_units_els = [...document.querySelectorAll('.units-button')];

  var grid_start_end_dontshow = ['px', '%', 'fr', 'ch', 'em', 'rem', 'vh', 'vw', 'vmin', 'vmax', 'cm', 'mm', 'in'];

  function setStylesOnUnitsButtons() {
    switch (lastSettingsButton) {
      case "padding-left-settings":
      case "padding-top-settings":
      case "padding-right-settings":
      case "padding-bottom-settings":
      case "font-size-settings":
      case "letter-spacing-settings":
        domID("unit-none").style.cssText = inactiveStyle;
        domID("unit-auto").style.cssText = inactiveStyle;
        document.querySelector('[data-unit_val="span"]').style.cssText = inactiveStyle;
        break;
      case "line-height-settings":
        domID("unit-auto").style.cssText = inactiveStyle;
        document.querySelector('[data-unit_val="span"]').style.cssText = inactiveStyle;
        break;
      case "grid-row-start-settings":
      case "grid-column-start-settings":
      case "grid-row-end-settings":
      case "grid-column-end-settings":
        array_of_units_els.map((el) => {
          if (grid_start_end_dontshow.indexOf(el.dataset['unit_val']) > -1) {
            el.style = 'display: none;';
          }
        });
        break;
      default:
        domID("unit-none").style.cssText = inactiveStyle;
        document.querySelector('[data-unit_val="span"]').style.cssText = inactiveStyle;
        break;
    }
  }

  function TheUIElementsUnitValueFromInputer3() {
    var UnitIs;
    var str = INPUTER3.value || units;
    UnitIs = array_of_units_els.filter((el) => {
      var visual_val = el.innerText;
      return returnUnits(str, visual_val);
    });
    if (UnitIs[0]) {
      UnitIs[0].style = buttonHLColor;
    } else {
      domID('unit-none').style = buttonHLColor;
    }
    setStylesOnUnitsButtons();
  }

  function clearTheUIElementsUnitValue() {
    array_of_units_els.map((el) => {
      el.style = buttonBGColor;
    });
    // only make none units show for line height
    if (
      lastSettingsButton !== "line-height-settings" &&
      lastSettingsButton !== "grid-row-start-settings" &&
      lastSettingsButton !== "grid-column-start-settings" &&
      lastSettingsButton !== "grid-row-end-settings" &&
      lastSettingsButton !== "grid-column-end-settings"
    ) {
      domID("unit-none").style.cssText = inactiveStyle;
    }
  }

  function addAllBorederStyleIfNoneSetFace() {
    addBorederStyleIfNone("left");
    addBorederStyleIfNone("top");
    addBorederStyleIfNone("right");
    addBorederStyleIfNone("bottom");
  }

  function addBorederStyleIfNoneSetFace() {
    switch (INPUTER2.value) {
      case "border-left-width":
        if (locks_obj['lock_border-width'] === 'true') {
          addAllBorederStyleIfNoneSetFace();
        } else {
          addBorederStyleIfNone("left");
        }
        break;
      case "border-top-width":
        if (locks_obj['lock_border-width'] === 'true') {
          addAllBorederStyleIfNoneSetFace();
        } else {
          addBorederStyleIfNone("top");
        }
        break;
      case "border-right-width":
        if (locks_obj['lock_border-width'] === 'true') {
          addAllBorederStyleIfNoneSetFace();
        } else {
          addBorederStyleIfNone("right");
        }
        break;
      case "border-bottom-width":
        if (locks_obj['lock_border-width'] === 'true') {
          addAllBorederStyleIfNoneSetFace();
        } else {
          addBorederStyleIfNone("bottom");
        }
        break;
    }

  }

  function addBorederStyleIfNone(side) {
    var theBorder = "border-" + side + "-style";
    var input1 = INPUTER1.value;

    if (inline_external_css === 'inline') {
      frameID(domElement[0]).style[INPUTER2.value] = theBorder;
    } else {
      if (!CSSstyles[theBorder]) {
        switch (breakPoint) {
          case "fullWidth":
            if (!thecssLG[input1][theBorder]) {
              put(theBorder, "solid", thecssLG[input1]);
              logger();
            }
            break;
          case "breakPoint1":
            if (!thecssMD[input1][theBorder]) {
              put(theBorder, "solid", thecssMD[input1]);
              logger();
            }
            break;
          case "breakPoint2":
            if (!thecssSM[input1][theBorder]) {
              put(theBorder, "solid", thecssSM[input1]);
              logger();
            }
            break;
          case "breakPoint3":
            if (!thecssXS[input1][theBorder]) {
              put(theBorder, "solid", thecssXS[input1]);
              logger();
            }
            break;
        }
      }
    }
  }

  // ---------------------------------------------------
  // ---------------------------------------------------
  // POPULATES THE VALUE READOUTS OF THE CURRENTLY SELECTED CLASS

  function createOptionIfNonStandard(style, option_name, select_el) {
    var select_option_el = document.querySelector(`[data-select='${style}'] option[value='${option_name}']`);
    var option;
    if (!select_option_el && document.activeElement !== INPUTER3) {
      if (style === 'background-image') {
        if (removeURLBrackets(option_name) === 'not-image-url' && option_name !== 'none') {
          option = document.createElement("option");
          option.text = option_name + " (custom)";
          option.value = option_name;
          select_el.appendChild(option);
        }
      } else {
        option = document.createElement("option");
        option.text = option_name + " (custom)";
        option.value = option_name;
        select_el.appendChild(option);
      }
      select_option_el = document.querySelector(`[data-select='${style}'] option[value='${option_name}']`);
      if (select_option_el) {
        select_option_el.setAttribute("selected", true);
      }
    }
  }

  var label__flex_wrap = document.querySelector('[for="select__flex-wrap"]');
  var label__align_content = document.querySelector('[for="select__align-content"]');
  var label__justify_content = document.querySelector('[for="select__justify-content"]');
  var label__align_items = document.querySelector('[for="select__align-items"]');

  function setFlexDirections(direction) {
    switch (direction) {
      case "row":
      case "row-reverse":
        label__flex_wrap.innerText = "🡘 flex wrap";
        label__align_content.innerText = "🡙 align content (if content wraps)";
        label__justify_content.innerText = "🡘 justify content";
        label__align_items.innerText = "🡙 align items";
        break;
      case "column":
      case "column-reverse":
        label__flex_wrap.innerText = "🡙 flex wrap";
        label__align_content.innerText = "🡘 align content (if content wraps)";
        label__justify_content.innerText = "🡙 justify content";
        label__align_items.innerText = "🡘 align items";
        break;
    }
  }

  function setInputValue(element, style) {
    element.parentElement.setAttribute('data-media-inherit', '');
    if (frameID(domElement[0]).style[style]) {
      element.value = frameID(domElement[0]).style[style];
      element.style = "color: var(--mainColor)";
      element.parentElement.setAttribute('data-media-inherit', 'inline');
    } else if (CSSstyles[style]) {
      element.value = CSSstyles[style];
      element.style = "color: var(--mainColor)";
      element.parentElement.setAttribute('data-media-inherit', `(${BP})`);
    } else if (getInheritedStyle(style).style) {
      element.value = getInheritedStyle(style).style;
      element.style = "color: #777; opacity: 0.5";
      element.parentElement.setAttribute('data-media-inherit', `(${getInheritedStyle(style).breakpoint})`);
    } else {
      element.value = "";
      element.style = "color: #777; opacity: 0.5";
    }
  }

  function removeSelectValue(style, el_id_if_different) {
    var select_el;
    if (!el_id_if_different) {
      select_el = document.querySelector('[data-select="' + style + '"]');
    } else {
      select_el = document.querySelector(el_id_if_different);
    }
    select_el.value = "";
  }

  function setSelectValue(style, el_id_if_different) {
    var other_style = "color: #777; opacity: 0.5";
    var style_options = document.querySelectorAll('[data-select="' + style + '"] option');
    [].forEach.call(style_options, function (style_option) {
      style_option.removeAttribute("selected");
    });
    var select_el;
    if (!el_id_if_different) {
      select_el = document.querySelector('[data-select="' + style + '"]');
    } else {
      select_el = document.querySelector(el_id_if_different);
    }
    select_el.removeAttribute('style');
    select_el.value = "";

    if (frameID(domElement[0]).style[style]) {
      select_el.style = "color: var(--mainColor)";
      select_el.value = frameID(domElement[0]).style[style];
      select_el.parentElement.setAttribute('data-media-inherit', 'inline');
      createOptionIfNonStandard(style, frameID(domElement[0]).style[style], select_el);
    } else if (CSSstyles[style]) {
      select_el.style = "color: var(--mainColor)";
      select_el.value = CSSstyles[style];
      select_el.parentElement.setAttribute('data-media-inherit', `(${BP})`);
      createOptionIfNonStandard(style, CSSstyles[style], select_el);
    } else if (checkOtherMediaVals(style)) {
      if (mobileFirst) {
        switch (breakPoint) {
          case "fullWidth":
            if (
              thecssMD[FillValueReadouts_input1] &&
              thecssMD[FillValueReadouts_input1][style]
            ) {
              select_el.style = other_style;
              select_el.value = thecssMD[FillValueReadouts_input1][style];
              select_el.parentElement.setAttribute('data-media-inherit', '(MD)');
              createOptionIfNonStandard(style, thecssMD[FillValueReadouts_input1][style], select_el);
            } else if (
              thecssSM[FillValueReadouts_input1] &&
              thecssSM[FillValueReadouts_input1][style]
            ) {
              select_el.style = other_style;
              select_el.value = thecssSM[FillValueReadouts_input1][style];
              select_el.parentElement.setAttribute('data-media-inherit', '(SM)');
              createOptionIfNonStandard(style, thecssSM[FillValueReadouts_input1][style], select_el);
            } else if (
              thecssXS[FillValueReadouts_input1] &&
              thecssXS[FillValueReadouts_input1][style]
            ) {
              select_el.style = other_style;
              select_el.value = thecssXS[FillValueReadouts_input1][style];
              select_el.parentElement.setAttribute('data-media-inherit', '(XS)');
              createOptionIfNonStandard(style, thecssXS[FillValueReadouts_input1][style], select_el);
            }
            break;
          case "breakPoint1":
            if (
              thecssSM[FillValueReadouts_input1] &&
              thecssSM[FillValueReadouts_input1][style]
            ) {
              select_el.style = other_style;
              select_el.value = thecssSM[FillValueReadouts_input1][style];
              select_el.parentElement.setAttribute('data-media-inherit', '(SM)');
              createOptionIfNonStandard(style, thecssSM[FillValueReadouts_input1][style], select_el);
            } else if (
              thecssXS[FillValueReadouts_input1] &&
              thecssXS[FillValueReadouts_input1][style]
            ) {
              select_el.style = other_style;
              select_el.value = thecssXS[FillValueReadouts_input1][style];
              select_el.parentElement.setAttribute('data-media-inherit', '(XS)');
              createOptionIfNonStandard(style, thecssXS[FillValueReadouts_input1][style], select_el);
            }
            break;
          case "breakPoint2":
            if (
              thecssXS[FillValueReadouts_input1] &&
              thecssXS[FillValueReadouts_input1][style]
            ) {
              select_el.style = other_style;
              select_el.value = thecssXS[FillValueReadouts_input1][style];
              select_el.parentElement.setAttribute('data-media-inherit', '(XS)');
              createOptionIfNonStandard(style, thecssXS[FillValueReadouts_input1][style], select_el);
            }
            break;
        }
      } else {
        switch (breakPoint) {
          case "breakPoint1":
            if (
              thecssLG[FillValueReadouts_input1] &&
              thecssLG[FillValueReadouts_input1][style]
            ) {
              select_el.style = other_style;
              select_el.value = thecssLG[FillValueReadouts_input1][style];
              select_el.parentElement.setAttribute('data-media-inherit', '(LG)');
              createOptionIfNonStandard(style, thecssLG[FillValueReadouts_input1][style], select_el);
            }
            break;
          case "breakPoint2":
            if (
              thecssMD[FillValueReadouts_input1] &&
              thecssMD[FillValueReadouts_input1][style]
            ) {
              select_el.style = other_style;
              select_el.value = thecssMD[FillValueReadouts_input1][style];
              select_el.parentElement.setAttribute('data-media-inherit', '(MD)');
              createOptionIfNonStandard(style, thecssMD[FillValueReadouts_input1][style], select_el);
            } else if (
              thecssLG[FillValueReadouts_input1] &&
              thecssLG[FillValueReadouts_input1][style]
            ) {
              select_el.style = other_style;
              select_el.value = thecssLG[FillValueReadouts_input1][style];
              select_el.parentElement.setAttribute('data-media-inherit', '(LG)');
              createOptionIfNonStandard(style, thecssLG[FillValueReadouts_input1][style], select_el);
            }
            break;
          case "breakPoint3":
            if (
              thecssSM[FillValueReadouts_input1] &&
              thecssSM[FillValueReadouts_input1][style]
            ) {
              select_el.style = other_style;
              select_el.value = thecssSM[FillValueReadouts_input1][style];
              select_el.parentElement.setAttribute('data-media-inherit', '(SM)');
              createOptionIfNonStandard(style, thecssSM[FillValueReadouts_input1][style], select_el);
            } else if (
              thecssMD[FillValueReadouts_input1] &&
              thecssMD[FillValueReadouts_input1][style]
            ) {
              select_el.style = other_style;
              select_el.value = thecssMD[FillValueReadouts_input1][style];
              select_el.parentElement.setAttribute('data-media-inherit', '(MD)');
              createOptionIfNonStandard(style, thecssMD[FillValueReadouts_input1][style], select_el);
            } else if (
              thecssLG[FillValueReadouts_input1] &&
              thecssLG[FillValueReadouts_input1][style]
            ) {
              select_el.style = other_style;
              select_el.value = thecssLG[FillValueReadouts_input1][style];
              select_el.parentElement.setAttribute('data-media-inherit', '(LG)');
              createOptionIfNonStandard(style, thecssLG[FillValueReadouts_input1][style], select_el);
            }
            break;
        }
      }
    }
  }



  function setIframeSelectHandels(style, style_value) {
    switch (style) {

      case "padding":
        iframeElementSelect.setAttribute('p-top', style_value);
        iframeElementSelect.setAttribute('p-right', style_value);
        iframeElementSelect.setAttribute('p-bottom', style_value);
        iframeElementSelect.setAttribute('p-left', style_value);
        break;
      case "padding-top":
        iframeElementSelect.setAttribute('p-top', style_value);
        break;
      case "padding-right":
        iframeElementSelect.setAttribute('p-right', style_value);
        break;
      case "padding-bottom":
        iframeElementSelect.setAttribute('p-bottom', style_value);
        break;
      case "padding-left":
        iframeElementSelect.setAttribute('p-left', style_value);
        break;

      case "margin":
        iframeElementSelect.setAttribute('m-top', style_value);
        iframeElementSelect.setAttribute('m-right', style_value);
        iframeElementSelect.setAttribute('m-bottom', style_value);
        iframeElementSelect.setAttribute('m-left', style_value);
        break;
      case "margin-top":
        iframeElementSelect.setAttribute('m-top', style_value);
        break;
      case "margin-right":
        iframeElementSelect.setAttribute('m-right', style_value);
        break;
      case "margin-bottom":
        iframeElementSelect.setAttribute('m-bottom', style_value);
        break;
      case "margin-left":
        iframeElementSelect.setAttribute('m-left', style_value);
        break;

      case "border-width":
        iframeElementSelect.setAttribute('b-top', style_value);
        iframeElementSelect.setAttribute('b-right', style_value);
        iframeElementSelect.setAttribute('b-bottom', style_value);
        iframeElementSelect.setAttribute('b-left', style_value);
        break;
      case "border-top-width":
        iframeElementSelect.setAttribute('b-top', style_value);
        break;
      case "border-right-width":
        iframeElementSelect.setAttribute('b-right', style_value);
        break;
      case "border-bottom-width":
        iframeElementSelect.setAttribute('b-bottom', style_value);
        break;
      case "border-left-width":
        iframeElementSelect.setAttribute('b-left', style_value);
        break;

      default:
        break;
    }
  }

  function setValueInnerHTML(element, style, novalue) {
    if (!element && !style) {
      return false;
    }
    if (!novalue) {
      novalue = "";
    }

    if (frameID(domElement[0]).style[style]) {
      element.textContent = frameID(domElement[0]).style[style];
      element.style.color = mainColor;
      element.style.opacity = "1";
      element.parentElement.setAttribute('data-media-inherit', 'inline');
      setIframeSelectHandels(style, frameID(domElement[0]).style[style]);
    } else if (CSSstyles[style]) {
      element.textContent = CSSstyles[style];
      element.style.color = mainColor;
      element.style.opacity = "1";
      element.parentElement.setAttribute('data-media-inherit', `(${BP})`);
      setIframeSelectHandels(style, CSSstyles[style]);
    } else if (checkOtherMediaVals(style)) {
      if (mobileFirst) {
        switch (breakPoint) {
          case "fullWidth":
            if (thecssMD[FillValueReadouts_input1] && thecssMD[FillValueReadouts_input1][style]) {
              element.style.color = null;
              element.style.opacity = "0.5";
              element.textContent = thecssMD[FillValueReadouts_input1][style];
              element.parentElement.setAttribute('data-media-inherit', '(MD)');
              setIframeSelectHandels(style, thecssMD[FillValueReadouts_input1][style]);
            } else if (thecssSM[FillValueReadouts_input1] && thecssSM[FillValueReadouts_input1][style]) {
              element.style.color = null;
              element.style.opacity = "0.5";
              element.textContent = thecssSM[FillValueReadouts_input1][style];
              element.parentElement.setAttribute('data-media-inherit', '(SM)');
              setIframeSelectHandels(style, thecssSM[FillValueReadouts_input1][style]);
            } else if (thecssXS[FillValueReadouts_input1] && thecssXS[FillValueReadouts_input1][style]) {
              element.style.color = null;
              element.style.opacity = "0.5";
              element.textContent = thecssXS[FillValueReadouts_input1][style];
              element.parentElement.setAttribute('data-media-inherit', '(XS)');
              setIframeSelectHandels(style, thecssXS[FillValueReadouts_input1][style]);
            } else {
              element.style.color = null;
              element.style.opacity = null;
              element.textContent = novalue;
              element.parentElement.setAttribute('data-media-inherit', '');
              setIframeSelectHandels(style, '');
            }
            break;
          case "breakPoint1":
            if (thecssSM[FillValueReadouts_input1] && thecssSM[FillValueReadouts_input1][style]) {
              element.style.color = null;
              element.style.opacity = "0.5";
              element.textContent = thecssSM[FillValueReadouts_input1][style];
              element.parentElement.setAttribute('data-media-inherit', '(SM)');
              setIframeSelectHandels(style, thecssSM[FillValueReadouts_input1][style]);
            } else if (thecssXS[FillValueReadouts_input1] && thecssXS[FillValueReadouts_input1][style]) {
              element.style.color = null;
              element.style.opacity = "0.5";
              element.textContent = thecssXS[FillValueReadouts_input1][style];
              element.parentElement.setAttribute('data-media-inherit', '(XS)');
              setIframeSelectHandels(style, thecssXS[FillValueReadouts_input1][style]);
            } else {
              element.style.color = null;
              element.style.opacity = null;
              element.textContent = novalue;
              element.parentElement.setAttribute('data-media-inherit', '');
              setIframeSelectHandels(style, '');
            }
            break;
          case "breakPoint2":
            if (thecssXS[FillValueReadouts_input1] && thecssXS[FillValueReadouts_input1][style]) {
              element.style.color = null;
              element.style.opacity = "0.5";
              element.textContent = thecssXS[FillValueReadouts_input1][style];
              element.parentElement.setAttribute('data-media-inherit', '(XS)');
              setIframeSelectHandels(style, thecssXS[FillValueReadouts_input1][style]);
            } else {
              element.style.color = null;
              element.style.opacity = null;
              element.textContent = novalue;
              element.parentElement.setAttribute('data-media-inherit', '');
              setIframeSelectHandels(style, '');
            }
            break;
          case "breakPoint3":
            if (thecssXS[FillValueReadouts_input1] && !thecssXS[FillValueReadouts_input1][style]) {
              element.style.color = null;
              element.style.opacity = null;
              element.textContent = novalue;
              element.parentElement.setAttribute('data-media-inherit', '');
              setIframeSelectHandels(style, '');
            }
            break;
        }
      } else {
        switch (breakPoint) {
          case "fullWidth":
            if (thecssLG[FillValueReadouts_input1] && !thecssLG[FillValueReadouts_input1][style]) {
              element.style.color = null;
              element.style.opacity = null;
              element.textContent = novalue;
              element.parentElement.setAttribute('data-media-inherit', '');
              setIframeSelectHandels(style, '');
            }
            break;
          case "breakPoint1":
            if (thecssLG[FillValueReadouts_input1] && thecssLG[FillValueReadouts_input1][style]) {
              element.style.color = null;
              element.style.opacity = "0.5";
              element.textContent = thecssLG[FillValueReadouts_input1][style];
              element.parentElement.setAttribute('data-media-inherit', '(LG)');
              setIframeSelectHandels(style, thecssLG[FillValueReadouts_input1][style]);
            } else {
              element.style.color = null;
              element.style.opacity = null;
              element.textContent = novalue;
              element.parentElement.setAttribute('data-media-inherit', '');
              setIframeSelectHandels(style, '');
            }
            break;
          case "breakPoint2":
            if (thecssMD[FillValueReadouts_input1] && thecssMD[FillValueReadouts_input1][style]) {
              element.style.color = null;
              element.style.opacity = "0.5";
              element.textContent = thecssMD[FillValueReadouts_input1][style];
              element.parentElement.setAttribute('data-media-inherit', '(MD)');
              setIframeSelectHandels(style, thecssMD[FillValueReadouts_input1][style]);
            } else if (thecssLG[FillValueReadouts_input1] && thecssLG[FillValueReadouts_input1][style]) {
              element.style.color = null;
              element.style.opacity = "0.5";
              element.textContent = thecssLG[FillValueReadouts_input1][style];
              element.parentElement.setAttribute('data-media-inherit', '(LG)');
              setIframeSelectHandels(style, thecssLG[FillValueReadouts_input1][style]);
            } else {
              element.style.color = null;
              element.style.opacity = null;
              element.textContent = novalue;
              element.parentElement.setAttribute('data-media-inherit', '');
              setIframeSelectHandels(style, '');
            }
            break;
          case "breakPoint3":
            if (thecssSM[FillValueReadouts_input1] && thecssSM[FillValueReadouts_input1][style]) {
              element.style.color = null;
              element.style.opacity = "0.5";
              element.textContent = thecssSM[FillValueReadouts_input1][style];
              element.parentElement.setAttribute('data-media-inherit', '(SM)');
              setIframeSelectHandels(style, thecssSM[FillValueReadouts_input1][style]);
            } else if (thecssMD[FillValueReadouts_input1] && thecssMD[FillValueReadouts_input1][style]) {
              element.style.color = null;
              element.style.opacity = "0.5";
              element.textContent = thecssMD[FillValueReadouts_input1][style];
              element.parentElement.setAttribute('data-media-inherit', '(MD)');
              setIframeSelectHandels(style, thecssMD[FillValueReadouts_input1][style]);
            } else if (thecssLG[FillValueReadouts_input1] && thecssLG[FillValueReadouts_input1][style]) {
              element.style.color = null;
              element.style.opacity = "0.5";
              element.textContent = thecssLG[FillValueReadouts_input1][style];
              element.parentElement.setAttribute('data-media-inherit', '(LG)');
              setIframeSelectHandels(style, thecssLG[FillValueReadouts_input1][style]);
            } else {
              element.style.color = null;
              element.style.opacity = null;
              element.textContent = novalue;
              element.parentElement.setAttribute('data-media-inherit', '');
              setIframeSelectHandels(style, '');
            }
            break;
        }

      }
    } else {
      element.textContent = novalue;
      element.style.color = null;
      element.style.opacity = null;
      element.parentElement.setAttribute('data-media-inherit', '');
      setIframeSelectHandels(style, '');
    }
  }

  //----------------------------------------------------------------------------------------------
  // grid-template-columns

  function setGridInputs(
    property_type_pass,
    data_type_pass,
    button_text_pass,
    input_text_pass,
    value,
    inherited_style
  ) {
    var property_type = property_type_pass || '';
    var data_type = data_type_pass || '';
    var button_text = button_text_pass || '';
    var input_text = input_text_pass || '';
    var grid_values = [];
    if (value) {
      if (value.indexOf(' ') > -1) {
        grid_values = value.split(' ');
      } else {
        grid_values.push(value);
      }
    }
    var gridHTML = '';
    grid_values.map((grid_col, index) => {
      var template = /*HTML*/ `
      <div class="value-wrapper__row">
        <div class="value-wrapper">
          <div class="value-wrapper__col">
              <button role="presentation" aria-label="GUI" type="button" class="HD plus-button"
                  id="${property_type}-up-${index}" data-${data_type}_index="${index}">&#9650;</button>
              <span data-${data_type}_value="${index}" id="${property_type}_value_${index}" style="${inherited_style}">${escapeHTML(grid_col)}</span>
              <button role="presentation" aria-label="GUI" type="button" class="settings-button"
                  id="${property_type}-settings-${index}">&#9722;</button>
          </div>
          <div class="value-wrapper__col value-wrapper__col--line">
              <button role="presentation" aria-label="GUI" type="button" class="HD minus-button"
                  id="${property_type}-down-${index}" data-${data_type}_index="${index}">&#9660;</button>

              <span>${input_text} ${(index + 1)}</span>
              <button role="presentation" aria-label="GUI" type="button" class="remove-button"
                  data-to_remove_index="${index}">&times;</button>
          </div>
        </div>
      </div>`;
      gridHTML = gridHTML + template;
    });
    var addNewButton = /*HTML*/ `
    <button role="presentation" style="width: 100%; margin: 10px 0 0; padding: 4px 10px 4px;" aria-label="GUI" type="button" class="HD" id="addNew-${property_type}"><i class="material-icons">add</i>&nbsp;&nbsp;${button_text}</button>`;
    if (!value) {
      domID(property_type + '-render').innerHTML = "" + addNewButton;
    } else {
      domID(property_type + '-render').innerHTML = gridHTML + addNewButton;
    }
    domID(`addNew-${property_type}`).onclick = () => {
      if (INPUTER1.value) {
        INPUTER2.value = property_type;

        if (frameID(domElement[0]).style[property_type]) {
          INPUTER3.value = frameID(domElement[0]).style[property_type];
        } else if (CSSstyles[property_type]) {
          INPUTER3.value = CSSstyles[property_type];
        } else {
          INPUTER3.value = "";
        }
        var grid_values = [];
        if (INPUTER3.value) {
          if (INPUTER3.value.indexOf(' ') > -1) {
            grid_values = INPUTER3.value.split(' ');
          } else {
            grid_values.push(INPUTER3.value);
          }
        }
        grid_values.push('1fr');
        INPUTER3.value = grid_values.join(' ');
      }
      clickAdder(null);
      FillUndo();
      FillValueReadouts();
    };
    var deleleBtns = [...document.querySelectorAll('#' + property_type + '-render .remove-button')];
    deleleBtns.map((deleleBtn) => {
      deleleBtn.onclick = () => {
        var slicepoint = deleleBtn.getAttribute('data-to_remove_index');
        var grid_values = [];
        if (!INPUTER1.value) {
          return false;
        }
        INPUTER2.value = property_type;
        INPUTER3.value = frameID(domElement[0]).style[property_type] || CSSstyles[property_type];
        if (INPUTER3.value) {
          if (INPUTER3.value.indexOf(' ') > -1) {
            grid_values = INPUTER3.value.split(' ');
          } else {
            grid_values.push(INPUTER3.value);
          }
        }
        grid_values.splice(slicepoint, 1);
        var new_grid_values = grid_values.join(' ');
        INPUTER3.value = new_grid_values;
        clickAdder(null);
        FillUndo();
        FillValueReadouts();
      };
    });
    var valueDraggers = [...document.querySelectorAll('#' + property_type + '-render [data-' + data_type + '_value]')];
    valueDraggers.map((valueDragger) => {
      draggerMaker(valueDragger.id, property_type, "y");
    });
    var unitsPanels = [...document.querySelectorAll('#' + property_type + '-render .settings-button')];
    unitsPanels.map((unitsPanel) => {
      showAndHideGUIUnitsPanel(unitsPanel.id, "unitsPanel");
    });
    var plusButtons = [...document.querySelectorAll('#' + property_type + '-render .plus-button')];
    plusButtons.map((plusButton, index) => {
      plusMinusBtnMaker(
        plusButton.id,
        property_type,
        property_type + "_value_" + index,
        "plus"
      );
    });
    var minusButtons = [...document.querySelectorAll('#' + property_type + '-render .minus-button')];
    minusButtons.map((minusButton, index) => {
      plusMinusBtnMaker(
        minusButton.id,
        property_type,
        property_type + "_value_" + index,
        "minus"
      );
    });
  }



  var select__gradient_type = domID('select__gradient-type');

  select__gradient_type.onchange = () => {
    INPUTER2.value = 'background';
    if (!CSSstyles['background']) {
      var type_of_grad;
      switch (select__gradient_type.value) {
        case 'linear':
          type_of_grad = `linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(255,255,255,1.00) 100%)`;
          break;
        case 'radial':
          type_of_grad = `radial-gradient(circle at 50% 50%, rgba(0,0,0,1) 0%, rgba(255,255,255,1.00) 100%)`;
          break;
        case 'elliptical':
          type_of_grad = `radial-gradient(ellipse at 50% 50%, rgba(0,0,0,1) 0%, rgba(255,255,255,1.00) 100%)`;
          break;
        case 'conical':
          type_of_grad = `conic-gradient(from 0deg at 50% 50%, rgba(0,0,0,1) 0%, rgba(255,255,255,1.00) 100%)`;
          break;
      }
      setTimeout(function () {
        INPUTER3.value = type_of_grad;
        clickAdder("units");
      }, 0);
    } else {
      setTimeout(function () {
        var getVal = createGradientValue();
        INPUTER3.value = getVal;
        clickAdder("units");
      }, 0);
    }
    setTimeout(function () {
      placeInHeadTempCSS_func();
      FillUndo();
      FillValueReadouts();
    }, 0);
  };


  var gradient_deg = domID('gradient-deg');
  var gradient_x = domID('gradient-x');
  var gradient_y = domID('gradient-y');
  var colour_stops = domID('colour_stops');

  draggerMaker(`gradient-deg`, 'background', "y");
  draggerMaker(`gradient-x`, 'background', "y");
  draggerMaker(`gradient-y`, 'background', "y");

  function createColorStop(index) {
    return /*HTML*/ `<div class="value-wrapper__row" data-stop id="gradient-stop-${index}">
    <div class="value-wrapper">
      <div class="value-wrapper__col">
          <div class="value-wrapper__colorpick">
              <svg id="gradient-stop-color-triangle-${index}" class="color-triangle"
                  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                  <path
                      d="M 0.03,10.00 C 0.03,10.00 10.00,19.97 10.00,19.97 10.00,19.97 0.06,20.00 0.06,20.00" />
              </svg>
              <div id="gradient-stop-color-${index}"></div>
          </div>
          <span class="hue-apply smaller-value" id="gradient-stop-color_value-${index}"></span>
      </div>
      <div class="value-wrapper__col value-wrapper__col--line hue-apply">
          <span>color ${index}</span>
      </div>
    </div>
   <div class="value-wrapper hue-apply">
       <div class="value-wrapper__col">
           <button role="presentation" aria-label="GUI" type="button" class="HD"
               id="gradient-stop-position-up-${index}">&#9650;</button>
           <span data-readout="value" class="stop-position-value" id="gradient-stop-position-${index}"></span>
       </div>
       <div class="value-wrapper__col value-wrapper__col--line">
           <button role="presentation" aria-label="GUI" type="button" class="HD"
               id="gradient-stop-position-down-${index}">&#9660;</button>
           <span>position</span>
           <button role="presentation" aria-label="GUI" type="button" class="remove-button"
           data-to_remove_stop="${index}">&times;</button>
       </div>
   </div>
</div>`.replace(/\s\s+/g, ' ');
  }

  function eventsForColorStop(val, index) {
    let [color_val, position_val] = val.split(' ');
    var colorinput_stop_value = document.querySelector(`#gradient-stop-color_value-${index}`);
    var colorinput_stop = document.querySelector(`#gradient-stop-color-${index}`);
    var colorinput_stop_picker = new CP(colorinput_stop);

    var color_triangle = document.querySelector(`#gradient-stop-color-triangle-${index}`);
    var for_picker = color_val;
    colorinput_stop_value.innerText = for_picker.replace(/ /g, '').replace('rgba(', '').replace(')', '');
    colorinput_stop_picker.source.value = set_color_for_picker(for_picker);
    colorinput_stop.style.background = for_picker;
    colorinput_stop.setAttribute('data-stop-color', for_picker);
    color_triangle.style.fill = color2NoAlpha(for_picker);
    colorinput_stop_picker.set(set_color_for_picker(for_picker));
    apply_picker_elements(colorinput_stop_picker, 'gradient-stop-color');
    setTimeout(function () {
      colorinput_stop_picker.on('change', function (r, g, b, a) {
        if (!INPUTER1.value) {
          this.exit();
          return false;
        }
        INPUTER2.value = 'background';
        blockIframe();
        var color_value = this.color(r, g, b, a); // this is always rgb
        this.source.value = color_value;
        this.source.style.background = this.color(r, g, b, a);
        var color = tinycolor(color_value);
        color = color.toRgb();
        var forInput3 = "";
        forInput3 = 'rgba(' + (color.r.toString() || '0') + ', ' + (color.g.toString() || '0') + ', ' + (color.b.toString() || '0') + ', ' + (color.a.toFixed(2).toString() || '0') + ')';
        colorinput_stop_value.innerText = forInput3.replace(/ /g, '').replace('rgba(', '').replace(')', '');
        colorinput_stop_picker.source.value = set_color_for_picker(forInput3);
        colorinput_stop.style.background = forInput3;
        colorinput_stop.setAttribute('data-stop-color', forInput3);
        color_triangle.style.fill = color2NoAlpha(forInput3);
        var getVal = createGradientValue();
        INPUTER3.value = getVal;
        placeInHeadTempCSS_func(getVal);
      });

      colorinput_stop_picker.on('exit', function () {
        var getVal = createGradientValue();
        INPUTER3.value = getVal;
        if (INPUTER3.value) {
          clickAdder("units");
          placeInHeadTempCSS_func();
          FillUndo();
          FillValueReadouts();
        }
        setTimeout(function () {
          unblockIframe();
        }, 3);
      });
    }, 3);
    // position
    var colorinput_stop_position = document.querySelector(`#gradient-stop-position-${index}`);
    colorinput_stop_position.innerText = position_val;
    draggerMaker(`gradient-stop-position-${index}`, 'background', "y");
    var pos_up = domID(`gradient-stop-position-up-${index}`);
    var pos_down = domID(`gradient-stop-position-down-${index}`);
    plusMinusBtnMakerGradient("plus", pos_up, colorinput_stop_position, '%', 0, 100);
    plusMinusBtnMakerGradient("minus", pos_down, colorinput_stop_position, '%', 0, 100);
    // remove stop
    var stop_remover = document.querySelector(`[data-to_remove_stop="${index}"]`);
    stop_remover.onclick = () => {
      var stop_wrap = document.querySelector(`#gradient-stop-${index}`);
      stop_wrap.remove();
      INPUTER2.value = 'background';
      setTimeout(function () {
        var getVal = createGradientValue();
        INPUTER3.value = getVal;
        clickAdder("units");
      }, 50);
      setTimeout(function () {
        placeInHeadTempCSS_func();
        FillUndo();
        FillValueReadouts();
      }, 100);
    };
  }


  function plusMinusBtnMakerGradient(PlusOrMinus, btn, readout, units, min, max) {
    var timepressed;
    var deleypress;
    btn.onmousedown = function () {
      if (!INPUTER1.value) {
        return false;
      }
      var theValue = Number(
        readout.textContent.replace(theValREGEX, "")
      );

      function incPlusOrMinus() {
        switch (PlusOrMinus) {
          case "plus":
            if (theValue < max) {
              theValue++;
            } else {
              theValue = max;
            }
            break;
          case "minus":
            if (theValue > min) {
              theValue--;
            } else {
              theValue = min;
            }
            break;
        }
      }

      function valMaker() {
        incPlusOrMinus();
      }

      function iter() {
        timepressed = setInterval(function () {
          INPUTER2.value = "background";
          valMaker();
          INPUTER3.value = createGradientValue();
          clickAdder('units');
          readout.textContent = theValue + units;
        }, 20);
        return false;
      }
      if (INPUTER1.value) {
        deleypress = setTimeout(iter, 200);
        INPUTER2.value = "background";
        valMaker();
        INPUTER3.value = createGradientValue();
        clickAdder('units');
        readout.textContent = theValue + units;
        // stops iter and timepressed functions
        btn.onmouseup = clearIter;
        btn.onmouseleave = clearIter;
      } // Increments on holding mousedown ends here.
      function clearIter() {
        clearInterval(timepressed);
        clearTimeout(deleypress);
        FillUndo();
        return false;
      }
    };
  }

  function createGradientValue() {
    var stoptype = select__gradient_type.value;
    var stopdeg = gradient_deg.innerText || '0';
    var stop_x = gradient_x.innerText || '50%';
    var stop_y = gradient_y.innerText || '50%';
    var datastops = [...document.querySelectorAll('[data-stop]')];
    var datastops_string = '';
    datastops.map((el) => {
      var colorpickerel = el.querySelector('.color-picker-source');
      var colorpickerel_val = colorpickerel.getAttribute('data-stop-color');
      var positionel = el.querySelector('.stop-position-value');
      var positionel_val = positionel.innerText;
      datastops_string += `, ${colorpickerel_val} ${positionel_val}`;
    });
    var type_of_grad;
    switch (stoptype) {
      case 'linear':
        type_of_grad = `linear-gradient(${stopdeg}deg${datastops_string})`;
        break;
      case 'radial':
        type_of_grad = `radial-gradient(circle at ${stop_x} ${stop_y}${datastops_string})`;
        break;
      case 'elliptical':
        type_of_grad = `radial-gradient(ellipse at ${stop_x} ${stop_y}${datastops_string})`;
        break;
      case 'conical':
        type_of_grad = `conic-gradient(from ${stopdeg}deg at ${stop_x} ${stop_y}${datastops_string})`;
        break;
    }
    return type_of_grad;
  }


  function setGrandientValues(value, input_colors) {
    var value_type = "";
    var value_deg = "";
    var value_x = "";
    var value_y = "";
    var disabled_style = 'display: none;';
    var disable_deg = "";
    var disable_x = "";
    var disable_y = "";
    var inner_values = "";
    colour_stops.innerHTML = '';
    if (!value) {
      select__gradient_type.value = value_type;
      select__gradient_type.style = input_colors;
      gradient_deg.innerText = value_deg;
      gradient_deg.style = input_colors;
      gradient_deg.parentElement.parentElement.style = disable_deg;
      gradient_x.innerText = value_x;
      gradient_x.style = input_colors;
      gradient_x.parentElement.parentElement.style = disable_x;
      gradient_y.innerText = value_y;
      gradient_y.style = input_colors;
      gradient_y.parentElement.parentElement.style = disable_y;
      return false;
    }

    inner_values = value.substring(value.indexOf('(') + 1, value.lastIndexOf(')'));
    inner_values = inner_values.split(/,(?![^(]*\))(?![^"']*["'](?:[^"']*["'][^"']*["'])*[^"']*$)/);

    // -----------------------------------------------------------------------------

    var total_stops = 0;

    if (value.indexOf('linear-gradient(') > -1) {
      value_type = 'linear';
      inner_values.map((val, index) => {
        val = val.trim();
        val = val.replace(/, /g, ',');
        if (val.indexOf('deg') > -1) {
          var deg = val.split('deg')[0];
          deg = deg.replace(/^\D+/g, '');
          value_deg = deg;
        } else {
          colour_stops.insertAdjacentHTML('beforeend', createColorStop(index));
          eventsForColorStop(val, index);
          total_stops = index;
        }
        disable_x = disabled_style;
        disable_y = disabled_style;
      });

    }

    // -----------------------------------------------------------------------------

    if (value.indexOf('conic-gradient(') > -1) {
      value_type = 'conical';
      inner_values.map((val, index) => {
        val = val.trim();
        val = val.replace(/, /g, ',');
        if (val.indexOf('deg') > -1) {
          var deg = val.split('deg')[0];
          deg = deg.replace(/^\D+/g, '');
          value_deg = deg;
        }
        if (val.indexOf('at') > -1) {
          var offsets = val.split('at')[1];
          offsets = offsets.trim();
          [value_x, value_y] = offsets.split(' ');
        } else {
          colour_stops.insertAdjacentHTML('beforeend', createColorStop(index));
          eventsForColorStop(val, index);
          total_stops = index;
        }
      });
    }

    // -----------------------------------------------------------------------------

    if (value.indexOf('radial-gradient(') > -1) {
      if (value.indexOf('circle') > -1) {
        value_type = 'radial';
        inner_values.map((val, index) => {
          val = val.trim();
          val = val.replace(/, /g, ',');
          if (val.indexOf('at') > -1) {
            var offsets = val.split('at')[1];
            offsets = offsets.trim();
            [value_x, value_y] = offsets.split(' ');
          } else {
            colour_stops.insertAdjacentHTML('beforeend', createColorStop(index));
            eventsForColorStop(val, index);
            total_stops = index;
          }
          disable_deg = disabled_style;
        });
      }
      if (value.indexOf('ellipse') > -1) {
        value_type = 'elliptical';
        inner_values.map((val, index) => {
          val = val.trim();
          val = val.replace(/, /g, ',');
          if (val.indexOf('at') > -1) {
            var offsets = val.split('at')[1];
            offsets = offsets.trim();
            [value_x, value_y] = offsets.split(' ');
          } else {
            colour_stops.insertAdjacentHTML('beforeend', createColorStop(index));
            eventsForColorStop(val, index);
            total_stops = index;
          }
          disable_deg = disabled_style;
        });
      }
    }

    var Buttons = /*HTML*/ `
    <div style="display: flex; gap: 5px;">
    <button role="presentation" style="width: 100%; margin: 10px 0 0; padding: 4px 10px 2px;" aria-label="GUI" type="button" class="HD" id="addNew-color-stop"><i class="material-icons">add</i>&nbsp;&nbsp;add stop</button>
    <button role="presentation" style="width: 100%; margin: 10px 0 0; padding: 4px 10px 2px;" aria-label="GUI" type="button" class="HD" id="remove-color-stops"><i class="material-icons">remove</i>&nbsp;&nbsp;remove all</button>
    </div>
    `;

    colour_stops.insertAdjacentHTML('beforeend', Buttons);

    var addNewButton_el = domID('addNew-color-stop');
    addNewButton_el.onclick = () => {
      INPUTER2.value = 'background';
      INPUTER3.value = frameID(domElement[0]).style['background'] || CSSstyles['background'];

      total_stops = total_stops + 1;
      colour_stops.insertAdjacentHTML('beforeend', createColorStop(total_stops));
      eventsForColorStop('rgba(0,0,0,1) 100%', total_stops);
      setTimeout(function () {
        var getVal = createGradientValue();
        INPUTER3.value = getVal;
        clickAdder("units");
      }, 0);
      setTimeout(function () {
        placeInHeadTempCSS_func();
        FillUndo();
        FillValueReadouts();
      }, 0);
    };


    var removecolorstops_el = domID('remove-color-stops');
    removecolorstops_el.onclick = () => {
      clickRemoveProp('background');
    };

    // -----------------------------------------------------------------------------
    select__gradient_type.value = value_type;
    select__gradient_type.style = input_colors;
    gradient_deg.innerText = value_deg;
    gradient_deg.style = input_colors;
    gradient_deg.parentElement.parentElement.style = disable_deg;
    gradient_x.innerText = value_x;
    gradient_x.style = input_colors;
    gradient_x.parentElement.parentElement.style = disable_x;
    gradient_y.innerText = value_y;
    gradient_y.style = input_colors;
    gradient_y.parentElement.parentElement.style = disable_y;
    plusMinusBtnMakerGradient("plus", domID('gradient-deg-up'), gradient_deg, '', 0, 360);
    plusMinusBtnMakerGradient("minus", domID('gradient-deg-down'), gradient_deg, '', 0, 360);
    plusMinusBtnMakerGradient("plus", domID('gradient-x-up'), gradient_x, '%', -500, 500);
    plusMinusBtnMakerGradient("minus", domID('gradient-x-down'), gradient_x, '%', -500, 500);
    plusMinusBtnMakerGradient("plus", domID('gradient-y-up'), gradient_y, '%', -500, 500);
    plusMinusBtnMakerGradient("minus", domID('gradient-y-down'), gradient_y, '%', -500, 500);
  }


  function get_filter_val(value, type_of_filter) {
    let filters_values = create_filters_obj(value) || [];
    let has_filter = false;
    filters_values.map(obj => {
      if (obj.property === type_of_filter) {
        has_filter = obj.value;
      }

    });
    return has_filter;
  }

  function set_filter_val(value, type_of_filter) {
    if (!value) return;
    if (!type_of_filter) return;
    if (!INPUTER1.value) return;
    if (INPUTER2.value !== 'filter') return;
    let val_to_set = '';
    let filters_values = create_filters_obj(INPUTER3.value) || [];
    let new_arr_of_filters = [];
    filters_values.map(obj => {
      if (obj.property === type_of_filter && obj.property === 'drop-shadow') {
        let val_x = document.querySelector(`#filter_drop-shadow-X_value`).innerText;
        let val_y = document.querySelector(`#filter_drop-shadow-Y_value`).innerText;
        let val_blur = document.querySelector(`#filter_drop-shadow-blur_value`).innerText;
        let val_color = document.querySelector(`#filter_drop-shadow-color_value`).innerText;
        val_to_set = `drop-shadow(${val_color} ${val_x} ${val_y} ${val_blur})`;
      } else if (obj.property === type_of_filter && obj.property !== 'drop-shadow') {
        val_to_set = `${type_of_filter}(${value})`;
      } else {
        val_to_set = `${obj.property}(${obj.value})`;
      }
      new_arr_of_filters.push(val_to_set);
    });
    INPUTER3.value = new_arr_of_filters.join(' ');
  }

  function delete_filter_val(type_of_filter) {
    if (!type_of_filter) return;
    if (!INPUTER1.value) return;
    INPUTER2.value = 'filter';
    INPUTER3.value = frameID(domElement[0]).style['filter'] || CSSstyles['filter'];
    let filters_values = create_filters_obj(INPUTER3.value) || [];
    let new_arr_of_filters = [];
    filters_values.map(obj => {
      let val_to_set = `${obj.property}(${obj.value})`;
      if (obj.property !== type_of_filter) {
        new_arr_of_filters.push(val_to_set);
      }
    });
    INPUTER3.value = new_arr_of_filters.join(' ');
    if (!INPUTER3.value) {
      clickRemoveProp(false);
    } else {
      clickAdder('units');
    }
    FillValueReadouts();
    FillUndo();
  }

  function filter_color_input(value) {
    let color_val = value;
    let drop_shad_value = domID('filter_drop-shadow-color_value');
    let drop_shad_picker = domID('filter_drop-shadow-color');
    let drop_shad_picker_triangle = domID('filter_drop-shadow-color-triangle');
    var colorinput_drop_shad_picker = new CP(drop_shad_picker);
    apply_picker_elements(colorinput_drop_shad_picker, 'filter_drop-shadow-color');
    var for_picker = color_val;
    colorinput_drop_shad_picker.source.value = set_color_for_picker(for_picker);
    drop_shad_picker.style.background = for_picker;
    drop_shad_picker.setAttribute('data-stop-color', for_picker);
    drop_shad_picker_triangle.style.fill = color2NoAlpha(for_picker);
    colorinput_drop_shad_picker.set(set_color_for_picker(for_picker));
    setTimeout(function () {
      colorinput_drop_shad_picker.on('change', function (r, g, b, a) {
        if (!INPUTER1.value) {
          this.exit();
          return false;
        }
        INPUTER2.value = 'filter';
        INPUTER3.value = frameID(domElement[0]).style['filter'] || CSSstyles['filter'];
        blockIframe();
        var color_value = this.color(r, g, b, a); // this is always rgb
        this.source.value = color_value;
        this.source.style.background = this.color(r, g, b, a);
        var color = tinycolor(color_value);
        color = color.toRgb();
        var forInput3 = "";
        forInput3 = 'rgba(' + (color.r.toString() || '0') + ', ' + (color.g.toString() || '0') + ', ' + (color.b.toString() || '0') + ', ' + (color.a.toFixed(2).toString() || '0') + ')';
        colorinput_drop_shad_picker.source.value = set_color_for_picker(forInput3);
        drop_shad_picker.style.background = forInput3;
        drop_shad_picker.setAttribute('data-stop-color', forInput3);
        drop_shad_picker_triangle.style.fill = color2NoAlpha(forInput3);
        drop_shad_value.innerText = color2hex(forInput3);
        set_filter_val(color2hex(forInput3), 'drop-shadow');
        placeInHeadTempCSS_func(INPUTER3.value);
      });
      colorinput_drop_shad_picker.on('exit', function () {
        if (INPUTER3.value) {
          clickAdder("units");
          placeInHeadTempCSS_func();
          FillUndo();
          FillValueReadouts();
        }
        setTimeout(function () {
          unblockIframe();
        }, 3);
      });
    }, 3);
  }

  function plusMinusBtnMakerFilter(type_of_filter, PlusOrMinus, btn, readout, units, min, max, drop_shad_val) {
    var timepressed;
    var deleypress;
    btn.onmousedown = function () {
      if (!INPUTER1.value) return false;
      INPUTER2.value = 'filter';
      INPUTER3.value = frameID(domElement[0]).style['filter'] || CSSstyles['filter'];
      var theValue = Number(
        readout.textContent.replace(theValREGEX, "")
      );

      function incPlusOrMinus() {
        switch (PlusOrMinus) {
          case "plus":
            if (Number(theValue) < Number(max)) {
              theValue++;
            } else {
              theValue = Number(max);
            }
            break;
          case "minus":
            if (Number(theValue) > Number(min)) {
              theValue--;
            } else {
              theValue = Number(min);
            }
            break;
        }
      }

      function valMaker() {
        incPlusOrMinus();
      }

      function iter() {
        timepressed = setInterval(function () {
          INPUTER2.value = "filter";
          valMaker();
          set_filter_val(theValue + units, type_of_filter);
          placeInHeadTempCSS_func(INPUTER3.value);
          readout.textContent = theValue + units;
          BoxRefresh();
        }, 20);
        return false;
      }
      if (INPUTER1.value) {
        deleypress = setTimeout(iter, 200);
        INPUTER2.value = "filter";
        valMaker();
        set_filter_val(theValue + units, type_of_filter);
        placeInHeadTempCSS_func(INPUTER3.value);
        readout.textContent = theValue + units;
        // stops iter and timepressed functions
        btn.onmouseup = clearIter;
        btn.onmouseleave = clearIter;
      } // Increments on holding mousedown ends here.
      function clearIter() {
        if (type_of_filter === 'drop-shadow') {
          INPUTER2.value = "filter";
          valMaker();
          //console.log(type_of_filter);
          set_filter_val(theValue + units, type_of_filter);
          readout.textContent = theValue + units;
        }
        clearInterval(timepressed);
        clearTimeout(deleypress);
        clickAdder('increment');
        FillUndo();
        placeInHeadTempCSS_func();
        FillValueReadouts();
        return false;
      }
    };
  }



  function create_filters_obj(val) {
    let theFilter = val; //get the value of the filter
    // the array of all the filters in css
    let filters = [
      "blur",
      "brightness",
      "contrast",
      "drop-shadow",
      "grayscale",
      "hue-rotate",
      "invert",
      "opacity",
      "saturate",
      "sepia",
      "url"
    ];
    // an empty array 
    let ry = [];
    filters.forEach((f, i) => {
      let oF = theFilter.match(f);
      if (oF) {
        ry.push({
          prop: oF[0],
          index: oF.index
        });
      }
    });
    // ry is the array of the filters and the position in theFilter string [{prop: "brightness", index: 0},{prop: "contrast", index: 17}...
    function compareNumbers(a, b) {
      return a.index - b.index;
    }
    // order the ry array by index
    let sortedry = ry.sort(compareNumbers);
    // the object with the filters
    let oFilters = {};
    let for_retrun = [];
    for (let i = 0; i < sortedry.length; i++) {
      let sbstr = (i + 1 < sortedry.length) ? theFilter.substring(sortedry[i].index, sortedry[i + 1].index).trim() : theFilter.substring(sortedry[i].index).trim();
      let value = sbstr.substring(sbstr.indexOf("(") + 1, sbstr.length - 1);
      oFilters[sortedry[i].prop] = value;
      let obj_to_push = {
        property: sortedry[i].prop,
        value: value
      };
      for_retrun.push(obj_to_push);
    }
    return for_retrun;
  }


  function setFilterValues(value, input_colors) {
    // blur(10px) contrast(2) drop-shadow(10px 15px 7px #000000)
    filters_render.innerHTML = "";
    INPUTER2.value = '';
    INPUTER3.value = '';
    value = frameID(domElement[0]).style["filter"] || CSSstyles['filter'];
    if (!value) return;
    INPUTER2.value = 'filter';
    INPUTER3.value = frameID(domElement[0]).style["filter"] || CSSstyles['filter'];
    let filters_values = create_filters_obj(value) || [];
    let filters_order = [];
    let filter_template = '';
    filters_values.map(filter => {
      filters_order.push(filter.property);
      if (filter.property === 'drop-shadow') {
        filter_template += /*HTML*/ `
        <span class="property-title" style="margin-top: 8px;">drop shadow:</span>
        <div class="value-wrapper__row">
            <div class="value-wrapper hue-apply">
                <div class="value-wrapper__col">
                    <button role="presentation" aria-label="GUI" type="button" class="HD"
                        id="filter_drop-shadow-X-up">&#9650;</button>
                    <span data-readout="value" id="filter_drop-shadow-X_value"></span>
                </div>
                <div class="value-wrapper__col value-wrapper__col--line">
                    <button role="presentation" aria-label="GUI" type="button" class="HD"
                        id="filter_drop-shadow-X-down">&#9660;</button>
                    <span>X</span>
                </div>
            </div>
            <div class="value-wrapper hue-apply">
              <div class="value-wrapper__col">
                  <button role="presentation" aria-label="GUI" type="button" class="HD"
                      id="filter_drop-shadow-Y-up">&#9650;</button>
                  <span data-readout="value" id="filter_drop-shadow-Y_value"></span>
              </div>
              <div class="value-wrapper__col value-wrapper__col--line">
                  <button role="presentation" aria-label="GUI" type="button" class="HD"
                      id="filter_drop-shadow-Y-down">&#9660;</button>
                  <span>Y</span>
              </div>
          </div>
        </div>
        <div class="value-wrapper__row">
            <div class="value-wrapper hue-apply">
                <div class="value-wrapper__col">
                    <button role="presentation" aria-label="GUI" type="button" class="HD"
                        id="filter_drop-shadow-blur-up">&#9650;</button>
                    <span data-readout="value" id="filter_drop-shadow-blur_value"></span>
                </div>
                <div class="value-wrapper__col value-wrapper__col--line">
                    <button role="presentation" aria-label="GUI" type="button" class="HD"
                        id="filter_drop-shadow-blur-down">&#9660;</button>
                    <span>blur</span>
                </div>
            </div>
            <div class="value-wrapper">
                <div class="value-wrapper__col">
                    <div class="value-wrapper__colorpick">
                        <svg id="filter_drop-shadow-color-triangle" class="color-triangle"
                            xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                            <path
                                d="M 0.03,10.00 C 0.03,10.00 10.00,19.97 10.00,19.97 10.00,19.97 0.06,20.00 0.06,20.00" />
                        </svg>
                        <div id="filter_drop-shadow-color"></div>
                    </div>
                    <span id="filter_drop-shadow-color_value" class="hue-apply"></span>
                </div>
                <div class="value-wrapper__col value-wrapper__col--line hue-apply">
                    <span>color</span>
                    <button role="presentation" aria-label="GUI" type="button" class="remove-button"
                    data-to_remove_filter="drop-shadow">&times;</button>
                </div>
            </div>
        </div>
        `.replace(/\s\s+/g, ' ');
      } else {
        filter_template += /*HTML*/ `
      <div class="value-wrapper__row">
          <div class="value-wrapper hue-apply">
              <div class="value-wrapper__col">
                  <button role="presentation" aria-label="GUI" type="button" class="HD"
                      id="filter_${filter.property}-up">&#9650;</button>
                  <span data-readout="value" id="filter_${filter.property}_value"></span>
              </div>
              <div class="value-wrapper__col value-wrapper__col--line">
                  <button role="presentation" aria-label="GUI" type="button" class="HD"
                      id="filter_${filter.property}-down">&#9660;</button>
                  <span>${filter.property}</span>
                  <button role="presentation" aria-label="GUI" type="button" class="remove-button"
                      data-to_remove_filter="${filter.property}">&times;</button>
              </div>
          </div>
      </div>
        `.replace(/\s\s+/g, ' ');
      }
    });

    filters_render.innerHTML = filter_template;
    filters_values.map(filter => {
      if (filter.property === 'drop-shadow') {

        let drop_show_vals_color;
        let drop_shad_val = filter.value.replaceAll(', ', ',');
        drop_shad_val = drop_shad_val.split(' ');

        let color_at_index;
        drop_shad_val.map((val, i) => {
          if (val.indexOf('hsl') > -1 || val.indexOf('rgb') > -1 || val.indexOf('#') > -1) {
            color_at_index = i;
          }
        });

        drop_show_vals_color = drop_shad_val[color_at_index];
        if (color_at_index === 0) {
          document.querySelector(`#filter_drop-shadow-X_value`).innerText = drop_shad_val[1];
          document.querySelector(`#filter_drop-shadow-Y_value`).innerText = drop_shad_val[2];
          document.querySelector(`#filter_drop-shadow-blur_value`).innerText = drop_shad_val[3];
          document.querySelector(`#filter_drop-shadow-color_value`).innerText = drop_shad_val[0];
        } else {
          document.querySelector(`#filter_drop-shadow-X_value`).innerText = drop_shad_val[0];
          document.querySelector(`#filter_drop-shadow-Y_value`).innerText = drop_shad_val[1];
          document.querySelector(`#filter_drop-shadow-blur_value`).innerText = drop_shad_val[2];
          document.querySelector(`#filter_drop-shadow-color_value`).innerText = drop_shad_val[3];
        }

        document.querySelector(`#filter_drop-shadow-X_value`).style = input_colors;
        document.querySelector(`#filter_drop-shadow-Y_value`).style = input_colors;
        document.querySelector(`#filter_drop-shadow-blur_value`).style = input_colors;
        document.querySelector(`#filter_drop-shadow-color_value`).style = input_colors;

        plusMinusBtnMakerFilter(
          filter.property,
          "plus",
          domID(`filter_drop-shadow-X-up`),
          domID(`filter_drop-shadow-X_value`),
          'px',
          '-999999',
          '999999',
          'drop-shadow-X'
        );
        plusMinusBtnMakerFilter(
          filter.property,
          "minus",
          domID(`filter_drop-shadow-X-down`),
          domID(`filter_drop-shadow-X_value`),
          'px',
          '-999999',
          '999999',
          'drop-shadow-X'
        );
        plusMinusBtnMakerFilter(
          filter.property,
          "plus",
          domID(`filter_drop-shadow-Y-up`),
          domID(`filter_drop-shadow-Y_value`),
          'px',
          '-999999',
          '999999',
          'drop-shadow-Y'
        );
        plusMinusBtnMakerFilter(
          filter.property,
          "minus",
          domID(`filter_drop-shadow-Y-down`),
          domID(`filter_drop-shadow-Y_value`),
          'px',
          '-999999',
          '999999',
          'drop-shadow-Y'
        );
        plusMinusBtnMakerFilter(
          filter.property,
          "plus",
          domID(`filter_drop-shadow-blur-up`),
          domID(`filter_drop-shadow-blur_value`),
          'px',
          '0',
          '999999',
          'drop-shadow-blur'
        );
        plusMinusBtnMakerFilter(
          filter.property,
          "minus",
          domID(`filter_drop-shadow-blur-down`),
          domID(`filter_drop-shadow-blur_value`),
          'px',
          '0',
          '999999',
          'drop-shadow-blur'
        );
        draggerMaker(`filter_drop-shadow-X_value`, 'filter', "y");
        draggerMaker(`filter_drop-shadow-Y_value`, 'filter', "y");
        draggerMaker(`filter_drop-shadow-blur_value`, 'filter', "y");
        filter_color_input(drop_show_vals_color);

        document.querySelector(`[data-to_remove_filter="drop-shadow"]`).onclick = () => {
          delete_filter_val("drop-shadow");
        };

      } else {
        document.querySelector(`#filter_${filter.property}_value`).innerText = filter.value;
        document.querySelector(`#filter_${filter.property}_value`).style = input_colors;
        document.querySelector(`[data-to_remove_filter="${filter.property}"]`).onclick = () => {
          delete_filter_val(filter.property);
        };
        var unit_type = '';
        var unit_min = '0';
        var unit_max = '100';
        switch (filter.property) {
          case 'blur':
            unit_type = 'px';
            unit_max = '10000';
            break;
          case 'hue-rotate':
            unit_type = 'deg';
            unit_max = '360';
            break;
          case 'grayscale':
          case 'invert':
          case 'opacity':
          case 'sepia':
            unit_type = '%';
            unit_max = '100';
            break;
          case 'brightness':
          case 'contrast':
          case 'saturate':
            unit_type = '%';
            unit_max = '10000';
            break;
        }
        plusMinusBtnMakerFilter(
          filter.property,
          "plus",
          domID(`filter_${filter.property}-up`),
          domID(`filter_${filter.property}_value`),
          unit_type,
          unit_min,
          unit_max
        );
        plusMinusBtnMakerFilter(
          filter.property,
          "minus",
          domID(`filter_${filter.property}-down`),
          domID(`filter_${filter.property}_value`),
          unit_type,
          unit_min,
          unit_max
        );
        draggerMaker(`filter_${filter.property}_value`, 'filter', "y");
      }
    });

    // disable already added filters in options
    [...select_filter.options].map((option) => {
      option.removeAttribute('disabled');
      if (filters_order.indexOf(option.value) > -1) {
        option.setAttribute('disabled', true);
      }
    });
  }

  let default_filter_vals = {
    "blur": "0px", // px
    "brightness": "100%", // %
    "contrast": "100%", //%
    "drop-shadow": "0px 0px 0px #000000", // multiple
    "grayscale": "0%", // %
    "hue-rotate": "0deg", // deg
    "invert": "0%", // %
    "opacity": "100%", // %
    "saturate": "100%", // %
    "sepia": "0%", // %
  };

  const select_filter = domID('select__filter-type');
  select_filter.onchange = () => {
    add_filter_type();
  };

  function add_filter_type() {
    if (!INPUTER1.value) return;
    INPUTER2.value = 'filter';

    if (frameID(domElement[0]).style['filter']) {
      INPUTER3.value = frameID(domElement[0]).style['filter'];
    } else if (CSSstyles['filter']) {
      INPUTER3.value = CSSstyles['filter'];
    } else {
      INPUTER3.value = "";
    }
    let selected_filter = select_filter.options[select_filter.selectedIndex].value;
    let has_filter = get_filter_val(INPUTER3.value, selected_filter);
    if (!has_filter && selected_filter !== 'no-filter') {
      INPUTER3.value = INPUTER3.value + ` ${selected_filter}(${default_filter_vals[selected_filter]})`;
      INPUTER3.value = INPUTER3.value.trim();
      clickAdder('units');
      FillValueReadouts();
      FillUndo();
      select_filter.selectedIndex = 0;
    }
  }




  //----------------------------------------------------------------------------------------------
  // FillValueReadouts

  var FillValueReadouts_input1;

  function FillValueReadouts() {

    domID('page-name').textContent = `(${page_name}.html)`;
    create_pages_elements();

    if (domElement[0] !== 'classcss') {
      let el = frameID(domElement[0]);
      if (!el) {
        return false;
      }
      let id_val = '';
      if (el.id && el.id.length !== 11 && !el.id.includes("ID-")) {
        id_val = `#${el.id}`;
      }
      domID('selector-name').textContent = `(${el.tagName.toLowerCase()}${id_val}${el.classList.length ? '.' + [...el.classList].join('.') : ''})`;
    } else {
      domID('selector-name').textContent = ``;
    }

    // if (document.getElementById("right-sections").style.getPropertyValue('display')) {
    //   return false;
    // }

    var input1 = INPUTER1.value;
    var css_active_btn;
    if (window.localStorage.getItem('active-tab-css')) {
      css_active_btn = window.localStorage.getItem('active-tab-css');
    }

    var allinnertabs = [...document.querySelectorAll('.sectionInnerWrap')];

    if (input1) {
      allinnertabs.map(el => {
        el.classList.remove('sectionInnerWrap_disable-edit');
        el.title = "";
      });
      [...document.querySelectorAll('[data-media-inherit]')].map((el) => {
        el.setAttribute('data-media-inherit', '');
      });
      [].forEach.call(pseudo_select_options, function (el) {
        el.removeAttribute('selected');
      });
      var has_pseudo = checkIfPseudo(input1);
      pseudo_select.value = has_pseudo;
      PseudoState = has_pseudo;
      if (has_pseudo) {
        pseudo_select.querySelector('[value="' + has_pseudo + '"]').setAttribute('selected', true);
        // pseudo_select.value = has_pseudo;
        // pseudo_select.dispatchEvent(new Event('change'));
      }
      let inputter_1_val_without_pseudo = INPUTER1.value.replaceAll(':' + has_pseudo, '');
      let found_els = frameSelectorAll(inputter_1_val_without_pseudo) || [];
      NUMBEROFELSFORSELECTOR.innerHTML = `targets: <i style="color: var(--button-text)">${found_els.length}</i>`;

      [...select_filter.options].map((option) => {
        option.removeAttribute('disabled');
      });

      cssStylesBreakPoints();
      FillValueReadouts_input1 = input1;
      checkOtherMediaValsInputVal = input1;

      var frame_style = frameID(domElement[0]).style;

      // color & opacity
      if (css_active_btn === 'colorsButton') {
        setValueInnerHTML(opacityValue, "opacity");
        setInputValue(colorValue_input, "color");
        setInputValue(backgroundColorValue_input, "background-color");
      }

      //===============================================================================//
      // position
      if (css_active_btn === 'positionButton') {
        setSelectValue("position");
        setValueInnerHTML(leftValue, "left");
        setValueInnerHTML(topValue, "top");
        setValueInnerHTML(rightValue, "right");
        setValueInnerHTML(bottomValue, "bottom");
      }

      //===============================================================================//
      // display
      else if (css_active_btn === 'displayButton') {
        setSelectValue("display");
      }

      //===============================================================================//
      // flexbox
      else if (css_active_btn === 'flexboxButton') {
        removeSelectValue("align-content");
        removeSelectValue("justify-content");
        removeSelectValue("align-items");
        removeSelectValue("align-self");
        setSelectValue("flex-direction");
        setFlexDirections("row");
        flexDirectionRow.style = buttonBGColor;
        flexDirectionRowReverse.style = buttonBGColor;
        flexDirectionColumn.style = buttonBGColor;
        flexDirectionColumnReverse.style = buttonBGColor;
        setSelectValue("flex-wrap");
        if (frame_style["display"] === "flex") {
          setSelectValue("align-content");
          setSelectValue("justify-content");
          setSelectValue("align-items");
        } else if (CSSstyles["display"] === "flex") {
          setSelectValue("align-content");
          setSelectValue("justify-content");
          setSelectValue("align-items");
        } else if (getInheritedStyle("display").style === "flex") {
          setSelectValue("align-content");
          setSelectValue("justify-content");
          setSelectValue("align-items");
        }
        setInputValue(flexOrder, "order");
        setInputValue(flexGrow, "flex-grow");
        setInputValue(flexShrink, "flex-shrink");
        setInputValue(flexBasis, "flex-basis");
        // flexbox

        if (parent_display_prop() === 'grid') {
          setSelectValue("align-self", "#select__align-self_grid");
        } else if (parent_display_prop() === 'flex') {
          setSelectValue("align-self");
        }

        let flex_direction = frame_style["flex-direction"] || CSSstyles["flex-direction"];

        switch (flex_direction) {
          case "row":
            flexDirectionRow.style = buttonHLColor;
            setFlexDirections("row");
            break;
          case "row-reverse":
            flexDirectionRowReverse.style = buttonHLColor;
            setFlexDirections("row-reverse");
            break;
          case "column":
            flexDirectionColumn.style = buttonHLColor;
            setFlexDirections("column");
            break;
          case "column-reverse":
            flexDirectionColumnReverse.style = buttonHLColor;
            setFlexDirections("column-reverse");
            break;
          default:
            switch (getInheritedStyle("flex-direction").style) {
              case "row":
                flexDirectionRow.style = buttonHLColor_faded;
                setFlexDirections("row");
                break;
              case "row-reverse":
                flexDirectionRowReverse.style = buttonHLColor_faded;
                setFlexDirections("row-reverse");
                break;
              case "column":
                flexDirectionColumn.style = buttonHLColor_faded;
                setFlexDirections("column");
                break;
              case "column-reverse":
                flexDirectionColumnReverse.style = buttonHLColor_faded;
                setFlexDirections("column-reverse");
                break;
            }
            break;
        }
      }





      //===============================================================================//
      // grid
      else if (css_active_btn === 'gridButton') {
        removeSelectValue("justify-items", "#select__justify-items_grid"); // not in flex
        removeSelectValue("align-items", "#select__align-items_grid");
        removeSelectValue("align-content", "#select__align-content_grid");
        removeSelectValue("justify-content", "#select__justify-content_grid");
        removeSelectValue("align-self", "#select__align-self_grid");
        setValueInnerHTML(gridRowStartValue, "grid-row-start");
        setValueInnerHTML(gridRowEndValue, "grid-row-end");
        setValueInnerHTML(gridColumnStartValue, "grid-column-start");
        setValueInnerHTML(gridColumnEndValue, "grid-column-end");
        if (frame_style["display"] === "grid") {
          setSelectValue("justify-items", "#select__justify-items_grid"); // not in flex
          setSelectValue("align-items", "#select__align-items_grid");
          setSelectValue("align-content", "#select__align-content_grid");
          setSelectValue("justify-content", "#select__justify-content_grid");
        } else if (CSSstyles["display"] === "grid") {
          setSelectValue("justify-items", "#select__justify-items_grid"); // not in flex
          setSelectValue("align-items", "#select__align-items_grid");
          setSelectValue("align-content", "#select__align-content_grid");
          setSelectValue("justify-content", "#select__justify-content_grid");
        } else if (getInheritedStyle("display").style === "grid") {
          setSelectValue("justify-items", "#select__justify-items_grid"); // not in flex
          setSelectValue("align-items", "#select__align-items_grid");
          setSelectValue("align-content", "#select__align-content_grid");
          setSelectValue("justify-content", "#select__justify-content_grid");
        }
        setSelectValue("grid-auto-flow");
        setSelectValue("justify-self");
        if (parent_display_prop() === 'grid') {
          setSelectValue("align-self", "#select__align-self_grid");
        } else if (parent_display_prop() === 'flex') {
          setSelectValue("align-self");
        }


        if (frame_style["grid-template-columns"]) {
          setGridInputs(
            'grid-template-columns',
            'grid_template_columns',
            'template column',
            'column',
            frame_style["grid-template-columns"],
            "color: var(--mainColor)"
          );
        } else if (CSSstyles["grid-template-columns"]) {
          setGridInputs(
            'grid-template-columns',
            'grid_template_columns',
            'template column',
            'column',
            CSSstyles["grid-template-columns"],
            "color: var(--mainColor)"
          );
        } else if (getInheritedStyle("grid-template-columns").style) {
          setGridInputs(
            'grid-template-columns',
            'grid_template_columns',
            'template column',
            'column',
            getInheritedStyle("grid-template-columns").style,
            "color: #777; opacity: 0.5");
        } else {
          setGridInputs(
            'grid-template-columns',
            'grid_template_columns',
            'template column',
            'column'
          );
        }

        if (frame_style["grid-template-rows"]) {
          setGridInputs(
            'grid-template-rows',
            'grid_template_rows',
            'template row',
            'row',
            frame_style["grid-template-rows"],
            "color: var(--mainColor)"
          );
        } else if (CSSstyles["grid-template-rows"]) {
          setGridInputs(
            'grid-template-rows',
            'grid_template_rows',
            'template row',
            'row',
            CSSstyles["grid-template-rows"],
            "color: var(--mainColor)"
          );
        } else if (getInheritedStyle("grid-template-rows").style) {
          setGridInputs(
            'grid-template-rows',
            'grid_template_rows',
            'template row',
            'row',
            getInheritedStyle("grid-template-rows").style,
            "color: #777; opacity: 0.5");
        } else {
          setGridInputs(
            'grid-template-rows',
            'grid_template_rows',
            'template row',
            'row'
          );
        }

        if (frame_style["grid-auto-columns"]) {
          setGridInputs(
            'grid-auto-columns',
            'grid_auto_columns',
            'auto column',
            'column',
            frame_style["grid-auto-columns"],
            "color: var(--mainColor)"
          );
        } else if (CSSstyles["grid-auto-columns"]) {
          setGridInputs(
            'grid-auto-columns',
            'grid_auto_columns',
            'auto column',
            'column',
            CSSstyles["grid-auto-columns"],
            "color: var(--mainColor)"
          );
        } else if (getInheritedStyle("grid-auto-columns").style) {
          setGridInputs(
            'grid-auto-columns',
            'grid_auto_columns',
            'auto column',
            'column',
            getInheritedStyle("grid-auto-columns").style,
            "color: #777; opacity: 0.5");
        } else {
          setGridInputs(
            'grid-auto-columns',
            'grid_auto_columns',
            'auto column',
            'column'
          );
        }

        if (frame_style["grid-auto-rows"]) {
          setGridInputs(
            'grid-auto-rows',
            'grid_auto_rows',
            'auto row',
            'row',
            frame_style["grid-auto-rows"],
            "color: var(--mainColor)"
          );
        } else if (CSSstyles["grid-auto-rows"]) {
          setGridInputs(
            'grid-auto-rows',
            'grid_auto_rows',
            'auto row',
            'row',
            CSSstyles["grid-auto-rows"],
            "color: var(--mainColor)"
          );
        } else if (getInheritedStyle("grid-auto-rows").style) {
          setGridInputs(
            'grid-auto-rows',
            'grid_auto_rows',
            'auto row',
            'row',
            getInheritedStyle("grid-auto-columns").style,
            "color: #777; opacity: 0.5");
        } else {
          setGridInputs(
            'grid-auto-rows',
            'grid_auto_rows',
            'auto row',
            'row'
          );
        }
      }




      //===============================================================================//
      // size
      else if (css_active_btn === 'sizeButton') {
        setValueInnerHTML(widthValue, "width");
        setValueInnerHTML(heightValue, "height");
        setValueInnerHTML(minWidthValue, "min-width");
        setValueInnerHTML(minHeightValue, "min-height");
        setValueInnerHTML(maxWidthValue, "max-width");
        setValueInnerHTML(maxHeightValue, "max-height");
        setSelectValue("object-fit");
      }


      //===============================================================================//
      // box





      // gap
      else if (css_active_btn === 'spacingButton') {
        if (frame_style["gap"]) {
          if (frame_style["gap"].indexOf(' ') > -1) {
            let [gapX, gapY] = frame_style["gap"].split(' ');
            gapValXReadout.textContent = gapX;
            gapValYReadout.textContent = gapY;
          } else {
            gapValXReadout.textContent = frame_style["gap"];
            gapValYReadout.textContent = frame_style["gap"];
          }
          gapValXReadout.style = "color: var(--mainColor)";
          gapValYReadout.style = "color: var(--mainColor)";
        } else if (CSSstyles["gap"]) {
          if (CSSstyles["gap"].indexOf(' ') > -1) {
            let [gapX, gapY] = CSSstyles["gap"].split(' ');
            gapValXReadout.textContent = gapX;
            gapValYReadout.textContent = gapY;
          } else {
            gapValXReadout.textContent = CSSstyles["gap"];
            gapValYReadout.textContent = CSSstyles["gap"];
          }
          gapValXReadout.style = "color: var(--mainColor)";
          gapValYReadout.style = "color: var(--mainColor)";
        } else if (getInheritedStyle("gap").style) {
          if (getInheritedStyle("gap").style.indexOf(' ') > -1) {
            let [gapX, gapY] = getInheritedStyle("gap").style.split(' ');
            gapValXReadout.textContent = gapX;
            gapValYReadout.textContent = gapY;
          } else {
            gapValXReadout.textContent = getInheritedStyle("gap").style;
            gapValYReadout.textContent = getInheritedStyle("gap").style;
          }
          gapValXReadout.style = "color: #777; opacity: 0.5";
          gapValYReadout.style = "color: #777; opacity: 0.5";
        } else {
          gapValXReadout.textContent = "";
          gapValYReadout.textContent = "";
          gapValXReadout.style = "color: #777; opacity: 0.5";
          gapValYReadout.style = "color: #777; opacity: 0.5";
        }
        // margins
        setValueInnerHTML(marginLeftValue, "margin-left");
        setValueInnerHTML(marginTopValue, "margin-top");
        setValueInnerHTML(marginRightValue, "margin-right");
        setValueInnerHTML(marginBottomValue, "margin-bottom");
        // paddings
        setValueInnerHTML(paddingTopValue, "padding-top");
        setValueInnerHTML(paddingLeftValue, "padding-left");
        setValueInnerHTML(paddingRightValue, "padding-right");
        setValueInnerHTML(paddingBottomValue, "padding-bottom");
        // box-sizing
        setSelectValue("box-sizing");
      }

      //===============================================================================//
      // border
      else if (css_active_btn === 'bordersButton') {
        setValueInnerHTML(borderLeftWidthValue, "border-left-width");
        setValueInnerHTML(borderTopWidthValue, "border-top-width");
        setValueInnerHTML(borderRightWidthValue, "border-right-width");
        setValueInnerHTML(borderBottomWidthValue, "border-bottom-width");
        // borders radius
        setValueInnerHTML(borderTopLeftRadiusValue, "border-top-left-radius");
        setValueInnerHTML(borderTopRightRadiusValue, "border-top-right-radius");
        setValueInnerHTML(borderBottomLeftRadiusValue, "border-bottom-left-radius");
        setValueInnerHTML(borderBottomRightRadiusValue, "border-bottom-right-radius");
        // borders colors

        let set_border_left_color = frame_style["border-left-color"] || CSSstyles["border-left-color"];
        let set_border_right_color = frame_style["border-right-color"] || CSSstyles["border-right-color"];
        let set_border_top_color = frame_style["border-top-color"] || CSSstyles["border-top-color"];
        let set_border_bottom_color = frame_style["border-bottom-color"] || CSSstyles["border-bottom-color"];


        if (set_border_left_color) {
          var border_left_for_picker = set_border_left_color;
          domID('border-left-color_value').innerText = border_left_for_picker.replace(/ /g, '').replace('rgba(', '').replace(')', '');
          colorinput_border_left.style.background = border_left_for_picker;
          colorinput_border_left_picker.source.value = set_color_for_picker(border_left_for_picker);
          border_left_color_triangle.style.fill = color2NoAlpha(border_left_for_picker);
        } else {
          domID('border-left-color_value').innerText = "";
          colorinput_border_left.style.background = null;
          colorinput_border_left_picker.source.value = null;
          border_left_color_triangle.style.fill = null;
        }


        if (set_border_right_color) {
          var border_right_for_picker = set_border_right_color;
          domID('border-right-color_value').innerText = border_right_for_picker.replace(/ /g, '').replace('rgba(', '').replace(')', '');
          colorinput_border_right.style.background = border_right_for_picker;
          colorinput_border_right_picker.source.value = set_color_for_picker(border_right_for_picker);
          border_right_color_triangle.style.fill = color2NoAlpha(border_right_for_picker);
        } else {
          domID('border-right-color_value').innerText = "";
          colorinput_border_right.style.background = null;
          colorinput_border_right_picker.source.value = null;
          border_right_color_triangle.style.fill = null;
        }


        if (set_border_top_color) {
          var border_top_for_picker = set_border_top_color;
          domID('border-top-color_value').innerText = border_top_for_picker.replace(/ /g, '').replace('rgba(', '').replace(')', '');
          colorinput_border_top.style.background = border_top_for_picker;
          colorinput_border_top_picker.source.value = set_color_for_picker(border_top_for_picker);
          border_top_color_triangle.style.fill = color2NoAlpha(border_top_for_picker);
        } else {
          domID('border-top-color_value').innerText = "";
          colorinput_border_top.style.background = null;
          colorinput_border_top_picker.source.value = null;
          border_top_color_triangle.style.fill = null;
        }


        if (set_border_bottom_color) {
          var border_bottom_for_picker = set_border_bottom_color;
          domID('border-bottom-color_value').innerText = border_bottom_for_picker.replace(/ /g, '').replace('rgba(', '').replace(')', '');
          colorinput_border_bottom.style.background = border_bottom_for_picker;
          colorinput_border_bottom_picker.source.value = set_color_for_picker(border_bottom_for_picker);
          border_bottom_color_triangle.style.fill = color2NoAlpha(border_bottom_for_picker);
        } else {
          domID('border-bottom-color_value').innerText = "";
          colorinput_border_bottom.style.background = null;
          colorinput_border_bottom_picker.source.value = null;
          border_bottom_color_triangle.style.fill = null;
        }
        // borders styles
        setSelectValue("border-left-style");
        setSelectValue("border-right-style");
        setSelectValue("border-top-style");
        setSelectValue("border-bottom-style");
      }

      //===============================================================================//
      // outline
      else if (css_active_btn === 'outlineButton') {
        setValueInnerHTML(outlineWidthValue, "outline-width");
        setValueInnerHTML(outlineOffsetValue, "outline-offset");
        setSelectValue("outline-style");
        let set_outline_color = frame_style["outline-color"] || CSSstyles["outline-color"];
        if (set_outline_color) {
          var outline_for_picker = set_outline_color;
          domID('outline-color_value').innerText = outline_for_picker.replace(/ /g, '').replace('rgba(', '').replace(')', '');
          colorinput_outline.style.background = outline_for_picker;
          colorinput_outline_picker.source.value = set_color_for_picker(outline_for_picker);
          outline_color_triangle.style.fill = color2NoAlpha(outline_for_picker);
        } else {
          domID('outline-color_value').innerText = "";
          colorinput_outline.style.background = null;
          colorinput_outline_picker.source.value = null;
          outline_color_triangle.style.fill = null;
        }
      }


      //===============================================================================//
      // overflow
      else if (css_active_btn === 'overflowButton') {
        setSelectValue("overflow-x");
        setSelectValue("overflow-y");
      }

      //===============================================================================//
      // float
      else if (css_active_btn === 'floatButton') {
        setSelectValue("float");
        setSelectValue("clear");
      }

      //===============================================================================//
      // z-index
      else if (css_active_btn === 'stackButton') {
        zindexValue.textContent = "";
        setValueInnerHTML(zindexValue, "z-index");
        zIndexAuto.style = buttonBGColor;
        zIndexInitial.style = buttonBGColor;
        zIndexInherit.style = buttonBGColor;
        let set_z_index = frame_style["z-index"] || CSSstyles["z-index"];
        switch (set_z_index) {
          case "auto":
            zIndexAuto.style = buttonHLColor;
            break;
          case "initial":
            zIndexInitial.style = buttonHLColor;
            break;
          case "inherit":
            zIndexInherit.style = buttonHLColor;
            break;
        }
      }

      //===============================================================================//
      // cursor
      else if (css_active_btn === 'cursorButton') {
        setSelectValue("cursor");
        let set_cursor = frame_style["cursor"] || CSSstyles["cursor"];
        if (set_cursor) {
          cursorTest.style.cursor = set_cursor;
        } else if (getInheritedStyle("cursor").style) {
          cursorTest.style.cursor = getInheritedStyle("cursor").style;
        } else {
          cursorTest.style.cursor = null;
        }
      }

      //===============================================================================//
      // font
      else if (css_active_btn === 'fontsButton') {
        setSelectValue("font-family");
        setSelectValue("font-weight");
        setSelectValue("font-style");
        setValueInnerHTML(fontFamilyInputer, "font-family", "");
        setValueInnerHTML(fontSizeValue, "font-size");
        setValueInnerHTML(letterSpacingValue, "letter-spacing");
        setValueInnerHTML(lineHeightValue, "line-height");
      }

      //===============================================================================//
      // text
      else if (css_active_btn === 'textButton') {
        setSelectValue("text-align");
        setSelectValue("text-align-last");
        setSelectValue("text-transform");
        setSelectValue("text-decoration-line");
        setSelectValue("direction");
        setSelectValue("unicode-bidi");
        setSelectValue("vertical-align");
        setSelectValue("text-decoration-style");
        setValueInnerHTML(textDecorationThicknessValue, "text-decoration-thickness");

        let set_text_decoration_color = frame_style["text-decoration-color"] || CSSstyles["text-decoration-color"];
        if (set_text_decoration_color) {
          var textdecorationcolor_for_picker = set_text_decoration_color;
          domID('text-decoration-color_value').innerText = textdecorationcolor_for_picker.replace(/ /g, '').replace('rgba(', '').replace(')', '');
          colorinput_textdecorationcolor.style.background = textdecorationcolor_for_picker;
          colorinput_textdecorationcolor_picker.source.value = set_color_for_picker(textdecorationcolor_for_picker);
          textdecorationcolor_color_triangle.style.fill = color2NoAlpha(textdecorationcolor_for_picker);
        } else {
          domID('text-decoration-color_value').innerText = "";
          colorinput_textdecorationcolor.style.background = null;
          colorinput_textdecorationcolor_picker.source.value = null;
          textdecorationcolor_color_triangle.style.fill = null;
        }
      }

      //===============================================================================//
      // list
      else if (css_active_btn === 'listButton') {
        setSelectValue("list-style-type");
        setSelectValue("list-style-position");
        setSelectValue("list-style-image");
      }

      //===============================================================================//
      // background image
      else if (css_active_btn === 'backgroundButton') {
        setSelectValue("background-image");
        setSelectValue("background-repeat");
        setSelectValue("background-size");
        setSelectValue("background-position-x");
        setSelectValue("background-position-y");
        setSelectValue("background-attachment");
        setSelectValue("background-blend-mode");
        setSelectValue("background-origin");
        setSelectValue("background-clip");
      }

      //===============================================================================//
      // background gradient
      else if (css_active_btn === 'gradientButton') {
        let set_background = frame_style["background"] || CSSstyles["background"];
        if (set_background) {
          setGrandientValues(set_background, "color: var(--mainColor)");
        } else if (getInheritedStyle("background").style) {
          setGrandientValues(getInheritedStyle("background").style, "color: #777; opacity: 0.5");
        } else {
          setGrandientValues(null, null);
        }
      }

      //===============================================================================//
      // background gradient
      else if (css_active_btn === 'filtersButton') {
        let set_filter = frame_style["filter"] || CSSstyles["filter"];
        if (set_filter) {
          setFilterValues(set_filter, "color: var(--mainColor)");
        } else if (getInheritedStyle("filter").style) {
          setFilterValues(getInheritedStyle("filter").style, "color: #777; opacity: 0.5");
        } else {
          setFilterValues(null, null);
        }
      }
      //===============================================================================//
      // transform
      else if (css_active_btn === 'transformButton') {
        getTransformValues();
        setTransformValues();
      }

      // draggers need to go outside css_active_btn
      // margins dragger
      setValueInnerHTML(marginTopValue_dragger, "margin-top");
      setValueInnerHTML(marginLeftValue_dragger, "margin-left");
      setValueInnerHTML(marginRightValue_dragger, "margin-right");
      setValueInnerHTML(marginBottomValue_dragger, "margin-bottom");
      // paddings dragger
      setValueInnerHTML(paddingTopValue_dragger, "padding-top");
      setValueInnerHTML(paddingLeftValue_dragger, "padding-left");
      setValueInnerHTML(paddingRightValue_dragger, "padding-right");
      setValueInnerHTML(paddingBottomValue_dragger, "padding-bottom");
      // borders dragger
      setValueInnerHTML(borderTopWidthValue_dragger, "border-top-width");
      setValueInnerHTML(borderLeftWidthValue_dragger, "border-left-width");
      setValueInnerHTML(borderRightWidthValue_dragger, "border-right-width");
      setValueInnerHTML(borderBottomWidthValue_dragger, "border-bottom-width");
      // border radius dragger
      setValueInnerHTML(borderTopLeftRadiusValue_dragger, "border-top-left-radius");
      setValueInnerHTML(borderTopRightRadiusValue_dragger, "border-top-right-radius");
      setValueInnerHTML(borderBottomLeftRadiusValue_dragger, "border-bottom-left-radius");
      setValueInnerHTML(borderBottomRightRadiusValue_dragger, "border-bottom-right-radius");

      setColorsOnColorInputs();
      setSelectDropdowns();
      add_clicks_to_value_wrappers();
    } else {
      allinnertabs.map(el => {
        el.classList.add('sectionInnerWrap_disable-edit');
        el.title = "no css selector specified";
      });
      NUMBEROFELSFORSELECTOR.innerHTML = '';
      zIndexAuto.style = buttonBGColor;
      zIndexInitial.style = buttonBGColor;
      zIndexInherit.style = buttonBGColor;
      flexDirectionRow.style = buttonBGColor;
      flexDirectionRowReverse.style = buttonBGColor;
      flexDirectionColumn.style = buttonBGColor;
      flexDirectionColumnReverse.style = buttonBGColor;
      currentShad1.style = buttonBGColor;
      currentShad2.style = buttonBGColor;
      currentShad3.style = buttonBGColor;
      currentShad4.style = buttonBGColor;
      boxShadowInset.style = '';
      currentShad1Text.style = buttonBGColor;
      currentShad2Text.style = buttonBGColor;
      currentShad3Text.style = buttonBGColor;
      currentShad4Text.style = buttonBGColor;

      [...document.querySelectorAll('[data-media-inherit]')].map((el) => {
        el.setAttribute('data-media-inherit', '');
      });
      [...document.querySelectorAll('[data-wrapper-active]')].map((el) => {
        el.setAttribute('data-wrapper-active', 'false');
      });
      [...document.querySelectorAll('#maincontainerRight .value-wrapper__col span')].map((el) => {
        if (el.id) {
          el.innerHTML = "";
        }
      });
      [...document.querySelectorAll('#maincontainerRight .value-wrapper__col input')].map((el) => {
        if (el.id) {
          el.value = "";
        }
      });
      [...document.querySelectorAll('#maincontainerRight .value-wrapper__col .color-triangle, #maincontainerRight .value-wrapper__col .color-picker-source')].map((el) => {
        if (el.id) {
          el.setAttribute('style', '');
        }
      });

      setFilterValues(null, null);
      setGrandientValues(null, null);
    }
    checkIfTabHasVals();
    setColorsOnColorInputs();
    setSelectDropdowns();
    setTitlesOnInputs();
  }
  // ---------------------------------------------------
  // ---------------------------------------------------

  var checkOtherMediaValsInputVal;

  function checkOtherMediaVals(val) {
    var pass = false;
    if (thecssLG[checkOtherMediaValsInputVal]) {
      if (thecssLG[checkOtherMediaValsInputVal][val]) {
        pass = true;
      }
    }
    if (thecssMD[checkOtherMediaValsInputVal]) {
      if (thecssMD[checkOtherMediaValsInputVal][val]) {
        pass = true;
      }
    }
    if (thecssSM[checkOtherMediaValsInputVal]) {
      if (thecssSM[checkOtherMediaValsInputVal][val]) {
        pass = true;
      }
    }
    if (thecssXS[checkOtherMediaValsInputVal]) {
      if (thecssXS[checkOtherMediaValsInputVal][val]) {
        pass = true;
      }
    }
    return pass;
  }

  function checkIfTabHasVals() {
    var buttonHLColor = "color: var(--mainColor)";
    var buttonHLColor_faded = "color: var(--main-text-faded)";
    var buttonBGColor = "color: var(--main-text)";
    if (!INPUTER1.value) {
      customPropertyButton.style = buttonBGColor;
      colorsButton.style = buttonBGColor;
      positionButton.style = buttonBGColor;
      displayButton.style = buttonBGColor;
      flexboxButton.style = buttonBGColor;
      floatButton.style = buttonBGColor;
      stackButton.style = buttonBGColor;
      cursorButton.style = buttonBGColor;
      overflowButton.style = buttonBGColor;
      spacingButton.style = buttonBGColor;
      sizeButton.style = buttonBGColor;
      fontsButton.style = buttonBGColor;
      textButton.style = buttonBGColor;
      listButton.style = buttonBGColor;
      bordersButton.style = buttonBGColor;
      outlineButton.style = buttonBGColor;
      shadowsButton.style = buttonBGColor;
      shadowsButtonText.style = buttonBGColor;
      transformButton.style = buttonBGColor;
      backgroundButton.style = buttonBGColor;
      gradientButton.style = buttonBGColor;
      filtersButton.style = buttonBGColor;
      return false;
    }
    setTimeout(function () {
      checkOtherMediaValsInputVal = INPUTER1.value;
      //-------------------------------------------
      if (!CSSstyles) {
        return false;
      }
      if (CSSstyles["display"]) {
        displayButton.style = buttonHLColor;
      } else if (getInheritedStyle("display").style) {
        displayButton.style = buttonHLColor_faded;
      } else {
        displayButton.style = buttonBGColor;
      }
      //-------------------------------------------
      if (
        CSSstyles["flex-direction"] ||
        CSSstyles["flex-wrap"] ||
        (CSSstyles["align-items"] && CSSstyles["display"] === 'flex') ||
        (CSSstyles["justify-content"] && CSSstyles["display"] === 'flex') ||
        (CSSstyles["align-content"] && CSSstyles["display"] === 'flex') ||
        CSSstyles["order"] ||
        CSSstyles["flex-grow"] ||
        CSSstyles["flex-shrink"] ||
        CSSstyles["flex-basis"]
      ) {
        flexboxButton.style = buttonHLColor;
      } else if (
        getInheritedStyle("flex-direction").style ||
        getInheritedStyle("flex-wrap").style ||
        (getInheritedStyle("align-items").style && getInheritedStyle("display").style === 'flex') ||
        (getInheritedStyle("justify-content").style && getInheritedStyle("display").style === 'flex') ||
        (getInheritedStyle("align-content").style && getInheritedStyle("display").style === 'flex') ||
        getInheritedStyle("order").style ||
        getInheritedStyle("flex-grow").style ||
        getInheritedStyle("flex-shrink").style ||
        getInheritedStyle("flex-basis").style
      ) {
        flexboxButton.style = buttonHLColor_faded;
      } else {
        flexboxButton.style = buttonBGColor;
      }
      //-------------------------------------------
      if (
        CSSstyles["grid-template-columns"] ||
        CSSstyles["grid-template-rows"] ||
        CSSstyles["grid-auto-columns"] ||
        CSSstyles["grid-auti-rows"] ||
        CSSstyles["justify-items"] ||
        (CSSstyles["align-items"] && CSSstyles["display"] === 'grid') ||
        (CSSstyles["justify-content"] && CSSstyles["display"] === 'grid') ||
        (CSSstyles["align-content"] && CSSstyles["display"] === 'grid') ||
        CSSstyles["grid-auto-flow"]
      ) {
        gridButton.style = buttonHLColor;
      } else if (
        getInheritedStyle("grid-template-columns").style ||
        getInheritedStyle("grid-template-rows").style ||
        getInheritedStyle("grid-auto-columns").style ||
        getInheritedStyle("grid-auto-rows").style ||
        getInheritedStyle("justify-items").style ||
        (getInheritedStyle("align-items").style && getInheritedStyle("display").style === 'grid') ||
        (getInheritedStyle("justify-content").style && getInheritedStyle("display").style === 'grid') ||
        (getInheritedStyle("align-content").style && getInheritedStyle("display").style === 'grid') ||
        getInheritedStyle("grid-auto-flow").style
      ) {
        gridButton.style = buttonHLColor_faded;
      } else {
        gridButton.style = buttonBGColor;
      }
      //-------------------------------------------
      if (
        CSSstyles["color"] ||
        CSSstyles["background-color"] ||
        CSSstyles["opacity"]
      ) {
        colorsButton.style = buttonHLColor;
      } else if (
        getInheritedStyle("color").style ||
        getInheritedStyle("background-color").style ||
        getInheritedStyle("opacity").style
      ) {
        colorsButton.style = buttonHLColor_faded;
      } else {
        colorsButton.style = buttonBGColor;
      }
      //-------------------------------------------
      if (
        CSSstyles["left"] ||
        CSSstyles["top"] ||
        CSSstyles["right"] ||
        CSSstyles["bottom"] ||
        CSSstyles["position"]
      ) {
        positionButton.style = buttonHLColor;
      } else if (
        getInheritedStyle("left").style ||
        getInheritedStyle("top").style ||
        getInheritedStyle("right").style ||
        getInheritedStyle("bottom").style ||
        getInheritedStyle("position").style
      ) {
        positionButton.style = buttonHLColor_faded;
      } else {
        positionButton.style = buttonBGColor;
      }
      //-------------------------------------------
      if (CSSstyles["float"] || CSSstyles["clear"]) {
        floatButton.style = buttonHLColor;
      } else if (getInheritedStyle("float").style || getInheritedStyle("clear").style) {
        floatButton.style = buttonHLColor_faded;
      } else {
        floatButton.style = buttonBGColor;
      }
      //-------------------------------------------
      if (CSSstyles["z-index"]) {
        stackButton.style = buttonHLColor;
      } else if (getInheritedStyle("z-index").style) {
        stackButton.style = buttonHLColor_faded;
      } else {
        stackButton.style = buttonBGColor;
      }
      //-------------------------------------------
      if (CSSstyles["cursor"]) {
        cursorButton.style = buttonHLColor;
      } else if (getInheritedStyle("cursor").style) {
        cursorButton.style = buttonHLColor_faded;
      } else {
        cursorButton.style = buttonBGColor;
      }
      //-------------------------------------------
      if (CSSstyles["overflow-x"] || CSSstyles["overflow-y"]) {
        overflowButton.style = buttonHLColor;
      } else if (getInheritedStyle("overflow-x").style || getInheritedStyle("overflow-y").style) {
        overflowButton.style = buttonHLColor_faded;
      } else {
        overflowButton.style = buttonBGColor;
      }
      //-------------------------------------------
      if (
        CSSstyles["margin-left"] ||
        CSSstyles["margin-top"] ||
        CSSstyles["margin-right"] ||
        CSSstyles["margin-bottom"] ||
        CSSstyles["padding-top"] ||
        CSSstyles["padding-left"] ||
        CSSstyles["padding-right"] ||
        CSSstyles["padding-bottom"] ||
        CSSstyles["gap"] ||
        CSSstyles["box-sizing"]
      ) {
        spacingButton.style = buttonHLColor;
      } else if (
        getInheritedStyle("margin-left").style ||
        getInheritedStyle("margin-top").style ||
        getInheritedStyle("margin-right").style ||
        getInheritedStyle("margin-bottom").style ||
        getInheritedStyle("padding-top").style ||
        getInheritedStyle("padding-left").style ||
        getInheritedStyle("padding-right").style ||
        getInheritedStyle("padding-bottom").style ||
        getInheritedStyle("gap").style ||
        getInheritedStyle("box-sizing").style
      ) {
        spacingButton.style = buttonHLColor_faded;
      } else {
        spacingButton.style = buttonBGColor;
      }
      //-------------------------------------------
      if (
        CSSstyles["width"] ||
        CSSstyles["height"] ||
        CSSstyles["min-width"] ||
        CSSstyles["min-height"] ||
        CSSstyles["max-width"] ||
        CSSstyles["max-height"] ||
        CSSstyles["object-fit"]
      ) {
        sizeButton.style = buttonHLColor;
      } else if (
        getInheritedStyle("width").style ||
        getInheritedStyle("height").style ||
        getInheritedStyle("min-width").style ||
        getInheritedStyle("min-height").style ||
        getInheritedStyle("max-width").style ||
        getInheritedStyle("max-height").style ||
        getInheritedStyle("object-fit").style
      ) {
        sizeButton.style = buttonHLColor_faded;
      } else {
        sizeButton.style = buttonBGColor;
      }
      //-------------------------------------------
      if (
        CSSstyles["font-family"] ||
        CSSstyles["font-size"] ||
        CSSstyles["letter-spacing"] ||
        CSSstyles["line-height"] ||
        CSSstyles["font-weight"] ||
        CSSstyles["font-style"]
      ) {
        fontsButton.style = buttonHLColor;
      } else if (
        getInheritedStyle("font-family").style ||
        getInheritedStyle("font-size").style ||
        getInheritedStyle("letter-spacing").style ||
        getInheritedStyle("line-height").style ||
        getInheritedStyle("font-weight").style ||
        getInheritedStyle("font-style").style
      ) {
        fontsButton.style = buttonHLColor_faded;
      } else {
        fontsButton.style = buttonBGColor;
      }
      //-------------------------------------------
      if (
        CSSstyles["text-transform"] ||
        CSSstyles["text-decoration-line"] ||
        CSSstyles["text-align"] ||
        CSSstyles["text-align-last"] ||
        CSSstyles["direction"] ||
        CSSstyles["unicode-bidi"] ||
        CSSstyles["vertical-align"] ||
        CSSstyles["text-decoration-color"] ||
        CSSstyles["text-decoration-style"] ||
        CSSstyles["text-decoration-thickness"]
      ) {
        textButton.style = buttonHLColor;
      } else if (
        getInheritedStyle("text-transform").style ||
        getInheritedStyle("text-decoration-line").style ||
        getInheritedStyle("text-align").style ||
        getInheritedStyle("text-align-last").style ||
        getInheritedStyle("direction").style ||
        getInheritedStyle("unicode-bidi").style ||
        getInheritedStyle("vertical-align").style ||
        getInheritedStyle("text-decoration-color").style ||
        getInheritedStyle("text-decoration-style").style ||
        getInheritedStyle("text-decoration-thickness").style
      ) {
        textButton.style = buttonHLColor_faded;
      } else {
        textButton.style = buttonBGColor;
      }
      //-------------------------------------------
      if (
        CSSstyles["list-style-type"] ||
        CSSstyles["list-style-position"] ||
        CSSstyles["list-style-image"]
      ) {
        listButton.style = buttonHLColor;
      } else if (
        getInheritedStyle("list-style-type").style ||
        getInheritedStyle("list-style-position").style ||
        getInheritedStyle("list-style-image").style
      ) {
        listButton.style = buttonHLColor_faded;
      } else {
        listButton.style = buttonBGColor;
      }
      //-------------------------------------------
      if (
        CSSstyles["border-left-width"] ||
        CSSstyles["border-top-width"] ||
        CSSstyles["border-right-width"] ||
        CSSstyles["border-bottom-width"] ||
        CSSstyles["border-top-left-radius"] ||
        CSSstyles["border-top-right-radius"] ||
        CSSstyles["border-bottom-left-radius"] ||
        CSSstyles["border-bottom-right-radius"] ||
        CSSstyles["border-left-style"] ||
        CSSstyles["border-top-style"] ||
        CSSstyles["border-right-style"] ||
        CSSstyles["border-bottom-style"]
      ) {
        bordersButton.style = buttonHLColor;
      } else if (
        getInheritedStyle("border-left-width").style ||
        getInheritedStyle("border-top-width").style ||
        getInheritedStyle("border-right-width").style ||
        getInheritedStyle("border-bottom-width").style ||
        getInheritedStyle("border-top-left-radius").style ||
        getInheritedStyle("border-top-right-radius").style ||
        getInheritedStyle("border-bottom-left-radius").style ||
        getInheritedStyle("border-bottom-right-radius").style ||
        getInheritedStyle("border-left-style").style ||
        getInheritedStyle("border-top-style").style ||
        getInheritedStyle("border-right-style").style ||
        getInheritedStyle("border-bottom-style").style
      ) {
        bordersButton.style = buttonHLColor_faded;
      } else {
        bordersButton.style = buttonBGColor;
      }
      //-------------------------------------------
      if (
        CSSstyles["outline-width"] ||
        CSSstyles["outline-offset"] ||
        CSSstyles["outline-color"] ||
        CSSstyles["outline-style"]
      ) {
        outlineButton.style = buttonHLColor;
      } else if (
        getInheritedStyle("outline-width").style ||
        getInheritedStyle("outline-offset").style ||
        getInheritedStyle("outline-color").style ||
        getInheritedStyle("outline-style").style
      ) {
        outlineButton.style = buttonHLColor_faded;
      } else {
        outlineButton.style = buttonBGColor;
      }
      //-------------------------------------------
      if (CSSstyles["box-shadow"]) {
        shadowsButton.style = buttonHLColor;
      } else if (getInheritedStyle("box-shadow").style) {
        shadowsButton.style = buttonHLColor_faded;
      } else {
        shadowsButton.style = buttonBGColor;
      }
      //-------------------------------------------
      if (CSSstyles["text-shadow"]) {
        shadowsButtonText.style = buttonHLColor;
      } else if (getInheritedStyle("text-shadow").style) {
        shadowsButtonText.style = buttonHLColor_faded;
      } else {
        shadowsButtonText.style = buttonBGColor;
      }
      //-------------------------------------------
      if (CSSstyles["transform"] || CSSstyles["transform-origin"]) {
        transformButton.style = buttonHLColor;
      } else if (getInheritedStyle("transform").style || getInheritedStyle("transform-origin").style) {
        transformButton.style = buttonHLColor_faded;
      } else {
        transformButton.style = buttonBGColor;
      }
      //-------------------------------------------
      if (CSSstyles["filter"]) {
        filtersButton.style = buttonHLColor;
      } else if (getInheritedStyle("filter").style) {
        filtersButton.style = buttonHLColor_faded;
      } else {
        filtersButton.style = buttonBGColor;
      }
      //-------------------------------------------
      if (
        CSSstyles["background-image"] ||
        CSSstyles["background-repeat"] ||
        CSSstyles["background-size"] ||
        CSSstyles["background-position-x"] ||
        CSSstyles["background-position-y"] ||
        CSSstyles["background-attachment"] ||
        CSSstyles["background-blend-mode"] ||
        CSSstyles["background-origin"] ||
        CSSstyles["background-clip"]
      ) {
        backgroundButton.style = buttonHLColor;
      } else if (
        getInheritedStyle("background-image").style ||
        getInheritedStyle("background-repeat").style ||
        getInheritedStyle("background-size").style ||
        getInheritedStyle("background-position-x").style ||
        getInheritedStyle("background-position-y").style ||
        getInheritedStyle("background-attachment").style ||
        getInheritedStyle("background-blend-mode").style ||
        getInheritedStyle("background-origin").style ||
        getInheritedStyle("background-clip").style
      ) {
        backgroundButton.style = buttonHLColor_faded;
      } else {
        backgroundButton.style = buttonBGColor;
      }
      //-------------------------------------------
      if (
        CSSstyles["background"]
      ) {
        gradientButton.style = buttonHLColor;
      } else if (
        getInheritedStyle("background").style
      ) {
        gradientButton.style = buttonHLColor_faded;
      } else {
        gradientButton.style = buttonBGColor;
      }


    }, 3);
  }

  function getInheritedStyle(style, otherclass) {
    var class_to_check = FillValueReadouts_input1;
    if (otherclass) {
      class_to_check = otherclass;
    }
    var forReturn = {
      style: "",
      breakpoint: ""
    };
    if (checkOtherMediaVals(style)) {
      if (mobileFirst) {
        switch (breakPoint) {
          case "fullWidth":
            if (thecssMD[class_to_check] && thecssMD[class_to_check][style]) {
              forReturn.style = thecssMD[class_to_check][style];
              forReturn.breakpoint = "MD";
            } else if (thecssSM[class_to_check] && thecssSM[class_to_check][style]) {
              forReturn.style = thecssSM[class_to_check][style];
              forReturn.breakpoint = "SM";
            } else if (thecssXS[class_to_check] && thecssXS[class_to_check][style]) {
              forReturn.style = thecssXS[class_to_check][style];
              forReturn.breakpoint = "XS";
            }
            break;
          case "breakPoint1":
            if (thecssSM[class_to_check] && thecssSM[class_to_check][style]) {
              forReturn.style = thecssSM[class_to_check][style];
              forReturn.breakpoint = "SM";
            } else if (thecssXS[class_to_check] && thecssXS[class_to_check][style]) {
              forReturn.style = thecssXS[class_to_check][style];
              forReturn.breakpoint = "XS";
            }
            break;
          case "breakPoint2":
            if (thecssXS[class_to_check] && thecssXS[class_to_check][style]) {
              forReturn.style = thecssXS[class_to_check][style];
              forReturn.breakpoint = "XS";
            }
            break;
          case "breakPoint3":
            break;
        }
      } else {
        switch (breakPoint) {
          case "fullWidth":
            break;
          case "breakPoint1":
            if (thecssLG[class_to_check] && thecssLG[class_to_check][style]) {
              forReturn.style = thecssLG[class_to_check][style];
              forReturn.breakpoint = "LG";
            }
            break;
          case "breakPoint2":
            if (thecssMD[class_to_check] && thecssMD[class_to_check][style]) {
              forReturn.style = thecssMD[class_to_check][style];
              forReturn.breakpoint = "MD";
            } else if (thecssLG[class_to_check] && thecssLG[class_to_check][style]) {
              forReturn.style = thecssLG[class_to_check][style];
              forReturn.breakpoint = "LG";
            }
            break;
          case "breakPoint3":
            if (thecssSM[class_to_check] && thecssSM[class_to_check][style]) {
              forReturn.style = thecssSM[class_to_check][style];
              forReturn.breakpoint = "SM";
            } else if (thecssMD[class_to_check] && thecssMD[class_to_check][style]) {
              forReturn.style = thecssMD[class_to_check][style];
              forReturn.breakpoint = "MD";
            } else if (thecssLG[class_to_check] && thecssLG[class_to_check][style]) {
              forReturn.style = thecssLG[class_to_check][style];
              forReturn.breakpoint = "LG";
            }
            break;
        }
      }
    }
    return forReturn;
  }

  function checkPropsArr(PropsArr, mq) {
    var pass = false;
    [].forEach.call(PropsArr, function (prop) {
      if (prop === mq) {
        pass = true;
      }
    });
    if (pass) {
      return true;
    } else {
      return false;
    }
  }

  function check_multiple_classes(PropsArr) {
    var readout = "";
    if (mobileFirst) {
      // mobile // mobile hoz // tablet
      switch (breakPoint) {
        case "fullWidth":
          if (checkPropsArr(PropsArr, "XS")) {
            readout = "XS";
          }
          if (checkPropsArr(PropsArr, "SM")) {
            readout = "SM";
          }
          if (checkPropsArr(PropsArr, "MD")) {
            readout = "MD";
          }
          break;
        case "breakPoint1":
          if (checkPropsArr(PropsArr, "XS")) {
            readout = "XS";
          }
          if (checkPropsArr(PropsArr, "SM")) {
            readout = "SM";
          }
          break;
        case "breakPoint2":
          if (checkPropsArr(PropsArr, "XS")) {
            readout = "XS";
          }
          break;
        case "breakPoint3":
          break;
      }
    } else {
      // desktop // tablet // mobile hoz
      switch (breakPoint) {
        case "fullWidth":
          break;
        case "breakPoint1":
          if (checkPropsArr(PropsArr, "LG")) {
            readout = "LG";
          }
          break;
        case "breakPoint2":
          if (checkPropsArr(PropsArr, "LG")) {
            readout = "LG";
          }
          if (checkPropsArr(PropsArr, "MD")) {
            readout = "MD";
          }
          break;
        case "breakPoint3":
          if (checkPropsArr(PropsArr, "LG")) {
            readout = "LG";
          }
          if (checkPropsArr(PropsArr, "MD")) {
            readout = "MD";
          }
          if (checkPropsArr(PropsArr, "SM")) {
            readout = "SM";
          }
          break;
      }
    }
    return readout;
  }

  var selecttDropdowns_els = [...document.querySelectorAll('[select-dropdown]')];
  var data_selects_elements = [...document.querySelectorAll('[data-select]')];

  function setSelectDropdowns() {
    var mq_readout;
    setTimeout(function () {
      if (!INPUTER1.value) {
        selecttDropdowns_els.map(el => {
          el.innerHTML = '';
        });

        data_selects_elements.map(el => {
          el.value = false;
        });

        return false;
      }
      switch (breakPoint) {
        case "fullWidth":
          mq_readout = 'LG';
          break;
        case "breakPoint1":
          mq_readout = 'MD';
          break;
        case "breakPoint2":
          mq_readout = 'SM';
          break;
        case "breakPoint3":
          mq_readout = 'XS';
          break;
      }

      var readout;
      var inheritHTML = '';
      var has_inline_str = ' & inline';
      if (!frameID(domElement[0])) {
        return false;
      }
      var frame_style = frameID(domElement[0]).style;

      [].forEach.call(selecttDropdowns_els, function (el) {
        var select_type = el.getAttribute('select-dropdown');
        var has_inline = '';
        var is_inline = '';

        // gap -----------------------------------------------------
        if (select_type === 'gap') {
          if (
            frame_style[select_type]
          ) {
            has_inline = has_inline_str;
            is_inline = '</span><span style="color: var(--mainColor)"><span class="select-dropdown-value-label">' + select_type + ':</span> (inline)</span>';
          }
          if (
            CSSstyles[select_type]
          ) {
            el.innerHTML = '</span><span style="color: var(--mainColor)"><span class="select-dropdown-value-label">' + select_type + ':</span> (' + mq_readout + has_inline + ')</span>';
          } else if (getInheritedStyle(select_type).style) {
            el.innerHTML = '</span><span style="color: var(--main-text-faded)"><span class="select-dropdown-value-label">' + select_type + ':</span> (' + getInheritedStyle(select_type).breakpoint + has_inline + ')</span>';
          } else {
            el.innerHTML = is_inline;
          }
        }
        // grid_template -----------------------------------------------------
        else if (select_type === 'grid_template') {
          if (
            frame_style['grid-template-columns'] ||
            frame_style['grid-template-rows']
          ) {
            has_inline = has_inline_str;
            is_inline = '</span><span style="color: var(--mainColor)"><span class="select-dropdown-value-label">template:</span> (inline)</span>';
          }
          if (
            CSSstyles['grid-template-columns'] ||
            CSSstyles['grid-template-rows']
          ) {
            el.innerHTML = '</span><span style="color: var(--mainColor)"><span class="select-dropdown-value-label">template:</span> (' + mq_readout + has_inline + ')</span>';
          } else if (
            getInheritedStyle('grid-template-columns').style ||
            getInheritedStyle('grid-template-rows').style
          ) {
            var tc = getInheritedStyle('grid-template-columns').breakpoint;
            var tr = getInheritedStyle('grid-template-rows').breakpoint;
            readout = check_multiple_classes([tc, tr]);
            el.innerHTML = '</span><span style="color: var(--main-text-faded)"><span class="select-dropdown-value-label">template:</span> (' + readout + has_inline + ')</span>';
          } else {
            el.innerHTML = is_inline;
          }
        }
        // grid_auto -----------------------------------------------------
        else if (select_type === 'grid_auto') {
          if (
            frame_style['grid-auto-columns'] ||
            frame_style['grid-auto-rows']
          ) {
            has_inline = has_inline_str;
            is_inline = '</span><span style="color: var(--mainColor)"><span class="select-dropdown-value-label">auto:</span> (inline)</span>';
          }
          if (
            CSSstyles['grid-auto-columns'] ||
            CSSstyles['grid-auto-rows']
          ) {
            el.innerHTML = '</span><span style="color: var(--mainColor)"><span class="select-dropdown-value-label">auto:</span> (' + mq_readout + has_inline + ')</span>';
          } else if (
            getInheritedStyle('grid-auto-columns').style ||
            getInheritedStyle('grid-auto-rows').style
          ) {
            var ac = getInheritedStyle('grid-auto-columns').breakpoint;
            var ar = getInheritedStyle('grid-auto-rows').breakpoint;
            readout = check_multiple_classes([ac, ar]);
            el.innerHTML = '</span><span style="color: var(--main-text-faded)"><span class="select-dropdown-value-label">auto:</span> (' + readout + has_inline + ')</span>';
          } else {
            el.innerHTML = is_inline;
          }
        }
        // padding -----------------------------------------------------
        else if (select_type === 'padding') {
          if (
            frame_style['padding-left'] ||
            frame_style['padding-right'] ||
            frame_style['padding-top'] ||
            frame_style['padding-bottom']
          ) {
            has_inline = has_inline_str;
            is_inline = '</span><span style="color: var(--mainColor)"><span class="select-dropdown-value-label">pad:</span> (inline)</span>';
          }
          if (
            CSSstyles['padding-left'] ||
            CSSstyles['padding-right'] ||
            CSSstyles['padding-top'] ||
            CSSstyles['padding-bottom']
          ) {
            el.innerHTML = '</span><span style="color: var(--mainColor)"><span class="select-dropdown-value-label">pad:</span> (' + mq_readout + has_inline + ')</span>';
          } else if (
            getInheritedStyle('padding-left').style ||
            getInheritedStyle('padding-right').style ||
            getInheritedStyle('padding-top').style ||
            getInheritedStyle('padding-bottom').style
          ) {
            var pl = getInheritedStyle('padding-left').breakpoint;
            var pr = getInheritedStyle('padding-right').breakpoint;
            var pt = getInheritedStyle('padding-top').breakpoint;
            var pb = getInheritedStyle('padding-bottom').breakpoint;
            readout = check_multiple_classes([pl, pr, pt, pb]);
            el.innerHTML = '</span><span style="color: var(--main-text-faded)"><span class="select-dropdown-value-label">pad:</span> (' + readout + has_inline + ')</span>';
          } else {
            el.innerHTML = is_inline;
          }
        }
        // margin -----------------------------------------------------
        else if (select_type === 'margin') {
          if (
            frame_style['margin-left'] ||
            frame_style['margin-right'] ||
            frame_style['margin-top'] ||
            frame_style['margin-bottom']
          ) {
            has_inline = has_inline_str;
            is_inline = '</span><span style="color: var(--mainColor)"><span class="select-dropdown-value-label">mar:</span> (inline)</span>';
          }
          if (
            CSSstyles['margin-left'] ||
            CSSstyles['margin-right'] ||
            CSSstyles['margin-top'] ||
            CSSstyles['margin-bottom']
          ) {
            el.innerHTML = '</span><span style="color: var(--mainColor)"><span class="select-dropdown-value-label">mar:</span> (' + mq_readout + has_inline + ')</span>';
          } else if (
            getInheritedStyle('margin-left').style ||
            getInheritedStyle('margin-right').style ||
            getInheritedStyle('margin-top').style ||
            getInheritedStyle('margin-bottom').style
          ) {
            var ml = getInheritedStyle('margin-left').breakpoint;
            var mr = getInheritedStyle('margin-right').breakpoint;
            var mt = getInheritedStyle('margin-top').breakpoint;
            var mb = getInheritedStyle('margin-bottom').breakpoint;
            readout = check_multiple_classes([ml, mr, mt, mb]);
            el.innerHTML = '</span><span style="color: var(--main-text-faded)"><span class="select-dropdown-value-label">mar:</span> (' + readout + has_inline + ')</span>';
          } else {
            el.innerHTML = is_inline;
          }
        }
        // outline -----------------------------------------------------
        else if (select_type === 'outline') {
          if (
            frame_style['outline-width'] ||
            frame_style['outline-offset'] ||
            frame_style['outline-color'] ||
            frame_style['outline-style']
          ) {
            has_inline = has_inline_str;
            is_inline = '</span><span style="color: var(--mainColor)"><span class="select-dropdown-value-label"></span> (inline)</span>';
          }
          if (
            CSSstyles['outline-width'] ||
            CSSstyles['outline-offset'] ||
            CSSstyles['outline-color'] ||
            CSSstyles['outline-style']
          ) {
            el.innerHTML = '</span><span style="color: var(--mainColor)"><span class="select-dropdown-value-label"></span> (' + mq_readout + has_inline + ')</span>';
          } else if (
            getInheritedStyle('outline-width').style ||
            getInheritedStyle('outline-offset').style ||
            getInheritedStyle('outline-color').style ||
            getInheritedStyle('outline-style').style
          ) {
            var ow = getInheritedStyle('outline-width').breakpoint;
            var oo = getInheritedStyle('outline-offset').breakpoint;
            var oc = getInheritedStyle('outline-color').breakpoint;
            var os = getInheritedStyle('outline-style').breakpoint;
            readout = check_multiple_classes([ow, oo, oc, os]);
            el.innerHTML = '</span><span style="color: var(--main-text-faded)"><span class="select-dropdown-value-label"></span> (' + readout + has_inline + ')</span>';
          } else {
            el.innerHTML = is_inline;
          }
        }
        // width -----------------------------------------------------
        else if (select_type === 'width') {
          if (
            frame_style['width'] ||
            frame_style['max-width'] ||
            frame_style['min-width']
          ) {
            has_inline = has_inline_str;
            is_inline = is_inline = '</span><span style="color: var(--mainColor)"><span class="select-dropdown-value-label">width:</span> (inline)</span>';
          }
          if (
            CSSstyles['width'] ||
            CSSstyles['max-width'] ||
            CSSstyles['min-width']
          ) {
            el.innerHTML = '</span><span style="color: var(--mainColor)"><span class="select-dropdown-value-label">width:</span> (' + mq_readout + has_inline + ')</span>';
          } else if (
            getInheritedStyle('width').style ||
            getInheritedStyle('max-width').style ||
            getInheritedStyle('min-width').style
          ) {
            var w = getInheritedStyle('width').breakpoint;
            var maxw = getInheritedStyle('max-width').breakpoint;
            var minw = getInheritedStyle('min-width').breakpoint;
            readout = check_multiple_classes([w, maxw, minw]);
            el.innerHTML = '</span><span style="color: var(--main-text-faded)"><span class="select-dropdown-value-label">width:</span> (' + readout + has_inline + ')</span>';
          } else {
            el.innerHTML = is_inline;
          }
        }
        // height -----------------------------------------------------
        else if (select_type === 'height') {
          if (
            frame_style['height'] ||
            frame_style['max-height'] ||
            frame_style['min-height']
          ) {
            has_inline = has_inline_str;
            is_inline = is_inline = '</span><span style="color: var(--mainColor)"><span class="select-dropdown-value-label">height:</span> (inline)</span>';
          }
          if (
            CSSstyles['height'] ||
            CSSstyles['max-height'] ||
            CSSstyles['min-height']
          ) {
            el.innerHTML = '</span><span style="color: var(--mainColor)"><span class="select-dropdown-value-label">height:</span> (' + mq_readout + has_inline + ')</span>';
          } else if (
            getInheritedStyle('height').style ||
            getInheritedStyle('max-height').style ||
            getInheritedStyle('min-height').style
          ) {
            var h = getInheritedStyle('height').breakpoint;
            var maxh = getInheritedStyle('max-height').breakpoint;
            var minh = getInheritedStyle('min-height').breakpoint;
            readout = check_multiple_classes([h, maxh, minh]);
            el.innerHTML = '</span><span style="color: var(--main-text-faded)"><span class="select-dropdown-value-label">height:</span> (' + readout + has_inline + ')</span>';
          } else {
            el.innerHTML = is_inline;
          }
        }
        // colors -----------------------------------------------------
        else if (select_type === 'colors') {
          if (
            frame_style['color'] ||
            frame_style['background-color'] ||
            frame_style['opacity']
          ) {
            has_inline = has_inline_str;
            is_inline = is_inline = '</span><span style="color: var(--mainColor)"><span class="select-dropdown-value-label"></span> (inline)</span>';
          }
          if (
            CSSstyles['color'] ||
            CSSstyles['background-color'] ||
            CSSstyles['opacity']
          ) {
            el.innerHTML = '</span><span style="color: var(--mainColor)"><span class="select-dropdown-value-label"></span> (' + mq_readout + has_inline + ')</span>';
          } else if (
            getInheritedStyle('color').style ||
            getInheritedStyle('background-color').style ||
            getInheritedStyle('opacity').style
          ) {
            var c = getInheritedStyle('color').breakpoint;
            var bc = getInheritedStyle('background-color').breakpoint;
            var o = getInheritedStyle('opacity').breakpoint;
            readout = check_multiple_classes([c, bc, o]);
            el.innerHTML = '</span><span style="color: var(--main-text-faded)"><span class="select-dropdown-value-label"></span> (' + readout + has_inline + ')</span>';
          } else {
            el.innerHTML = is_inline;
          }
        }
        // font -----------------------------------------------------
        else if (select_type === 'font') {
          if (
            frame_style['font-family'] ||
            frame_style['font-size'] ||
            frame_style['letter-spacing'] ||
            frame_style['line-height'] ||
            frame_style['font-weight'] ||
            frame_style['font-style']
          ) {
            has_inline = has_inline_str;
            is_inline = is_inline = '<span style="color: var(--mainColor)"> (inline)</span>';
          }
          if (
            CSSstyles['font-family'] ||
            CSSstyles['font-size'] ||
            CSSstyles['letter-spacing'] ||
            CSSstyles['line-height'] ||
            CSSstyles['font-weight'] ||
            CSSstyles['font-style']
          ) {
            el.innerHTML = '<span style="color: var(--mainColor)"> (' + mq_readout + has_inline + ')</span>';
          } else if (
            getInheritedStyle('font-family').style ||
            getInheritedStyle('font-size').style ||
            getInheritedStyle('letter-spacing').style ||
            getInheritedStyle('line-height').style ||
            getInheritedStyle('font-weight').style ||
            getInheritedStyle('font-style').style
          ) {
            var ff = getInheritedStyle('font-family').breakpoint;
            var fs = getInheritedStyle('font-size').breakpoint;
            var ls = getInheritedStyle('letter-spacing').breakpoint;
            var lh = getInheritedStyle('line-height').breakpoint;
            var fw = getInheritedStyle('font-weight').breakpoint;
            var fst = getInheritedStyle('font-style').breakpoint;
            readout = check_multiple_classes([ff, fs, ls, lh, fw, fst]);
            el.innerHTML = '<span style="color: var(--main-text-faded)"> (' + readout + has_inline + ')</span>';
          } else {
            el.innerHTML = is_inline;
          }
        }
        // text -----------------------------------------------------
        else if (select_type === 'text') {
          if (
            frame_style['text-align'] ||
            frame_style['text-align-last'] ||
            frame_style['text-transform'] ||
            frame_style['text-decoration-line'] ||
            frame_style['direction'] ||
            frame_style['unicode-bidi'] ||
            frame_style['vertical-align'] ||
            frame_style['text-decoration-color'] ||
            frame_style['text-decoration-style'] ||
            frame_style['text-decoration-thickness']
          ) {
            has_inline = has_inline_str;
            is_inline = is_inline = '<span style="color: var(--mainColor)"> (inline)</span>';
          }
          if (
            CSSstyles['text-align'] ||
            CSSstyles['text-align-last'] ||
            CSSstyles['text-transform'] ||
            CSSstyles['text-decoration-line'] ||
            CSSstyles['direction'] ||
            CSSstyles['unicode-bidi'] ||
            CSSstyles['vertical-align'] ||
            CSSstyles['text-decoration-color'] ||
            CSSstyles['text-decoration-style'] ||
            CSSstyles['text-decoration-thickness']
          ) {
            el.innerHTML = '<span style="color: var(--mainColor)"> (' + mq_readout + has_inline + ')</span>';
          } else if (
            getInheritedStyle('text-align').style ||
            getInheritedStyle('text-align-last').style ||
            getInheritedStyle('text-transform').style ||
            getInheritedStyle('text-decoration-line').style ||
            getInheritedStyle('direction').style ||
            getInheritedStyle('unicode-bidi').style ||
            getInheritedStyle('vertical-align').style ||
            getInheritedStyle('text-decoration-color').style ||
            getInheritedStyle('text-decoration-style').style ||
            getInheritedStyle('text-decoration-thickness').style
          ) {
            var ta = getInheritedStyle('text-align').breakpoint;
            var tal = getInheritedStyle('text-align-last').breakpoint;
            var tt = getInheritedStyle('text-transform').breakpoint;
            var tdl = getInheritedStyle('text-decoration-line').breakpoint;
            var d = getInheritedStyle('direction').breakpoint;
            var ub = getInheritedStyle('unicode-bidi').breakpoint;
            var va = getInheritedStyle('vertical-align').breakpoint;
            var tdc = getInheritedStyle('text-decoration-color').breakpoint;
            var tds = getInheritedStyle('text-decoration-style').breakpoint;
            var tdt = getInheritedStyle('text-decoration-thickness').breakpoint;

            readout = check_multiple_classes([ta, tal, tt, tdl, d, ub, va, tdc, tds, tdt]);
            el.innerHTML = '<span style="color: var(--main-text-faded)"> (' + readout + has_inline + ')</span>';
          } else {
            el.innerHTML = is_inline;
          }
        }
        // text-shadow -----------------------------------------------------
        else if (select_type === 'text-shadow') {
          if (
            frame_style[select_type]
          ) {
            has_inline = has_inline_str;
            is_inline = is_inline = '<span style="color: var(--mainColor)"> (inline)</span>';
          }
          if (CSSstyles[select_type]) {
            el.innerHTML = '<span style="color: var(--mainColor)"> (' + mq_readout + has_inline + ')</span>';
          } else if (getInheritedStyle(select_type).style) {
            el.innerHTML = '<span style="color: var(--main-text-faded)"> (' + getInheritedStyle(select_type).breakpoint + has_inline + ')</span>';
          } else {
            el.innerHTML = is_inline;
          }
        }
        // borders -----------------------------------------------------
        else if (select_type === 'borders') {
          if (
            frame_style['border-left-width'] ||
            frame_style['border-top-width'] ||
            frame_style['border-right-width'] ||
            frame_style['border-bottom-width'] ||
            frame_style['border-left-style'] ||
            frame_style['border-top-style'] ||
            frame_style['border-right-style'] ||
            frame_style['border-bottom-style'] ||
            frame_style['border-top-left-radius'] ||
            frame_style['border-top-right-radius'] ||
            frame_style['border-bottom-left-radius'] ||
            frame_style['border-bottom-right-radius'] ||
            frame_style['border-left-color'] ||
            frame_style['border-top-color'] ||
            frame_style['border-right-color'] ||
            frame_style['border-bottom-color']
          ) {
            has_inline = has_inline_str;
            is_inline = is_inline = '<span style="color: var(--mainColor)"> (inline)</span>';
          }
          if (
            CSSstyles['border-left-width'] ||
            CSSstyles['border-top-width'] ||
            CSSstyles['border-right-width'] ||
            CSSstyles['border-bottom-width'] ||
            CSSstyles['border-left-style'] ||
            CSSstyles['border-top-style'] ||
            CSSstyles['border-right-style'] ||
            CSSstyles['border-bottom-style'] ||
            CSSstyles['border-top-left-radius'] ||
            CSSstyles['border-top-right-radius'] ||
            CSSstyles['border-bottom-left-radius'] ||
            CSSstyles['border-bottom-right-radius'] ||
            CSSstyles['border-left-color'] ||
            CSSstyles['border-top-color'] ||
            CSSstyles['border-right-color'] ||
            CSSstyles['border-bottom-color']
          ) {
            el.innerHTML = '<span style="color: var(--mainColor)"> (' + mq_readout + has_inline + ')</span>';
          } else if (
            getInheritedStyle('border-left-width').style ||
            getInheritedStyle('border-top-width').style ||
            getInheritedStyle('border-right-width').style ||
            getInheritedStyle('border-bottom-width').style ||
            getInheritedStyle('border-left-style').style ||
            getInheritedStyle('border-top-style').style ||
            getInheritedStyle('border-right-style').style ||
            getInheritedStyle('border-bottom-style').style ||
            getInheritedStyle('border-top-left-radius').style ||
            getInheritedStyle('border-top-right-radius').style ||
            getInheritedStyle('border-bottom-left-radius').style ||
            getInheritedStyle('border-bottom-right-radius').style ||
            getInheritedStyle('border-left-color').style ||
            getInheritedStyle('border-top-color').style ||
            getInheritedStyle('border-right-color').style ||
            getInheritedStyle('border-bottom-color').style
          ) {
            var b1 = getInheritedStyle('border-left-width').breakpoint;
            var b2 = getInheritedStyle('border-top-width').breakpoint;
            var b3 = getInheritedStyle('border-right-width').breakpoint;
            var b4 = getInheritedStyle('border-bottom-width').breakpoint;
            var b5 = getInheritedStyle('border-left-style').breakpoint;
            var b6 = getInheritedStyle('border-top-style').breakpoint;
            var b7 = getInheritedStyle('border-right-style').breakpoint;
            var b8 = getInheritedStyle('border-bottom-style').breakpoint;
            var b9 = getInheritedStyle('border-top-left-radius').breakpoint;
            var b10 = getInheritedStyle('border-top-right-radius').breakpoint;
            var b11 = getInheritedStyle('border-bottom-left-radius').breakpoint;
            var b12 = getInheritedStyle('border-bottom-right-radius').breakpoint;
            var b13 = getInheritedStyle('border-left-color').breakpoint;
            var b14 = getInheritedStyle('border-top-color').breakpoint;
            var b15 = getInheritedStyle('border-right-color').breakpoint;
            var b16 = getInheritedStyle('border-bottom-color').breakpoint;
            readout = check_multiple_classes([b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16]);
            el.innerHTML = '<span style="color: var(--main-text-faded)"> (' + readout + has_inline + ')</span>';
          } else {
            el.innerHTML = is_inline;
          }
        }
        // overflow-x -----------------------------------------------------
        else if (select_type === 'overflow-x') {
          if (
            frame_style[select_type]
          ) {
            has_inline = has_inline_str;
            is_inline = is_inline = '<span style="color: var(--mainColor)"> (inline)</span>';
          }
          if (CSSstyles[select_type]) {
            el.innerHTML = '<span style="color: var(--mainColor)"><span class="select-dropdown-value-label">x:</span> (' + mq_readout + has_inline + ')</span>';
          } else if (getInheritedStyle(select_type).style) {
            el.innerHTML = '<span style="color: var(--main-text-faded)"><span class="select-dropdown-value-label">x:</span> (' + getInheritedStyle(select_type).breakpoint + has_inline + ')</span>';
          } else {
            el.innerHTML = is_inline;
          }
        }
        // overflow-y -----------------------------------------------------
        else if (select_type === 'overflow-y') {
          if (
            frame_style[select_type]
          ) {
            has_inline = has_inline_str;
            is_inline = is_inline = '<span style="color: var(--mainColor)"> (inline)</span>';
          }
          if (CSSstyles[select_type]) {
            el.innerHTML = '<span style="color: var(--mainColor)"><span class="select-dropdown-value-label">y:</span> (' + mq_readout + has_inline + ')</span>';
          } else if (getInheritedStyle(select_type).style) {
            el.innerHTML = '<span style="color: var(--main-text-faded)"><span class="select-dropdown-value-label">y:</span> (' + getInheritedStyle(select_type).breakpoint + has_inline + ')</span>';
          } else {
            el.innerHTML = is_inline;
          }
        }
        // box-shadow -----------------------------------------------------
        else if (select_type === 'box-shadow') {
          if (
            frame_style[select_type]
          ) {
            has_inline = has_inline_str;
            is_inline = is_inline = '<span style="color: var(--mainColor)"> (inline)</span>';
          }
          if (CSSstyles[select_type]) {
            el.innerHTML = '<span style="color: var(--mainColor)"> (' + mq_readout + has_inline + ')</span>';
          } else if (getInheritedStyle(select_type).style) {
            el.innerHTML = '<span style="color: var(--main-text-faded)"> (' + getInheritedStyle(select_type).breakpoint + has_inline + ')</span>';
          } else {
            el.innerHTML = is_inline;
          }
        }
        // background-image -----------------------------------------------------
        else if (select_type === 'background-image') {
          if (
            frame_style[select_type]
          ) {
            has_inline = has_inline_str;
            is_inline = is_inline = '<span style="color: var(--mainColor)"> (inline)</span>';
          }
          if (CSSstyles[select_type]) {
            el.innerHTML = '<span style="color: var(--mainColor)"> (' + mq_readout + has_inline + ')</span>';
          } else if (getInheritedStyle(select_type).style) {
            el.innerHTML = '<span style="color: var(--main-text-faded)"> (' + getInheritedStyle(select_type).breakpoint + has_inline + ')</span>';
          } else {
            el.innerHTML = is_inline;
          }
        }
        // background-gradient -----------------------------------------------------
        else if (select_type === 'background-gradient') {
          if (
            frame_style['background']
          ) {
            has_inline = has_inline_str;
            is_inline = is_inline = '<span style="color: var(--mainColor)"> (inline)</span>';
          }
          if (CSSstyles['background']) {
            el.innerHTML = '<span style="color: var(--mainColor)"> (' + mq_readout + has_inline + ')</span>';
          } else if (getInheritedStyle('background').style) {
            el.innerHTML = '<span style="color: var(--main-text-faded)"> (' + getInheritedStyle('background').breakpoint + has_inline + ')</span>';
          } else {
            el.innerHTML = is_inline;
          }
        }
        // filter -----------------------------------------------------
        else if (select_type === 'filter') {
          if (
            frame_style['filter']
          ) {
            has_inline = has_inline_str;
            is_inline = is_inline = '<span style="color: var(--mainColor)"> (inline)</span>';
          }
          if (CSSstyles['filter']) {
            el.innerHTML = '<span style="color: var(--mainColor)"> (' + mq_readout + has_inline + ')</span>';
          } else if (getInheritedStyle('filter').style) {
            el.innerHTML = '<span style="color: var(--main-text-faded)"> (' + getInheritedStyle('filter').breakpoint + has_inline + ')</span>';
          } else {
            el.innerHTML = is_inline;
          }
        }
        // transform -----------------------------------------------------
        else if (select_type === 'transform') {
          if (
            frame_style['transform'] || frame_style['transform-origin']
          ) {
            has_inline = has_inline_str;
            is_inline = is_inline = '<span style="color: var(--mainColor)"> (inline)</span>';
          }
          if (CSSstyles['transform'] || CSSstyles['transform-origin']) {
            el.innerHTML = '<span style="color: var(--mainColor)"> (' + mq_readout + has_inline + ')</span>';
          } else if (getInheritedStyle('transform').style || getInheritedStyle('transform-origin').style) {
            var t = getInheritedStyle('transform').breakpoint;
            var to = getInheritedStyle('transform-origin').breakpoint;
            readout = check_multiple_classes([t, to]);
            el.innerHTML = '<span style="color: var(--main-text-faded)"> (' + readout + has_inline + ')</span>';
          } else {
            el.innerHTML = is_inline;
          }
        }
        // transform -----------------------------------------------------
        else if (select_type === 'list') {
          if (
            frame_style['list-style-image'] ||
            frame_style['list-style-type'] ||
            frame_style['list-style-position']
          ) {
            has_inline = has_inline_str;
            is_inline = is_inline = '<span style="color: var(--mainColor)"> (inline)</span>';
          }
          if (
            CSSstyles['list-style-image'] ||
            CSSstyles['list-style-type'] ||
            CSSstyles['list-style-position']
          ) {
            el.innerHTML = '<span style="color: var(--mainColor)"> (' + mq_readout + has_inline + ')</span>';
          } else if (
            getInheritedStyle('list-style-image').style ||
            getInheritedStyle('list-style-type').style ||
            getInheritedStyle('list-style-position').style
          ) {
            var lsi = getInheritedStyle('list-style-image').breakpoint;
            var lst = getInheritedStyle('list-style-type').breakpoint;
            var lsp = getInheritedStyle('list-style-position').breakpoint;
            readout = check_multiple_classes([lsi, lst, lsp]);
            el.innerHTML = '<span style="color: var(--main-text-faded)"> (' + readout + has_inline + ')</span>';
          } else {
            el.innerHTML = is_inline;
          }
        }
        // anything else -----------------------------------------------------
        else {
          if (
            frame_style[select_type]
          ) {
            has_inline = has_inline_str;
            is_inline = is_inline = '<span style="color: var(--mainColor)"> (inline)</span>';
          }
          if (CSSstyles[select_type]) {
            el.innerHTML = '<span>' + escapeHTML(CSSstyles[select_type]) + '</span><span style="color: var(--mainColor)"> (' + mq_readout + has_inline + ')</span>';
          } else if (getInheritedStyle(select_type).style) {
            el.innerHTML = '<span>' + escapeHTML(getInheritedStyle(select_type).style) + '</span><span style="color: var(--main-text-faded)"> (' + getInheritedStyle(select_type).breakpoint + has_inline + ')</span>';
          } else {
            var iframe_el = frameID(domElement[0]);
            if (iframe_el) {
              var compStyles = window.getComputedStyle(iframe_el);
              var style = compStyles.getPropertyValue(select_type);
              el.innerHTML = '<span>' + escapeHTML(style) + '</span>' + inheritHTML;
            }
          }
        }
      }, 0);
    });
  }

  // ---------------------------------------------------
  // ---------------------------------------------------
  // Changes the unit from one to the other (px -> %)
  // by regexing anything thats not a number removing it
  // then adding the new unit type.
  function unitChanger(units) {
    if (units === "auto") {
      INPUTER3.value = "auto";
      clickAdder("units");
      return false;
    }

    //console.log('unitChanger', units);

    INPUTER3.value = INPUTER3.value.replace("span", "").trim();
    var numberUnits = INPUTER3.value.replace(theValREGEX, "");
    var oldUnits = INPUTER3.value.match(theValREGEX) || ["null"];
    oldUnits = oldUnits[0];

    //console.log('oldUnits', oldUnits);

    switch (oldUnits) {
      case "px":
        if (units === "%") {
          numberUnits = 100;
        } else if (units === "em" || units === "rem") {
          numberUnits = (Number(numberUnits) / 16).toFixed(1);
        } else if (units === "vh" || units === "vw") {
          numberUnits = (Number(numberUnits) / 10).toFixed(1);
        }
        break;
      case "%":
        if (units === "em" || units === "rem") {
          numberUnits = (Number(numberUnits) / 16).toFixed(1);
        } else if (units === "vh" || units === "vw") {
          numberUnits = (Number(numberUnits) / 10).toFixed(1);
        }
        break;
      case "rem":
      case "em":
        if (units === "px") {
          numberUnits = (Number(numberUnits) * 16).toFixed(1);
        }
        break;
      case "vh":
      case "vw":
        if (units === "px") {
          numberUnits = (16).toFixed(1);
        } else if (units === "%") {
          numberUnits = (100).toFixed(1);
        } else if (units === "em" || units === "rem") {
          numberUnits = (1).toFixed(1);
        }
        break;
    }

    if (units === "fr") {
      numberUnits = 1;
    }
    if (units === "ch") {
      numberUnits = 1;
    }

    //console.log('replaceUnits', numberUnits);

    if (INPUTER3.value !== "auto") {
      if (units !== "none") {
        INPUTER3.value = addUnits(numberUnits);
      } else {
        INPUTER3.value = numberUnits;
      }
    } else if (Number(numberUnits) > 0 || Number(numberUnits) < 0) {
      INPUTER3.value = addUnits(numberUnits);
    } else {
      INPUTER3.value = addUnits(0);
    }
    clearTheUIElementsUnitValue();
    TheUIElementsUnitValueFromInputer3();

    var lock_items;
    switch (INPUTER2.value) {
      case "padding-left":
      case "padding-top":
      case "padding-right":
      case "padding-bottom":
        if (locks_obj['lock_padding'] === 'true') {
          lock_items = [
            "padding-left",
            "padding-top",
            "padding-right",
            "padding-bottom",
          ];
          setLockItems(lock_items);
        } else {
          clickAdder("increment");
        }
        break;
      case "margin-left":
      case "margin-top":
      case "margin-right":
      case "margin-bottom":
        if (locks_obj['lock_margin'] === 'true') {
          lock_items = [
            "margin-left",
            "margin-top",
            "margin-right",
            "margin-bottom"
          ];
          setLockItems(lock_items);
        } else {
          clickAdder("increment");
        }
        break;
      case "border-left-width":
      case "border-top-width":
      case "border-right-width":
      case "border-bottom-width":
        if (locks_obj['lock_border-width'] === 'true') {
          lock_items = [
            "border-left-width",
            "border-top-width",
            "border-right-width",
            "border-bottom-width"
          ];
          setLockItems(lock_items);
        } else {
          clickAdder("increment");
        }
        break;
      case "border-top-left-radius":
      case "border-top-right-radius":
      case "border-bottom-left-radius":
      case "border-bottom-right-radius":
        if (locks_obj['lock_border-radius'] === 'true') {
          lock_items = [
            "border-top-left-radius",
            "border-top-right-radius",
            "border-bottom-left-radius",
            "border-bottom-right-radius",
          ];
          setLockItems(lock_items);
        } else {
          clickAdder("increment");
        }
        break;
      default:
        clickAdder("increment");
        break;
    }
    FillUndo();
    FillValueReadouts();

  }

  function unitChangerForTransform(units) {
    if (lastSettingsButton === "translateX-settings") {
      translateValXUnits = units;
      INPUTER3.value = createNewTransformValues();
    }
    if (lastSettingsButton === "translateY-settings") {
      translateValYUnits = units;
      INPUTER3.value = createNewTransformValues();
    }
    if (lastSettingsButton === "originX-settings") {
      originValXUnits = units;
      INPUTER3.value = createNewTransformOriginValues();
    }
    if (lastSettingsButton === "originY-settings") {
      originValYUnits = units;
      INPUTER3.value = createNewTransformOriginValues();
    }
  }

  function unitChangerForGap(units) {
    if (lastSettingsButton === "gapX-settings") {
      INPUTER3.value = gapValXReadout.innerHTML.replace(theValREGEX, units) + ' ' + gapValYReadout.innerHTML;
    }
    if (lastSettingsButton === "gapY-settings") {
      INPUTER3.value = gapValXReadout.innerHTML + ' ' + gapValYReadout.innerHTML.replace(theValREGEX, units);
    }
  }

  function unitChangerGridTemplate(units, value_el) {
    var val_el = domID(lastSettingsButton).parentElement.querySelector('[' + value_el + ']');
    var arr_index = val_el.getAttribute(value_el);
    var grid_values = [];
    if (INPUTER3.value) {
      if (INPUTER3.value.indexOf(' ') > -1) {
        grid_values = INPUTER3.value.split(' ');
      } else {
        grid_values.push(INPUTER3.value);
      }
    }
    grid_values[arr_index] = val_el.innerHTML.replace(theValREGEX, units);
    var new_grid_values = grid_values.join(' ');
    INPUTER3.value = new_grid_values;
  }

  // ---------------------------------------------------
  // ---------------------------------------------------
  // Changes the unit types

  array_of_units_els.map((el) => {
    addUnitListener(el, el.dataset['unit_val']);
  });

  // ---------------------------------------------------
  // ---------------------------------------------------
  // Sets the unit type and calls unitChanger.
  function addUnitListener(unitsbtn, ItsUnits) {
    unitsbtn.addEventListener("mousedown", function () {
      units = ItsUnits; // Sets global units
      if (ItsUnits === "auto") {
        unitChanger(ItsUnits);
        highlightTheUnitsButton(ItsUnits);
        return false;
      }
      if (!INPUTER3.value) {
        //clearTheUIElementsUnitValue();
        highlightTheUnitsButton(ItsUnits);
        FillValueReadouts();
        buttonRefresh();
        return false;
      }
      if (INPUTER1.value) {
        switch (INPUTER2.value) {
          case "transform":
          case "transform-origin":
            unitChangerForTransform(ItsUnits);
            break;
          case "gap":
            unitChangerForGap(ItsUnits);
            break;
          case "grid-template-columns":
            unitChangerGridTemplate(ItsUnits, 'data-grid_template_columns_value');
            break;
          case "grid-template-rows":
            unitChangerGridTemplate(ItsUnits, 'data-grid_template_rows_value');
            break;
          case "grid-auto-columns":
            unitChangerGridTemplate(ItsUnits, 'data-grid_auto_columns_value');
            break;
          case "grid-auto-rows":
            unitChangerGridTemplate(ItsUnits, 'data-grid_auto_rows_value');
            break;
          default:
            unitChanger(ItsUnits);
            break;
        }
        clickAdder("units");
        highlightTheUnitsButton(ItsUnits);
        FillValueReadouts();
        buttonRefresh();
      }
    });
  }
  // ---------------------------------------------------
  // ---------------------------------------------------
  array_of_units_els[0].style = buttonHLColor;
  // Shows default value on startup.
  // ---------------------------------------------------
  // ---------------------------------------------------
  // Sets the value to auto.
  domID("unit-auto").addEventListener("mousedown", function () {
    if (INPUTER1.value && INPUTER2.value) {
      INPUTER3.value = "auto";
      clickAdder("units");
      FillValueReadouts();
      buttonRefresh();
      clearTheUIElementsUnitValue();
      TheUIElementsUnitValueFromInputer3();
    }
  });

  function toggleClass(element, className) {
    if (!element || !className) {
      return;
    }
    className = " " + className;
    var classString = element.getAttribute('class');
    var nameIndex = classString.indexOf(className);
    if (nameIndex === -1) {
      classString += className;
    } else {
      classString =
        classString.substr(0, nameIndex) +
        classString.substr(nameIndex + className.length);
    }
    element.setAttribute('class', classString);
  }

  function dropdownBelowInputer1() {
    populateClassesDropdown();
    // populateTargetsDropdown();
    // var rect = document
    //   .querySelector(".input-wrap-1")
    //   .getBoundingClientRect();
    // DROPDOWN_CLASSES.style.top = rect.bottom + "px";
    // DROPDOWN_CLASSES.style.left = rect.left + "px";
    // DROPDOWN_CLASSES.style.width = rect.width + "px";
  }


  var mouseover_DROPDOWN_CLASSES = false;
  DROPDOWN_CLASSES.onmouseenter = function () {
    mouseover_DROPDOWN_CLASSES = true;
  };
  DROPDOWN_CLASSES.onmouseleave = function () {
    mouseover_DROPDOWN_CLASSES = false;
  };

  function toggleClassEditDropDown() {
    if (DROPDOWN_CLASSES.classList.contains("active")) {
      if (!mouseover_DROPDOWN_CLASSES) {
        toggleClass(DROPDOWN_CLASSES, "active");
      }
    }
  }

  scrollboxAreaBG.onclick = function () {
    toggleClassEditDropDown();
  };

  var changed;
  var dropdownBelowInputer1_mode = "startup";

  domEvent(ADDCLASS_BTN, "mousedown", function (e) {
    toggle_dropdown_for_selectors('toggle');
    window.removeEventListener("mousedown", onClickOutside);
    iframe.contentWindow.removeEventListener("mousedown", onClickOutside);
    setTimeout(() => {
      onClickOutside_dropdown_classes();
    }, 10);
  });

  domEvent(INPUTER1, "mousedown", function (e) {
    toggle_dropdown_for_selectors('toggle');
    window.removeEventListener("mousedown", onClickOutside);
    iframe.contentWindow.removeEventListener("mousedown", onClickOutside);
    setTimeout(() => {
      onClickOutside_dropdown_classes();
    }, 10);
  });

  let onClickOutside = (e) => {
    if (
      e.target &&
      e.target.parentElement &&
      !e.target.parentElement.getAttribute('data-dp-cls') ||
      !e.target.getAttribute('data-dp-cls')
    ) {
      toggle_dropdown_for_selectors('hide');
    }
  };

  function onClickOutside_dropdown_classes() {
    let dropdown_classes_panel = [...document.querySelectorAll('#dropdown-classes, #dropdown-classes *')];
    dropdown_classes_panel.map(el => {
      el.setAttribute('data-dp-cls', true);
    });
    window.addEventListener("mousedown", onClickOutside);
    iframe.contentWindow.addEventListener("mousedown", onClickOutside);
  }

  function toggle_dropdown_for_selectors(toggle_display = 'toggle') {
    // switches the dropdown type
    if (dropdownBelowInputer1_mode === "startup") {
      changed = false;
    }
    if (dropdownBelowInputer1_mode === "classes") {
      changed = false;
    }
    if (dropdownBelowInputer1_mode === "targets") {
      changed = true;
    }

    if (toggle_display === 'toggle') {
      if (DROPDOWN_CLASSES.classList.contains("active")) {
        if (!changed) {
          toggleClass(DROPDOWN_CLASSES, "active");
        }
      } else {
        toggleClass(DROPDOWN_CLASSES, "active");
      }
    }
    if (toggle_display === 'show') {
      DROPDOWN_CLASSES.classList.add("active");
    }
    if (toggle_display === 'hide') {
      DROPDOWN_CLASSES.classList.remove("active");
    }
    dropdownBelowInputer1_mode = "classes";
    domID("targetDiv").style.display = "none";
    domID("targetDropBox").style.display = "none";
    domID("dropdown-classes-buttons").style.display = "flex";
    domID("dropdown-classes-render").style.display = "flex";
    dropdownBelowInputer1();
  }


  // domEvent(OPEN_TARGET, "mousedown", function () {
  //   if (!frameID(domElement[0])) {
  //     info("Select an element to target its children");
  //     return false;
  //   }
  //   updateClasses(frameID(domElement[0]));
  //   if (dropdownBelowInputer1_mode === "startup") {
  //     changed = false;
  //   }
  //   if (dropdownBelowInputer1_mode === "classes") {
  //     changed = true;
  //   }
  //   if (dropdownBelowInputer1_mode === "targets") {
  //     changed = false;
  //   }
  //   if (DROPDOWN_CLASSES.classList.contains("active")) {
  //     if (!changed) {
  //       toggleClass(DROPDOWN_CLASSES, "active");
  //     }
  //   } else {
  //     toggleClass(DROPDOWN_CLASSES, "active");
  //   }
  //   dropdownBelowInputer1_mode = "targets";
  //   domID("targetDiv").style.display = "flex";
  //   domID("targetDropBox").style.display = "flex";
  //   domID("dropdown-classes-buttons").style.display = "none";
  //   domID("dropdown-classes-render").style.display = "none";
  //   dropdownBelowInputer1();
  // });


  var icon_add = '<i class="material-icons">add</i>';
  var icon_remove = '<i class="material-icons">close</i>';

  function checkIfPseudo(val) {
    if (!val) {
      return false;
    }
    var pass = false;
    [].forEach.call(array_of_pseudos, function (pseudo) {
      if (val.indexOf(":" + pseudo) > -1) {
        pass = pseudo;
      }
    });
    return pass;
  }



  function populateClassesDropdown() {
    // dont render if dropdown classes not visable
    if (!DROPDOWN_CLASSES.classList.contains('active')) {
      return false;
    }
    // first check if the elemet can be selected with selector
    let just_clear = false;
    var has_pseudo = checkIfPseudo(INPUTER1.value);
    let inputter_1_val_without_pseudo = INPUTER1.value.replaceAll(':' + has_pseudo, '');
    let found_els = frameSelectorAll(inputter_1_val_without_pseudo) || [];
    if (
      (!found_els.length) ||
      (
        INPUTER1.value === 'body' ||
        INPUTER1.value === ':root' ||
        INPUTER1.value === ':host')
    ) {
      just_clear = true;
      domElement[0] = "classcss";
      domElement[1] = "DIV";
      INPUTER2.value = "";
      INPUTER3.value = "";
      INPUTER4.value = "";
      buttonRefresh();
      FillValueReadouts();
      DOMtree();
      hightlightClassBtns();
      hightlightALLClassBtns();
      refreshShadowValues();
      refreshTextShadowValues();
      refreshElementAttrs(true);
      other_atributes_container.innerHTML = "";
      inputerColor(INPUTER1);
      inputerColor(INPUTER4);
    }
    let classEls = [];
    let classEls_pseudo = [];
    let arr_of_all_selectors = [];

    function push_to_arr_of_all_selectors(val) {
      if (arr_of_all_selectors.indexOf(val) === -1) {
        arr_of_all_selectors.push(val);
      }
    }
    let full_array_of_pseudos = array_of_pseudos.map(item => {
      return ':' + item;
    });
    let empty_css = {
      "body": false,
      ":host": false,
      ":root": false
    };

    function push_document_has_styles(key) {
      switch (key) {
        case "body":
        case ":host":
        case ":root":
          empty_css[key] = true;
          break;
      }
    }
    for (const [key, value] of Object.entries(thecssLG)) {
      if (!isEmpty(thecssLG[key])) {
        push_to_arr_of_all_selectors(key);
        push_document_has_styles(key);
      }
    }
    for (const [key, value] of Object.entries(thecssMD)) {
      if (!isEmpty(thecssMD[key])) {
        push_to_arr_of_all_selectors(key);
        push_document_has_styles(key);
      }
    }
    for (const [key, value] of Object.entries(thecssSM)) {
      if (!isEmpty(thecssSM[key])) {
        push_to_arr_of_all_selectors(key);
        push_document_has_styles(key);
      }
    }
    for (const [key, value] of Object.entries(thecssXS)) {
      if (!isEmpty(thecssXS[key])) {
        push_to_arr_of_all_selectors(key);
        push_document_has_styles(key);
      }
    }
    arr_of_all_selectors.map(selector => {
      full_array_of_pseudos.map(pseudo_item => {
        let temp_selector = selector.replaceAll(pseudo_item, '');
        let found_els = frameSelectorAll(temp_selector) || [];
        if (found_els.length) {
          found_els.map(el => {
            if (el.id === domElement[0]) {
              if (selector.includes(pseudo_item)) {
                classEls_pseudo.push({
                  'selector': selector,
                  'length': found_els.length,
                  'pseudo': pseudo_item
                });
              } else {
                classEls.push({
                  'selector': selector,
                  'length': found_els.length
                });
              }
            }
          });
        }
      });
    });

    // filter dupes
    classEls_pseudo = classEls_pseudo.filter((value, index, self) =>
      index === self.findIndex((t) => (
        t.selector === value.selector
      ))
    );
    classEls = classEls.filter((value, index, self) =>
      index === self.findIndex((t) => (
        t.selector === value.selector
      ))
    );

    // delete any remaining pseudo
    classEls.forEach((obj, i) => {
      full_array_of_pseudos.map(pseudo_item => {
        if (obj.selector.includes(pseudo_item)) {
          classEls.splice(i, 1);
        }
      });
    });

    // sort
    classEls_pseudo = classEls_pseudo.sort((a, b) => a.selector.localeCompare(b.selector));
    classEls = classEls.sort((a, b) => a.selector.localeCompare(b.selector));
    DROPDOWN_CLASSES_RENDER.innerHTML = '';

    // selectors with CSS
    // -------------------------------------
    let arr_for_without_css_filter = [];
    if (classEls.length && !just_clear) {
      DROPDOWN_CLASSES_RENDER.innerHTML += /*HTML*/ `<span class="drop-select-header" data-dp-cls="true">selectors with CSS:</span>`;
      classEls.map(el => {
        arr_for_without_css_filter.push(el.selector);
        let active = '';
        if (el.selector === INPUTER1.value) {
          active = ` style="${buttonHLColor}"`;
        }
        let page_text = ``;
        if (page_names.length > 1) {
          page_text = ` on ${page_name} page. &#10;It may target elements on ${page_names.length - 1} other page(s).`;
        }
        let button_title = `${el.selector} &#10;targets ${el.length > 1 ? 'this and ' + (el.length - 1)  + ' other element(s)' : 'only this element'}${page_text}`;
        DROPDOWN_CLASSES_RENDER.innerHTML += /*HTML*/ `
        <div class="drop-select" data-dp-cls="true">
          <button 
            data-selector="${escapeHTML(el.selector)}"
            class="drop-select-class"${active} 
            title="${escapeHTML(button_title)}"
            data-dp-cls="true"
          >
            <span data-dp-cls="true">${escapeHTML(el.selector)}</span>
            <span data-dp-cls="true"><i data-dp-cls="true">(${el.length})</i></span>
          </button>
          <button 
            data-delete-selector="${escapeHTML(el.selector)}"
            class="drop-select-delete" 
            title="Delete ${escapeHTML(el.selector)} selector."
            data-dp-cls="true">×
          </button>
        </div>
        `;
      });
    }

    // selectors without CSS
    // -------------------------------------
    let selected_element_classes = [];
    if (frameID(domElement[0]).id !== 'classcss') {
      selected_element_classes = [...frameID(domElement[0]).classList] || [];
      selected_element_classes = selected_element_classes.map(cls => {
        return '.' + cls;
      });
      if (frameID(domElement[0]).id.length === 11 && frameID(domElement[0]).id.includes("ID-")) {
        // dont add id
      } else {
        selected_element_classes.push('#' + frameID(domElement[0]).id);
      }
      selected_element_classes.push(frameID(domElement[0]).tagName.toLowerCase());
      arr_for_without_css_filter.map(filt_item => {
        let pindex = selected_element_classes.indexOf(filt_item);
        if (pindex !== -1) {
          selected_element_classes.splice(pindex, 1);
        }
      });
    }
    if (selected_element_classes.length) {
      selected_element_classes.sort((a, b) => a.localeCompare(b));
      DROPDOWN_CLASSES_RENDER.innerHTML += /*HTML*/ `
      <span class="drop-select-header" data-dp-cls="true">selectors without CSS:</span>`;
      selected_element_classes.map(el => {
        let active = '';
        if (el === INPUTER1.value) {
          active = ` style="${buttonHLColor}"`;
        }
        let number_of_els = '';
        let found_els = frameSelectorAll(el) || [];
        if (found_els.length) {
          number_of_els = /*HTML*/ `<span data-dp-cls="true"><i data-dp-cls="true">(${found_els.length})</i></span>`;
        }
        DROPDOWN_CLASSES_RENDER.innerHTML += /*HTML*/ `
        <div class="drop-select" data-dp-cls="true">
          <button 
            data-selector="${escapeHTML(el)}"
            class="drop-select-class"${active} 
            title="Edit ${escapeHTML(el)} styles." data-dp-cls="true"
          >
            <span data-dp-cls="true">${escapeHTML(el)}</span>
            ${number_of_els}
          </button>
        </div>
        `;
      });
    }

    // CSS pseudo selectors
    // -------------------------------------
    if (classEls_pseudo.length && !just_clear) {
      DROPDOWN_CLASSES_RENDER.innerHTML += /*HTML*/ `<span class="drop-select-header" data-dp-cls="true">CSS pseudo selectors:</span>`;
      classEls_pseudo.map(el => {
        let active = '';
        if (el.selector === INPUTER1.value) {
          active = ` style="${buttonHLColor}"`;
        }
        let page_text = ``;
        if (page_names.length > 1) {
          page_text = ` on ${page_name} page. &#10;It may target elements on ${page_names.length - 1} other page(s).`;
        }
        let button_title = `${el.selector} &#10;targets ${el.length > 1 ? 'this and ' + (el.length - 1)  + ' other element(s)' : 'only this element'}${page_text}`;
        DROPDOWN_CLASSES_RENDER.innerHTML += /*HTML*/ `
          <div class="drop-select" data-dp-cls="true">
            <button 
              data-selector="${escapeHTML(el.selector)}"
              data-pseudo-btn="${escapeHTML(el.pseudo)}"
              class="drop-select-class"${active} 
              title="${escapeHTML(button_title)}"
              data-dp-cls="true">
              <span data-dp-cls="true">${escapeHTML(el.selector)}</span>
              <span data-dp-cls="true"><i data-dp-cls="true">(${el.length})</i></span>
            </button>
            <button 
              data-delete-selector="${escapeHTML(el.selector)}"
              class="drop-select-delete" 
              title="Delete ${escapeHTML(el.selector)} selector."
              data-dp-cls="true">×
            </button>
          </div>
          `;
      });
    }

    // document selectors
    // -------------------------------------
    //if (!classEls.length && !classEls_pseudo.length && !selected_element_classes.length) {
    DROPDOWN_CLASSES_RENDER.innerHTML += /*HTML*/ `
      <span class="drop-select-header" data-dp-cls="true">document selectors:</span>`;
    ['body', ':root', ':host'].map(el => {
      let active = '';
      if (el === INPUTER1.value) {
        active = ` style="${buttonHLColor}"`;
      }
      DROPDOWN_CLASSES_RENDER.innerHTML += /*HTML*/ `
        <div class="drop-select" data-dp-cls="true">
          <button 
            data-selector="${escapeHTML(el)}"
            class="drop-select-class"${active} 
            title="Edit ${escapeHTML(el)} styles."
            data-dp-cls="true"
          >
            <span data-dp-cls="true">${escapeHTML(el)}</span>
          </button>
          <button 
            style="${empty_css[el] ? '' : 'display: none;'}" 
            data-delete-selector="${escapeHTML(el)}"
            class="drop-select-delete" 
            title="Delete ${escapeHTML(el)} selector."
            data-dp-cls="true">×
          </button>
        </div>
        `;
    });
    //}

    // all selectors
    // -------------------------------------
    if (!classEls.length && !classEls_pseudo.length && !selected_element_classes.length) {
      arr_of_all_selectors = arr_of_all_selectors.sort((a, b) => a.localeCompare(b));

      DROPDOWN_CLASSES_RENDER.innerHTML += /*HTML*/ `
      <span class="drop-select-header" data-dp-cls="true">all CSS selectors:</span>`;
      arr_of_all_selectors =

        arr_of_all_selectors.map(el => {
          if (
            el === 'body' ||
            el === ':root' ||
            el === ':host'
          ) {
            return;
          }
          let number_of_els = '';
          let found_els = frameSelectorAll(el) || [];
          if (found_els.length) {
            number_of_els = /*HTML*/ `<span data-dp-cls="true"><i data-dp-cls="true">(${found_els.length})</i></span>`;
          }
          let active = '';
          if (el === INPUTER1.value) {
            active = ` style="${buttonHLColor}"`;
          }
          let page_text = ``;
          if (page_names.length > 1) {
            page_text = ` on ${page_name} page. &#10;It may target elements on ${page_names.length - 1} other page(s).`;
          }
          let button_title = `${el} &#10;targets ${found_els.length} element(s)${page_text}`;
          DROPDOWN_CLASSES_RENDER.innerHTML += /*HTML*/ `
      <div class="drop-select" data-dp-cls="true">
        <button 
          data-selector="${escapeHTML(el)}"
          class="drop-select-class"${active} 
          title="${escapeHTML(button_title)}"
          data-dp-cls="true"
        >
          <span data-dp-cls="true">${escapeHTML(el)}</span>
          ${number_of_els}
        </button>
        <button 
          data-delete-selector="${escapeHTML(el)}"
          class="drop-select-delete" 
          title="Delete ${escapeHTML(el)} selector."
          data-dp-cls="true">×
        </button>
      </div>
      `;
        });
    }

    let dropdown_els = [...document.querySelectorAll('.drop-select-class')];
    let arr_selectors = [];

    dropdown_els.map(el => {

      let data_selector = el.getAttribute('data-selector');
      arr_selectors.push(data_selector);

      el.ondblclick = function () {
        DROPDOWN_CLASSES.classList.remove('active');
      };

      el.onclick = function () {
        if (data_selector) {
          INPUTER1.value = data_selector;
          if (
            data_selector === 'body' ||
            data_selector === ':root' ||
            data_selector === ':host'
          ) {
            deselectElement();
            INPUTER1.value = data_selector;
            FillValueReadouts();
            DROPDOWN_CLASSES.classList.remove('active');
          } else {
            if (domElement[0] === 'classcss') {
              let found_els = frameSelectorAll(data_selector) || [];
              if (found_els.length) {
                selectElement(frameID(found_els[0].id));
              }
            } else {
              frameID(domElement[0]).setAttribute('data-tracker', data_selector);
              selectElement(frameID(domElement[0]));
            }
          }
        }
        let data_pseudo = el.getAttribute('data-pseudo-btn');
        if (data_pseudo) {
          data_pseudo = data_pseudo.substring(1);
          pseudo_select.value = data_pseudo;
        } else {
          pseudo_select.value = '';
        }
        populateClassesDropdown();
      };
    });

    let dropdown_els_delete = [...document.querySelectorAll('.drop-select-delete')];
    dropdown_els_delete.map(el => {
      el.onclick = function () {
        let selector = el.getAttribute('data-delete-selector');
        let is_ok_to_remove = confirm(`This will remove all ${selector} CSS & selectors.`);
        if (is_ok_to_remove) {
          delete thecssLG[selector];
          delete thecssMD[selector];
          delete thecssSM[selector];
          delete thecssXS[selector];
          let found_els = [...classcss.querySelectorAll(`[data-tracker="${selector}"]`)] || [];
          if (found_els.length) {
            found_els.map(el => {
              el.removeAttribute('data-tracker');
            });
          }
          //deselectElement();
          FillUndo();
          selectElement(frameID(domElement[0]));
          return;
        } else {
          return;
        }
      };
    });

    // populate combo dropdown
    let arr_child_selectors_of_current = [];
    let el_child_els_of_current = [];
    let inputer1_clear_of_pseudo = INPUTER1.value;

    full_array_of_pseudos.map(pseudo_item => {
      if (!pseudo_item.includes('::')) {
        if (inputer1_clear_of_pseudo.includes(pseudo_item)) {
          inputer1_clear_of_pseudo = inputer1_clear_of_pseudo.replaceAll(pseudo_item, '');
        }
      }
    });

    el_child_els_of_current = frameSelectorAll(`${inputer1_clear_of_pseudo} *`) || [];
    el_child_els_of_current.map(el => {
      if (el.id.length && el.id.length !== 11 && !el.id.includes("ID-")) {
        let id_val = `#${el.id}`;
        if (arr_child_selectors_of_current.indexOf(id_val) === -1) {
          arr_child_selectors_of_current.push(id_val);
        }
      }
      if (el.tagName.toLowerCase() !== 'br') {
        let tag_name = el.tagName.toLowerCase();
        if (arr_child_selectors_of_current.indexOf(tag_name) === -1) {
          arr_child_selectors_of_current.push(tag_name);
        }
      }
      if (el.className) {
        let el_classes = [...el.classList];
        el_classes.map(cls => {
          let class_name = `.${cls}`;
          if (arr_child_selectors_of_current.indexOf(class_name) === -1) {
            arr_child_selectors_of_current.push(class_name);
          }
        });
      }
    });

    arr_child_selectors_of_current = arr_child_selectors_of_current.sort((a, b) => a.localeCompare(b));
    comboselect.innerHTML = /*HTML*/ ``;
    if (arr_child_selectors_of_current.length) {
      comboselect
        .parentElement
        .parentElement
        .style.cssText = ``;
      arr_child_selectors_of_current.map(selector => {
        comboselect.innerHTML += /*HTML*/ `<option value="${escapeHTML(selector)}">${escapeHTML(selector)}</option>`;
      });
    } else {
      comboselect
        .parentElement
        .parentElement
        .style.cssText = `opacity: 0.5; pointer-events: none;`;
    }
    comboselect.value = '';

  }


  const clearselector = domID('clear-selector');
  clearselector.onclick = () => {
    INPUTER1.value = '';
    FillValueReadouts();
    populateClassesDropdown();
  };


  const comboselect = domID('combo-select');
  comboselect.onchange = () => {
    INPUTER1.value = INPUTER1.value.trim();
    INPUTER1.value = INPUTER1.value + " " + comboselect.value;
    populateClassesDropdown();
  };
  const comboclear = domID('clear-combo');
  comboclear.onclick = () => {
    INPUTER1.value = INPUTER1.value.trim();
    let selectors_arr = [];
    if (INPUTER1.value.indexOf(' ')) {
      selectors_arr = INPUTER1.value.split(' ');
      selectors_arr.pop();
      selectors_arr = selectors_arr.join(' ');
    }
    if (selectors_arr.length) {
      INPUTER1.value = selectors_arr.trim();
      populateClassesDropdown();
    }
  };



  INPUTER4_WRAP.style.display = "none";

  OPEN_RENAME.onmouseup = function () {
    if (!INPUTER1.value.trim()) {
      alert('No selector specified.');
      return;
    }
    var rename_selector = prompt(
      "This will rename all " + INPUTER1.value + " selectors in the CSS. \nAny elements this selector targets may not be targetted anymore.", INPUTER1.value
    );
    if (rename_selector) {
      let selector = INPUTER1.value;
      if (selector === rename_selector) {
        return;
      }
      if (
        thecssLG[rename_selector] ||
        thecssMD[rename_selector] ||
        thecssSM[rename_selector] ||
        thecssXS[rename_selector]
      ) {
        alert('This selector already exists in the CSS, aborting.');
        return;
      }
      if (thecssLG[selector]) {
        thecssLG[rename_selector] = thecssLG[selector];
        delete thecssLG[selector];
      }
      if (thecssMD[selector]) {
        thecssMD[rename_selector] = thecssMD[selector];
        delete thecssMD[selector];
      }
      if (thecssSM[selector]) {
        thecssSM[rename_selector] = thecssSM[selector];
        delete thecssSM[selector];
      }
      if (thecssXS[selector]) {
        thecssXS[rename_selector] = thecssXS[selector];
        delete thecssXS[selector];
      }
      let found_els_with_data_tracker = [...classcss.querySelectorAll(`[data-tracker="${selector}"]`)] || [];
      found_els_with_data_tracker.map(el => {
        el.removeAttribute('data-tracker');
      });
      FillUndo();
      INPUTER1.value = rename_selector;
      selectElement(frameID(domElement[0]));
      return;
    } else {
      return;
    }
  };

  OPEN_DUPLICATE.onmouseup = function () {
    if (!INPUTER1.value.trim()) {
      alert('No selector specified.');
      return;
    }
    var copy_selector = prompt(
      "This will create duplicates of all " + INPUTER1.value + " selectors in the CSS with the selector given.", INPUTER1.value
    );
    if (copy_selector) {
      let selector = INPUTER1.value;
      if (selector === copy_selector) {
        return;
      }
      if (
        thecssLG[copy_selector] ||
        thecssMD[copy_selector] ||
        thecssSM[copy_selector] ||
        thecssXS[copy_selector]
      ) {
        alert('This selector already exists in the CSS, aborting.');
        return;
      }
      if (thecssLG[selector]) {
        thecssLG[copy_selector] = JSON.parse(JSON.stringify(thecssLG[selector]));
      }
      if (thecssMD[selector]) {
        thecssMD[copy_selector] = JSON.parse(JSON.stringify(thecssMD[selector]));
      }
      if (thecssSM[selector]) {
        thecssSM[copy_selector] = JSON.parse(JSON.stringify(thecssSM[selector]));
      }
      if (thecssXS[selector]) {
        thecssXS[copy_selector] = JSON.parse(JSON.stringify(thecssXS[selector]));
      }
      //deselectElement();
      let found_els_with_data_tracker = [...classcss.querySelectorAll(`[data-tracker="${selector}"]`)] || [];
      found_els_with_data_tracker.map(el => {
        el.removeAttribute('data-tracker', copy_selector);
      });
      FillUndo();
      INPUTER1.value = copy_selector;
      selectElement(frameID(domElement[0]));
      return;
    } else {
      return;
    }
  };

  let CSS_copy = {};

  COPY_SELECTOR_STYLES.onclick = () => {
    CSS_copy = {};
    for (const property in CSSstyles) {
      CSS_copy[property] = CSSstyles[property];
    }
  };

  PASTE_SELECTOR_STYLES.onclick = () => {
    for (const property in CSS_copy) {
      switch (breakPoint) {
        case "fullWidth":
          if (!thecssLG[INPUTER1.value]) {
            put(INPUTER1.value, {}, thecssLG);
          }
          put(property, CSS_copy[property], thecssLG[INPUTER1.value]);
          break;
        case "breakPoint1":
          if (!thecssMD[INPUTER1.value]) {
            put(INPUTER1.value, {}, thecssMD);
          }
          put(property, CSS_copy[property], thecssMD[INPUTER1.value]);
          break;
        case "breakPoint2":
          if (!thecssSM[INPUTER1.value]) {
            put(INPUTER1.value, {}, thecssSM);
          }
          put(property, CSS_copy[property], thecssSM[INPUTER1.value]);
          break;
        case "breakPoint3":
          if (!thecssXS[INPUTER1.value]) {
            put(INPUTER1.value, {}, thecssXS);
          }
          put(property, CSS_copy[property], thecssXS[INPUTER1.value]);
          break;
      }
    }
    FillValueReadouts();
    FillUndo();
    refreshCodeView();
    selectElement(frameID(domElement[0]));
  };

  DELETE_SELECTOR_STYLES.onclick = () => {
    switch (breakPoint) {
      case "fullWidth":
        delete thecssLG[INPUTER1.value];
        break;
      case "breakPoint1":
        delete thecssMD[INPUTER1.value];
        break;
      case "breakPoint2":
        delete thecssSM[INPUTER1.value];
        break;
      case "breakPoint3":
        delete thecssXS[INPUTER1.value];
        break;
    }
    FillValueReadouts();
    FillUndo();
    refreshCodeView();
    selectElement(frameID(domElement[0]));
  };

  CLEANCLASSES.onmouseup = function () {
    if (!INPUTER1.value.trim()) {
      alert('No selector specified.');
      return;
    }
    var remove_selector = confirm(
      "This will remove all " + INPUTER1.value + " CSS & selectors."
    );
    if (remove_selector) {
      let selector = INPUTER1.value;
      delete thecssLG[selector];
      delete thecssMD[selector];
      delete thecssSM[selector];
      delete thecssXS[selector];
      let found_els_with_data_tracker = [...classcss.querySelectorAll(`[data-tracker="${selector}"]`)] || [];
      found_els_with_data_tracker.map(el => {
        el.removeAttribute('data-tracker');
      });
      FillUndo();
      INPUTER1.value = '';
      selectElement(frameID(domElement[0]));
      return;
    } else {
      return;
    }
  };

  function clearOpenButtons() {
    OPEN_RENAME.removeAttribute('style');
    OPEN_DUPLICATE.removeAttribute('style');
  }

  function closeInputer4() {
    INPUTER1_WRAP.style.display = null;
    INPUTER4_WRAP.style.display = "none";
    clearOpenButtons();
  }

  OPEN_CANCEL.onclick = function () {
    closeInputer4();
  };

  // INPUTER4.onblur = function () {
  //   closeInputer4();
  // };

  domID("renameClass").onclick = function () {
    closeInputer4();
  };
  domID("addAnotherClass").onclick = function () {
    closeInputer4();
  };
  domID("copyClass").onclick = function () {
    closeInputer4();
  };

  // OPEN_TARGET.onmouseup = function () {
  //   con("OPEN_TARGET");
  // };

  domEvent(ADDPROP_BTN, "mousedown", clickAdder);
  domEvent(REMOVEPROP_BTN, "mousedown", function () {
    clickRemoveProp(false);
  });

  // ---------------------------------------------------
  // ---------------------------------------------------
  // Fills spaces with - to avoid multiple classes and invalid CSS property names.

  function reload() {
    window.location.reload();
  }

  function handler_mouse_foward_back(event) {
    event = event || window.event;
    event.preventDefault();
    var btnCode;
    if ('object' === typeof event) {
      btnCode = event.button;
      switch (btnCode) {
        case 3:
          if (fullScreenMode) {
            reload();
          } else {
            undoBtn();
          }
          break;
        case 4:
          if (fullScreenMode) {
            reload();
          } else {
            redoBtn();
          }
          break;
      }
    }
  }


  var body = document.getElementsByTagName('body')[0];
  body.onmouseup = function (e) {
    if (overScrollbox === false) {
      handler_mouse_foward_back(e);
    }
  };


  function set_inputer1_value() {
    inputerColor(INPUTER1);
    INPUTER2.value = "";
    INPUTER3.value = "";
    var stylesBreak = cssStylesBreakPoints();
    if (stylesBreak[INPUTER1.value.trim()]) {
      FillValueReadouts();
    }
    let found_els = frameSelectorAll(INPUTER1.value.trim()) || [];
    if (found_els.length) {
      found_els[0].setAttribute('data-tracker', INPUTER1.value.trim());
      selectElement(found_els[0]);
      NUMBEROFELSFORSELECTOR.innerHTML = `targets: <i style="color: var(--button-text)">${found_els.length}</i>`;
    } else {
      iframeElementSelect.setAttribute('target', '');
      NUMBEROFELSFORSELECTOR.innerHTML = ``;
      domID('selector-name').textContent = ``;
    }
  }

  INPUTER1.oninput = function () {
    set_inputer1_value();
  };

  INPUTER1.onblur = function () {
    INPUTER1.value = INPUTER1.value.trim();
    set_inputer1_value();
  };

  INPUTER2.onclick = function () {
    var stylesBreak = cssStylesBreakPoints();
    if (!stylesBreak[INPUTER1.value]) {
      if (INPUTER1.value) {
        clickAddClass();
      }
      return false;
    }
  };

  INPUTER2.oninput = function () {
    var stylesBreak = cssStylesBreakPoints();
    if (!stylesBreak[INPUTER1.value]) {
      return false;
    }
    INPUTER2.value = INPUTER2.value.replace(/\s/g, "-");
    if (CSSstyles[INPUTER2.value]) {
      INPUTER3.value = CSSstyles[INPUTER2.value];
    } else {
      INPUTER3.value = "";
    }
    FillValueReadouts();
    //openTabForProperty(INPUTER2.value);
  };

  INPUTER3.oninput = function () {
    clickAdder();
    if (inline_external_css !== 'inline') {
      setTimeout(function () {
        FillValueReadouts();
      }, 300);
    }
  };

  INPUTER3.onblur = function () {
    setTimeout(function () {
      FillValueReadouts();
    }, 300);
  };

  INPUTER3.addEventListener("keydown", function (event) {
    if (event.key === "Enter") {
      con(INPUTER3.value);
      if (INPUTER1.value && INPUTER2.value && INPUTER3.value) {
        FillUndo();
      }
    }
  });

  INPUTER3.addEventListener("blur", function (event) {
    con(INPUTER3.value);
    if (INPUTER1.value && INPUTER2.value && INPUTER3.value) {
      FillUndo();
    }
  });

  INPUTER4.oninput = function () {
    INPUTER4.value = INPUTER4.value.replace(/\s/g, "-");
    inputerColor(INPUTER4);
  };

  function inputerColor(inputer1) {
    var stylesBreak = cssStylesBreakPoints();
    if (!stylesBreak[inputer1.value]) {
      inputer1.style.color = "gray";
    } else {
      inputer1.style.color = null;
    }
  }

  // Adds a class to the thecss object.
  function clickAddClass() {
    var input1 = INPUTER1.value;
    var input2 = INPUTER2.value;
    con('clickAddClass', input1, input2);
    if (input1 && !input2) {
      if (!thecssLG[INPUTER1.value]) {
        put(input1, {}, thecssLG);
        put(input1, {}, thecssMD);
        put(input1, {}, thecssSM);
        put(input1, {}, thecssXS);
        info("Class has been added.", null, null);
      }
    } else if (input1 && input2) {
      INPUTER1.value = "";
      INPUTER2.value = "";
      INPUTER3.value = "";
      info(
        "You need to add a new class name first with no property.",
        null,
        null
      );
    } else {
      info("You need to add or select a class name!", null, null);
    }
    buttonRefresh();
    populateClassesDropdown();
  }
  // ---------------------------------------------------
  // ---------------------------------------------------
  // Adds the property and value to the thecss object.
  function clickAdder(buttonType) {
    var input1 = INPUTER1.value;
    var input2 = INPUTER2.value;
    var input3 = INPUTER3.value;
    var canDelete = true;
    if (!input1) {
      info("No classname or element selected.", 4000, true);
      return false;
    }
    if (buttonType === "units" || buttonType === "increment") {
      canDelete = false;
    }

    if (inline_external_css === 'inline') {
      frameID(domElement[0]).style[input2] = input3;
    } else {
      switch (breakPoint) {
        case "fullWidth":
          if (!thecssLG[input1]) {
            put(input1, {}, thecssLG);
            selectElement(frameID(domElement[0]));
          }
          break;
        case "breakPoint1":
          if (!thecssMD[input1]) {
            put(input1, {}, thecssMD);
            selectElement(frameID(domElement[0]));
          }
          break;
        case "breakPoint2":
          if (!thecssSM[input1]) {
            put(input1, {}, thecssSM);
            selectElement(frameID(domElement[0]));
          }
          break;
        case "breakPoint3":
          if (!thecssXS[input1]) {
            put(input1, {}, thecssXS);
            selectElement(frameID(domElement[0]));
          }
          break;
      }

      if (input2 && !input3) {
        switch (breakPoint) {
          case "fullWidth":
            put(input2, input3, thecssLG[input1]);
            break;
          case "breakPoint1":
            put(input2, input3, thecssMD[input1]);
            break;
          case "breakPoint2":
            put(input2, input3, thecssSM[input1]);
            break;
          case "breakPoint3":
            put(input2, input3, thecssXS[input1]);
            break;
        }
        info("Property added.", null, null);
      } else if (input2 && input3) {
        switch (breakPoint) {
          case "fullWidth":
            if (thecssLG[input1][input2] !== input3) {
              put(input2, input3, thecssLG[input1]);
            } else {
              if (canDelete) {
                del(input2, thecssLG[input1]);
                INPUTER2.value = "";
                INPUTER3.value = "";
              }
            }
            break;
          case "breakPoint1":
            if (thecssMD[input1][input2] !== input3) {
              put(input2, input3, thecssMD[input1]);
            } else {
              if (canDelete) {
                del(input2, thecssMD[input1]);
                INPUTER2.value = "";
                INPUTER3.value = "";
              }
            }
            break;
          case "breakPoint2":
            if (thecssSM[input1][input2] !== input3) {
              put(input2, input3, thecssSM[input1]);
            } else {
              if (canDelete) {
                del(input2, thecssSM[input1]);
                INPUTER2.value = "";
                INPUTER3.value = "";
              }
            }
            break;
          case "breakPoint3":
            if (thecssXS[input1][input2] !== input3) {
              put(input2, input3, thecssXS[input1]);
            } else {
              if (canDelete) {
                del(input2, thecssXS[input1]);
                INPUTER2.value = "";
                INPUTER3.value = "";
              }
            }
            break;
        }
      } else if (!input1) {
        if (testIfcss()) {
          info("Select an element.", null, null);
        } else {
          info(
            "You need to create a element with a class name.",
            null,
            null
          );
        }
      }

    }
    buttonRefresh();
  }
  // ---------------------------------------------------
  // ---------------------------------------------------
  // Removes the Class from thecss object.
  function clickRemoveClass() {
    var input1 = INPUTER1.value;
    INPUTER2.focus();
    var elementsHaveClass = classcss.getElementsByClassName(input1);
    if (elementsHaveClass.length !== 0) {
      info(
        "You need to remove the elements with this classname first.",
        4000,
        null
      );
    } else {
      switch (breakPoint) {
        case "fullWidth":
          del(input1, thecssLG);
          break;
        case "breakPoint1":
          del(input1, thecssMD);
          break;
        case "breakPoint2":
          del(input1, thecssSM);
          break;
        case "breakPoint3":
          del(input1, thecssXS);
          break;
      }
      INPUTER1.value = "";
      clickAdder(null);
      FillValueReadouts();
      buttonRefresh();
      populateClassesDropdown();
    }
  }
  // ---------------------------------------------------
  // ---------------------------------------------------
  // Removes the property from thecss object.
  function clickRemoveProp(passedProp) {
    var input1 = INPUTER1.value;
    var input2;
    if (!input1) {
      info("No classname or element selected.", 4000, true);
      return false;
    }
    if (passedProp) {
      input2 = passedProp;
    } else {
      input2 = INPUTER2.value;
    }
    if (!input2) {
      return false;
    }
    if (inline_external_css === 'inline') {
      frameID(domElement[0]).style[input2] = '';
    } else {
      switch (breakPoint) {
        case "fullWidth":
          del(input2, thecssLG[input1]);
          break;
        case "breakPoint1":
          del(input2, thecssMD[input1]);
          break;
        case "breakPoint2":
          del(input2, thecssSM[input1]);
          break;
        case "breakPoint3":
          del(input2, thecssXS[input1]);
          break;
      }
      INPUTER2.value = "";
    }
    remove_vendor_prefixes_data.map((prefix) => {
      remove_prefixed_css(prefix + input2);
    });
    info("Property removed.");
    INPUTER3.value = "";
    clickAdder("increment");
    FillValueReadouts();
    buttonRefresh();
  }
  // ---------------------------------------------------
  // ---------------------------------------------------
  // Refresh GUI
  function buttonRefresh() {
    FillStorage();
    logger();
    FillStorageHTML();
    BoxRefresh();
    refreshElementAttrs();
  }
  // ---------------------------------------------------
  // ---------------------------------------------------
  // Refresh CodeView
  // ---------------------------------------------------
  // ---------------------------------------------------
  // Breakpoint buttons
  BREAKPOINT_BTN_LG.style = buttonHLColor;

  function selectElementMouseEvent() {
    if (domElement[0] === "classcss") {
      return false;
    }
    selectElement(frameID(domElement[0]));
    BoxRefresh();
  }

  function setScrollBoxToFullWidth() {
    document.documentElement.style.setProperty('--scrollbox_width', scrollbox_width_resizer_vars + 'px');
    document.documentElement.style.setProperty('--scrollbox_width_with_side_panels', scrollbox_width_resizer_vars_with_side_panels + 'px');
    let scrollbox_width_offset = scrollbox_width_resizer_vars + 30;
    SCROLLBOX.style.maxWidth = `calc(100% - ${scrollbox_width_offset}px)`; // scrollbox_width
    SCROLLBOX.style.minWidth = `calc(100% - ${scrollbox_width_offset}px)`; // scrollbox_width
    var sourceDimensions = SCROLLBOX;
    var computedStyle = window.getComputedStyle(sourceDimensions, null);
    var scrollBoxWidth = Number(
      computedStyle.getPropertyValue("width").replace(theValREGEX, "")
    );

    if (isEven(scrollBoxWidth)) {} else {
      scrollBoxWidth--;
    }
    SCROLLBOX_HANDEL.value = scrollBoxWidth.toString();
    setScrollboxResizeBlocker();
    SCROLLBOX.style.minWidth = scrollBoxWidth + "px";
    SCROLLBOX.style.maxWidth = scrollBoxWidth + "px";
    return scrollBoxWidth;
  }
  // Needs calling at startup or the scrollBox gets nasty white lines.
  setScrollBoxToFullWidth();

  BREAKPOINT_BTN_LG.onmousedown = function () {
    clickedBP = true;
    fullWidth();
    css_external();
  };

  function fullWidth() {
    // 
    breakPoint = "fullWidth";
    BREAKPOINT_BTN_LG.style = buttonHLColor;
    BREAKPOINT_BTN_MD.style = buttonBGColor;
    BREAKPOINT_BTN_SM.style = buttonBGColor;
    BREAKPOINT_BTN_XS.style = buttonBGColor;
    setBreakPointLine(BREAKPOINT_LINE_LG);
    setMediaQuerySliderReadout();
    if (clickedBP) {
      set_BREAKPOINT_LINE_FULL();
      setScrollboxResizeBlocker();
      SCROLLBOX.style.minWidth = ScrollboxSizeVal + "px";
      BREAKPOINT_WIDTH_READOUT.innerHTML = ScrollboxSizeVal + " x " + iframe.offsetHeight + BREAKPOINT_WIDTH_READOUT_mode;

      selectElementMouseEvent();
    }
    clickedBP = false;
    FillValueReadouts();
    refreshShadowValues();
    refreshTextShadowValues();
    storeTheCurrentBreakpoint();
  }

  BREAKPOINT_BTN_MD.onmousedown = function () {
    clickedBP = true;
    breakPoint1();
    css_external();
  };

  function breakPoint1() {
    // 
    breakPoint = "breakPoint1";
    BREAKPOINT_BTN_LG.style = buttonBGColor;
    BREAKPOINT_BTN_MD.style = buttonHLColor;
    BREAKPOINT_BTN_SM.style = buttonBGColor;
    BREAKPOINT_BTN_XS.style = buttonBGColor;
    setBreakPointLine(BREAKPOINT_LINE_MD);
    setMediaQuerySliderReadout();
    if (clickedBP) {
      set_BREAKPOINT_LINE_3();
      setScrollboxResizeBlocker();
      SCROLLBOX.style.minWidth = ScrollboxSizeVal + "px";
      BREAKPOINT_WIDTH_READOUT.innerHTML = ScrollboxSizeVal + " x " + iframe.offsetHeight + BREAKPOINT_WIDTH_READOUT_mode;

      selectElementMouseEvent();
    }
    clickedBP = false;
    FillValueReadouts();
    refreshShadowValues();
    refreshTextShadowValues();
    storeTheCurrentBreakpoint();
  }
  BREAKPOINT_BTN_SM.onmousedown = function () {
    clickedBP = true;
    breakPoint2();
    css_external();
  };

  function breakPoint2() {
    // 
    breakPoint = "breakPoint2";
    BREAKPOINT_BTN_LG.style = buttonBGColor;
    BREAKPOINT_BTN_MD.style = buttonBGColor;
    BREAKPOINT_BTN_SM.style = buttonHLColor;
    BREAKPOINT_BTN_XS.style = buttonBGColor;
    setBreakPointLine(BREAKPOINT_LINE_SM);
    setMediaQuerySliderReadout();
    if (clickedBP) {
      set_BREAKPOINT_LINE_2();
      setScrollboxResizeBlocker();
      SCROLLBOX.style.minWidth = ScrollboxSizeVal + "px";
      BREAKPOINT_WIDTH_READOUT.innerHTML = ScrollboxSizeVal + " x " + iframe.offsetHeight + BREAKPOINT_WIDTH_READOUT_mode;

      selectElementMouseEvent();
    }
    clickedBP = false;
    FillValueReadouts();
    refreshShadowValues();
    refreshTextShadowValues();
    storeTheCurrentBreakpoint();
  }
  BREAKPOINT_BTN_XS.onmousedown = function () {
    clickedBP = true;
    breakPoint3();
    css_external();
  };

  function breakPoint3() {
    // 
    breakPoint = "breakPoint3";
    BREAKPOINT_BTN_LG.style = buttonBGColor;
    BREAKPOINT_BTN_MD.style = buttonBGColor;
    BREAKPOINT_BTN_SM.style = buttonBGColor;
    BREAKPOINT_BTN_XS.style = buttonHLColor;
    setBreakPointLine(BREAKPOINT_LINE_XS);
    setMediaQuerySliderReadout();
    if (clickedBP) {
      set_BREAKPOINT_LINE_1();
      setScrollboxResizeBlocker();
      SCROLLBOX.style.minWidth = ScrollboxSizeVal + "px";
      BREAKPOINT_WIDTH_READOUT.innerHTML = ScrollboxSizeVal + " x " + iframe.offsetHeight + BREAKPOINT_WIDTH_READOUT_mode;

      selectElementMouseEvent();
    }
    clickedBP = false;
    FillValueReadouts();
    refreshShadowValues();
    refreshTextShadowValues();
    storeTheCurrentBreakpoint();
  }
  // ---------------------------------------------------
  // ---------------------------------------------------
  // Store the current Breakpoint
  function storeTheCurrentBreakpoint() {
    window.localStorage.setItem("lastBreakpoint", breakPoint);
    window.localStorage.setItem(
      "scrollBoxSizeValue",
      SCROLLBOX_HANDEL.value
    );
  }
  // Set the breakpoint when the page loads
  function setBreakpointWhenPageLoads() {
    var lastBreakpoint = window.localStorage.getItem("lastBreakpoint");
    var scrollBoxSizeValue = window.localStorage.getItem(
      "scrollBoxSizeValue"
    );
    var scrollBoxSizeValue_vertical = window.localStorage.getItem(
      "scrollBoxSizeValue_vertical"
    );

    if (scrollBoxSizeValue_vertical) {
      SCROLLBOX.style.height = scrollBoxSizeValue_vertical + 'px';
      let styles = window.getComputedStyle(SCROLLBOX);
      let h = parseInt(styles.height, 10);
      if ((h + 100) > (window.innerHeight)) {
        SCROLLBOX.style.height = (window.innerHeight - 98) + 'px';
      }
      if (SCROLLBOX.offsetHeight < 200) {
        SCROLLBOX.style.removeProperty('height');
      }
    } else {
      if (SCROLLBOX.offsetHeight < 200) {
        SCROLLBOX.style.removeProperty('height');
      }
      //SCROLLBOX.style.height = (window.innerHeight - 98) + 'px';
      // setTimeout(() => {
      //   let styles = window.getComputedStyle(SCROLLBOX);
      //   let h = parseInt(styles.height, 10);
      //   window.localStorage.setItem("scrollBoxSizeValue_vertical", h);
      // }, 1500);
    }



    var fullWidthVal;
    if (!lastBreakpoint || !scrollBoxSizeValue) {

      if (!mobileFirst) {
        clickedBP = true;
        fullWidth();
      } else {
        clickedBP = true;
        breakPoint3();
      }
    }
    if (lastBreakpoint && scrollBoxSizeValue) {
      if (
        scrollBoxSizeValue <= getScrollBoxMax() &&
        scrollBoxSizeValue >= breakPoint_Min_Value
      ) {
        SCROLLBOX_HANDEL.value = scrollBoxSizeValue.toString();
        setScrollboxResizeBlocker();
        SCROLLBOX.style.minWidth = scrollBoxSizeValue + "px";
        BREAKPOINT_WIDTH_READOUT.innerHTML = scrollBoxSizeValue + " x " + iframe.offsetHeight + BREAKPOINT_WIDTH_READOUT_mode;
        if (lastBreakpoint === 'fullWidth') {
          clickedBP = false;
          fullWidth();
        }
        if (lastBreakpoint === 'breakPoint1') {
          clickedBP = false;
          breakPoint1();
        }
        if (lastBreakpoint === 'breakPoint2') {
          clickedBP = false;
          breakPoint2();
        }
        if (lastBreakpoint === 'breakPoint3') {
          clickedBP = false;
          breakPoint3();
        }
      } else {
        fullWidthVal = getScrollBoxMax();
        SCROLLBOX_HANDEL.value = fullWidthVal.toString();
        setScrollboxResizeBlocker();
        SCROLLBOX.style.minWidth = fullWidthVal + "px";
        BREAKPOINT_WIDTH_READOUT.innerHTML = fullWidthVal + " x " + iframe.offsetHeight + BREAKPOINT_WIDTH_READOUT_mode;
        clickedBP = true;
        fullWidth();
      }
    }
    storeTheCurrentBreakpoint();
  }
  // ---------------------------------------------------
  // ---------------------------------------------------
  // Gets the current breakpoint css object.
  function cssStylesBreakPoints() {
    var input1 = INPUTER1.value;
    var CSSstyleCurrent;
    switch (breakPoint) {
      case "fullWidth":
        CSSstyleCurrent = thecssLG;
        BP = 'LG';
        //CSSstyles = thecss[input1];
        break;
      case "breakPoint1":
        CSSstyleCurrent = thecssMD;
        BP = 'MD';
        //CSSstyles = thecssBP1[input1];
        break;
      case "breakPoint2":
        CSSstyleCurrent = thecssSM;
        BP = 'SM';
        //CSSstyles = thecssBP2[input1];
        break;
      case "breakPoint3":
        CSSstyleCurrent = thecssXS;
        BP = 'XS';
        //CSSstyles = thecssBP3[input1];
        break;
    }
    if (input1 && CSSstyleCurrent[input1]) {
      CSSstyles = CSSstyleCurrent[input1];
    } else {
      CSSstyles = {};
    }
    return CSSstyleCurrent;
  }
  // ---------------------------------------------------
  // ---------------------------------------------------
  // Writes CSS into the head style tag of iframe.
  function logger() {
    if (mobileFirst) {
      placeInHead.innerHTML = createCSSForMobileFirst();
    } else {
      placeInHead.innerHTML = createCSSForMobileLast();
    }
    if (codesection.style.display !== "none") {
      refreshCodeView();
    }
    if (preview_active) {
      set_preview_css_html();
    }
  }
  // ---------------------------------------------------
  // ---------------------------------------------------
  // Gets blobs using localforage.
  function createObjectOfBlobs() {
    objectOfBlobs = {};
    return localforage
      .iterate(function (value, key, iterationNumber) {
        if (
          value.type === "image/png" ||
          value.type === "image/jpeg" ||
          value.type === "image/jpg" ||
          value.type === "image/gif" ||
          value.type === "image/svg+xml"
        ) {
          var blob = window.URL.createObjectURL(value);
          objectOfBlobs[key] = blob;
        }
      })
      .then(function () {
        logger();
      });
  }
  // ---------------------------------------------------
  // ---------------------------------------------------
  // Creates the CSS replaces background immage urls with
  // blob image urls.
  function thecssConcat(obj) {
    var showMeMap = Object.keys(obj)
      .map(function (rule) {
        var showMeMapVals = Object.keys(obj[rule])
          .map(function (prop) {
            // here to change bg image
            if (prop === "background-image") {
              var split3 = removeURLBrackets(obj[rule][prop]);
              if (split3 !== 'not-image-url') {
                var resultofSplit = objectOfBlobs[split3] + "";
                return prop + ": url(" + resultofSplit + ");";
              } else {
                return prop + ":" + obj[rule][prop] + ";";
              }
            } else {
              return prop + ":" + obj[rule][prop] + ";";
            }
          })
          .join("");
        if (showMeMapVals) {
          return rule + "{" + showMeMapVals + "}";
        }
      })
      .join("");
    return showMeMap;
  }

  function createCSSForMobileLast() {
    var forReturn =
      thecssConcat(thecssLG) +
      "@media screen and (max-width: " +
      (breakPoint_MD_Value - 0.02) +
      "px) {" +
      thecssConcat(thecssMD) +
      "}" +
      "@media screen and (max-width: " +
      (breakPoint_SM_Value - 0.02) +
      "px) {" +
      thecssConcat(thecssSM) +
      "}" +
      "@media screen and (max-width: " +
      (breakPoint_XS_Value - 0.02) +
      "px) {" +
      thecssConcat(thecssXS) +
      "}";
    return forReturn;
  }

  function createCSSForMobileFirst() {
    var forReturn =
      thecssConcat(thecssXS) +
      "@media screen and (min-width: " +
      (breakPoint_XS_Value) +
      "px) {" +
      thecssConcat(thecssSM) +
      "}" +
      "@media screen and (min-width: " +
      (breakPoint_SM_Value) +
      "px) {" +
      thecssConcat(thecssMD) +
      "}" +
      "@media screen and (min-width: " +
      (breakPoint_MD_Value) +
      "px) {" +
      thecssConcat(thecssLG) +
      "}";
    return forReturn;
  }
  // ---------------------------------------------------
  // ---------------------------------------------------
  // set media query readout under sliders.
  function setMediaQuerySliderReadout() {
    BREAKPOINT_LINE_XS.style.width = breakPoint_XS_Value + "px";
    BREAKPOINT_LINE_SM.style.width = breakPoint_SM_Value + "px";
    BREAKPOINT_LINE_MD.style.width = breakPoint_MD_Value + "px";
  }
  setMediaQuerySliderReadout();

  function setMediaQueryToInputs() {
    BREAKPOINT_INPUT_XS.value = breakPoint_XS_Value.toString();
    BREAKPOINT_INPUT_SM.value = breakPoint_SM_Value.toString();
    BREAKPOINT_INPUT_MD.value = breakPoint_MD_Value.toString();
  }

  function setInputsToMediaQuery() {
    breakPoint_XS_Value = Number(
      BREAKPOINT_INPUT_XS.value.replace(theValREGEX, "")
    );
    breakPoint_SM_Value = Number(
      BREAKPOINT_INPUT_SM.value.replace(theValREGEX, "")
    );
    breakPoint_MD_Value = Number(
      BREAKPOINT_INPUT_MD.value.replace(theValREGEX, "")
    );
    setBreakPointCSSvariables();
  }

  function BREAKPOINT_SETTINGS_toggle() {
    var isOff = BREAKPOINT_SETTINGS_CONTAINER.classList[0];
    setMediaQueryToInputs();
    if (isOff === "off") {
      BREAKPOINT_SETTINGS_CONTAINER.setAttribute("class", "on");
    } else {
      BREAKPOINT_SETTINGS_CONTAINER.setAttribute("class", "off");
    }
    BREAKPOINT_INPUTS_DEFAULTS.innerHTML = "default";
    if (
      Number(BREAKPOINT_INPUT_MD.value) === 992 &&
      Number(BREAKPOINT_INPUT_SM.value) === 768 &&
      Number(BREAKPOINT_INPUT_XS.value) === 576
    ) {
      BREAKPOINT_INPUTS_DEFAULTS.style.opacity = 0.4;
    } else {
      BREAKPOINT_INPUTS_DEFAULTS.style.opacity = 1;
    }
  }


  BREAKPOINT_SETTINGS.onmousedown = function () {
    BREAKPOINT_SETTINGS_toggle();
  };

  setMediaQueryToInputs();
  BREAKPOINT_INPUTS_CANCEL.onmousedown = closeMediaQSettings;

  function closeMediaQSettings() {
    var isOff = BREAKPOINT_SETTINGS_CONTAINER.classList[0];
    if (isOff !== "off") {
      BREAKPOINT_SETTINGS_CONTAINER.setAttribute("class", "off");
    }
  }

  BREAKPOINT_INPUTS_DEFAULTS.onmousedown = function () {
    if (
      Number(BREAKPOINT_INPUT_MD.value) === 992 &&
      Number(BREAKPOINT_INPUT_SM.value) === 768 &&
      Number(BREAKPOINT_INPUT_XS.value) === 576
    ) {
      BREAKPOINT_INPUT_MD.value = breakPoint_MD_Value;
      BREAKPOINT_INPUT_SM.value = breakPoint_SM_Value;
      BREAKPOINT_INPUT_XS.value = breakPoint_XS_Value;
      BREAKPOINT_INPUTS_DEFAULTS.innerHTML = "default";
    } else {
      BREAKPOINT_INPUT_MD.value = 992;
      BREAKPOINT_INPUT_SM.value = 768;
      BREAKPOINT_INPUT_XS.value = 576;
      BREAKPOINT_INPUTS_DEFAULTS.innerHTML = "current";
    }
  };

  BREAKPOINT_INPUTS_APPLY.onmousedown = function () {
    if (
      Number(BREAKPOINT_INPUT_MD.value) === breakPoint_MD_Value &&
      Number(BREAKPOINT_INPUT_SM.value) === breakPoint_SM_Value &&
      Number(BREAKPOINT_INPUT_XS.value) === breakPoint_XS_Value
    ) {
      return false;
    }
    var pass = true;
    var border = "1px solid red";
    BREAKPOINT_INPUT_MD.style.border = null;
    BREAKPOINT_INPUT_SM.style.border = null;
    BREAKPOINT_INPUT_XS.style.border = null;
    BREAKPOINT_INPUTS_DEFAULTS.innerHTML = "default";
    if (
      BREAKPOINT_INPUT_MD.value === "992" &&
      BREAKPOINT_INPUT_SM.value === "768" &&
      BREAKPOINT_INPUT_XS.value === "576"
    ) {
      BREAKPOINT_INPUTS_DEFAULTS.style.opacity = 0.4;
    } else {
      BREAKPOINT_INPUTS_DEFAULTS.style.opacity = 1;
    }
    var maxWidth = Number(getScrollBoxMax());
    var Tablet = Number(BREAKPOINT_INPUT_MD.value);
    var mobHoz = Number(BREAKPOINT_INPUT_SM.value);
    var mobVert = Number(BREAKPOINT_INPUT_XS.value);
    //---------------------------------------------------
    // Tablet
    if (mobVert < breakPoint_Min_Value || mobVert > mobHoz) {
      info(
        "Mobile vert needs to be greater than " + breakPoint_Min_Value + " px and less than Mobil hoz",
        7000,
        null
      );
      if (pass) {
        BREAKPOINT_INPUT_XS.style.border = border;
      }
      pass = false;
    } else if (mobHoz < mobVert || Tablet < mobHoz) {
      info(
        "Mobile hoz needs to be greater than Mobile vert and less than Tablet width",
        7000,
        null
      );
      if (pass) {
        BREAKPOINT_INPUT_SM.style.border = border;
      }
      pass = false;
    } else if (Tablet > maxWidth || Tablet < mobHoz) {
      info(
        "Tablet needs to be less than canvas width and greater than Mobile hoz",
        7000,
        null
      );
      if (pass) {
        BREAKPOINT_INPUT_MD.style.border = border;
      }
      pass = false;
    }
    //---------------------------------------------------
    if (!pass) {
      return false;
    }

    setInputsToMediaQuery();
    FillStorageBreakpoints();
    logger();
    refreshCodeView();
    FillUndo();
    //closeMediaQSettings();
    setBreakpointWhenPageLoads();
    //window.location.reload();
    var lastBreakpoint = window.localStorage.getItem("lastBreakpoint");
    if (lastBreakpoint === 'fullWidth') {
      clickedBP = true;
      fullWidth();
    }
    if (lastBreakpoint === 'breakPoint1') {
      clickedBP = true;
      breakPoint1();
    }
    if (lastBreakpoint === 'breakPoint2') {
      clickedBP = true;
      breakPoint2();
    }
    if (lastBreakpoint === 'breakPoint3') {
      clickedBP = true;
      breakPoint3();
    }
  };
  // ---------------------------------------------------
  // ---------------------------------------------------
  // media modes mobile first / responsive.
  mobileFirstBtn.onmousedown = function () {
    mobileFirstTrue();
    FillStoragemobileFirst();
    mobileFirstBtn.style = buttonHLColor;
    mobileLastBtn.style = buttonBGColor;
    logger();
    refreshCodeView();


  };
  mobileLastBtn.onmousedown = function () {
    mobileFirstFalse();
    FillStoragemobileFirst();
    mobileFirstBtn.style = buttonBGColor;
    mobileLastBtn.style = buttonHLColor;
    logger();
    refreshCodeView();
  };

  // ---------------------------------------------------
  // ---------------------------------------------------
  // insertAdjacentHTML shortened.
  /*
    domAdd : adds an HTML element to the DOM
    domAdd(A HTML Element, 'afterbegin', '<button id="' + val + '">the id : '+ val);
    ---------------------------------------------------
    // domAdd // params= 1.where in DOM - 2.Adjacent mode - 3.What to add.
    Possible places:
    <!-- 'beforebegin' -->
    <p>
      <!-- 'afterbegin' -->
      foo
      <!-- 'beforeend' -->
    </p>
    <!-- 'afterend' -->
    */
  function domAdd(addItTo, place, whatToAdd) {
    return addItTo.insertAdjacentHTML(place, whatToAdd);
  }


  // ---------------------------------------------------
  // ---------------------------------------------------
  // addEventListener shortened
  /*
    Example:
    domAdd(a_HTML_element, 'mousedown', a function());
    ---------------------------------------------------
    domevent // params= 1.What in DOM - 2.possible types:
    https://www.w3schools.com/jsref/dom_obj_event.asp
    - 3.What to add.
    */
  function domEvent(addItTo, typeofevent, whatItFires) {
    if (!addItTo || !typeofevent || !whatItFires) {
      return;
    } else {
      return addItTo.addEventListener(typeofevent, whatItFires);
    }
  }
  // ---------------------------------------------------
  // ---------------------------------------------------
  // Toggles class of a element of a given ID
  /** 
   * Example:
   * domToggle('domID(ID)', 'mousedown', 'domID(ID)', 'cssClass');
   * ------------------------------------------------------------
   * triggerId ........ could be ID of a button that you click on.
   * eventtrigger ..... could be a click hover ect..
   * targetid ......... ID of the item you are toggling class of
   * targetcssClass ... css class (can in css file)
   */
  function domTogCSS(triggerId, eventtrigger, targetid, targetcssClass) {
    domID(triggerId).addEventListener(eventtrigger, function () {
      toggleClass(domID(targetid), targetcssClass);
    });

    function toggleClass(element, className) {
      if (!element || !className) {
        return;
      }
      var classString = element.getAttribute('class');
      var nameIndex = classString.indexOf(className);
      if (nameIndex === -1) {
        classString += " " + className;
      } else {
        classString =
          classString.substr(0, nameIndex) +
          classString.substr(nameIndex + className.length);
      }
      element.setAttribute('class', classString);
    }
  }
  // ---------------------------------------------------
  // ---------------------------------------------------
  // Toggle class of elements.
  domTogCSS("inputer1", "mouseenter", "inputer1", "classdiv");
  domTogCSS("inputer1", "mouseleave", "inputer1", "classdiv");
  domTogCSS("inputer2", "mouseenter", "inputer2", "classdiv");
  domTogCSS("inputer2", "mouseleave", "inputer2", "classdiv");
  domTogCSS("inputer3", "mouseenter", "inputer3", "classdiv");
  domTogCSS("inputer3", "mouseleave", "inputer3", "classdiv");
  // ---------------------------------------------------
  // ---------------------------------------------------
  // Generates a unique ID for each added element.
  function guidGenerator() {
    var S4 = function () {
      return ((1 + Math.random()) * 0x10000).toString(16).substring(1, 5);
    };
    uniqid = "ID-" + (S4() + S4());
    return uniqid;
  }
  // 

  // Generates a unique class for each added element.
  function classGenerator(tag) {
    var S4 = function () {
      return ((1 + Math.random()) * 0x10000).toString(16).substring(1, 4);
    };
    uniqid = tag + "-" + S4() + S4();
    return uniqid;
  }
  // ---------------------------------------------------
  // ----------------------------------------------------
  // ---------------------------------------------------
  // ----------------------------------------------------
  // SelectElement [ Fires when element is clicked ]
  // Event targets elements on canvas or buttons of app.

  /***
   *     ######  ######## ##       ########  ######  ########
   *    ##    ## ##       ##       ##       ##    ##    ##
   *    ##       ##       ##       ##       ##          ##
   *     ######  ######   ##       ######   ##          ##
   *          ## ##       ##       ##       ##          ##
   *    ##    ## ##       ##       ##       ##    ##    ##
   *     ######  ######## ######## ########  ######     ##
   *
   *    ######## ##       ######## ##     ## ######## ##    ## ########
   *    ##       ##       ##       ###   ### ##       ###   ##    ##
   *    ##       ##       ##       #### #### ##       ####  ##    ##
   *    ######   ##       ######   ## ### ## ######   ## ## ##    ##
   *    ##       ##       ##       ##     ## ##       ##  ####    ##
   *    ##       ##       ##       ##     ## ##       ##   ###    ##
   *    ######## ######## ######## ##     ## ######## ##    ##    ##
   */

  function targetDropBoxRefresh(theElement) {
    if (!theElement) {
      return false;
    }
    if (!frameID(theElement.id)) {
      return false;
    }
    if (!frameID(theElement.id).children) {
      return false;
    }
    if (frameID(theElement.id).children.length) {
      if (domID("targetDropBox").firstChild) {
        targetDropText.textContent = "select a target";
        domID("targetDiv").style.opacity = "1";
        domID("targetDiv").style.pointerEvents = "initial";
      } else {
        targetDropText.textContent = "children need a unique class";
        domID("targetDiv").style.opacity = null;
        domID("targetDiv").style.pointerEvents = null;
      }
    } else {
      domID("targetDiv").style.opacity = null;
      domID("targetDiv").style.pointerEvents = null;
      targetDropText.textContent = "for parents only";
    }
  }

  // add to array elements that shouldnt get deselected
  const web_components = [
    "dp-carousel",
    "dp-accordion",
    "dp-accordion-group",
    "dp-scroll-drag",
    "dp-tabs",
    "dp-tab",
    "dp-header",
  ];

  function is_this_or_parents_web_component() {
    var current_el = frameID(domElement[0]);
    if (!current_el) {
      return false;
    }
    var pass = false;
    web_components.map((item) => {
      let closest_web_component = current_el.closest(item);
      if (closest_web_component) {
        pass = true;
      }
    });
    if (domElement[1].toLowerCase().indexOf('dp-') > -1) {
      pass = false;
    }
    if (domElement[1].toLowerCase().indexOf("dp-carousel") > -1) {
      pass = true;
    }
    if (domElement[1].toLowerCase().indexOf("dp-scroll-drag") > -1) {
      pass = true;
    }
    if (domElement[1].toLowerCase().indexOf("dp-tabs") > -1) {
      pass = true;
    }
    if (domElement[1].toLowerCase().indexOf("dp-tab") > -1) {
      pass = true;
    }
    if (domElement[1].toLowerCase().indexOf("dp-header") > -1) {
      pass = true;
    }
    return pass;
  }

  function deselectElement() {
    if (editingText === true) {
      return false;
    }
    if (is_this_or_parents_web_component()) {
      return false;
    }
    //selectElement(classcss);
    domElement[0] = "classcss";
    domElement[1] = "DIV";
    // domElement[1] = "";

    //selectElement(classcss);
    clearInputer1OfPseudo();
    INPUTER1.value = "";
    INPUTER2.value = "";
    INPUTER3.value = "";
    INPUTER4.value = "";
    buttonRefresh();
    FillValueReadouts();
    DOMtree();
    hightlightClassBtns();
    hightlightALLClassBtns();
    refreshShadowValues();
    refreshTextShadowValues();
    refreshElementAttrs(true);
    other_atributes_container.innerHTML = "";
    inputerColor(INPUTER1);
    inputerColor(INPUTER4);
    populateClassesDropdown();
    //other_atributes_container.innerHTML = "";
  }

  function selectElement(theElement) {

    //toggleClassEditDropDown();
    //populateClassesDropdown();

    //con(theElement);
    if (!theElement) {
      theElement = frameID(domElement[0]);
      // INPUTER1.value = null;
      // return false;
    }
    if (!theElement) {
      theElement = frameID(domElement[0]);
      INPUTER1.value = null;
      return false;
    }
    if (overScrollbox) {
      //domTreeBtnHighlight(theElement.id);
    }

    if (theElement.nodeType === Node.TEXT_NODE) {
      INPUTER1.value = null;
      return false;
    }


    // check the element can query with data tracker
    let get_el = false;
    let els_with_this_data_tracker = frameSelectorAll(`${theElement.getAttribute('data-tracker')}`) || [];
    els_with_this_data_tracker.map(el => {
      if (theElement.id === el.id) {
        get_el = true;
      }
    });

    // if the data-tracker doesnt target the element check if its because of pseudo
    if (!get_el) {
      let current_data_tracker = theElement.getAttribute('data-tracker');
      let pseudo_check = checkIfPseudo(current_data_tracker);
      if (!pseudo_check) {
        theElement.setAttribute('data-tracker', '');
      }
    }
    if (theElement.getAttribute('data-tracker').length === 12 && theElement.getAttribute('data-tracker').includes("#ID-")) {
      theElement.setAttribute('data-tracker', theElement.tagName.toLowerCase());
    }
    if (!theElement.getAttribute('data-tracker')) {
      if (theElement.getAttribute('class')) {
        let class_to_add = theElement.classList[0];
        theElement.setAttribute('data-tracker', '.' + class_to_add);
      } else {
        let id_to_add = '#' + theElement.id;
        if (id_to_add.length === 12 && id_to_add.includes("#ID-")) {
          theElement.setAttribute('data-tracker', theElement.tagName.toLowerCase());
        } else {
          theElement.setAttribute('data-tracker', id_to_add);
        }
      }
    }
    targetDropBoxRefresh(theElement);
    if (frameID(domElement[0])) {
      var el = frameID(domElement[0]);
      el.removeAttribute("contenteditable");
      el.draggable = false;
    }
    if (!theElement) {
      return false;
    }
    if (classcss.children.length) {
      if (INPUTER1.value !== theElement.getAttribute('data-tracker').trim()) {
        INPUTER2.value = "";
        INPUTER3.value = "";
      }
      if (theElement.id !== domElement[0]) {
        INPUTER1.value =
          theElement.getAttribute('data-tracker').trim();
      }
      let input_pseudo = checkIfPseudo(INPUTER1.value.trim());
      if (input_pseudo) {
        pseudo_select.value = input_pseudo;
      }
      theElement.setAttribute('data-tracker', INPUTER1.value.trim());

      updateClasses(frameID(theElement.id));
      targetDropBoxRefresh();
      domElement = [];
      domElement[0] = theElement.id;
      domElement[1] = theElement.tagName;
      copyPlace = [];
      copyPlace.push(domElement[0]);
      copyPlace.push(domElement[1]);
      classcss.removeAttribute('data-tracker');
      SCROLLBOX.removeAttribute('data-tracker');

      cssStylesBreakPoints();
      if (!CSSstyles) {
        put(INPUTER1.value, {}, thecssLG);
        put(INPUTER1.value, {}, thecssMD);
        put(INPUTER1.value, {}, thecssSM);
        put(INPUTER1.value, {}, thecssXS);
        selectElement(frameID(domElement[0]));
        return false;
      }

      populateClassesDropdown();
      buttonRefresh();
      FillValueReadouts();
      DOMtree(theElement.id);
      hightlightClassBtns();
      hightlightALLClassBtns();
      refreshShadowValues();
      refreshTextShadowValues();
      inputerColor(INPUTER1);
      inputerColor(INPUTER4);
      var elementDisplay = frameID(theElement.id);
      var elementDisplayStyle = window.getComputedStyle(
        elementDisplay,
        null
      );
      var elementDisplayStyleProp = elementDisplayStyle.getPropertyValue(
        "display"
      );
      var elementDisplayStylePropCheck = domID(
        "display-" + elementDisplayStyleProp + ""
      );
      if (elementDisplayStylePropCheck) {
        elementDisplayStylePropCheck.style.borderColor = BorderHL;
      }
      if (altKeyPressed) {
        theElement.draggable = true;
      } else {
        theElement.draggable = false;
      }
      theElement.ondragstart = function (event) {
        dragStart(event);
      };
      theElement.ondragend = function (event) {
        dragEnd(event);
      };
    }
    //
    //localStorage.setItem("domElement", domElement[0]);
    selectScroller(theElement);

    // if (!frameID(theElement.id).getAttribute('class') && INPUTER1.value !== 'domposer-element,body') {
    //   INPUTER1.value = null;
    //   //delete frameID(theElement.id)['data-tracker'];
    //   frameID(theElement.id).removeAttribute('data-tracker');
    // }

    //add_tree_arrays(domElement[0]);
    //clickTreeExpand_render();






  }
  // ---------------------------------------------------
  // ----------------------------------------------------
  // Returns true if it is a DOM node.
  function isNode(o) {
    return typeof Node === "object" ?
      o instanceof Node :
      o &&
      typeof o === "object" &&
      typeof o.nodeType === "number" &&
      typeof o.nodeName === "string";
  }
  // ---------------------------------------------------
  // ----------------------------------------------------
  // Scrolls to the selected element on the canvas.
  function selectScroller() {
    if (!autoScroll) {
      return false;
    }
    if (!frameID(domElement[0])) {
      return false;
    }

    var canvasHeight = iframe.getBoundingClientRect().height;
    var rect = frameID(domElement[0]).getBoundingClientRect();

    var scrollAmount;
    if (rect.height > canvasHeight) {
      scrollAmount = rect.top - 40;
    } else {
      scrollAmount = (rect.top + ((rect.height / 2) - (canvasHeight / 2))) - 40;
    }

    iframe.contentWindow.window.scrollBy({
      top: scrollAmount,
      behavior: 'smooth',
    });

  }
  // ---------------------------------------------------
  // ----------------------------------------------------
  // Scrolls to the selected element on the canvas.
  function autoScroller(theElement, scrollTime, smoothOrAuto) {

    if (isNode(theElement)) {} else {
      theElement = frameID(theElement);
    }
    setTimeout(function () {
      if (!theElement) {
        return false;
      }
      theElement.scrollIntoView({
        behavior: smoothOrAuto,
        block: "center",
        inline: "center"
      });

    }, scrollTime);
  }
  // ---------------------------------------------------
  // ----------------------------------------------------
  // updates the highlight of dom tree buttons
  function domTreeBtnHighlight(dataid) {
    if (dataid === '""') {
      return false;
    }
    var el = document.querySelector('[data-clicks= "' + dataid + '"]');
    if (el) {
      el.style.transition = "background-color 0.15s";
      el.setAttribute("class", "domTree_HL");
    }
    var scrollEl = document.querySelector(".domTree_HL");
    autoScroller(scrollEl, 10, "auto");
  }

  // ---------------------------------------------------
  // ----------------------------------------------------
  // Drag and Drop
  // dragStart
  function dragStart(event) {
    classcss.draggable = false;
    if (!fullScreenMode) {
      event.dataTransfer.dropEffect = "move";
      event.dataTransfer.setData("text", event.target.id);
      frameID(event.target.getAttribute("id")).style.outline = null;
      frameID(event.target.getAttribute("id")).style.borderBottom = null;
    }
  }
  // dragEnter
  function dragEnter(event) {
    try {
      classcss.draggable = false;
      if (!fullScreenMode) {
        //event.preventDefault();
        let over_el = event.target.getAttribute("id");
        iframeElementSelect.setAttribute('target-hover', over_el);
        var theElementItsOver = frameID(over_el);

        let data_dropper = [...classcss.querySelectorAll('[data-dropper]')];
        data_dropper.map((el) => {
          el.remove();
        });
        if (dragover_element) {
          //console.log('dragEnter theElementItsOver', theElementItsOver);
          theElementItsOver.insertAdjacentHTML("afterend", dragover_element);
          return false;
        }

        if (event.target.tagName === "IMG") {
          if (event.dataTransfer.files[0]) {
            theElementItsOver.style.outline = "1px dashed #0F0";
          } else {
            theElementItsOver.style.outline = "1px dashed #0F0";
          }
        }

      }
    } catch (err) {
      con("dragEnter error : " + err.message);
    }
  }
  // dragLeave
  function dragLeave(event) {
    try {
      event.preventDefault();
      frameID(event.target.getAttribute("id")).style.outline = null;
      frameID(event.target.getAttribute("id")).style.borderBottom = null;
    } catch (err) {
      con("dragLeave error : " + err.message);
    }
  }
  // dragDrop
  function dragDrop(event) {
    event.preventDefault();
    var droppedIMG = event.dataTransfer.files[0];
    // A canvas file drop must be an image before creating or saving a reference.
    if (droppedIMG && !(droppedIMG.type || '').startsWith('image/')) {
      info('Only image files can be dropped onto the canvas. Use Upload project to import a ZIP.', false, true);
      return false;
    }
    var element = frameID(event.target.id);

    let data_dropper = [...classcss.querySelectorAll('[data-dropper]')];
    data_dropper.map((el) => {
      el.remove();
    });

    let drop_element = event.dataTransfer.getData("application/drop-element");
    if (drop_element) {
      //console.log(drop_element);
      if (element) {
        domElement[0] = element.id;
        domElement[1] = element.tagName;
      }
      addElement(drop_element);
      return false;
    }

    var elemId = event.dataTransfer.getData("text");
    var libraryImageName = event.dataTransfer.getData("application/x-domposer-image");
    if (event.target.tagName === "IMG") {
      if (libraryImageName) {
        element.dataset.image = libraryImageName;
        renderImagesFromIndexedDB();
        FillStorageHTML();
        FillUndo();
        DOMtree();
      } else if (event.dataTransfer.files[0]) {
        if (event.dataTransfer.files[0].type.includes("image/")) {
          const imageName = droppedIMG.name;
          element.dataset.image = imageName;
          var url = window.URL.createObjectURL(droppedIMG);
          event.target.src = url;
          localforage.setItem(imageName, droppedIMG);
          renderPreviewImagesFromIndexedDB();
          frameID(
            event.target.getAttribute("id")
          ).style.outline = null;
          FillStorageHTML();
          FillUndo();
          DOMtree();
        }
      } else if (Blob) {
        element.dataset.image = dragDBimageName;
        frameID(event.target.getAttribute("id")).style.outline = null;
        FillStorageHTML();
        FillUndo();
        DOMtree();
        renderImagesFromIndexedDB();
      } else {
        insertAfter(event.target, frameID(elemId));
        removeAttributes();
        FillUndo();
        DOMtree();
      }
    } else {

      if (event.target.tagName !== "img") {

        var imageSave;

        if (!isDBimage && droppedIMG && droppedIMG.type.startsWith("image/")) {
          imageSave = localforage.setItem(droppedIMG.name, droppedIMG);
        }

        guidGenerator();
        var HTML_to_add = {
          tag: "img",
          id: uniqid,
          class: "dropped_img"
        };
        HTML_to_add['alt'] = 'alt text';
        HTML_to_add['data-image'] = isDBimage ? dragDBimageName : droppedIMG.name;

        var id_to_select = HTML_to_add.id;

        if (
          event.target.id === "classcss" ||
          event.target.tagName.toLowerCase() === "dp-carousel" ||
          event.target.tagName.toLowerCase() === "dp-scroll-drag"
        ) {
          domAddElement(event.target, "beforeend", HTML_to_add);
        } else {
          domAddElement(event.target, "afterend", HTML_to_add);
        }

        info(
          event.target.tagName,
          null,
          null
        );
        FillStorageHTML();
        if (imageSave) {
          imageSave.then(function () {
            renderImagesFromIndexedDB();
            renderPreviewImagesFromIndexedDB();
          });
        } else {
          renderImagesFromIndexedDB();
        }
        FillUndo();
        DOMtree();
        setTimeout(function () {
          BoxRefresh();
          selectElement(frameID(id_to_select));
        }, 60);

        // info(
        //   "You can only drag images onto image elements.",
        //   null,
        //   null
        // );
        return false;
      }
      insertAfter(event.target, frameID(elemId));
      removeAttributes();
      FillUndo();
      DOMtree();
    }
    droppedIn = true;
    if (event.target.id !== "classcss") {
      setTimeout(function () {
        BoxRefresh();
        selectElement(frameID(event.target.id));
      }, 60);
    }

    function removeAttributes() {
      frameID(elemId).removeAttribute("draggable");
      // domID(elemId).style.cursor = 'default';
      frameID(event.target.getAttribute("id")).style.outline = null;
      frameID(event.target.getAttribute("id")).style.borderBottom = null;
    }
    setTimeout(function () {
      FillStorageHTML();
      BoxRefresh();
    }, 10);
  }
  // dragEnd
  function dragEnd(event) {
    if (droppedIn === false) {}
    frameID(event.target.getAttribute("id")).style.outline = null;
    frameID(event.target.getAttribute("id")).style.borderBottom = null;
    buttonRefresh();
    selectElement(frameID(event.target.id));
    droppedIn = false;
    setTimeout(function () {
      [].forEach.call(classcss.children, function (el) {
        el.draggable = false;
        var elsChildren = el.getElementsByTagName("*");
        [].forEach.call(elsChildren, function (elChild) {
          elChild.draggable = false;
        });
      });
    }, 310);
  }

  // ---------------------------------------------------
  // ----------------------------------------------------
  // Refresh element Attributes and tag name inputs
  function listAttributes(el) {
    //console.log(el);
    // First, let's verify that the paragraph has some attributes
    if (el.hasAttributes()) {
      var attrs = [...el.attributes];
      var output = {};
      attrs.map((attr) => {
        switch (attr.name) {
          case "id":
          case "class":
          case "draggable":
          case "data-tracker":
            break;
          case "src":
            if (el.tagName.toLowerCase() === "script") {
              output[attr.name] = attr.value;
            }
            break;
          case "data-image":
            output[attr.name] = attr.value;
            break;
          default:
            output[attr.name] = attr.value;
        }
      });
      //console.log(output);
      return output;
    }
  }

  var select__element = domID("select__element");
  var select__element_options = document.querySelectorAll('#select__element option');
  // class
  var attrsClassList = domID('attrs-class-list');
  var attrsClass = domID('attrs-class');
  var attrsClassRemove = domID('attrs-class-remove');
  // id
  var attrsID = domID('attrs-id');
  var attrsIDRemove = domID('attrs-id-remove');
  // others
  var other_atributes_container = domID('other-atributes');

  function refreshElementAttrs(clear) {

    setTimeout(function () {
      // ------------------------------------------------------------------
      // element tag name
      if (!domElement[1] || domElement[0] === 'classcss') {
        select__element.value = "";
        select__element.style = null;
        attrsClass.value = "";
        attrsClass.style = null;
        attrsID.value = "";
        attrsID.style = null;
        return false;
      }

      if (!frameID(domElement[0])) {
        select__element.value = "";
        select__element.style = null;
        attrsClass.value = "";
        attrsClass.style = null;
        attrsID.value = "";
        attrsID.style = null;
        return false;
      }

      var tag_type = domElement[1].toLowerCase();
      [].forEach.call(select__element_options, function (element_option) {
        element_option.removeAttribute("selected");
      });

      if (!clear) {
        select__element.value = tag_type;
        var select_option_el = document.querySelector('#select__element option[value="' + tag_type + '"]');
        var first_option = document.querySelector('#select__element option[value="other-type"]');
        if (select_option_el) {
          select_option_el.setAttribute("selected", true);
          select__element.style = 'color: var(--mainColor);';
          first_option.textContent = '';
        } else {
          first_option.textContent = tag_type;
          first_option.setAttribute("selected", true);
        }
      } else {
        select__element.value = "";
        select__element.style = null;
      }

      if (!clear) {
        attrsClass.value = frameID(domElement[0]).getAttribute('class');
        attrsClass.style = 'color: var(--mainColor); padding-right: 1px;';
      } else {
        attrsClass.value = "";
        attrsClass.style = null;
      }

      // ------------------------------------------------------------------
      // id attribute
      if (!clear) {
        if (
          frameID(domElement[0]).id.length === 11 &&
          frameID(domElement[0]).id.includes("ID-")
        ) {
          attrsID.value = '';
          attrsID.style = null;
        } else {
          attrsID.value = frameID(domElement[0]).id;
          attrsID.style = 'color: var(--mainColor); padding-right: 1px;';
        }
      } else {
        attrsID.value = "";
        attrsID.style = null;
      }

      // ------------------------------------------------------------------

      if (!clear) {
        // other attributes
        var attrs = listAttributes(frameID(domElement[0]));
        other_atributes_container.replaceChildren(attributeRows(attrs, all_image_options || []));
        for (const property in attrs) {
          var other_attrsID = domID(`attrs-${property}`);
          var other_attrsIDRemove = domID(`attrs-${property}-remove`);
          if (!clear) {
            other_attrsID.value = frameID(domElement[0]).getAttribute(property);
            other_attrsID.style = 'color: var(--mainColor); padding-right: 1px;';
          } else {
            other_attrsID.value = "";
            other_attrsID.style = null;
          }
          other_attrsID.oninput = function () {
            var attribute_value = frameID(domElement[0]).getAttribute(property);
            var attribute_entered = this.value;
            frameID(domElement[0]).setAttribute(property, attribute_entered);
            if (attribute_entered === attribute_value) {
              other_attrsID.style = 'color: var(--mainColor); padding-right: 1px;';
            } else {
              other_attrsID.style = 'padding-right: 1px;';
            }
            renderImagesFromIndexedDB();
            FillStorageHTML();
            refreshCodeView();
            set_preview_css_html();
            frameID(domElement[0]).addEventListener("load", () => {
              DOMtree();
            }, {
              once: true
            });
          };

          other_attrsID.onchange = function () {
            renderImagesFromIndexedDB();
            FillStorageHTML();
            FillValueReadouts();
            refreshElementAttrs();
            FillUndo();
            frameID(domElement[0]).addEventListener("load", () => {
              DOMtree();
              selectElement(frameID(domElement[0]));
            }, {
              once: true
            });
          };

          other_attrsIDRemove.onclick = function () {
            renderImagesFromIndexedDB();
            frameID(domElement[0]).removeAttribute(property);
            FillStorageHTML();
            FillValueReadouts();
            refreshElementAttrs();
            refreshCodeView();
            set_preview_css_html();
            FillUndo();
            setTimeout(() => {
              DOMtree();
              selectElement(frameID(domElement[0]));
            }, 50);
          };
        }
      } else {
        other_atributes_container.innerHTML = "";
      }
    }, 0);
  }

  attrsID.oninput = function () {
    if (!domElement[1] || domElement[0] === 'classcss') {
      info("", null, null);
      if (this.value) {
        info('Select an element before changing id.', null, true);
      }
      return false;
    }
    var attribute_value = frameID(domElement[0]).id;
    var attribute_entered = this.value;
    attribute_entered = attribute_entered.trim();
    attribute_entered = attribute_entered.toLowerCase();
    if (attribute_entered === attribute_value) {
      attrsID.style = 'color: var(--mainColor); padding-right: 1px;';
    } else {
      attrsID.style = 'padding-right: 1px;';
    }
    if (creatHTMLandDownload(page_name).fileHTMLBody.indexOf(' id="' + attribute_entered + '"') > -1) {
      info('Sorry, this ' + 'id' + ' attribute already exists.', null, true);
      attrsID.style = 'color: red; padding-right: 1px;';
      return false;
    } else {
      info('', null, true);
      attrsID.style = 'color: var(--mainColor); padding-right: 1px;';
    }


    if (attribute_entered) {
      frameID(domElement[0]).setAttribute('id', attribute_entered);
      domElement[0] = attribute_entered;
    } else {
      guidGenerator();
      frameID(domElement[0]).setAttribute('id', uniqid);
      domElement[0] = uniqid;
    }
    if (frameID(domElement[0]).id === this.value) {
      attrsID.style = 'color: var(--mainColor); padding-right: 1px;';
    }

    INPUTER1.value = `#${domElement[0]}`;
    frameID(domElement[0]).setAttribute('data-tracker', `#${domElement[0]}`);
    if (frameID(domElement[0]).getAttribute('data-tracker').length === 12 && frameID(domElement[0]).getAttribute('data-tracker').includes("#ID-")) {
      INPUTER1.value = frameID(domElement[0]).tagName.toLowerCase();
      frameID(domElement[0]).setAttribute('data-tracker', frameID(domElement[0]).tagName.toLowerCase());
    }

    FillStorageHTML();
    DOMtree(frameID(domElement[0]).id);
    selectElement(frameID(domElement[0]));
    FillValueReadouts();
    refreshElementAttrs();
    refreshCodeView();
    set_preview_css_html();
  };

  attrsIDRemove.onclick = function () {
    if (!domElement[1] || domElement[0] === 'classcss') {
      attrsID.value = "";
      info("", null, null);
      return false;
    }
    if (!attrsID.value) {
      return false;
    }
    guidGenerator();
    frameID(domElement[0]).setAttribute('id', uniqid);
    domElement[0] = uniqid;

    INPUTER1.value = `#${domElement[0]}`;
    frameID(domElement[0]).setAttribute('data-tracker', `#${domElement[0]}`);
    if (frameID(domElement[0]).getAttribute('data-tracker').length === 12 && frameID(domElement[0]).getAttribute('data-tracker').includes("#ID-")) {
      INPUTER1.value = frameID(domElement[0]).tagName.toLowerCase();
      frameID(domElement[0]).setAttribute('data-tracker', frameID(domElement[0]).tagName.toLowerCase());
    }

    FillStorageHTML();
    DOMtree(frameID(domElement[0]).id);
    selectElement(frameID(domElement[0]));
    FillValueReadouts();
    refreshElementAttrs();
    refreshCodeView();
    set_preview_css_html();
    FillUndo();
  };

  attrsID.onchange = function () {
    FillUndo();
  };

  // attrsClass.oninput = function () {
  //   this.value = this.value.replace(/\s\s+/g, ' ');
  //   var attribute_value = frameID(domElement[0]).getAttribute('class');
  //   var attribute_entered = this.value;
  //   if (attribute_entered === attribute_value) {
  //     attrsClass.style = 'color: var(--mainColor); padding-right: 1px;';
  //   } else {
  //     attrsClass.style = 'padding-right: 1px;';
  //   }
  // };


  function update_classes_list() {
    // ------------------------------------------------------------------
    // class attribute(s) all classes present on html
    var arr_of_html_classes = [];
    [...classcss.querySelectorAll("*")].map((el) => {
      var clsname = el.getAttribute("class");
      if (clsname) {
        if (clsname.indexOf(' ') > -1) {
          var split_clsname = clsname.split(' ');
          split_clsname.map((split_cls) => {
            arr_of_html_classes.push(split_cls);
          });
        } else {
          arr_of_html_classes.push(clsname);
        }
      }
    });
    arr_of_html_classes = arr_of_html_classes.sort();
    arr_of_html_classes = arr_of_html_classes.filter(function (item, pos, ary) {
      return !pos || item != ary[pos - 1];
    });
    attrsClassList.innerHTML = "";
    arr_of_html_classes.map((val) => {
      var option = document.createElement('option');
      option.innerText = val;
      option.setAttribute('value', val);
      if (INPUTER1.value === val) {
        option.setAttribute('selected', true);
      } else {
        option.removeAttribute('selected');
      }
      attrsClassList.appendChild(option);
    });
  }

  attrsClass.oninput = function () {
    this.value = this.value.replace(/\s\s+/g, ' ');
    change_class_name();
  };

  function change_class_name() {
    var attribute_entered = attrsClass.value;
    attribute_entered = attribute_entered.toLowerCase();

    //if the tag name matches
    if (select__element.value !== 'other-type' && select__element.value !== frameID(domElement[0]).tagName.toLowerCase()) {
      return false;
    }

    var last_class = attribute_entered;
    if (last_class.indexOf(' ') > -1) {
      last_class = last_class.split(' ');
      if (attribute_entered.endsWith(' ')) {
        last_class.pop();
      }
      last_class = last_class.join('.');
    }
    if (last_class) {
      INPUTER1.value = '.' + last_class;
    } else {
      INPUTER1.value = frameID(domElement[0]).tagName.toLowerCase();
    }

    if (last_class) {
      frameID(domElement[0]).setAttribute('data-tracker', '.' + last_class);
      if (frameID(domElement[0]).getAttribute('class') === attrsClass.value) {
        attrsClass.style = 'color: var(--mainColor); padding-right: 1px;';
      }
    } else {
      frameID(domElement[0]).setAttribute('data-tracker', frameID(domElement[0]).tagName.toLowerCase());
    }

    frameID(domElement[0]).setAttribute('class', last_class.replaceAll('.', ' '));
    DOMtree(frameID(domElement[0]).id);
    FillStorageHTML();

    if (!attribute_entered.endsWith(' ')) {
      selectElement(frameID(domElement[0]));
      refreshElementAttrs();
    }
    FillValueReadouts();
    refreshCodeView();
    set_preview_css_html();
    FillUndo();
    populateClassesDropdown();
    iframeElementSelect.setAttribute('target', "");
    iframeElementSelect.setAttribute('target', frameID(domElement[0]).id);
    update_classes_list();
  }

  attrsClassRemove.onclick = function () {
    frameID(domElement[0]).setAttribute('class', '');
    INPUTER1.value = '';
    frameID(domElement[0])['data-tracker'] = '';
    FillStorageHTML();
    DOMtree(frameID(domElement[0]).id);
    selectElement(frameID(domElement[0]));
    FillValueReadouts();
    refreshElementAttrs();
    refreshCodeView();
    set_preview_css_html();
    FillUndo();
  };

  // ---------------------------------------------------
  // ----------------------------------------------------
  // Adds elements to the DOM

  // add element button
  domID('add-new-element').onclick = function () {
    addElement(domID('select__element').value);
  };

  let dragover_element = '<div data-dropper></div>';

  function addComponentClickAndDrag(button_id, component_name, friendly_name) {
    domID(button_id).onclick = function () {
      addElement(component_name);
    }
    domID(button_id).setAttribute('draggable', true);
    domEvent(domID(button_id), "dragstart", function (e) {
      e.dataTransfer.setData("application/drop-element", component_name);
      dragover_element = /*HTML*/ `<div data-dropper style="--data-dropper-content: '${friendly_name}'"></div>`;
      startEl = component_name;
      canDropEl = true;
      iframeElementSelect.setAttribute('target-dragging', true);
    });
    domEvent(domID(button_id), "dragend", function (e) {
      let data_dropper = [...classcss.querySelectorAll('[data-dropper]')];
      data_dropper.map((el) => {
        el.remove();
      });
      iframeElementSelect.setAttribute('target-dragging', '');
    });
  }

  addComponentClickAndDrag('add-accordion-group', 'dp-accordion-group', 'drop accordion group');
  addComponentClickAndDrag('add-accordion', 'dp-accordion', 'drop accordion');
  addComponentClickAndDrag('add-tabs', 'dp-tabs', 'drop tabs');
  addComponentClickAndDrag('add-carousel', 'dp-carousel', 'drop carousel');
  addComponentClickAndDrag('add-scroll-drag', 'dp-scroll-drag', 'drop scroll drag');
  addComponentClickAndDrag('add-inlinesvg', 'dp-inline-svg', 'drop inline svg');
  addComponentClickAndDrag('add-header', 'dp-header', 'drop header');

  domID('add-tab').onclick = function () {
    if (domElement[1].toLowerCase() === 'dp-tabs') {
      addElement('dp-tab');
    } else if (frameID(domElement[0]) && frameID(domElement[0]).parentElement && frameID(domElement[0]).parentElement.tagName.toLowerCase() === 'dp-tabs') {
      selectElement(frameID(domElement[0]).parentElement);
      addElement('dp-tab');
    } else {
      info("Please select dp-tabs element or a dp-tab element before adding dp-tab.", false, true);
    }
  };


  // ---------------------------------------------------
  // ---------------------------------------------------
  // Creates elements to add to the DOM
  /**
   * addItTo = element to add to.
   * place = beforeend or afterend.
   * el_obj = HTML to added to the dom.
   */
  function domAddElement(addItTo, place, el_obj) {
    if (!el_obj.tag) {
      info("select a tag name before adding element");
      return false;
    }

    let append_html = false;

    var tempEl = addItTo.ownerDocument.createElement(el_obj.tag);
    tempEl.id = el_obj.id;
    if (el_obj.class) {
      tempEl.setAttribute('class', el_obj.class);
    }
    if (el_obj.text) {
      tempEl.innerText = el_obj.text;
    }
    if (el_obj.src) {
      tempEl.src = el_obj.src;
    }
    if (el_obj.alt) {
      tempEl.alt = el_obj.alt;
    }
    if (el_obj.value) {
      tempEl.setAttribute('value', el_obj.value);
    }
    if (el_obj.type) {
      tempEl.setAttribute('type', el_obj.type);
    }
    if (el_obj['data-image']) {
      tempEl.setAttribute('data-image', el_obj['data-image']);
    }

    // dp-carousel
    if (el_obj.tag.toLowerCase() === 'dp-carousel') {
      tempEl.setAttribute('theme', component_theme);
      tempEl.setAttribute('aspect-ratio', '16 / 9');
      tempEl.setAttribute('background-size', 'cover');
      tempEl.setAttribute('max-height', '500px');
      tempEl.setAttribute('auto-scroll', '3000');
      tempEl.setAttribute('disable-prev-next', 'false');
      tempEl.setAttribute('disable-dots', 'false');
      tempEl.setAttribute('disable-scroll', 'false');
      tempEl.setAttribute('disable-grab', 'false');
      tempEl.innerHTML = /*HTML*/ `<img id="${guidGenerator()}" data-image="place_holder_2.svg" alt="alt text">
<img id="${guidGenerator()}" data-image="place_holder_3.svg" alt="alt text">
<img id="${guidGenerator()}" data-image="place_holder_4.svg" alt="alt text">
`;
      add_image_to_store("/images/place_holder_2.svg", 'place_holder_2');
      add_image_to_store("/images/place_holder_3.svg", 'place_holder_3');
      add_image_to_store("/images/place_holder_4.svg", 'place_holder_4');
    }

    // dp-scroll-drag
    if (el_obj.tag.toLowerCase() === 'dp-scroll-drag') {
      tempEl.setAttribute('hide-scrollbar', 'true');
      tempEl.setAttribute('max-height', '500px');
      tempEl.innerHTML = /*HTML*/ `<img id="${guidGenerator()}" data-image="place_holder_2.svg" alt="alt text">
<img id="${guidGenerator()}" data-image="place_holder_3.svg" alt="alt text">
<img id="${guidGenerator()}" data-image="place_holder_4.svg" alt="alt text">
<img id="${guidGenerator()}" data-image="place_holder_2.svg" alt="alt text">
<img id="${guidGenerator()}" data-image="place_holder_3.svg" alt="alt text">
<img id="${guidGenerator()}" data-image="place_holder_4.svg" alt="alt text">
`;
      add_image_to_store("/images/place_holder_2.svg", 'place_holder_2');
      add_image_to_store("/images/place_holder_3.svg", 'place_holder_3');
      add_image_to_store("/images/place_holder_4.svg", 'place_holder_4');
    }

    // dp-accordion
    if (el_obj.tag.toLowerCase() === 'dp-accordion') {
      tempEl.setAttribute('border', '1px solid currentcolor');
      tempEl.setAttribute('border-opacity', '0.3');
      tempEl.setAttribute('chevron-color', 'currentcolor');
      tempEl.setAttribute('chevron-size', '1rem');
      if (!el_obj.class) {
        tempEl.setAttribute('class', "acc");
      }
      tempEl.innerHTML = /*HTML*/ `<div id="${guidGenerator()}" slot="title" class="acc-title">
  <span class="acc-title-text" id="${guidGenerator()}" >Double click to edit text.</span>
</div>
<div id="${guidGenerator()}" slot="content" class="acc-content">
  <span class="acc-content-text" id="${guidGenerator()}" >Lorem ipsum dolor sit amet consectetur adipisicing elit.</span>
</div>`;

      tree_expand_parent_el_arr.push(tempEl.id);
      window.localStorage.setItem(
        'tree_expand_parent_el_arr', JSON.stringify(tree_expand_parent_el_arr)
      );
      setTimeout(() => {
        let clickTree = document.querySelector(`[data-clicks="${tempEl.id}"]`);
        let clickTree_sub = clickTree.querySelector(`.t-i.t-i--with_child`);
        simulateMouseEvent(clickTree_sub, "mousedown");
        setTimeout(() => {
          simulateMouseEvent(clickTree, "mousedown");
          simulateMouseEvent(clickTree_sub, "mousedown");
        }, 200);
      }, 200);
    }

    // dp-accordion-group
    if (el_obj.tag.toLowerCase() === 'dp-accordion-group') {
      var ids = {
        "id_1": guidGenerator(),
        "id_2": guidGenerator(),
        "id_3": guidGenerator()
      };
      if (!el_obj.class) {
        tempEl.setAttribute('class', "acc-group");
      }
      tempEl.innerHTML = /*HTML*/ `
  <dp-accordion border="1px solid currentcolor" border-opacity="0.3" chevron-color="currentcolor" chevron-size="1rem" id="${ids.id_1}" class="acc">
    <div id="${guidGenerator()}" slot="title" class="acc-title">
      <span class="acc-title-text" id="${guidGenerator()}" >Double tap to edit text.</span>
    </div>
    <div id="${guidGenerator()}" slot="content" class="acc-content">
      <span class="acc-content-text" id="${guidGenerator()}" >Lorem ipsum dolor sit amet consectetur adipisicing elit.</span>
    </div>
  </dp-accordion>
  <dp-accordion border="1px solid currentcolor" border-opacity="0.3" chevron-color="currentcolor" chevron-size="1rem" id="${ids.id_2}" class="acc">
    <div id="${guidGenerator()}" slot="title" class="acc-title">
      <span class="acc-title-text" id="${guidGenerator()}" >Double tap to edit text.</span>
    </div>
    <div id="${guidGenerator()}" slot="content" class="acc-content">
      <span class="acc-content-text" id="${guidGenerator()}" >Lorem ipsum dolor sit amet consectetur adipisicing elit.</span>
    </div>
  </dp-accordion>
  <dp-accordion border="1px solid currentcolor" border-opacity="0.3" chevron-color="currentcolor" chevron-size="1rem" id="${ids.id_3}" class="acc">
    <div id="${guidGenerator()}" slot="title" class="acc-title">
      <span class="acc-title-text" id="${guidGenerator()}" >Double tap to edit text.</span>
    </div>
    <div id="${guidGenerator()}" slot="content" class="acc-content">
      <span class="acc-content-text" id="${guidGenerator()}" >Lorem ipsum dolor sit amet consectetur adipisicing elit.</span>
    </div>
  </dp-accordion>`;
      tree_expand_parent_el_arr.push(tempEl.id);
      tree_expand_parent_el_arr.push(ids.id_1);
      tree_expand_parent_el_arr.push(ids.id_2);
      tree_expand_parent_el_arr.push(ids.id_3);
      window.localStorage.setItem(
        'tree_expand_parent_el_arr', JSON.stringify(tree_expand_parent_el_arr)
      );
      setTimeout(() => {
        let clickTree = document.querySelector(`[data-clicks="${tempEl.id}"]`);
        let clickTree_sub = clickTree.querySelector(`.t-i.t-i--with_child`);
        simulateMouseEvent(clickTree_sub, "mousedown");
        setTimeout(() => {
          simulateMouseEvent(clickTree, "mousedown");
          simulateMouseEvent(clickTree_sub, "mousedown");
        }, 200);
      }, 200);
    }

    // dp-inline-svg
    if (el_obj.tag.toLowerCase() === 'dp-inline-svg') {
      tempEl.setAttribute('data-image', 'place_holder_1.svg');
      add_image_to_store("/images/place_holder_1.svg", 'place_holder_1');
    }

    // dp-tabs
    if (el_obj.tag.toLowerCase() === 'dp-tabs') {
      tempEl.setAttribute('tabs-padding', '0.5rem 1rem');
      tempEl.setAttribute('tabs-color', 'rgba(0,0,0,0)');
      tempEl.setAttribute('tabs-color-active', 'rgba(0,0,0,0)');
      tempEl.setAttribute('tabs-opacity', '0.6');
      tempEl.setAttribute('slider-color', 'currentcolor');
      tempEl.setAttribute('slider-bg-color', 'currentcolor');
      tempEl.setAttribute('slider-bg-opacity', '0.3');
      tempEl.innerHTML = /*HTML*/ `<dp-tab-label id="${guidGenerator()}" class="dp-tab-label">Tab Label</dp-tab-label>
<dp-tab-content id="${guidGenerator()}" class="dp-tab-content">
    Lorem ipsum dolor sit amet consectetur adipisicing elit.
</dp-tab-content>
<dp-tab-label id="${guidGenerator()}" class="dp-tab-label">Tab Label</dp-tab-label>
<dp-tab-content id="${guidGenerator()}" class="dp-tab-content">
    Lorem ipsum dolor sit amet consectetur adipisicing elit.
</dp-tab-content>
<dp-tab-label id="${guidGenerator()}" class="dp-tab-label">Tab Label</dp-tab-label>
<dp-tab-content id="${guidGenerator()}" class="dp-tab-content">
    Lorem ipsum dolor sit amet, consectetur adipisicing elit.
</dp-tab-content>`;
    }

    // dp-tab
    if (el_obj.tag.toLowerCase() === 'dp-tab') {
      append_html = true;
      place = 'beforeend';
      tempEl = /*HTML*/ `<dp-tab-label id="${guidGenerator()}" class="dp-tab-label">Tab Label</dp-tab-label>
    <dp-tab-content id="${guidGenerator()}" class="dp-tab-content">
        Lorem ipsum dolor sit amet, consectetur adipisicing elit.
    </dp-tab-content>`;
    }

    // dp-header
    if (el_obj.tag.toLowerCase() === 'dp-header') {
      append_html = true;
      place = 'beforeend';

      tempEl = /*HTML*/ `<dp-header id="${guidGenerator()}" style="
    position: fixed; 
    top: 0; left: 0; 
    width: 100%; 
    z-index: 999999999; 
    background: #fff; 
    box-shadow: 0 15px 10px -10px #555;
    color: #444;

  ">
    <div id="${guidGenerator()}" slot="logo">
      <img id="${guidGenerator()}" width="30" height="30" src="https://domposer.dunkerley.dev/images/logo.svg">
      <span id="${guidGenerator()}">Domposer</span>
    </div>
    <nav id="${guidGenerator()}" slot="nav-1">
      <a id="${guidGenerator()}" href="#work">Our Work</a>
      <a id="${guidGenerator()}" href="#about">About</a>
      <a id="${guidGenerator()}" href="#careers">Careers</a>
      <a id="${guidGenerator()}" href="#contact">Contact</a>
    </nav>
    <nav id="${guidGenerator()}" slot="nav-2">
      <a id="${guidGenerator()}" href="#careers">Careers</a>
      <button id="${guidGenerator()}">Contact</button>
    </nav>
    <div id="${guidGenerator()}" slot="mobile-logo">
      <img id="${guidGenerator()}" width="30" height="30" src="https://domposer.dunkerley.dev/images/logo.svg">
      <span id="${guidGenerator()}">Domposer</span>
    </div>
    <nav id="${guidGenerator()}" slot="mobile-nav">
      <div id="${guidGenerator()}" style="background: #fff; color: #000; display: flex; flex-direction: column; justify-content: center; align-items: center; gap: 1rem; padding: 1rem; box-shadow: 0 15px 10px -10px #555; ">
        <a id="${guidGenerator()}" href="#work">Our Work</a>
        <a id="${guidGenerator()}" href="#about">About</a>
        <a id="${guidGenerator()}" href="#careers">Careers</a>
        <a id="${guidGenerator()}" href="#contact">Contact</a>
        <a id="${guidGenerator()}" href="#careers">Careers</a>
        <button id="${guidGenerator()}">Contact</button>
      </div>
    </nav>
  </dp-header>`;



    }


    if (append_html) {
      return addItTo.insertAdjacentHTML(place, tempEl);
    } else {
      return addItTo.insertAdjacentElement(place, tempEl);
    }

  }



  var store_names_not_allowed = ['CSS_LG', 'CSS_MD', 'CSS_SM', 'CSS_XS'];


  function add_image_to_store(url, img_name) {
    img_name = img_name.replace('.svg', "");
    img_name = img_name.replace('.png', "");
    img_name = img_name.replace('.jpeg', "");
    img_name = img_name.replace('.jpg', "");
    img_name = img_name.replace('.gif', "");
    fetchExternalData(url, true)
      .then(result => {
        var file_type = "";
        switch (result[0].type) {
          case "image/svg+xml":
            file_type = ".svg";
            break;
          case "image/png":
            file_type = ".png";
            break;
          case "image/jpeg":
            file_type = ".jpeg";
            break;
          case "image/jpg":
            file_type = ".jpg";
            break;
          case "image/gif":
            file_type = ".gif";
            break;
        }
        if (!file_type) {
          info("File type not supported");
          return false;
        }
        if (store_names_not_allowed.indexOf(img_name) > -1) {
          info("File name not allowed");
          return false;
        }
        localforage.setItem((img_name + file_type), result[0]);
        setTimeout(() => {
          renderImagesFromIndexedDB();
          renderPreviewImagesFromIndexedDB();
          FillStorageHTML();
          FillUndo();
          DOMtree();
          // setTimeout(() => {
          //   domID('image-name-id').scrollIntoView({
          //     behavior: "auto",
          //     block: "start",
          //     inline: "center"
          //   });
          // }, 100);
        }, 100);
      })
      .catch(console.error);
  }

  function remove_image_from_store(img_name) {
    if (store_names_not_allowed.indexOf(img_name) > -1) {
      info("Not allowed to be removed");
      return false;
    }

    [...classcss.querySelectorAll(`[data-image="${img_name}"]`)].map(el => {
      el.setAttribute('data-image', 'place_holder_1.svg');
      add_image_to_store("/images/place_holder_1.svg", 'place_holder_1');
    });

    localforage.removeItem(img_name);
    info(img_name + ' removed');
    domID('image-name-id').value = "";
    domID('image-url-id').value = "";
    setTimeout(() => {
      renderPreviewImagesFromIndexedDB();
      FillStorageHTML();
      FillUndo();
      DOMtree();
    }, 100);
  }

  domID('add-new-image').onclick = () => {
    let image_name = domID('image-name-id').value;
    let image_url = domID('image-url-id').value;
    if (!image_url && !image_url) {
      info("Please add a image URL and name.", false, true);
      return false;
    }
    if (!image_name) {
      info("Please add a image name.", false, true);
      return false;
    }
    if (!image_url) {
      info("Please add a image URL.", false, true);
      return false;
    }
    add_image_to_store(image_url, image_name);
    domID('image-name-id').value = "";
    domID('image-url-id').value = "";
  };

  domID('image-name-id-remove').onclick = () => {
    domID('image-name-id').value = "";
  };

  domID('image-url-id-remove').onclick = () => {
    domID('image-url-id').value = "";
  };

  domID('remove-image').onclick = () => {
    let image_name = domID('image-name-id').value;
    if (!image_name) {
      info("Please click or type in image name of image you wish to remove.", false, false);
      return false;
    }
    var is_ok_to_remove = confirm('Warning, this image will be wiped from storage and cannot be undone, you would need to re-upload it.');
    if (is_ok_to_remove) {
      remove_image_from_store(image_name);
    }
  };

  function promptAddClassNewElement(elementType) {
    var promptPlaceholder = attrsClass.value || "";
    var createClassName = prompt(
      "Add a class name to add styles to your new " + elementType + " tag.", promptPlaceholder
    );
    if (createClassName) {
      return createClassName.trim().toLowerCase();
    } else {
      return "";
    }
  }



  let class_prompt_exclude = ['dp-tab'];

  function addElement(elementType) {

    guidGenerator();
    var classToAdd = classGenerator(elementType);
    var addedLast;
    var place;
    var placeTag = domElement[1] || "CLASSCSS";
    var HTML_to_add;
    var tagContent = 'Double tap to edit text.';
    INPUTER1.value = '.' + classToAdd;

    //var classToAdd = INPUTER1.value;
    if (domElement[0] === "classcss") {
      placeTag = "CLASSCSS";
    }

    function writeToDOM(tagPosition) {
      place = frameID(domElement[0]) || classcss;

      HTML_to_add = {
        tag: elementType,
        id: uniqid,
        class: classToAdd
      };

      acceptTextEdit.map((item) => {
        if (item === elementType) {
          HTML_to_add['text'] = tagContent;
        }
      });

      switch (elementType) {
        // elements that dont contain other elements
        case "option":
          HTML_to_add['class'] = null;
          HTML_to_add['value'] = elementType + ' value';
          HTML_to_add['text'] = elementType + ' text';
          break;
        case "select":
        case "input":
          HTML_to_add['value'] = elementType + ' value';
          HTML_to_add['type'] = 'text';
          break;
        case "img":
          HTML_to_add['src'] = 'images/place_holder_1.svg';
          HTML_to_add['alt'] = 'alt text';
          break;
      }
      domAddElement(place, tagPosition, HTML_to_add);
      addedLast = uniqid;
      domElement[0] = uniqid;
    }

    guidGenerator();

    if (classcss.childElementCount > 0 && placeTag !== "CLASSCSS") {
      writeToDOM("afterend");
    } else {
      writeToDOM("beforeend");
    }

    // check all elements have an id, sometime browser adds its own elements in tables

    if (frameID(addedLast)) {
      INPUTER2.value = "";
      INPUTER3.value = "";
      clickAddClass();
      FillStorageHTML();
      DOMtree(frameID(addedLast).id);
      selectElement(frameID(addedLast));
      FillValueReadouts();
      refreshElementAttrs();
      refreshCodeView();
      set_preview_css_html();
      FillUndo();
      setTimeout(() => {
        BoxRefresh();
      }, 200);
    }
  }
  // ---------------------------------------------------
  // ----------------------------------------------------
  // Removes elements from the DOM
  domEvent(domID("removeElement"), "mousedown", removeElement);

  function removeElement() {
    var prevSib;
    var input1;
    var theElementString = domElement[0];
    var elementsHaveClass;
    if (theElementString === "classcss") {

      return false;
    }
    var theElement = frameID(domElement[0]);
    if (!theElement) {
      return false;
    }
    prevSib = theElement.previousSibling;
    if (!prevSib) {
      if (
        theElement.parentElement.id === "classcss"
      ) {
        var classcssElements = classcss.children[1];
        prevSib = classcssElements;
      } else {
        prevSib = theElement.parentElement;
      }
    }
    if (!prevSib) {
      prevSib = classcss;
    }
    theElement.remove();
    input1 = INPUTER1.value;
    domElement[0] = "classcss";
    domElement[1] = "DIV";
    //clickAddClass();
    FillStorageHTML();
    input1 = INPUTER1.value;
    updateTarget();
    DOMtree(prevSib.id);
    BoxRefresh();
    selectElement(prevSib);
    FillUndo();
    refreshElementAttrs();
  }
  // ---------------------------------------------------
  // ----------------------------------------------------
  // Copy element from the DOM
  domEvent(domID("copyElement"), "mousedown", copyElement);
  var itemToCopy;
  var clonedItem;
  var newcopy = false;
  var anothernewcopy = false;
  var copyPlace = [];

  function copyElement() {
    if (domElement[0] !== "classcss") {
      if (newcopy === false && domElement[0]) {
        copyPlace = [];
        copyPlace.push(domElement[0]);
        copyPlace.push(domElement[1]);
        itemToCopy = frameID(domElement[0]);
        clonedItem = itemToCopy.cloneNode(true);
        guidGenerator();
        clonedItem.id = uniqid;
        //clonedItem.removeAttribute('style');
        newcopy = true;
        anothernewcopy = false;
        FillUndo();
      }
    }
  }
  // ---------------------------------------------------
  // ----------------------------------------------------
  // Paste element from the DOM
  domEvent(domID("pasteElement"), "mousedown", pasteElement);

  function pasteElement() {
    if (
      INPUTER1 === document.activeElement ||
      INPUTER2 === document.activeElement ||
      INPUTER3 === document.activeElement) {
      return false;
    }
    if (domElement[0] !== "classcss") {
      if (clonedItem) {
        var cloneClassName = clonedItem.getAttribute('class');
        var allClassNames = JSON.stringify(cloneClassName);
        var nameIndex = allClassNames.indexOf(allClassNames);
        if (nameIndex === -1) {} else {
          if (anothernewcopy === true) {
            itemToCopy = clonedItem;
            clonedItem = itemToCopy.cloneNode(true);
            guidGenerator();
            clonedItem.id = uniqid;
            insertAfter(frameID(copyPlace[0]), clonedItem);
            (function () {
              var kids = clonedItem;
              var all = kids.getElementsByTagName("*");
              for (var j = 0; j < all.length; j++) {
                guidGenerator();
                all[j].id = uniqid;
              }
            })();
            DOMtree(clonedItem.id);
            updateTarget();
            FillStorageHTML();
            selectElement(clonedItem);
            newcopy = false;
            anothernewcopy = true;
          }
          if (newcopy === true) {
            insertAfter(frameID(copyPlace[0]), clonedItem);
            (function () {
              var kids = clonedItem;
              var all = kids.getElementsByTagName("*");
              for (var j = 0; j < all.length; j++) {
                guidGenerator();
                all[j].id = uniqid;
              }
            })();
            DOMtree(clonedItem.id);
            updateTarget();
            FillStorageHTML();
            selectElement(clonedItem);
            newcopy = false;
            anothernewcopy = true;
          }
          FillUndo();
        }
      }
    }
  }

  domEvent(domID("duplicateElement"), "mousedown", () => {
    copyElement();
    pasteElement();
  });


  // ---------------------------------------------------
  // ----------------------------------------------------
  // Creates a target for the place to add elements.
  function updateTarget() {
    input1fortarget = INPUTER1.value;
    var targlen = classcss.getElementsByClassName(input1fortarget).length;
    var targ = classcss.getElementsByClassName(input1fortarget);
    if (targ[targlen - 1]) {
      domElement[0] = targ[targlen - 1].id;
      domElement[1] = targ[targlen - 1].tagName;
    }
  }
  // ---------------------------------------------------
  // ----------------------------------------------------
  // Retrieve data from local storage or sets defaults in case of no data.
  // CSS

  function set_CSS_from_localStorage() {
    // LG
    if (window.localStorage.CSS_LG) {
      thecssLG = JSON.parse(window.localStorage.CSS_LG);
    } else if (window.localStorage.AlltheCSS) {
      thecssLG = JSON.parse(window.localStorage.AlltheCSS);
    } else {
      thecssLG = {};
    }

    // breakpoint 1
    if (window.localStorage.CSS_MD) {
      thecssMD = JSON.parse(window.localStorage.CSS_MD);
    } else if (window.localStorage.AlltheCSSBP1) {
      thecssMD = JSON.parse(window.localStorage.AlltheCSSBP1);
    } else {
      thecssMD = {};
    }
    // breakpoint 2
    if (window.localStorage.CSS_SM) {
      thecssSM = JSON.parse(window.localStorage.CSS_SM);
    } else if (window.localStorage.AlltheCSSBP2) {
      thecssSM = JSON.parse(window.localStorage.AlltheCSSBP2);
    } else {
      thecssSM = {};
    }
    // breakpoint 3
    if (window.localStorage.CSS_XS) {
      thecssXS = JSON.parse(window.localStorage.CSS_XS);
    } else if (window.localStorage.AlltheCSSBP3) {
      thecssXS = JSON.parse(window.localStorage.AlltheCSSBP3);
    } else {
      thecssXS = {};
    }
  }
  set_CSS_from_localStorage();

  // ---------------------------------------------------
  // ----------------------------------------------------
  // Renders HTML from local storage.
  function renderHTML() {
    // return false;
    let allHTML;
    if (window.localStorage[`HTML_${page_name}`]) {
      allHTML = window.localStorage[`HTML_${page_name}`];
    } else if (window.localStorage.AlltheHTML) {
      allHTML = window.localStorage.AlltheHTML;
    }
    if (allHTML) {
      let imageBlob = /src="blob:(.*?)"/g;
      let elem;
      allHTML = allHTML.replace(imageBlob, "");
      let removedBlobs = allHTML.replace(imageBlob, "");
      elem = projectHTMLContainer(removedBlobs);

      renderToDOM(createDOMMap(elem));

      //domAdd(classcss, "beforeend", elem.innerHTML);
      elem = null;
    }
  }
  // ---------------------------------------------------
  // ----------------------------------------------------
  // Render preview images from indexedDB

  function check_for_images_not_in_DB() {
    let dataImages = [...classcss.querySelectorAll(`[data-image]`)];
    let dataImages_no_src = [];
    dataImages.map(el => {
      if (!el.getAttribute('src') || el.getAttribute('src') === "") {
        if (dataImages_no_src.indexOf(el.getAttribute('data-image')) === -1) {
          dataImages_no_src.push(el.getAttribute('data-image'));
        }
      }
    });
    if (dataImages_no_src.length === 1) {
      info(`Error image ${dataImages_no_src.join(', ')} missing, you may need to re-upload.`, false, true);
    } else if (dataImages_no_src.length > 1) {
      info(`Error images (${dataImages_no_src.join(', ')}) missing, you may need to re-upload.`, false, true);
    } else {
      info(``);
    }
  }

  function renderImagesFromIndexedDB(strict) {
    SCROLLBOX.style.setProperty('opacity', '0');
    return localforage.iterate(function (value, key, iterationNumber) {
      if (
        value.type === "image/png" ||
        value.type === "image/jpeg" ||
        value.type === "image/jpg" ||
        value.type === "image/gif" ||
        value.type === "image/svg+xml"
      ) {
        let url = window.URL.createObjectURL(value);
        let dataImages = [...classcss.querySelectorAll('[data-image]')].filter(el => el.getAttribute('data-image') === key);
        dataImages.map(el => {
          el.setAttribute('src', url);
        });
      }
    }).then(function () {
      SCROLLBOX.style.setProperty('opacity', '1');
      if (!strict) {
        setTimeout(() => {
          SCROLLBOX.style.removeProperty('transition');
          check_for_images_not_in_DB();
        }, 150);
      } else {
        SCROLLBOX.style.removeProperty('transition');
      }
    }).catch(function (error) {
      SCROLLBOX.style.setProperty('opacity', '1');
      throw error;
    });
  }
  // ---------------------------------------------------
  // ----------------------------------------------------
  // Render preview images from indexedDB
  var dragDBimageName;
  var renderPreviewImagesFromIndexedDB_running = false;

  function bytesToSize(bytes) {
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes == 0) return '0 Bytes';
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
  }


  var all_image_options = [];

  var previewImagesPromise;
  function renderPreviewImagesFromIndexedDB(strict) {
    if (renderPreviewImagesFromIndexedDB_running === true) {
      return strict ? previewImagesPromise.then(() => renderPreviewImagesFromIndexedDB(true)) : false;
    }
    var images_total_filesize = 0;
    all_image_options = [];
    renderPreviewImagesFromIndexedDB_running = true;
    var background_select_el = domID('select__background-image');
    var list_style_select_el = domID('select__list-style-image');
    var totalfilesize_element = domID('total-file-size');
    background_select_el.innerHTML = "";
    list_style_select_el.innerHTML = "";
    var blob;
    var imageCards = document.createDocumentFragment();
    //clearTheHTML(imageHolder);
    previewImagesPromise = new Promise(function (resolve, reject) {
      requestAnimationFrame(function () {
        localforage
          .iterate(function (value, key, iterationNumber) {
            if (
              value.type === "image/png" ||
              value.type === "image/jpeg" ||
              value.type === "image/jpg" ||
              value.type === "image/gif" ||
              value.type === "image/svg+xml"
            ) {
              blob = window.URL.createObjectURL(value);
              imageCards.appendChild(imageCard(key, blob, bytesToSize(value.size)));
              var option = document.createElement("option");
              option.text = key;
              option.value = 'url(images/' + key + ')';
              background_select_el.appendChild(option);
              list_style_select_el.appendChild(option.cloneNode(true));
              images_total_filesize += value.size;
              all_image_options.push(key);
            }
          })
          .then(function () {
            if (imageCards) {
              var option = document.createElement("option");
              option.text = 'none';
              option.value = 'none';
              background_select_el.appendChild(option);
              list_style_select_el.appendChild(option.cloneNode(true));
              totalfilesize_element.innerText = bytesToSize(images_total_filesize);
              imageHolder.replaceChildren(imageCards);
              domForQuery("[data-DBimage]", function (el) {
                domEvent(el, "mousedown", function () {
                  dragDBimageName = el.getAttribute(
                    "data-DBimage"
                  );
                  isDBimage = true;
                  domID('image-name-id').value = dragDBimageName;
                });
                domEvent(el, "mouseup", function () {
                  isDBimage = false;
                });
                domEvent(el, "dragstart", function (event) {
                  isDBimage = true;
                  event.dataTransfer.setData(
                    "application/x-domposer-image",
                    el.getAttribute("data-DBimage")
                  );
                });
                domEvent(el, "dragend", function () {
                  isDBimage = false;
                });
              });
              if (!strict) {
                setTimeout(() => {
                  FillValueReadouts();
                  refreshElementAttrs();
                  DOMtree();
                }, 100);
              }
            }
            return createObjectOfBlobs();
          }).then(function () {
            renderPreviewImagesFromIndexedDB_running = false;
            resolve();
          })["catch"](function (err) {
            renderPreviewImagesFromIndexedDB_running = false;
            reject(err);
          });
      });
    });
    return strict ? previewImagesPromise : previewImagesPromise.catch(function () {});
  }
  // ---------------------------------------------------
  // ----------------------------------------------------
  // Strip classcss of indexDBImages
  function removeIndexedDBImagesFromClasscss(htmlToStrip) {
    var htlmObject = projectHTMLContainer(htmlToStrip);
    var dataImages = htlmObject.querySelectorAll("[data-image]");
    if (!dataImages) {
      return false;
    }
    [].forEach.call(dataImages, function (element) {
      element.removeAttribute('src');
    });
    return htlmObject.innerHTML.toString();
  }
  // ---------------------------------------------------
  // ----------------------------------------------------
  // Removes all HTML elements from the a Html element (classcss).
  function clearTheHTML(element) {
    while (element.firstChild) {
      element.removeChild(element.firstChild);
    }
  }
  // ---------------------------------------------------
  // ----------------------------------------------------
  // Removes all the CSS in localStorage
  domEvent(domID("removeAll"), "mousedown", removeAllthecss);

  function deleteAllCookies() {
    var cookies = document.cookie.split(";");
    [].forEach.call(cookies, function (cookie) {
      var eqPos = cookie.indexOf("=");
      var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    });
  }

  function removeAllthecss() {
    var confirmdelete = prompt('Click ok to delete this project and start from a clean slate.\n\n' +
      'Type "all" and click ok to remove all data including cookies and revert to the original landing page.\n');
    if (confirmdelete === null) {
      return false; //break out of the function early
    }
    if (confirmdelete.toLowerCase() === '') {

      let keep_tutorial_data_index = window.localStorage.getItem('tutorial_data_index') || '';

      let keep_left_sections = document.getElementById("left-sections").getAttribute('style') || '';
      let keep_right_sections = document.getElementById("right-sections").getAttribute('style') || '';
      let keep_code_section = codesection.getAttribute('style') || '';

      let keep_theme_color = window.localStorage.getItem('theme-color') || '';

      let keep_autoScroll = window.localStorage.getItem('autoScroll') || '';
      let keep_structure_height = window.localStorage.getItem('structure_height') || '';

      // tabs
      let keep_active_tab_pages = window.localStorage.getItem('active-tab-pages') || '';
      let keep_active_tab_structure = window.localStorage.getItem('active-tab-structure') || '';
      let keep_active_tab_element = window.localStorage.getItem('active-tab-element') || '';
      let keep_active_tab_components = window.localStorage.getItem('active-tab-components') || '';
      let keep_active_tab_images = window.localStorage.getItem('active-tab-images') || '';

      let keep_component_theme = window.localStorage.getItem('component_theme') || '';

      let keep_normalizecss = window.localStorage.getItem('normalizecss') || '';
      let keep_mobileFirst = window.localStorage.getItem('mobileFirst') || '';

      window.localStorage.clear();
      window.sessionStorage.clear();
      localforage.clear();
      setTimeout(function () {
        fullWidth();
        setScrollBoxToFullWidth();
        storeTheCurrentBreakpoint();
        currentundoLevel = 0;
        window.localStorage.removeItem("scrollBoxSizeValue");
        window.localStorage.removeItem("lastBreakpoint");
        window.localStorage.setItem("tutorial_data_index", keep_tutorial_data_index);
        window.localStorage.setItem("on_load_count", onLoadCounter);
        window.localStorage.setItem('normalizecss', keep_normalizecss);
        window.localStorage.setItem('mobileFirst', keep_mobileFirst);
        window.localStorage.setItem('active-tab-pages', keep_active_tab_pages);
        window.localStorage.setItem('active-tab-structure', keep_active_tab_structure);
        window.localStorage.setItem('active-tab-element', keep_active_tab_element);
        window.localStorage.setItem('active-tab-components', keep_active_tab_components);
        window.localStorage.setItem('active-tab-images', keep_active_tab_images);
        window.localStorage.setItem("left-sections-style", keep_left_sections);
        window.localStorage.setItem("right-sections-style", keep_right_sections);
        window.localStorage.setItem("code-section-style", keep_code_section);
        window.localStorage.setItem("theme-color", keep_theme_color);
        window.localStorage.setItem("autoScroll", keep_autoScroll);
        window.localStorage.setItem("structure_height", keep_structure_height);
        window.localStorage.setItem("component_theme", keep_component_theme);
        window.sessionStorage.setItem("currentundoLevel", currentundoLevel);
        setTimeout(function () {
          window.location.reload();
        }, 200);
      }, 200);
    }
    if (confirmdelete.toLowerCase() === 'all') {
      deleteAllCookies();
      window.localStorage.clear();
      window.sessionStorage.clear();
      localforage.clear();
      setTimeout(function () {
        window.location.reload();
      }, 200);
    }
  }
  // ---------------------------------------------------
  // ----------------------------------------------------
  // Adds CSS data to local storage.
  FillStorage();
  siteTitleFn();

  function FillStorage() {
    if (projectImportRunning || failedImportBackup) return;
    setTimeout(function () {
      if (projectImportRunning || failedImportBackup) return;
      window.localStorage.removeItem("CSS_LG");
      var dataToStore1 = JSON.stringify(thecssLG);
      window.localStorage.setItem("CSS_LG", dataToStore1);
      window.localStorage.removeItem("CSS_MD");
      var dataToStore2 = JSON.stringify(thecssMD);
      window.localStorage.setItem("CSS_MD", dataToStore2);
      window.localStorage.removeItem("CSS_SM");
      var dataToStore3 = JSON.stringify(thecssSM);
      window.localStorage.setItem("CSS_SM", dataToStore3);
      window.localStorage.removeItem("CSS_XS");
      var dataToStore4 = JSON.stringify(thecssXS);
      window.localStorage.setItem("CSS_XS", dataToStore4);
    }, 0);
  }
  // ---------------------------------------------------
  // ----------------------------------------------------
  // Store Mobile first boolean.
  function FillStoragemobileFirst() {
    window.localStorage.removeItem("mobileFirst");
    window.localStorage.setItem("mobileFirst", mobileFirst);
  }
  // ---------------------------------------------------
  // ----------------------------------------------------
  // Store Breakpoints.
  function FillStorageBreakpoints() {
    window.localStorage.removeItem("breakPoint1Value");
    window.localStorage.removeItem("breakPoint2Value");
    window.localStorage.removeItem("breakPoint3Value");
    window.localStorage.setItem("breakPoint1Value", breakPoint_MD_Value);
    window.localStorage.setItem("breakPoint2Value", breakPoint_SM_Value);
    window.localStorage.setItem("breakPoint3Value", breakPoint_XS_Value);
  }
  // ---------------------------------------------------
  // ----------------------------------------------------
  // Adds HTML data to local storage.

  function add_element_empty_attributes() {
    let all_els = [...classcss.querySelectorAll('*')];
    if (all_els) {
      all_els.map(el => {
        if (checkTagNameExceptsChildren(el.tagName)) {
          el.removeAttribute('data-element-empty');
          let base_size = el.offsetHeight;
          if (
            el.innerHTML === '' &&
            base_size === 0
          ) {
            el.setAttribute('data-element-empty', true);
          } else {
            el.removeAttribute('data-element-empty');
          }
        } else {
          el.removeAttribute('data-element-empty');
        }
      });
    }
  }

  function FillStorageHTML() {
    if (failedImportBackup) return;
    let string_of_html = '';
    if (classcss.innerHTML) {

      add_element_empty_attributes();

      string_of_html = classcss.innerHTML
        .replace(/\s+/g, ' ')
        .trim()
        .replaceAll('> <', '><');
    }
    window.localStorage.setItem(`HTML_${page_name}`, string_of_html);
  }
  //domEvent(domID("logDOM"), "mousedown", FillStorageHTML);
  // ---------------------------------------------------
  // ----------------------------------------------------
  // Undo and Redo buttons and keypresses.
  if (window.sessionStorage.getItem("currentundoLevel")) {
    currentundoLevel = window.sessionStorage.getItem("currentundoLevel");
  } else {
    currentundoLevel = 0;
    window.sessionStorage.setItem("currentundoLevel", currentundoLevel);
  }

  window.onbeforeunload = function () {
    window.sessionStorage.setItem("currentundoLevel", currentundoLevel);
  };

  function addEvent(obj, evt, fn) {
    if (obj.addEventListener) {
      obj.addEventListener(evt, fn, false);
    } else if (obj.attachEvent) {
      obj.attachEvent("on" + evt, fn);
    }
  }

  var delayToManySaves = true;
  setTimeout(function () {
    delayToManySaves = false;
  }, 10000);

  // addEvent(document, "mouseout", function (e) {
  //   e = e ? e : window.event;
  //   var from = e.relatedTarget || e.toElement;
  //   if (!from || from.nodeName == "HTML") {
  //     // stop your drag event here
  //     // for now we can just use an alert
  //     if (delayToManySaves === false) {
  //       var checkIfCanSave = domID("saveProject");
  //       if (checkIfCanSave) {
  //         saveOrDownloadFiles(true); // save
  //       }
  //       delayToManySaves = true;
  //       setTimeout(function () {
  //         delayToManySaves = false;
  //       }, 30000);
  //     }
  //   }
  // });

  var checker;

  function navigatorOffline(api) {
    var levelWidthStyle = "width:" + "100" + "%;";
    var levelColorStyle = "background:" + "red" + ";";

    clearInterval(checker);
    checker = setInterval(check, 2000);

    function check() {
      if (navigator.onLine === true) {
        stopCheck();
        saveOrDownloadFiles(api);
      } else {
        info(
          "Couldn't save project Please check your internet connection!!",
          false,
          true
        );
        storageleveltext.innerHTML = "offline";
        storagelevelbar.style = levelWidthStyle + levelColorStyle;
      }
    }

    function stopCheck() {
      clearInterval(checker);
    }
  }

  function navigatorOnline() {
    info("Saving project files...", 2000, false);
  }

  // ---------------------------------------------------
  // ----------------------------------------------------
  // Undo and Redo buttons and keypresses.
  function removeThisUndo(undoNum) {
    window.sessionStorage.removeItem("undo_obj_" + undoNum);
  }
  // gets all key value pairs
  function allStorage() {
    var archive = [],
      keys = Object.keys(localStorage),
      i = 0,
      key;
    for (;
      (key = keys[i]); i++) {
      archive.push(key + "=" + localStorage.getItem(key));
    }
    return archive;
  }

  function toArray() {
    let string_of_html = '';
    if (classcss.innerHTML) {
      string_of_html = classcss.innerHTML
        .replace(/\s+/g, ' ')
        .trim()
        .replaceAll('> <', '><');
    }
    HTMLarray = string_of_html;
  }


  function findDiff(str1, str2) {
    if (!str1 || !str2) {
      return false;
    }
    var diff = "";
    str2.split('').forEach(function (val, i) {
      if (val != str1.charAt(i)) {
        diff += val;
      }
    });
    return diff;
  }

  function addUndo(numPassed) {

    var imageBlob = /src="blob:(.*?)"/g; // remove the blobs as they change all the time

    if (classcss) {
      toArray();
    }

    let html_page = `HTML_${page_name}`;

    // this will get stored
    var undo_obj = {
      "CSS_LG": thecssLG,
      "CSS_MD": thecssMD,
      "CSS_SM": thecssSM,
      "CSS_XS": thecssXS,
      "inputer1": INPUTER1.value,
      "inputer2": INPUTER2.value,
      "inputer3": INPUTER3.value,
      "inputer4": INPUTER4.value,
      "lastElement": domElement[0],
      "currentundoLevel": numPassed,
      "page_name": page_name,
      "page_names": page_names,
    };
    undo_obj[html_page] = HTMLarray.replace(imageBlob, "");

    undo_obj = JSON.stringify(undo_obj);
    // compare the data thats coming into Fillundo with last current stored
    currentundoLevel = window.sessionStorage.getItem("currentundoLevel");
    var lastundo = JSON.parse(window.sessionStorage.getItem("undo_obj_" + currentundoLevel));
    var lastundo_obj_compare;
    if (lastundo && lastundo[`HTML_${page_name}`]) {
      lastundo_obj_compare = {
        "CSS_LG": lastundo.CSS_LG,
        "CSS_MD": lastundo.CSS_MD,
        "CSS_SM": lastundo.CSS_SM,
        "CSS_XS": lastundo.CSS_XS,
      };
      lastundo_obj_compare[html_page] = lastundo[`HTML_${page_name}`].replace(imageBlob, "");
      lastundo_obj_compare = JSON.stringify(lastundo_obj_compare);
    }

    var undo_obj_compare = {
      "CSS_LG": thecssLG,
      "CSS_MD": thecssMD,
      "CSS_SM": thecssSM,
      "CSS_XS": thecssXS,
    };
    undo_obj_compare[html_page] = HTMLarray.replace(imageBlob, "");
    undo_obj_compare = JSON.stringify(undo_obj_compare);

    var difference = findDiff(lastundo_obj_compare, undo_obj_compare);

    if (lastundo_obj_compare === undo_obj_compare) {
      con("last undo IS same as current data");
      if (lastundo_obj_compare) {
        con(lastundo_obj_compare.length);
      }
      con(undo_obj_compare.length);
    } else {
      con("last undo IS NOT same as current data");
      con("difference size:");
      con(difference.length);
      window.sessionStorage.setItem("undo_obj_" + numPassed, undo_obj);
      window.sessionStorage.setItem("currentundoLevel", numPassed);
      if (PROJECT_NAME) {
        saveDebounce();
      }
    }
  }
  const saveDebounce = debounce(() => saveOrDownloadFiles(true), 2000);

  function sortNumber(a, b) {
    return a - b;
  }

  var arrayOfUndos = [];

  function getArrayOfUndos() {
    //var itemInStore = "HTML_index_";
    var itemInStore = "undo_obj_";

    var getArrayOfUndosArr = [];
    var getArrayOfUndosKey;
    var getArrayOfUndosKeyNum;
    for (var i = 0, len = sessionStorage.length; i < len; ++i) {
      getArrayOfUndosKey = sessionStorage.key(i);
      if (getArrayOfUndosKey.indexOf(itemInStore) > -1) {
        getArrayOfUndosKeyNum = Number(
          getArrayOfUndosKey.replace(itemInStore, "")
        );
        getArrayOfUndosArr.push(getArrayOfUndosKeyNum);
      }
    }
    getArrayOfUndosArr.sort(sortNumber);
    getArrayOfUndosArr.join(",");
    arrayOfUndos = getArrayOfUndosArr;
  }

  function FillUndo(forImport) {
    if ((projectImportRunning && !forImport) || failedImportBackup) return;

    delayToManySaves = false;
    var l_strorage = localStorageSpace();
    var s_storage = sessionStorageSpace();
    function fillUndoNow() {
      if ((projectImportRunning && !forImport) || failedImportBackup) return;
      var currentUndo = Number(
        window.sessionStorage.getItem("currentundoLevel")
      );
      if (!currentUndo) {
        currentUndo = 0;
        window.sessionStorage.setItem("currentundoLevel", currentUndo);
      }
      // remove undos if no enough storage
      if (s_storage > 5000) {
        removeHalfOfUndos();
      }
      if (l_strorage > 5000) {
        removeHalfOfUndos();
      }
      // remove the undos that are higher than the currentundoLevel
      for (var i = 0; i < arrayOfUndos.length; i++) {
        if (arrayOfUndos[i] > currentUndo) {
          removeThisUndo(arrayOfUndos[i]);
        }
      }
      var nextUndo = Number(
        Number(window.sessionStorage.getItem("currentundoLevel")) + 1
      );
      addUndo(nextUndo);
      getArrayOfUndos();
      undoInc = window.sessionStorage.undoLevel;

      populateClassesDropdown();
    }
    if (forImport) fillUndoNow();
    else setTimeout(fillUndoNow, 0);
  }

  function removeHalfOfUndos() {
    getArrayOfUndos();
    var halfLength = Number(arrayOfUndos.length / 2);
    for (var i = 0; i < halfLength; i++) {
      removeThisUndo(arrayOfUndos[i]);
    }
    for (var j = 0; j < halfLength; j++) {
      arrayOfUndos.splice(j, 1);
    }
  }

  // ---------------------------------------------------
  // ---------------------------------------------------


  // Undo/Redo Buttons.
  function undoBtn() {
    currentundoLevel = Number(
      window.sessionStorage.getItem("currentundoLevel")
    );
    if (!arrayOfUndos) {
      return false;
    }
    var indexOfcurrentundoLevel = arrayOfUndos.indexOf(currentundoLevel);
    var indexOfcurrentundoLevelnext;
    indexOfcurrentundoLevelnext = indexOfcurrentundoLevel - 1;
    if (indexOfcurrentundoLevelnext < 0) {
      indexOfcurrentundoLevelnext = 0;
    }
    con(arrayOfUndos);
    con(indexOfcurrentundoLevelnext);
    var currentundoLevelnext = arrayOfUndos[indexOfcurrentundoLevelnext];
    if (currentundoLevelnext) {
      if (indexOfcurrentundoLevel === 0) {
        con('nothing to undo');
        info('nothing to undo', null, null);
      } else {
        con('applied undo');
        info('applied undo', null, null);
      }
      currentundoLevel = currentundoLevelnext;
      window.sessionStorage.setItem("currentundoLevel", currentundoLevel);
      undoRedo();
    } else {
      con('nothing to undo');
    }
  }

  // Redo Button.
  function redoBtn() {
    currentundoLevel = Number(
      window.sessionStorage.getItem("currentundoLevel")
    );
    if (!arrayOfUndos) {
      return false;
    }
    var indexOfcurrentundoLevel = arrayOfUndos.indexOf(currentundoLevel);
    var indexOfcurrentundoLevelnext;
    indexOfcurrentundoLevelnext = indexOfcurrentundoLevel + 1;
    if (indexOfcurrentundoLevelnext < 0) {
      indexOfcurrentundoLevelnext = 0;
    }
    con(arrayOfUndos);
    con(indexOfcurrentundoLevel);
    con(indexOfcurrentundoLevelnext);
    var currentundoLevelnext = arrayOfUndos[indexOfcurrentundoLevelnext];
    if (currentundoLevelnext) {
      con('applied redo');
      info('applied redo', null, null);
      currentundoLevel = currentundoLevelnext;
      window.sessionStorage.setItem("currentundoLevel", currentundoLevel);
      undoRedo();
    } else {
      con('nothing to redo');
      info('nothing to redo', null, null);
    }
  }

  function undoRedo() {
    var inc = Number(currentundoLevel);
    setTimeout(function () {

      INPUTER1.blur();
      INPUTER2.blur();
      INPUTER3.blur();
      INPUTER4.blur();

      var undo_obj = JSON.parse(window.sessionStorage.getItem("undo_obj_" + inc));

      if (inc === 1 && undo_obj[`HTML_${page_name}`] === '""') {
        con('nothing');
        undo_obj[`HTML_${page_name}`] = "";
      }


      con(undo_obj);

      if (undo_obj.CSS_LG) {
        page_name = undo_obj.page_name;
        page_names = undo_obj.page_names;
        thecssLG = undo_obj.CSS_LG;
        thecssMD = undo_obj.CSS_MD;
        thecssSM = undo_obj.CSS_SM;
        thecssXS = undo_obj.CSS_XS;
        HTMLarray = undo_obj[`HTML_${page_name}`];
        INPUTER1.value = undo_obj.inputer1;
        INPUTER2.value = undo_obj.inputer2;
        INPUTER3.value = undo_obj.inputer3;
        INPUTER4.value = undo_obj.inputer4;
        var HTMLstrippedOfBlobs = removeIndexedDBImagesFromClasscss(
          undo_obj[`HTML_${page_name}`]
        );
        window.localStorage.setItem('page_names', JSON.stringify(page_names));
        window.localStorage.setItem('page_name', page_name);
        clearTheHTML(classcss);
        //domAdd(classcss, "beforeend", HTMLstrippedOfBlobs);
        let elem = projectHTMLContainer(HTMLstrippedOfBlobs);
        renderToDOM(createDOMMap(elem));
        // var selectLastElement = undo_obj.lastElement;
        // selectElement(frameID(selectLastElement));
        deselectElement();

        FillValueReadouts();
        //DOMtree(selectLastElement);
        DOMtree();

        buttonRefresh();
        DOMtree();
        hightlightClassBtns();
        hightlightALLClassBtns();

        refreshCodeView();

        if (PROJECT_NAME) {
          saveDebounce();
        }
      }
    }, 0);
    SCROLLBOX.style.setProperty('opacity', '0');
    setTimeout(() => {
      renderImagesFromIndexedDB();
      renderPreviewImagesFromIndexedDB();
    }, 100);

  }
  // ---------------------------------------------------
  // ----------------------------------------------------
  // Test if css objects contain css
  function notEmpty(obj) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) return true;
    }
    return false;
  }

  function testIfcss() {
    var forReturn = false;
    if (notEmpty(thecssLG)) {
      forReturn = true;
    }
    if (notEmpty(thecssMD)) {
      forReturn = true;
    }
    if (notEmpty(thecssSM)) {
      forReturn = true;
    }
    if (notEmpty(thecssXS)) {
      forReturn = true;
    }
    return forReturn;
  }
  // ---------------------------------------------------
  // ----------------------------------------------------
  // Buttons that fire a fill of the undo function.
  // The array of button id's can be found near the
  // begining of this file.
  btnsThatUndo.forEach.call(btnsThatUndo, function (el) {
    domEvent(domID(el), "mouseup", FillUndo);
  });
  // ---------------------------------------------------
  // ----------------------------------------------------
  // Key logger on iframe
  iframe.contentWindow.addEventListener("keyup", function iframeKeyup(e) {
    BoxRefresh();
    if (editingText) {
      FillStorageHTML();
      FillUndo();
    }
  });
  // ---------------------------------------------------
  // ----------------------------------------------------
  // Key bindings
  function keyboardInput(e) {
    var evtobj = window.event ? event : e;

    // switch (evtobj.keyCode) {
    //   case 49: // 1
    //     e.preventDefault();
    //     simulateMouseEvent(BREAKPOINT_BTN_XS, "mousedown");
    //     break;
    //   case 113: // F2
    //     e.preventDefault();
    //     simulateMouseEvent(BREAKPOINT_BTN_SM, "mousedown");
    //     break;
    //   case 114: // F3
    //     e.preventDefault();
    //     simulateMouseEvent(BREAKPOINT_BTN_MD, "mousedown");
    //     break;
    //   case 115: // F4
    //     e.preventDefault();
    //     simulateMouseEvent(BREAKPOINT_BTN_LG, "mousedown");
    //     break;
    //   case 116: // F5
    //     e.preventDefault();
    //     simulateMouseEvent(CSSINLINEBTN, "mousedown");
    //     break;
    // }

    if (!overMainRight) {
      switch (evtobj.keyCode) {
        case 16: // Shift
          e.preventDefault();
          break;
        case 46: // Delete
          e.preventDefault();
          removeElement();
          break;
        case 8: // Backspace
          break;
        case 27: // Esc
          e.preventDefault();
          toggleFullScreenMode();
          break;
        case 32: // SpaceBar
          break;
      }

      if (evtobj.altKey) {
        e.preventDefault();
        switch (evtobj.keyCode) {
          case 38: // ctrl + ArrowUp
            e.preventDefault();
            select_element_sibling_previous();
            context_menu();
            break;
          case 40: // ctrl + ArrowDown
            e.preventDefault();
            select_element_sibling_next();
            context_menu();
            break;
          case 37: // ctrl + ArrowLeft
            e.preventDefault();
            select_element_parent();
            context_menu();
            break;
          case 39: // ctrl + ArrowRight
            e.preventDefault();
            select_element_child();
            context_menu();
            break;
        }
      }

      if (evtobj.ctrlKey) {
        e.preventDefault();
        switch (evtobj.keyCode) {
          case 89: // ctrl + Y
            e.preventDefault();
            redoBtn();
            break;
          case 90: // ctrl + Z
            e.preventDefault();
            undoBtn();
            break;
          case 67: // ctrl + C
            e.preventDefault();
            copyElement();
            //FillUndo();
            break;
          case 68: // ctrl + d
            e.preventDefault();
            copyElement();
            pasteElement();
            //FillUndo();
            break;
          case 86: // ctrl + V
            e.preventDefault();
            pasteElement();
            break;
          case 88: // ctrl + X // delete
            e.preventDefault();
            removeElement();
            break;
          case 38: // ctrl + ArrowUp
            e.preventDefault();
            previousTree();
            break;
          case 40: // ctrl + ArrowDown
            e.preventDefault();
            nextTree();
            break;
          case 37: // ctrl + ArrowLeft
            e.preventDefault();
            upTheTree();
            break;
          case 39: // ctrl + ArrowRight
            e.preventDefault();
            downTheTree();
            break;
          case 83: // // ctrl + S
            // e.preventDefault();
            // saveOrDownloadFiles();
            break;
        }
      }
    }
  }
  iframe.contentWindow.window.addEventListener("keydown", function (e) {
    if (e.ctrlKey && e.which == 83) {
      e.preventDefault();
      //alert("Ctrl+S");
      //saveOrDownloadFiles(true);
      //saveOrDownloadFiles();
      return false;
    }
  });
  document.addEventListener("keydown", function (e) {
    var keycode = (e.keyCode ? e.keyCode : e.which);
    if (e.ctrlKey && keycode == 83) {
      e.preventDefault();
      //alert("Ctrl+S");
      //saveOrDownloadFiles(true);
      //saveOrDownloadFiles();
      return false;
    }
    // enter keypress on GUI
    if (keycode === 13) {
      // Enter
      switch (document.activeElement) {
        case INPUTER1:
          e.preventDefault();
          if (INPUTER1.value) {
            clickAddClass();
            INPUTER2.focus();
          }
          break;
        case INPUTER2:
          e.preventDefault();
          if (INPUTER2.value) {
            INPUTER3.focus();
          }
          break;
        case INPUTER3:
          e.preventDefault();
          INPUTER3.blur();
          break;
      }
    }
  });

  window.onkeyup = keyboardInput;
  UNDO_BTN.onmousedown = function (e) {
    e.preventDefault();
    undoBtn();
    return false;
  };
  REDO_BTN.onmousedown = function (e) {
    redoBtn();
    return false;
  };

  // ---------------------------------------------------
  // ----------------------------------------------------
  // Color and background-color selector buttons.
  // ---------------------------------------------------
  // ----------------------------------------------------
  // RGBA Sliders
  RED_SLIDER.value = "128";
  GREEN_SLIDER.value = "128";
  BLUE_SLIDER.value = "128";
  ALPHA_SLIDER.value = "100";
  RED_SLIDER.oninput = function () {
    requestAnimationFrame(colorFunction);
  };
  GREEN_SLIDER.oninput = function () {
    requestAnimationFrame(colorFunction);
  };
  BLUE_SLIDER.oninput = function () {
    requestAnimationFrame(colorFunction);
  };
  ALPHA_SLIDER.oninput = function () {
    alphaVal = Number(ALPHA_SLIDER.value);
    alphaVal /= Math.pow(10, 2);
    requestAnimationFrame(colorFunction);
  };
  // ---------------------------------------------------
  // ----------------------------------------------------
  // RGBA Sliders function
  function colorFunction() {
    if (!INPUTER1.value) {
      return false;
    }
    rgb =
      RED_SLIDER.value +
      "," +
      GREEN_SLIDER.value +
      "," +
      BLUE_SLIDER.value;
    theColor = "rgba(" + rgb + "," + alphaVal + ")";
    INPUTER2.value = theColorProperty;
    INPUTER3.value = theColor;
    clickAdder(null);
  }
  // ---------------------------------------------------
  // ----------------------------------------------------
  // RGBA Sliders, updates slider positions and color/BGcolor button values.
  function getColorValues(color) {
    var pars;
    var repars;
    var values = {
      red: null,
      green: null,
      blue: null,
      alpha: null
    };
    if (typeof color == "string") {
      /* hex */
      if (color.indexOf("#") === 0) {
        color = color.substr(1);
        if (color.length == 3)
          values = {
            red: parseInt(color[0] + color[0], 16),
            green: parseInt(color[1] + color[1], 16),
            blue: parseInt(color[2] + color[2], 16),
            alpha: 1
          };
        else
          values = {
            red: parseInt(color.substr(0, 2), 16),
            green: parseInt(color.substr(2, 2), 16),
            blue: parseInt(color.substr(4, 2), 16),
            alpha: 1
          };
        /* rgb */
      } else if (color.indexOf("rgb(") === 0) {
        pars = color.indexOf(",");
        values = {
          red: parseInt(color.substr(4, pars)),
          green: parseInt(
            color.substr(pars + 1, color.indexOf(",", pars))
          ),
          blue: parseInt(
            color.substr(
              color.indexOf(",", pars + 1) + 1,
              color.indexOf(")")
            )
          ),
          alpha: 1
        };
        /* rgba */
      } else if (color.indexOf("rgba(") === 0) {
        pars = color.indexOf(",");
        repars = color.indexOf(",", pars + 1);
        values = {
          red: parseInt(color.substr(5, pars)),
          green: parseInt(color.substr(pars + 1, repars)),
          blue: parseInt(
            color.substr(
              color.indexOf(",", pars + 1) + 1,
              color.indexOf(",", repars)
            )
          ),
          alpha: parseFloat(
            color.substr(
              color.indexOf(",", repars + 1) + 1,
              color.indexOf(")")
            )
          )
        };
        /* verbous */
      } else if (color.indexOf("transparent") === 0) {
        values = {
          red: 0,
          green: 0,
          blue: 0,
          alpha: 0
        };
        /* verbous */
      } else {
        var stdCol = {
          black: "#000000",
          silver: "#c0c0c0",
          gray: "#808080",
          white: "#ffffff",
          maroon: "#800000",
          red: "#ff0000",
          purple: "#800080",
          fuchsia: "#ff00ff",
          green: "#008000",
          lime: "#00ff00",
          olive: "#808000",
          yellow: "#ffff00",
          navy: "#000080",
          blue: "#0000ff",
          teal: "#008080",
          aqua: "#00ffff",
          orange: "#ffa500",
          aliceblue: "#f0f8ff",
          antiquewhite: "#faebd7",
          aquamarine: "#7fffd4",
          azure: "#f0ffff",
          beige: "#f5f5dc",
          bisque: "#ffe4c4",
          blanchedalmond: "#ffebcd",
          blueviolet: "#8a2be2",
          brown: "#a52a2a",
          burlywood: "#deb887",
          cadetblue: "#5f9ea0",
          chartreuse: "#7fff00",
          chocolate: "#d2691e",
          coral: "#ff7f50",
          cornflowerblue: "#6495ed",
          cornsilk: "#fff8dc",
          crimson: "#dc143c",
          cyan: "#00ffff",
          darkblue: "#00008b",
          darkcyan: "#008b8b",
          darkgoldenrod: "#b8860b",
          darkgray: "#a9a9a9",
          darkgreen: "#006400",
          darkgrey: "#a9a9a9",
          darkkhaki: "#bdb76b",
          darkmagenta: "#8b008b",
          darkolivegreen: "#556b2f",
          darkorange: "#ff8c00",
          darkorchid: "#9932cc",
          darkred: "#8b0000",
          darksalmon: "#e9967a",
          darkseagreen: "#8fbc8f",
          darkslateblue: "#483d8b",
          darkslategray: "#2f4f4f",
          darkslategrey: "#2f4f4f",
          darkturquoise: "#00ced1",
          darkviolet: "#9400d3",
          deeppink: "#ff1493",
          deepskyblue: "#00bfff",
          dimgray: "#696969",
          dimgrey: "#696969",
          dodgerblue: "#1e90ff",
          firebrick: "#b22222",
          floralwhite: "#fffaf0",
          forestgreen: "#228b22",
          gainsboro: "#dcdcdc",
          ghostwhite: "#f8f8ff",
          gold: "#ffd700",
          goldenrod: "#daa520",
          greenyellow: "#adff2f",
          grey: "#808080",
          honeydew: "#f0fff0",
          hotpink: "#ff69b4",
          indianred: "#cd5c5c",
          indigo: "#4b0082",
          ivory: "#fffff0",
          khaki: "#f0e68c",
          lavender: "#e6e6fa",
          lavenderblush: "#fff0f5",
          lawngreen: "#7cfc00",
          lemonchiffon: "#fffacd",
          lightblue: "#add8e6",
          lightcoral: "#f08080",
          lightcyan: "#e0ffff",
          lightgoldenrodyellow: "#fafad2",
          lightgray: "#d3d3d3",
          lightgreen: "#90ee90",
          lightgrey: "#d3d3d3",
          lightpink: "#ffb6c1",
          lightsalmon: "#ffa07a",
          lightseagreen: "#20b2aa",
          lightskyblue: "#87cefa",
          lightslategray: "#778899",
          lightslategrey: "#778899",
          lightsteelblue: "#b0c4de",
          lightyellow: "#ffffe0",
          limegreen: "#32cd32",
          linen: "#faf0e6",
          magenta: "#ff00ff",
          mediumaquamarine: "#66cdaa",
          mediumblue: "#0000cd",
          mediumorchid: "#ba55d3",
          mediumpurple: "#9370db",
          mediumseagreen: "#3cb371",
          mediumslateblue: "#7b68ee",
          mediumspringgreen: "#00fa9a",
          mediumturquoise: "#48d1cc",
          mediumvioletred: "#c71585",
          midnightblue: "#191970",
          mintcream: "#f5fffa",
          mistyrose: "#ffe4e1",
          moccasin: "#ffe4b5",
          navajowhite: "#ffdead",
          oldlace: "#fdf5e6",
          olivedrab: "#6b8e23",
          orangered: "#ff4500",
          orchid: "#da70d6",
          palegoldenrod: "#eee8aa",
          palegreen: "#98fb98",
          paleturquoise: "#afeeee",
          palevioletred: "#db7093",
          papayawhip: "#ffefd5",
          peachpuff: "#ffdab9",
          peru: "#cd853f",
          pink: "#ffc0cb",
          plum: "#dda0dd",
          powderblue: "#b0e0e6",
          rosybrown: "#bc8f8f",
          royalblue: "#4169e1",
          saddlebrown: "#8b4513",
          salmon: "#fa8072",
          sandybrown: "#f4a460",
          seagreen: "#2e8b57",
          seashell: "#fff5ee",
          sienna: "#a0522d",
          skyblue: "#87ceeb",
          slateblue: "#6a5acd",
          slategray: "#708090",
          slategrey: "#708090",
          snow: "#fffafa",
          springgreen: "#00ff7f",
          steelblue: "#4682b4",
          tan: "#d2b48c",
          thistle: "#d8bfd8",
          tomato: "#ff6347",
          turquoise: "#40e0d0",
          violet: "#ee82ee",
          wheat: "#f5deb3",
          whitesmoke: "#f5f5f5",
          yellowgreen: "#9acd32",
          rebeccapurple: "#663399",
          transparent: "transparent"
        };
        if (stdCol[color] !== undefined)
          values = getColorValues(stdCol[color]);
      }
    }
    return values;
  }

  // ---------------------------------------------------
  // ----------------------------------------------------
  // Shows how much local storage used.

  function localStorageSpace() {
    var allStrings = "";
    for (var key_1 in window.localStorage) {
      if (window.localStorage.hasOwnProperty(key_1)) {
        allStrings += window.localStorage[key_1];
      }
    }
    return allStrings ?
      Math.round(3 + (allStrings.length * 16) / (8 * 1024)) / 2 :
      0;
  }

  // ---------------------------------------------------
  // ----------------------------------------------------
  // Shows how much session storage used.

  function sessionStorageSpace() {
    var allStrings = "";
    for (var key_2 in window.sessionStorage) {
      if (window.sessionStorage.hasOwnProperty(key_2)) {
        allStrings += window.sessionStorage[key_2];
      }
    }
    return allStrings ?
      Math.round(3 + (allStrings.length * 16) / (8 * 1024)) / 2 :
      0;
  }

  // ---------------------------------------------------
  // ----------------------------------------------------
  // Adds extra class element from inputer4.
  domEvent(domID("addAnotherClass"), "mousedown", function () {
    if (!INPUTER1.value) {
      INPUTER1.value = INPUTER4.value;
    }
    if (INPUTER1.value && INPUTER4.value) {
      if (domElement[0] !== "classcss") {
        frameID(domElement[0]).classList.add(INPUTER4.value);
        INPUTER1.value = INPUTER4.value;
        INPUTER1.value = "";
        INPUTER1.value = "";
        if (!thecssLG[INPUTER4.value]) {
          put(INPUTER4.value, {}, thecssLG);
          put(INPUTER4.value, {}, thecssMD);
          put(INPUTER4.value, {}, thecssSM);
          put(INPUTER4.value, {}, thecssXS);
        }
        buttonRefresh();
        DOMtree();
        selectElement(frameID(domElement[0]));
        logger();
      }
    }
  });
  // Remove extra class element inputer4.
  domEvent(domID("removeExtraClass"), "mousedown", function () {
    if (INPUTER1.value && INPUTER4.value) {
      if (frameID(domElement[0]).classList.length > 1) {
        frameID(domElement[0]).classList.remove(INPUTER4.value);
        domForQuery('[data-tracker="' + INPUTER1.value + '"]', function (
          el
        ) {
          //delete el['data-tracker'];
          el.removeAttribute('data-tracker');
        });
        buttonRefresh();
        clickRemoveClass();
        DOMtree();
        selectElement(frameID(domElement[0]));
        INPUTER4.value = INPUTER1.value;
      }
    }
  });
  // Populates inputer4 and inputer1's value with class button value.
  document.querySelector("body").addEventListener("mouseup", function (event) {
    if (event.target.dataset.name === "removeRefresh") {
      INPUTER1.value = event.target.innerHTML;
      INPUTER4.value = event.target.innerHTML;
      INPUTER2.value = "";
      INPUTER3.value = "";
      frameID(domElement[0])['data-tracker'] = event.target.innerHTML;
      FillValueReadouts();
      hightlightClassBtns();
      hightlightALLClassBtns();
      // this is the lower set by inputer 4
      selectElement(frameID(domElement[0]));
    }
    if (event.target.dataset.name === "removeRefreshClasses") {
      //inputer1.value = (<HTMLElement>event.target).innerHTML;
      INPUTER4.value = event.target.innerHTML;
      INPUTER2.value = "";
      INPUTER3.value = "";
      FillValueReadouts();
      hightlightClassBtns();
      hightlightALLClassBtns();
    } else if (domElement[0]) {
      if (event.target.id === "background-color") {
        if (!INPUTER1.value) {
          if (testIfcss()) {
            info("Select an element.", null, null);
          } else {
            info(
              "You need to create a element with a class name.",
              null,
              null
            );
          }
          return false;
        }
        if (CSSstyles["background-color"]) {
          INPUTER2.value = "background-color";
          INPUTER3.value = CSSstyles["background-color"];
          FillValueReadouts();
          buttonRefresh();
        } else {
          INPUTER2.value = "";
          INPUTER3.value = "";
        }
      } else if (event.target.id === "color") {
        if (!INPUTER1.value) {
          if (testIfcss()) {
            info("Select an element.", null, null);
          } else {
            info(
              "You need to create a element with a class name.",
              null,
              null
            );
          }
          return false;
        }
        if (CSSstyles["color"]) {
          INPUTER2.value = "color";
          INPUTER3.value = CSSstyles["color"];
          FillValueReadouts();
          buttonRefresh();
        } else {
          INPUTER2.value = "";
          INPUTER3.value = "";
        }
      }
    }
  });

  function hightlightClassBtns() {
    var input1 = INPUTER1.value;
    domForQuery('button[data-name="removeRefresh"]', function (el) {
      el.style = buttonBGColor;
    });
    if (document.querySelector('[data-classID="' + input1 + '"]')) {
      document
        .querySelector('[data-classID="' + input1 + '"]').style = buttonHLColor;
    }
  }

  function hightlightALLClassBtns() {
    var input1 = INPUTER1.value;
    domForQuery('button[data-name="removeRefreshClasses"]', function (el) {
      el.style = buttonBGColor;
    });
    if (document.querySelector('[data-classesID="' + input1 + '"]')) {
      document
        .querySelector('[data-classesID="' + input1 + '"]').style = buttonHLColor;
    }
  }
  // ---------------------------------------------------
  // ---------------------------------------------------
  // Renders DOM tree buttons


  var html_add = "";

  var DomTreeRunning = false;
  var allKids_arr = [];

  var number_of_class;

  let domtree_id;

  function DOMtree(HL) {

    if (document.getElementById("left-sections").style.getPropertyValue('display')) {
      return false;
    }

    if (!DomTreeRunning) {
      DomTreeRunning = true;
      allKids_arr = [];
      html_add = "";
      number_of_class = 1;

      var allKids = [...classcss.querySelectorAll("*")];
      allKids_arr = allKids.filter((kid) => {
        var arrayOfTagNames = getTagNamesArray(kid);
        if (arrayOfTagNames.length !== 1 && kid.tagName === 'BR') {
          // no return;
        } else {
          return kid;
        }
      });

      rebtns3.innerHTML = "";
      if (!allKids.length) {
        rebtns3.innerHTML = /*HTML*/ `<div class="rebtns3_container">no elements added</div>`;
      }

      domtree_id = 0;
      render_all_domtree_elements();
      domAdd(
        rebtns3,
        "beforeend",
        html_add
      );
      addClickDom();
      if (HL) {
        domTreeBtnHighlight(HL);
      }
      DomTreeRunning = false;
      // }, 0);
      clickTreeExpand();
      clickTreeExpand_render();
    }
  }


  function addOrRemove_array_item(array, value) {
    var index = array.indexOf(value);
    if (index === -1) {
      array.push(value);
    } else {
      array.splice(index, 1);
    }
  }

  function remove_array_item(array, value) {
    var index = array.indexOf(value);
    array.splice(index, 1);
  }

  let tree_expand_parent_el_arr = [];
  let tree_expand_children_el_arr = [];

  if (window.localStorage.getItem('tree_expand_parent_el_arr')) {
    tree_expand_parent_el_arr = JSON.parse(window.localStorage.getItem('tree_expand_parent_el_arr'));
  }
  if (window.localStorage.getItem('tree_expand_children_el_arr')) {
    tree_expand_children_el_arr = JSON.parse(window.localStorage.getItem('tree_expand_children_el_arr'));
  }

  function clickTreeExpand() {
    [...document.querySelectorAll('.t-i--with_child')].forEach(el => {
      el.style.setProperty('pointer-events', 'all');
      el.onmousedown = () => {
        add_tree_arrays(el.parentElement.getAttribute('data-clicks'));
      };
    });
  }

  // this fires only when expansion is clicked
  function add_tree_arrays(el) {
    tree_expand_children_el_arr = [];

    [...document.querySelectorAll('data-clicks')].forEach(el => {
      let el_id = el.getAttribute('data-clicks');
      if (tree_expand_parent_el_arr.indexOf(el_id) === -1) {
        remove_array_item(tree_expand_parent_el_arr, el_id);
      }
    });

    let parent_el = frameID(el);
    addOrRemove_array_item(tree_expand_parent_el_arr, parent_el.id);
    // remove any parent of this el
    let active_el = parent_el;
    while (active_el) {
      if (active_el.id === 'classcss') {
        break;
      }
      active_el = active_el.parentElement;
      if (active_el.id) {
        tree_expand_parent_el_arr = tree_expand_parent_el_arr.filter((item) => {
          return active_el.id !== item;
        });
      }
    }
    tree_expand_parent_el_arr.forEach(parent_el => {
      if (frameID(parent_el)) {
        let el_children = [...frameID(parent_el).getElementsByTagName("*")];
        el_children.forEach(child_el => {
          if (child_el.id) {
            tree_expand_children_el_arr.push(child_el.id);
          }
        });
      }
    });
    window.localStorage.setItem('tree_expand_parent_el_arr', JSON.stringify(tree_expand_parent_el_arr));
    window.localStorage.setItem('tree_expand_children_el_arr', JSON.stringify(tree_expand_children_el_arr));
    clickTreeExpand_render();
  }

  function clickTreeExpand_render() {
    [...document.querySelectorAll('[data-clicks]')].forEach(el => {
      let this_id = el.getAttribute('data-clicks');
      if (tree_expand_parent_el_arr.indexOf(this_id) > -1) {
        el.classList.add("closed-tree-parent");
      } else {
        el.classList.remove("closed-tree-parent");
      }
      if (tree_expand_children_el_arr.indexOf(this_id) > -1) {
        el.classList.add("closed-tree");
      } else {
        el.classList.remove("closed-tree");
      }
    });
    // get parents of active id 
    let active_parents = [];
    let active_el = frameID(domElement[0]);
    if (active_el) {
      while (active_el) {
        if (active_el.id === 'classcss') {
          break;
        }
        active_el = active_el.parentElement;
        if (active_el.id) {
          active_parents.unshift(active_el.id);
        }
      }
    }
    active_parents.forEach((el) => {
      if (el !== 'classcss' && document.querySelector('[data-clicks="' + el + '"]')) {
        document.querySelector('[data-clicks="' + el + '"]').classList.remove("closed-tree-parent");
      }
    });
    // get children of those parents
    var siblings = [];
    active_parents.forEach((el) => {
      let sibling = frameID(el).firstElementChild;
      if (sibling) {
        while (sibling) {
          if (sibling.nodeType === 1 && sibling !== frameID(el)) {
            siblings.push(sibling.id);
          }
          sibling = sibling.nextSibling;
        }
      }
    });
    siblings.forEach((el) => {
      if (document.querySelector('[data-clicks="' + el + '"]')) {
        document.querySelector('[data-clicks="' + el + '"]').classList.remove("closed-tree");
      }
    });
  }

  function render_all_domtree_elements() {
    allKids_arr.map((val, i) => {
      allKids_arr.map((val, j) => {
        if (parentNth(allKids_arr[i], j + 1) === classcss) {
          html_add += renderDOMTreeBtn(j + "", allKids_arr[i]);
        }
      });
    });
    // Stops anchor click if not in fullscreen mode
    stopAClicks();
  }

  function stopAClicks() {
    var atags = classcss.getElementsByTagName("A");
    [].forEach.call(atags, function (atag) {
      atag.addEventListener("click", function (event) {
        if (fullScreenMode) {
          return false;
        }
        event.preventDefault();
        return false;
      });
    });
  }

  function parentNth(element, number) {
    var el = element;
    var i;
    for (i = 0; i < number; i++) {
      if (el.parentElement) {
        el = el.parentElement;
      }
    }
    return el;
  }

  function removeDups(names) {
    var unique = {};
    names.forEach(function (i) {
      if (!unique[i]) {
        unique[i] = true;
      }
    });
    return Object.keys(unique);
  }

  function getTagNamesArray(el) {
    var children = el.children;
    var childrenlen = children.length;
    var i;
    var childrenArray = [];
    for (i = 0; i < childrenlen; i++) {
      childrenArray.push(children[i].tagName);
    }
    return removeDups(childrenArray);
  }

  // returns true if the element or one of its parents has the class classname
  function hasSomeParentTheClass(element, classname) {
    if (!element) {
      return false;
    }
    if (element.classList && element.classList.contains(classname)) return true;
    return element.parentNode && hasSomeParentTheClass(element.parentNode, classname);
  }


  var tree_div_1 = '<div class="t-i t-i--next_sib t-i--highlight"></div>';
  var tree_div_2 = '<div class="t-i t-i--next_sib"></div>';
  var tree_div_3 = '<div class="t-i t-i--space"></div>';
  var tree_div_4 = '<div class="t-i t-i--no_sib t-i--highlight"></div>';
  var tree_div_5 = '<div class="t-i t-i--no_sib"></div>';
  var tree_div_6 = '<div class="t-i t-i--sib t-i--highlight"></div>';
  var tree_div_7 = '<div class="t-i t-i--sib"></div>';
  var tree_div_8 = '<div class="t-i t-i--only_child t-i--highlight"></div>';
  var tree_div_9 = '<div class="t-i t-i--only_child"></div>';
  var tree_div_10 = '<div class="t-i t-i--with_child t-i--highlight"></div>';
  var tree_div_11 = '<div class="t-i t-i--with_child"></div>';




  function renderDOMTreeBtn(parentElementNum, DOMchild) {
    //con(DOMchild);
    var arrayOfTagNames = getTagNamesArray(DOMchild);
    if (arrayOfTagNames.length === 1 && DOMchild.tagName === 'BR') {
      return false;
    }
    // Dont want BR to show in the tree.
    //var place = rebtns3;
    var tag = DOMchild.tagName.toLowerCase();
    var id = DOMchild.id;
    var treeBlocks = "";
    var highlight_children = hasSomeParentTheClass(DOMchild, INPUTER1.value);

    for (var i = parentElementNum; i >= 1; i--) {
      var NthParentEl = parentNth(DOMchild, i);
      if (NthParentEl !== classcss) {
        var nextSibling = NthParentEl.nextSibling;
        while (nextSibling && nextSibling.nodeType != 1) {
          nextSibling = nextSibling.nextSibling;
        }
        //var nextSibling_readout = "&nbsp;";
        var nextSibling_readout;
        if (nextSibling) {
          //nextSibling_readout = "|";
          var highlight_children_nextSibling = hasSomeParentTheClass(nextSibling, INPUTER1.value);
          if (highlight_children_nextSibling) {
            nextSibling_readout = tree_div_1;
          } else {
            nextSibling_readout = tree_div_2;
          }
        } else {
          nextSibling_readout = tree_div_3;
        }
        treeBlocks += nextSibling_readout;
      }
    }

    //var DOMchild_sibling_readout = "L";
    var DOMchild_sibling_readout;
    if (highlight_children) {
      DOMchild_sibling_readout = tree_div_4;
    } else {
      DOMchild_sibling_readout = tree_div_5;
    }

    var DOMchild_nextSibling = DOMchild.nextSibling;
    while (DOMchild_nextSibling && DOMchild_nextSibling.nodeType != 1) {
      DOMchild_nextSibling = DOMchild_nextSibling.nextSibling;
    }
    if (DOMchild_nextSibling) {
      //DOMchild_sibling_readout = "⊢";
      if (highlight_children) {
        DOMchild_sibling_readout = tree_div_6;
      } else {
        DOMchild_sibling_readout = tree_div_7;
      }
    }

    //var DOMchild_children_readout = "-";
    var DOMchild_children_readout;
    if (highlight_children) {
      DOMchild_children_readout = tree_div_8;
    } else {
      DOMchild_children_readout = tree_div_9;
    }

    if (DOMchild.children.length) { // if it has children
      if (arrayOfTagNames.length === 1 && arrayOfTagNames[0] === "BR") {
        // do nothing
      } else {
        //DOMchild_children_readout = '⊺';
        if (highlight_children) {
          DOMchild_children_readout = tree_div_10;
        } else {
          DOMchild_children_readout = tree_div_11;
        }
      }

    }

    treeBlocks += DOMchild_sibling_readout;
    treeBlocks += DOMchild_children_readout;

    var DOMclassname_active = "";
    if (DOMchild.classList.length) {
      [...DOMchild.classList].map((DOMclassname) => {
        var active_class = "";
        if (INPUTER1.value === '.' + DOMclassname) {
          active_class = ' data-selectornumberdomtree="' + number_of_class + '" class="domTreeClassColor--active"';
          number_of_class++;
        }
        DOMclassname = "." +
          DOMclassname
          .toString()
          .trim()
          .replace(/\s+/g, ".");
        DOMclassname_active += '<span' + active_class + '>' + escapeHTML(DOMclassname) + '</span>';
      });
    }

    var DOMtagname_active = "";
    var active_tag = "";
    if (domElement[1] && tag === domElement[1].toLowerCase() && INPUTER1.value && INPUTER1.value !== "undefined") {
      active_tag = ' class="domTreeTagColor--active"';
    }
    DOMtagname_active = '<span' + active_tag + '>' + escapeHTML(tag) + '</span>';

    var idName;
    if (id.length === 11 && id.includes("ID-")) {
      idName = "";
    } else {
      idName = "#" + id;
    }

    var data_image_tag = '';
    let img_src = DOMchild.getAttribute('src');
    if (img_src) {
      let data_image = DOMchild.getAttribute('data-image');
      data_image_tag = /*HTML*/ `<div class="domtr-data-image" style="background-image: url(${escapeHTML(JSON.stringify(img_src))});"></div>`;
    }

    domtree_id++;

    return /*HTML*/ `<div draggable="true" class="domTree_BG" id="dt-${domtree_id}" data-name="domtr" data-css="domtd" data-clicks="${escapeHTML(id)}">${treeBlocks}<span class="domTreeTagColor">${DOMtagname_active}</span>${data_image_tag}<span class="domTreeIdColor">${escapeHTML(idName)}</span><span class="domTreeClassColor">${DOMclassname_active}</span></div>`;

  }

  function addClickDom() {
    var els_to_add_click_to = [...document.querySelectorAll('[data-name="domtr"]')];
    els_to_add_click_to.map((el) => {
      var el_id = el.getAttribute('data-clicks');
      var el_uniqid = el.id;
      var el_tag = el.tagName;
      clickDOM(el_id, el_uniqid, el_tag);
    });
  }

  var startEl;
  var startElChildrenArr;
  var canDropEl;
  var overEl;
  var top_mid_or_bottom;
  var isDBimage;

  function allDescendants(node) {
    for (var i = 0; i < node.childNodes.length; i++) {
      var child = node.childNodes[i];
      allDescendants(child);
      startElChildrenArr.push(child.id);
    }
  }


  var allow_childen = [...document.querySelectorAll('[data-allow_childen]')];
  var acceptChildren = allow_childen.map((el) => {
    return el.value;
  });

  var allow_text_edit = [...document.querySelectorAll('[data-allow_text_edit]')];
  var acceptTextEdit = allow_text_edit.map((el) => {
    return el.value;
  });

  function checkTagNameExceptsChildren(tagname) {
    var passtest = false;
    acceptChildren.map((exceptChild) => {
      if (tagname.toLowerCase() === exceptChild.toLowerCase()) {
        passtest = true;
      }
    });
    return passtest;
  }

  function select_expand_tree_el(el) {
    remove_array_item(tree_expand_parent_el_arr, el);

    tree_expand_children_el_arr = [];
    let parent_el = frameID(el);
    let active_el = parent_el;
    while (active_el) {
      if (active_el.id === 'classcss') {
        break;
      }
      active_el = active_el.parentElement;
      if (active_el.id) {
        tree_expand_parent_el_arr = tree_expand_parent_el_arr.filter((item) => {
          return active_el.id !== item;
        });
      }
    }
    tree_expand_parent_el_arr.forEach(parent_el => {
      if (frameID(parent_el)) {
        let el_children = [...frameID(parent_el).getElementsByTagName("*")];
        el_children.forEach(child_el => {
          if (child_el.id) {
            tree_expand_children_el_arr.push(child_el.id);
          }
        });
      }
    });

    [...document.querySelectorAll('[data-clicks]')].forEach(el => {
      let this_id = el.getAttribute('data-clicks');
      if (tree_expand_parent_el_arr.indexOf(this_id) === -1) {
        el.classList.remove("closed-tree-parent");
      }
      if (tree_expand_children_el_arr.indexOf(this_id) === -1) {
        el.classList.remove("closed-tree");
      }
    });
  }

  let tree_open_delay = null;

  function clickDOM(place, id, tag) {
    domEvent(domID(id), "mousedown", function () {
      if (isDBimage === true) {
        canDropEl = false;
        return false;
      }
      con('clickDOM');
      con(frameID(place).getAttribute('class'));
      //DOMtree(frameID(place).id);
      selectElement(frameID(place));
    });
    domEvent(domID(id), "dragstart", function (e) {
      if (isDBimage === true) {
        return false;
      }
      e.dataTransfer.setDragImage(img, 0, 0);
      startEl = domID(id).getAttribute("data-clicks");
      startElChildrenArr = [];
      allDescendants(frameID(startEl));
      canDropEl = true;
    });
    domEvent(domID(id), "dragenter", function (e) {
      if (isDBimage === true) {
        canDropEl = false;
        return false;
      }
      clearTimeout(tree_open_delay);
      // open tree after delay
      tree_open_delay = setTimeout(() => {
        // if over el has class 
        let current_over_el = document.querySelector('[data-clicks="' + overEl + '"]');
        if (!current_over_el.classList.contains('closed-tree-parent')) {
          return false;
        }

        var tagEl = frameID(overEl).tagName;
        if (!checkTagNameExceptsChildren(tagEl)) {
          return false;
        }

        select_expand_tree_el(overEl);
      }, 1250);
    });
    domEvent(domID(id), "dragover", function (e) {
      if (isDBimage === true) {
        return false;
      }
      var rect = e.target.getBoundingClientRect();
      var y = e.clientY - rect.top; //y position within the element.
      var height = rect.height;
      overEl = domID(id).getAttribute("data-clicks");
      if (startEl === overEl) {
        return false;
      }
      var pass = true;
      if (startElChildrenArr) {
        [].forEach.call(startElChildrenArr, function (elID) {
          if (elID === overEl) {
            pass = false;
          }
        });
      }
      if (pass === false) {
        canDropEl = false;
        domID(id).style.borderBottom = "0px dashed " + "red";
        domID(id).style.border = "1px dashed " + "red";
        msgStr = "Cannot Insert element into itself";
        info(msgStr, null, true);
        return false;
      } else {
        canDropEl = true;
      }
      var msgStr;
      var tagEl = frameID(overEl).tagName;
      var ytop = y < height / 3;
      var ymid = y > height / 3 && y < (height / 3) * 2;
      var ybot = y > (height / 3) * 2;

      let startEl_textContent = startEl;
      let check_start_el = frameID(startEl);
      if (check_start_el) {
        startEl_textContent = document.querySelector('[data-clicks="' + frameID(startEl).id + '"]').textContent;
      }

      let overEl_textContent = document.querySelector('[data-clicks="' + frameID(overEl).id + '"]').textContent;

      if (
        // at the top
        ytop &&
        checkTagNameExceptsChildren(tagEl)
      ) {
        // put before
        domID(id).style.border = null;
        domID(id).style.borderTop = "1px dashed " + BorderHL;
        domID(id).style.background = 'var(--light-bg-color)';
        msgStr =
          "Put " +
          '<span class="hue-apply" style="color: var(--mainColor);">' + startEl_textContent + '</span>' +
          " before " +
          '<span class="hue-apply" style="color: var(--mainColor);">' + overEl_textContent + '</span>';
        info(msgStr, null, null);
        top_mid_or_bottom = "top";
      } else if (
        // at the middle
        ymid &&
        checkTagNameExceptsChildren(tagEl)
        // put inside
      ) {
        domID(id).style.borderBottom = "0px dashed " + BorderHL;
        domID(id).style.border = "1px dashed " + BorderHL;
        domID(id).style.background = 'var(--light-bg-color)';
        msgStr =
          "Insert " +
          '<span class="hue-apply" style="color: var(--mainColor);">' + startEl_textContent + '</span>' +
          " into " +
          '<span class="hue-apply" style="color: var(--mainColor);">' + overEl_textContent + '</span>';
        info(msgStr, null, null);
        top_mid_or_bottom = "mid";
      } else if (
        // at the bottom
        ybot &&
        checkTagNameExceptsChildren(tagEl)
        // put after
      ) {
        domID(id).style.border = null;
        domID(id).style.borderBottom = "1px dashed " + BorderHL;
        domID(id).style.background = 'var(--light-bg-color)';
        msgStr =
          "Put " +
          '<span class="hue-apply" style="color: var(--mainColor);">' + startEl_textContent + '</span>' +
          " after " +
          '<span class="hue-apply" style="color: var(--mainColor);">' + overEl_textContent + '</span>';
        info(msgStr, null, null);
        top_mid_or_bottom = "bottom";
      } else {
        if (ytop) {
          // put before
          domID(id).style.border = null;
          domID(id).style.borderTop = "1px dashed " + BorderHL;
          domID(id).style.background = 'var(--light-bg-color)';
          msgStr =
            "Put " +
            '<span class="hue-apply" style="color: var(--mainColor);">' + startEl_textContent + '</span>' +
            " before " +
            '<span class="hue-apply" style="color: var(--mainColor);">' + overEl_textContent + '</span>';
          info(msgStr, null, null);
          top_mid_or_bottom = "top";
        } else if (ymid || ybot) {
          // put after
          domID(id).style.border = null;
          domID(id).style.borderBottom = "1px dashed " + BorderHL;
          domID(id).style.background = 'var(--light-bg-color)';
          msgStr =
            "Put " +
            '<span class="hue-apply" style="color: var(--mainColor);">' + startEl_textContent + '</span>' +
            " after " +
            '<span class="hue-apply" style="color: var(--mainColor);">' + overEl_textContent + '</span>';
          info(msgStr, null, null);
          top_mid_or_bottom = "bottom";
        }
      }
    });
    domEvent(domID(id), "dragleave", function (e) {
      domID(id).style.marginBottom = "0px";
      domID(id).style.borderBottom = null;
      domID(id).style.border = null;
      domID(id).style.background = null;
      if (canDropEl === false) {
        return false;
      }
      overEl = domID(id).getAttribute("data-clicks");
    });
    domEvent(domID(id), "drop", function (e) {
      if (canDropEl === false) {
        return false;
      }
      if (startEl === overEl) {
        return false;
      }

      var tagEl = frameID(overEl).tagName;
      let position_to_add = "";
      if (checkTagNameExceptsChildren(tagEl)) {
        if (top_mid_or_bottom === "top") {
          position_to_add = "beforebegin";
        } else if (top_mid_or_bottom === "mid") {
          position_to_add = "afterbegin";
        } else if (top_mid_or_bottom === "bottom") {
          position_to_add = "afterend";
        }
      } else {
        if (top_mid_or_bottom === "top") {
          position_to_add = "beforebegin";
        } else if (top_mid_or_bottom === "mid") {
          // does not get inserted
          position_to_add = "afterend";
        } else if (top_mid_or_bottom === "bottom") {
          position_to_add = "afterend";
        }
      }

      let drop_element = e.dataTransfer.getData("application/drop-element");
      if (drop_element) {
        guidGenerator();
        let HTML_to_add = {
          tag: drop_element,
          id: uniqid
        };
        domAddElement(frameID(overEl), position_to_add, HTML_to_add);
      } else {
        frameID(overEl).insertAdjacentElement(
          position_to_add,
          frameID(startEl)
        );
      }

      renderToDOM(createDOMMap(classcss));
      FillUndo();

      select_expand_tree_el(startEl);
      //DOMtree(frameID(startEl).id);
      //refreshCodeView();
      info("", null, null);
      setTimeout(() => {
        selectElement(frameID(startEl));
      }, 100);
    });

    domEvent(domID(id), "contextmenu", function (e) {
      e.preventDefault();
      context_menu(e, true);
      // con('contextmenu click');
      // promptForAttribute(place);
    });
  }

  var arr_attrs_not_allowed = ['draggable', 'data-tracker', 'data-image', 'src', 'style'];

  addAttributes.onmousedown = function () {
    if (!domElement[1] || domElement[0] === 'classcss') {
      info('Select an element before adding attributes.', 2000, true);
      return false;
    }
    promptForAttribute(domElement[0]);
  };

  function promptForAttribute(place) {
    //con("context menu for: " + place);
    var arr_attrs_required = [];
    var attribute_name = prompt("Which attribute you would like to add/edit?");
    if (attribute_name === null) {
      return false; //break out of the function early
    }
    attribute_name = attribute_name.trim();
    attribute_name = attribute_name.toLowerCase();
    if (!attribute_name) {
      return false;
    } else {
      if (arr_attrs_not_allowed.indexOf(attribute_name) > -1) {
        alert('Sorry, ' + attribute_name + ' attribute cannot be changed.');
        return false;
      }
    }
    var attribute_value = "";
    if (frameID(place).getAttribute(attribute_name)) {
      attribute_value = frameID(place).getAttribute(attribute_name);
      if (attribute_name === 'id' && attribute_value.length === 11 && attribute_value.includes("ID-")) {
        attribute_value = "";
      }
    }
    var attribute_entered = prompt("Enter value for " + attribute_name, attribute_value);
    if (attribute_entered === attribute_value) {
      return false; //break out of the function early
    }
    if (attribute_entered === null) {
      return false; //break out of the function early
    }
    attribute_entered = attribute_entered.trim();
    attribute_entered = attribute_entered.toLowerCase();
    if (attribute_entered) {
      if (attribute_name === 'id' && creatHTMLandDownload(page_name).fileHTMLBody.indexOf(' id="' + attribute_entered + '"') > -1) {
        alert('Sorry, this ' + attribute_name + ' attribute already exists.');
        return false;
      }
      frameID(place).setAttribute(attribute_name, attribute_entered);
      if (attribute_name === 'class') {
        var last_class = attribute_entered;
        if (last_class.indexOf(' ') > -1) {
          last_class = last_class.split(' ');
          last_class = last_class[last_class.length - 1];
        }
        INPUTER1.value = last_class;
        frameID(place)['data-tracker'] = last_class;
      }
      con(attribute_name + " = " + attribute_entered);
    } else {
      if (arr_attrs_required.indexOf(attribute_name) > -1) {
        alert('Sorry, a ' + attribute_name + ' attribute is required, change not applied!');
        return false;
      } else {
        if (attribute_name === 'id') {
          guidGenerator();
          frameID(place).id = uniqid;
        } else {
          frameID(place).removeAttribute(attribute_name);
          con(attribute_name + " removed");
        }
      }
    }
    FillStorageHTML();
    FillUndo();
    refreshCodeView();
    info("", null, null);
    selectElement(frameID(place));
  }

  // select parent element
  function select_element_parent() {
    let parent_el = frameID(domElement[0]).parentElement;
    if (domElement[0] !== 'classcss') {
      if (parent_el && parent_el.id !== 'classcss') {
        selectElement(frameID(parent_el.id));
      }
    }
  }

  // select first child element
  function select_element_child() {
    let child_els = [...frameID(domElement[0]).children] || [];
    if (child_els.length) {
      selectElement(frameID(child_els[0].id));
    }
  }

  // select first child element
  function select_element_sibling_next() {
    let sibling = frameID(domElement[0]).nextSibling;
    if (sibling) {
      selectElement(frameID(sibling.id));
    }
  }

  // select first child element
  function select_element_sibling_previous() {
    let sibling = frameID(domElement[0]).previousSibling;
    if (sibling) {
      selectElement(frameID(sibling.id));
    }
  }

  // ---------------------------------------------------
  // ---------------------------------------------------
  // Moves element out of div.
  function upTheTree() {
    var Child = frameID(domElement[0]);
    var newParent = Child.parentElement;
    if (newParent !== classcss) {
      newParent.insertAdjacentElement("beforebegin", Child);
      //classcss.innerHTML = classcss.innerHTML;
      renderToDOM(createDOMMap(classcss));
      FillUndo();
    }
    DOMtree(Child.id);
    selectElement(frameID(domElement[0]));
    refreshCodeView();
  }
  domEvent(domID("upTheTree"), "mousedown", function () {
    upTheTree();
  });
  // ---------------------------------------------------
  // ---------------------------------------------------
  // Put element in the next adjacent div.
  function downTheTree() {
    var Child = frameID(domElement[0]);
    var newParent;
    if (Child.nextElementSibling) {
      newParent = Child.nextElementSibling;
    } else {
      return false;
    }
    var tn = newParent.tagName;
    if (checkTagNameExceptsChildren(tn)) {
      newParent.insertAdjacentElement("beforeend", Child);
      //classcss.innerHTML = classcss.innerHTML;
      renderToDOM(createDOMMap(classcss));
      FillUndo();
    }
    DOMtree(Child.id);
    selectElement(frameID(domElement[0]));
    refreshCodeView();
  }
  domEvent(domID("downTheTree"), "mousedown", function () {
    if (!frameID(domElement[0]).nextElementSibling) {
      return false;
    }
    var tn = frameID(domElement[0]).nextElementSibling.tagName;
    if (checkTagNameExceptsChildren(tn)) {
      downTheTree();
    }
  });
  // ---------------------------------------------------
  // ---------------------------------------------------
  // Put element before previous.
  function previousTree() {
    var Child = frameID(domElement[0]);
    var newPlace = Child.previousElementSibling;
    if (newPlace) {
      newPlace.insertAdjacentElement("beforebegin", Child);
      FillUndo();
    }
    DOMtree(Child.id);
    selectElement(frameID(domElement[0]));
    refreshCodeView();
  }
  domEvent(domID("previousTree"), "mousedown", function () {
    previousTree();
  });
  // ---------------------------------------------------
  // ---------------------------------------------------
  // Put element after next.
  function nextTree() {
    var Child = frameID(domElement[0]);
    var newPlace = Child.nextElementSibling;
    if (newPlace) {
      newPlace.insertAdjacentElement("afterend", Child);
      FillUndo();
    }
    DOMtree(Child.id);
    selectElement(frameID(domElement[0]));
    refreshCodeView();
  }
  domEvent(domID("nextTree"), "mousedown", function () {
    nextTree();
  });
  // ---------------------------------------------------
  // ---------------------------------------------------
  // collapseTheTree.
  function collapseTheTree() {
    let els_with_children = [...document.querySelectorAll('.t-i--with_child')];
    let array_of_els_with_children_data_id = [];
    els_with_children.map((el) => {
      array_of_els_with_children_data_id.push(el.parentElement.getAttribute('data-clicks'));
    });
    tree_expand_parent_el_arr = array_of_els_with_children_data_id;
    window.localStorage.setItem(
      'tree_expand_parent_el_arr', JSON.stringify(tree_expand_parent_el_arr)
    );
    let clickTree = document.querySelector(`[data-clicks="${domElement[0]}"]`);
    if (!clickTree) {
      return false;
    }
    let clickTree_sub = clickTree.querySelector(`.t-i.t-i--with_child`);
    if (!clickTree_sub) {
      return false;
    }
    simulateMouseEvent(clickTree_sub, "mousedown");
    setTimeout(() => {
      simulateMouseEvent(clickTree, "mousedown");
      simulateMouseEvent(clickTree_sub, "mousedown");
      var domtree_active = document.querySelector('.domTree_HL');
      if (domtree_active) {
        domtree_active.scrollIntoView({
          behavior: "auto",
          block: "center",
          inline: "center"
        });
      }

    }, 10);
  }
  domEvent(domID("collapseTheTree"), "mousedown", function () {
    collapseTheTree();
  });
  // ---------------------------------------------------
  // ---------------------------------------------------
  // expandTheTree.
  function expandTheTree() {
    setTimeout(() => {
      let clickTree_subs = [...document.querySelectorAll(`.t-i`)];
      clickTree_subs.map(el => {
        el.parentElement.classList.remove('closed-tree-parent');
        el.parentElement.classList.remove('closed-tree');
      });
      tree_expand_parent_el_arr = [];
      tree_expand_children_el_arr = [];
      window.localStorage.setItem(
        'tree_expand_parent_el_arr', JSON.stringify(tree_expand_parent_el_arr)
      );
      window.localStorage.setItem(
        'tree_expand_children_el_arr', JSON.stringify(tree_expand_children_el_arr)
      );
      var domtree_active = document.querySelector('.domTree_HL');
      if (domtree_active) {
        domtree_active.scrollIntoView({
          behavior: "auto",
          block: "center",
          inline: "center"
        });
      }
    }, 10);
  }
  domEvent(domID("expandTheTree"), "mousedown", function () {
    expandTheTree();
  });
  // ---------------------------------------------------
  // ---------------------------------------------------
  // Autoscroll.
  autoScrollButton.onmousedown = function () {
    autoScrollSwitch();
  };
  autoScrollButton.style = buttonHLColor;

  var was_autoScroll = window.localStorage.getItem("autoScroll");
  if (was_autoScroll && was_autoScroll === "true") {
    autoScroll = true;
    autoScrollButton.style = buttonHLColor;
  } else if (was_autoScroll && was_autoScroll === "false") {
    autoScroll = false;
    autoScrollButton.style = buttonBGColor;
  }

  function autoScrollSwitch(on_off) {
    if (on_off === 'on') {
      autoScroll = true;
      autoScrollButton.style = buttonHLColor;
    } else if (on_off === 'off') {
      autoScroll = false;
      autoScrollButton.style = buttonBGColor;
    } else {
      if (autoScroll) {
        autoScroll = false;
        autoScrollButton.style = buttonBGColor;
      } else {
        autoScroll = true;
        autoScrollButton.style = buttonHLColor;
      }
    }
    window.localStorage.setItem("autoScroll", autoScroll);
  }
  // ---------------------------------------------------
  // ---------------------------------------------------
  // Selection of element highlighting.

  function BoxRefresh(target = false) {



    if (!INPUTER1.value) {
      iframeElementSelect.setAttribute('target', '');
      return false;
    }
    if (classcss.children.length) {
      if (!fullScreenMode) {
        if (!target) {
          iframeElementSelect.setAttribute('target', domElement[0]);
          iframe.contentWindow.postMessage('update_target', window.location.origin);
        } else {
          iframeElementSelect.setAttribute('target', target);
          iframe.contentWindow.postMessage('update_target', window.location.origin);
        }
      }
    }
  }

  // ---------------------------------------------------
  // ---------------------------------------------------
  // ---------------------------------------------------
  // Create a new class from input4 and copy class in input1 plus all data.
  function copyClass() {
    var input1 = INPUTER1.value;
    var input4 = INPUTER4.value;
    var copyFrom1 = [];
    var copyFrom2 = [];
    var copyFrom3 = [];
    var copyFrom4 = [];

    if (!isLetterFirst(INPUTER4.value)) {
      return false;
    }
    if (!classEls.includes(INPUTER4.value)) {

      if (thecssLG[input1]) {
        copyFrom1.push(JSON.parse(JSON.stringify(thecssLG[input1])));
        put(input4, copyFrom1[0], thecssLG);
      }
      if (thecssMD[input1]) {
        copyFrom2.push(JSON.parse(JSON.stringify(thecssMD[input1])));
        put(input4, copyFrom2[0], thecssMD);
      }
      if (thecssSM[input1]) {
        copyFrom3.push(JSON.parse(JSON.stringify(thecssSM[input1])));
        put(input4, copyFrom3[0], thecssSM);
      }
      if (thecssXS[input1]) {
        copyFrom4.push(JSON.parse(JSON.stringify(thecssXS[input1])));
        put(input4, copyFrom4[0], thecssXS);
      }

      info("Class has been duplicated.", 4000, null);
      FillValueReadouts();
      buttonRefresh();
      logger();
      DOMtree();
      deselectElement();
      INPUTER1.value = input4;
    } else {
      info("That class already exists!", 4000, true);
    }
  }
  domEvent(domID("copyClass"), "mousedown", function () {
    copyClass();
    FillUndo();
  });
  // ---------------------------------------------------
  // ---------------------------------------------------
  // renameClass.

  function isLetterFirst(str) {
    str = str.charAt(0).toLowerCase();
    var pass = false;
    if (str.length === 1 && str.match(/[a-z]/i)) {
      pass = true;
    } else {
      info(
        "Class names need to be greater than 0 characters long and can only start with a character that is a-z or A-Z.",
        4000,
        null
      );
    }
    return pass;
  }

  function renameClass(newName) {
    var input1 = INPUTER1.value;
    var copyFrom1 = [];
    var copyFrom2 = [];
    var copyFrom3 = [];
    var copyFrom4 = [];
    INPUTER4.value = newName;
    var input4 = INPUTER4.value;
    if (!isLetterFirst(INPUTER4.value)) {
      return false;
    }
    if (!classEls.includes(INPUTER4.value)) {
      var els = [...classcss.getElementsByClassName(input1)];
      for (var i = 0; i < els.length; i++) {
        els[i].setAttribute('class', els[i].getAttribute('class').replace(input1, input4));
        els[i]['data-tracker'] = input4;
      }
      copyFrom1.push(thecssLG[input1]); // what the css currently is.
      copyFrom2.push(thecssMD[input1]);
      copyFrom3.push(thecssSM[input1]);
      copyFrom4.push(thecssXS[input1]);
      // ??? do I copy the css into a class that already exists or warn ???

      if (thecssLG[input1]) {
        put(input4, copyFrom1[0], thecssLG); // put the current css
        del(input1, thecssLG); // remove the old css
      }
      if (thecssMD[input1]) {
        put(input4, copyFrom2[0], thecssMD);
        del(input1, thecssMD);
      }
      if (thecssSM[input1]) {
        put(input4, copyFrom3[0], thecssSM);
        del(input1, thecssSM);
      }
      if (thecssXS[input1]) {
        put(input4, copyFrom4[0], thecssXS);
        del(input1, thecssXS);
      }
      // domForQuery('[data-tracker="' + input1 + '"]', function (el) {
      //     el['data-tracker'] = input4;
      // });
      info("Class has been renamed.", 4000, null);
      INPUTER1.value = input4;
      logger();
      DOMtree();
      clickAdder(null);
      buttonRefresh();
      FillValueReadouts();
      selectElement(frameID(domElement[0]));
      FillUndo();
    } else {
      info("That class already exists!", 4000, true);
    }
  }
  domEvent(domID("renameClass"), "mousedown", function () {
    renameClass(INPUTER4.value);
  });
  // ---------------------------------------------------
  // ---------------------------------------------------


  var normalizecss = /*CSS*/ `
/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */

html {
  line-height: 1.15; 
  -webkit-text-size-adjust: 100%;
}

body {
  margin: 0;
}

main {
  display: block;
}

h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}

pre {
  font-family: monospace, monospace;
  font-size: 1em;
}

a {
  background-color: transparent;
}

abbr[title] {
  border-bottom: none;
  text-decoration: underline;
  text-decoration: underline dotted;
}

b,
strong {
  font-weight: bolder;
}

code,
kbd,
samp {
  font-family: monospace, monospace;
  font-size: 1em;
}

small {
  font-size: 80%;
}

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

img {
  border-style: none;
}

button,
input,
optgroup,
select,
textarea {
  font-family: inherit;
  font-size: 100%;
  line-height: 1.15;
  margin: 0;
}

button,
input {
  overflow: visible;
}

button,
select {
  text-transform: none;
}

button,
[type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button;
}

button::-moz-focus-inner,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

button:-moz-focusring,
[type="button"]:-moz-focusring,
[type="reset"]:-moz-focusring,
[type="submit"]:-moz-focusring {
  outline: 1px dotted ButtonText;
}

fieldset {
  padding: 0.35em 0.75em 0.625em;
}

legend {
  box-sizing: border-box;
  color: inherit;
  display: table;
  max-width: 100%;
  padding: 0;
  white-space: normal;
}

progress {
  vertical-align: baseline;
}

textarea {
  overflow: auto;
}

[type="checkbox"],
[type="radio"] {
  box-sizing: border-box;
  padding: 0;
}

[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
  height: auto;
}

[type="search"] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  -webkit-appearance: button;
  font: inherit;
}

details {
  display: block;
}

summary {
  display: list-item;
}

template {
  display: none;
}

[hidden] {
  display: none;
}

/* ----------------------------- */

`;

  var defaultcss = /*CSS*/ `/* Default styles -------------- */

.domposer-element,body { 
  background-color: #FFF;
  color: #000;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 16px;
  padding: 0 0 0 0;
  margin: 0 0 0 0;
  box-sizing: border-box;
  height: 100%;
}

p,h1,h2,h3,h4,h5,h6,li,span,input,textarea,pre,button {
  margin: 0;
}

button,input {
  box-sizing: content-box;
}

/* ----------------------------- */

`;
  let dp_elements = '';

  // Creates formatted HTML text string.
  function creatHTMLandDownload(passed_page_name) {
    //=================================
    // Head
    var textForDownload;
    // Need to make a copy of local storage the apply it after download
    var imageData = /data-image="/g;
    var imageSrcForApp = /src=".\/images\//g;
    var imageBlob = /src="blob:(.*?)"/g;
    var idMatch = /ID-[a-zA-Z0-9]{8}/g;
    var allJS = window.localStorage.AlltheJS;
    var js = "";
    if (allJS) {
      js = JSON.parse(allJS);
    }
    var headHTMLJSON = window.localStorage.AlltheHeadHTML;
    var headHTML = "";
    if (headHTMLJSON) {
      headHTML = JSON.parse(headHTMLJSON);
    }
    var allHTML = window.localStorage[`HTML_${passed_page_name}`] || "";

    var has_dp_elements = false;
    if (allHTML.indexOf('<dp-') > -1) {
      has_dp_elements = true;
    }

    var elem;
    var removedBlobs = allHTML.replace(imageBlob, ``);
    elem = projectHTMLContainer(removedBlobs);

    var forArray = elem.childNodes || "";
    // let normalize = '<link href="normalize.css" rel="stylesheet" type="text/css"/>';
    var HTMLhead = // Can be found in compStyleBefore.css
      '<meta charset="utf-8"/>\n' +
      "<title>" +
      passed_page_name +
      "</title>\n" +
      '<meta name ="viewport"' +
      ' content ="width=device-width, initial-scale=1.0,' +
      ' minimum-scale=1.0, user-scalable=yes" />\n' +
      headHTML +
      '<link href="' +
      siteTitle +
      '.css" rel="stylesheet" type="text/css"/>\n';
    [].forEach.call(forArray, function (el) {
      if (!el.id) {
        // -> leave it alone
      } else {
        // -> remove attributes added by domposer
        if (el.id.match(idMatch)) {
          el.removeAttribute("id");
        }
        el.removeAttribute("data-tracker");
        el.removeAttribute("data-target-drop-button");
        el.removeAttribute("draggable");
        el.removeAttribute("contenteditable");
        //el.removeAttribute('style');
        if (el.tagName.toLowerCase() !== 'script') {
          let src_data = el.getAttribute('src');
          if (src_data && src_data.indexOf('https://') === -1) {
            el.removeAttribute("src");
          }
        }
        var elsChildren = el.getElementsByTagName("*");
        [].forEach.call(elsChildren, function (elChild) {
          if (elChild.id.match(idMatch)) {
            elChild.removeAttribute("id");
          }
          elChild.removeAttribute("data-tracker");
          elChild.removeAttribute("data-target-drop-button");
          elChild.removeAttribute("draggable");
          elChild.removeAttribute("contenteditable");
          //elChild.removeAttribute('style');
          //el.removeAttribute("src");
          if (elChild.tagName.toLowerCase() !== 'script') {
            let child_src_data = elChild.getAttribute('src');
            if (child_src_data && child_src_data.indexOf('https://') === -1) {
              elChild.removeAttribute("src");
            }
          }
        });
      }
    });
    var htmlStringMinusData = elem.innerHTML;
    htmlStringMinusData = htmlStringMinusData.replaceAll('src="images/https://', 'src="https://');
    htmlStringMinusData = htmlStringMinusData.replace(
      imageData,
      'src="images/'
    );
    htmlStringMinusData = htmlStringMinusData.replace(
      imageSrcForApp,
      'src="images/'
    );
    htmlStringMinusData = htmlStringMinusData.replace(imageBlob, "");
    htmlStringMinusData = htmlStringMinusData.replaceAll('src="images/https://', 'src="https://');

    let dp_elements_formatted = '';
    if (has_dp_elements) {
      dp_elements = '<script src="js/dp-custom-elements.js" defer></script>';
      dp_elements_formatted = '\n' + dp_elements;
    } else {
      dp_elements = '';
    }


    //================================
    // Combine arrays
    var lang = "en";
    textForDownload =
      "<!DOCTYPE html>\n" +
      '<html lang="' +
      lang +
      '">\n' +
      "<head>\n" +
      HTMLhead +
      "</head>\n" +
      "<body>\n" +
      // '<div id="classcss">\n' +
      htmlStringMinusData +
      // '</div>\n' +
      // "<script>\n" +
      // js +
      // "\n</script>\n" +
      `<div style="position: fixed; left: 2rem; bottom: 2rem">
  <a id="domposer-link" href="https://domposer.dunkerley.dev" target="_blank"><img width="30" height="30" src="https://domposer.dunkerley.dev/images/logo.svg"></a>
</div>` +
      dp_elements_formatted +
      "</body>\n" +
      "</html>\n";
    var textForDownload2 = beautify_html(textForDownload, {
      indent_inner_html: false,
      indent_size: 2,
      indent_char: " ",
      wrap_line_length: 0,
      brace_style: "expand",
      preserve_newlines: true,
      max_preserve_newlines: 5,
      indent_handlebars: false,
      extra_liners: ["/html"]
    });
    textForDownload = textForDownload2;

    var extralines = /></g;
    //var nbsps = /&nbsp;/g;
    htmlStringMinusData = htmlStringMinusData.replace(extralines, '>\n<');
    //htmlStringMinusData = htmlStringMinusData.replace(nbsps, ' ');

    var HTMLBody = beautify_html(htmlStringMinusData, {
      indent_inner_html: false,
      indent_size: 2,
      indent_char: " ",
      wrap_line_length: 0,
      brace_style: "expand",
      preserve_newlines: true,
      max_preserve_newlines: 5,
      indent_handlebars: false,
      extra_liners: ["/html"]
    });


    // var HTMLBody = htmlStringMinusData;
    return {
      fileName: siteTitle + ".html",
      fileData: textForDownload,
      fileHTMLBody: HTMLBody
    };
  }


  // ---------------------------------------------------
  // ---------------------------------------------------
  // Creates a codepen
  domID('codepenForm').onclick = function (e) {
    e.preventDefault();

    var addNormalizeIsTrueSet = (window.localStorage.getItem('normalizecss') === 'true');
    var data_to_send = {};
    var custom_elements = '';
    var regex_val = /src="images\/(.*?)"/g;

    put("title", "Domposer Project", data_to_send);

    //var imageSrcForApp = /src=\"(.*?)\"/g;
    let html_to_send = creatHTMLandDownload(page_name).fileHTMLBody;
    html_to_send = html_to_send.replaceAll(`src="images/logo.svg"`, `src="https://domposer.dunkerley.dev/images/logo.svg"`);
    html_to_send = html_to_send.replaceAll(`src="images/chevron.min.svg"`, `src="https:/domposer.dunkerley.dev/images/chevron.min.svg"`);
    html_to_send = html_to_send.replaceAll(`src="images/place_holder_1.svg"`, `src="https://domposer.dunkerley.dev/images/place_holder_1.svg"`);
    html_to_send = html_to_send.replaceAll(`src="images/place_holder_2.svg"`, `src="https://domposer.dunkerley.dev/images/place_holder_2.svg"`);
    html_to_send = html_to_send.replaceAll(`src="images/place_holder_3.svg"`, `src="https://domposer.dunkerley.dev/images/place_holder_3.svg"`);
    html_to_send = html_to_send.replaceAll(`src="images/place_holder_4.svg"`, `src="https://domposer.dunkerley.dev/images/place_holder_4.svg"`);
    html_to_send = html_to_send.replaceAll(regex_val, `src="https://domposer.dunkerley.dev/images/place_holder_1.svg"`);

    if (dp_elements) {
      custom_elements += '\n<script src="https://domposer.dunkerley.dev/js/custom-elements/dp-custom-elements.js" defer></script>';
    }

    put("html", html_to_send + custom_elements, data_to_send);
    put("css", creatCSSandDownload(true, false).fileData, data_to_send);
    if (addNormalizeIsTrueSet) {
      put("css_starter", "normalize", data_to_send);
    }
    domID('codepenData').value = JSON.stringify(data_to_send);
    domID('codepenForm').submit();
  };


  var render_preview, preview_close_check, preview_request = 0;
  var preview_shell_generation = null, preview_editor_port = null;
  let has_preview = false;

  function reset_preview_state() {
    clearTimeout(render_preview); clearInterval(preview_close_check);
    preview_request++; preview_shell_generation = null;
    if (preview_editor_port) { preview_editor_port.close(); preview_editor_port = null; }
    preview_active = false; preview = null; has_preview = 'false';
    domID('preview').style.cssText = '';
    window.sessionStorage.setItem('preview', has_preview);
  }

  function initiate_preview() {
    const legacy = window.domposerLegacyPreview;
    if ((legacy && legacy.state !== 'safe') || (!legacy && 'serviceWorker' in navigator && navigator.serviceWorker.controller)) {
      if (preview && !preview.closed) preview.close();
      reset_preview_state();
      info(legacy && legacy.state === 'checking' ? 'Checking an existing historical controller. Try opening Preview again shortly.' :
        'Historical preview control could not be verified. Save your work or download a recovery ZIP, close all Domposer previews and editor windows manually, then reopen while online.', false, true);
      return;
    }
    if (preview_update_required || !/^[a-f0-9]{64}$/.test(preview_asset_release || '')) { if (preview && !preview.closed) preview.close(); reset_preview_state(); require_preview_update(); return; }
    if (has_preview !== 'true') {
      if (preview && !preview.closed) preview.close();
      reset_preview_state(); return;
    }
    if (!preview || preview.closed) {
      preview_shell_generation = null;
      preview = window.open('', 'preview', 'location=no,menubar=no,status=no,titlebar=no,toolbar=no');
      if (!preview) { reset_preview_state(); return; }
      try {
        // Explicit opening establishes a fresh shell even if a named window
        // survives a previous editor page. Reuse within this session stays intact.
        preview.location.href = '/preview?visual-preview=2&release=' + encodeURIComponent(preview_asset_release);
      } catch (error) { preview.location.href = '/preview?visual-preview=2&release=' + encodeURIComponent(preview_asset_release); }
    }
    preview.focus(); preview_active = true;
    preview.postMessage({type:'domposer-preview-ping', version:2, release:preview_asset_release}, window.location.origin);
    if (preview_editor_port) set_preview_css_html();
    clearInterval(preview_close_check);
    preview_close_check = setInterval(() => { if (preview && preview.closed) reset_preview_state(); }, 500);
  }

  window.addEventListener('message', event => {
    const data = event.data;
    if (!data || data.type !== 'domposer-preview-ready') return;
    if (!preview || preview.closed || event.source !== preview || event.origin !== window.location.origin) {
      event.ports.forEach(port => port.close()); return;
    }
    if (!data || data.type !== 'domposer-preview-ready' || Object.keys(data).some(key => !['type','generation','version','release'].includes(key)) ||
        data.version !== 2 || data.release !== preview_asset_release || typeof data.generation !== 'string' || !/^[a-f0-9]{48}$/.test(data.generation) || event.ports.length !== 1) {
      event.ports.forEach(port => port.close()); return;
    }
    // A different generation requires an explicit popup reopen, never automatic
    // replay into a reloaded/navigated document sharing the same WindowProxy.
    if (preview_shell_generation) { event.ports.forEach(port => port.close()); return; }
    preview_shell_generation = data.generation;
    preview_editor_port = event.ports[0];
    const connection = preview_editor_port;
    connection.onmessage = () => {}; // No sandbox/editor commands are accepted.
    connection.onmessageerror = () => {
      if (connection !== preview_editor_port) return;
      preview_editor_port.close(); preview_editor_port = null;
      preview_request++; preview_active = false;
    };
    set_preview_css_html();
  });

  domID('preview').onclick = function () {
    has_preview = has_preview === 'true' ? 'false' : 'true';
    domID('preview').style.cssText = has_preview === 'true' ? 'background: var(--mainColor); color: var(--button-text-active);' : '';
    initiate_preview();
    window.sessionStorage.setItem('preview', has_preview);
  };

  function set_preview_css_html() {
    const legacy = window.domposerLegacyPreview;
    if ((legacy && legacy.state !== 'safe') || (!legacy && 'serviceWorker' in navigator && navigator.serviceWorker.controller)) {
      if (preview && !preview.closed) preview.close();
      reset_preview_state(); return;
    }
    clearTimeout(render_preview);
    const request = ++preview_request;
    if (!preview) return;
    if (preview.closed) { reset_preview_state(); return; }
    if (!preview_editor_port) return;
    render_preview = setTimeout(async () => {
      const target = preview, generation = preview_shell_generation, port = preview_editor_port;
      const project = domID('currentProject');
      const identity = project ? project.value : '';
      const html = classcss.innerHTML;
      const css = (normalize_for_preview || '') + '\n' + placeInHead.textContent;
      try {
        const snapshot = await createPreviewSnapshot(classcss, css, localforage, objectOfBlobs || {});
        if ((window.domposerLegacyPreview && window.domposerLegacyPreview.state !== 'safe') ||
            (!window.domposerLegacyPreview && 'serviceWorker' in navigator && navigator.serviceWorker.controller)) return;
        if (request !== preview_request || target !== preview || target.closed || generation !== preview_shell_generation || port !== preview_editor_port ||
            identity !== (domID('currentProject') ? domID('currentProject').value : '')) return;
        if (html !== classcss.innerHTML || css !== (normalize_for_preview || '') + '\n' + placeInHead.textContent) {
          // Asset hydration/components can change source during the asynchronous
          // read. Discard stale bytes, but do not strand an otherwise valid first
          // connection without a snapshot. Never retry into another project/port.
          set_preview_css_html(); return;
        }
        port.postMessage({type:'visual-render', revision:request, ...snapshot});
      } catch (error) {
        // Fixed plain text only. No source strings, tokens or arbitrary error HTML.
        info('Visual preview could not load this snapshot. Check its asset and size limits.', false, true);
      }
    }, 60);
  }

  function list_element_attributes(el) {
    let for_return = {};
    if (el.hasAttributes()) {
      var attrs = el.attributes;
      var output = "";
      for (var i = attrs.length - 1; i >= 0; i--) {
        for_return[attrs[i].name] = attrs[i].value;
      }
      return for_return;
    } else {
      return false;
    }
  }




  // ---------------------------------------------------
  // ---------------------------------------------------
  // Creates a custom element
  //


  function creatCustomElement(passed_page_name) {





    var custom_element_name = "`" + `dp-${passed_page_name}-element` + "`";
    var html_content = "`" + /*HTML*/ `
${creatHTMLandDownload(passed_page_name).fileHTMLBody}
<div style="position: fixed; left: 2rem; bottom: 2rem">
  <a id="domposer-link"></a>
</div>` + "`";
    var css_content = "`" + `${creatCSSandDownload(true, true).fileData}` + "`";

    // main js file starts here ----------------------------------------------

    var jsfile = /*javascript*/ `

(function () {

  var CSS_template = /*CSS*/ ${css_content};

  var HTML_template = /*HTML*/ ${html_content};

  customElements.define(${custom_element_name}, class extends HTMLElement {

    constructor() {
      super();
      this.attachShadow({
        mode: 'open'
      });
      const template = document.createElement('template');
      template.innerHTML = '<style>' + CSS_template + '</style>' + '<div class="domposer-element">' + HTML_template + '</div>';
      this.shadowRoot.appendChild(template.content.cloneNode(true));
    }

    // watchs for changes in observedAttributes array
    attributeChangedCallback(name, oldValue, newValue) {
      if (oldValue !== newValue) {
        console.log(${custom_element_name} + ', ' + name + ' attributes changed, from: ' + oldValue + ' to: ' + newValue);
        this.updateTemplateWithAttribute(name);
      }
    }

    // fires once elements are connected to the dom
    connectedCallback() {
      console.log(${custom_element_name} + ' connected');
      this.templateAppended();
      const template = this;
      [].forEach.call(this.constructor.observedAttributes, function (name) {
        template.updateTemplateWithAttribute(name);
      });
    }

    // fires once elements are removed from dom
    disconnectedCallback() {
      console.log(${custom_element_name} + ' disconnected');
    }

    // fires once elements are moved to new page
    adoptedCallback() {
      console.log(${custom_element_name} + ' moved to new page');
    }

    templateAppended() {
      this.domposerLink = this.shadowRoot.getElementById('domposer-link');
    }

    // Specify observed attributes for attributeChangedCallback
    static get observedAttributes() {
      return ['attribute_1', 'attribute_2', 'attribute_3'];
    }

    updateTemplateWithAttribute(name) {
      switch (name) {
        case 'attribute_1':
          if (this.domposerLink) {
            this.domposerLink.setAttribute('href', this.getAttribute('attribute_1'));
          }
          break;
        case 'attribute_2':
          if (this.domposerLink) {
            this.domposerLink.innerHTML = '<img width="30" height="30" src="' + this.getAttribute('attribute_2') + '"/>';
          }
          break;
        case 'attribute_3':
          if (this.domposerLink) {
            this.domposerLink.setAttribute('target', this.getAttribute('attribute_3'));
          }
          break;
      }
    }
  });
})();`;
    var fileName = 'dp-' + passed_page_name + '-element.js';
    var tagName = `<dp-${passed_page_name}-element attribute_1="https://domposer.dunkerley.dev" attribute_2="https://domposer.dunkerley.dev/images/logo.svg" attribute_3="_blank"></dp-${passed_page_name}-element>`;

    var custom_els = [
      dp_elements
    ];
    var custom_els_template = "";
    custom_els.map((el, i) => {
      if (el) {
        if (i === 0) {
          custom_els_template += el;
        } else {
          custom_els_template += '\n  ' + el;
        }
      }
    });

    var htmlFile = /*HTML*/ `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="utf-8" />
  <title>dp-${passed_page_name}-element</title>
  <meta name="viewport" content="width=device-width, initial-scale=1.0, minimum-scale=1.0, user-scalable=yes">
  <style>
  body {
    background-color: #FFF;
    color: #000;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 16px;
    padding: 0 0 0 0;
    margin: 0 0 0 0;
    box-sizing: border-box;
    overflow-x: hidden;
  }
  </style>
</head>
<body>
  ${tagName}
  <script src="js/${fileName}"></script>
  ${custom_els_template}
</body>
</html>`;

    var cs_obj = {
      fileContent: jsfile,
      fileName: fileName,
      tagName: tagName,
      htmlFile: htmlFile
    };
    return cs_obj;
  }

  // ---------------------------------------------------
  // ---------------------------------------------------
  // Creates a formatted CSS text string.
  // test button
  domEvent(domID("testcss"), "mousedown", creatCSSandDownload);

  function creatCSSandDownload(addDefaultCSS, addNormalizeCSS) {
    //=================================
    // fullWidth
    var cssarrHTML = "";
    var cssarrHTMLBP1 = "";
    var cssarrHTMLBP2 = "";
    var cssarrHTMLBP3 = "";
    if (!mobileFirst) {
      //=================================
      // RESPONSIVE
      //=================================
      cssarrHTML = Object.keys(thecssLG)
        .map(function (rule) {
          if (isEmpty(thecssLG[rule])) {} else {
            var showMeMapVals = Object.keys(thecssLG[rule])
              .map(function (prop) {
                return (
                  "  " +
                  prop.trim() +
                  ": " +
                  thecssLG[rule][prop].trim() +
                  ";\n"
                );
              })
              .join("");
            if (showMeMapVals) {
              return (
                rule.trim() +
                " {\n" +
                showMeMapVals +
                "}\n\n"
              );
            }
          }
        })
        .join("");
      //=================================
      // breakPoint1
      cssarrHTMLBP1 = Object.keys(thecssMD)
        .map(function (rule) {
          if (isEmpty(thecssMD[rule])) {} else {
            var showMeMapVals = Object.keys(thecssMD[rule])
              .map(function (prop) {
                return (
                  "    " +
                  prop.trim() +
                  ": " +
                  thecssMD[rule][prop].trim() +
                  ";\n"
                );
              })
              .join("");
            if (showMeMapVals) {
              return (
                "  " +
                rule.trim() +
                " {\n" +
                showMeMapVals +
                "  }\n\n"
              );
            }
          }
        })
        .join("");
      if (cssarrHTMLBP1.length) {
        cssarrHTMLBP1 =
          "@media screen and (max-width: " +
          (breakPoint_MD_Value - 0.02) +
          "px) {\n\n" +
          cssarrHTMLBP1 +
          "}\n\n";
      }
      //=================================
      // breakPoint2
      cssarrHTMLBP2 = Object.keys(thecssSM)
        .map(function (rule) {
          if (isEmpty(thecssSM[rule])) {} else {
            var showMeMapVals = Object.keys(thecssSM[rule])
              .map(function (prop) {
                return (
                  "    " +
                  prop.trim() +
                  ": " +
                  thecssSM[rule][prop].trim() +
                  ";\n"
                );
              })
              .join("");
            if (showMeMapVals) {
              return (
                "  " +
                rule.trim() +
                " {\n" +
                showMeMapVals +
                "  }\n\n"
              );
            }
          }
        })
        .join("");
      if (cssarrHTMLBP2.length) {
        cssarrHTMLBP2 =
          "@media screen and (max-width: " +
          (breakPoint_SM_Value - 0.02) +
          "px) {\n\n" +
          cssarrHTMLBP2 +
          "}\n\n";
      }
      //=================================
      // breakPoint3
      cssarrHTMLBP3 = Object.keys(thecssXS)
        .map(function (rule) {
          if (isEmpty(thecssXS[rule])) {} else {
            var showMeMapVals = Object.keys(thecssXS[rule])
              .map(function (prop) {
                return (
                  "    " +
                  prop.trim() +
                  ": " +
                  thecssXS[rule][prop].trim() +
                  ";\n"
                );
              })
              .join("");
            if (showMeMapVals) {
              return (
                "  " +
                rule.trim() +
                " {\n" +
                showMeMapVals +
                "  }\n\n"
              );
            }
          }
        })
        .join("");
      if (cssarrHTMLBP3.length) {
        cssarrHTMLBP3 =
          "@media screen and (max-width: " +
          (breakPoint_XS_Value - 0.02) +
          "px) {\n\n" +
          cssarrHTMLBP3 +
          "}\n\n";
      }
    } else {
      //=================================
      // MOBILE FIRST
      //=================================
      //=================================
      cssarrHTML = Object.keys(thecssXS)
        .map(function (rule) {
          if (isEmpty(thecssXS[rule])) {} else {
            var showMeMapVals = Object.keys(thecssXS[rule])
              .map(function (prop) {
                return (
                  "  " +
                  prop.trim() +
                  ": " +
                  thecssXS[rule][prop].trim() +
                  ";\n"
                );
              })
              .join("");
            if (showMeMapVals) {
              return (
                rule.trim() +
                " {\n" +
                showMeMapVals +
                "}\n\n"
              );
            }
          }
        })
        .join("");
      //=================================
      // breakPoint1
      cssarrHTMLBP1 = Object.keys(thecssSM)
        .map(function (rule) {
          if (isEmpty(thecssSM[rule])) {} else {
            var showMeMapVals = Object.keys(thecssSM[rule])
              .map(function (prop) {
                return (
                  "    " +
                  prop.trim() +
                  ": " +
                  thecssSM[rule][prop].trim() +
                  ";\n"
                );
              })
              .join("");
            if (showMeMapVals) {
              return (
                "  " +
                rule.trim() +
                " {\n" +
                showMeMapVals +
                "  }\n\n"
              );
            }
          }
        })
        .join("");
      if (cssarrHTMLBP1.length) {
        cssarrHTMLBP1 =
          "@media screen and (min-width: " +
          breakPoint_XS_Value +
          "px) {\n\n" +
          cssarrHTMLBP1 +
          "}\n\n";
      }
      //=================================
      // breakPoint2
      cssarrHTMLBP2 = Object.keys(thecssMD)
        .map(function (rule) {
          if (isEmpty(thecssMD[rule])) {} else {
            var showMeMapVals = Object.keys(thecssMD[rule])
              .map(function (prop) {
                return (
                  "    " +
                  prop.trim() +
                  ": " +
                  thecssMD[rule][prop].trim() +
                  ";\n"
                );
              })
              .join("");
            if (showMeMapVals) {
              return (
                "  " +
                rule.trim() +
                " {\n" +
                showMeMapVals +
                "  }\n\n"
              );
            }
          }
        })
        .join("");
      if (cssarrHTMLBP2.length) {
        cssarrHTMLBP2 =
          "@media screen and (min-width: " +
          breakPoint_SM_Value +
          "px) {\n\n" +
          cssarrHTMLBP2 +
          "}\n\n";
      }
      //=================================
      // breakPoint3
      cssarrHTMLBP3 = Object.keys(thecssLG)
        .map(function (rule) {
          if (isEmpty(thecssLG[rule])) {} else {
            var showMeMapVals = Object.keys(thecssLG[rule])
              .map(function (prop) {
                return (
                  "    " +
                  prop.trim() +
                  ": " +
                  thecssLG[rule][prop].trim() +
                  ";\n"
                );
              })
              .join("");
            if (showMeMapVals) {
              return (
                "  " +
                rule.trim() +
                " {\n" +
                showMeMapVals +
                "  }\n\n"
              );
            }
          }
        })
        .join("");
      if (cssarrHTMLBP3.length) {
        cssarrHTMLBP3 =
          "@media screen and (min-width: " +
          breakPoint_MD_Value +
          "px) {\n\n" +
          cssarrHTMLBP3 +
          "}\n\n";
      }
      //=================================
    }
    //================================
    // Combine arrays
    var pre =
      cssarrHTML + cssarrHTMLBP1 + cssarrHTMLBP2 + cssarrHTMLBP3 + "";

    var addNormalizeIsTrueSet = (window.localStorage.getItem('normalizecss') === 'true');


    if (addDefaultCSS && addNormalizeCSS && addNormalizeIsTrueSet) {
      return {
        fileName: siteTitle + ".css",
        fileData: normalizecss + defaultcss + pre
      };
    } else if (addDefaultCSS) {
      return {
        fileName: siteTitle + ".css",
        fileData: defaultcss + pre
      };
    } else {
      return {
        fileName: siteTitle + ".css",
        fileData: pre
      };
    }
  }
  // ---------------------------------------------------
  // ---------------------------------------------------
  // Creates a time string.
  function time() {
    var timeStamp;
    var d = new Date();
    /* const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];*/
    var months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ];
    var fullYear = d.getFullYear() + "";
    var year = fullYear.substring(2);
    timeStamp =
      ("0" + d.getDate()).slice(-2) +
      "/" +
      months[d.getMonth()] +
      "/" +
      year +
      " " +
      d.getHours() +
      ":" +
      ("0" + d.getMinutes()).slice(-2) +
      "";
    return timeStamp;
  }
  // ---------------------------------------------------
  // ---------------------------------------------------
  // Creates a zip folder download of the project.
  var download_option_visable = false;
  domEvent(domID("downloadFiles"), "mousedown", function () {
    if (!download_option_visable) {
      saveOrDownloadFiles();
      download_option_visable = true;
    } else {
      viewModal_off(domID("download-options"));
      download_option_visable = false;
    }
  });
  domID("download-options-close").onclick = function () {
    viewModal_off(domID("download-options"));
    download_option_visable = false;
  };
  viewModal_off(domID("download-options"));


  var downloadOrLose = document.querySelectorAll(".downloadOrLose");
  [].forEach.call(downloadOrLose, function (downloadOrLose_el) {
    domEvent(downloadOrLose_el, "mousedown", function () {
      saveOrDownloadFiles();
    });
  });

  var downloadFilesAlt = domID("downloadFiles-alt");
  if (downloadFilesAlt) {
    domEvent(downloadFilesAlt, "mousedown", function (e) {
      e.preventDefault();
      saveOrDownloadFiles();
    });
  }

  domEvent(domID("downloadFilesOnUploadPrompt"), "mousedown", function () {
    saveOrDownloadFiles();
  });


  var downloadButtons = document.querySelectorAll("#viewProjects table tr td:nth-of-type(3) a");

  function disableDownloads() {
    if (!downloadButtons) {
      return false;
    }
    [].forEach.call(downloadButtons, function (el) {
      el.style.opacity = "0.4";
      el.style.pointerEvents = "none";
    });
  }

  function enableDownloads() {
    if (!downloadButtons) {
      return false;
    }
    [].forEach.call(downloadButtons, function (el) {
      el.style.opacity = "1";
      el.style.pointerEvents = "all";
    });
  }

  const fetchExternalData = (uri, file) => {
    if (file) {
      return Promise.all([
          fetch(uri)
        ])
        .then(
          results => Promise.all(
            results.map(result => result.blob())
          )
        );
    } else {
      return Promise.all([
          fetch(uri)
        ])
        .then(
          results => Promise.all(
            results.map(result => result.text())
          )
        );
    }
  };



  let dp_elements_file;
  setTimeout(() => {
    fetchExternalData("/js/custom-elements/dp-custom-elements.js")
      .then(result => {
        dp_elements_file = result[0];
      })
      .catch(console.error);
  }, 100);

  function saveOrDownloadFiles(api, logoutAfterSave, loginAfterSave, projectDetails) {
    if (projectImportRunning || failedImportBackup) return false;
    disableDownloads();
    if (fullScreenMode) {
      return false;
    }

    if (api && storageleveltext) {
      storageleveltext.innerHTML = "saving";
    }

    if (navigator.onLine === true) {
      navigatorOnline();
    } else {
      navigatorOffline(api);
      return false;
    }

    var zip = new JSZip();

    var images_folder = zip.folder("images");

    localforage
      .iterate(function (value, key, iterationNumber) {
        images_folder.file(key, localforage.getItem(key), {
          base64: true
        });
      }).then(function () {

        // Gets local storage.
        var s = serializeProjectSnapshot(localStorage);
        time();
        var downloadName = "project.json";
        zip.file(downloadName, s);

        if (!api) {

          viewModal_on(domID("download-options"));

          var downloadall_btn = domID("download-all");
          var downloadwc_btn = domID("download-wc");

          downloadall_btn.onclick = function () {

            //lopp here
            var needs_js_folder;

            page_names.map(page => {
              zip.file(page + ".html", creatHTMLandDownload(page).fileData);
              if (dp_elements) {
                needs_js_folder = true;
              }
            });

            var js_folder = "";
            if (needs_js_folder) {
              js_folder = zip.folder("js");
              js_folder.file("dp-custom-elements.js", dp_elements_file);
            }

            zip.file(
              creatCSSandDownload().fileName,
              creatCSSandDownload(true, true).fileData
            );
            zip.generateAsync({
              type: "blob"
            }).then(function (content) {
              // see FileSaver.js
              FileSaver.saveAs(content, siteTitle + ".zip");
              if (!loginAfterSave) {
                setTimeout(function () {
                  location.reload();
                }, 15);
              } else {
                loginPanel_form.submit();
              }
            });
          };

          downloadwc_btn.onclick = function () {

            var needs_js_folder;

            page_names.map(page => {
              zip.file(page + ".html", creatCustomElement(page).htmlFile);
              if (dp_elements) {
                needs_js_folder = true;
              }
            });

            var js_folder = "";
            if (needs_js_folder) {
              js_folder = zip.folder("js");
              js_folder.file("dp-custom-elements.js", dp_elements_file);
            }

            if (!js_folder) {
              js_folder = zip.folder("js");
            }

            page_names.map(page => {
              js_folder.file(creatCustomElement(page).fileName, creatCustomElement(page).fileContent);
            });


            //js_folder.file(creatCustomElement().fileName, creatCustomElement().fileContent);
            zip.generateAsync({
              type: "blob"
            }).then(function (content) {
              // see FileSaver.js
              FileSaver.saveAs(content, siteTitle + ".zip");
              if (!loginAfterSave) {
                setTimeout(function () {
                  location.reload();
                }, 15);
              } else {
                loginPanel_form.submit();
              }
            });
          };

        } else if (api && storageleveltext) {
          var projectNameInput = domID("projectName") || PROJECT_NAME;
          var projectDescriptionInput = domID("projectDescription") || PROJECT_DESCRIPTION;
          var projectNameValue = projectDetails ? projectDetails.projectname : (projectNameInput && projectNameInput.value);
          var projectDescriptionValue = projectDetails ? projectDetails.description : (projectDescriptionInput && projectDescriptionInput.value);

          if (!projectNameValue) {
            if (logoutAfterSave) { logoutInProgress = false; }
            enableDownloads();
            return false;
          }
          zip.generateAsync({
            compression: "DEFLATE",
            type: "Uint8Array"
          }).then(function (content) {
            var formData = new FormData();

            formData.append("projectname", projectNameValue);
            formData.append("description", projectDescriptionValue || "");
            formData.append(
              "edited_on_frontend_or_backend",
              "frontend"
            );

            var fileObj = new File(
              [content],
              projectNameValue + ".zip"
            );
            formData.append("attachment[0]", fileObj);

            var currentProjectInput = domID("currentProject");
            var currentProjectId = currentProjectInput && currentProjectInput.value;
            var url = !projectDetails && currentProjectId ? "api/storeZip" + currentProjectId : "api/storeNew";

            var config = {
              headers: {
                "content-type": "multipart/form-data",
                "Accept": "application/json"
              }
            };
            axios.post(url, formData, config)
              .then(function (response) {
                var result = response.data || {};
                if (result.success !== true || !result.project || !result.project.id) {
                  throw new Error(result.message || "Project save was not confirmed.");
                }

                var projectState = domID("viewProjects") || document.body;
                function updateSessionField(id, value) {
                  var field = domID(id);
                  if (!field) {
                    field = document.createElement("input");
                    field.type = "hidden";
                    field.id = id;
                    projectState.appendChild(field);
                  }
                  field.value = value || "";
                }

                updateSessionField("currentProject", result.project.id);
                updateSessionField("projectName", result.project.projectname || projectNameValue);
                updateSessionField("projectDescription", result.project.projectdescription || projectDescriptionValue);
                if (typeof result.data === "number" && storagelevelbar && storageleveltext) {
                  updateStorageLevel(result.data);
                }
                enableDownloads();
                if (projectDetails && viewProjects) {
                  projectsViewModal_on = viewModal_off(viewProjects);
                }
                if (logoutAfterSave) {
                  logoutCurrentProject();
                }
              })
              .catch(function (error) {
                var message = error.response && error.response.data && error.response.data.message;
                info(message || error.message || "Unable to save project.", false, true);
                if (logoutAfterSave) { logoutInProgress = false; }
                enableDownloads();
              });
          });
        }
      });
  }
  // ---------------------------------------------------
  // ---------------------------------------------------
  // storage levels
  //

  var storageLevelPercentage;
  var storagelevelbar = domID("storagelevelbar");
  var storageleveltext = domID("storageleveltext");
  var storageleveltextInnerthml = domID("storageleveltext");
  if (storageleveltextInnerthml) {
    storageleveltextInnerthml = storageleveltextInnerthml.innerHTML;
  }

  function updateStorageLevel(level) {
    var used = (level / 1000).toFixed(2);
    var remaing = (2 - used).toFixed(2);
    storageLevelPercentage = (level / 2 / 10).toFixed(0);
    var levelColor = "var(--light-bg-color)";
    var storageMessage = remaing + "mb of storage remaing";
    var warning = false;
    if (level === 2000) {
      storageMessage = "cannot save no remaing storage!!";
      levelColor = "red";
      warning = true;
    } else if (level >= 1750 && level < 2000) {
      storageMessage = "storage very low!! " + remaing + "mb remaining";
      levelColor = "red";
      warning = true;
    } else if (level >= 1500 && level < 1750) {
      storageMessage =
        "storage getting low!! " + remaing + "mb remaining";
      levelColor = "orange";
    } else if (level >= 1000 && level < 1500) {
      levelColor = "yellow";
    } else if (level >= 500 && level < 1000) {
      levelColor = "green";
    } else if (level >= 0 && level < 500) {
      levelColor = "blue";
    }
    info(storageMessage, false, warning);
    var levelWidthStyle = "width:" + storageLevelPercentage + "%;";
    var levelColorStyle = "background:" + levelColor + ";";
    storagelevelbar.style = levelWidthStyle + levelColorStyle;
    storageleveltext.innerHTML = storageleveltextInnerthml;
    if (storageOnTable) {
      storageOnTable.innerHTML = used + "MB";
    }
  }

  var storageOnTable = document.querySelector("#viewProjects table tr td.active:nth-of-type(4)");


  // ---------------------------------------------------

  var onloadStorageLevel = domID("currentProjectzipfilesize");
  if (onloadStorageLevel) {
    updateStorageLevel(onloadStorageLevel.value);
    setTimeout(function () {
      updateStorageLevel(onloadStorageLevel.value);
    }, 5000);
  }

  // ---------------------------------------------------

  // ---------------------------------------------------
  // ---------------------------------------------------
  // Checks if an object has a property.
  // returns true/false use in if statement.
  function isEmpty(map) {
    for (var key_3 in map) {
      if (map.hasOwnProperty(key_3)) {
        return !map.hasOwnProperty(key_3);
      }
    }
    return true;
  }
  // ---------------------------------------------------
  // ---------------------------------------------------
  // File operations.

  domEvent(domID("uploadProject"), "mousedown", function () {
    time();
    holder.style.display = "block";
  });
  domEvent(domID("cancelFileDrop"), "mousedown", function () {
    time();
    holder.style.display = null;
  });
  domEvent(domID("saveProject"), "mousedown", function () {
    time();
    if (!isDomposerAuthenticated()) {
      if (login_btn && !loginModal_on) {
        login_btn.onclick();
      }
      return;
    }
    var currentProjectInput = domID("currentProject");
    if (!currentProjectInput || !currentProjectInput.value) {
      if (viewProjects && !projectsViewModal_on) {
        viewProjects.style.removeProperty("display");
        projectsView_toggle();
      }
      var projectNameField = domID("new-projectname");
      if (projectNameField) {
        projectNameField.focus();
      }
      return;
    }
    saveOrDownloadFiles(true);
  });

  // ---------------------------------------------------
  // Project recovery never invokes the normal export/reload or logout paths.
  function remember_recovery_draft(event) {
    const target = event.target;
    if (!target || !target.closest) return;
    const root = target.closest('#prism_html, #prism_css');
    if (!root) return;
    if (root.id === 'prism_css') recoveryCSSDrafts.set(target, true);
    recoveryDrafts.set(root.id, {editor:root.id, page:page_name, text:root.innerText});
  }
  document.addEventListener('input', remember_recovery_draft, true);
  document.addEventListener('paste', event => {
    Promise.resolve().then(() => remember_recovery_draft(event));
  }, true);
  let recoveryBusy = false;
  async function recover_project(action) {
    if (recoveryBusy) return;
    recoveryBusy = true;
    info(action === 'save' ? 'Saving project snapshot…' : 'Preparing recovery ZIP…', false, false);
    try {
      if (projectImportRunning || failedImportBackup || !classcss || !classcss.isConnected) throw Error('Editor is not ready. Keep this tab open and finish the import or storage recovery first.');
      if (action === 'save' && recoveryDrafts.size) throw Error('Code-view edits are not applied. Apply them using the existing controls, or download a recovery ZIP which preserves them separately. Keep this tab open.');
      const project = domID('currentProject');
      const projectId = project && project.value;
      const name = domID('projectName') || PROJECT_NAME;
      const projectName = name && name.value;
      const description = domID('projectDescription') || PROJECT_DESCRIPTION;
      if (action === 'save' && (!isDomposerAuthenticated() || !projectId || !projectName)) throw Error('Sign in and select or create a project using the existing controls, or download a recovery ZIP. Keep this tab open.');
      // Capture live committed state synchronously, without depending on queued
      // persistence timers or overwriting storage if its quota is exhausted.
      const committed = {
        ['HTML_' + page_name]:removeIndexedDBImagesFromClasscss(classcss.innerHTML),
        CSS_LG:JSON.stringify(thecssLG), CSS_MD:JSON.stringify(thecssMD),
        CSS_SM:JSON.stringify(thecssSM), CSS_XS:JSON.stringify(thecssXS),
        page_name, page_names:JSON.stringify(page_names), mobileFirst:JSON.stringify(mobileFirst),
        breakPoint1Value:String(breakPoint_MD_Value), breakPoint2Value:String(breakPoint_SM_Value), breakPoint3Value:String(breakPoint_XS_Value)
      };
      const projectDescription = description && description.value || '';
      const drafts = [...recoveryDrafts.values()].map(draft => ({...draft}));
      const session = Object.create(null);
      for (let i=0;i<sessionStorage.length;i++) {const key=sessionStorage.key(i);session[key]=sessionStorage.getItem(key);}
      const bytes = await recoveryArchive({JSZip, storage:localStorage, assets:localforage, committed, drafts, session});
      if (action === 'download') {
        FileSaver.saveAs(new Blob([bytes], {type:'application/zip'}), 'domposer-recovery.zip');
        info('Recovery ZIP prepared, including assets and any unapplied code-view drafts. Confirm the download completed. Keep this tab open until your work is safe.', false, false);
      } else {
        const data = new FormData();
        data.append('projectname', projectName); data.append('description', projectDescription);
        data.append('edited_on_frontend_or_backend', 'frontend');
        data.append('attachment[0]', new File([bytes], 'project.zip', {type:'application/zip'}));
        const response = await axios.post('/api/storeZip' + projectId, data, {headers:{Accept:'application/json'}});
        if (!response.data || response.data.success !== true || String(response.data.project && response.data.project.id) !== projectId) throw Error('Project save was not confirmed. Keep this tab open.');
        info('Project snapshot saved successfully. Save again if you make further changes.', false, false);
      }
    } catch (error) {
      info((action === 'save' ? 'Save failed. ' : 'Recovery download failed. ') +
        (error && error.message || 'Keep this tab open and try again.'), false, true);
    } finally {
      recoveryBusy=false;
    }
  }
  // ---------------------------------------------------
  // ---------------------------------------------------
  // Creates a download link and clicks it.
  // Not used but keep.
  function download(filename, text) {
    var pom = document.createElement("a");
    pom.setAttribute(
      "href",
      "data:text/plain;charset=utf-8," + encodeURIComponent(text)
    );
    pom.setAttribute("download", filename);
    if (document.createEvent) {
      var event_2 = document.createEvent("MouseEvents");
      event_2.initEvent("click", true, true);
      pom.dispatchEvent(event_2);
    } else {
      pom.click();
    }
  }
  // ---------------------------------------------------
  // ---------------------------------------------------
  // site title
  function siteTitleFn() {
    siteTitle = "domposer";
    localforage.config({
      name: siteTitle
    });
  }

  // ---------------------------------------------------
  // ---------------------------------------------------
  // Resize the scrollbox.
  function isEven(n) {
    //return false;
    return n % 2 === 0;
  }

  function blockIframe() {
    iframeBlocker.style.display = "block";
    if (iframeElementSelect) {
      iframeElementSelect.setAttribute('target', '');
    }
  }

  function unblockIframe() {
    iframeBlocker.style.display = null;
    if (iframeElementSelect) {
      iframeElementSelect.setAttribute('target', domElement[0]);
    }
  }

  var breakpointminmax = domID('breakpointminmax');
  var breakpointminmax_value = "max";
  var stored_breakpointminmax_value = window.localStorage.getItem('data-minmax');
  if (stored_breakpointminmax_value) {
    breakpointminmax_value = stored_breakpointminmax_value;
    breakpointminmax.setAttribute("data-minmax", stored_breakpointminmax_value);
  } else {
    breakpointminmax.setAttribute("data-minmax", breakpointminmax_value);
  }

  breakpointminmax.onclick = function () {
    if (breakpointminmax_value === "min") {
      breakpointminmax_value = "max";
      window.localStorage.setItem('data-minmax', "max");
    } else {
      breakpointminmax_value = "min";
      window.localStorage.setItem('data-minmax', "min");
    }
    breakpointminmax.setAttribute("data-minmax", breakpointminmax_value);
  };

  function set_BREAKPOINT_LINE_FULL() {
    var SCROLLBOX_HANDEL_max = SCROLLBOX_HANDEL.getAttribute("max");

    if (breakpointminmax_value === "min") {
      if (ScrollboxSizeVal === (breakPoint_MD_Value)) {
        ScrollboxSizeVal = SCROLLBOX_HANDEL_max;
      } else {
        ScrollboxSizeVal = (breakPoint_MD_Value);
      }
    } else {
      if (ScrollboxSizeVal === SCROLLBOX_HANDEL_max) {
        ScrollboxSizeVal = (breakPoint_MD_Value);
      } else {
        ScrollboxSizeVal = SCROLLBOX_HANDEL_max;
      }
    }
    SCROLLBOX_HANDEL.value = ScrollboxSizeVal.toString();
    setScrollboxResizeBlocker();
  }

  function set_BREAKPOINT_LINE_3() {
    if (breakpointminmax_value === "min") {
      if (ScrollboxSizeVal === (breakPoint_SM_Value)) {
        ScrollboxSizeVal = (breakPoint_MD_Value - 1);
      } else {
        ScrollboxSizeVal = (breakPoint_SM_Value);
      }
    } else {
      if (ScrollboxSizeVal === (breakPoint_MD_Value - 1)) {
        ScrollboxSizeVal = (breakPoint_SM_Value);
      } else {
        ScrollboxSizeVal = (breakPoint_MD_Value - 1);
      }
    }
    SCROLLBOX_HANDEL.value = ScrollboxSizeVal.toString();
    setScrollboxResizeBlocker();
  }

  function set_BREAKPOINT_LINE_2() {
    if (breakpointminmax_value === "min") {
      if (ScrollboxSizeVal === (breakPoint_XS_Value)) {
        ScrollboxSizeVal = (breakPoint_SM_Value - 1);
      } else {
        ScrollboxSizeVal = (breakPoint_XS_Value);
      }
    } else {
      if (ScrollboxSizeVal === (breakPoint_SM_Value - 1)) {
        ScrollboxSizeVal = (breakPoint_XS_Value);
      } else {
        ScrollboxSizeVal = (breakPoint_SM_Value - 1);
      }
    }
    SCROLLBOX_HANDEL.value = ScrollboxSizeVal.toString();
    setScrollboxResizeBlocker();
  }

  function set_BREAKPOINT_LINE_1() {
    if (breakpointminmax_value === "min") {
      if (ScrollboxSizeVal === breakPoint_Min_Value) {
        ScrollboxSizeVal = (breakPoint_XS_Value - 1);
      } else {
        ScrollboxSizeVal = breakPoint_Min_Value;
      }
    } else {
      if (ScrollboxSizeVal === (breakPoint_XS_Value - 1)) {
        ScrollboxSizeVal = breakPoint_Min_Value;
      } else {
        ScrollboxSizeVal = (breakPoint_XS_Value - 1);
      }
    }
    SCROLLBOX_HANDEL.value = ScrollboxSizeVal.toString();
    setScrollboxResizeBlocker();
  }

  function setScrollboxResizeBlocker() {
    var currentVal = SCROLLBOX_HANDEL.value;
    var maxVal = SCROLLBOX_HANDEL.getAttribute('max');
    var result = Number(((maxVal - currentVal) / 2));
    if (currentVal <= breakPoint_Min_Value) {
      result = Number(((maxVal - breakPoint_Min_Value) / 2));
    }
    scrollboxResizeBlocker.style.width = result + 'px';
  }

  var ScrollboxSizeVal;
  var storeVal = [];

  function ScrollboxSizeResizer() {
    var sourceDimensions = SCROLLBOX;
    var computedStyle = window.getComputedStyle(sourceDimensions, null);
    var classcssWidth = Number(
      computedStyle.getPropertyValue("width").replace(theValREGEX, "")
    );
    SCROLLBOX.style.minWidth = classcssWidth + "px";
    SCROLLBOX_HANDEL.max = (classcssWidth - 40).toString();
    setScrollboxResizeBlocker();
  }


  BREAKPOINT_LINE_LG.onmousedown = function () {
    clickedBP = true;
    fullWidth();
  };

  BREAKPOINT_LINE_MD.onmousedown = function () {
    clickedBP = true;
    breakPoint1();
  };

  BREAKPOINT_LINE_SM.onmousedown = function () {
    clickedBP = true;
    breakPoint2();
  };

  BREAKPOINT_LINE_XS.onmousedown = function () {
    clickedBP = true;
    breakPoint3();
  };

  function SCROLLBOX_bring_to_front(toggle = false) {
    var current_front = [...document.querySelectorAll(".bring-to-front")];
    if (!SCROLLBOX.classList.contains("bring-to-front")) {
      current_front.map((el) => {
        el.classList.remove("bring-to-front");
      });
      SCROLLBOX.classList.add("bring-to-front");
    } else {
      if (toggle) {
        current_front.map((el) => {
          el.classList.remove("bring-to-front");
        });
      }
    }
  }

  domID('paraBreakWidth').addEventListener('click', (e) => {
    SCROLLBOX_bring_to_front(true);
  });

  function ScrollboxResizer(value) {
    if (isEven(value)) {} else {
      value--;
    }

    if (value >= breakPoint_Min_Value) {
      BREAKPOINT_WIDTH_READOUT.innerHTML = value + " x " + iframe.offsetHeight + BREAKPOINT_WIDTH_READOUT_mode;
      SCROLLBOX.style.minWidth = value + "px";
      storeVal = [];
      storeVal.push(value);
    } else {
      SCROLLBOX_HANDEL.value = storeVal[0];
      setScrollboxResizeBlocker();
    }
    if (value >= breakPoint_MD_Value) {
      fullWidth();
      cssStylesBreakPoints();
    } else if (value >= breakPoint_SM_Value && value < breakPoint_MD_Value) {
      breakPoint1();
      cssStylesBreakPoints();
    } else if (value >= breakPoint_XS_Value && value < breakPoint_SM_Value) {
      breakPoint2();
      cssStylesBreakPoints();
    } else if (value < breakPoint_XS_Value) {
      breakPoint3();
      cssStylesBreakPoints();
    }
  }

  function drag_SCROLLBOX_HANDEL_X(elmnt) {
    let pos1 = 0;
    let pos3 = 0;
    let w = 0;
    let l = 0;

    elmnt.addEventListener("mousedown", dragMouseDown, {
      passive: false
    });
    elmnt.addEventListener("touchstart", dragMouseDown, {
      passive: false
    });

    elmnt.addEventListener("mouseenter", dragMouseEnter, {
      passive: false
    });

    elmnt.addEventListener("mouseleave", dragMouseLeave, {
      passive: false
    });

    function dragMouseEnter() {
      domID('resize-scrollbox-hoz').classList.add('resize-scrollbox-hover');
    }

    function dragMouseLeave() {
      domID('resize-scrollbox-hoz').classList.remove('resize-scrollbox-hover');
    }

    function set_positions(e) {
      // get the mouse cursor position at startup:
      if (e.type === "touchmove") {
        pos1 = pos3 - e.touches[0].clientX;
        pos3 = e.touches[0].clientX;
      } else {
        pos1 = pos3 - e.clientX;
        pos3 = e.clientX;
      }
    }



    function dragMouseDown(e) {
      e = e || window.event;
      e.preventDefault();
      set_positions(e);
      blockIframe();
      domID('resize-scrollbox-hoz').classList.add('resize-scrollbox-active');
      domID('app').style.cssText = "cursor: ew-resize !important";
      domID('left-sections').style.pointerEvents = "none";
      domID('right-sections').style.pointerEvents = "none";
      domID('code-section').style.pointerEvents = "none";
      document.addEventListener("mouseup", closeDragElement, {
        passive: false
      });
      document.addEventListener("touchend", closeDragElement, {
        passive: false
      });
      document.addEventListener("mousemove", elementDrag, {
        passive: false
      });
      document.addEventListener("touchmove", elementDrag, {
        passive: false
      });
      blockIframe();
    }

    function elementDrag(e) {
      e = e || window.event;
      e.preventDefault();
      set_positions(e);
      // set the element's new position:
      let styles = window.getComputedStyle(SCROLLBOX);
      l = parseInt(styles.left, 10);
      w = parseInt(styles.width, 10);
      let set_val = w;
      if (w >= breakPoint_Min_Value) {
        let new_pos = (pos1 * 2);
        if (!isEven(new_pos)) {
          new_pos--;
        }
        set_val = w - new_pos;
      }
      if (set_val + 28 >= window.innerWidth) {
        set_val = window.innerWidth - 28;
      }
      SCROLLBOX_HANDEL.value = set_val;
      setScrollboxResizeBlocker();
      ScrollboxResizer(set_val);
    }

    function closeDragElement() {
      // stop moving when mouse button is released:
      document.removeEventListener("mouseup", closeDragElement);
      document.removeEventListener("touchend", closeDragElement);
      document.removeEventListener("mousemove", elementDrag);
      document.removeEventListener("touchmove", elementDrag);
      domID('resize-scrollbox-hoz').classList.remove('resize-scrollbox-active');
      domID('app').style.cssText = "";
      domID('left-sections').style.pointerEvents = null;
      domID('right-sections').style.pointerEvents = null;
      domID('code-section').style.pointerEvents = null;
      unblockIframe();
      selectElement(frameID(domElement[0]));
      BoxRefresh();
      unblockIframe();
      const styles = window.getComputedStyle(domID('scrollbox'));
      w = parseInt(styles.width, 10);
      localStorage.setItem("scrollBoxSizeValue", w);
      tutorial_change(tutorial_data_index);
    }
  }

  drag_SCROLLBOX_HANDEL_X(domID('resize-scrollbox-hoz'));

  function drag_SCROLLBOX_HANDEL_Y(elmnt) {
    let pos2 = 0;
    let pos4 = 0;
    let t = 0;
    let h = 0;

    elmnt.addEventListener("mousedown", dragMouseDown, {
      passive: false
    });
    elmnt.addEventListener("touchstart", dragMouseDown, {
      passive: false
    });

    elmnt.addEventListener("mouseenter", dragMouseEnter, {
      passive: false
    });

    elmnt.addEventListener("mouseleave", dragMouseLeave, {
      passive: false
    });

    function dragMouseEnter() {
      domID('resize-scrollbox-vert').classList.add('resize-scrollbox-hover');
    }

    function dragMouseLeave() {
      domID('resize-scrollbox-vert').classList.remove('resize-scrollbox-hover');
    }

    function set_positions(e) {
      // get the mouse cursor position at startup:
      if (e.type === "touchmove") {
        pos2 = pos4 - e.touches[0].clientY;
        pos4 = e.touches[0].clientY;
      } else {
        pos2 = pos4 - e.clientY;
        pos4 = e.clientY;
      }
    }

    function dragMouseDown(e) {
      e = e || window.event;
      e.preventDefault();
      set_positions(e);
      blockIframe();
      domID('resize-scrollbox-vert').classList.add('resize-scrollbox-active');
      domID('app').style.cssText = "cursor: ns-resize !important";
      domID('left-sections').style.pointerEvents = "none";
      domID('right-sections').style.pointerEvents = "none";
      domID('code-section').style.pointerEvents = "none";
      document.addEventListener("mouseup", closeDragElement, {
        passive: false
      });
      document.addEventListener("touchend", closeDragElement, {
        passive: false
      });
      document.addEventListener("mousemove", elementDrag, {
        passive: false
      });
      document.addEventListener("touchmove", elementDrag, {
        passive: false
      });
      blockIframe();
    }

    function elementDrag(e) {
      e = e || window.event;
      e.preventDefault();
      set_positions(e);
      // set the element's new position:
      const styles = window.getComputedStyle(SCROLLBOX);
      t = parseInt(styles.top, 10);
      h = parseInt(styles.height, 10);
      scrollbox.style.height = h - pos2 + 'px';
      t = parseInt(styles.top, 10);
      h = parseInt(styles.height, 10);
      if (h <= breakPoint_Min_Value) {
        scrollbox.style.height = breakPoint_Min_Value + 'px';
      }
      if ((h + 98) > (window.innerHeight)) {
        scrollbox.style.height = (window.innerHeight - 98) + 'px';
      }
      let ScrollboxSizeVal = Number(SCROLLBOX_HANDEL.value);
      setScrollboxResizeBlocker();
      ScrollboxResizer(ScrollboxSizeVal);
    }

    function closeDragElement() {
      // stop moving when mouse button is released:
      document.removeEventListener("mouseup", closeDragElement);
      document.removeEventListener("touchend", closeDragElement);
      document.removeEventListener("mousemove", elementDrag);
      document.removeEventListener("touchmove", elementDrag);
      domID('resize-scrollbox-vert').classList.remove('resize-scrollbox-active');
      domID('app').style.cssText = "";
      domID('left-sections').style.pointerEvents = null;
      domID('right-sections').style.pointerEvents = null;
      domID('code-section').style.pointerEvents = null;
      unblockIframe();
      selectElement(frameID(domElement[0]));
      BoxRefresh();
      unblockIframe();
      const styles = window.getComputedStyle(domID('scrollbox'));
      h = parseInt(styles.height, 10);
      localStorage.setItem("scrollBoxSizeValue_vertical", h);
      tutorial_change(tutorial_data_index);
    }
  }

  drag_SCROLLBOX_HANDEL_Y(domID('resize-scrollbox-vert'));

  function drag_SCROLLBOX_HANDEL_BOTH(elmnt) {
    let pos1 = 0;
    let pos2 = 0;
    let pos3 = 0;
    let pos4 = 0;

    let w = 0;
    let h = 0;
    let l = 0;
    let t = 0;

    elmnt.addEventListener("mousedown", dragMouseDown, {
      passive: false
    });

    elmnt.addEventListener("touchstart", dragMouseDown, {
      passive: false
    });

    elmnt.addEventListener("mouseenter", dragMouseEnter, {
      passive: false
    });

    elmnt.addEventListener("mouseleave", dragMouseLeave, {
      passive: false
    });

    function dragMouseEnter() {
      domID('resize-scrollbox-hoz').classList.add('resize-scrollbox-hover');
      domID('resize-scrollbox-vert').classList.add('resize-scrollbox-hover');
      domID('resize-scrollbox-both').classList.add('resize-scrollbox-hover');
    }

    function dragMouseLeave() {
      domID('resize-scrollbox-hoz').classList.remove('resize-scrollbox-hover');
      domID('resize-scrollbox-vert').classList.remove('resize-scrollbox-hover');
      domID('resize-scrollbox-both').classList.remove('resize-scrollbox-hover');
    }

    function set_positions(e) {
      // get the mouse cursor position at startup:
      if (e.type === "touchmove") {
        pos1 = pos3 - e.touches[0].clientX;
        pos2 = pos4 - e.touches[0].clientY;
        pos3 = e.touches[0].clientX;
        pos4 = e.touches[0].clientY;
      } else {
        pos1 = pos3 - e.clientX;
        pos2 = pos4 - e.clientY;
        pos3 = e.clientX;
        pos4 = e.clientY;
      }
    }

    function dragMouseDown(e) {
      e = e || window.event;
      e.preventDefault();
      set_positions(e);
      blockIframe();
      domID('resize-scrollbox-hoz').classList.add('resize-scrollbox-active');
      domID('resize-scrollbox-vert').classList.add('resize-scrollbox-active');
      domID('resize-scrollbox-both').classList.add('resize-scrollbox-active');
      domID('app').style.cssText = "cursor: nw-resize !important";
      domID('left-sections').style.pointerEvents = "none";
      domID('right-sections').style.pointerEvents = "none";
      domID('code-section').style.pointerEvents = "none";
      document.addEventListener("mouseup", closeDragElement, {
        passive: false
      });
      document.addEventListener("touchend", closeDragElement, {
        passive: false
      });
      document.addEventListener("mousemove", elementDrag, {
        passive: false
      });
      document.addEventListener("touchmove", elementDrag, {
        passive: false
      });
      blockIframe();
    }

    function elementDrag(e) {
      e = e || window.event;
      e.preventDefault();
      set_positions(e);
      // set the element's new position:
      let styles = window.getComputedStyle(SCROLLBOX);
      t = parseInt(styles.top, 10);
      h = parseInt(styles.height, 10);
      l = parseInt(styles.left, 10);
      w = parseInt(styles.width, 10);
      /// vert
      scrollbox.style.height = h - pos2 + 'px';
      t = parseInt(styles.top, 10);
      h = parseInt(styles.height, 10);
      if (h <= breakPoint_Min_Value) {
        scrollbox.style.height = breakPoint_Min_Value + 'px';
      }
      if ((h + 98) > (window.innerHeight)) {
        scrollbox.style.height = (window.innerHeight - 98) + 'px';
      }
      /// hoz
      let set_val = w;
      if (w >= breakPoint_Min_Value) {
        let new_pos = (pos1 * 2);
        if (!isEven(new_pos)) {
          new_pos--;
        }
        set_val = w - new_pos;
      }
      if (set_val + 28 >= window.innerWidth) {
        set_val = window.innerWidth - 28;
      }
      SCROLLBOX_HANDEL.value = set_val;
      setScrollboxResizeBlocker();
      ScrollboxResizer(set_val);

      iframeElementSelect.setAttribute('target', '');
      //iframe.contentWindow.postMessage('update_target');
    }

    function closeDragElement() {
      // stop moving when mouse button is released:
      document.removeEventListener("mouseup", closeDragElement);
      document.removeEventListener("touchend", closeDragElement);
      document.removeEventListener("mousemove", elementDrag);
      document.removeEventListener("touchmove", elementDrag);
      domID('resize-scrollbox-hoz').classList.remove('resize-scrollbox-active');
      domID('resize-scrollbox-vert').classList.remove('resize-scrollbox-active');
      domID('resize-scrollbox-both').classList.remove('resize-scrollbox-active');
      domID('app').style.cssText = "";
      domID('left-sections').style.pointerEvents = null;
      domID('right-sections').style.pointerEvents = null;
      domID('code-section').style.pointerEvents = null;
      unblockIframe();
      selectElement(frameID(domElement[0]));
      BoxRefresh();
      unblockIframe();
      const styles = window.getComputedStyle(domID('scrollbox'));
      h = parseInt(styles.height, 10);
      localStorage.setItem("scrollBoxSizeValue_vertical", h);
      tutorial_change(tutorial_data_index);
    }
  }

  drag_SCROLLBOX_HANDEL_BOTH(domID('resize-scrollbox-both'));

  // ---------------------------------------------------
  // ---------------------------------------------------
  // Resize window and trigger page reload.
  // Needed as the GUI iframe size needs to
  // be calulated on window resize.
  // Maybe a better way todo this but for now this works.


  function debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, timeout);
    };
  }

  function windowWidthChange() {
    var w = window.innerWidth;
    if (w < breakPoint_MD_Value + scrollbox_width_resizer_vars_min_width) {
      // CSSDone();
      setTimeout(function () {
        toggleFullScreenMode();
        if (w < 567) {
          // dont adjust panels 
        } else {
          // adjust panels 
          dragSideBar_store(document.getElementById("left-sections"), document.getElementById("htmlButton"));
          dragSideBar_store(document.getElementById("right-sections"), document.getElementById("cssButton"));
          dragSideBar_store(codesection, document.getElementById("viewCodeButton"));
        }
      }, 0);
    } else {
      window.location.reload();
    }
  }

  const ResizeWindow = debounce(() => windowWidthChange(), 500);
  window.addEventListener("resize", ResizeWindow);

  // ---------------------------------------------------
  // ---------------------------------------------------
  // Prevents default of window drag drop.
  window.addEventListener(
    "dragover",
    function (e) {
      e = e || event;
      e.preventDefault();
    },
    false
  );
  window.addEventListener(
    "drop",
    function (e) {
      e = e || event;
      e.preventDefault();
    },
    false
  );
  // ---------------------------------------------------
  // ---------------------------------------------------
  // upload Loads the JSON project file into localstorage and reloads window.
  // Step 1 : The File Selector

  holder.ondrop = function (e) {
    e.preventDefault();
    uploadFiles(e.dataTransfer.files[0]);
  };

  var projectImportRunning = false;
  var failedImportBackup;

  async function loadImportedProject(preparedHTML) {
    // Selection belongs to the previous canvas, not the incoming project.
    // uploadFiles captured it and the inputs already, so rollback can restore them.
    domElement = ['classcss', 'DIV'];
    [INPUTER1, INPUTER2, INPUTER3, INPUTER4].forEach(input => { input.value = ''; });
    set_CSS_from_localStorage();
    mobileFirst = JSON.parse(localStorage.getItem('mobileFirst') || 'true');
    page_name = localStorage.getItem('page_name') || 'index';
    page_names = JSON.parse(localStorage.getItem('page_names') || '["index"]');
    if (localStorage.breakPoint1Value && localStorage.breakPoint2Value && localStorage.breakPoint3Value) {
      breakPoint_MD_Value = JSON.parse(localStorage.breakPoint1Value);
      breakPoint_SM_Value = JSON.parse(localStorage.breakPoint2Value);
      breakPoint_XS_Value = JSON.parse(localStorage.breakPoint3Value);
      setBreakPointCSSvariables();
    }
    clearTheHTML(classcss);
    renderToDOM(preparedHTML);
    logger();
    await renderPreviewImagesFromIndexedDB(true);
    await renderImagesFromIndexedDB(true);
    check_for_images_not_in_DB();
    FillValueReadouts();
    refreshElementAttrs();
    buttonRefresh();
    DOMtree();
    hightlightClassBtns();
    hightlightALLClassBtns();
    refreshCodeView();
    clickedBP = true;
    currentundoLevel = 0;
    if (localStorage.mobileFirst) {
      if (localStorage.mobileFirst === 'true') mobileFirstTrue();
      else mobileFirstFalse();
    } else {
      mobileFirstTrue();
      FillStoragemobileFirst();
    }
    setBreakpointWhenPageLoads();
    onLoadCounter = 1;
    localStorage.setItem('on_load_count', onLoadCounter);
    getArrayOfUndos();
    FillUndo(true);
  }

  async function uploadFiles(file) {
    if (projectImportRunning) {
      info('A project import is already running.', false, true);
      return false;
    }
    if (failedImportBackup) {
      holder.style.display = 'block';
      domID('project-import-error').hidden = false;
      domID('project-import-error').focus();
      info('Download the recovery ZIP and reload the editor before importing again.', false, true);
      return false;
    }
    var importError = domID('project-import-error');
    importError.textContent = '';
    importError.hidden = true;
    projectImportRunning = true;
    // Keep live nodes, including their listeners, for editor rollback.
    var previousNodes = Array.from(classcss.childNodes);
    var previousState = { thecssLG, thecssMD, thecssSM, thecssXS, mobileFirst,
      page_name, page_names, breakPoint_MD_Value, breakPoint_SM_Value,
      breakPoint_XS_Value, currentundoLevel, onLoadCounter, clickedBP,
      breakPoint, objectOfBlobs, all_image_options, HTMLarray, undoInc,
      BREAKPOINT_WIDTH_READOUT_mode, delayToManySaves,
      domElement: domElement.slice(), arrayOfUndos: arrayOfUndos.slice() };
    var previousImageUI = [imageHolder, domID('select__background-image'),
      domID('select__list-style-image')].map(element => ({ element,
        nodes: Array.from(element.childNodes), value: element.value }));
    var previousImageSize = domID('total-file-size').innerText;
    var previousControls = [SCROLLBOX, mobileFirstBtn, mobileLastBtn,
      BREAKPOINT_BTN_LG, BREAKPOINT_BTN_MD, BREAKPOINT_BTN_SM, BREAKPOINT_BTN_XS,
      BREAKPOINT_LINE_LG, BREAKPOINT_LINE_MD, BREAKPOINT_LINE_SM, BREAKPOINT_LINE_XS]
      .map(element => ({ element, style: element.getAttribute('style'),
        className: element.className }));
    var previousReadout = BREAKPOINT_WIDTH_READOUT.innerHTML;
    var previousInputs = [INPUTER1, INPUTER2, INPUTER3, INPUTER4]
      .map(element => ({ element, value: element.value }));
    var preparedHTML;
    var previousHolderDisplay = holder.style.display;
    var previousStorageText = storageleveltext && storageleveltext.innerHTML;
    try {
      if (storageleveltext) storageleveltext.innerHTML = 'updating...';
      await importProjectZip(file, {
        JSZip, imageStorage: localforage, localStorage, sessionStorage,
        makeImage: (blob, type) => new File([blob], 'untitled', { type }),
        prepareProject: function (effective) {
          var page = effective.get('page_name') || 'index';
          var html = effective.get('HTML_' + page) || effective.get('AlltheHTML') || '';
          var element = projectHTMLContainer(html.replace(/src="blob:(.*?)"/g, ''));
          preparedHTML = createDOMMap(element);
        },
        loadProject: () => loadImportedProject(preparedHTML),
        restoreEditor: async function () {
          ({ thecssLG, thecssMD, thecssSM, thecssXS, mobileFirst, page_name,
            page_names, breakPoint_MD_Value, breakPoint_SM_Value,
            breakPoint_XS_Value, currentundoLevel, onLoadCounter, clickedBP,
            breakPoint, objectOfBlobs, all_image_options, HTMLarray, undoInc,
            BREAKPOINT_WIDTH_READOUT_mode, delayToManySaves,
            domElement, arrayOfUndos } = previousState);
          clearTheHTML(classcss);
          previousNodes.forEach(node => classcss.appendChild(node));
          setBreakPointCSSvariables();
          logger();
          holder.style.display = previousHolderDisplay;
          previousInputs.forEach(({ element, value }) => { element.value = value; });
          FillValueReadouts();
          BoxRefresh();
          refreshElementAttrs();
          DOMtree();
          previousImageUI.forEach(({ element, nodes, value }) => {
            clearTheHTML(element);
            nodes.forEach(node => element.appendChild(node));
            if (value !== undefined) element.value = value;
          });
          domID('total-file-size').innerText = previousImageSize;
          previousControls.forEach(({ element, style, className }) => {
            if (style === null) element.removeAttribute('style');
            else element.setAttribute('style', style);
            element.className = className;
          });
          BREAKPOINT_WIDTH_READOUT.innerHTML = previousReadout;
        }
      });
    } catch (error) {
      if (error.backup) {
        // Keep a recovery copy when persistent storage failure prevents rollback.
        failedImportBackup = error.backup;
        var recoveryButton = document.createElement('button');
        recoveryButton.type = 'button';
        recoveryButton.textContent = 'Download recovery ZIP';
        var recoveryStatus = document.createElement('span');
        recoveryStatus.setAttribute('role', 'status');
        recoveryButton.onclick = async function () {
          recoveryStatus.textContent = '';
          try {
            var recoveryZip = new JSZip();
            recoveryZip.file('project.json', JSON.stringify(Object.fromEntries(failedImportBackup.local)));
            failedImportBackup.images.forEach(([key, value]) => recoveryZip.file('images/' + key, value));
            recoveryZip.file('recovery-session.json', JSON.stringify(Object.fromEntries(failedImportBackup.session)));
            FileSaver.saveAs(await recoveryZip.generateAsync({ type: 'blob' }), 'domposer-recovery.zip');
          } catch (recoveryError) {
            console.error('Recovery ZIP could not be generated', recoveryError);
            recoveryStatus.textContent = 'Unable to download the recovery ZIP. Keep this tab open and try again.';
          }
        };
      }
      console.error('Project ZIP import failed', error);
      info('', false, true);
      var errorMessage = error.backup
        ? 'Unable to import project. Storage recovery was incomplete and your project may need recovery. Keep this tab open and download the recovery ZIP.'
        : error.message || 'Unable to import this ZIP project.';
      INFO_READOUT.textContent = errorMessage;
      importError.textContent = errorMessage;
      if (recoveryButton) {
        importError.appendChild(recoveryButton);
        importError.appendChild(recoveryStatus);
      }
      importError.hidden = false;
      holder.style.display = 'block';
      importError.focus();
      if (storageleveltext) storageleveltext.innerHTML = previousStorageText;
      return false;
    } finally {
      projectImportRunning = false;
    }
    holder.style.display = 'none';
    showTheApp();
    var w = window.innerWidth;
    if (w < breakPoint_MD_Value + scrollbox_width_resizer_vars_min_width) {
      setTimeout(function () { toggleFullScreenMode(true); }, 50);
    }
    setTimeout(function () {
      saveOrDownloadFiles(true);
      delayToManySaves = true;
      setTimeout(function () { delayToManySaves = false; }, 30000);
    }, 500);
    return true;
  }
  //uploadFiles();
  // ---------------------------------------------------
  // ---------------------------------------------------
  // drop images to indexedDB
  // Step 1 : The File Selector
  imageDropZone.ondrop = function (e) {
    e.preventDefault();
    info('');
    var droppedImages = e.dataTransfer.files;
    for (var i = 0; i < droppedImages.length; i++) {
      var dropped_indexOf = droppedImages[i].name.indexOf('-') || 0;
      var dropped_length = droppedImages[i].name.length || 0;

      if (dropped_indexOf === 8 && dropped_length === 40) {
        // do nothing
      } else if (droppedImages[i].type.indexOf("image/") > -1) {
        if (
          droppedImages[i].type.indexOf("image/jpg") > -1 ||
          droppedImages[i].type.indexOf("image/jpeg") > -1 ||
          droppedImages[i].type.indexOf("image/png") > -1 ||
          droppedImages[i].type.indexOf("image/gif") > -1 ||
          droppedImages[i].type.indexOf("image/svg") > -1
        ) {
          localforage.setItem(
            droppedImages[i].name,
            droppedImages[i]
          ).then(() => {
            renderPreviewImagesFromIndexedDB();
            renderImagesFromIndexedDB();
            BoxRefresh();
          });
        } else {
          info("Image file type not supported.", false, true);
        }
      } else {
        info("File is not a type of image.", false, true);
      }
    }

  };

  // ---------------------------------------------------
  // ---------------------------------------------------
  // Link, visited, hover and active
  function PseudoPutter(pseudo) {
    // con('PseudoPutter');
    // con(INPUTER1.value);
    // con(pseudo);
    if (!INPUTER1.value || !pseudo) {
      return false;
    }
    var putThis;
    putThis = INPUTER1.value + ":" + pseudo;
    // put(putThis, {}, thecss);
    // put(putThis, {}, thecssBP1);
    // put(putThis, {}, thecssBP2);
    // put(putThis, {}, thecssBP3);
    switch (breakPoint) {
      case "fullWidth":
        put(putThis, {}, thecssLG);
        break;
      case "breakPoint1":
        put(putThis, {}, thecssMD);
        break;
      case "breakPoint2":
        put(putThis, {}, thecssSM);
        break;
      case "breakPoint3":
        put(putThis, {}, thecssXS);
        break;
    }
  }

  domID('clear-pseudo').onmouseup = function () {
    clearInputer1OfPseudo();

    populateClassesDropdown();
  };

  function clearInputer1OfPseudo() {
    var str1 = INPUTER1.value + "";
    [].forEach.call(array_of_pseudos, function (pseudo) {
      var replacement = ":" + pseudo;
      str1 = str1.replace(replacement, "");
    });
    INPUTER1.value = str1;
    pseudo_select.value = "";
    [].forEach.call(pseudo_select_options, function (el) {
      el.removeAttribute('selected');
    });

    setTimeout(function () {
      FillValueReadouts();
    }, 100);
  }

  function removeTargetClass() {
    if (INPUTER1.value.indexOf(" .") > -1) {
      var splitIt = INPUTER1.value;
      var split = splitIt.split(" .");
      INPUTER1.value = split[0];
    }
  }

  function PseudoCreate(pseudo) {
    removeTargetClass();
    clearInputer1OfPseudo();
    if (PseudoState !== pseudo) {
      PseudoState = pseudo;
      if (INPUTER1.value) {
        var currentstlyes = cssStylesBreakPoints();
        if (!currentstlyes[INPUTER1.value + ":" + pseudo]) {
          PseudoPutter(pseudo);
        }
      }
    } else {
      PseudoState = "noneSelected";
    }
    PseudoFunction();
  }

  var array_of_pseudos = [];
  var pseudo_btns = document.querySelectorAll('[data-pseudo]');
  [].forEach.call(pseudo_btns, function (el) {
    var el_pseudo = el.getAttribute('data-pseudo');
    //array_of_pseudos.push(el_pseudo);
    domEvent(el, "mousedown", function () {
      PseudoCreate(el_pseudo);
    });
  });

  var pseudo_select = domID('pseudos-select');
  pseudo_select.value = "";
  var pseudo_select_options = pseudo_select.children;

  [].forEach.call(pseudo_select_options, function (el) {
    var el_pseudo = el.getAttribute('value');
    array_of_pseudos.push(el_pseudo);
    // domEvent(el, "mousedown", function () {
    //   PseudoCreate(el_pseudo)
    // });
  });

  pseudo_select.onchange = function () {
    var el_pseudo = pseudo_select.value;
    PseudoCreate(el_pseudo);

    PseudoState = pseudo_select.value;

    INPUTER1.value = INPUTER1.value + ':' + el_pseudo;


    FillValueReadouts();
    setColorsOnColorInputs();
    populateClassesDropdown();
  };

  function PseudoFunction() {
    [].forEach.call(pseudo_btns, function (el) {
      el.style = buttonBGColor;
    });
    [].forEach.call(pseudo_select_options, function (el) {
      el.removeAttribute('selected');
    });


    pseudo_select.value = "";
    if (PseudoState !== "noneSelected") {

    }
    if (domElement[0] !== 'classcss') {
      selectElement(frameID(domElement[0]));
    }

  }
  // ---------------------------------------------------
  // ---------------------------------------------------
  // BOX SHADOWS
  // Gets all boxShadow values and puts them into array of objects
  var shadowsArray;
  var shad1 = {
    red: 0,
    green: 0,
    blue: 0,
    alpha: 1,
    hShadow: 0,
    vShadow: 0,
    blur: 0,
    spread: 0,
    inset: ""
  };
  var shad2 = {
    red: 0,
    green: 0,
    blue: 0,
    alpha: 1,
    hShadow: 0,
    vShadow: 0,
    blur: 0,
    spread: 0,
    inset: ""
  };
  var shad3 = {
    red: 0,
    green: 0,
    blue: 0,
    alpha: 1,
    hShadow: 0,
    vShadow: 0,
    blur: 0,
    spread: 0,
    inset: ""
  };
  var shad4 = {
    red: 0,
    green: 0,
    blue: 0,
    alpha: 1,
    hShadow: 0,
    vShadow: 0,
    blur: 0,
    spread: 0,
    inset: ""
  };
  var currentShadSelection = 1;
  var currentShad = {
    red: 0,
    green: 0,
    blue: 0,
    alpha: 1
  };
  domEvent(currentShad1, "mousedown", function () {
    if (!INPUTER1.value) {
      return false;
    }
    createBoxShadowIfNone();
    currentShadSelection = 1;
    INPUTER3.value = "";
    refreshShadowValues();
  });
  domEvent(currentShad2, "mousedown", function () {
    if (!INPUTER1.value) {
      return false;
    }
    createBoxShadowIfNone();
    currentShadSelection = 2;
    INPUTER3.value = "";
    refreshShadowValues();
  });
  domEvent(currentShad3, "mousedown", function () {
    if (!INPUTER1.value) {
      return false;
    }
    createBoxShadowIfNone();
    currentShadSelection = 3;
    INPUTER3.value = "";
    refreshShadowValues();
  });
  domEvent(currentShad4, "mousedown", function () {
    if (!INPUTER1.value) {
      return false;
    }
    createBoxShadowIfNone();
    currentShadSelection = 4;
    INPUTER3.value = "";
    refreshShadowValues();
  });

  function createBoxShadowIfNone() {
    if (frameID(domElement[0]).style["box-shadow"] || CSSstyles["box-shadow"]) {} else {
      var input1 = INPUTER1.value;
      var BoxShadDefaults =
        "rgba(0, 0, 0, 1) 0px 0px 0px 0px, " +
        "rgba(0, 0, 0, 1) 0px 0px 0px 0px, " +
        "rgba(0, 0, 0, 1) 0px 0px 0px 0px, " +
        "rgba(0, 0, 0, 1) 0px 0px 0px 0px ";

      if (inline_external_css === 'inline') {
        frameID(domElement[0]).style["box-shadow"] = BoxShadDefaults;
      } else {
        switch (breakPoint) {
          case "fullWidth":
            put("box-shadow", BoxShadDefaults, thecssLG[input1]);
            break;
          case "breakPoint1":
            put("box-shadow", BoxShadDefaults, thecssMD[input1]);
            break;
          case "breakPoint2":
            put("box-shadow", BoxShadDefaults, thecssSM[input1]);
            break;
          case "breakPoint3":
            put("box-shadow", BoxShadDefaults, thecssXS[input1]);
            break;
        }
      }
      selectElement(frameID(domElement[0]));
    }
  }

  function getShadowsAll(shads) {
    shadowsArray = [];
    var array = shads.split(", rgb");

    function Shadow(theShadow) {
      var shadBits = theShadow.split(") "),
        color = getColorValues(shadBits[0] + ")"),
        lengths = shadBits[1].split(" "),
        shadowLengths = {
          color: color,
          hShadow: lengths[0],
          vShadow: lengths[1],
          blur: lengths[2],
          spread: lengths[3],
          inset: lengths[4] // Reads as last property.
        };
      shadowsArray.push(shadowLengths);
    }
    for (var i = 0; i < array.length; i++) {
      if (i !== 0) {
        array[i] = "rgb" + array[i];
      }
      Shadow(array[i]);
    }
  }

  function roundNumber(num, scale) {
    if (("" + num).indexOf("e") === -1) {
      return +(Math.round(Number(num + "e+" + scale)) + "e-" + scale);
    } else {
      var arr = ("" + num).split("e");
      var sig = "";
      if (+arr[1] + scale > 0) {
        sig = "+";
      }
      return +(
        Math.round(Number(+arr[0] + "e" + sig + (+arr[1] + scale))) +
        "e-" +
        scale
      );
    }
  }

  function refreshShadowValues() {
    if (INPUTER1.value) {
      const target = frameID(domElement[0]);
      if (!target) return;
      let frame_style = target.style;
      if (frame_style["box-shadow"] || CSSstyles["box-shadow"]) {
        var boxShadow = "";

        switch (breakPoint) {
          case "fullWidth":
            boxShadow = frame_style["box-shadow"] || thecssLG[INPUTER1.value]["box-shadow"];
            break;
          case "breakPoint1":
            boxShadow = frame_style["box-shadow"] || thecssMD[INPUTER1.value]["box-shadow"];
            break;
          case "breakPoint2":
            boxShadow = frame_style["box-shadow"] || thecssSM[INPUTER1.value]["box-shadow"];
            break;
          case "breakPoint3":
            boxShadow = frame_style["box-shadow"] || thecssXS[INPUTER1.value]["box-shadow"];
            break;
        }

        if (boxShadow) {
          getShadowsAll(boxShadow);
          shad1 = "";
          if (shadowsArray[0]) {
            shad1 = {
              red: shadowsArray[0].color.red,
              green: shadowsArray[0].color.green,
              blue: shadowsArray[0].color.blue,
              alpha: roundNumber(shadowsArray[0].color.alpha, 2),
              hShadow: shadowsArray[0].hShadow,
              vShadow: shadowsArray[0].vShadow,
              blur: shadowsArray[0].blur,
              spread: shadowsArray[0].spread,
              inset: shadowsArray[0].inset || ""
            };
          }
          shad2 = "";
          if (shadowsArray[1]) {
            shad2 = {
              red: shadowsArray[1].color.red,
              green: shadowsArray[1].color.green,
              blue: shadowsArray[1].color.blue,
              alpha: roundNumber(shadowsArray[1].color.alpha, 2),
              hShadow: shadowsArray[1].hShadow,
              vShadow: shadowsArray[1].vShadow,
              blur: shadowsArray[1].blur,
              spread: shadowsArray[1].spread,
              inset: shadowsArray[1].inset || ""
            };
          }
          shad3 = "";
          if (shadowsArray[2]) {
            shad3 = {
              red: shadowsArray[2].color.red,
              green: shadowsArray[2].color.green,
              blue: shadowsArray[2].color.blue,
              alpha: roundNumber(shadowsArray[2].color.alpha, 2),
              hShadow: shadowsArray[2].hShadow,
              vShadow: shadowsArray[2].vShadow,
              blur: shadowsArray[2].blur,
              spread: shadowsArray[2].spread,
              inset: shadowsArray[2].inset || ""
            };
          }
          shad4 = "";
          if (shadowsArray[3]) {
            shad4 = {
              red: shadowsArray[3].color.red,
              green: shadowsArray[3].color.green,
              blue: shadowsArray[3].color.blue,
              alpha: roundNumber(shadowsArray[3].color.alpha, 2),
              hShadow: shadowsArray[3].hShadow,
              vShadow: shadowsArray[3].vShadow,
              blur: shadowsArray[3].blur,
              spread: shadowsArray[3].spread,
              inset: shadowsArray[3].inset || ""
            };
          }
          currentShad1.style = buttonBGColor;
          currentShad2.style = buttonBGColor;
          currentShad3.style = buttonBGColor;
          currentShad4.style = buttonBGColor;
          switch (currentShadSelection) {
            case 1:
              currentShad = shad1;
              currentShad1.style = buttonHLColor;
              break;
            case 2:
              currentShad = shad2;
              currentShad2.style = buttonHLColor;
              break;
            case 3:
              currentShad = shad3;
              currentShad3.style = buttonHLColor;
              break;
            case 4:
              currentShad = shad4;
              currentShad4.style = buttonHLColor;
              break;
          }
        }
        if (frame_style["box-shadow"] || CSSstyles["box-shadow"]) {
          var shadowColor_for_picker = 'rgba(' + currentShad.red + ', ' + currentShad.green + ', ' + currentShad.blue + ', ' + currentShad.alpha + ')';
          colorinput_box_shadow.style.background = shadowColor_for_picker;
          colorinput_box_shadow_picker.source.value = set_color_for_picker(shadowColor_for_picker);
          box_shadow_color_triangle.style.fill = color2NoAlpha(shadowColor_for_picker);

          domID('box-shadow-color_value').innerText = shadowColor_for_picker.replace(/ /g, '').replace('rgba(', '').replace(')', '');
          boxShadowHShadowValue.textContent = currentShad.hShadow;
          boxShadowVShadowValue.textContent = currentShad.vShadow;
          boxShadowBlurValue.textContent = currentShad.blur;
          boxShadowSpreadValue.textContent = currentShad.spread;
          if (currentShad.inset !== "inset") {
            boxShadowInset.removeAttribute('style');
          } else {
            boxShadowInset.style = "color: var(--mainColor)";
          }
          redShadValue.textContent = currentShad.red;
          redShad.value = currentShad.red;
          greenShadValue.textContent = currentShad.green;
          greenShad.value = currentShad.green;
          blueShadValue.textContent = currentShad.blue;
          blueShad.value = currentShad.blue;
          alphaShadValue.textContent = currentShad.alpha;
          alphaShad.value = (currentShad.alpha * 100).toString();
        }
      } else {
        domID('box-shadow-color_value').innerText = "";
        currentShad1.style = buttonBGColor;
        currentShad2.style = buttonBGColor;
        currentShad3.style = buttonBGColor;
        currentShad4.style = buttonBGColor;
        colorinput_box_shadow.style.background = null;
        colorinput_box_shadow_picker.source.value = null;
        box_shadow_color_triangle.style.fill = null;

        boxShadowHShadowValue.textContent = "";
        boxShadowVShadowValue.textContent = "";
        boxShadowBlurValue.textContent = "";
        boxShadowSpreadValue.textContent = "";
        boxShadowInset.removeAttribute('style');
        redShadValue.textContent = "";
        redShad.value = null;
        greenShadValue.textContent = "";
        greenShad.value = null;
        blueShadValue.textContent = "";
        blueShad.value = null;
        alphaShadValue.textContent = "";
        alphaShad.value = null;
      }
    }
  }
  plusMinusBtnMakerBoxShadow(
    "box-shadow-hShadow-up",
    "plus",
    "box-shadow-hShadow_value"
  );
  plusMinusBtnMakerBoxShadow(
    "box-shadow-hShadow-down",
    "minus",
    "box-shadow-hShadow_value"
  );
  plusMinusBtnMakerBoxShadow(
    "box-shadow-vShadow-up",
    "plus",
    "box-shadow-vShadow_value"
  );
  plusMinusBtnMakerBoxShadow(
    "box-shadow-vShadow-down",
    "minus",
    "box-shadow-vShadow_value"
  );
  plusMinusBtnMakerBoxShadow(
    "box-shadow-blur-up",
    "plus",
    "box-shadow-blur_value"
  );
  plusMinusBtnMakerBoxShadow(
    "box-shadow-blur-down",
    "minus",
    "box-shadow-blur_value"
  );
  plusMinusBtnMakerBoxShadow(
    "box-shadow-spread-up",
    "plus",
    "box-shadow-spread_value"
  );
  plusMinusBtnMakerBoxShadow(
    "box-shadow-spread-down",
    "minus",
    "box-shadow-spread_value"
  );

  function plusMinusBtnMakerBoxShadow(Id, PlusOrMinus, ID) {
    var btn = domID(Id);
    var timepressed;
    var deleypress;
    var forInput3;
    btn.onmousedown = function () {
      if (!INPUTER1.value) {
        return false;
      }
      var theShadowValue = Number(
        domID(ID).innerHTML.replace(theValREGEX, "")
      );
      forInput3 = boxShadowAdder(forInput3);
      var theShadColors =
        "rgba(" +
        currentShad.red +
        ", " +
        currentShad.green +
        ", " +
        currentShad.blue +
        ", " +
        currentShad.alpha +
        ") ";
      var theShadInset = currentShad.inset;
      createBoxShadowIfNone();

      function incPlusOrMinus() {
        switch (PlusOrMinus) {
          case "plus":
            theShadowValue++;
            break;
          case "minus":
            theShadowValue--;
            break;
        }
      }

      function incPlusOrMinusNotLessThan0() {
        switch (PlusOrMinus) {
          case "plus":
            theShadowValue++;
            break;
          case "minus":
            if (theShadowValue >= 1) {
              theShadowValue--;
            }
            break;
        }
      }

      function boxShadowMaker() {
        switch (ID) {
          case "box-shadow-hShadow_value":
            incPlusOrMinus();
            forInput3 =
              theShadColors +
              theShadowValue +
              "px " +
              currentShad.vShadow +
              " " +
              currentShad.blur +
              " " +
              currentShad.spread +
              " " +
              theShadInset;
            break;
          case "box-shadow-vShadow_value":
            incPlusOrMinus();
            forInput3 =
              theShadColors +
              currentShad.hShadow +
              " " +
              theShadowValue +
              "px " +
              currentShad.blur +
              " " +
              currentShad.spread +
              " " +
              theShadInset;
            break;
          case "box-shadow-blur_value":
            incPlusOrMinusNotLessThan0();
            forInput3 =
              theShadColors +
              currentShad.hShadow +
              " " +
              currentShad.vShadow +
              " " +
              theShadowValue +
              "px " +
              currentShad.spread +
              " " +
              theShadInset;
            break;
          case "box-shadow-spread_value":
            incPlusOrMinus();
            forInput3 =
              theShadColors +
              currentShad.hShadow +
              " " +
              currentShad.vShadow +
              " " +
              currentShad.blur +
              " " +
              theShadowValue +
              "px " +
              theShadInset;
            break;
        }
      }

      function iter() {
        timepressed = setInterval(function () {
          INPUTER2.value = "box-shadow";
          boxShadowMaker();
          INPUTER3.value = boxShadowAdder(forInput3);
          clickAdder(null);
          domID(ID).textContent = theShadowValue + "px ";
        }, 20);
        return false;
      }
      if (INPUTER1.value) {
        deleypress = setTimeout(iter, 200);
        INPUTER2.value = "box-shadow";
        boxShadowMaker();
        INPUTER3.value = boxShadowAdder(forInput3);
        clickAdder(null);
        domID(ID).textContent = theShadowValue + "px ";
        // stops iter and timepressed functions
        btn.onmouseup = clearIter;
        btn.onmouseleave = clearIter;
      } // Increments on holding mousedown ends here.
      function clearIter() {
        clearInterval(timepressed);
        clearTimeout(deleypress);
        refreshShadowValues();
        return false;
      }
    };
  }

  function boxShadowAdder(forInput3) {
    var fullShad1 =
      "rgba(" +
      shad1.red +
      ", " +
      shad1.green +
      ", " +
      shad1.blue +
      ", " +
      shad1.alpha +
      ") " +
      shad1.hShadow +
      " " +
      shad1.vShadow +
      " " +
      shad1.blur +
      " " +
      shad1.spread +
      " " +
      shad1.inset;
    var fullShad2 =
      "rgba(" +
      shad2.red +
      ", " +
      shad2.green +
      ", " +
      shad2.blue +
      ", " +
      shad2.alpha +
      ") " +
      shad2.hShadow +
      " " +
      shad2.vShadow +
      " " +
      shad2.blur +
      " " +
      shad2.spread +
      " " +
      shad2.inset;
    var fullShad3 =
      "rgba(" +
      shad3.red +
      ", " +
      shad3.green +
      ", " +
      shad3.blue +
      ", " +
      shad3.alpha +
      ") " +
      shad3.hShadow +
      " " +
      shad3.vShadow +
      " " +
      shad3.blur +
      " " +
      shad3.spread +
      " " +
      shad3.inset;
    var fullShad4 =
      "rgba(" +
      shad4.red +
      ", " +
      shad4.green +
      ", " +
      shad4.blue +
      ", " +
      shad4.alpha +
      ") " +
      shad4.hShadow +
      " " +
      shad4.vShadow +
      " " +
      shad4.blur +
      " " +
      shad4.spread +
      " " +
      shad4.inset;
    var thecase;
    switch (currentShadSelection) {
      case 1:
        thecase =
          forInput3 +
          ", " +
          fullShad2 +
          ", " +
          fullShad3 +
          ", " +
          fullShad4;
        break;
      case 2:
        thecase =
          fullShad1 +
          ", " +
          forInput3 +
          ", " +
          fullShad3 +
          ", " +
          fullShad4;
        break;
      case 3:
        thecase =
          fullShad1 +
          ", " +
          fullShad2 +
          ", " +
          forInput3 +
          ", " +
          fullShad4;
        break;
      case 4:
        thecase =
          fullShad1 +
          ", " +
          fullShad2 +
          ", " +
          fullShad3 +
          ", " +
          forInput3;
        break;
    }
    // inputer3.value = thecase;
    return thecase;
  }
  domEvent(boxShadowInset, "mousedown", function () {
    shadowInset();
  });

  function shadowInset() {
    if (INPUTER1.value) {
      var forInput3 = "";
      createBoxShadowIfNone();
      if (currentShad.inset !== "inset") {
        INPUTER2.value = "box-shadow";
        forInput3 =
          "rgba(" +
          currentShad.red +
          ", " +
          currentShad.green +
          ", " +
          currentShad.blue +
          ", " +
          currentShad.alpha +
          ") " +
          currentShad.hShadow +
          " " +
          currentShad.vShadow +
          " " +
          currentShad.blur +
          " " +
          currentShad.spread +
          " " +
          "inset";
      } else {
        INPUTER2.value = "box-shadow";
        forInput3 =
          "rgba(" +
          currentShad.red +
          ", " +
          currentShad.green +
          ", " +
          currentShad.blue +
          ", " +
          currentShad.alpha +
          ") " +
          currentShad.hShadow +
          " " +
          currentShad.vShadow +
          " " +
          currentShad.blur +
          " " +
          currentShad.spread +
          "" +
          "";
      }
      INPUTER3.value = boxShadowAdder(forInput3);
      clickAdder(null);
      selectElement(frameID(domElement[0]));
    }
  }
  // Box Shadow colors
  redShad.oninput = function () {
    createBoxShadowIfNone();
    redShadcolorFunction();
    clickAdder(null);
    refreshShadowValues();
  };
  greenShad.oninput = function () {
    createBoxShadowIfNone();
    greenShadcolorFunction();
    clickAdder(null);
    refreshShadowValues();
  };
  blueShad.oninput = function () {
    createBoxShadowIfNone();
    blueShadcolorFunction();
    clickAdder(null);
    refreshShadowValues();
  };
  alphaShad.oninput = function () {
    createBoxShadowIfNone();
    alphaShadVal = alphaShad.value;
    alphaShadVal /= Math.pow(10, 2);
    alphaShadcolorFunction();
    clickAdder(null);
    refreshShadowValues();
  };
  var alphaShadVal;

  function redShadcolorFunction() {
    if (INPUTER1.value) {
      var forInput3 = "";
      INPUTER2.value = "box-shadow";
      forInput3 =
        "rgba(" +
        redShad.value +
        ", " +
        currentShad.green +
        ", " +
        currentShad.blue +
        ", " +
        currentShad.alpha +
        ") " +
        currentShad.hShadow +
        " " +
        currentShad.vShadow +
        " " +
        currentShad.blur +
        " " +
        currentShad.spread +
        " " +
        currentShad.inset;
      INPUTER3.value = boxShadowAdder(forInput3);
      redShadValue.textContent = redShad.value;
    }
  }

  function greenShadcolorFunction() {
    if (INPUTER1.value) {
      var forInput3 = "";
      INPUTER2.value = "box-shadow";
      forInput3 =
        "rgba(" +
        currentShad.red +
        ", " +
        greenShad.value +
        ", " +
        currentShad.blue +
        ", " +
        currentShad.alpha +
        ") " +
        currentShad.hShadow +
        " " +
        currentShad.vShadow +
        " " +
        currentShad.blur +
        " " +
        currentShad.spread +
        " " +
        currentShad.inset;
      INPUTER3.value = boxShadowAdder(forInput3);
      greenShadValue.textContent = greenShad.value;
    }
  }

  function blueShadcolorFunction() {
    if (INPUTER1.value) {
      var forInput3 = "";
      INPUTER2.value = "box-shadow";
      forInput3 =
        "rgba(" +
        currentShad.red +
        ", " +
        currentShad.green +
        ", " +
        blueShad.value +
        ", " +
        currentShad.alpha +
        ") " +
        currentShad.hShadow +
        " " +
        currentShad.vShadow +
        " " +
        currentShad.blur +
        " " +
        currentShad.spread +
        " " +
        currentShad.inset;
      INPUTER3.value = boxShadowAdder(forInput3);
      blueShadValue.textContent = blueShad.value;
    }
  }

  function alphaShadcolorFunction() {
    if (INPUTER1.value) {
      var forInput3 = "";
      INPUTER2.value = "box-shadow";
      forInput3 =
        "rgba(" +
        currentShad.red +
        ", " +
        currentShad.green +
        ", " +
        currentShad.blue +
        ", " +
        alphaShadVal +
        ") " +
        currentShad.hShadow +
        " " +
        currentShad.vShadow +
        " " +
        currentShad.blur +
        " " +
        currentShad.spread +
        " " +
        currentShad.inset;
      INPUTER3.value = boxShadowAdder(forInput3);
      alphaShadValue.textContent = alphaShadVal;
    }
  }
  // End of box shadows
  // ---------------------------------------------------
  // ---------------------------------------------------
  // Text Shadows
  var shadowsArrayText;
  var shad1Text;
  var shad2Text;
  var shad3Text;
  var shad4Text;
  var currentShadSelectionText = 1;
  var currentShadText;
  domEvent(currentShad1Text, "mousedown", function () {
    createTextShadowIfNone();
    currentShadSelectionText = 1;
    INPUTER3.value = "";
    refreshTextShadowValues();
  });
  domEvent(currentShad2Text, "mousedown", function () {
    createTextShadowIfNone();
    currentShadSelectionText = 2;
    INPUTER3.value = "";
    refreshTextShadowValues();
  });
  domEvent(currentShad3Text, "mousedown", function () {
    createTextShadowIfNone();
    currentShadSelectionText = 3;
    INPUTER3.value = "";
    refreshTextShadowValues();
  });
  domEvent(currentShad4Text, "mousedown", function () {
    createTextShadowIfNone();
    currentShadSelectionText = 4;
    INPUTER3.value = "";
    refreshTextShadowValues();
  });

  function createTextShadowIfNone() {
    if (CSSstyles["text-shadow"]) {} else {
      var input1 = INPUTER1.value;
      var textShadDefaults =
        "rgba(0, 0, 0, 1) 0px 0px 0px, " +
        "rgba(0, 0, 0, 0) 0px 0px 0px, " +
        "rgba(0, 0, 0, 0) 0px 0px 0px, " +
        "rgba(0, 0, 0, 0) 0px 0px 0px ";
      switch (breakPoint) {
        case "fullWidth":
          put("text-shadow", textShadDefaults, thecssLG[input1]);
          break;
        case "breakPoint1":
          put("text-shadow", textShadDefaults, thecssMD[input1]);
          break;
        case "breakPoint2":
          put("text-shadow", textShadDefaults, thecssSM[input1]);
          break;
        case "breakPoint3":
          put("text-shadow", textShadDefaults, thecssXS[input1]);
          break;
      }
      selectElement(frameID(domElement[0]));
    }
  }

  function getTextShadowsAll(shads) {
    shadowsArrayText = [];
    var array = shads.split(", rgb");

    function Shadow(theShadow) {
      var shadBits = theShadow.split(") "),
        color = getColorValues(shadBits[0] + ")"),
        lengths = shadBits[1].split(" "),
        shadowLengths = {
          color: color,
          hShadow: lengths[0],
          vShadow: lengths[1],
          blur: lengths[2] // Reads as last property.
        };
      shadowsArrayText.push(shadowLengths);
    }
    for (var i = 0; i < array.length; i++) {
      if (i !== 0) {
        array[i] = "rgb" + array[i];
      }
      Shadow(array[i]);
    }
  }

  function refreshTextShadowValues() {
    if (INPUTER1.value) {
      if (CSSstyles["text-shadow"]) {
        var textShadow = "";
        switch (breakPoint) {
          case "fullWidth":
            textShadow = thecssLG[INPUTER1.value]["text-shadow"];
            break;
          case "breakPoint1":
            textShadow = thecssMD[INPUTER1.value]["text-shadow"];
            break;
          case "breakPoint2":
            textShadow = thecssSM[INPUTER1.value]["text-shadow"];
            break;
          case "breakPoint3":
            textShadow = thecssXS[INPUTER1.value]["text-shadow"];
            break;
        }
        if (textShadow) {
          getTextShadowsAll(textShadow);
          shad1Text = "";
          if (shadowsArrayText[0]) {
            shad1Text = {
              red: shadowsArrayText[0].color.red,
              green: shadowsArrayText[0].color.green,
              blue: shadowsArrayText[0].color.blue,
              alpha: roundNumber(
                shadowsArrayText[0].color.alpha,
                2
              ),
              hShadow: shadowsArrayText[0].hShadow,
              vShadow: shadowsArrayText[0].vShadow,
              blur: shadowsArrayText[0].blur || ""
            };
          }
          shad2Text = "";
          if (shadowsArrayText[1]) {
            shad2Text = {
              red: shadowsArrayText[1].color.red,
              green: shadowsArrayText[1].color.green,
              blue: shadowsArrayText[1].color.blue,
              alpha: roundNumber(
                shadowsArrayText[1].color.alpha,
                2
              ),
              hShadow: shadowsArrayText[1].hShadow,
              vShadow: shadowsArrayText[1].vShadow,
              blur: shadowsArrayText[1].blur || ""
            };
          }
          shad3Text = "";
          if (shadowsArrayText[2]) {
            shad3Text = {
              red: shadowsArrayText[2].color.red,
              green: shadowsArrayText[2].color.green,
              blue: shadowsArrayText[2].color.blue,
              alpha: roundNumber(
                shadowsArrayText[2].color.alpha,
                2
              ),
              hShadow: shadowsArrayText[2].hShadow,
              vShadow: shadowsArrayText[2].vShadow,
              blur: shadowsArrayText[2].blur || ""
            };
          }
          shad4Text = "";
          if (shadowsArrayText[3]) {
            shad4Text = {
              red: shadowsArrayText[3].color.red,
              green: shadowsArrayText[3].color.green,
              blue: shadowsArrayText[3].color.blue,
              alpha: roundNumber(
                shadowsArrayText[3].color.alpha,
                2
              ),
              hShadow: shadowsArrayText[3].hShadow,
              vShadow: shadowsArrayText[3].vShadow,
              blur: shadowsArrayText[3].blur || ""
            };
          }
          currentShad1Text.style = buttonBGColor;
          currentShad2Text.style = buttonBGColor;
          currentShad3Text.style = buttonBGColor;
          currentShad4Text.style = buttonBGColor;
          switch (currentShadSelectionText) {
            case 1:
              currentShadText = shad1Text;
              currentShad1Text.style = buttonHLColor;
              break;
            case 2:
              currentShadText = shad2Text;
              currentShad2Text.style = buttonHLColor;
              break;
            case 3:
              currentShadText = shad3Text;
              currentShad3Text.style = buttonHLColor;
              break;
            case 4:
              currentShadText = shad4Text;
              currentShad4Text.style = buttonHLColor;
              break;
          }
        }
        if (CSSstyles["text-shadow"]) {
          var shadowColor_for_picker = 'rgba(' + currentShadText.red + ', ' + currentShadText.green + ', ' + currentShadText.blue + ', ' + currentShadText.alpha + ')';
          colorinput_text_shadow.style.background = shadowColor_for_picker;
          colorinput_text_shadow_picker.source.value = set_color_for_picker(shadowColor_for_picker);
          text_shadow_color_triangle.style.fill = color2NoAlpha(shadowColor_for_picker);
          domID('text-shadow-color_value').innerText = shadowColor_for_picker.replace(/ /g, '').replace('rgba(', '').replace(')', '');
          TextShadowHShadowValue.textContent = currentShadText.hShadow;
          TextShadowVShadowValue.textContent = currentShadText.vShadow;
          TextShadowBlurValue.textContent = currentShadText.blur;
          redShadTextValue.textContent = currentShadText.red;
          redShadText.value = currentShadText.red;
          greenShadTextValue.textContent = currentShadText.green;
          greenShadText.value = currentShadText.green;
          blueShadTextValue.textContent = currentShadText.blue;
          blueShadText.value = currentShadText.blue;
          alphaShadTextValue.textContent = currentShadText.alpha;
          alphaShadText.value = (
            currentShadText.alpha * 100
          ).toString();
        }
      } else {
        domID('text-shadow-color_value').innerText = "";
        currentShad1Text.style = buttonBGColor;
        currentShad2Text.style = buttonBGColor;
        currentShad3Text.style = buttonBGColor;
        currentShad4Text.style = buttonBGColor;
        colorinput_text_shadow.style.background = null;
        colorinput_text_shadow_picker.source.value = null;
        text_shadow_color_triangle.style.fill = null;
        TextShadowHShadowValue.textContent = "";
        TextShadowVShadowValue.textContent = "";
        TextShadowBlurValue.textContent = "";
        redShadTextValue.textContent = "";
        redShadText.value = null;
        greenShadTextValue.textContent = "";
        greenShadText.value = null;
        blueShadTextValue.textContent = "";
        blueShadText.value = null;
        alphaShadTextValue.textContent = "";
        alphaShadText.value = null;
      }
    }
  }
  plusMinusBtnMakerTextShadow(
    "text-shadow-hShadow-up",
    "plus",
    "text-shadow-hShadow_value"
  );
  plusMinusBtnMakerTextShadow(
    "text-shadow-hShadow-down",
    "minus",
    "text-shadow-hShadow_value"
  );
  plusMinusBtnMakerTextShadow(
    "text-shadow-vShadow-up",
    "plus",
    "text-shadow-vShadow_value"
  );
  plusMinusBtnMakerTextShadow(
    "text-shadow-vShadow-down",
    "minus",
    "text-shadow-vShadow_value"
  );
  plusMinusBtnMakerTextShadow(
    "text-shadow-blur-up",
    "plus",
    "text-shadow-blur_value"
  );
  plusMinusBtnMakerTextShadow(
    "text-shadow-blur-down",
    "minus",
    "text-shadow-blur_value"
  );

  function plusMinusBtnMakerTextShadow(Id, PlusOrMinus, ID) {
    var btn = domID(Id);
    var timepressed;
    var deleypress;
    btn.onmousedown = function () {
      var theShadowValue = Number(
        domID(ID).innerHTML.replace(theValREGEX, "")
      );
      var forInput3;
      var theShadColors =
        "rgba(" +
        currentShadText.red +
        ", " +
        currentShadText.green +
        ", " +
        currentShadText.blue +
        ", " +
        currentShadText.alpha +
        ") ";
      createTextShadowIfNone();

      function incTextPlusOrMinus() {
        switch (PlusOrMinus) {
          case "plus":
            theShadowValue++;
            break;
          case "minus":
            theShadowValue--;
            break;
        }
      }

      function incTextPlusOrMinusNotLessThan0() {
        switch (PlusOrMinus) {
          case "plus":
            theShadowValue++;
            break;
          case "minus":
            if (theShadowValue >= 1) {
              theShadowValue--;
            }
            break;
        }
      }

      function textShadowMaker() {
        switch (ID) {
          case "text-shadow-hShadow_value":
            incTextPlusOrMinus();
            forInput3 =
              theShadColors +
              theShadowValue +
              "px " +
              currentShadText.vShadow +
              " " +
              currentShadText.blur;
            break;
          case "text-shadow-vShadow_value":
            incTextPlusOrMinus();
            forInput3 =
              theShadColors +
              currentShadText.hShadow +
              " " +
              theShadowValue +
              "px " +
              currentShadText.blur;
            break;
          case "text-shadow-blur_value":
            incTextPlusOrMinusNotLessThan0();
            forInput3 =
              theShadColors +
              currentShadText.hShadow +
              " " +
              currentShadText.vShadow +
              " " +
              theShadowValue +
              "px ";
            break;
        }
      }

      function iter() {
        timepressed = setInterval(function () {
          INPUTER2.value = "text-shadow";
          textShadowMaker();
          INPUTER3.value = textShadowAdder(forInput3);
          clickAdder(null);
          domID(ID).textContent = theShadowValue + "px ";
        }, 20);
        return false;
      }
      if (INPUTER1.value) {
        deleypress = setTimeout(iter, 200);
        INPUTER2.value = "text-shadow";
        textShadowMaker();
        INPUTER3.value = textShadowAdder(forInput3);
        clickAdder(null);
        domID(ID).textContent = theShadowValue + "px ";
        // stops iter and timepressed functions
        btn.onmouseup = clearIter;
        btn.onmouseleave = clearIter;
      } // Increments on holding mousedown ends here.
      function clearIter() {
        clearInterval(timepressed);
        clearTimeout(deleypress);
        refreshTextShadowValues();
        return false;
      }
    };
  }

  function textShadowAdder(forInput3) {
    var fullShad1 =
      "rgba(" +
      shad1Text.red +
      ", " +
      shad1Text.green +
      ", " +
      shad1Text.blue +
      ", " +
      shad1Text.alpha +
      ") " +
      shad1Text.hShadow +
      " " +
      shad1Text.vShadow +
      " " +
      shad1Text.blur;
    var fullShad2 =
      "rgba(" +
      shad2Text.red +
      ", " +
      shad2Text.green +
      ", " +
      shad2Text.blue +
      ", " +
      shad2Text.alpha +
      ") " +
      shad2Text.hShadow +
      " " +
      shad2Text.vShadow +
      " " +
      shad2Text.blur;
    var fullShad3 =
      "rgba(" +
      shad3Text.red +
      ", " +
      shad3Text.green +
      ", " +
      shad3Text.blue +
      ", " +
      shad3Text.alpha +
      ") " +
      shad3Text.hShadow +
      " " +
      shad3Text.vShadow +
      " " +
      shad3Text.blur;
    var fullShad4 =
      "rgba(" +
      shad4Text.red +
      ", " +
      shad4Text.green +
      ", " +
      shad4Text.blue +
      ", " +
      shad4Text.alpha +
      ") " +
      shad4Text.hShadow +
      " " +
      shad4Text.vShadow +
      " " +
      shad4Text.blur;
    var thecase;
    switch (currentShadSelectionText) {
      case 1:
        thecase =
          forInput3 +
          ", " +
          fullShad2 +
          ", " +
          fullShad3 +
          ", " +
          fullShad4;
        break;
      case 2:
        thecase =
          fullShad1 +
          ", " +
          forInput3 +
          ", " +
          fullShad3 +
          ", " +
          fullShad4;
        break;
      case 3:
        thecase =
          fullShad1 +
          ", " +
          fullShad2 +
          ", " +
          forInput3 +
          ", " +
          fullShad4;
        break;
      case 4:
        thecase =
          fullShad1 +
          ", " +
          fullShad2 +
          ", " +
          fullShad3 +
          ", " +
          forInput3;
        break;
    }
    return thecase;
    // clickAdder(null);
  }
  // Text Shadow colors
  redShadText.oninput = function () {
    createTextShadowIfNone();
    redShadTextcolorFunction();
    clickAdder(null);
    refreshTextShadowValues();
  };
  greenShadText.oninput = function () {
    createTextShadowIfNone();
    greenShadTextcolorFunction();
    clickAdder(null);
    refreshTextShadowValues();
  };
  blueShadText.oninput = function () {
    createTextShadowIfNone();
    blueShadTextcolorFunction();
    clickAdder(null);
    refreshTextShadowValues();
  };
  alphaShadText.oninput = function () {
    createTextShadowIfNone();
    alphaShadTextVal = alphaShadText.value;
    alphaShadTextVal /= Math.pow(10, 2);
    alphaShadTextcolorFunction();
    clickAdder(null);
    refreshTextShadowValues();
  };
  var alphaShadTextVal;

  function redShadTextcolorFunction() {
    if (INPUTER1.value) {
      var forInput3 = "";
      INPUTER2.value = "text-shadow";
      forInput3 =
        "rgba(" +
        redShadText.value +
        ", " +
        currentShadText.green +
        ", " +
        currentShadText.blue +
        ", " +
        currentShadText.alpha +
        ") " +
        currentShadText.hShadow +
        " " +
        currentShadText.vShadow +
        " " +
        currentShadText.blur;
      INPUTER3.value = textShadowAdder(forInput3);
      redShadTextValue.textContent = redShadText.value;
    }
  }

  function greenShadTextcolorFunction() {
    if (INPUTER1.value) {
      var forInput3 = "";
      INPUTER2.value = "text-shadow";
      forInput3 =
        "rgba(" +
        currentShadText.red +
        ", " +
        greenShadText.value +
        ", " +
        currentShadText.blue +
        ", " +
        currentShadText.alpha +
        ") " +
        currentShadText.hShadow +
        " " +
        currentShadText.vShadow +
        " " +
        currentShadText.blur;
      INPUTER3.value = textShadowAdder(forInput3);
      greenShadTextValue.textContent = greenShadText.value;
    }
  }

  function blueShadTextcolorFunction() {
    if (INPUTER1.value) {
      var forInput3 = "";
      INPUTER2.value = "text-shadow";
      forInput3 =
        "rgba(" +
        currentShadText.red +
        ", " +
        currentShadText.green +
        ", " +
        blueShadText.value +
        ", " +
        currentShadText.alpha +
        ") " +
        currentShadText.hShadow +
        " " +
        currentShadText.vShadow +
        " " +
        currentShadText.blur;
      INPUTER3.value = textShadowAdder(forInput3);
      blueShadTextValue.textContent = blueShadText.value;
    }
  }

  function alphaShadTextcolorFunction() {
    if (INPUTER1.value) {
      var forInput3 = "";
      INPUTER2.value = "text-shadow";
      forInput3 =
        "rgba(" +
        currentShadText.red +
        ", " +
        currentShadText.green +
        ", " +
        currentShadText.blue +
        ", " +
        alphaShadTextVal +
        ") " +
        currentShadText.hShadow +
        " " +
        currentShadText.vShadow +
        " " +
        currentShadText.blur;
      INPUTER3.value = textShadowAdder(forInput3);
      alphaShadTextValue.textContent = alphaShadTextVal;
    }
  }
  // ---------------------------------------------------
  // ---------------------------------------------------
  // TODO;
  // Transitions
  domEvent(domID("box-shadow-transition-add"), "mousedown", addTransition);

  function addTransition() {
    if (INPUTER1.value) {
      INPUTER2.value = "transition";
      // [transition-property] [duration] [timing-function] [delay]
      INPUTER3.value = "all 0.5s ease";
      clickAdder(null);
    }
  }
  domEvent(
    domID("box-shadow-transition-remove"),
    "mousedown",
    removeTransition
  );

  function removeTransition() {
    if (INPUTER1.value) {
      INPUTER2.value = "transition";
      clickRemoveProp(false);
    }
  }

  // ---------------------------------------------------
  // ---------------------------------------------------
  // Buttons to show Panels
  // sets heights and closes all the tab buttons
  function CSSDone() {
    setTimeout(function () {
      setTheHeightsForTheTabButtons();
      domForQuery(".sectionInnerWrap", function (el) {
        el.style = "height: 0px";
      });

      unblockIframe();

      var css_active_btn;
      var pages_active_btn;
      var structure_active_btn;
      var components_active_btn;
      var element_active_btn;
      var images_active_btn;

      if (window.localStorage.getItem('active-tab-css')) {
        css_active_btn = window.localStorage.getItem('active-tab-css');
        simulateMouseEvent(domID(css_active_btn), "mousedown");
        domID(css_active_btn).scrollIntoView({
          behavior: "auto",
          block: "start",
          inline: "center"
        });
      }

      if (window.localStorage.getItem('active-tab-pages')) {
        pages_active_btn = window.localStorage.getItem('active-tab-pages');
        simulateMouseEvent(domID(pages_active_btn), "mousedown");
      }

      if (window.localStorage.getItem('active-tab-structure')) {
        structure_active_btn = window.localStorage.getItem('active-tab-structure');
        simulateMouseEvent(domID(structure_active_btn), "mousedown");
      }

      if (window.localStorage.getItem('active-tab-components')) {
        components_active_btn = window.localStorage.getItem('active-tab-components');
        simulateMouseEvent(domID(components_active_btn), "mousedown");
      }

      if (window.localStorage.getItem('active-tab-element')) {
        element_active_btn = window.localStorage.getItem('active-tab-element');
        simulateMouseEvent(domID(element_active_btn), "mousedown");
      }
      if (window.localStorage.getItem('active-tab-images')) {
        images_active_btn = window.localStorage.getItem('active-tab-images');
        simulateMouseEvent(domID(images_active_btn), "mousedown");
      }

    }, 200);
  }

  function setTheHeightsForTheTabButtons() {
    showAndHideGUIPanels("customPropertyButton", "customProperty");
    showAndHideGUIPanels("colorsButton", "colors");
    showAndHideGUIPanels("positionButton", "position");
    showAndHideGUIPanels("displayButton", "display");
    showAndHideGUIPanels("flexboxButton", "flexbox");
    showAndHideGUIPanels("gridButton", "grid");
    showAndHideGUIPanels("floatButton", "float");
    showAndHideGUIPanels("stackButton", "stack");
    showAndHideGUIPanels("cursorButton", "cursor");
    showAndHideGUIPanels("overflowButton", "overflow");
    showAndHideGUIPanels("spacingButton", "spacing");
    showAndHideGUIPanels("sizeButton", "size");
    showAndHideGUIPanels("fontsButton", "fonts");
    showAndHideGUIPanels("textButton", "text");
    showAndHideGUIPanels("listButton", "list");
    showAndHideGUIPanels("bordersButton", "borders");
    showAndHideGUIPanels("outlineButton", "outline");
    showAndHideGUIPanels("backgroundButton", "background");
    showAndHideGUIPanels("gradientButton", "gradient");
    showAndHideGUIPanels("filtersButton", "filter");
    showAndHideGUIPanels("shadowsButton", "shadows");
    showAndHideGUIPanels("shadowsButtonText", "shadowsText");
    showAndHideGUIPanels("transformButton", "transform");
    showAndHideGUIPanels_HTML("elementsButton", "elements", "active-tab-element", true);
    showAndHideGUIPanels_HTML("imagesButton", "images", "active-tab-images", true);
    showAndHideGUIPanels_HTML("pagesButton", "pages", "active-tab-pages");
    showAndHideGUIPanels_HTML("structureButton", "structure", "active-tab-structure");
    showAndHideGUIPanels_HTML("componentsButton", "components", "active-tab-components");

    document.querySelectorAll(".tab-button").forEach(function (el) {
      el.removeEventListener("mousedown", setTheHeightsForTheTabButtons);
    });
  }

  function showAndHideGUIPanels(button, div) {
    domEvent(domID(button), "mousedown", function () {
      domForQuery(".sectionInnerWrap.sectionInnerWrap_CSS", function (el) {
        el.style = "height: 0px";
        el.parentElement.classList.remove('active-tab');
      });
      var theDiv = domID(div);
      var style = window.getComputedStyle(theDiv);
      var height = style.getPropertyValue("height");
      if (height === "0px") {
        theDiv.style.height = '100%';
        theDiv.parentElement.classList.add('active-tab');
        window.localStorage.setItem('active-tab-css', button);
      } else {
        theDiv.style.height = "0px";
        theDiv.parentElement.classList.remove('active-tab');
        window.localStorage.setItem('active-tab-css', '');
      }
      FillValueReadouts();
      if (
        button === 'sizeButton' ||
        button === 'spacingButton' ||
        button === 'bordersButton'
      ) {
        iframeElementSelect.setAttribute('box-edit', button);
      }

    });
  }

  function showAndHideGUIPanels_HTML(button, div, activetab, scroll) {
    domEvent(domID(button), "mousedown", function () {
      var theDiv = domID(div);
      var style = window.getComputedStyle(theDiv);
      var height = style.getPropertyValue("height");
      if (height === "0px") {
        theDiv.style.height = '100%';
        theDiv.parentElement.classList.add('active-tab');
        window.localStorage.setItem(activetab, button);
      } else {
        theDiv.style.height = "0px";
        theDiv.parentElement.classList.remove('active-tab');
        window.localStorage.setItem(activetab, '');
      }
    });

    domEvent(domID(button), "click", function () {
      var theDiv = domID(div);
      if (scroll) {

        autoScroller(theDiv, 50, "smooth");


      }
    });

  }







  // ---------------------------------------------------
  // ---------------------------------------------------
  // Buttons to show Units panel
  // popup on click
  showAndHideGUIUnitsPanel("left-settings", "unitsPanel");
  showAndHideGUIUnitsPanel("top-settings", "unitsPanel");
  showAndHideGUIUnitsPanel("right-settings", "unitsPanel");
  showAndHideGUIUnitsPanel("bottom-settings", "unitsPanel");
  showAndHideGUIUnitsPanel("margin-left-settings", "unitsPanel");
  showAndHideGUIUnitsPanel("margin-top-settings", "unitsPanel");
  showAndHideGUIUnitsPanel("margin-right-settings", "unitsPanel");
  showAndHideGUIUnitsPanel("margin-bottom-settings", "unitsPanel");
  showAndHideGUIUnitsPanel("padding-left-settings", "unitsPanel");
  showAndHideGUIUnitsPanel("padding-top-settings", "unitsPanel");
  showAndHideGUIUnitsPanel("padding-right-settings", "unitsPanel");
  showAndHideGUIUnitsPanel("padding-bottom-settings", "unitsPanel");
  showAndHideGUIUnitsPanel("width-settings", "unitsPanel");
  showAndHideGUIUnitsPanel("height-settings", "unitsPanel");
  showAndHideGUIUnitsPanel("min-width-settings", "unitsPanel");
  showAndHideGUIUnitsPanel("min-height-settings", "unitsPanel");
  showAndHideGUIUnitsPanel("max-width-settings", "unitsPanel");
  showAndHideGUIUnitsPanel("max-height-settings", "unitsPanel");
  showAndHideGUIUnitsPanel("font-size-settings", "unitsPanel");
  showAndHideGUIUnitsPanel("letter-spacing-settings", "unitsPanel");
  showAndHideGUIUnitsPanel("line-height-settings", "unitsPanel");
  showAndHideGUIUnitsPanel("border-left-width-settings", "unitsPanel");
  showAndHideGUIUnitsPanel("border-top-width-settings", "unitsPanel");
  showAndHideGUIUnitsPanel("border-right-width-settings", "unitsPanel");
  showAndHideGUIUnitsPanel("border-bottom-width-settings", "unitsPanel");
  showAndHideGUIUnitsPanel("border-top-left-radius-settings", "unitsPanel");
  showAndHideGUIUnitsPanel("border-top-right-radius-settings", "unitsPanel");
  showAndHideGUIUnitsPanel(
    "border-bottom-left-radius-settings",
    "unitsPanel"
  );
  showAndHideGUIUnitsPanel(
    "border-bottom-right-radius-settings",
    "unitsPanel"
  );
  showAndHideGUIUnitsPanel("translateX-settings", "unitsPanel");
  showAndHideGUIUnitsPanel("translateY-settings", "unitsPanel");
  showAndHideGUIUnitsPanel("originX-settings", "unitsPanel");
  showAndHideGUIUnitsPanel("originY-settings", "unitsPanel");
  showAndHideGUIUnitsPanel("gapX-settings", "unitsPanel");
  showAndHideGUIUnitsPanel("gapY-settings", "unitsPanel");

  showAndHideGUIUnitsPanel("grid-row-start-settings", "unitsPanel");
  showAndHideGUIUnitsPanel("grid-column-start-settings", "unitsPanel");
  showAndHideGUIUnitsPanel("grid-row-end-settings", "unitsPanel");
  showAndHideGUIUnitsPanel("grid-column-end-settings", "unitsPanel");

  showAndHideGUIUnitsPanel("outline-width-settings", "unitsPanel");
  showAndHideGUIUnitsPanel("outline-offset-settings", "unitsPanel");

  showAndHideGUIUnitsPanel("text-decoration-thickness-settings", "unitsPanel");

  domID("unitsPanel").style.cssText = "display: none;";
  var lastSettingsButton;

  function showAndHideGUIUnitsPanel(button, div) {
    domEvent(domID(button), "mousedown", function () {
      lastSettingsButton = button;
      if (!INPUTER1.value) {
        return false;
      }
      var forInputer2 = button + "";
      forInputer2 = forInputer2.replace("-settings", "");

      if (button.indexOf('grid-template-columns-settings') > -1) {
        INPUTER2.value = "grid-template-columns";
        INPUTER3.value = CSSstyles["grid-template-columns"] || "";
      } else if (button.indexOf('grid-template-rows-settings') > -1) {
        INPUTER2.value = "grid-template-rows";
        INPUTER3.value = CSSstyles["grid-template-rows"] || "";
      } else if (button.indexOf('grid-auto-columns-settings') > -1) {
        INPUTER2.value = "grid-auto-columns";
        INPUTER3.value = CSSstyles["grid-auto-columns"] || "";
      } else if (button.indexOf('grid-auto-rows-settings') > -1) {
        INPUTER2.value = "grid-auto-rows";
        INPUTER3.value = CSSstyles["grid-auto-rows"] || "";
      } else {
        switch (lastSettingsButton) {
          case "translateX-settings":
          case "translateY-settings":
            INPUTER2.value = "transform";
            INPUTER3.value = CSSstyles["transform"] || "";
            break;
          case "originX-settings":
          case "originY-settings":
            INPUTER2.value = "transform-origin";
            INPUTER3.value = CSSstyles["transform-origin"] || "";
            break;
          case "gapX-settings":
          case "gapY-settings":
            INPUTER2.value = "gap";
            INPUTER3.value = CSSstyles["gap"] || "";
            break;
          default:
            INPUTER2.value = forInputer2;
            INPUTER3.value = CSSstyles[forInputer2] || "";
            break;
        }
      }
      var theDiv = domID(div);
      var theButton = domID(button);
      var btnposition = theButton.getBoundingClientRect();
      var btnpositionLeft = btnposition.left;
      var btnpositionTop = btnposition.top;
      if (lastSettingsButton === button) {
        if (theDiv.style.display === "none") {
          theDiv.style.display = "initial";
        } else {
          theDiv.style.cssText = "display: none;";
        }
        theDiv.style.left = btnpositionLeft - 91 + "px";
        theDiv.style.top = btnpositionTop + 28 + "px";
      } else {
        lastSettingsButton = button;
        theDiv.style.cssText = "display: none;";
        if (theDiv.style.display === "none") {
          theDiv.style.display = "initial";
        } else {
          theDiv.style.cssText = "display: none;";
        }
        theDiv.style.left = btnpositionLeft - 134 + "px";
        theDiv.style.top = btnpositionTop + 25 + "px";
      }
      var forValueOfReadout;
      if (button.indexOf('grid-template-columns-settings') > -1) {
        forValueOfReadout = domID(button).parentElement.querySelector('[data-grid_template_columns_value]').id;
      } else if (button.indexOf('grid-template-rows-settings') > -1) {
        forValueOfReadout = domID(button).parentElement.querySelector('[data-grid_template_rows_value]').id;
      } else if (button.indexOf('grid-auto-columns-settings') > -1) {
        forValueOfReadout = domID(button).parentElement.querySelector('[data-grid_auto_columns_value]').id;
      } else if (button.indexOf('grid-auto-rows-settings') > -1) {
        forValueOfReadout = domID(button).parentElement.querySelector('[data-grid_auto_rows_value]').id;
      } else {
        forValueOfReadout = forInputer2 + "_value";
      }
      var ValueOfReadoutUnits;
      var ValueOfReadout = domID(forValueOfReadout).innerText;

      if (ValueOfReadout !== "") {
        if (ValueOfReadout.indexOf('span') > -1) {
          ValueOfReadoutUnits = 'span';
        } else {
          ValueOfReadoutUnits = ValueOfReadout.match(theValREGEX) + "";
        }
      } else {
        units = "px";
        ValueOfReadoutUnits = units;
      }
      highlightTheUnitsButton(ValueOfReadoutUnits);
      if (lastSettingsButton !== button) {
        clearTheUIElementsUnitValue();
        TheUIElementsUnitValueFromInputer3();
      }
    });
  }

  function highlightTheUnitsButton(ValueOfReadoutUnits) {
    if (ValueOfReadoutUnits === "null") {
      ValueOfReadoutUnits = "";
    }
    units = ValueOfReadoutUnits; // sets the main units var
    array_of_units_els.map((el) => {
      el.style = buttonBGColor;
    });
    array_of_units_els.map((el) => {
      if (ValueOfReadoutUnits === el.dataset['unit_val']) {
        el.style = buttonHLColor;
      }
    });
    setStylesOnUnitsButtons();
  }
  // hide when scroll
  var supportsPassive = false;
  try {
    var opts = Object.defineProperty({}, "passive", {
      get: function () {
        supportsPassive = true;
      }
    });
    window.addEventListener("test", null, opts);
  } catch (e) {}
  // passive applied if supported, capture will be false either way.
  maincontainerRight.addEventListener(
    "mousewheel",
    hideUnitsPanel,
    supportsPassive ? {
      passive: true
    } :
    false
  );

  function hideUnitsPanel() {
    domID("unitsPanel").style.cssText = "display: none;";
  }
  maincontainerRight.onmousedown = function (event) {
    if (lastSettingsButton !== event.target.id) {
      domID("unitsPanel").style.cssText = "display: none;";
    }
  };

  var remove_property_btns = document.querySelectorAll(".remove-button");
  [].forEach.call(remove_property_btns, function (remove_property_btn) {
    remove_property_btn.onclick = function () {
      var item_to_remove = remove_property_btn.getAttribute("data-to_remove");
      var item_to_remove_transform = remove_property_btn.getAttribute("data-to_remove_transform");

      con('item_to_remove: ' + item_to_remove);
      con('item_to_remove_transform: ' + item_to_remove_transform);

      if (INPUTER1.value && item_to_remove) {
        if (item_to_remove.indexOf(' ' > -1)) {
          item_to_remove.split(' ').map((item) => {
            checkLocks_remove(item);
            clickRemoveProp(item);
          });
        } else {
          checkLocks_remove(item_to_remove);
          clickRemoveProp(item_to_remove);
        }
      }

      if (INPUTER1.value && item_to_remove_transform) {
        if (CSSstyles['transform']) {
          INPUTER2.value = 'transform';
          INPUTER3.value = CSSstyles['transform'];
        }
        var regex_val = false;
        switch (item_to_remove_transform) {
          case 'rotate':
            regex_val = /rotate\((.*?)\)/g;
            break;
          case 'translateX':
            regex_val = /translateX\((.*?)\)/g;
            break;
          case 'translateY':
            regex_val = /translateY\((.*?)\)/g;
            break;
          case 'scale':
            regex_val = /scale\((.*?)\)/g;
            break;
          case 'skew':
            regex_val = /skew\((.*?)\)/g;
            break;
        }
        if (regex_val && INPUTER3.value.indexOf(item_to_remove_transform) > -1) {
          INPUTER3.value = INPUTER3.value.replace(regex_val, '').trim().replace(/\s\s+/g, ' ');
          INPUTER3.value = INPUTER3.value.trim();
          if (!INPUTER3.value && INPUTER2.value === 'transform') {
            clickRemoveProp('transform');
          } else {
            clickAdder();
          }
        }
      }

      FillUndo();
      FillValueReadouts();
      refreshTextShadowValues();
      refreshShadowValues();
      buttonRefresh();
    };
  });

  function checkLocks_remove(item_to_remove) {
    var lock_items;
    switch (item_to_remove) {
      case "padding-left":
      case "padding-top":
      case "padding-right":
      case "padding-bottom":
        if (locks_obj['lock_padding'] === 'true') {
          lock_items = [
            "padding-left",
            "padding-top",
            "padding-right",
            "padding-bottom",
          ];
          setLockItems_remove(lock_items);
        }
        break;
      case "margin-left":
      case "margin-top":
      case "margin-right":
      case "margin-bottom":
        if (locks_obj['lock_margin'] === 'true') {
          lock_items = [
            "margin-left",
            "margin-top",
            "margin-right",
            "margin-bottom"
          ];
          setLockItems_remove(lock_items);
        }
        break;
      case "border-left-width":
      case "border-top-width":
      case "border-right-width":
      case "border-bottom-width":
        if (locks_obj['lock_border-width'] === 'true') {
          lock_items = [
            "border-left-width",
            "border-top-width",
            "border-right-width",
            "border-bottom-width"
          ];
          setLockItems_remove(lock_items);
        }
        break;
      case "border-top-left-radius":
      case "border-top-right-radius":
      case "border-bottom-left-radius":
      case "border-bottom-right-radius":
        if (locks_obj['lock_border-radius'] === 'true') {
          lock_items = [
            "border-top-left-radius",
            "border-top-right-radius",
            "border-bottom-left-radius",
            "border-bottom-right-radius",
          ];
          setLockItems_remove(lock_items);
        }
        break;
      case "border-left-style":
      case "border-top-style":
      case "border-right-style":
      case "border-bottom-style":
        if (locks_obj['lock_border-style'] === 'true') {
          lock_items = [
            "border-left-style",
            "border-top-style",
            "border-right-style",
            "border-bottom-style"
          ];
          setLockItems_remove(lock_items);
        }
        break;
      case "border-left-color":
      case "border-top-color":
      case "border-right-color":
      case "border-bottom-color":
        if (locks_obj['lock_border-color'] === 'true') {
          lock_items = [
            "border-left-color",
            "border-top-color",
            "border-right-color",
            "border-bottom-color"
          ];
          setLockItems_remove(lock_items);
        }
        break;
    }
  }



  // ---------------------------------------------------
  // ---------------------------------------------------
  // FullScreen mode
  fullScreenMessage.style.opacity = "0";
  fullScreenMessage.style.cssText = "display: none;";
  domEvent(domID("fullScreen"), "click", toggleFullScreenMode);


  function toggleFullScreenMode(once) {

    if (window.innerWidth < breakPoint_MD_Value + scrollbox_width_resizer_vars_min_width) {
      // small screens
      tutorial_show_active = 'false';
      SCROLLBOX.style.height = null;
      SCROLLBOX.style.minWidth = "100%";
      SCROLLBOX.style.maxWidth = "100%";
      SCROLLBOX.style.top = "36px";
      SCROLLBOX.style.bottom = "38px";
      SCROLLBOX.style.border = "0px";
      SCROLLBOX.style.left = "50%";
      SCROLLBOX.style.minHeight = "auto";
      SCROLLBOX.style.maxHeight = "100%";
      BREAKPOINT_WIDTH_READOUT.innerHTML = '';
      SCROLLBOX_HANDEL.style.cssText = "display: none;";
      BREAKPOINT_LINE_LG.style.cssText = "display: none;";
      BREAKPOINT_LINE_MD.style.cssText = "display: none;";
      BREAKPOINT_LINE_SM.style.cssText = "display: none;";
      BREAKPOINT_LINE_XS.style.cssText = "display: none;";
      codesection.style.cssText = "display: none;";
      document.getElementById("viewCodeButton").style.cssText = "display: none;";
      let codepenForm = domID('codepenForm');
      if (codepenForm) {
        codepenForm.parentNode.removeChild(codepenForm);
      }
      domID("app").classList.add('small-screen');
      breakPoint3();
      setTimeout(() => {
        let iframe_el = document.getElementById('iframeClasscss');
        BREAKPOINT_WIDTH_READOUT.innerHTML = iframe_el.offsetWidth + " x " + iframe_el.offsetHeight + BREAKPOINT_WIDTH_READOUT_mode;
      }, 200);
    }

  }
  // ---------------------------------------------------
  // ---------------------------------------------------
  // Transforms
  var rotateVal;
  var scaleValX;
  var scaleValY;
  var skewValX;
  var skewValY;
  var translateValX;
  var translateValY;
  var originValX;
  var originValY;
  // with units
  var rotateValWithUnits;
  var skewValXWithUnits;
  var skewValYWithUnits;
  var translateValXWithUnits;
  var translateValYWithUnits;
  var originValXWithUnits;
  var originValYWithUnits;
  // greyed out
  var allTransforms_faded;
  var allTransformsOrigin_faded;

  function getTransformValues() {
    if (!INPUTER1.value) {
      return false;
    }
    var input1 = INPUTER1.value;
    FillValueReadouts_input1 = input1;
    checkOtherMediaValsInputVal = input1;

    allTransforms_faded = false;
    allTransformsOrigin_faded = false;

    rotateVal = "";
    scaleValX = "";
    scaleValY = "";
    skewValX = "";
    skewValY = "";
    translateValX = "";
    translateValY = "";
    originValX = "";
    originValY = "";
    rotateValWithUnits = "";
    skewValXWithUnits = "";
    skewValYWithUnits = "";
    translateValXWithUnits = "";
    translateValYWithUnits = "";
    originValXWithUnits = "";
    originValYWithUnits = "";
    var allTransforms = [];
    var allTransformsOrigin = [];
    var currentTransformStyle = CSSstyles["transform"];
    var currentTransformOriginStyle = CSSstyles["transform-origin"];
    if (currentTransformStyle) {
      allTransforms.push(currentTransformStyle + "");
    } else {
      if (getInheritedStyle("transform").style) {
        allTransforms.push(getInheritedStyle("transform").style + "");
        allTransforms_faded = true;
      }
    }
    if (currentTransformOriginStyle) {
      allTransformsOrigin.push(currentTransformOriginStyle + "");
    } else {
      if (getInheritedStyle("transform-origin").style) {
        allTransformsOrigin.push(getInheritedStyle("transform-origin").style + "");
        allTransformsOrigin_faded = true;
      }
    }
    var toText = allTransforms + "";
    var toText2 = allTransformsOrigin + "";
    var allTransforms2 = toText.split(" ");
    var allTransformsOrigin2 = toText2.split(" ");
    for (var i = 0; i < allTransforms2.length; i++) {
      if (allTransforms2[i].indexOf("rotate(") > -1) {
        rotateVal = allTransforms2[i].replace("rotate(", "");
        rotateValWithUnits = rotateVal.replace(")", "");
        rotateVal = rotateVal.replace(theValREGEX, "");
      }
      if (allTransforms2[i].indexOf("scale(") > -1) {
        var scaleVal = allTransforms2[i].replace("scale(", "");
        scaleVal = scaleVal.replace(theValREGEX, "");
        [scaleValX, scaleValY] = scaleVal.split(",");
      }
      if (allTransforms2[i].indexOf("skew(") > -1) {
        var skewVal = allTransforms2[i].replace("skew(", "");
        skewVal = skewVal.replace(")", "");
        let [x, y] = skewVal.split(",");
        skewValXWithUnits = x;
        skewValYWithUnits = y;
        skewValX = x.replace(theValREGEX, "");
        skewValY = y.replace(theValREGEX, "");
      }
      if (allTransforms2[i].indexOf("translateX(") > -1) {
        translateValX = allTransforms2[i].replace("translateX(", "");
        translateValXWithUnits = translateValX.replace(")", "");
        translateValX = translateValX.replace(theValREGEX, "");
        translateValXUnits = translateValXWithUnits.match(
          theValREGEX
        ) || ["none"];
      }
      if (allTransforms2[i].indexOf("translateY(") > -1) {
        translateValY = allTransforms2[i].replace("translateY(", "");
        translateValYWithUnits = translateValY.replace(")", "");
        translateValY = translateValY.replace(theValREGEX, "");
        translateValYUnits = translateValYWithUnits.match(
          theValREGEX
        ) || ["none"];
      }
    }
    //con(allTransformsOrigin2);
    if (allTransformsOrigin2[0] && allTransformsOrigin2[1]) {
      originValXWithUnits = allTransformsOrigin2[0];
      originValYWithUnits = allTransformsOrigin2[1];
      originValX = allTransformsOrigin2[0].replace(theValREGEX, "");
      originValY = allTransformsOrigin2[1].replace(theValREGEX, "");
      originValXUnits =
        allTransformsOrigin2[0].match(theValREGEX).toString() || "none";
      originValYUnits =
        allTransformsOrigin2[1].match(theValREGEX).toString() || "none";
    }
  }

  function setTransformValues() {
    rotateValReadout.textContent = rotateValWithUnits || "";
    scaleValXReadout.textContent = scaleValX || "";
    scaleValYReadout.textContent = scaleValY || "";
    skewValXReadout.textContent = skewValXWithUnits || "";
    skewValYReadout.textContent = skewValYWithUnits || "";
    translateValXReadout.textContent = translateValXWithUnits || "";
    translateValYReadout.textContent = translateValYWithUnits || "";
    if (allTransforms_faded) {
      rotateValReadout.style.opacity = "0.5";
      scaleValXReadout.style.opacity = "0.5";
      scaleValYReadout.style.opacity = "0.5";
      skewValXReadout.style.opacity = "0.5";
      skewValYReadout.style.opacity = "0.5";
      translateValXReadout.style.opacity = "0.5";
      translateValYReadout.style.opacity = "0.5";
      rotateValReadout.style.color = null;
      scaleValXReadout.style.color = null;
      scaleValYReadout.style.color = null;
      skewValXReadout.style.color = null;
      skewValYReadout.style.color = null;
      translateValXReadout.style.color = null;
      translateValYReadout.style.color = null;
    } else {
      rotateValReadout.style.opacity = null;
      scaleValXReadout.style.opacity = null;
      scaleValYReadout.style.opacity = null;
      skewValXReadout.style.opacity = null;
      skewValYReadout.style.opacity = null;
      translateValXReadout.style.opacity = null;
      translateValYReadout.style.opacity = null;
      rotateValReadout.style.color = mainColor;
      scaleValXReadout.style.color = mainColor;
      scaleValYReadout.style.color = mainColor;
      skewValXReadout.style.color = mainColor;
      skewValYReadout.style.color = mainColor;
      translateValXReadout.style.color = mainColor;
      translateValYReadout.style.color = mainColor;
    }
    originValXReadout.textContent = originValXWithUnits || "";
    originValYReadout.textContent = originValYWithUnits || "";
    if (allTransformsOrigin_faded) {
      originValXReadout.style.opacity = "0.5";
      originValYReadout.style.opacity = "0.5";
      originValXReadout.style.color = null;
      originValYReadout.style.color = null;
    } else {
      originValXReadout.style.opacity = null;
      originValYReadout.style.opacity = null;
      originValXReadout.style.color = mainColor;
      originValYReadout.style.color = mainColor;
    }
  }

  var translateValXUnits = "px";
  var translateValYUnits = "px";

  function createNewTransformValues() {
    var rotate;
    var scale;
    var skew;
    var translateX;
    var translateY;
    var forInput3 = "";
    if (rotateVal) {
      rotate = " rotate(" + rotateVal + "deg)";
    } else {
      rotate = "";
    }
    if (scaleValX && scaleValY) {
      scale = " scale(" + scaleValX + "," + scaleValY + ")";
    } else if (scaleValX && !scaleValY) {
      scale = " scale(" + scaleValX + ",1.00)";
    } else if (!scaleValX && scaleValY) {
      scale = " scale(1.00," + scaleValY + ")";
    } else {
      scale = "";
    }
    if (skewValX && skewValY) {
      skew = " skew(" + skewValX + "deg," + skewValY + "deg)";
    } else if (skewValX && !skewValY) {
      skew = " skew(" + skewValX + "deg,0.0deg)";
    } else if (!skewValX && skewValY) {
      skew = " skew(0.0deg," + skewValY + "deg)";
    } else {
      skew = "";
    }
    if (translateValX) {
      translateX =
        " translateX(" + translateValX + translateValXUnits + ")";
    } else {
      translateX = "";
    }
    if (translateValY) {
      translateY =
        " translateY(" + translateValY + translateValYUnits + ")";
    } else {
      translateY = "";
    }
    forInput3 = rotate + scale + skew + translateX + translateY;
    forInput3 = forInput3.trim();
    if (forInput3.length) {
      return forInput3;
    }
  }
  var originValXUnits = "%";
  var originValYUnits = "%";

  function createNewTransformOriginValues() {
    var origin = "";
    var forInput3 = "";
    if (!CSSstyles["transform-origin"]) {
      originValX = 50;
      originValY = 50;
    }
    origin =
      originValX + originValXUnits + " " + originValY + originValYUnits;
    forInput3 = origin;
    forInput3 = forInput3.trim();
    if (forInput3.length) {
      return forInput3;
    }
  }

  domEvent(domID("rotate-up"), "mousedown", function () {
    transformIncUpOrDown("up", "rotate-up");
  });
  domEvent(domID("rotate-down"), "mousedown", function () {
    transformIncUpOrDown("down", "rotate-down");
  });
  domEvent(domID("scaleX-up"), "mousedown", function () {
    transformIncUpOrDown("up", "scaleX-up");
  });
  domEvent(domID("scaleX-down"), "mousedown", function () {
    transformIncUpOrDown("down", "scaleX-down");
  });
  domEvent(domID("scaleY-up"), "mousedown", function () {
    transformIncUpOrDown("up", "scaleY-up");
  });
  domEvent(domID("scaleY-down"), "mousedown", function () {
    transformIncUpOrDown("down", "scaleY-down");
  });
  domEvent(domID("skewX-up"), "mousedown", function () {
    transformIncUpOrDown("up", "skewX-up");
  });
  domEvent(domID("skewX-down"), "mousedown", function () {
    transformIncUpOrDown("down", "skewX-down");
  });
  domEvent(domID("skewY-up"), "mousedown", function () {
    transformIncUpOrDown("up", "skewY-up");
  });
  domEvent(domID("skewY-down"), "mousedown", function () {
    transformIncUpOrDown("down", "skewY-down");
  });
  domEvent(domID("translateX-up"), "mousedown", function () {
    transformIncUpOrDown("up", "translateX-up");
  });
  domEvent(domID("translateX-down"), "mousedown", function () {
    transformIncUpOrDown("down", "translateX-down");
  });
  domEvent(domID("translateY-up"), "mousedown", function () {
    transformIncUpOrDown("up", "translateY-up");
  });
  domEvent(domID("translateY-down"), "mousedown", function () {
    transformIncUpOrDown("down", "translateY-down");
  });
  domEvent(domID("originX-up"), "mousedown", function () {
    transformIncUpOrDown("up", "originX-up");
  });
  domEvent(domID("originX-down"), "mousedown", function () {
    transformIncUpOrDown("down", "originX-down");
  });
  domEvent(domID("originY-up"), "mousedown", function () {
    transformIncUpOrDown("up", "originY-up");
  });
  domEvent(domID("originY-down"), "mousedown", function () {
    transformIncUpOrDown("down", "originY-down");
  });

  function transformIncUpOrDown(upDown, button) {
    if (!INPUTER1.value) {
      return false;
    }
    var val = 0;
    var incAmount = 0;
    switch (button) {
      case "rotate-up":
      case "rotate-down":
        val = rotateVal || 0.0;
        incAmount = Number(0.5);
        break;
      case "scaleX-up":
      case "scaleX-down":
        val = scaleValX || 1.0;
        incAmount = Number(0.01);
        break;
      case "scaleY-up":
      case "scaleY-down":
        val = scaleValY || 1.0;
        incAmount = Number(0.01);
        break;
      case "skewX-up":
      case "skewX-down":
        val = skewValX || 0.0;
        incAmount = Number(0.5);
        break;
      case "skewY-up":
      case "skewY-down":
        val = skewValY || 0.0;
        incAmount = Number(0.5);
        break;
      case "translateX-up":
      case "translateX-down":
        val = translateValX || 0;
        incAmount = Number(1);
        break;
      case "translateY-up":
      case "translateY-down":
        val = translateValY || 0;
        incAmount = Number(1);
        break;
      case "originX-up":
      case "originX-down":
        if (!isNaN(originValX)) {
          val = originValX || 50;
          incAmount = Number(1);
        } else {
          val = 50;
          incAmount = Number(1);
        }
        break;
      case "originY-up":
      case "originY-down":
        if (!isNaN(originValY)) {
          val = originValY || 50;
          incAmount = Number(1);
        } else {
          val = 50;
          incAmount = Number(1);
        }
        break;
    }
    var timepressed;
    var deleypress;
    var btn = domID(button);
    var up = function () {
      val = Number(val) + incAmount;
    };
    var down = function () {
      val = Number(val) - incAmount;
    };
    var doTheIncs = function () {
      if (upDown === "up") {
        up();
      } else {
        down();
      }
      switch (button) {
        case "rotate-up":
        case "rotate-down":
          roundNumber(val, 2);
          rotateVal = val.toFixed(1);
          break;
        case "scaleX-up":
        case "scaleX-down":
          roundNumber(val, 3);
          scaleValX = val.toFixed(2);
          break;
        case "scaleY-up":
        case "scaleY-down":
          roundNumber(val, 3);
          scaleValY = val.toFixed(2);
          break;
        case "skewX-up":
        case "skewX-down":
          roundNumber(val, 2);
          skewValX = val.toFixed(1);
          break;
        case "skewY-up":
        case "skewY-down":
          roundNumber(val, 2);
          skewValY = val.toFixed(1);
          break;
        case "translateX-up":
        case "translateX-down":
          roundNumber(val, 2);
          translateValX = val.toFixed(0);
          break;
        case "translateY-up":
        case "translateY-down":
          roundNumber(val, 2);
          translateValY = val.toFixed(0);
          break;
        case "originX-up":
        case "originX-down":
          roundNumber(val, 2);
          originValX = val.toFixed(0);
          break;
        case "originY-up":
        case "originY-down":
          roundNumber(val, 2);
          originValY = val.toFixed(0);
          break;
      }
      let trans_temp = '';
      if (
        button !== "originX-up" &&
        button !== "originX-down" &&
        button !== "originY-up" &&
        button !== "originY-down"
      ) {
        trans_temp = createNewTransformValues();
      } else {
        trans_temp = createNewTransformOriginValues();
      }
      INPUTER3.value = trans_temp;
      clickAdder("increment");
      getTransformValues();
      setTransformValues();
    };
    var iter = function () {
      timepressed = setInterval(function () {
        doTheIncs();
      }, 20);
      return false;
    };
    var clearIter = function () {
      clearInterval(timepressed);
      clearTimeout(deleypress);
      clickAdder("increment");
      FillUndo();
      FillValueReadouts();
      return false;
    };
    if (
      button !== "originX-up" &&
      button !== "originX-down" &&
      button !== "originY-up" &&
      button !== "originY-down"
    ) {
      INPUTER2.value = "transform";
    } else {
      INPUTER2.value = "transform-origin";
    }
    doTheIncs();
    if (
      button !== "originX-up" &&
      button !== "originX-down" &&
      button !== "originY-up" &&
      button !== "originY-down"
    ) {
      INPUTER3.value = createNewTransformValues();
    } else {
      INPUTER3.value = createNewTransformOriginValues();
    }
    clickAdder("increment");
    getTransformValues();
    setTransformValues();
    deleypress = setTimeout(iter, 200);
    btn.onmouseup = clearIter;
    btn.onmouseleave = clearIter;
  }

  // ---------------------------------------------------
  // ---------------------------------------------------
  // Decendent selector dropbox.
  targetDropText.onmousedown = function () {
    selectClass();
  };
  targetDropText.onmouseover = function () {
    info(
      "Tip, this could make the parents hover target the childs class. " +
      "The child's class needs to be different than its parents. ",
      null,
      null
    );
  };
  targetDropText.onmouseleave = function () {
    info(null, null, null);
  };
  //var selectClassDisplay = false;
  function selectClass() {
    if (!INPUTER1.value.length) {
      return false;
    }

    refreshTargetDropButtons();
    updateClasses(frameID(domElement[0]));
  }

  function selectClassButton(event) {
    var itsName = targetDropText.textContent;
    var input1 = INPUTER1.value;
    var toRemove;
    var restoreInput1;
    var splitName;
    var putThis;
    if (input1.indexOf(itsName) > -1) {
      toRemove = " ." + itsName;
      restoreInput1 = input1.replace(toRemove, "");
      INPUTER1.value = restoreInput1;
    } else if (input1.indexOf(" .") > -1) {
      splitName = input1.split(" .");
      toRemove = " ." + splitName[1];
      restoreInput1 = input1.replace(toRemove, "");
      INPUTER1.value = restoreInput1;
      INPUTER1.value = INPUTER1.value + " ." + itsName;
    } else {
      INPUTER1.value = input1 + " ." + itsName;
    }
    putThis = INPUTER1.value;
    if (!thecssLG[INPUTER1.value]) {
      put(putThis, {}, thecssLG);
      put(putThis, {}, thecssMD);
      put(putThis, {}, thecssSM);
      put(putThis, {}, thecssXS);
    }
    selectElement(frameID(domElement[0]));
  }

  function updateClasses(el) {
    if (!el || el === classcss) {
      return false;
    }
    //clear the present list
    var myNode = targetDropBox;
    while (myNode.firstChild) {
      myNode.removeChild(myNode.firstChild);
    }


    // el is selected element

    // need to get add the childer of selected element
    var els_children = el.querySelectorAll("*");
    var arr_of_classes = [];
    [].forEach.call(els_children, function (el) {
      [].forEach.call(el.classList, function (class_name) {
        if (arr_of_classes.indexOf(class_name) === -1) {
          arr_of_classes.push(class_name);
        }
      });
    });

    [].forEach.call(arr_of_classes, function (class_name) {
      var id = "selectClass-" + class_name;
      const button = document.createElement('button');
      button.className = 'targetDropButton';
      button.id = id;
      button.textContent = class_name;
      targetDropBox.appendChild(button);
    });

    refreshTargetDropButtons();

  }

  function refreshTargetDropButtons() {
    var targetDropButtons = document.getElementsByClassName(
      "targetDropButton"
    );
    [].forEach.call(targetDropButtons, function (el) {
      el.onmousedown = function () {
        targetDropText.textContent = el.textContent;
        frameID(domElement[0]).dataset.targetDropButton = el.textContent;
        selectClassButton(null);
        toggleClass(DROPDOWN_CLASSES, "active");
        //targetDropBox.style.cssText = "display: none;";
        // selectClassDisplay = false;
      };
    });
  }
  // ---------------------------------------------------
  // ----------------------------------------------------
  // Get array of class names from iframe #classcss
  function getClassNames(containerElement) {
    var classes = [];
    var allEls = containerElement.querySelectorAll("#classcss *");

    function pushClassName(el) {
      el.getAttribute('class').split(/\s/).forEach(function (cl) {
        if (cl && classes.indexOf(cl) == -1) classes.push(cl);
      });
    }
    [].forEach.call(allEls, function (el) {
      pushClassName(el);
    });
    classes.sort();
    return classes;
  }
  // TODO;
  // Add dropdown and fill with classnames then add event listener
  // to them to populate inputer1.
  // Also need to add the logic for when the class is changed in inputer1
  // does it select the first element with this classname? or somehow
  // highlight all elements with this classname the latter maybe nicer
  // but more complex as would need to unselect selected element
  // and get all positions for highlighting with a different color
  // also in the domtree.
  // also need to remove getClassNames from the selectElement function.
  // ---------------------------------------------------
  // ---------------------------------------------------
  // ---------------------------------------------------
  // ---------------------------------------------------
  // first time visitor
  // visit counter

  /***
   *    ##     ## ####  ######  #### ########  #######  ########
   *    ##     ##  ##  ##    ##  ##     ##    ##     ## ##     ##
   *    ##     ##  ##  ##        ##     ##    ##     ## ##     ##
   *    ##     ##  ##   ######   ##     ##    ##     ## ########
   *     ##   ##   ##        ##  ##     ##    ##     ## ##   ##
   *      ## ##    ##  ##    ##  ##     ##    ##     ## ##    ##
   *       ###    ####  ######  ####    ##     #######  ##     ##
   *
   *    ##        #######   ######   ####  ######
   *    ##       ##     ## ##    ##   ##  ##    ##
   *    ##       ##     ## ##         ##  ##
   *    ##       ##     ## ##   ####  ##  ##
   *    ##       ##     ## ##    ##   ##  ##
   *    ##       ##     ## ##    ##   ##  ##    ##
   *    ########  #######   ######   ####  ######
   */

  SCROLLBOX.style.setProperty('transition', 'opacity 0.3s ease-in');
  SCROLLBOX.style.setProperty('opacity', '0');

  function showTheApp() {
    setTimeout(function () {
      domID("theAppVisibility").style = "opacity: 1;";
    }, 150);
  }


  var onLoadCounter = localStorage.getItem("on_load_count");
  var currentProjectdom;
  var edited_on_frontend_or_backend = domID("editedOn");
  if (edited_on_frontend_or_backend) {
    edited_on_frontend_or_backend = String(edited_on_frontend_or_backend.value || "").trim().toLowerCase();
  } else {
    edited_on_frontend_or_backend = "backend";
  }

  function visitorFileLoadLogic() {
    if (onLoadCounter === null) {
      setTimeout(function () {
        request("domposer.zip", uploadFiles);
        console.log("Welcome to " + window.location.href);
      }, 0);
      //uploadFiles(zipfile);
      onLoadCounter = 1;
      localStorage.setItem("on_load_count", onLoadCounter);
      localStorage.setItem("active-tab-pages", 'pagesButton');
      localStorage.setItem("active-tab-structure", 'structureButton');
      localStorage.setItem("active-tab-components", 'componentsButton');
      localStorage.setItem("active-tab-element", 'elementsButton');
      localStorage.setItem("active-tab-images", 'imagesButton');
      component_theme = 'dark';
      window.localStorage.setItem('component_theme', component_theme);
      component_theme__select.value = component_theme;
      getArrayOfUndos();
    } else {
      currentProjectdom = domID("currentProject");
      if (!currentProjectdom) {
        console.log("Welcome back to " + window.location.href);
        console.log(
          "login or create an account to have multiple projects"
        );
        onLoadCounter++;
        localStorage.setItem("on_load_count", onLoadCounter);
        getArrayOfUndos();
        showTheApp();
        FillUndo();
      } else {
        currentProjectdom = domID("currentProject").value;
        var localStoragecurrentProject = localStorage.getItem(
          "currentProject"
        );

        var currentProjectzipfile = domID("currentProjectzipfile");
        if (currentProjectzipfile) {
          // use local storage or zip
          console.log("currentProject: " + currentProjectdom);
          console.log("prorect name: " + PROJECT_NAME.value);
          console.log(
            "prorect description: " + PROJECT_DESCRIPTION.value
          );
          if (edited_on_frontend_or_backend === "frontend") {
            // use local storage
            console.log(
              "Welcome back to " + window.location.href
            );
            console.log("using local storage");
            getArrayOfUndos();
            showTheApp();
            FillUndo();
          } else {
            // use zip file
            window.localStorage.clear();
            window.sessionStorage.clear();
            localforage.clear();
            fullWidth();
            setScrollBoxToFullWidth();
            storeTheCurrentBreakpoint();
            request(currentProjectzipfile.value, uploadFiles);
            setTimeout(function () {
              console.log(
                "Welcome to " + window.location.href
              );
              console.log(
                "using zip file " +
                currentProjectzipfile.value
              );
            }, 50);
          }
        } else {
          window.localStorage.clear();
          window.sessionStorage.clear();
          localforage.clear();
          fullWidth();
          setScrollBoxToFullWidth();
          storeTheCurrentBreakpoint();
          window.localStorage.setItem(
            "on_load_count",
            onLoadCounter
          );
          setTimeout(function () {
            console.log("loading newproject.zip");
            console.log("Welcome to " + window.location.href);
            console.log("no project found");
            request("newproject.zip", uploadFiles);
          }, 50);
        }
      }
    }
  }

  function request(file, callback) {
    var request = new XMLHttpRequest();
    request.open("GET", file, true);
    request.responseType = "arraybuffer";
    request.onreadystatechange = function () {
      /** Do nothing if we are not ready yet */
      if (request.readyState !== XMLHttpRequest.DONE) {
        return;
      }
      if (request.status === 200) {
        callback(
          new Blob([request.response], {
            type: "application/zip"
          })
        );
      } else {
        console.error(request.status);
        callback(false);
      }
    };
    request.send();
  }

  // ---------------------------------------------------
  function getScrollBoxMax() {
    var winWidth = window.innerWidth;
    var sides = scrollbox_width_resizer_vars_min_width;
    var scrollBoxMaxWidth = winWidth - sides;
    if (isEven(scrollBoxMaxWidth)) {} else {
      scrollBoxMaxWidth--;
    }
    return scrollBoxMaxWidth;
  }
  // ---------------------------------------------------
  // ---------------------------------------------------
  // Flexbox
  function flexContainerButtons(buttonClass) {
    var setFlex = function (element) {
      if (!INPUTER1.value) {
        return false;
      } else {
        INPUTER2.value = buttonClass;
        INPUTER3.value = this.dataset.flex;
        clickAdder(null);
        FillValueReadouts();
        buttonRefresh();
        BoxRefresh();
        setTimeout(function () {
          selectElement(frameID(domElement[0]));
        }, 0);
        var queriedEls_1 = document.querySelectorAll("." + buttonClass);
        [].forEach.call(queriedEls_1, function (el) {
          el.style = buttonBGColor;
        });
        this.style = buttonHLColor;
      }
    };
    var queriedEls = document.querySelectorAll("." + buttonClass);
    [].forEach.call(queriedEls, function (el) {
      el.style = buttonBGColor;
      domEvent(el, "mousedown", setFlex);
    });
  }
  flexContainerButtons("flex-direction");
  flexContainerButtons("flex-wrap");
  flexContainerButtons("justify-content");
  flexContainerButtons("align-items");
  flexContainerButtons("align-content");
  flexContainerButtons("align-self");

  function flexInputs(inputElement, propertyName) {
    inputElement.oninput = function () {
      if (!INPUTER1.value) {
        return false;
      }
      INPUTER2.value = propertyName;
      if (isNaN(inputElement.value)) {
        if (inputElement.id !== "flex-basis") {
          inputElement.value = null;
        }
      }
      INPUTER3.value = inputElement.value;
      clickAdder(null);
      FillValueReadouts();
      buttonRefresh();
      BoxRefresh();
      setTimeout(function () {
        selectElement(frameID(domElement[0]));
      }, 0);
    };
  }
  flexInputs(flexOrder, "order");
  flexInputs(flexGrow, "flex-grow");
  flexInputs(flexShrink, "flex-shrink");
  flexInputs(flexBasis, "flex-basis");
  // ---------------------------------------------------
  // ---------------------------------------------------
  // zIndex
  zIndexButtonPress(zIndexAuto, "auto");
  zIndexButtonPress(zIndexInitial, "initial");
  zIndexButtonPress(zIndexInherit, "inherit");

  function zIndexButtonPress(button, cssProperty) {
    button.addEventListener("mousedown", function () {
      if (!INPUTER1.value) {
        return false;
      }
      INPUTER2.value = "z-index";
      INPUTER3.value = cssProperty;
      clickAdder(null);
      FillValueReadouts();
      buttonRefresh();
      BoxRefresh();
    });
  }
  // ---------------------------------------------------
  // ---------------------------------------------------
  // statndard inputs
  function standardInputs(inputElement, propertyName) {
    inputElement.oninput = function () {
      if (!INPUTER1.value) {
        return false;
      }
      INPUTER2.value = propertyName;
      INPUTER3.value = inputElement.value;
      clickAdder(null);
      FillValueReadouts();
      buttonRefresh();
      BoxRefresh();
      setTimeout(function () {
        selectElement(frameID(domElement[0]));
      }, 0);
    };
  }
  standardInputs(colorValue_input, "color");
  standardInputs(backgroundColorValue_input, "background-color");

  domEvent(colorPickerShowBtn, "mousedown", function () {
    if (colorPanel.style.display === "block") {
      colorPanel.style.cssText = "display: none;";
    } else {
      colorPanel.style.display = "block";
    }
  });

  // ---------------------------------------------------
  // ---------------------------------------------------

  function removeURLBrackets(stringToChange) {
    if (!stringToChange) {
      return false;
    }
    var split1 = stringToChange.split("url(images/");
    if (split1[1]) {
      var split2 = split1[1].split(")");
      return split2[0] + "";
    } else {
      return 'not-image-url';
    }
  }

  // ---------------------------------------------------
  // ---------------------------------------------------
  // CodeView show, hide & refresh

  domEvent(viewCodeButton, "mousedown", viewCode);

  codeView = localStorage.getItem("codeview");
  if (localStorage.getItem("code-section-style")) {
    codesection.style.cssText = localStorage.getItem("code-section-style");
    if (codesection.style.display === "none") {
      codeView = false;
    } else {
      codeView = true;
    }
  }

  function viewCode() {
    if (codesection.style.display !== "none") {
      codeView = false;
    } else {
      codeView = true;
    }
    localStorage.setItem("codeview", codeView);
    if (codeView) {
      refreshCodeView();
      closeMediaQSettings();
      setTimeout(function () {
        BoxRefresh();
      }, 0);
    }
  }

  var prism_css = domID('prism_css');
  var prism_html = domID('prism_html');
  var editing_code = false;


  function refreshCodeView() {
    if (editing_code || recoveryDrafts.size) {
      return false;
    }
    if (!codeView) {
      return false;
    }
    if (window.innerWidth < breakPoint_MD_Value + scrollbox_width_resizer_vars_min_width) {
      return false;
    }
    setTimeout(function () {
      if (editing_code || recoveryDrafts.size) return;
      addID_to_els_without();
      prism_css.innerHTML = Prism.highlight(creatCSSandDownload().fileData, Prism.languages.css, 'css');
      prism_html.innerHTML = Prism.highlight(creatHTMLandDownload(page_name).fileHTMLBody, Prism.languages.html, 'html');
      setTimeout(function () {
        jumpToClassInTextarea();
      }, 10);
    }, 0);
  }

  function addID_to_els_without() {
    if (classcss) {
      var allEls = [...classcss.querySelectorAll('*')];
      allEls.map((el) => {
        if (el.tagName.toLowerCase() !== 'br') {
          if (!el.id) {
            guidGenerator();
            el.id = uniqid;
          }
        }
      });
    }
  }

  // ---------------------------------------------------
  // ---------------------------------------------------
  // Jump to className position in textarea
  // based of the current breakpoint.

  function grid_or_flex() {
    var forReturn = false;
    if (CSSstyles["display"] === 'flex') {
      forReturn = "flexboxButton";
    } else if (getInheritedStyle("display").style === 'flex') {
      forReturn = "flexboxButton";
    } else if (CSSstyles["display"] === 'grid') {
      forReturn = "gridButton";
    } else if (getInheritedStyle("display").style === 'grid') {
      forReturn = "gridButton";
    }
    return forReturn;
  }

  function parent_display_prop() {
    var iframe_el = frameID(domElement[0]);
    if (!iframe_el) {
      return false;
    }
    var iframe_el_parent = iframe_el.parentElement;
    var compStyles = window.getComputedStyle(iframe_el_parent);
    var display_prop = compStyles.getPropertyValue('display');
    return display_prop;

  }

  function openTabForProperty(property, no_update) {
    var tab_to_open;
    property = return_cleared_of_prefixes(property);
    switch (property) {
      case "opacity":
      case "color":
      case "background-color":
        tab_to_open = "colorsButton";
        break;
      case "position":
      case "left":
      case "top":
      case "right":
      case "bottom":
        tab_to_open = "positionButton";
        break;
      case "display":
        tab_to_open = "displayButton";
        break;
      case "flex-direction":
      case "flex-wrap":
      case "flex-grow":
      case "flex-shrink":
      case "flex-basis":
      case "order":
        tab_to_open = "flexboxButton";
        break;
      case "align-self":
        if (parent_display_prop() === 'grid') {
          tab_to_open = "gridButton";
        } else if (parent_display_prop() === 'flex') {
          tab_to_open = "flexboxButton";
        }
        break;
      case "align-items":
      case "justify-content":
      case "align-content":
        if (grid_or_flex()) {
          tab_to_open = grid_or_flex();
        } else {
          setTimeout(() => {
            info('No display setting of grid or flex found.');
          }, 100);
          tab_to_open = "displayButton";
        }
        break;
      case "justify-items":
      case "grid-template-columns":
      case "grid-template-rows":
      case "grid-auto-columns":
      case "grid-auto-rows":
      case "grid-auto-flow":
      case "justify-self":
      case "grid-row-start":
      case "grid-column-start":
      case "grid-row-end":
      case "grid-column-end":
        tab_to_open = "gridButton";
        break;
      case "size":
      case "width":
      case "min-width":
      case "max-width":
      case "height":
      case "min-height":
      case "max-height":
      case "object-fit":
        tab_to_open = "sizeButton";
        iframeElementSelect.setAttribute('box-edit', 'sizeButton');
        break;
      case "margin":
      case "margin-left":
      case "margin-top":
      case "margin-right":
      case "margin-bottom":
      case "padding":
      case "padding-left":
      case "padding-top":
      case "padding-right":
      case "padding-bottom":
      case "gap":
      case "box-sizing":
        tab_to_open = "spacingButton";
        iframeElementSelect.setAttribute('box-edit', 'spacingButton');
        break;
      case "border":
      case "border-width":
      case "border-style":
      case "border-left":
      case "border-top":
      case "border-right":
      case "border-bottom":
      case "border-left-width":
      case "border-left-style":
      case "border-top-width":
      case "border-top-style":
      case "border-right-width":
      case "border-right-style":
      case "border-bottom-width":
      case "border-bottom-style":
      case "border-top-left-radius":
      case "border-top-right-radius":
      case "border-bottom-left-radius":
      case "border-bottom-right-radius":
      case "border-top-color":
      case "border-bottom-color":
      case "border-left-color":
      case "border-right-color":
        tab_to_open = "bordersButton";
        iframeElementSelect.setAttribute('box-edit', 'bordersButton');
        break;
      case "outline-width":
      case "outline-offset":
      case "outline-color":
      case "outline-style":
        tab_to_open = "outlineButton";
        break;
      case "overflow":
      case "overflow-x":
      case "overflow-y":
        tab_to_open = "overflowButton";
        break;
      case "float":
      case "clear":
        tab_to_open = "floatButton";
        break;
      case "z-index":
        tab_to_open = "stackButton";
        break;
      case "cursor":
        tab_to_open = "cursorButton";
        break;
      case "font-family":
      case "font-size":
      case "letter-spacing":
      case "line-height":
      case "font-weight":
      case "font-style":
        tab_to_open = "fontsButton";
        break;
      case "text-align":
      case "text-align-last":
      case "text-transform":
      case "text-decoration":
      case "text-decoration-line":
      case "direction":
      case "unicode-bidi":
      case "vertical-align":
      case "text-decoration-color":
      case "text-decoration-style":
      case "text-decoration-thickness":
        tab_to_open = "textButton";
        break;
      case "list-style":
      case "list-style-type":
      case "list-style-position":
      case "list-style-image":
        tab_to_open = "listButton";
        break;
      case "text-shadow":
        tab_to_open = "shadowsButtonText";
        break;
      case "box-shadow":
        tab_to_open = "shadowsButton";
        break;
      case "background-image":
      case "background-repeat":
      case "background-size":
      case "background-position-x":
      case "background-position-y":
      case "background-attachment":
      case "background-blend-mode":
      case "background-origin":
      case "background-clip":
        tab_to_open = "backgroundButton";
        break;
      case "background":
        tab_to_open = "gradientButton";
        break;
      case "filter":
        tab_to_open = "filtersButton";
        break;
      case "transform":
      case "transform-origin":
        tab_to_open = "transformButton";
        break;
      case "transition":
        tab_to_open = "transitionButton";
        break;
      default:
        tab_to_open = "customPropertyButton";
        con("no property for: " + property);
        break;
    }
    if (tab_to_open) {
      var allinnertabs = document.querySelectorAll('.sectionInnerWrap');
      [].forEach.call(allinnertabs, function (el) {
        el.classList.add('sectionInnerWrap--no-transition');
      });
      simulateMouseEvent(domID(tab_to_open), "mousedown");
      if (!no_update) {
        domID(tab_to_open).parentElement.scrollIntoView({
          behavior: "auto",
          block: "start",
          inline: "center"
        });
      }
      [].forEach.call(allinnertabs, function (el) {
        el.classList.remove('sectionInnerWrap--no-transition');
      });
    }
  }

  var disabletempscroll = false;

  function getPreviousSibling(elem, selector) {
    // Get the next sibling element
    var sibling = elem.previousElementSibling;
    // If there's no selector, return the first sibling
    if (!selector) return sibling;
    // If the sibling matches our selector, use it
    // If not, jump to the next sibling and continue the loop
    while (sibling) {
      if (sibling.matches(selector)) return sibling;
      sibling = sibling.previousElementSibling;
    }
  }



  function jumpToClassInTextarea() {
    // CSS
    var checkwith = INPUTER1.value;
    var found_bp = 'found_bp_' + 0;
    var found_bp_inc = 0;
    var prism_breakpoint;
    var w = window.innerWidth;
    // unwrap all token value
    let token_values = [...prism_css.querySelectorAll('.token-value')];
    token_values.map(el => {
      let parent = el.parentNode;
      while (el.firstChild) parent.insertBefore(el.firstChild, el);
      parent.removeChild(el);
    });

    prism_css.innerHTML = prism_css.innerHTML
      .replaceAll('<span class="token punctuation">:</span>', `<span class="token punctuation">:</span><span class="token-value">`)
      .replaceAll('<span class="token punctuation">;</span>', `</span><span class="token punctuation">;</span>`);

    var prism_els = prism_css.querySelectorAll("*:not(.token-value)");
    token_values = [...prism_css.querySelectorAll('.token-value')];
    token_values.map(el => {
      if (el
        .previousSibling
        .previousSibling
        .previousSibling
        .previousSibling
        .previousSibling
        .textContent === 'and') {
        el.removeAttribute('contenteditable');
        el.classList.add('property');
        if (el.parentElement.classList.contains("atrule")) {
          el.onclick = function () {
            BREAKPOINT_SETTINGS_toggle();
          };
        }
        return;
      } else {
        el.setAttribute('contenteditable', true);
      }

      let class_str;
      let property_str;
      let value_str;

      el.onfocus = (e) => {
        class_str = '';
        property_str = '';
        value_str = '';
      };

      el.onkeydown = (e) => {
        var keycode = (e.keyCode ? e.keyCode : e.which);
        if (keycode === 13) {
          e.preventDefault();
          // Enter
          el.blur();
          return false;
        }
        class_str = '';
        property_str = '';
        value_str = '';
      };

      el.onkeyup = (e) => {
        let selector_el = getPreviousSibling(el, '.token.selector');
        if (!selector_el) {
          return false;
        }

        if (w < breakPoint_MD_Value + scrollbox_width_resizer_vars_min_width) {
          // small screen do nothing
        } else {
          let data_mq_el = getPreviousSibling(el, '.token.property');
          let data_mq_el_val = data_mq_el.getAttribute("data-mq");
          if (data_mq_el_val) {
            if (data_mq_el_val.indexOf(".")) {
              data_mq_el_val = data_mq_el_val.split(".")[0];
            }
            data_mq_el_val = Number(data_mq_el_val);
            SCROLLBOX_HANDEL.value = data_mq_el_val.toString();
            setScrollboxResizeBlocker();
            ScrollboxResizer(data_mq_el_val);
          }
        }
        class_str = getPreviousSibling(el, '.token.selector').innerText;
        property_str = getPreviousSibling(el, '.token.property').innerText;
        value_str = el.innerText.trim();
        INPUTER1.value = class_str;
        INPUTER2.value = property_str;
        INPUTER3.value = value_str;
        placeInHeadTempCSS_func(value_str);
        BoxRefresh();
      };
      el.onblur = (e) => {
        if (!class_str && !property_str && !value_str) {
          return false;
        }
        INPUTER1.value = class_str;
        INPUTER2.value = property_str;
        INPUTER3.value = value_str;
        const applied = clickAdder();
        placeInHeadTempCSS_func();
        if (applied !== false) {
          recoveryCSSDrafts.delete(el);
          if (!recoveryCSSDrafts.size) recoveryDrafts.delete('prism_css');
        }
        FillUndo();
        setTimeout(() => {
          BoxRefresh();
          FillValueReadouts();
        }, 10);
      };
    });

    if (mobileFirst) {
      prism_breakpoint = breakPoint_Min_Value;
    } else {
      prism_breakpoint = SCROLLBOX_HANDEL.getAttribute("max");
    }
    var prism_class_is = "";
    [].forEach.call(prism_els, function (prism_el) {
      if (prism_el.classList.contains('atrule')) {
        found_bp_inc++;
        found_bp = 'found_bp_' + found_bp_inc;
        var grab_mq = prism_el.innerText;
        grab_mq = grab_mq.split(": ")[1];
        grab_mq = grab_mq.split("px")[0];
        prism_breakpoint = grab_mq;
      }
      if (prism_el.classList.contains('selector')) {
        if (prism_breakpoint) {
          prism_el.setAttribute("data-mq", prism_breakpoint);
        }
        var class_name = prism_el.innerText;
        prism_class_is = class_name;
        prism_el.onmouseup = function () {
          con(class_name);

          css_external();

          if (w < breakPoint_MD_Value + scrollbox_width_resizer_vars_min_width) {
            // small screen do nothing
          } else {
            let ScrollboxSizeVal = prism_el.getAttribute("data-mq");
            if (ScrollboxSizeVal.indexOf(".")) {
              ScrollboxSizeVal = ScrollboxSizeVal.split(".")[0];
            }
            ScrollboxSizeVal = Number(ScrollboxSizeVal);
            SCROLLBOX_HANDEL.value = ScrollboxSizeVal.toString();
            setScrollboxResizeBlocker();
            ScrollboxResizer(ScrollboxSizeVal);
          }

          INPUTER1.value = class_name;
          inputerColor(INPUTER1);
          INPUTER2.value = "";
          INPUTER3.value = "";
          FillValueReadouts();
          populateClassesDropdown();

          // get first item with this class and jump to it

          // var has_pseudo = checkIfPseudo(INPUTER1.value);
          // if (!has_pseudo && INPUTER1.value.indexOf(' ') === -1 && INPUTER1.value.indexOf(',') === -1) {
          //   disabletempscroll = true;

          //   var el_with_class = frameSelectorAll(INPUTER1.value)[0];
          //   //var el_with_class = iframeContents.querySelector(INPUTER1.value);
          //   if (el_with_class) {
          //     selectElement(el_with_class);
          //   }
          // } else {
          //   disabletempscroll = true;
          //   deselectElement();
          //   INPUTER1.value = class_name;
          //   FillValueReadouts();

          //   if (w < breakPoint_MD_Value + scrollbox_width_resizer_vars_min_width) {
          //     // small screen do nothing
          //   } else {
          //     setScrollboxResizeBlocker();
          //     ScrollboxResizer(ScrollboxSizeVal);
          //   }

          //   INPUTER1.value = class_name;
          // }
        };
        if (prism_el.innerText === checkwith) {
          prism_el.classList.add(found_bp);
        }
      }
      if (prism_el.classList.contains("property")) {
        if (prism_breakpoint) {
          prism_el.setAttribute("data-mq", prism_breakpoint);
        }
        prism_el.setAttribute("data-cls", prism_class_is);
        // if (prism_el.parentElement.classList.contains("atrule")) {
        //   prism_el.onclick = function () {
        //     BREAKPOINT_SETTINGS_toggle();
        //   };
        // } else {
        prism_el.onmouseup = function () {

          css_external();

          if (w < breakPoint_MD_Value + scrollbox_width_resizer_vars_min_width) {
            // small screen do nothing
          } else {
            let ScrollboxSizeVal = prism_el.getAttribute("data-mq");
            if (ScrollboxSizeVal.indexOf(".")) {
              ScrollboxSizeVal = ScrollboxSizeVal.split(".")[0];
            }
            ScrollboxSizeVal = Number(ScrollboxSizeVal);
            SCROLLBOX_HANDEL.value = ScrollboxSizeVal.toString();
            setScrollboxResizeBlocker();
            ScrollboxResizer(ScrollboxSizeVal);
          }

          INPUTER1.value = prism_el.getAttribute("data-cls");
          inputerColor(INPUTER1);
          INPUTER2.value = prism_el.innerText;
          openTabForProperty(INPUTER2.value);
          simulateMouseEvent(INPUTER2, "input");
          FillValueReadouts();
          // get first item with this class and jump to it
          populateClassesDropdown();



          // var has_pseudo = checkIfPseudo(INPUTER1.value);
          // if (!has_pseudo && INPUTER1.value.indexOf(' ') === -1 && INPUTER1.value.indexOf(',') === -1) {
          //   disabletempscroll = true;
          //   //var el_with_class = iframeContents.querySelector(INPUTER1.value);
          //   var el_with_class = frameSelectorAll(INPUTER1.value)[0];
          //   if (el_with_class) {
          //     selectElement(el_with_class);
          //   }
          // } else {
          //   disabletempscroll = true;
          //   deselectElement();
          //   INPUTER1.value = prism_el.getAttribute("data-cls");
          //   FillValueReadouts();
          //   if (w < breakPoint_MD_Value + scrollbox_width_resizer_vars_min_width) {
          //     // small screen do nothing
          //   } else {
          //     setScrollboxResizeBlocker();
          //     ScrollboxResizer(ScrollboxSizeVal);
          //   }
          //   INPUTER1.value = prism_el.getAttribute("data-cls");
          // }
        };
        //}
      }

      if (prism_el.classList.contains("rule") && prism_el.innerText === '@media') {
        prism_el
          .nextElementSibling
          .nextElementSibling
          .nextElementSibling
          .nextElementSibling
          .classList.add('follows-rule');
      }



    });
    var found_bp_0 = prism_css.querySelector(".found_bp_0");
    var found_bp_1 = prism_css.querySelector(".found_bp_1");
    var found_bp_2 = prism_css.querySelector(".found_bp_2");
    var found_bp_3 = prism_css.querySelector(".found_bp_3");
    if (found_bp_0) {
      found_bp_0.classList.add('prism_css_selector_HL_other_BP');
      found_bp_0.classList.remove('prism_css_selector_HL');
    }
    if (found_bp_1) {
      found_bp_1.classList.add('prism_css_selector_HL_other_BP');
      found_bp_1.classList.remove('prism_css_selector_HL');
    }
    if (found_bp_2) {
      found_bp_2.classList.add('prism_css_selector_HL_other_BP');
      found_bp_2.classList.remove('prism_css_selector_HL');
    }
    if (found_bp_3) {
      found_bp_3.classList.add('prism_css_selector_HL_other_BP');
      found_bp_3.classList.remove('prism_css_selector_HL');
    }
    var active_el;
    var inactive_els;
    if (mobileFirst) {
      switch (breakPoint) {
        case "fullWidth":
          active_el = found_bp_3;
          inactive_els = found_bp_2 || found_bp_1 || found_bp_0;
          break;
        case "breakPoint1":
          active_el = found_bp_2;
          inactive_els = found_bp_1 || found_bp_0;
          break;
        case "breakPoint2":
          active_el = found_bp_1;
          inactive_els = found_bp_0;
          break;
        case "breakPoint3":
          active_el = found_bp_0;
          break;
      }
    } else {
      switch (breakPoint) {
        case "fullWidth":
          active_el = found_bp_0;
          break;
        case "breakPoint1":
          active_el = found_bp_1;
          inactive_els = found_bp_0;
          break;
        case "breakPoint2":
          active_el = found_bp_2;
          inactive_els = found_bp_1 || found_bp_0;
          break;
        case "breakPoint3":
          active_el = found_bp_3;
          inactive_els = found_bp_2 || found_bp_1 || found_bp_0;
          break;
      }
    }

    if (active_el) {
      active_el.classList.remove('prism_css_selector_HL_other_BP');
      active_el.classList.add('prism_css_selector_HL');
      if (autoScroll) {
        if (!disabletempscroll) {
          active_el.scrollIntoView({
            behavior: "auto",
            block: "center",
            inline: "center"
          });
        } else {
          setTimeout(() => {
            disabletempscroll = false;
          }, 100);
        }
      }
      info("", null, null);
    } else if (inactive_els) {
      if (autoScroll) {
        if (!disabletempscroll) {
          inactive_els.scrollIntoView({
            behavior: "auto",
            block: "center",
            inline: "center"
          });
        } else {
          setTimeout(() => {
            disabletempscroll = false;
          }, 100);
        }
      }

      info("Classes are set at other screen sizes, styles maybe inherited", null, null);
    } else {
      info("No class set at this screen size and no styles are inherited from others", null, null);
    }

    // HTML
    var number_of_class = 1;
    var prism_els_HTML = prism_html.querySelectorAll("*");
    let current_selection_class;

    if (frameID(domElement[0])) {
      current_selection_class = frameID(domElement[0]).className;
    }

    [].forEach.call(prism_els_HTML, function (prism_el) {
      if (current_selection_class && prism_el.innerText.indexOf(`class="${current_selection_class}"`) > -1) {
        prism_el.classList.add('prism_html_selector_HL_other');
        prism_el.setAttribute('data-selectornumber', number_of_class);
        number_of_class++;
      }
    });

    var domtree_active_number = document.querySelector('.domTree_HL .domTreeClassColor--active');
    if (domtree_active_number) {
      var active_number = domtree_active_number.getAttribute('data-selectornumberdomtree');
      //con(active_number);
      var scrolltohtml = prism_html.querySelector('[data-selectornumber="' + active_number + '"]');
      if (scrolltohtml) {
        scrolltohtml.classList.add('prism_html_selector_HL');
        if (autoScroll) {
          scrolltohtml.scrollIntoView({
            behavior: "auto",
            block: "center",
            inline: "center"
          });
        }
      }
    }
  }
  // ---------------------------------------------------
  // ----------------------------------------------------
  // Copy code to the clipboard from codeView

  function copyToClipboard(el) {
    var range = document.createRange();
    range.selectNode(el);
    window.getSelection().removeAllRanges(); // clear current selection
    window.getSelection().addRange(range); // to select text
    document.execCommand("copy");
    window.getSelection().removeAllRanges(); // to deselect
  }


  copyHTML.addEventListener("click", function () {
    try {
      copyToClipboard(prism_html);
      info("Copied HTML to clipboard.", null, null);
    } catch (err) {
      info("Oops, unable to copy " + err, null, null);
    }
  });
  copyCSS.addEventListener("click", function () {
    try {
      copyToClipboard(prism_css);
      info("Copied CSS to clipboard.", null, null);
    } catch (err) {
      info("Oops, unable to copy " + err, null, null);
    }
  });
  domEvent(domID("siteTitle"), "mousedown", function (e) {
    e.preventDefault();
  });

  // ---------------------------------------------------
  // ----------------------------------------------------
  // modals logic

  function viewModal_on(modal) {
    var Rect = modal.getBoundingClientRect();
    var w = window.innerWidth;
    var h = window.innerHeight;
    modal.style.opacity = "1";
    modal.style.top = (h / 2) - (Rect.height / 2) + 'px';
    modal.style.left = (w / 2) - (Rect.width / 2) + 'px';
    return true;
  }

  function viewModal_off(modal) {
    var Rect = modal.getBoundingClientRect();
    var w = window.innerWidth;
    modal.style.opacity = null;
    modal.style.top = null;
    modal.style.left = (w / 2) - (Rect.width / 2) + 'px';
    return false;
  }

  // ---------------------------------------------------
  // ----------------------------------------------------
  // OTP-only authentication without navigating away from the editor.
  function isDomposerAuthenticated() {
    var state = domID('domposerAuthState');
    return !!state && state.value.trim() === '1';
  }

  function setDomposerAuthenticated(authenticated) {
    var state = domID('domposerAuthState');
    if (state) {
      state.value = authenticated ? '1' : '0';
    }
    ['projects', 'storagelevel'].forEach(function (id) {
      var control = domID(id);
      if (control) {
        if (authenticated) {
          control.style.removeProperty('display');
        } else {
          control.style.display = 'none';
        }
      }
    });
  }

  var loginModal_on = false;
  var loginPanel = domID("loginPanel");
  var loginPanel_form = document.querySelector("#loginPanel form");
  var login_btn = domID("login");
  var closeLogin = domID("closeLogin");
  var authStep = 'email';
  var authBusy = false;
  var authEmail = '';
  var authCooldowns = Object.create(null);
  var authCountdown;
  var authSuccessTimer = null;
  var otpCodeInput = domID('otp-code');
  var otpDigitBoxes = document.querySelectorAll('#otp-digit-boxes .otp-digit-box');
  var otpStatus = domID('otp-status');
  var otpResend = domID('otp-resend');
  var authSubmit = loginPanel_form && loginPanel_form.querySelector('button[type="submit"]');

  function clearAuthSuccessTimer() {
    if (authSuccessTimer !== null) {
      clearTimeout(authSuccessTimer);
      authSuccessTimer = null;
    }
  }

  function closeAuthModal() {
    clearAuthSuccessTimer();
    loginModal_on = false;
    viewModal_off(loginPanel);
  }

  function renderOtpDigits() {
    if (!otpCodeInput) {
      return;
    }
    var activeDigit = Math.min(5, otpCodeInput.selectionStart == null ? otpCodeInput.value.length : otpCodeInput.selectionStart);
    otpDigitBoxes.forEach(function (box, index) {
      box.textContent = otpCodeInput.value.charAt(index);
      box.classList.toggle('is-active', document.activeElement === otpCodeInput && index === activeDigit);
    });
  }

  function setOtpStatus(message, isError) {
    if (!otpStatus) {
      return;
    }
    otpStatus.textContent = message || '';
    otpStatus.hidden = !message;
    otpStatus.classList.toggle('auth-error', !!isError);
  }

  function updateAuthCountdown() {
    if (!otpResend) {
      return;
    }
    var remaining = Math.max(0, Math.ceil(((authCooldowns[authEmail] || 0) - Date.now()) / 1000));
    otpResend.textContent = remaining ? 'Resend code in ' + remaining + 's' : 'Resend code';
    otpResend.disabled = authBusy || remaining > 0;
    if (!remaining && authCountdown) {
      clearInterval(authCountdown);
      authCountdown = null;
    }
  }

  function setAuthBusy(busy) {
    authBusy = busy;
    loginPanel_form.setAttribute('aria-busy', busy ? 'true' : 'false');
    loginPanel_form.querySelectorAll('button').forEach(function (button) {
      button.disabled = busy || authStep === 'success';
    });
    closeLogin.disabled = busy && authStep !== 'success';
    updateAuthCountdown();
  }

  function showAuthStep(step) {
    authStep = step;
    var copy = {
      email: ['Welcome to Domposer', 'Sign in to save your projects and continue building.', 'Continue with email'],
      verify: ['Check your email', "We've sent a 6-digit code to", 'Verify and sign in'],
      name: ['Create your account', 'Save your projects and pick up where you left off.', 'Create account'],
      success: ["You're signed in!", '', '']
    }[step];
    domID('auth-title').textContent = copy[0];
    domID('auth-description').textContent = copy[1];
    authSubmit.textContent = copy[2];
    loginPanel_form.querySelectorAll('[data-auth-screen]').forEach(function (element) {
      var visible = element.getAttribute('data-auth-screen').split(' ').indexOf(step) !== -1;
      element.hidden = !visible;
      element.querySelectorAll('input').forEach(function (input) {
        input.disabled = !visible;
        input.required = visible;
      });
    });
    var emailDisplay = domID('auth-email');
    emailDisplay.textContent = authEmail;
    emailDisplay.hidden = step !== 'verify' && step !== 'name';
    setOtpStatus('', false);
    updateAuthCountdown();
    if (loginModal_on) {
      viewModal_on(loginPanel);
      var focusInput = step === 'success' ? closeLogin : domID(step === 'verify' ? 'otp-code' : step === 'name' ? 'name' : 'email');
      focusInput.focus();
    }
    renderOtpDigits();
  }

  function authError(error) {
    var errors = error.response && error.response.data && error.response.data.errors;
    var message = errors && (errors.otp || errors.email || errors.name) ||
      (error.response && error.response.data && error.response.data.message) ||
      error.message || 'Unable to sign in. Please try again.';
    setOtpStatus(Array.isArray(message) ? message[0] : message, true);
  }

  function finishAuthentication(response, accountCreated) {
    if (!response.data || response.data.success !== true || !response.data.user) {
      throw new Error((response.data && response.data.message) || 'Unable to complete sign in.');
    }
    var csrfToken = response.data.csrf_token;
    if (typeof csrfToken !== 'string' || !csrfToken) {
      throw new Error('Unable to synchronize sign-in security. Please refresh before saving.');
    }
    var csrfMeta = document.querySelector('meta[name="csrf-token"]');
    if (csrfMeta) {
      csrfMeta.content = csrfToken;
    }
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    document.querySelectorAll('input[type="hidden"][name="_token"]').forEach(function (input) {
      input.value = csrfToken;
    });
    var user = response.data.user;
    var userIdentity = domID('userIdentity');
    if (userIdentity) {
      var userIcon = userIdentity.querySelector('i');
      if (!userIcon) {
        userIcon = document.createElement('i');
        userIcon.className = 'material-icons';
        userIcon.style.marginRight = '0';
        userIdentity.insertBefore(userIcon, userIdentity.firstChild);
      }
      userIcon.textContent = 'person';
      userIcon.title = (user.name || user.email) + '\n' + user.email + '\nemail ' + (user.verified ? 'verified' : 'unverified');
      userIcon.classList.toggle('green', user.verified === true);
      userIcon.classList.toggle('red', user.verified !== true);

      var userLabel = domID('userIdentityName');
      if (!userLabel) {
        userLabel = document.createElement('span');
        userLabel.id = 'userIdentityName';
        userLabel.style.fontSize = '0.8rem';
        userIdentity.appendChild(userLabel);
      }
      userLabel.textContent = user.name || user.email || 'User';
      userIdentity.style.display = 'inline-flex';
      userIdentity.style.alignItems = 'center';
      userIdentity.style.gap = '0.5rem';
    }

    var loginButton = domID('login');
    if (loginButton) {
      loginButton.style.display = 'none';
    }
    var logoutButton = domID('logout');
    if (logoutButton) {
      logoutButton.style.removeProperty('display');
    }
    var authControls = domID('authToolbarControls');
    if (authControls) {
      authControls.style.removeProperty('display');
    }

    setDomposerAuthenticated(true);
    clearAuthSuccessTimer();
    showAuthStep('success');
    domID('auth-title').textContent = accountCreated ? 'Account created!' : "You're signed in!";
    domID('auth-description').textContent = (accountCreated ? 'Welcome to Domposer, ' : 'Welcome back, ') + (user.name || user.email || 'User') + '.';
    setAuthBusy(false);
    if (loginModal_on) {
      closeLogin.focus();
      viewModal_on(loginPanel);
    }
    authSuccessTimer = setTimeout(closeAuthModal, 3000);
  }

  function requestAuthCode() {
    if (authBusy || authStep === 'success') {
      return;
    }
    var requestedEmail = domID('email').value.trim().toLowerCase();
    authEmail = requestedEmail;
    if ((authCooldowns[authEmail] || 0) > Date.now()) {
      showAuthStep('verify');
      if (!authCountdown) {
        authCountdown = setInterval(updateAuthCountdown, 1000);
      }
      return;
    }
    setOtpStatus('', false);
    setAuthBusy(true);
    axios.post('/otp/request', { email: requestedEmail })
      .then(function (response) {
        if (!response.data || response.data.success !== true) {
          throw new Error((response.data && response.data.message) || 'Unable to send your code.');
        }
        authCooldowns[requestedEmail] = Date.now() + 60000;
        otpCodeInput.value = '';
        showAuthStep('verify');
        clearInterval(authCountdown);
        authCountdown = setInterval(updateAuthCountdown, 1000);
      })
      .catch(function (error) {
        authError(error);
        var message = error.response && error.response.data && error.response.data.errors && error.response.data.errors.email;
        if (message && String(message).indexOf('wait 60 seconds') !== -1) {
          authCooldowns[requestedEmail] = Date.now() + 60000;
          clearInterval(authCountdown);
          authCountdown = setInterval(updateAuthCountdown, 1000);
        }
      })
      .then(function () { setAuthBusy(false); });
  }

  if (loginPanel_form) {
    loginPanel_form.onsubmit = function (event) {
      event.preventDefault();
      if (authBusy || authStep === 'success') {
        return;
      }
      if (authStep === 'email') {
        requestAuthCode();
        return;
      }
      var endpoint;
      var data;
      if (authStep === 'verify') {
        var code = otpCodeInput.value.trim();
        if (!/^\d{6}$/.test(code)) {
          setOtpStatus('Enter the six-digit code sent to your email.', true);
          return;
        }
        endpoint = '/otp/verify';
        data = { email: authEmail, otp: code, remember: true };
      } else {
        endpoint = '/otp/register';
        data = { name: domID('name').value.trim() };
      }
      setOtpStatus('', false);
      setAuthBusy(true);
      axios.post(endpoint, data)
        .then(function (response) {
          if (response.data && response.data.success === true && response.data.needs_username === true) {
            showAuthStep('name');
            return;
          }
          finishAuthentication(response, endpoint === '/otp/register');
        })
        .catch(authError)
        .then(function () { setAuthBusy(false); });
    };
    otpResend.onclick = requestAuthCode;
    domID('otp-change-email').onclick = domID('auth-start-again').onclick = function () {
      if (!authBusy) {
        otpCodeInput.value = '';
        showAuthStep('email');
      }
    };
    otpCodeInput.addEventListener('input', function () {
      this.value = this.value.replace(/\D/g, '').slice(0, 6);
      renderOtpDigits();
    });
    otpCodeInput.addEventListener('paste', function (event) {
      var code = event.clipboardData.getData('text').trim();
      if (/^\d{6}$/.test(code)) {
        event.preventDefault();
        this.value = code;
        this.setSelectionRange(code.length, code.length);
        renderOtpDigits();
      }
    });
    ['focus', 'blur', 'keyup', 'click', 'select', 'change'].forEach(function (eventName) {
      otpCodeInput.addEventListener(eventName, renderOtpDigits);
    });
    login_btn.onclick = function () {
      if (authBusy && authStep !== 'success') {
        return;
      }
      clearAuthSuccessTimer();
      loginModal_on = !loginModal_on;
      if (loginModal_on) {
        viewModal_on(loginPanel);
        var input = authStep === 'success' ? closeLogin : loginPanel_form.querySelector('input:not([type="hidden"]):not(:disabled)');
        if (input) { input.focus(); }
      } else {
        viewModal_off(loginPanel);
      }
    };
    closeLogin.onclick = function () {
      if (!authBusy || authStep === 'success') {
        closeAuthModal();
        document.cookie = "registeredUser=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      }
    };
    showAuthStep('email');
    viewModal_off(loginPanel);
    if (loginPanel.querySelector('.invalid-feedback') || getCookie('registeredUser') || new URLSearchParams(window.location.search).has('signin')) {
      setTimeout(function () {
        clearAuthSuccessTimer();
        loginModal_on = true;
        viewModal_on(loginPanel);
        domID('email').focus();
      }, 1000);
    }
  }

  function getCookie(cname) {
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].trim();
      if (cookie.indexOf(cname + '=') === 0) {
        return decodeURIComponent(cookie.substring(cname.length + 1));
      }
    }
    return '';
  }

  var projectsViewModal_on = false;
  var viewProjects = domID("viewProjects");
  var projects_btn = domID("projects");
  var closeviewProjects = domID("closeviewProjects");
  var projectsRefreshPending = false;

  function refreshProjectsModal() {
    return axios.get("/", { headers: { "Accept": "text/html" } }).then(function (response) {
      var fetchedPage = new DOMParser().parseFromString(response.data, "text/html");
      var fetchedModal = fetchedPage.getElementById("viewProjects");
      var fetchedForms = fetchedModal && fetchedModal.querySelector(".project-forms");
      var existingForms = viewProjects.querySelector(".project-forms");
      if (!fetchedForms || !existingForms || fetchedModal.style.display === "none") {
        throw new Error("Unable to load your projects.");
      }
      fetchedModal.querySelectorAll("script").forEach(function (script) {
        script.remove();
      });

      var existingNewForm = viewProjects.querySelector("#apiPostZipFiles");
      var fetchedNewForm = fetchedForms.querySelector("#apiPostZipFiles");
      if (existingNewForm) {
        existingNewForm.hidden = !fetchedNewForm;
        if (fetchedNewForm) {
          fetchedNewForm.replaceWith(existingNewForm);
        } else {
          fetchedForms.appendChild(existingNewForm);
        }
      }
      var existingList = viewProjects.querySelector(".project-list");
      var fetchedList = fetchedModal.querySelector(".project-list");
      if (existingList) {
        existingList.remove();
      }
      if (fetchedList) {
        viewProjects.insertBefore(fetchedList, existingForms);
      }
      existingForms.replaceWith(fetchedForms);
      var updateFile = viewProjects.querySelector("#update-file");
      if (updateFile) {
        relabelChooseFile(updateFile);
      }
    });
  }

  if (projects_btn && viewProjects && closeviewProjects) {
    domID("projects").onclick = function () {
      if (!isDomposerAuthenticated() || projectsRefreshPending) {
        return;
      }
      if (projectsViewModal_on) {
        projectsView_toggle();
        return;
      }
      projectsRefreshPending = true;
      refreshProjectsModal().catch(function () {
        info("Unable to refresh projects. Please try again.", false, true);
      }).then(function () {
        projectsRefreshPending = false;
        if (!isDomposerAuthenticated()) { return; }
        viewProjects.style.removeProperty("display");
        projectsView_toggle();
      });
    };
    domID("closeviewProjects").onclick = function () {
      projectsView_toggle();
    };
    viewModal_off(viewProjects);
  } else if (projects_btn && viewProjects && !closeviewProjects) {

    viewModal_off(viewProjects);
    setTimeout(function () {
      if (isDomposerAuthenticated()) { viewModal_on(viewProjects); }
    }, 1000);
  }

  function projectsView_toggle() {
    if (!isDomposerAuthenticated()) { return; }
    if (projectsViewModal_on === false) {
      projectsViewModal_on = viewModal_on(viewProjects);
    } else {
      projectsViewModal_on = viewModal_off(viewProjects);
    }
  }

  var newProjectForm = domID("apiPostZipFiles");
  if (newProjectForm) {
    newProjectForm.addEventListener("submit", function (event) {
      if (!isDomposerAuthenticated()) {
        event.preventDefault();
        return;
      }
      var newProjectFile = domID("new-file");
      if (newProjectFile && newProjectFile.files && newProjectFile.files.length) {
        return;
      }

      event.preventDefault();
      var projectNameField = domID("new-projectname");
      var projectDescriptionField = domID("new-description");
      var projectNameValue = projectNameField ? projectNameField.value.trim() : "";
      if (!projectNameValue) {
        if (projectNameField) {
          projectNameField.focus();
        }
        return;
      }

      saveOrDownloadFiles(true, false, false, {
        projectname: projectNameValue,
        description: projectDescriptionField ? projectDescriptionField.value.trim() : ""
      });
    });
  }

  function relabelChooseFile(input) {
    var label = input.previousElementSibling;
    var labelVal = label.innerHTML;
    input.addEventListener('change', function (e) {
      var fileName = '';
      if (input.files && input.files.length > 1) {
        fileName = (input.getAttribute('data-multiple-caption') || '').replace('{count}', input.files.length);
      } else {
        fileName = e.target.value.split('\\').pop();
      }
      if (fileName) {
        label.querySelector('span').textContent = fileName;
      } else {
        label.innerHTML = labelVal;
      }
    });
  }

  if (domID("new-file")) {
    relabelChooseFile(domID("new-file"));
  }
  if (domID("update-file")) {
    relabelChooseFile(domID("update-file"));
  }

  var logo = domID("logo");
  if (logo) {
    logo.onclick = function () {
      window.location.reload();
    };
  }

  function logoutCurrentProject() {
    if (logoutRequestPending) { return; }
    logoutRequestPending = true;
    return axios.post('/projects/logout', {}, { headers: { 'Accept': 'application/json' } }).then(function () {
      setDomposerAuthenticated(false);
      ["currentProject", "projectName", "projectDescription"].forEach(function (id) {
        var field = domID(id);
        if (field) {
          field.value = "";
        }
        localStorage.removeItem(id);
        sessionStorage.removeItem(id);
      });
      window.location = '/';
    }).catch(function (error) {
      logoutRequestPending = false;
      logoutInProgress = false;
      var message = error.response && error.response.data && error.response.data.message;
      info(message || 'Unable to sign out. Please try again.', false, true);
    });
  }

  function confirmSaveLogout() {
    if (fullScreenMode) {
      logoutCurrentProject();
    } else {
      var r = confirm("Save project?");
      if (r == true) {
        if (saveOrDownloadFiles(true, true, false) === false) {
          logoutInProgress = false;
        }
      } else {
        logoutCurrentProject();
      }
    }
  }

  var logoutInProgress = false;
  var logoutRequestPending = false;
  var logout_btn = domID("logout");
  if (logout_btn) {
    document.cookie = "registeredUser=true";
    logout_btn.onclick = function () {
      if (logoutInProgress) {
        return;
      }
      logoutInProgress = true;
      confirmSaveLogout();
    };
  }

  // new color picker code

  function colorFunction2(passedcolor) {
    if (!INPUTER1.value) {
      return false;
    }
    INPUTER2.value = "color";
    INPUTER3.value = passedcolor;
    clickAdder(null);
  }

  function colorFunction2_bg(passedcolor) {
    if (!INPUTER1.value) {
      return false;
    }
    if (!passedcolor) {
      return false;
    }
    INPUTER2.value = "background-color";
    INPUTER3.value = passedcolor;
    clickAdder(null);
  }

  function setColorsOnColorInputs() {

    setTimeout(function () {

      if (!frameID(domElement[0])) {
        return false;
      }

      let frame_style = frameID(domElement[0]).style;

      if (!CSSstyles) {
        unblockIframe();
        media_color.removeAttribute('style');
        media_color_bg.removeAttribute('style');
        media_color_triangle.removeAttribute('style');
        media_color_triangle_bg.removeAttribute('style');
        media_color.removeAttribute("data-mediacolor");
        media_color_bg.removeAttribute("data-mediacolor");
        colorinput.style.background = "";
        colorinput_bg.style.background = "";
        colorinputTriangle.style.fill = "none";
        colorinputTriangle_bg.style.fill = "none";
        picker.source.value = "";
        picker_bg.source.value = "";
        return false;
      }

      let set_color = "";
      if (frame_style["color"]) {
        set_color = frame_style["color"];
      } else if (CSSstyles["color"]) {
        set_color = CSSstyles["color"];
      }

      let set_bg_color = "";
      if (frame_style["background-color"]) {
        set_bg_color = frame_style["background-color"];
      } else if (CSSstyles["background-color"]) {
        set_bg_color = CSSstyles["background-color"];
      }

      if (INPUTER2.value === "color") {
        INPUTER3.value = set_color;
      }
      if (INPUTER2.value === "background-color") {
        INPUTER3.value = set_bg_color;
      }

      colorinput.style.background = set_color;
      colorinputTriangle.style.fill = color2NoAlpha(set_color);
      picker.source.value = set_color_for_picker(set_color) || "";

      colorinput_bg.style.background = set_bg_color;
      colorinputTriangle_bg.style.fill = color2NoAlpha(set_bg_color);
      picker_bg.source.value = set_color_for_picker(set_bg_color) || "";

      var colors_arr = [];

      //con(breakPoint);

      var inherited_colors_obj = {
        "thecss": {
          "color": "",
          "background-color": ""
        },
        "thecssBP1": {
          "color": "",
          "background-color": ""
        },
        "thecssBP2": {
          "color": "",
          "background-color": ""
        },
        "thecssBP3": {
          "color": "",
          "background-color": ""
        },
      };

      function push_colors(key2, value2) {
        array_of_colour_propertys.forEach(function (key) {
          if (key2 === key) {
            var color_test = tinycolor(value2);
            if (color_test.isValid()) {
              if (colors_arr.indexOf(color_test.toHex8String()) === -1) {
                colors_arr.push(color_test.toHex8String());
              }
            }
          }
        });
      }

      for (const [key, value] of Object.entries(thecssLG)) {
        for (const [key2, value2] of Object.entries(value)) {
          if (key2 === 'color' || key2 === 'background-color') {
            if (key === INPUTER1.value) {
              inherited_colors_obj.thecss[key2] = value2;
            }
          }
          push_colors(key2, value2);
        }
      }
      for (const [key, value] of Object.entries(thecssMD)) {
        for (const [key2, value2] of Object.entries(value)) {
          if (key2 === 'color' || key2 === 'background-color') {
            if (key === INPUTER1.value) {
              inherited_colors_obj.thecssBP1[key2] = value2;
            }
          }
          push_colors(key2, value2);
        }
      }
      for (const [key, value] of Object.entries(thecssSM)) {
        for (const [key2, value2] of Object.entries(value)) {
          if (key2 === 'color' || key2 === 'background-color') {
            if (key === INPUTER1.value) {
              inherited_colors_obj.thecssBP2[key2] = value2;
            }
          }
          push_colors(key2, value2);
        }
      }
      for (const [key, value] of Object.entries(thecssXS)) {
        for (const [key2, value2] of Object.entries(value)) {
          if (key2 === 'color' || key2 === 'background-color') {
            if (key === INPUTER1.value) {
              inherited_colors_obj.thecssBP3[key2] = value2;
            }
          }
          push_colors(key2, value2);
        }
      }
      media_color.removeAttribute('style');
      media_color_bg.removeAttribute('style');
      media_color.removeAttribute("data-mediacolor");
      media_color_bg.removeAttribute("data-mediacolor");
      media_color_triangle.removeAttribute('style');
      media_color_triangle_bg.removeAttribute('style');
      if (mobileFirst) {
        // this is mobile first
        switch (breakPoint) {
          case "fullWidth":
            // inherits BP3 & BP2 & BP1 
            // color
            if (inherited_colors_obj.thecssBP3['color']) {
              media_color.style.background = inherited_colors_obj.thecssBP3['color'];
              media_color.setAttribute('data-mediacolor', 'thecssBP3');
              media_color_triangle.style.fill = color2NoAlpha(inherited_colors_obj.thecssBP3['color']);
            }
            if (inherited_colors_obj.thecssBP2['color']) {
              media_color.style.background = inherited_colors_obj.thecssBP2['color'];
              media_color.setAttribute('data-mediacolor', 'thecssBP2');
              media_color_triangle.style.fill = color2NoAlpha(inherited_colors_obj.thecssBP2['color']);
            }
            if (inherited_colors_obj.thecssBP1['color']) {
              media_color.style.background = inherited_colors_obj.thecssBP1['color'];
              media_color.setAttribute('data-mediacolor', 'thecssBP1');
              media_color_triangle.style.fill = color2NoAlpha(inherited_colors_obj.thecssBP1['color']);
            }
            // background-color
            if (inherited_colors_obj.thecssBP3['background-color']) {
              media_color_bg.style.background = inherited_colors_obj.thecssBP3['background-color'];
              media_color_bg.setAttribute('data-mediacolor_bg', 'thecssBP3');
              media_color_triangle_bg.style.fill = color2NoAlpha(inherited_colors_obj.thecssBP3['background-color']);
            }
            if (inherited_colors_obj.thecssBP2['background-color']) {
              media_color_bg.style.background = inherited_colors_obj.thecssBP2['background-color'];
              media_color_bg.setAttribute('data-mediacolor_bg', 'thecssBP2');
              media_color_triangle_bg.style.fill = color2NoAlpha(inherited_colors_obj.thecssBP2['background-color']);
            }
            if (inherited_colors_obj.thecssBP1['background-color']) {
              media_color_bg.style.background = inherited_colors_obj.thecssBP1['background-color'];
              media_color_bg.setAttribute('data-mediacolor_bg', 'thecssBP1');
              media_color_triangle_bg.style.fill = color2NoAlpha(inherited_colors_obj.thecssBP1['background-color']);
            }
            break;
          case "breakPoint1":
            // inherits BP3 & BP2
            // color
            if (inherited_colors_obj.thecssBP3['color']) {
              media_color.style.background = inherited_colors_obj.thecssBP3['color'];
              media_color.setAttribute('data-mediacolor', 'thecssBP3');
              media_color_triangle.style.fill = color2NoAlpha(inherited_colors_obj.thecssBP3['color']);
            }
            if (inherited_colors_obj.thecssBP2['color']) {
              media_color.style.background = inherited_colors_obj.thecssBP2['color'];
              media_color.setAttribute('data-mediacolor', 'thecssBP2');
              media_color_triangle.style.fill = color2NoAlpha(inherited_colors_obj.thecssBP2['color']);
            }
            // background-color
            if (inherited_colors_obj.thecssBP3['background-color']) {
              media_color_bg.style.background = inherited_colors_obj.thecssBP3['background-color'];
              media_color_bg.setAttribute('data-mediacolor_bg', 'thecssBP3');
              media_color_triangle_bg.style.fill = color2NoAlpha(inherited_colors_obj.thecssBP3['background-color']);
            }
            if (inherited_colors_obj.thecssBP2['background-color']) {
              media_color_bg.style.background = inherited_colors_obj.thecssBP2['background-color'];
              media_color_bg.setAttribute('data-mediacolor_bg', 'thecssBP2');
              media_color_triangle_bg.style.fill = color2NoAlpha(inherited_colors_obj.thecssBP2['background-color']);
            }
            break;
          case "breakPoint2":
            // inherits BP3
            // color
            if (inherited_colors_obj.thecssBP3['color']) {
              media_color.style.background = inherited_colors_obj.thecssBP3['color'];
              media_color.setAttribute('data-mediacolor', 'thecssBP3');
              media_color_triangle.style.fill = color2NoAlpha(inherited_colors_obj.thecssBP3['color']);
            }
            // background-color
            if (inherited_colors_obj.thecssBP3['background-color']) {
              media_color_bg.style.background = inherited_colors_obj.thecssBP3['background-color'];
              media_color_bg.setAttribute('data-mediacolor_bg', 'thecssBP3');
              media_color_triangle_bg.style.fill = color2NoAlpha(inherited_colors_obj.thecssBP3['background-color']);
            }
            break;
          case "breakPoint3":
            // doesnt inhirit anything
            break;
        }
      } else {

        // this is desktop first

        switch (breakPoint) {
          case "fullWidth":
            // doesnt inhirit anything
            break;
          case "breakPoint1":
            // inhirit thecss 
            // color
            if (inherited_colors_obj.thecss['color']) {
              media_color.style.background = inherited_colors_obj.thecss['color'];
              media_color.setAttribute('data-mediacolor', 'thecss');
              media_color_triangle.style.fill = color2NoAlpha(inherited_colors_obj.thecss['color']);
            }
            // background-color
            if (inherited_colors_obj.thecss['background-color']) {
              media_color_bg.style.background = inherited_colors_obj.thecss['background-color'];
              media_color_bg.setAttribute('data-mediacolor_bg', 'thecss');
              media_color_triangle_bg.style.fill = color2NoAlpha(inherited_colors_obj.thecss['background-color']);
            }
            break;
          case "breakPoint2":
            // inhirit thecss & thecssBP1
            // color
            if (inherited_colors_obj.thecss['color']) {
              media_color.style.background = inherited_colors_obj.thecss['color'];
              media_color.setAttribute('data-mediacolor', 'thecss');
              media_color_triangle.style.fill = color2NoAlpha(inherited_colors_obj.thecss['color']);
            }
            if (inherited_colors_obj.thecssBP1['color']) {
              media_color.style.background = inherited_colors_obj.thecssBP1['color'];
              media_color.setAttribute('data-mediacolor', 'thecssBP1');
              media_color_triangle.style.fill = color2NoAlpha(inherited_colors_obj.thecssBP1['color']);
            }
            // background-color
            if (inherited_colors_obj.thecss['background-color']) {
              media_color_bg.style.background = inherited_colors_obj.thecss['background-color'];
              media_color_bg.setAttribute('data-mediacolor_bg', 'thecss');
              media_color_triangle_bg.style.fill = color2NoAlpha(inherited_colors_obj.thecss['background-color']);
            }
            if (inherited_colors_obj.thecssBP1['background-color']) {
              media_color_bg.style.background = inherited_colors_obj.thecssBP1['background-color'];
              media_color_bg.setAttribute('data-mediacolor_bg', 'thecssBP1');
              media_color_triangle_bg.style.fill = color2NoAlpha(inherited_colors_obj.thecssBP1['background-color']);
            }
            break;
          case "breakPoint3":
            // inhirit thecss & thecssBP1 & thecssBP2
            // color
            if (inherited_colors_obj.thecss['color']) {
              media_color.style.background = inherited_colors_obj.thecss['color'];
              media_color.setAttribute('data-mediacolor', 'thecss');
              media_color_triangle.style.fill = color2NoAlpha(inherited_colors_obj.thecss['color']);
            }
            if (inherited_colors_obj.thecssBP1['color']) {
              media_color.style.background = inherited_colors_obj.thecssBP1['color'];
              media_color.setAttribute('data-mediacolor', 'thecssBP1');
              media_color_triangle.style.fill = color2NoAlpha(inherited_colors_obj.thecssBP1['color']);
            }
            if (inherited_colors_obj.thecssBP2['color']) {
              media_color.style.background = inherited_colors_obj.thecssBP2['color'];
              media_color.setAttribute('data-mediacolor', 'thecssBP2');
              media_color_triangle.style.fill = color2NoAlpha(inherited_colors_obj.thecssBP2['color']);
            }
            // background-color
            if (inherited_colors_obj.thecss['background-color']) {
              media_color_bg.style.background = inherited_colors_obj.thecss['background-color'];
              media_color_bg.setAttribute('data-mediacolor_bg', 'thecss');
              media_color_triangle_bg.style.fill = color2NoAlpha(inherited_colors_obj.thecss['background-color']);
            }
            if (inherited_colors_obj.thecssBP1['background-color']) {
              media_color_bg.style.background = inherited_colors_obj.thecssBP1['background-color'];
              media_color_bg.setAttribute('data-mediacolor_bg', 'thecssBP1');
              media_color_triangle_bg.style.fill = color2NoAlpha(inherited_colors_obj.thecssBP1['background-color']);
            }
            if (inherited_colors_obj.thecssBP2['background-color']) {
              media_color_bg.style.background = inherited_colors_obj.thecssBP2['background-color'];
              media_color_bg.setAttribute('data-mediacolor_bg', 'thecssBP2');
              media_color_triangle_bg.style.fill = color2NoAlpha(inherited_colors_obj.thecssBP2['background-color']);
            }
            break;
        }
      }


      function clickTheMediaColourButton(bp) {
        switch (bp) {
          case 'thecss':
            clickedBP = true;
            fullWidth();
            break;
          case 'thecssBP1':
            clickedBP = true;
            breakPoint1();
            break;
          case 'thecssBP2':
            clickedBP = true;
            breakPoint2();
            break;
          case 'thecssBP3':
            clickedBP = true;
            breakPoint3();
            break;
        }
        cssStylesBreakPoints();
        clickedBP = false;
        selectElement(frameID(domElement[0]));
      }

      function roundUpNearest10(num) {
        return Math.ceil(num / 10) * 10;
      }

      media_color.onclick = function (e) {
        var bp = e.target.getAttribute("data-mediacolor");
        if (!bp) {
          return false;
        }
        clickTheMediaColourButton(bp);
        INPUTER2.value = 'color';
        INPUTER3.value = CSSstyles['color'];
      };

      media_color_bg.onclick = function (e) {
        var bp = e.target.getAttribute("data-mediacolor_bg");
        if (!bp) {
          return false;
        }
        clickTheMediaColourButton(bp);
        INPUTER2.value = 'background-color';
        INPUTER3.value = CSSstyles['background-color'];
      };

      if (colour_type_for_input === "color") {
        colorinput.style.borderColor = "#FFF";
        colorinput_bg.style.borderColor = "#000";
      } else {
        colorinput.style.borderColor = "#000";
        colorinput_bg.style.borderColor = "#fff";
      }

      var colors_arr_no_dupes = colors_arr.filter(function (item, pos, self) {
        return self.indexOf(item) == pos;
      });

      colors_arr_no_dupes.sort();
      var swatches_html_els = '';
      var number_swatches;
      var max_number_swatches = roundUpNearest10(colors_arr_no_dupes.length);
      if (max_number_swatches === 0) {
        max_number_swatches = 10;
      }
      for (number_swatches = 0; number_swatches < max_number_swatches; number_swatches++) {
        if (colors_arr_no_dupes[number_swatches]) {
          swatches_html_els += /*HTML*/ `
          <div class="color_swatche">
            <svg class="color-triangle" style="fill:${escapeHTML(color2NoAlpha(colors_arr_no_dupes[number_swatches]))}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <path d="M 0.03,10.00 C 0.03,10.00 10.00,19.97 10.00,19.97 10.00,19.97 0.06,20.00 0.06,20.00" />
            </svg>
            <div 
              data-swatch="${escapeHTML(colors_arr_no_dupes[number_swatches])}"
              style="
                pointer-events: all; 
                cursor: pointer; 
                opacity: 1; 
                background:${escapeHTML(colors_arr_no_dupes[number_swatches])}"
            >
            </div>
          </div>`;
        } else {
          swatches_html_els += '<div class="color_swatche"></div>';
        }
      }

      domID('color_swatches').innerHTML = swatches_html_els;

      var swatches = document.querySelectorAll(".color_swatche");
      [].forEach.call(swatches, function (swatche) {

        swatche.onmouseup = function (e) {
          if (!INPUTER1.value) {
            info("No classname or element selected.", 4000, true);
            return false;
          }
          if (picker_showing) {
            return false;
          }
          var color = e.target.getAttribute("data-swatch");
          store_the_color(color);
        };

        swatche.onmouseenter = function (e) {
          if (!INPUTER1.value) {
            return false;
          }
          let swatch_el = e.target.querySelector('[data-swatch]');
          let color_val;
          if (swatch_el) {
            color_val = swatch_el.getAttribute("data-swatch");
          }
          if (!color_val) {
            return false;
          }
          if (CSSstyles[colour_type_for_input] === color_val) {
            swatche.title = "this is the current color \n" + color_val;
            return false;
          }
          if (colour_type_for_input === "color") {
            swatche.title = "click to apply the color \n" + color_val;
          } else {
            swatche.title = "click to apply the background color \n" + color_val;
          }
        };

      });
    }, 10);
  }

  var array_of_colour_propertys = [
    "color",
    "background-color",
    "outline-color",
    "text-decoration-color",
    "fill",
    "stroke",
    "border-left-color",
    "border-right-color",
    "border-top-color",
    "border-bottom-color",
  ];

  function color2hex(rgb) {
    var color = tinycolor(rgb);
    return color.toHex8String();
  }

  function color2rgb(hex) {
    var color = tinycolor(hex);
    return color.toRgbString();
  }

  function color2hsl(hex) {
    var color = tinycolor(hex);
    return color.toHslString();
  }

  function color2NoAlpha(val) {
    var color = "none";
    if (val) {
      color = tinycolor(val);
      color.setAlpha(1);
    }
    return color;
  }

  function set_color_type(val, colour_type_passed) {
    if (!val) {
      //con("rgb_or_hex no val");
      return false;
    }
    var color_type;
    if (val.indexOf("#") > -1) {
      color_type = 'hex';
    } else if (val.indexOf("rgb") > -1) {
      color_type = 'rgb';
    } else if (val.indexOf("hsl") > -1) {
      color_type = 'hsl';
    } else {
      var color = tinycolor(val);
      color_type = color.getFormat();
    }

    let check_type = color_type_selected;
    if (colour_type_passed) {
      check_type = colour_type_passed;
    }

    if (check_type === color_type && color_type !== 'name') {
      return val;
    }
    if (check_type === 'hex' && color_type !== check_type) {
      return color2hex(val);
    }
    if (check_type === 'rgb' && color_type !== check_type) {
      return color2rgb(val);
    }
    if (check_type === 'hsl' && color_type !== check_type) {
      return color2hsl(val);
    }
    if (check_type === 'name' && color_type !== check_type) {
      return color2hex(val);
    }
  }

  function set_color_for_picker(val) {
    if (!val) {
      //con("rgb_or_hex no val");
      return false;
    }
    var color_type;
    if (val.indexOf("#") > -1) {
      color_type = 'hex';
    } else if (val.indexOf("rgb") > -1) {
      color_type = 'rgb';
    } else if (val.indexOf("hsl") > -1) {
      color_type = 'hsl';
    } else {
      var color = tinycolor(val);
      color_type = color.getFormat();
    }
    // set hex for color picker
    if (color_type === "rgb") {
      return color2hex(val);
    }
    if (color_type === "hsl") {
      return color2hex(val);
    }
    if (color_type === "name") {
      return color2hex(val);
    }
    if (color_type_selected === 'hex') {
      return val;
    }
  }


  function store_the_color(color) {
    if (array_of_colour_propertys.includes(INPUTER2.value)) {
      INPUTER3.value = color;
      if (INPUTER2.value.includes('border-') && INPUTER2.value.includes('-color')) {
        if (locks_obj['lock_border-color'] === 'true') {
          var lock_items = [
            "border-top-color",
            "border-bottom-color",
            "border-left-color",
            "border-right-color"
          ];
          setLockItems(lock_items);
        } else {
          clickAdder("units");
        }
      } else {
        clickAdder("units");
      }
      info("Applied color " + color, null, null);
    } else {
      if (CSSstyles[colour_type_for_input] === color) {
        return false;
      }
      if (colour_type_for_input === "color") {
        INPUTER2.value = "color";
        INPUTER3.value = color;
        picker.source.value = set_color_for_picker(INPUTER3.value);
        colorinputTriangle.style.fill = color2NoAlpha(INPUTER3.value);
        colorFunction2(color);
        colorinput.style.background = color;
        info("Applied color " + color, null, null);
      } else {
        INPUTER2.value = "background-color";
        INPUTER3.value = color;
        picker_bg.source.value = set_color_for_picker(INPUTER3.value);
        colorinputTriangle_bg.style.fill = color2NoAlpha(INPUTER3.value);
        colorFunction2_bg(color);
        colorinput_bg.style.background = color;
        info("Applied background color " + color, null, null);
      }
    }
    new_color_val = color;
    placeInHeadTempCSS_func();
    FillValueReadouts();
    FillUndo();
  }

  let just_exit = false;

  function apply_picker_elements(picker, for_value) {

    let els_wrap = document.createElement('span');
    els_wrap.setAttribute('class', 'picker_els_wrap');
    picker.self.appendChild(els_wrap);

    let picker_eye_dropper;
    let eye_dropper = window.EyeDropper;

    let picker_value_text_el = document.createElement('input');
    picker_value_text_el.setAttribute('class', 'picker_value_text');
    els_wrap.appendChild(picker_value_text_el);

    if (eye_dropper) {
      picker_eye_dropper = document.createElement('button');
      picker_eye_dropper.setAttribute('class', 'picker_eye_dropper');
      els_wrap.appendChild(picker_eye_dropper);
      picker_eye_dropper.innerHTML = `<i class="material-icons">colorize</i>`;
    }

    let picker_swatches_container = document.createElement('div');
    picker_swatches_container.setAttribute('class', 'picker_swatches_container');
    picker.self.appendChild(picker_swatches_container);
    var swatches = [...document.querySelectorAll(".color_swatche")];
    swatches.map(swatche => {
      let clone = swatche.cloneNode(true);
      picker_swatches_container.appendChild(clone);
    });

    let set_color_type_val = false;
    if (
      for_value === 'filter_drop-shadow-color' ||
      for_value === 'outline-color' ||
      for_value === 'text-decoration-color' ||
      for_value === 'text-shadow-color' ||
      for_value === 'box-shadow-color'
    ) {
      set_color_type_val = 'rgb';
    }

    picker.on('enter', function (r, g, b, a) {

      blockIframe();

      [...document.querySelectorAll(".picker_swatches_container")].map(swatches_container => {
        swatches_container.innerHTML = '';
      });

      var swatches = [...document.querySelectorAll(".color_swatche")];
      swatches.map(swatche => {
        console.log(swatche);
        let clone = swatche.cloneNode(true);
        picker_swatches_container.appendChild(clone);
        clone.onmouseup = function (e) {
          console.log(clone);
          var color = e.target.getAttribute("data-swatch");
          picker_value_text_el.value = set_color_type(color, set_color_type_val);
          picker.fire('change', CP.HEX(color2hex(color)));
          setTimeout(() => {
            picker._set.apply(picker, CP.HEX(color2hex(color)));
          }, 20);
        };

        clone.onmouseenter = function (e) {
          let swatch_el = e.target.querySelector('[data-swatch]');
          let color_val;
          if (swatch_el) {
            color_val = swatch_el.getAttribute("data-swatch");
          }
          if (!color_val) {
            return false;
          }
          clone.title = set_color_type(color_val, set_color_type_val);
        };
      });


      picker_value_text_el.value = set_color_type(this.color(r, g, b, a), set_color_type_val) || '';
      picker.on('change', function (r, g, b, a) {
        picker_value_text_el.value = set_color_type(this.color(r, g, b, a), set_color_type_val);
        just_exit = false;
      });
      picker_value_text_el.oninput = (e) => {
        var color = e.target.value;
        just_exit = false;
        store_the_color(color);
      };
      picker_value_text_el.onchange = (e) => {
        var color = e.target.value;
        just_exit = false;
        store_the_color(color);
      };

      if (eye_dropper) {
        picker_eye_dropper.onclick = () => {
          const eyeDropper = new EyeDropper();
          eyeDropper.open().then((result) => {
            var color = result.sRGBHex;
            picker_value_text_el.value = set_color_type(color, set_color_type_val);
            picker.fire('change', CP.HEX(color));
            setTimeout(() => {
              picker._set.apply(picker, CP.HEX(color));
            }, 20);
          }).catch((e) => {
            console.log(e);
          });
        };
      }
    });
    apply_close_picker_btn(picker);
  }

  function apply_close_picker_btn(picker) {
    let picker_done_btn = document.createElement('span');
    picker_done_btn.setAttribute('class', 'picker_done_btn');
    picker_done_btn.innerText = 'apply/close';
    picker.self.appendChild(picker_done_btn);
    picker_done_btn.onclick = () => {
      picker.exit();
      setTimeout(function () {
        unblockIframe();
      }, 3);
    };
  }

  var colorinput = document.querySelector('#colorinput');
  var picker = new CP(colorinput);
  apply_picker_elements(picker, 'color');
  var colorinputTriangle = document.querySelector('#colorinput-triangle');
  //color2NoAlpha

  var colorinput_bg = document.querySelector('#colorinput_bg');
  var picker_bg = new CP(colorinput_bg);
  apply_picker_elements(picker_bg, 'background-color');
  var colorinputTriangle_bg = document.querySelector('#colorinput-triangle-bg');
  // var picker = new CP(colorinput);
  // var picker_bg = new CP(colorinput_bg);

  var picker_showing = false;

  var new_color_val;
  var old_color_val;
  var colour_type_for_input = "color";
  colorinput.style.borderColor = "#fff";
  var media_color = document.querySelector('#media_color');
  var media_color_triangle = document.querySelector('#media_color_triangle');
  var media_color_bg = document.querySelector('#media_color_bg');
  var media_color_triangle_bg = document.querySelector('#media_color_triangle_bg');

  var color_type_selected = 'hex';
  var color_hex_btn = document.querySelector('#color_hex');
  var color_rgb_btn = document.querySelector('#color_rgb');
  var color_hsl_btn = document.querySelector('#color_hsl');

  var colorinput_wrapper = document.querySelector('#colorinput_wrapper');

  color_hex_btn.classList = "active";

  function changes_color_type_active() {
    if (color_type_selected === 'hex') {
      color_hex_btn.classList = "active";
      color_rgb_btn.classList = "";
      color_hsl_btn.classList = "";
    }
    if (color_type_selected === 'rgb') {
      color_hex_btn.classList = "";
      color_rgb_btn.classList = "active";
      color_hsl_btn.classList = "";
    }
    if (color_type_selected === 'hsl') {
      color_hex_btn.classList = "";
      color_rgb_btn.classList = "";
      color_hsl_btn.classList = "active";
    }
    if (color_type_selected === 'name') {
      color_hex_btn.classList = "";
      color_rgb_btn.classList = "";
      color_hsl_btn.classList = "";
    }
  }

  function set_color_type_active(val) {
    if (val.indexOf("#") > -1) {
      color_type_selected = 'hex';
    } else if (val.indexOf("rgb") > -1) {
      color_type_selected = 'rgb';
    } else if (val.indexOf("hsl") > -1) {
      color_type_selected = 'hsl';
    } else {
      var color = tinycolor(val);
      color_type_selected = color.getFormat();
    }
    changes_color_type_active();
  }


  setTimeout(function () {
    function changes_color_type_button() {
      new_color_val = false;
      if (!INPUTER1.value) {
        return false;
      }
      if (INPUTER2.value === "background-color" || INPUTER2.value === "color") {
        if (CSSstyles && CSSstyles[INPUTER2.value]) {
          var old_color = INPUTER3.value;
          var new_color = set_color_type(old_color);
          if (new_color && new_color !== old_color) {

            if (colour_type_for_input === "color") {
              colorFunction2(new_color);
              colorinput.style.background = new_color;
            }

            if (colour_type_for_input === "background-color") {
              colorFunction2_bg(new_color);
              colorinput_bg.style.background = new_color;
            }
            setColorsOnColorInputs();
            FillUndo();
            FillValueReadouts();
          }
        }
      }
    }

    color_hex_btn.onmousedown = function () {
      color_type_selected = 'hex';
      changes_color_type_button();
      changes_color_type_active();
    };

    color_rgb_btn.onmousedown = function () {
      color_type_selected = 'rgb';
      changes_color_type_button();
      changes_color_type_active();
    };

    color_hsl_btn.onmousedown = function () {
      color_type_selected = 'hsl';
      changes_color_type_button();
      changes_color_type_active();
    };

    colorinput.onmouseenter = function () {
      colorinput.style.borderColor = "#fff";
      colorinput_bg.style.borderColor = "#000";
      if (!INPUTER1.value) {
        return false;
      }
      if (INPUTER2.value === "background-color" || INPUTER2.value === "color") {
        INPUTER2.value = "color";
        if (!CSSstyles || !CSSstyles["color"]) {
          INPUTER3.value = "";
          return false;
        }
        if (CSSstyles["color"]) {
          INPUTER3.value = CSSstyles["color"];
          picker.source.value = set_color_for_picker(INPUTER3.value);
          colorinputTriangle.style.fill = color2NoAlpha(INPUTER3.value);
          set_color_type_active(INPUTER3.value);
        }
      }
    };

    colorinput_bg.onmouseenter = function () {
      colorinput.style.borderColor = "#000";
      colorinput_bg.style.borderColor = "#fff";
      if (!INPUTER1.value) {
        return false;
      }
      if (INPUTER2.value === "background-color" || INPUTER2.value === "color") {
        INPUTER2.value = "background-color";
        if (!CSSstyles || !CSSstyles["background-color"]) {
          INPUTER3.value = "";
          return false;
        }
        if (CSSstyles["background-color"]) {
          INPUTER3.value = CSSstyles["background-color"];
          picker_bg.source.value = set_color_for_picker(INPUTER3.value);
          colorinputTriangle_bg.style.fill = color2NoAlpha(INPUTER3.value);
          set_color_type_active(INPUTER3.value);
        }
      }
    };


    function colorinputMouseleave(color_colorbg) {
      if (color_colorbg === "color") {
        if (colour_type_for_input === "color") {
          colorinput.style.borderColor = "#FFF";
          colorinput_bg.style.borderColor = "#000";
        } else {
          colorinput.style.borderColor = "#000";
          colorinput_bg.style.borderColor = "#fff";
        }
      }
      if (color_colorbg === "background-color") {
        if (colour_type_for_input === "color") {
          colorinput.style.borderColor = "#FFF";
          colorinput_bg.style.borderColor = "#000";
        } else {
          colorinput.style.borderColor = "#000";
          colorinput_bg.style.borderColor = "#fff";
        }
      }
    }

    colorinput.onmouseleave = function () {
      colorinputMouseleave("color");
    };

    colorinput_bg.onmouseleave = function () {
      colorinputMouseleave("background-color");
    };


    function clickOnColorInput(color_colorbg) {
      if (picker_showing) {
        just_exit = true;
        picker.exit();
        return false;
      }
      if (!INPUTER1.value) {
        return false;
      }
      blockIframe();
      picker_showing = true;
      colour_type_for_input = color_colorbg;
      INPUTER2.value = color_colorbg;
      if (!CSSstyles || !CSSstyles[color_colorbg]) {
        INPUTER3.value = "";
        old_color_val = '';
        return false;
      }
      if (CSSstyles[color_colorbg]) {
        INPUTER3.value = CSSstyles[color_colorbg];
        old_color_val = CSSstyles[color_colorbg];
      }
      if (color_colorbg === "color") {
        picker.source.value = set_color_for_picker(INPUTER3.value);
        colorinputTriangle.style.fill = color2NoAlpha(INPUTER3.value);
      }
      if (color_colorbg === "background-color") {
        picker_bg.source.value = set_color_for_picker(INPUTER3.value);
        colorinputTriangle_bg.style.fill = color2NoAlpha(INPUTER3.value);
      }
    }

    colorinput.onmousedown = function () {
      colour_type_for_input = "color";
      clickOnColorInput("color");
    };
    colorinput_bg.onmousedown = function () {
      colour_type_for_input = "background-color";
      clickOnColorInput("background-color");
    };

    // colorinput.onmouseup = function () {
    //   colorinput_wrapper.classList.add("--disable-button");
    // };
    // colorinput_bg.onmouseup = function () {
    //   colorinput_wrapper.classList.add("--disable-button");
    // };

    function pickerChange(color, color_colorbg) {
      if (!INPUTER1.value) {
        info("No classname or element selected.", 4000, true);
        INPUTER2.value = "";
        INPUTER3.value = "";
        return false;
      }
      blockIframe();
      picker_showing = true;
      if (color_colorbg === "color") {
        colorinput.style.background = color;
      }
      if (color_colorbg === "background-color") {
        colorinput_bg.style.background = color;
      }
      INPUTER2.value = color_colorbg;
      INPUTER3.value = color;
      if (domElement[0]) {
        placeInHeadTempCSS_func(color);
        new_color_val = color;
      }
    }

    picker.on('change', function (r, g, b, a) {
      var color_value = this.color(r, g, b, a); // this is always rgb
      color_value = set_color_type(color_value);
      this.source.value = color_value;
      colorinputTriangle.style.fill = color2NoAlpha(color_value);
      pickerChange(color_value, "color");
    });

    picker_bg.on('change', function (r, g, b, a) {
      var color_value = this.color(r, g, b, a); // this is always rgb
      color_value = set_color_type(color_value);
      this.source.value = color_value;
      colorinputTriangle_bg.style.fill = color2NoAlpha(color_value);
      pickerChange(color_value, "background-color");
    });

    picker.on('enter', function () {
      new_color_val = INPUTER3.value;
    });

    picker_bg.on('enter', function () {
      new_color_val = INPUTER3.value;
    });


    function pickerExit(color_colorbg) {

      if (just_exit) {
        just_exit = false;
        new_color_val = false;
        picker_showing = false;
        unblockIframe();
        placeInHeadTempCSS_func();
        FillUndo();
        FillValueReadouts();
        colorinput_wrapper.removeAttribute('class');
        return;
      }

      placeInHeadTempCSS_func();

      if (old_color_val !== new_color_val) {
        if (new_color_val) {
          if (color_colorbg === "color") {
            colorFunction2(new_color_val);
            info("Applied color " + new_color_val, null, null);
          }
          if (color_colorbg === "background-color") {
            colorFunction2_bg(new_color_val);
            info("Applied background color " + new_color_val, null, null);
          }
        }
        new_color_val = false;
        setColorsOnColorInputs();
        FillUndo();
        FillValueReadouts();
      }
      setTimeout(function () {
        unblockIframe();
        picker_showing = false;
        colorinput_wrapper.removeAttribute('class');
      }, 3);
    }

    picker.on('exit', function () {
      pickerExit("color");
    });

    picker_bg.on('exit', function () {
      pickerExit("background-color");
    });

    domID('color_delete').onclick = function () {
      if (!INPUTER1.value) {
        return false;
      }
      if (colour_type_for_input === "color") {
        INPUTER2.value = "color";
      } else {
        INPUTER2.value = "background-color";
      }
      con("deleting: " + INPUTER1.value + " " + INPUTER2.value + " " + INPUTER3.value);
      clickRemoveProp(false);
      FillUndo();
      setColorsOnColorInputs();
      FillValueReadouts();
    };

    // setTimeout ends
  }, 10);


  // outline color picker
  var colorinput_outline = document.querySelector('#outline-color');
  var colorinput_outline_picker = new CP(colorinput_outline);
  apply_picker_elements(colorinput_outline_picker, 'outline-color');
  var outline_color_triangle = document.querySelector('#outline-color-triangle');
  createColorPicker_outline(colorinput_outline_picker, outline_color_triangle, "outline-color");

  function createColorPicker_outline(picker, picker_triangle, css_property) {
    picker.on('enter', function () {
      if (!INPUTER1.value) {
        this.exit();
        info("Select element first");
        return false;
      } else {
        INPUTER2.value = css_property;
        if (CSSstyles[css_property]) {
          INPUTER3.value = CSSstyles[css_property];
        }
      }
    });
    picker.on('change', function (r, g, b, a) {
      if (!INPUTER1.value) {
        this.exit();
        return false;
      }
      INPUTER2.value = css_property;
      blockIframe();
      var color_value = this.color(r, g, b, a); // this is always rgb
      this.source.value = color_value;
      this.source.style.background = this.color(r, g, b, a);
      var forInput3 = "";
      var color = tinycolor(color_value);
      color = color.toRgb();
      forInput3 = 'rgba(' + (color.r.toString() || '0') + ', ' + (color.g.toString() || '0') + ', ' + (color.b.toString() || '0') + ', ' + (color.a.toFixed(2).toString() || '0') + ')';
      INPUTER3.value = forInput3;
      picker_triangle.style.fill = color2NoAlpha(forInput3);
      placeInHeadTempCSS_func(forInput3);
    });
    picker.on('exit', function () {
      if (INPUTER3.value) {
        clickAdder("units");
        placeInHeadTempCSS_func();
        FillUndo();
        FillValueReadouts();
      }
      setTimeout(function () {
        unblockIframe();
      }, 3);
    });
  }


  // textdecorationcolor color picker
  var colorinput_textdecorationcolor = document.querySelector('#text-decoration-color');
  var colorinput_textdecorationcolor_picker = new CP(colorinput_textdecorationcolor);
  apply_picker_elements(colorinput_textdecorationcolor_picker, 'text-decoration-color');
  var textdecorationcolor_color_triangle = document.querySelector('#text-decoration-color-triangle');
  createColorPicker_textdecorationcolor(colorinput_textdecorationcolor_picker, textdecorationcolor_color_triangle, "text-decoration-color");

  function createColorPicker_textdecorationcolor(picker, picker_triangle, css_property) {
    picker.on('enter', function () {
      if (!INPUTER1.value) {
        this.exit();
        info("Select element first");
        return false;
      } else {
        INPUTER2.value = css_property;
        if (CSSstyles[css_property]) {
          INPUTER3.value = CSSstyles[css_property];
        }
      }
    });
    picker.on('change', function (r, g, b, a) {
      if (!INPUTER1.value) {
        this.exit();
        return false;
      }
      INPUTER2.value = css_property;
      blockIframe();
      var color_value = this.color(r, g, b, a); // this is always rgb
      this.source.value = color_value;
      this.source.style.background = this.color(r, g, b, a);
      var forInput3 = "";
      var color = tinycolor(color_value);
      color = color.toRgb();
      forInput3 = 'rgba(' + (color.r.toString() || '0') + ', ' + (color.g.toString() || '0') + ', ' + (color.b.toString() || '0') + ', ' + (color.a.toFixed(2).toString() || '0') + ')';
      INPUTER3.value = forInput3;
      picker_triangle.style.fill = color2NoAlpha(forInput3);
      placeInHeadTempCSS_func(forInput3);
    });
    picker.on('exit', function () {
      if (INPUTER3.value) {
        clickAdder("units");
        placeInHeadTempCSS_func();
        FillUndo();
        FillValueReadouts();
      }
      setTimeout(function () {
        unblockIframe();
      }, 3);
    });
  }





  // border-left color picker
  var colorinput_border_left = document.querySelector('#border-left-color');
  var colorinput_border_left_picker = new CP(colorinput_border_left);
  apply_picker_elements(colorinput_border_left_picker, 'border-left-color');
  var border_left_color_triangle = document.querySelector('#border-left-color-triangle');
  createColorPicker_border(colorinput_border_left_picker, border_left_color_triangle, "border-left-color");

  // border-right color picker
  var colorinput_border_right = document.querySelector('#border-right-color');
  var colorinput_border_right_picker = new CP(colorinput_border_right);
  apply_picker_elements(colorinput_border_right_picker, 'border-right-color');
  var border_right_color_triangle = document.querySelector('#border-right-color-triangle');
  createColorPicker_border(colorinput_border_right_picker, border_right_color_triangle, "border-right-color");

  // border-top color picker
  var colorinput_border_top = document.querySelector('#border-top-color');
  var colorinput_border_top_picker = new CP(colorinput_border_top);
  apply_picker_elements(colorinput_border_top_picker, 'border-top-color');
  var border_top_color_triangle = document.querySelector('#border-top-color-triangle');
  createColorPicker_border(colorinput_border_top_picker, border_top_color_triangle, "border-top-color");

  // border-bottom color picker
  var colorinput_border_bottom = document.querySelector('#border-bottom-color');
  var colorinput_border_bottom_picker = new CP(colorinput_border_bottom);
  apply_picker_elements(colorinput_border_bottom_picker, 'border-bottom-color');
  var border_bottom_color_triangle = document.querySelector('#border-bottom-color-triangle');
  createColorPicker_border(colorinput_border_bottom_picker, border_bottom_color_triangle, "border-bottom-color");

  function createColorPicker_border(picker, picker_triangle, css_property) {
    picker.on('enter', function () {
      if (!INPUTER1.value) {
        this.exit();
        info("Select element first");
        return false;
      } else {
        INPUTER2.value = css_property;
        if (CSSstyles[css_property]) {
          INPUTER3.value = CSSstyles[css_property];
        }
      }
    });
    picker.on('change', function (r, g, b, a) {
      if (!INPUTER1.value) {
        this.exit();
        return false;
      }
      INPUTER2.value = css_property;
      blockIframe();
      var color_value = this.color(r, g, b, a); // this is always rgb
      this.source.value = color_value;
      this.source.style.background = this.color(r, g, b, a);
      var forInput3 = "";
      var color = tinycolor(color_value);
      color = color.toRgb();
      forInput3 = 'rgba(' + (color.r.toString() || '0') + ', ' + (color.g.toString() || '0') + ', ' + (color.b.toString() || '0') + ', ' + (color.a.toFixed(2).toString() || '0') + ')';
      INPUTER3.value = forInput3;
      picker_triangle.style.fill = color2NoAlpha(forInput3);
      if (locks_obj['lock_border-color'] === 'true') {
        placeInHeadTempCSS_func_multi('border-color', forInput3);
      } else {
        placeInHeadTempCSS_func(forInput3);
      }
    });
    picker.on('exit', function () {
      if (INPUTER3.value) {
        if (locks_obj['lock_border-color'] === 'true') {
          var lock_items = [
            "border-top-color",
            "border-bottom-color",
            "border-left-color",
            "border-right-color"
          ];
          setLockItems(lock_items);
        } else {
          clickAdder("units");
        }
        placeInHeadTempCSS_func();
        FillUndo();
        FillValueReadouts();
      }
      setTimeout(function () {
        unblockIframe();
      }, 3);
    });
  }


  // text shadows color picker
  var colorinput_text_shadow = document.querySelector('#text-shadow-color');
  var colorinput_text_shadow_picker = new CP(colorinput_text_shadow);
  apply_picker_elements(colorinput_text_shadow_picker, 'text-shadow-color');
  var text_shadow_color_triangle = document.querySelector('#text-shadow-color-triangle');

  colorinput_text_shadow_picker.on('enter', function () {
    if (!INPUTER1.value) {
      this.exit();
      info("Select a element to add text shadows");
      return false;
    } else {
      INPUTER2.value = "text-shadow";
      if (CSSstyles["text-shadow"]) {
        INPUTER3.value = CSSstyles["text-shadow"];
      }
    }
  });
  colorinput_text_shadow_picker.on('change', function (r, g, b, a) {
    if (!INPUTER1.value) {
      this.exit();
      return false;
    }
    INPUTER2.value = "text-shadow";
    blockIframe();
    var color_value = this.color(r, g, b, a); // this is always rgb
    this.source.value = color_value;
    this.source.style.background = this.color(r, g, b, a);
    createTextShadowIfNone();
    var forInput3 = "";
    var color = tinycolor(color_value);
    color = color.toRgb();
    var rgba = 'rgba(' + (color.r.toString() || '0') + ', ' + (color.g.toString() || '0') + ', ' + (color.b.toString() || '0') + ', ' + (color.a.toFixed(2).toString() || '0') + ')';
    forInput3 = rgba + " " + currentShadText.hShadow + " " + currentShadText.vShadow + " " + currentShadText.blur;
    INPUTER3.value = textShadowAdder(forInput3);
    text_shadow_color_triangle.style.fill = color2NoAlpha(forInput3);
    placeInHeadTempCSS_func(textShadowAdder(forInput3));
    domID('text-shadow-color_value').innerText = rgba.replace(/ /g, '').replace('rgba(', '').replace(')', '');
  });
  colorinput_text_shadow_picker.on('exit', function () {
    if (INPUTER3.value) {
      clickAdder("units");
      refreshTextShadowValues();
      placeInHeadTempCSS_func();
      FillUndo();
      FillValueReadouts();
    }
    setTimeout(function () {
      unblockIframe();
    }, 3);
  });


  // box shadows color picker
  var colorinput_box_shadow = document.querySelector('#box-shadow-color');
  var colorinput_box_shadow_picker = new CP(colorinput_box_shadow);
  apply_picker_elements(colorinput_box_shadow_picker, 'box-shadow-color');
  var box_shadow_color_triangle = document.querySelector('#box-shadow-color-triangle');

  colorinput_box_shadow_picker.on('enter', function () {
    if (!INPUTER1.value) {
      this.exit();
      info("Select a element to add box shadows");
      return false;
    } else {
      INPUTER2.value = "box-shadow";
      if (CSSstyles["box-shadow"]) {
        INPUTER3.value = CSSstyles["box-shadow"];
      }
    }
  });
  colorinput_box_shadow_picker.on('change', function (r, g, b, a) {
    if (!INPUTER1.value) {
      this.exit();
      return false;
    }
    INPUTER2.value = "box-shadow";
    blockIframe();
    var color_value = this.color(r, g, b, a); // this is always rgb
    this.source.value = color_value;
    this.source.style.background = this.color(r, g, b, a);
    createBoxShadowIfNone();
    var forInput3 = "";
    var color = tinycolor(color_value);
    color = color.toRgb();
    var rgba = 'rgba(' + (color.r.toString() || '0') + ', ' + (color.g.toString() || '0') + ', ' + (color.b.toString() || '0') + ', ' + (color.a.toFixed(2).toString() || '0') + ')';
    forInput3 = rgba + " " + currentShad.hShadow + " " + currentShad.vShadow + " " + currentShad.blur + " " + currentShad.spread + " " + currentShad.inset;
    INPUTER3.value = boxShadowAdder(forInput3);
    box_shadow_color_triangle.style.fill = color2NoAlpha(forInput3);
    placeInHeadTempCSS_func(boxShadowAdder(forInput3));
    domID('box-shadow-color_value').innerText = rgba.replace(/ /g, '').replace('rgba(', '').replace(')', '');
  });
  colorinput_box_shadow_picker.on('exit', function () {
    if (INPUTER3.value) {
      clickAdder("units");
      refreshShadowValues();
      placeInHeadTempCSS_func();
      FillUndo();
      FillValueReadouts();
    }
    setTimeout(function () {
      unblockIframe();
    }, 3);
  });

  var window_resizer_inputs_2 = document.querySelectorAll("#window-resizer_2");
  [].forEach.call(window_resizer_inputs_2, function (resizer_input) {
    // window_class needs to be unique
    window_resizer(resizer_input, ".window_class_2", "5px", null);
    window_resizer_init(resizer_input, ".window_class_2", "5px", null);
  });

  function window_resizer(resizer_input, window_class, px_value, callBack) {
    var direction = resizer_input.getAttribute('data-direction');
    var max;
    if (direction === "y") {
      max = scrollboxAreaBG.offsetHeight;
      resizer_input.setAttribute('max', max);
    }
    max = Math.round(resizer_input.getAttribute('max'));
    var parent_el = resizer_input.parentElement;
    var windowDivs = parent_el.querySelectorAll(window_class); // window_class needs to be unique
    var first_el = windowDivs[0];
    var second_el = windowDivs[1];
    resizer_input.oninput = function () {
      //blockIframe();

      var new_value_raw;
      var new_value;
      var other_value_raw;
      var other_value;
      if (!direction || direction === 'x') {
        //
        new_value_raw = (resizer_input.value / 100);
        other_value_raw = ((max - resizer_input.value) / 100);
        //
        new_value = 'calc(' + new_value_raw + "% - " + px_value + ")";
        first_el.style.width = new_value;
        first_el.style.minWidth = new_value;
        first_el.style.maxWidth = new_value;
        //
        other_value = 'calc(' + other_value_raw + "% - " + px_value + ")";
        second_el.style.width = other_value;
        second_el.style.minWidth = other_value;
        second_el.style.maxWidth = other_value;
      } else if (direction === 'y') {
        var testnumber = 28;
        if (Math.round(resizer_input.value) < testnumber) {
          resizer_input.value = testnumber;
        }
        if (Math.round(resizer_input.value) > (max - testnumber)) {
          resizer_input.value = (max - testnumber);
        }
        var y_value = Number(max) - Number(resizer_input.value);
        new_value_raw = Number(y_value) - testnumber - 1;
        other_value_raw = ((Number(max) - y_value)) - testnumber;
        //window.localStorage.setItem("scrollBoxSizeValue_vertical", resizer_input.value);
        //
        new_value = 'calc(' + new_value_raw + "px + 0px)";
        first_el.style.height = new_value;
        first_el.style.minHeight = new_value;
        first_el.style.maxHeight = new_value;
        //
        other_value = 'calc(' + other_value_raw + "px + 0px)";
        second_el.style.height = other_value;
        second_el.style.minHeight = other_value;
        second_el.style.maxHeight = other_value;
      }
      if (callBack) {
        callBack(new_value_raw, other_value_raw);
      }
      BREAKPOINT_WIDTH_READOUT.innerHTML = iframe.offsetWidth + " x " + iframe.offsetHeight + BREAKPOINT_WIDTH_READOUT_mode;
    };

    resizer_input.onmouseup = function () {
      if (domElement[0]) {
        selectElement(frameID(domElement[0]));
        BoxRefresh();
      }
      unblockIframe();
    };
  }

  function window_resizer_init(resizer_input, window_class, px_value, callBack) {
    var direction = resizer_input.getAttribute('data-direction');
    var max = resizer_input.getAttribute('max');
    if (direction === "y") {
      max = scrollboxAreaBG.offsetHeight;
      resizer_input.setAttribute('max', max);
    }

    var parent_el = resizer_input.parentElement;
    var windowDivs = parent_el.querySelectorAll(window_class); // window_class needs to be unique
    var first_el = windowDivs[0];
    var second_el = windowDivs[1];
    var new_value;
    var other_value;
    if (!direction || direction === 'x') {
      resizer_input.style.cursor = "ew-resize";
      new_value = 'calc(' + (resizer_input.value / 100) + "% - " + px_value + ")";
      first_el.style.width = new_value;
      first_el.style.minWidth = new_value;
      first_el.style.maxWidth = new_value;
      first_el.style.position = "relative";
      first_el.style.height = "100%";
      first_el.style.minHeight = "100%";
      first_el.style.maxHeight = "100%";
      other_value = 'calc(' + ((max - resizer_input.value) / 100) + "% - " + px_value + ")";
      second_el.style.width = other_value;
      second_el.style.minWidth = other_value;
      second_el.style.maxWidth = other_value;
      second_el.style.position = "relative";
      second_el.style.height = "100%";
      second_el.style.minHeight = "100%";
      second_el.style.maxHeight = "100%";
    } else if (direction === 'y') {
      var y_value = max - resizer_input.value;
      resizer_input.style.cursor = "ns-resize";
      resizer_input.classList.add('window-resizer__input--vertical-slider');
      parent_el.style.flexDirection = "column";
      parent_el.style.justifyContent = "center";
      parent_el.style.alignItems = "space-between";
      new_value = 'calc(' + (y_value / 100) + "% - " + px_value + ")";
      first_el.style.position = "relative";
      first_el.style.height = new_value;
      first_el.style.minHeight = new_value;
      first_el.style.maxHeight = new_value;
      first_el.style.width = "100%";
      first_el.style.minWidth = "100%";
      first_el.style.maxWidth = "100%";
      other_value = 'calc(' + ((max - y_value) / 100) + "% - " + px_value + ")";
      second_el.style.position = "relative";
      second_el.style.height = other_value;
      second_el.style.minHeight = other_value;
      second_el.style.maxHeight = other_value;
      second_el.style.width = "100%";
      second_el.style.minWidth = "100%";
      second_el.style.maxWidth = "100%";
    }
    if (callBack) {
      callBack(new_value_raw, other_value_raw);
    }
  }


  function simulateMouseEvent(target, type, bubbles, cancelable, view, detail, screenX, screenY, clientX, clientY) {
    try {
      var customEvent = document.createEvent("MouseEvents");
      customEvent.initMouseEvent(type, bubbles, cancelable, view, detail, screenX, screenY, clientX, clientY);
      target.dispatchEvent(customEvent);
    } catch (e) {}
  }

  var locks_obj = {};
  var locks = [...document.querySelectorAll('[data-locks]')];
  locks.map((lock) => {
    let lock_type = 'lock_' + lock.getAttribute('data-locks');
    if (window.localStorage.getItem(lock_type)) {
      lock.setAttribute('data-locked', localStorage.getItem(lock_type));
      locks_obj[lock_type] = localStorage.getItem(lock_type);
    } else {
      locks_obj[lock_type] = lock.getAttribute('data-locked');
    }
    lock.onclick = () => {
      let lock_locked = lock.getAttribute('data-locked');
      let new_lock_locked;
      if (lock_locked === 'false') {
        new_lock_locked = 'true';
      } else {
        new_lock_locked = 'false';
      }
      lock.setAttribute('data-locked', new_lock_locked);
      window.localStorage.setItem(lock_type, new_lock_locked);
      locks_obj[lock_type] = new_lock_locked;
    };
  });

  function setTitlesOnInputs() {
    if (INPUTER1.value) {
      INPUTER1.setAttribute('title', INPUTER1.value);
    } else {
      INPUTER1.removeAttribute('title');
    }
    if (INPUTER2.value) {
      INPUTER2.setAttribute('title', INPUTER2.value);
    } else {
      INPUTER2.removeAttribute('title');
    }
    if (INPUTER3.value) {
      INPUTER3.setAttribute('title', INPUTER3.value);
    } else {
      INPUTER3.removeAttribute('title');
    }
    if (pseudo_select.value) {
      pseudo_select.setAttribute('title', pseudo_select.value);
    } else {
      pseudo_select.removeAttribute('title');
    }
    if (attrsClass.value) {
      attrsClass.setAttribute('title', attrsClass.value);
    } else {
      attrsClass.removeAttribute('title');
    }
    if (select__element.value) {
      select__element.setAttribute('title', select__element.value);
    } else {
      select__element.removeAttribute('title');
    }
    if (attrsID.value) {
      attrsID.setAttribute('title', attrsID.value);
    } else {
      attrsID.removeAttribute('title');
    }
  }

  // this will fire when when css in changed with mouse 
  var addElements = [...document.querySelectorAll('#maincontainerRightFixed, #maincontainerRight')];
  addElements.map((el) => {
    el.onmouseup = function () {
      setTitlesOnInputs();
    };
  });

  var normalizeApplyBTN = domID('normalizeApplyBTN');

  var normalize_for_preview;

  function NormalizeToIframe() {
    if (!window.localStorage.getItem('normalizecss')) {
      window.localStorage.setItem('normalizecss', true);
    }
    if (window.localStorage.getItem('normalizecss') === 'true') {
      placeInHeadNormalize.innerHTML = normalizecss.replace(/\s+/g, '');
      normalizeApplyBTN.style = 'width: calc(100% - 15px); background: var(--mainColor); color: var(--button-text-active);';
    } else {
      placeInHeadNormalize.innerHTML = '';
      normalizeApplyBTN.style = 'width: calc(100% - 15px);';
    }
    normalize_for_preview = placeInHeadNormalize.innerHTML;

    normalizeApplyBTN.onclick = () => {
      var isTrueSet = (window.localStorage.getItem('normalizecss') === 'true');
      window.localStorage.setItem('normalizecss', !isTrueSet);
      if (window.localStorage.getItem('normalizecss') === 'true') {
        placeInHeadNormalize.innerHTML = normalizecss.replace(/\s+/g, '');
        normalizeApplyBTN.style = 'width: calc(100% - 15px); background: var(--mainColor); color: var(--button-text-active);';
      } else {
        placeInHeadNormalize.innerHTML = '';
        normalizeApplyBTN.style = 'width: calc(100% - 15px);';
      }
      if (preview) {
        normalize_for_preview = placeInHeadNormalize.innerHTML;
        set_preview_css_html();
      }
    };
  }

  var resize_rebtns3 = new ResizeObserver(entries => {
    if (!fullScreenMode) {
      for (let entry of entries) {
        const cr = entry.contentRect;
        let structure_height = `${cr.height}px`;
        window.localStorage.setItem('structure_height', structure_height);
      }
    }
  });

  resize_rebtns3.observe(rebtns3);
  if (window.localStorage.getItem('structure_height')) {
    rebtns3.style.setProperty('height', window.localStorage.getItem('structure_height'));
  }

  function observe_classcss() {
    let observe_classcss_timeout;
    const targetNode = classcss;
    const config = {
      childList: true,
      attributes: true,
      subtree: true
    };
    const callback = (mutationsList, observer) => {
      for (let mutation of mutationsList) {
        if (mutation.type === 'childList') {
          clearTimeout(observe_classcss_timeout);
          observe_classcss_timeout = setTimeout(() => {
            con('Elements childList has changed');
            BoxRefresh();
          }, 100);
        }
      }
    };
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }

  component_theme__select.onchange = () => {
    component_theme = component_theme__select[component_theme__select.selectedIndex].value;
    window.localStorage.setItem('component_theme', component_theme);
  };

  if (window.localStorage.getItem('component_theme')) {
    component_theme = window.localStorage.getItem('component_theme');
    component_theme__select.value = component_theme;
  }

  function bring_to_front(e) {
    // bring to front
    var current_front = [...document.querySelectorAll(".bring-to-front")];
    current_front.map((el) => {
      el.classList.remove("bring-to-front");
    });
    this.classList.add("bring-to-front");
  }

  function dragSideBar(elmnt) {
    var pos1 = 0,
      pos2 = 0,
      pos3 = 0,
      pos4 = 0;

    let drag_header = document.getElementById(elmnt.id + "-header");
    if (drag_header) {
      drag_header.addEventListener("mousedown", dragMouseDown, {
        passive: false
      });
      drag_header.addEventListener("touchstart", dragMouseDown, {
        passive: false
      });
    } else {
      // otherwise, move the DIV from anywhere inside the DIV:
      elmnt.addEventListener("mousedown", dragMouseDown, {
        passive: false
      });
      elmnt.addEventListener("touchstart", dragMouseDown, {
        passive: false
      });
    }

    elmnt.addEventListener("mousedown", bring_to_front, {
      passive: false
    });
    elmnt.addEventListener("touchstart", bring_to_front, {
      passive: false
    });

    function set_positions(e) {
      // get the mouse cursor position at startup:
      if (e.type === "touchmove") {
        pos1 = pos3 - e.touches[0].clientX;
        pos2 = pos4 - e.touches[0].clientY;
        pos3 = e.touches[0].clientX;
        pos4 = e.touches[0].clientY;
      } else {
        pos1 = pos3 - e.clientX;
        pos2 = pos4 - e.clientY;
        pos3 = e.clientX;
        pos4 = e.clientY;
      }
    }

    function dragMouseDown(e) {
      e = e || window.event;
      e.preventDefault();
      // get the mouse cursor position at startup:
      if (e.type === "touchstart") {
        pos3 = e.touches[0].clientX;
        pos4 = e.touches[0].clientY;
      } else {
        pos3 = e.clientX;
        pos4 = e.clientY;
      }
      document.addEventListener("mouseup", closeDragElement, {
        passive: false
      });
      document.addEventListener("touchend", closeDragElement, {
        passive: false
      });
      document.addEventListener("mousemove", elementDrag, {
        passive: false
      });
      document.addEventListener("touchmove", elementDrag, {
        passive: false
      });
      blockIframe();
      document.getElementById(elmnt.id + "-header").style.setProperty('cursor', 'grabbing');
    }

    function elementDrag(e) {
      e = e || window.event;
      e.preventDefault();
      set_positions(e);
      // set the element's new position:

      // horizontal:
      elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
      // vertical:
      elmnt.style.top = (elmnt.offsetTop - pos2) + "px";

      // left
      if ((elmnt.offsetLeft) < 0) {
        elmnt.style.left = "0px";
      }
      // right
      if ((elmnt.offsetLeft + elmnt.offsetWidth) > (window.innerWidth)) {
        elmnt.style.left = (window.innerWidth - elmnt.offsetWidth) + "px";
      }
      // top
      if ((elmnt.offsetTop) < 36) {
        elmnt.style.top = "36px";
      }
      // bottom
      if ((elmnt.offsetTop + elmnt.offsetHeight) > (window.innerHeight - 36)) { // good
        elmnt.style.top = (window.innerHeight - elmnt.offsetHeight) - 36 + "px";
      }
    }

    function closeDragElement() {
      // stop moving when mouse button is released:
      document.removeEventListener("mouseup", closeDragElement);
      document.removeEventListener("touchend", closeDragElement);
      document.removeEventListener("mousemove", elementDrag);
      document.removeEventListener("touchmove", elementDrag);
      unblockIframe();
      document.getElementById(elmnt.id + "-header").style.removeProperty('cursor');
      tutorial_change(tutorial_data_index);
    }
  }

  dragSideBar(document.getElementById("left-sections"));
  dragSideBar(document.getElementById("right-sections"));
  dragSideBar(codesection);

  function resizeSideBar(elmnt) {
    let pos1 = 0,
      pos2 = 0,
      pos3 = 0,
      pos4 = 0;

    let w = 0;
    let h = 0;

    let resize_top = elmnt.querySelector('.resize-top');
    let resize_left = elmnt.querySelector('.resize-left');
    let resize_bottom = elmnt.querySelector('.resize-bottom');
    let resize_right = elmnt.querySelector('.resize-right');
    let resize_both = elmnt.querySelector('.resize-both');

    if (resize_top) {
      resize_top.addEventListener("mousedown", dragMouseDown_T, {
        passive: false
      });
      resize_top.addEventListener("touchstart", dragMouseDown_T, {
        passive: false
      });
    }

    if (resize_left) {
      resize_left.addEventListener("mousedown", dragMouseDown_L, {
        passive: false
      });
      resize_left.addEventListener("touchstart", dragMouseDown_L, {
        passive: false
      });
    }

    if (resize_bottom) {
      resize_bottom.addEventListener("mousedown", dragMouseDown_B, {
        passive: false
      });
      resize_bottom.addEventListener("touchstart", dragMouseDown_B, {
        passive: false
      });
    }

    if (resize_right) {
      resize_right.addEventListener("mousedown", dragMouseDown_R, {
        passive: false
      });
      resize_right.addEventListener("touchstart", dragMouseDown_R, {
        passive: false
      });
    }

    if (resize_both) {
      resize_both.addEventListener("mousedown", dragMouseDown_BOTH, {
        passive: false
      });
      resize_both.addEventListener("touchstart", dragMouseDown_BOTH, {
        passive: false
      });
    }

    elmnt.addEventListener("mousedown", bring_to_front, {
      passive: false
    });
    elmnt.addEventListener("touchstart", bring_to_front, {
      passive: false
    });

    function set_positions(e) {
      // get the mouse cursor position at startup:
      if (e.type === "touchmove") {
        pos1 = pos3 - e.touches[0].clientX;
        pos2 = pos4 - e.touches[0].clientY;
        pos3 = e.touches[0].clientX;
        pos4 = e.touches[0].clientY;
      } else {
        pos1 = pos3 - e.clientX;
        pos2 = pos4 - e.clientY;
        pos3 = e.clientX;
        pos4 = e.clientY;
      }
    }

    function dragMouseDown_T(e) {
      e = e || window.event;
      e.preventDefault();
      set_positions(e);
      document.addEventListener("mouseup", closeDragElement, {
        passive: false
      });
      document.addEventListener("touchend", closeDragElement, {
        passive: false
      });
      document.addEventListener("mousemove", elementDrag_T, {
        passive: false
      });
      document.addEventListener("touchmove", elementDrag_T, {
        passive: false
      });
      blockIframe();
    }

    function dragMouseDown_L(e) {
      e = e || window.event;
      e.preventDefault();
      set_positions(e);
      document.addEventListener("mouseup", closeDragElement, {
        passive: false
      });
      document.addEventListener("touchend", closeDragElement, {
        passive: false
      });
      document.addEventListener("mousemove", elementDrag_L, {
        passive: false
      });
      document.addEventListener("touchmove", elementDrag_L, {
        passive: false
      });
      blockIframe();
    }

    function dragMouseDown_B(e) {
      e = e || window.event;
      e.preventDefault();
      set_positions(e);
      document.addEventListener("mouseup", closeDragElement, {
        passive: false
      });
      document.addEventListener("touchend", closeDragElement, {
        passive: false
      });
      document.addEventListener("mousemove", elementDrag_B, {
        passive: false
      });
      document.addEventListener("touchmove", elementDrag_B, {
        passive: false
      });
      blockIframe();
    }

    function dragMouseDown_R(e) {
      e = e || window.event;
      e.preventDefault();
      set_positions(e);
      document.addEventListener("mouseup", closeDragElement, {
        passive: false
      });
      document.addEventListener("touchend", closeDragElement, {
        passive: false
      });
      document.addEventListener("mousemove", elementDrag_R, {
        passive: false
      });
      document.addEventListener("touchmove", elementDrag_R, {
        passive: false
      });
      blockIframe();
    }


    function dragMouseDown_BOTH(e) {
      e = e || window.event;
      e.preventDefault();
      set_positions(e);
      document.addEventListener("mouseup", closeDragElement, {
        passive: false
      });
      document.addEventListener("touchend", closeDragElement, {
        passive: false
      });
      document.addEventListener("mousemove", elementDrag_BOTH, {
        passive: false
      });
      document.addEventListener("touchmove", elementDrag_BOTH, {
        passive: false
      });
      blockIframe();
    }

    function elementDrag_T(e) {
      e = e || window.event;
      e.preventDefault();
      set_positions(e);
      // set the element's new position:
      const styles = window.getComputedStyle(elmnt);
      h = parseInt(styles.height, 10);
      // top
      elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
      if ((elmnt.offsetTop) < 36) {
        elmnt.style.top = "36px";
      } else {
        elmnt.style.height = (h + pos2) + "px";
      }
      // bottom
      if ((elmnt.offsetTop + elmnt.offsetHeight) > (window.innerHeight - 36)) { // good
        elmnt.style.top = (window.innerHeight - elmnt.offsetHeight) - 36 + "px";
      }
    }

    function elementDrag_B(e) {
      e = e || window.event;
      e.preventDefault();
      set_positions(e);
      // set the element's new position:
      const styles = window.getComputedStyle(elmnt);
      h = parseInt(styles.height, 10);
      elmnt.style.height = (h - pos2) + "px";
      h = parseInt(styles.height, 10);
      // bottom
      if ((elmnt.offsetTop + h) > (window.innerHeight - 36)) {
        elmnt.style.height = (h + pos2) + "px";
      }
    }

    function elementDrag_L(e) {
      e = e || window.event;
      e.preventDefault();
      set_positions(e);
      const styles = window.getComputedStyle(elmnt);
      let left = parseInt(styles.left, 10);
      w = parseInt(styles.width, 10);

      if ((left - pos1) < 0) {
        elmnt.style.left = "0px";
      } else {
        if (((left + w) - pos1) > (left + 272) - pos1) {
          elmnt.style.left = (left - pos1) + "px";
        }
        elmnt.style.width = (w + pos1) + "px";
        // right
        if ((left + w) > (window.innerWidth)) {
          elmnt.style.left = (window.innerWidth - w) + "px";
        }
      }
    }

    function elementDrag_R(e) {
      e = e || window.event;
      e.preventDefault();
      set_positions(e);
      // set the element's new position:
      const styles = window.getComputedStyle(elmnt);
      w = parseInt(styles.width, 10);
      elmnt.style.width = (w - pos1) + "px";
      w = parseInt(styles.width, 10);
      // right
      if ((elmnt.offsetLeft + w) > (window.innerWidth)) {
        elmnt.style.width = (w + pos1) + "px";
      }
    }

    function elementDrag_BOTH(e) {
      e = e || window.event;
      e.preventDefault();
      set_positions(e);
      // set the element's new position:
      const styles = window.getComputedStyle(elmnt);
      w = parseInt(styles.width, 10);
      h = parseInt(styles.height, 10);
      elmnt.style.height = (h - pos2) + "px";
      elmnt.style.width = (w - pos1) + "px";
      w = parseInt(styles.width, 10);
      h = parseInt(styles.height, 10);
      // right
      if ((elmnt.offsetLeft + w) > (window.innerWidth)) {
        elmnt.style.width = (w + pos1) + "px";
      }
      // bottom
      if ((elmnt.offsetTop + h) > (window.innerHeight - 36)) {
        elmnt.style.height = (h + pos2) + "px";
      }
    }


    function closeDragElement() {
      // stop moving when mouse button is released:
      document.removeEventListener("mouseup", closeDragElement);
      document.removeEventListener("touchend", closeDragElement);
      document.removeEventListener("mousemove", elementDrag_T);
      document.removeEventListener("touchmove", elementDrag_T);
      document.removeEventListener("mousemove", elementDrag_L);
      document.removeEventListener("touchmove", elementDrag_L);
      document.removeEventListener("mousemove", elementDrag_B);
      document.removeEventListener("touchmove", elementDrag_B);
      document.removeEventListener("mousemove", elementDrag_R);
      document.removeEventListener("touchmove", elementDrag_R);
      document.removeEventListener("mousemove", elementDrag_BOTH);
      document.removeEventListener("touchmove", elementDrag_BOTH);

      unblockIframe();
      tutorial_change(tutorial_data_index);
    }
  }

  resizeSideBar(document.getElementById("left-sections"));
  resizeSideBar(document.getElementById("right-sections"));
  resizeSideBar(codesection);






  function dragSideBar_store(elmnt, btn) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === "attributes") {
          localStorage.setItem(elmnt.id + '-style', elmnt.getAttribute('style'));
        }
      });
    });
    observer.observe(elmnt, {
      attributes: true, //configure it to listen to attribute changes
      attributeFilter: ['style']
    });
    let section_style = localStorage.getItem(elmnt.id + '-style');
    if (section_style) {
      elmnt.style = section_style;
    }

    let is_visable = elmnt.style.getPropertyValue('display');
    if (is_visable === 'none') {
      elmnt.style.removeProperty('display');
    }
    // check if out of bounds
    // left
    if ((elmnt.offsetLeft) < 0) {
      elmnt.style.left = "0px";
    }
    // right
    if ((elmnt.offsetLeft + elmnt.offsetWidth) > (window.innerWidth)) {
      elmnt.style.left = (window.innerWidth - elmnt.offsetWidth) + "px";
    }
    // top
    if ((elmnt.offsetTop) < 36) {
      elmnt.style.top = "36px";
    }
    // bottom
    if ((elmnt.offsetTop + elmnt.offsetHeight) > (window.innerHeight - 36)) { // good
      elmnt.style.top = (window.innerHeight - elmnt.offsetHeight) - 36 + "px";
    }

    if (is_visable === 'none') {
      elmnt.style.setProperty('display', 'none');
    }

    let display_of = elmnt.style.getPropertyValue('display');
    if (display_of) {
      btn.style = buttonBGColor;
    } else {
      btn.style = buttonHLColor;
    }

    refreshCodeView();

    btn.onclick = (e) => {
      let display_of = elmnt.style.getPropertyValue('display');
      if (!display_of) {
        elmnt.style.setProperty('display', 'none');
        btn.style = buttonBGColor;
      } else {
        elmnt.style.removeProperty('display');
        btn.style = buttonHLColor;
      }
      // bring to front
      var current_front = [...document.querySelectorAll(".bring-to-front")];
      current_front.map((el) => {
        el.classList.remove("bring-to-front");
      });
      elmnt.classList.add("bring-to-front");
      localStorage.setItem(elmnt.id + '-style', elmnt.getAttribute('style'));
    };
  }

  dragSideBar_store(document.getElementById("left-sections"), document.getElementById("htmlButton"));
  dragSideBar_store(document.getElementById("right-sections"), document.getElementById("cssButton"));
  dragSideBar_store(codesection, document.getElementById("viewCodeButton"));

  document.getElementById("htmlButton").addEventListener('click', () => {
    DOMtree();
  });
  document.getElementById("cssButton").addEventListener('click', () => {
    FillValueReadouts();
  });

  function close_dragSideBar(section, btn, btn_close) {
    function close_dragSideBar_event() {
      document.getElementById(section).style.setProperty('display', 'none');
      document.getElementById(btn).style = buttonBGColor;
      localStorage.setItem(section + '-style', document.getElementById(section).getAttribute('style'));
    }
    document.getElementById(btn_close).addEventListener("touchend", close_dragSideBar_event);
    document.getElementById(btn_close).addEventListener("mouseup", close_dragSideBar_event);
  }

  close_dragSideBar("left-sections", "htmlButton", "left-section-close");
  close_dragSideBar("right-sections", "cssButton", "right-section-close");
  close_dragSideBar("code-section", "viewCodeButton", "code-section-close");

  setTimeout(() => {
    if (!onLoadCounter) {
      simulateMouseEvent(domID('viewCodeButton'), "click");

      // dont show css and html sections on mobile first visit
      if (window.innerWidth < breakPoint_MD_Value + scrollbox_width_resizer_vars_min_width) {
        domID("left-sections").style.setProperty('display', 'none');
        domID("htmlButton").style = buttonBGColor;
        localStorage.setItem("left-sections" + '-style', domID("left-sections").getAttribute('style'));

        domID("right-sections").style.setProperty('display', 'none');
        domID("cssButton").style = buttonBGColor;
        localStorage.setItem("right-sections" + '-style', domID("right-sections").getAttribute('style'));
      }
    }

  }, 0);

  function stringToHTML(str, type = 'body') {
    var parser = new DOMParser();
    var doc = parser.parseFromString(str, 'text/html');
    if (type === 'body') {
      return doc.body;
    } else if (type === 'head') {
      return doc.head;
    }
    return false;
  }

  const prism_html_debounce = debounce((e) => prism_html_input(e), 10);
  //prism_html.addEventListener("keyup", prism_html_debounce);

  prism_html.addEventListener("keydown", function (e) {
    // press tab.
    if (e.key == 'Tab') {
      e.preventDefault();
      // Insert a space.
      let selection = window.getSelection();
      selection.getRangeAt(0).insertNode(document.createTextNode("  "));
      remember_recovery_draft(e);
      return;
    }
  });

  prism_html.addEventListener("keyup", function (e) {
    let selection = window.getSelection();
    var store_range = document.createRange();
  });


  prism_html.addEventListener("focus", function () {
    editing_code = true;
  });

  prism_html.addEventListener("blur", function (e) {
    editing_code = false;
  });

  prism_html.addEventListener("paste", function (e) {
    e.preventDefault();
    var text = e.clipboardData.getData('text');
    let text_node = document.createTextNode(text);
    let selection = window.getSelection();
    selection.getRangeAt(0).insertNode(text_node);

    // set cursor to end of pasted content
    var range = document.createRange();
    range.setStart(text_node, text.length);
    range.collapse(true);
    selection.removeAllRanges();
    selection.addRange(range);
    prism_html.focus();
  });

  domID('saveHTML').addEventListener("click", function (e) {
    prism_html_debounce(e);
  });

  prism_html.addEventListener("copy", function (e) {
    setTimeout(() => {
      document.getSelection().removeAllRanges();
    }, 50);
  });

  prism_html.addEventListener("mousedown", function (e) {
    document.getSelection().removeAllRanges();
  });

  window.addEventListener('click', release_prism_html);

  function release_prism_html(e) {
    let el_id = e.target.id || '';
    if (el_id !== 'prism_html' && !hasSomeParentTheID(e.target, 'prism_html')) {
      prism_html.blur();
    }
  }

  // returns true if the element or one of its parents has the class classname
  function hasSomeParentTheID(element, el_id) {
    if (!element) {
      return false;
    }
    if (element.id && element.id === el_id) return true;
    return element.parentNode && hasSomeParentTheID(element.parentNode, el_id);
  }


  function prism_html_input(e) {
    e.preventDefault();
    // BODY
    let string_of_html = prism_html.innerText.replace(/\s+/g, ' ').trim().replaceAll('> <', '><');
    let new_doc_body = stringToHTML(string_of_html, 'body');
    let new_els_body = [...new_doc_body.querySelectorAll('*')];
    new_els_body.map((el) => {
      // add if no id
      let el_id = el.getAttribute('id');
      let el_class = el.getAttribute('class');
      let el_src = el.getAttribute('src');
      let el_tagname = el.tagName.toLowerCase();
      if (!el_id) {
        el.setAttribute('id', guidGenerator());
      }
      if (el_class) {
        el.setAttribute('data-tracker', '');
      }
      if (el_src && el_tagname !== 'script') {
        let new_src = el_src.replaceAll('images/', '');
        if (el_src.indexOf('https://') === -1) {
          el.setAttribute('data-image', new_src);
          el.removeAttribute('src');
        } else {
          el.setAttribute('src', new_src);
        }
      }
      if (el_tagname === 'script') {
        console.log("el_tagname === 'script'", el);
      }
    });

    // HEAD
    let new_doc_head = stringToHTML(prism_html.innerText, 'head');
    let elem = projectHTMLContainer(new_doc_body.innerHTML + new_doc_head.innerHTML);
    renderToDOM(createDOMMap(elem));
    FillStorageHTML();
    recoveryDrafts.delete('prism_html');
    renderImagesFromIndexedDB();
    FillUndo();
    DOMtree();
    setTimeout(function () {
      BoxRefresh();
      FillUndo();
      if (preview_active) {
        set_preview_css_html();
      }
      refreshCodeView();
    }, 15);
  }


  domID('darkmodeToggle').addEventListener('click', () => {
    if (document.documentElement.getAttribute('data-theme') === 'dark') {
      document.documentElement.setAttribute('data-theme', 'light');
      iframeHTML.setAttribute('data-theme', 'light');
      window.localStorage.setItem('darkmode', 'false');
    } else {
      document.documentElement.setAttribute('data-theme', 'dark');
      iframeHTML.setAttribute('data-theme', 'dark');
      window.localStorage.setItem('darkmode', 'true');
    }
  });

  // data focus
  function add_clicks_to_value_wrappers() {
    let value_wrappers = [...document.querySelectorAll('.active-tab .value-wrapper')];
    value_wrappers.map(wrapper => {
      wrapper.setAttribute('data-wrapper-active', false);
      wrapper.onclick = () => {
        value_wrappers.map(wrapper_false => {
          wrapper_false.setAttribute('data-wrapper-active', false);
        });
        if (wrapper.getAttribute('data-wrapper-active') !== 'true') {
          wrapper.setAttribute('data-wrapper-active', true);
          let input_or_select = [...wrapper.querySelectorAll('input, select')];
          if (input_or_select[0]) {
            input_or_select[0].focus();
          } else {
            wrapper.focus();
          }
        }
      };
    });
  }

  // ---------------------------------------------------
  // ---------------------------------------------------
  // ---------------------------------------------------
  // ---------------------------------------------------
  // pages

  function create_pages_elements() {
    pages_render.replaceChildren(...page_names.map(page => textOption(page, page)));
    pages_render.value = page_name;

    pages_render.onchange = () => {
      page_name = pages_render.value;
      window.localStorage.setItem('page_name', page_name);
      clearTheHTML(classcss);
      renderHTML();
      FillStorageHTML();
      SCROLLBOX.style.setProperty('opacity', '0');
      setTimeout(() => {
        renderImagesFromIndexedDB();
        renderPreviewImagesFromIndexedDB();
        DOMtree();
        refreshCodeView();
        FillUndo();
        deselectElement();
      }, 100);
    };
  }
  create_pages_elements();

  domID('add-page').onclick = () => {
    var new_page_name = prompt(
      "Enter name of new page"
    );
    if (new_page_name) {

      if (page_names.indexOf(new_page_name) > -1) {
        alert('Page already exists.');
        return false;
      }

      new_page_name = new_page_name.replace(/\s+/g, '-').toLowerCase();
      page_names.push(new_page_name);
      window.localStorage.setItem('page_names', JSON.stringify(page_names));

      page_name = new_page_name;
      window.localStorage.setItem('page_name', page_name);
      FillValueReadouts();
      clearTheHTML(classcss);
      renderHTML();
      FillStorageHTML();
      DOMtree();
      refreshCodeView();
      FillUndo();
      SCROLLBOX.style.setProperty('opacity', '0');
      setTimeout(() => {
        renderImagesFromIndexedDB();
        renderPreviewImagesFromIndexedDB();
      }, 100);
    }
  };

  domID('copy-page').onclick = () => {
    var new_page_name = prompt(
      "Enter name of new page copy", page_name + ' copy'
    );
    if (new_page_name) {

      if (page_names.indexOf(new_page_name) > -1) {
        alert('Page already exists.');
        return false;
      }

      new_page_name = new_page_name.replace(/\s+/g, '-').toLowerCase();
      page_names.push(new_page_name);
      window.localStorage.setItem('page_names', JSON.stringify(page_names));
      page_name = new_page_name;
      window.localStorage.setItem('page_name', page_name);

      FillValueReadouts();
      //clearTheHTML(classcss); // remove this to copy
      renderHTML();
      FillStorageHTML();
      DOMtree();
      refreshCodeView();
      FillUndo();
      SCROLLBOX.style.setProperty('opacity', '0');
      setTimeout(() => {
        renderImagesFromIndexedDB();
        renderPreviewImagesFromIndexedDB();
      }, 100);
    }
  };

  domID('rename-page').onclick = () => {
    if (page_name === 'index') {
      alert('Cannot rename index page.');
      return false;
    }

    var new_page_name = prompt(
      `Enter new name for ${page_name} page.`, page_name
    );
    if (new_page_name) {

      if (page_names.indexOf(new_page_name) > -1) {
        alert('Page already exists.');
        return false;
      }

      new_page_name = new_page_name.replace(/\s+/g, '-').toLowerCase();

      // store new page name
      let page_name_index = page_names.indexOf(page_name);
      if (page_name_index > -1) {
        page_names[page_name_index] = new_page_name; // 2nd parameter means remove one item only
      }
      window.localStorage.setItem('page_names', JSON.stringify(page_names));

      // copt data over in store
      let previous_data = window.localStorage.getItem('HTML_' + page_name);
      window.localStorage.setItem('HTML_' + new_page_name, previous_data);
      window.localStorage.removeItem('HTML_' + page_name);

      // set page to new page
      page_name = new_page_name;
      window.localStorage.setItem('page_name', page_name);

      FillValueReadouts();
      clearTheHTML(classcss); // remove this to copy
      renderHTML();
      FillStorageHTML();
      DOMtree();
      refreshCodeView();
      FillUndo();
      SCROLLBOX.style.setProperty('opacity', '0');
      setTimeout(() => {
        renderImagesFromIndexedDB();
        renderPreviewImagesFromIndexedDB();
      }, 100);
    }
  };

  domID('delete-page').onclick = () => {
    if (page_name === 'index') {
      alert('Cannot delete index page.');
      return false;
    }

    let remove_page = confirm(`Are you sure you want to delete this ${page_name} page?`);
    if (remove_page) {

      window.localStorage.removeItem('HTML_' + page_name);
      var pindex = page_names.indexOf(page_name);
      if (pindex !== -1) {
        page_names.splice(pindex, 1);
      }
      window.localStorage.setItem('page_names', JSON.stringify(page_names));
      page_name = 'index';
      window.localStorage.setItem('page_name', page_name);

      FillValueReadouts();
      clearTheHTML(classcss);
      renderHTML();
      FillStorageHTML();
      DOMtree();
      refreshCodeView();
      FillUndo();
      SCROLLBOX.style.setProperty('opacity', '0');
      setTimeout(() => {
        renderImagesFromIndexedDB();
        renderPreviewImagesFromIndexedDB();
      }, 100);
    }
  };




  var inline_external_css = window.localStorage.getItem('inline_external_css');

  if (inline_external_css && inline_external_css === 'inline') {
    css_inline();
  } else {
    css_external();
  }

  function css_inline() {
    inline_external_css = 'inline';
    window.localStorage.setItem('inline_external_css', inline_external_css);
    CSSINLINEBTN.classList.add('active');
    reverseBreakpointsDiv.classList.add('inline-active');
  }

  function css_external() {
    inline_external_css = 'external';
    window.localStorage.setItem('inline_external_css', inline_external_css);
    CSSINLINEBTN.classList.remove('active');
    reverseBreakpointsDiv.classList.remove('inline-active');
  }

  CSSINLINEBTN.onclick = () => {
    if (inline_external_css !== 'inline') {
      css_inline();
    } else {
      css_external();
    }
  };



  function context_menu_close(e) {
    let is_context_menu = e.target.closest('#context-menu');
    if (!is_context_menu) {
      domID('context-menu').style['display'] = 'none';
      window.removeEventListener('mousedown', context_menu_close);
      iframeContents.removeEventListener('mousedown', context_menu_close);
    }
    iframeBlocker.style.display = null;
  }

  const context_menu_element = domID('context-menu');

  function context_menu(e, domtree) {
    iframeBlocker.style.display = "block";
    let posX, posY;
    if (e && e.target) {
      e = e || window.event;
      e.preventDefault();
      // get the mouse cursor position at startup:
      if (!domtree) {
        if (e.type === "touchstart") {
          posX = e.touches[0].clientX + SCROLLBOX.offsetLeft - (SCROLLBOX.offsetWidth / 2);
          posY = e.touches[0].clientY + SCROLLBOX.offsetTop;
        } else {
          posX = e.clientX + SCROLLBOX.offsetLeft - (SCROLLBOX.offsetWidth / 2);
          posY = e.clientY + SCROLLBOX.offsetTop;
        }
      } else {
        if (e.type === "touchstart") {
          posX = e.touches[0].clientX;
          posY = e.touches[0].clientY;
        } else {
          posX = e.clientX;
          posY = e.clientY;
        }
      }
      context_menu_element.style['left'] = (Number(posX) + 3) + 'px';
      context_menu_element.style['top'] = (Number(posY) + 3) + 'px';
    }

    // create list of parents 
    var disable_classcss = '';
    var a = frameID(domElement[0]);
    var els = [];
    if (a.id !== 'classcss') {
      while (a) {
        els.unshift(a);
        if (a.parentElement.id === 'classcss') {
          a = null;
        } else {
          a = a.parentElement;
        }
      }
    } else {
      disable_classcss = ' submenu-disabled';
    }
    els = els.reverse();
    let parents_html = '';
    els.map(el => {
      if (el.id !== domElement[0]) {
        let id_val = '';
        if (el.id.length && el.id.length !== 11 && !el.id.includes("ID-")) {
          id_val = `#${el.id}`;
        }
        let parent_el = frameID(domElement[0]).parentElement;
        if (parent_el && parent_el.id === el.id) {
          parent_el = parent_el.id;
        }
        parents_html += /*HTML*/ `
        <div class="submenu-item" data-selectelement="${escapeHTML(el.id)}">
          <div class="menu-item-drop">
            <span>${escapeHTML(el.tagName.toLowerCase())}${escapeHTML(id_val)}${escapeHTML(el.classList.length ? '.' + [...el.classList].join('.') : '')}</span>
            <span style="${(el.id === parent_el) ? 'text-align: right; color: var(--main-text);' : 'display: none'}">&nbsp;alt + ⯇</span>
          </div>
        </div>`;
      }
    });

    // create list of siblings
    let sibling_html = '';
    let sibling_html_length = 0;
    let parent_id = frameID(domElement[0]).parentElement.id;
    if (parent_id) {
      let sibling_els = [...frameID(domElement[0]).parentElement.children];
      sibling_els.map(el => {
        if (el.tagName.toLowerCase() === 'br') {
          return;
        }
        sibling_html_length++;
        let id_val = '';
        if (el.id.length && el.id.length !== 11 && !el.id.includes("ID-")) {
          id_val = `#${el.id}`;
        }
        let prev_sib = frameID(domElement[0]).previousSibling;
        if (prev_sib && prev_sib.id) {
          prev_sib = prev_sib.id;
        }
        let next_sib = frameID(domElement[0]).nextSibling;
        if (next_sib && next_sib.id) {
          next_sib = next_sib.id;
        }
        sibling_html += /*HTML*/ `
          <div class="submenu-item" data-selectelement="${escapeHTML(el.id)}">
            <div class="menu-item-drop">
              <span>${escapeHTML(el.tagName.toLowerCase())}${escapeHTML(id_val)}${escapeHTML(el.classList.length ? '.' + [...el.classList].join('.') : '')}</span>
              <span style="${(el.id === domElement[0]) ? 'color: var(--mainColor)' : 'display: none'}">&nbsp;(selected)</span>
              <span style="${(el.id === prev_sib) ? 'text-align: right; color: var(--main-text);' : 'display: none'}">&nbsp;alt + ⯅</span>
              <span style="${(el.id === next_sib) ? 'text-align: right; color: var(--main-text);' : 'display: none'}">&nbsp;alt + ⯆</span>
            </div>
          </div>`;
      });
    }

    // create a list of children
    let children_html = '';
    let children_els = [...frameID(domElement[0]).children];
    children_els.map(el => {
      if (el.tagName.toLowerCase() === 'br') {
        return;
      }
      let id_val = '';
      if (el.id.length && el.id.length !== 11 && !el.id.includes("ID-")) {
        id_val = `#${el.id}`;
      }
      let child_els = [...frameID(domElement[0]).children] || [];
      if (child_els.length && child_els[0].id === el.id) {
        child_els = child_els[0].id;
      }
      children_html += /*HTML*/ `
        <div class="submenu-item" data-selectelement="${escapeHTML(el.id)}">
          <div class="menu-item-drop">
            <span>${escapeHTML(el.tagName.toLowerCase())}${escapeHTML(id_val)}${escapeHTML(el.classList.length ? '.' + [...el.classList].join('.') : '')}</span>
            <span style="${(el.id === child_els) ? 'text-align: right; color: var(--main-text);' : 'display: none'}">&nbsp;alt + ⯈</span>
          </div>
        </div>`;
    });

    let box_edit = iframeElementSelect.getAttribute('box-edit');


    // check if can edit text
    var disable_text_edit = ' submenu-disabled';
    acceptTextEdit.map((item) => {
      if (item === frameID(domElement[0]).tagName.toLowerCase()) {
        disable_text_edit = '';
      }
    });


    // create menu items:
    let items = /*HTML*/ `
        <div class="menu-item">
          <div class="menu-item-drop">
            <span>box edit</span>
            <i class="material-icons rorate">arrow_drop_down</i>
          </div>
          <div class="submenu">
            <div class="submenu-item" data-clickitem="sizeButton">
              <div style="${(box_edit === 'sizeButton') ? 'color: var(--mainColor)' : ''}" class="menu-item-drop">
                <span>Size</span>
              </div>
            </div>
            <div class="submenu-item" data-clickitem="spacingButton">
              <div style="${(box_edit === 'spacingButton') ? 'color: var(--mainColor)' : ''}" class="menu-item-drop">
                <span>margin & padding</span>
              </div>
            </div>
            <div class="submenu-item" data-clickitem="bordersButton">
              <div style="${(box_edit === 'bordersButton') ? 'color: var(--mainColor)' : ''}" class="menu-item-drop">
                <span>border</span>
              </div>
            </div>
          </div>
        </div>
        <hr style="margin: 0">
        <div class="menu-item${parents_html ? '' : ' submenu-disabled'}">
          <div class="menu-item-drop">
            <span>select parent</span>
            <i class="material-icons rorate">arrow_drop_down</i>
          </div>
          <div class="submenu" >
            ${parents_html}
          </div>
        </div>
        <div class="menu-item${sibling_html_length > 1 ? '' : ' submenu-disabled'}">
          <div class="menu-item-drop">
            <span>select sibling</span>
            <i class="material-icons rorate">arrow_drop_down</i>
          </div>
          <div class="submenu" >
            ${sibling_html}
          </div>
        </div>
        <div class="menu-item${children_html ? '' : ' submenu-disabled'}">
          <div class="menu-item-drop">
            <span>select child</span>
            <i class="material-icons rorate">arrow_drop_down</i>
          </div>
          <div class="submenu">
            ${children_html}
          </div>
        </div>
        <hr style="margin: 0">
        <div class="menu-item${disable_classcss}">
          <div class="menu-item-drop">
            <span>move element</span>
            <i class="material-icons rorate">arrow_drop_down</i>
          </div>
          <div class="submenu">
            <div class="submenu-item" data-clickitem="previousTree">
              <div class="menu-item-drop">
                <i class="material-icons">arrow_upward</i>
                <span class="key-tip">
                  <span>before previous</span>
                  <span>ctrl + ⯅</span>
                </span>
              </div>
            </div>
            <div class="submenu-item" data-clickitem="nextTree">
              <div class="menu-item-drop">
                <i class="material-icons">arrow_downward</i>
                <span class="key-tip">
                  <span>after next</span>
                  <span>ctrl + ⯆</span>
                </span>
              </div>
            </div>
            <div class="submenu-item" data-clickitem="upTheTree">
              <div class="menu-item-drop">
                <i class="material-icons vert-flip">subdirectory_arrow_left</i>
                <span class="key-tip">
                  <span>out of parent</span>
                  <span>ctrl + ⯇</span>
                </span>
              </div>
            </div>
            <div class="submenu-item" data-clickitem="downTheTree">
              <div class="menu-item-drop">
                <i class="material-icons">subdirectory_arrow_right</i>
                <span class="key-tip">
                  <span>into the next</span>
                  <span>ctrl + ⯈</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <hr style="margin: 0">
        <div class="menu-item${disable_text_edit}" data-clickitem="text_edit">
          <div class="menu-item-drop">
            <i class="material-icons">edit</i>
            <span class="key-tip">
              <span>text edit</span>
              <span>dbl click</span>
            </span>
          </div>
        </div>
        <hr style="margin: 0">
        <div class="menu-item${disable_classcss}" data-clickitem="copyElement">
          <div class="menu-item-drop">
            <i class="material-icons">content_copy</i>
            <span class="key-tip">
              <span>copy</span>
              <span>ctrl + c</span>
            </span>
          </div>
        </div>
        <div class="menu-item${disable_classcss}" data-clickitem="pasteElement" >
          <div class="menu-item-drop">
            <i class="material-icons">assignment</i>
            <span class="key-tip">
              <span>paste</span>
              <span>ctrl + v</span>
            </span>
          </div>
        </div>
        <div class="menu-item${disable_classcss}" data-clickitem="duplicateElement">
          <div class="menu-item-drop">
            <i class="material-icons">control_point_duplicate</i>
            <span class="key-tip">
              <span>duplicate</span>
              <span>ctrl + d</span>
            </span>
          </div>
        </div>
        <div class="menu-item${disable_classcss}" data-clickitem="removeElement">
          <div class="menu-item-drop">
            <i class="material-icons">close</i>
            <span class="key-tip">
              <span>delete</span>
              <span>ctrl + x</span>
            </span>
          </div>
        </div>
        <hr style="margin: 0">
        <div class="menu-item" data-clickitem="undobutton">
          <div class="menu-item-drop">
            <i class="material-icons">undo</i>
            <span class="key-tip">
              <span>undo</span>
              <span>ctrl + z</span>
            </span>
          </div>
        </div>
        <div class="menu-item" data-clickitem="redobutton">
          <div class="menu-item-drop">
            <i class="material-icons">redo</i>
            <span class="key-tip">
              <span>redo</span>
              <span>ctrl + y</span>
            </span>
          </div>
        </div>
      `;

    context_menu_element.innerHTML = items;
    if (e && e.target) {
      context_menu_element.style['display'] = 'flex';
      // move if out of window
      if (context_menu_element.offsetHeight + Number(posY) > window.innerHeight) {
        context_menu_element.style['top'] = Number(posY) - context_menu_element.offsetHeight + 'px';
      }
      if (context_menu_element.offsetWidth + Number(posX) > window.innerWidth) {
        context_menu_element.style['left'] = Number(posX) - context_menu_element.offsetWidth + 'px';
      }
    }

    window.addEventListener('mousedown', context_menu_close);
    iframeContents.addEventListener('mousedown', context_menu_close);
    let remove_context_on_els = [...context_menu_element.querySelectorAll('#context-menu, #context-menu *')];
    remove_context_on_els.map((el) => {
      el.addEventListener('contextmenu', e => e.preventDefault());
    });

    let data_selectelement_els = [...context_menu_element.querySelectorAll('[data-selectelement]')];
    data_selectelement_els.map((el) => {
      el.onclick = () => {
        let el_target = el.getAttribute('data-selectelement');
        selectElement(frameID(el_target));
        context_menu_element.style['display'] = 'none';
      };
    });

    let data_clickitem_els = [...context_menu_element.querySelectorAll('[data-clickitem]')];
    data_clickitem_els.map((el) => {
      el.onclick = () => {
        let el_target = el.getAttribute('data-clickitem');
        if (el_target === 'text_edit') {
          let el_to_click = frameID(domElement[0]);
          context_menu_element.style['display'] = 'none';
          el_to_click.setAttribute('contenteditable', 'true');
          el_to_click.focus();
          editingText = true;
          iframeElementSelect.setAttribute('target', '');
          iframeElementSelect.setAttribute('target-hover', '');
          el_to_click.onblur = () => {
            el_to_click.removeAttribute('contenteditable');
            editingText = false;
          };
        } else {
          let el_to_click = domID(el_target);
          simulateMouseEvent(el_to_click, "mousedown");
          context_menu_element.style['display'] = 'none';
        }
      };
    });
  }


  setTimeout(() => {

    // console.log(window.frames[0]);
    // console.log(iframe.contentWindow);

    // iframe.contentWindow.iframe_callback(() => {
    //   console.warn('from app iframe');
    // });


    // // window.frames[0].iframe_callback(() => {
    //     console.warn('from app iframe');
    //   });
  }, 5000);




  // set tutorial arrow
  const tutorial = domID('tutorial');
  const tutorial_show = domID('tutorial-show');
  const tutorial_arrow = domID('tutorial-arrow');
  const tutorial_text = domID('tutorial-text');
  const tutorial_button_next = domID('tutorial-button-next');
  const tutorial_button_prev = domID('tutorial-button-prev');
  const tutorial_button_close = domID('tutorial-button-close');
  const tutorial_select_items = domID('tutorial-select-items');

  let tutorial_show_active;
  if (window.localStorage.getItem('tutorial_show_active')) {
    tutorial_show_active = window.localStorage.getItem('tutorial_show_active');
    //console.log(tutorial_show_active);
  } else {
    tutorial_show_active = 'true';
  }

  tutorial_button_close.onclick = () => {
    tutorial_show_active = 'false';
    tutorial_show.style.cssText = '';
    tutorial.style.display = 'none';
    window.localStorage.setItem('tutorial_show_active', tutorial_show_active);
    tutorial_change(tutorial_data_index);
    tutorial_select_items.value = tutorial_data_index;
  };

  tutorial_show.onclick = () => {
    if (tutorial_show_active === 'true') {
      tutorial_show_active = 'false';
      tutorial_show.style.cssText = '';
      tutorial.style.display = 'none';
    } else {
      tutorial_show_active = 'true';
      tutorial_show.style.cssText = 'background: var(--mainColor); color: var(--button-text-active);';
      tutorial.style.display = 'flex';
    }
    window.localStorage.setItem('tutorial_show_active', tutorial_show_active);
    tutorial_change(tutorial_data_index);
    tutorial_select_items.value = tutorial_data_index;
  };

  let tutorial_data_index;
  if (window.localStorage.getItem('tutorial_data_index')) {
    tutorial_data_index = Number(window.localStorage.getItem('tutorial_data_index'));
  } else {
    tutorial_data_index = 0;
  }

  function show_tutorial() {

    if (window.innerWidth < breakPoint_MD_Value + scrollbox_width_resizer_vars_min_width) {
      return;
    }

    if (tutorial_show_active === 'true') {
      tutorial_show.style.cssText = 'background: var(--mainColor); color: var(--button-text-active);';
      tutorial.style.display = 'flex';
    } else {
      tutorial_show.style.cssText = '';
      tutorial.style.display = 'none';
    }
    tutorial_change(tutorial_data_index);
    tutorial_select_items.value = tutorial_data_index;
  }

  function show_section_html() {
    //console.log('show_section_html');
    if (domID("left-sections").style['display'] == 'none') {
      simulateMouseEvent(domID("htmlButton"), "click");
    }
  }

  function show_section_css() {
    if (domID("right-sections").style['display'] == 'none') {
      simulateMouseEvent(domID("cssButton"), "click");
    }
  }

  const tutorial_data = [{
      element: '#tutorial-show',
      points: 'bottom-right',
      title: 'Welcome to the tutorial',
      text: 'This is a tutorial to help you learn how to use the app. You can click the next button to continue.',
      func: () => {
        show_section_html();
      }
    },
    {
      element: '#add-page',
      points: 'top-left',
      title: 'Create a new page',
      text: 'Click the button to create a new page, call it whatever you want.',
      func: () => {
        show_section_html();
        let menu_open = domID('add-page').closest('.sectionWrap');
        if (!menu_open.classList.contains('active-tab')) {
          simulateMouseEvent(domID("pagesButton"), "mousedown");
        }
      }
    },
    {
      element: '#select__element',
      points: 'top-left',
      title: 'Create a new element',
      text: 'Select h1 element from the dropdown list.',
      func: () => {
        show_section_html();
      }
    },
    {
      element: '#add-new-element',
      points: 'top-left',
      title: 'Create a new element',
      text: 'Click the add element button to add the h1 element.',
      func: () => {
        show_section_html();
      }
    },
    {
      element: '#attrs-class',
      points: 'top-left',
      title: 'Add class name',
      text: 'Type the class name you want to add to the h1 element.',
      func: () => {
        show_section_html();
      }
    },
    {
      element: '#colorinput',
      points: 'top-right',
      title: 'Change styles',
      text: 'Click the color picker to change the color of the h1 element. You can also change the color by typing the color code in the input field or by selecting a color from a swatch.',
      func: () => {
        show_section_css();
        openTabForProperty('color');
      }
    },
    {
      element: '#font-size-up',
      points: 'top-right',
      title: 'Change styles',
      text: 'Click the font size up & down button to adjust the font size of the h1 element.',
      func: () => {
        show_section_css();
        openTabForProperty('font-size');
      }
    },
    {
      element: '#font-size_value',
      points: 'top-right',
      title: 'Change styles',
      text: 'Drag the value up and down to adjust the font size of the h1 element.',
      func: () => {
        show_section_css();
        openTabForProperty('font-size');
      }
    },
    {
      element: '#font-size-settings',
      points: 'bottom-right',
      title: 'Change styles',
      text: 'Change the units this value uses from px to something else like em.',
      func: () => {
        show_section_css();
        openTabForProperty('font-size');
      }
    },
    {
      element: '[data-to_remove="font-size"]',
      points: 'top-right',
      title: 'Change styles',
      text: 'Remove the font-size style value from the h1 element.',
      func: () => {
        show_section_css();
        openTabForProperty('font-size');
      }
    },
    {
      element: '#inputer1',
      points: 'top-right',
      title: 'Change styles',
      text: 'Enter any valid selector here to select the element you want to change the style of. Click the dropdown button to see the list of all current and possible selectors.',
      func: () => {
        show_section_css();
        openTabForProperty('font-size');
      }
    },
    {
      element: '#structure',
      points: 'top-left',
      title: 'Selecting moving & copying',
      text: 'This area is for selecting and moving elements. You can select an element by clicking on it. You can also move the element by dragging it. You can also do this by right clicking on the element on the canvas.',
      func: () => {
        show_section_html();
        let menu_open = domID('structure').closest('.sectionWrap');
        if (!menu_open.classList.contains('active-tab')) {
          simulateMouseEvent(domID("structureButton"), "mousedown");
        }
      }
    },
    {
      element: '#dt-1 .domTreeClassColor',
      points: 'top-left',
      title: 'Selecting moving & copying',
      text: 'Click this element to highlight it. CSS styles will only be applied when a element is selected.',
      func: () => {
        show_section_html();
        let classcss_firstchild = classcss.children[0];
        if (classcss_firstchild) {
          selectElement(classcss_firstchild);
        }
        let menu_open = domID('structure').closest('.sectionWrap');
        if (!menu_open.classList.contains('active-tab')) {
          simulateMouseEvent(domID("structureButton"), "mousedown");
        }
      }
    },
    {
      element: '#iframeClasscss',
      points: 'top-left',
      title: 'Selecting moving & copying',
      text: 'You can also click this element on the canvas to highlight it.',
      func: () => {
        show_section_html();
        let classcss_firstchild = classcss.children[0];
        if (classcss_firstchild) {
          selectElement(classcss_firstchild);
        }
        let menu_open = domID('structure').closest('.sectionWrap');
        if (!menu_open.classList.contains('active-tab')) {
          simulateMouseEvent(domID("structureButton"), "mousedown");
        }
      }
    },
    {
      element: '#duplicateElement',
      points: 'top-left',
      title: 'Selecting moving & copying',
      text: 'Click this button to duplicate it a few times. Tip, you can also use ctrl + d to duplicate but click on canvas first.',
      func: () => {
        show_section_html();
        let menu_open = domID('structure').closest('.sectionWrap');
        if (!menu_open.classList.contains('active-tab')) {
          simulateMouseEvent(domID("structureButton"), "mousedown");
        }
      }
    },
    {
      element: '#removeElement',
      points: 'top-left',
      title: 'Selecting moving & copying',
      text: 'Click this button to remove elements. Tip, you can also use ctrl + x to delete but click on canvas first.',
      func: () => {
        show_section_html();
        let menu_open = domID('structure').closest('.sectionWrap');
        if (!menu_open.classList.contains('active-tab')) {
          simulateMouseEvent(domID("structureButton"), "mousedown");
        }
      }
    },
    {
      element: '#iframeClasscss',
      points: 'top-right',
      title: 'Selecting moving & copying',
      text: 'You can also do these things by right clicking and bringing up the context menu.',
      func: () => {}
    },
    {
      element: '#undobutton',
      points: 'bottom-left',
      title: 'Undo & Redo',
      text: 'If you make a mistake at any point you can undo and redo here. ctrl + z to undo and ctrl + y to redo. This applys to everything you do on the canvas.',
      func: () => {}
    },
    {
      element: '#breakPointSettings',
      points: 'top-left',
      title: 'Mobile and responsive styles',
      text: 'Breakpoint values can be adjusted here and the mode for responsive or mobile first. Theme and normalize are also available here.',
      func: () => {}
    },
    {
      element: '#breakPointLine3',
      points: 'top-left',
      title: 'Mobile and responsive styles',
      text: 'Click on these bars to set canvas size to the breakpoint clicking again will toggle between the min and max of this breakpoint.',
      func: () => {}
    },
    {
      element: '#breakPoint_XS',
      points: 'top-right',
      title: 'Mobile and responsive styles',
      text: 'Clicking these buttons also sets the screen size in the same way. Any newly added styles will be added to the current breakpoint.',
      func: () => {
        show_section_css();
      }
    },
    {
      element: '#css-inline',
      points: 'top-right',
      title: 'Inline styles',
      text: 'This will apply styles directly to the HTML inlined as opposed to external stylesheet. Only use this if absolutely necessary, it is intended more for HTML emails.',
      func: () => {}
    },
    {
      element: '#paraBreakWidth',
      points: 'top-left',
      title: 'Mobile and responsive styles',
      text: 'Click here to temporarily bring the canvas up top of other panels to adjust canvas size.',
      func: () => {}
    },
    {
      element: '#breakpointminmax',
      points: 'top-right',
      title: 'Mobile and responsive styles',
      text: 'When clicking on breakpoints this makes them default to min or max on click first.',
      func: () => {}
    },
    {
      element: '#viewCodeButton',
      points: 'bottom-right',
      title: 'Code editor',
      text: 'HTML can be fully edited in the code editor. CSS can be clicked to open the values up in the CSS panel, only values can be edited, not selectors or properties, use the CSS panel for those.',
      func: () => {}
    },
    {
      element: '#preview',
      points: 'bottom-right',
      title: 'Preview',
      text: 'This opens another window to preview how the site will look when not in the editor. Changes will live update in the preview.',
      func: () => {}
    },
    {
      element: '#removeAll',
      points: 'bottom-right',
      title: 'Starting new projects',
      text: 'Clicking ok without entering any text will remove all CSS & HTML, if you type all then click ok it reverts to the demo template.',
      func: () => {}
    },
    {
      element: '#codepenForm',
      points: 'bottom-right',
      title: 'Open in codepen',
      text: 'This will open the project page in Codepen.',
      func: () => {}
    },
    {
      element: '#downloadFiles',
      points: 'bottom-right',
      title: 'Download project',
      text: 'This will download the project files with the specified options. Registering for a free account is required to upload and have upto 5 projects.',
      func: () => {}
    },
    {
      element: '#login',
      points: 'bottom-right',
      title: 'Register',
      text: 'Register for a free account to upload projects and have upto 5 projects.',
      func: () => {}
    },
  ];

  function tutorial_disable_buttons() {
    //console.log('tutorial_disable_buttons tutorial_data_index', tutorial_data_index)
    if (tutorial_data_index === 0) {
      tutorial_button_prev.classList.add('disabled');
    } else {
      tutorial_button_prev.classList.remove('disabled');
    }
    if (tutorial_data_index === tutorial_data.length - 1) {
      tutorial_button_next.classList.add('disabled');
    } else {
      tutorial_button_next.classList.remove('disabled');
    }
  }

  tutorial_data.map((item, i) => {
    let option = `<option value="${i}">${i + 1}. ${item.title}</option>`;
    tutorial_select_items.innerHTML += option;
  });

  tutorial_select_items.onchange = () => {
    tutorial_data_index = Number(tutorial_select_items.value);
    window.localStorage.setItem('tutorial_data_index', tutorial_data_index);
    let tutorial_data_element = tutorial_data[tutorial_data_index];
    tutorial_data_element.func();
    tutorial_arrow_position(tutorial_data_element.element, tutorial_data_element.points);
    tutorial_text.innerHTML = tutorial_data[tutorial_data_index].text;
  };

  function tutorial_change(prev_next) {

    if (tutorial_show_active !== 'true') {
      return;
    }

    if (!prev_next) {
      tutorial_data_index = tutorial_data_index = 0;
      window.localStorage.setItem('tutorial_data_index', tutorial_data_index);
      let tutorial_data_element = tutorial_data[tutorial_data_index];
      tutorial_text.innerHTML = tutorial_data[tutorial_data_index].text;
      tutorial_data_element.func();
      tutorial_arrow_position(tutorial_data_element.element, tutorial_data_element.points);
    }

    if (prev_next == 'next') {
      tutorial_data_index++;
    } else if (prev_next == 'prev') {
      tutorial_data_index--;
    } else {
      tutorial_data_index = prev_next;
    }

    if (tutorial_data_index < 0) {
      tutorial_data_index = 0;
    }
    if (tutorial_data_index > tutorial_data.length - 1) {
      tutorial_data_index = tutorial_data.length - 1;
    }

    tutorial_disable_buttons();

    window.localStorage.setItem('tutorial_data_index', tutorial_data_index);
    let tutorial_data_element = tutorial_data[tutorial_data_index];
    if (tutorial_data_element) {
      tutorial_text.innerHTML = tutorial_data[tutorial_data_index].text;
      tutorial_data_element.func();
      tutorial_arrow_position(tutorial_data_element.element, tutorial_data_element.points);
    }
  }

  tutorial_button_next.onclick = () => {
    tutorial_change('next');
    tutorial_select_items.value = tutorial_data_index;
  };

  tutorial_button_prev.onclick = () => {
    tutorial_change('prev');
    tutorial_select_items.value = tutorial_data_index;
  };


  function tutorial_arrow_position(selector, direction) {

    if (tutorial_show_active !== 'true') {
      return;
    }

    if (selector && direction) {
      let tutorial_data_element = document.querySelector(selector);
      if (!tutorial_data_element) {
        tutorial_arrow.style['display'] = 'none';
        return false;
      }
      tutorial_arrow.setAttribute('data-points', direction);
      tutorial_arrow.style['display'] = 'block';
      let tutorial_data_element_offset = tutorial_data_element.getBoundingClientRect();
      let tutorial_data_element_offset_top = tutorial_data_element_offset.top;
      let tutorial_data_element_offset_left = tutorial_data_element_offset.left;
      let tutorial_data_element_offset_width = tutorial_data_element_offset.width;
      let tutorial_data_element_offset_height = tutorial_data_element_offset.height;

      if (selector === '#iframeClasscss') {
        setTimeout(() => {
          tutorial_data_element_offset = tutorial_data_element.getBoundingClientRect();
          tutorial_data_element_offset_top = tutorial_data_element_offset.top;
          tutorial_data_element_offset_left = tutorial_data_element_offset.left;
          tutorial_arrow.style['top'] = `${tutorial_data_element_offset_top + 20}px`;
          tutorial_arrow.style['left'] = `${tutorial_data_element_offset_left + 20}px`;
        }, 200);
      } else if (selector === '#breakPointLine3') {
        tutorial_data_element_offset = tutorial_data_element.getBoundingClientRect();
        tutorial_data_element_offset_top = tutorial_data_element_offset.top;
        tutorial_data_element_offset_left = tutorial_data_element_offset.left;
        tutorial_arrow.style['top'] = `${tutorial_data_element_offset_top + 0}px`;
        tutorial_arrow.style['left'] = `${tutorial_data_element_offset_left + 20}px`;
      } else {
        switch (direction) {
          case 'top-right':
            tutorial_arrow.style['top'] = `${tutorial_data_element_offset_top + (tutorial_data_element_offset_height / 2)}px`;
            tutorial_arrow.style['left'] = `${tutorial_data_element_offset_left + (tutorial_data_element_offset_width / 2) - tutorial_arrow.offsetWidth}px`;
            break;
          case 'bottom-right':
            tutorial_arrow.style['top'] = `${tutorial_data_element_offset_top + (tutorial_data_element_offset_height) - tutorial_arrow.offsetHeight}px`;
            tutorial_arrow.style['left'] = `${tutorial_data_element_offset_left + (tutorial_data_element_offset_width / 2) - tutorial_arrow.offsetWidth}px`;
            break;
          case 'top-left':
            tutorial_arrow.style['top'] = `${tutorial_data_element_offset_top + (tutorial_data_element_offset_height / 2)}px`;
            tutorial_arrow.style['left'] = `${tutorial_data_element_offset_left + (tutorial_data_element_offset_width / 2)}px`;
            break;
          case 'bottom-left':
            tutorial_arrow.style['top'] = `${tutorial_data_element_offset_top + (tutorial_data_element_offset_height - tutorial_arrow.offsetHeight)}px`;
            tutorial_arrow.style['left'] = `${tutorial_data_element_offset_left + (tutorial_data_element_offset_width / 2)}px`;
            break;
          default:
            break;
        }
      }
    } else {
      tutorial_arrow.style['display'] = 'none';
    }
    tutorial_disable_buttons();
  }

  // render safely to dom //

  function createDOMMap(element) {
    var map = [];
    Array.from(element.childNodes).forEach(function (node) {
      map.push({
        content: node.childNodes && node.childNodes.length > 0 ? null : node.textContent,
        namespace: node.namespaceURI,
        atts: node.nodeType === 3 || node.nodeType === 8 ? [] : getAttributes(node.attributes),
        type: node.nodeType === 3 ? 'text' : node.nodeType === 8 ? 'comment' : node.localName,
        children: createDOMMap(node.localName === 'template' ? node.content : node)
      });
    });
    return map;
  }

  function getAttributes(attributes) {
    return Array.from(attributes).map(function (attribute) {
      return {
        att: attribute.name,
        namespace: attribute.namespaceURI,
        value: attribute.value
      };
    });
  }

  function renderToDOM(map) {
    //if (!append) { classcss.innerHTML = ''; }
    //con('renderToDOM');
    classcss.innerHTML = '';
    map.forEach(function (node, index) {
      classcss.appendChild(makeElem(node));
    });
  }

  function makeElem(elem) {
    const doc = classcss.ownerDocument;
    var node = elem.type === 'text' ? doc.createTextNode(elem.content) :
      elem.type === 'comment' ? doc.createComment(elem.content) :
      doc.createElementNS(elem.namespace || 'http://www.w3.org/1999/xhtml', elem.type);
    add_Attributes(node, elem.atts);
    if (elem.children.length > 0) {
      elem.children.forEach(function (childElem) {
        (node.localName === 'template' ? node.content : node).appendChild(makeElem(childElem));
      });
    } else if (elem.type !== 'text' && elem.type !== 'comment') {
      node.textContent = elem.content;
    }
    return node;
  }

  function add_Attributes(elem, atts) {
    atts.forEach(function (attribute) {
      if (attribute.namespace) {
        elem.setAttributeNS(attribute.namespace, attribute.att, attribute.value || '');
      } else {
        elem.setAttribute(attribute.att, attribute.value || '');
      }
    });
  }

  // Parse project source without a browsing context, resource fetches or custom
  // element upgrades. These nodes are inspected/serialized, never connected to UI.
  function projectHTMLContainer(html) {
    const template = document.createElement('template');
    template.innerHTML = '<div></div>';
    const container = template.content.firstChild;
    container.innerHTML = html;
    return container;
  }

  function escapeHTML(value) {
    return String(value).replace(/[&<>"']/g, character => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    })[character]);
  }

  function textOption(value, text) {
    const option = document.createElement('option');
    option.value = value;
    option.textContent = text;
    return option;
  }

  function attributeRows(attrs, images) {
    const fragment = document.createDocumentFragment();
    for (const property of Object.keys(attrs)) {
      const isImage = property === 'data-image';
      const row = document.createElement('div');
      row.className = 'value-wrapper__row';
      // Only fixed application markup is parsed here. Project values are assigned
      // as properties/attributes below and cannot create additional UI elements.
      row.innerHTML = '<div class="value-wrapper"><div class="value-wrapper__col" style="justify-content:flex-start"><div style="width:100%;padding-right:1px"></div></div><div class="value-wrapper__col value-wrapper__col--line"><label></label><button role="presentation" aria-label="GUI" type="button">&times;</button></div></div>';
      row.firstChild.title = isImage ? 'Element src attribute.' : 'Element ' + property + ' attribute.';
      const holder = row.firstChild.firstChild.firstChild;
      holder.className = isImage ? 'value-wrapper__select-icon' : 'value-wrapper__input-icon';
      const control = document.createElement(isImage ? 'select' : 'input');
      control.className = isImage ? 'value-wrapper__select' : 'value-wrapper__input';
      control.style.cssText = 'width:100%;padding-right:1px';
      control.id = 'attrs-' + property;
      control.title = attrs[property];
      control.setAttribute('aria-label', 'GUI');
      control.setAttribute('autocomplete', 'off');
      control.setAttribute('placeholder', ' ');
      if (isImage) control.append(...images.map(key => textOption(key, key)));
      else control.setAttribute('list', control.id + '-list');
      control.value = attrs[property];
      holder.appendChild(control);
      if (isImage) { const arrow = document.createElement('span'); arrow.textContent = '\u25bc'; holder.appendChild(arrow); }
      const label = row.querySelector('label');
      label.htmlFor = control.id;
      label.textContent = isImage ? 'src' : property;
      const remove = row.querySelector('button');
      remove.id = control.id + '-remove';
      if (isImage) remove.style.display = 'none';
      fragment.appendChild(row);
    }
    return fragment;
  }

  function imageCard(key, url, size) {
    const card = document.createElement('div');
    card.className = 'imageHolderAll';
    card.title = key + '\n' + size;
    card.innerHTML = '<div class="imageHolderDiv"><div class="imageHolderDiv__inner"></div></div><div class="imageHolderTextContainer"><p class="imageHolderText"></p></div>';
    const image = document.createElement('img');
    image.className = 'imageHolderImg';
    image.alt = 'image holder';
    image.draggable = true;
    image.setAttribute('data-DBimage', key);
    image.src = url; // Trusted createObjectURL result, never a project string.
    card.firstChild.appendChild(image);
    card.querySelector('p').textContent = key;
    return card;
  }

  function supports() {
    if (!Array.from || !window.DOMParser) return false;
    var parser = parser || new DOMParser();
    try {
      parser.parseFromString('x', 'text/html');
    } catch (err) {
      return false;
    }
    return true;
  }

  // Check for browser support
  if (!supports()) throw new Error('Your browser is not supported.');

})(); // THE End
